/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/watershed/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(464);
	module.exports = __webpack_require__(466);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(51);


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(227);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(226);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(84);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(84);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(309)();
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(134);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(26);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(82);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 14 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMProperty = __webpack_require__(48);
	var ReactDOMComponentFlags = __webpack_require__(185);
	
	var invariant = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 16 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(387);


/***/ },
/* 22 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(93)('wks');
	var uid = __webpack_require__(67);
	var Symbol = __webpack_require__(34).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(183);
	var PooledClass = __webpack_require__(39);
	var ReactFeatureFlags = __webpack_require__(188);
	var ReactReconciler = __webpack_require__(49);
	var Transaction = __webpack_require__(77);
	
	var invariant = __webpack_require__(10);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(39);
	
	var emptyFunction = __webpack_require__(26);
	var warning = __webpack_require__(12);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(53)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(34);
	var core = __webpack_require__(22);
	var ctx = __webpack_require__(86);
	var hide = __webpack_require__(42);
	var has = __webpack_require__(36);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 34 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 36 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(41);
	var IE8_DOM_DEFINE = __webpack_require__(136);
	var toPrimitive = __webpack_require__(95);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(137);
	var defined = __webpack_require__(87);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 39 */
[866, 11],
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(235), __esModule: true };

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(37);
	var createDesc = __webpack_require__(57);
	module.exports = __webpack_require__(32) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(35));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(302);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(108);
	var setInnerHTML = __webpack_require__(79);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(116);
	var setTextContent = __webpack_require__(201);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(410);
	var ReactInstrumentation = __webpack_require__(23);
	
	var warning = __webpack_require__(12);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactBaseClasses = __webpack_require__(216);
	var ReactChildren = __webpack_require__(477);
	var ReactDOMFactories = __webpack_require__(478);
	var ReactElement = __webpack_require__(52);
	var ReactPropTypes = __webpack_require__(479);
	var ReactVersion = __webpack_require__(480);
	
	var createReactClass = __webpack_require__(481);
	var onlyChild = __webpack_require__(485);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(31);
	
	var warning = __webpack_require__(12);
	var canDefineProperty = __webpack_require__(220);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(218);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(141);
	var enumBugKeys = __webpack_require__(88);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 56 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(40);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventPluginRegistry = __webpack_require__(109);
	var EventPluginUtils = __webpack_require__(110);
	var ReactErrorUtils = __webpack_require__(114);
	
	var accumulateInto = __webpack_require__(194);
	var forEachAccumulated = __webpack_require__(195);
	var invariant = __webpack_require__(10);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	var EventPluginUtils = __webpack_require__(110);
	
	var accumulateInto = __webpack_require__(194);
	var forEachAccumulated = __webpack_require__(195);
	var warning = __webpack_require__(12);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	var getEventTarget = __webpack_require__(119);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(44);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 64 */
11,
/* 65 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(87);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 67 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(35));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(151));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(288));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(283));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(284));
	
	var _properties = __webpack_require__(150);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(285));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(146);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(45);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(101);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(80);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(81);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(83);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(164);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(323);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(166);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(370);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(205);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(311);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(312);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(313);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(314);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(163);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(58);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(164);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(315);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(316);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(165);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(318);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(319);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(321);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(320);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(102);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(71);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(322);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(72);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(324);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(325);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(328);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(103);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(167);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(329);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(330);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(331);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(334);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(335);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(336);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(168);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(104);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(343);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(344);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(169);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(170);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(171);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(172);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(173);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(347);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(175);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(346);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(174);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(176);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(351);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(352);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(353);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(354);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(355);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(178);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(356);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(179);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(357);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(358);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(359);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(360);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(361);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(28);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(362);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(364);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(105);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(106);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(365);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(180);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(366);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(367);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(368);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(369);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(373);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(134);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventPluginRegistry = __webpack_require__(109);
	var ReactEventEmitterMixin = __webpack_require__(402);
	var ViewportMetrics = __webpack_require__(193);
	
	var getVendorPrefixedEventName = __webpack_require__(434);
	var isEventSupported = __webpack_require__(120);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	var ViewportMetrics = __webpack_require__(193);
	
	var getEventModifierState = __webpack_require__(118);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	var DOMNamespaces = __webpack_require__(108);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(116);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(82);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(491);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(229);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(228);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(238);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 87 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 88 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(41);
	var dPs = __webpack_require__(253);
	var enumBugKeys = __webpack_require__(88);
	var IE_PROTO = __webpack_require__(92)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(135)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(244).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 90 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(37).f;
	var has = __webpack_require__(36);
	var TAG = __webpack_require__(25)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(93)('keys');
	var uid = __webpack_require__(67);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(22);
	var global = __webpack_require__(34);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(65) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 94 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(43);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(34);
	var core = __webpack_require__(22);
	var LIBRARY = __webpack_require__(65);
	var wksExt = __webpack_require__(97);
	var defineProperty = __webpack_require__(37).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(25);


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(35));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 101 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(70);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(205);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(181);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(337);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(338);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(339);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(340);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(341);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(342);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(83);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(47);
	var Danger = __webpack_require__(379);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(23);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(116);
	var setInnerHTML = __webpack_require__(79);
	var setTextContent = __webpack_require__(201);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactErrorUtils = __webpack_require__(114);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactPropTypesSecret = __webpack_require__(408);
	var propTypesFactory = __webpack_require__(161);
	
	var React = __webpack_require__(51);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(29);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(26);
	var warning = __webpack_require__(12);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(82);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(126);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(50);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(158);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/climate-icon.18cf273d.png";

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 131 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(233), __esModule: true };

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	var document = __webpack_require__(34).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(32) && !__webpack_require__(53)(function () {
	  return Object.defineProperty(__webpack_require__(135)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(85);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(65);
	var $export = __webpack_require__(33);
	var redefine = __webpack_require__(143);
	var hide = __webpack_require__(42);
	var Iterators = __webpack_require__(54);
	var $iterCreate = __webpack_require__(248);
	var setToStringTag = __webpack_require__(91);
	var getPrototypeOf = __webpack_require__(255);
	var ITERATOR = __webpack_require__(25)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(56);
	var createDesc = __webpack_require__(57);
	var toIObject = __webpack_require__(38);
	var toPrimitive = __webpack_require__(95);
	var has = __webpack_require__(36);
	var IE8_DOM_DEFINE = __webpack_require__(136);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(141);
	var hiddenKeys = __webpack_require__(88).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(36);
	var toIObject = __webpack_require__(38);
	var arrayIndexOf = __webpack_require__(240)(false);
	var IE_PROTO = __webpack_require__(92)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(32);
	var getKeys = __webpack_require__(55);
	var toIObject = __webpack_require__(38);
	var isEnum = __webpack_require__(56).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(42);


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(94);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(257)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(138)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(44));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(45));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(69));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(44));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(69));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(35));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(286));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(35));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(26);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = {
		"type": "Feature Collection",
		"features": [
			{
				"type": "Feature",
				"id": "ER-PLM0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9496458,
						38.91950016,
						2803.56
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM0",
					"name": "Hillslope auger soil samples",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors, piezometer. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11bl9FbTVYT0R4UUE\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Soil/sediment Temperature; matric potentials; water levels; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9492731,
						38.91977114,
						2787.16
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM1",
					"name": "Hillslope Borehole (M1)",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors, piezometer. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11bl9FbTVYT0R4UUE\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Soil/sediment Temperature; matric potentials; water levels; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM1_1DHl4dNQEK1Jb1bRRq2j2DvLeu9L-gc1q",
							"ER-PLM1_1Ig4tDFrLfYpclSnHsW4YeEoNuNFcwR8r",
							"ER-PLM1_1Df8i_qTutb-lKvBamkcBaeYS7Wlnx4Pr"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9487135,
						38.92015681,
						2777.25
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM2",
					"name": "Hillslope Borehole (M2)",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11SHprMkd0a2ZWUUU\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Soil/sediment Temperature; matric potentials; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM2_1z9BUKgabfr1vLS8DQ_6yYTn7UroR0vlT",
							"ER-PLM2_1Rqjtly5iPAoC-O5k-VK7OBRL4Fv_3A3v"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9483668,
						38.92078433,
						2759.69
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM3",
					"name": "Hillslope Borehole (M3)",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors. Click <a href=\"https://drive.google.com/file/d/0B5RSGI83Og11Y3RkM0JQNXJDUmc/view?usp=sharing\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Soil/sediment Temperature; matric potentials; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM3_1jk-ZktIfdcILcUL3oJxwveeNNxVCM9oj",
							"ER-PLM3_1Ttsrqq9EptJX65fC73jBzbTfLS5Rwdsu"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9479528,
						38.92100596,
						2757.43
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM4",
					"name": "Hillslope monitoring site (M4)",
					"category": "SFA Intensive",
					"instrumentation": "Shallow Gas Samplers, Water Samplers,Soil Moisture sensors (Matric Potential, TDR), thermistors individually installed (no borehole). Click <a href=\"hhttps://drive.google.com/file/d/0B5RSGI83Og11TkZlUFM5a1ctQ00/view?usp=sharing\">here</a> for drilling log. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11T3NuVFZZck1NNDQ\">here</a> for instrumentation depths.",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Soil/sediment Temperature; matric potentials; hydraulic potentials; water content changes; pore water chemical composition; pore gas composition; surface soil CO2 fluxes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM4_1JoonMxxHy-lUDl7QZRvJ-ejJofgV4R0G"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9490082,
						38.91993899,
						2783.11
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM5",
					"name": "Hillslope well (PLM5)",
					"category": "SFA Intensive",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Deep shale bedrock hydrology and geochemistry",
					"description": "Hillslope drilling location used to collect continuous core over the 0 to 10-m depth interval and to install a groundwater monitoring well used to measure sesonal variations in groundwater elevation and solute composition. Groundwater sampling depth is 7.6-m below ground surface.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484325,
						38.92079804,
						2759.65
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM6",
					"name": "Hillslope well (M6)",
					"category": "SFA Intensive",
					"instrumentation": "Shallow groundwater monitoring well. Click <a href=\"https://drive.google.com/open?id=0B5RSGI83Og11VklCVlRwbnFzZmRXcXlPWWpmWi1PQ2pnSExF\">here</a> for borehole log.",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Hillslope drilling location used to collect continuous core over the 0 to 10-m depth interval and to install a groundwater monitoring well used to measure sesonal variations in groundwater elevation and solute composition. Groundwater sampling depth is 7.6-m below ground surface.",
					"variables_measured": "Water Level; Electrical Conductivity (EC);",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM6_1DCRaVpzbA5cY_Msu2O1p2xANoS29VbPS"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9489495,
						38.91990393,
						2782.86
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM7",
					"name": "Hillslope well (PLM7)",
					"category": "SFA Intensive",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Deep shale bedrock hydrology and geochemistry",
					"description": "Hillslope drilling location used to install a 70-m, 3\" screened borehole for hydrologic testing and moniotirng and geochemical sampling.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM7_1ypKvvJqeBFFKQ0X4WceQi4obtzMxX-BV"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9471077,
						38.92256571,
						2760.84
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM8",
					"name": "Hillslope well (PLM8)",
					"category": "SFA Intensive",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Deep shale bedrock hydrology and geochemistry",
					"description": "Hillslope drilling location used to collect continuous core over the 3-22m depth interval and installation of a 3\" screened borehole for hydrologic testing and moniotirng and geochemical sampling.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM8_1KIxGYic47rh8iFEQFYRV6DOIg_qu1-mp"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9470843,
						38.92255708,
						2760.85
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM9",
					"name": "Hillslope well (PLM9)",
					"category": "SFA Intensive",
					"instrumentation": "Shallow groundwater monitoring well",
					"research_theme": "Deep shale bedrock hydrology and geochemistry",
					"description": "Hillslope drilling location used to collect continuous core over the 3-22m depth interval and installation of a 3\" screened borehole for hydrologic testing and moniotirng and geochemical sampling.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PLM9_1AWokwE0jGeAWSrkgDo7aHP8W8CphDOFs"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-GLS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0021174,
						38.97757966,
						2925.04
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-GLS1",
					"name": "Gothic Lower Subalpine",
					"category": "SFA Satellite Site",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Solute composition of deep groundwater",
					"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-GLS1_1kakMTKZyBgPBuqJVibVpFEJCr5kdRiOA"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-GUM1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9923898,
						38.95504938,
						2894.54
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-GUM1",
					"name": "Gothic Upper Montane-1",
					"category": "SFA Satellite Site",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Solute composition of deep groundwater",
					"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-GUM1_1c0VY7VgJXkJcReKGNHRllcR-zgy9UntY"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-IRW1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.099899,
						38.875618,
						3141.92
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-IRW1",
					"name": "Irwin Well",
					"category": "SFA Satellite Site",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Solute composition of deep groundwater",
					"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-INY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9868278,
						38.95516944,
						2905.13
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-INY1",
					"name": "Inouye Well",
					"category": "SFA Satellite Site",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Solute composition of deep groundwater",
					"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within the Mancos Shale. Well depth is 200-ft with the production zone unknown.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RBL1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9896811,
						38.9587928,
						2889.89
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RBL1",
					"name": "RMBL Well",
					"category": "SFA Satellite Site",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Solute composition of deep groundwater",
					"description": "Data used to constrain temporal variations in geochemical composition of deep groundwater within a confined layer sandstone interbed aquifer of the Mancos Shale. Well depth is 200 ft with the production zone from 160 to 200-ft. Samples for geochemical analysis are collected at ground surface due to artesian flow from the aquifer.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-RBL1_1YqONoeAgGi9Si2GNTKLRIK42To9evQ7u",
							"ER-RBL1_1cJ1OiF7IENtxOHbfSYRWyZEgkUdZtn4F"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RCK1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0055887,
						38.98166807,
						2933.69
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RCK1",
					"name": "Rock Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-RCK1_1ivpBjVxrUm4TLEXTOrkI5CEE6FRCsGsf"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RUS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.007755,
						38.98893967,
						2952.39
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RUS1",
					"name": "Rustlers Gulch",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_",
							"ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht",
							"ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2",
							"ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SHM1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9895197,
						38.94540579,
						2879.75
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SHM1",
					"name": "Shumway Well",
					"category": "SFA Satellite Site",
					"instrumentation": "Deep groundwater monitoring well",
					"research_theme": "Variations in groundwater elevation and solute composition",
					"description": "221 ft (well currently not being used for water production; production zone unknown)",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNI1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9798065,
						38.92619374,
						3145.58
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL EESA"
					},
					"id": "SG-SNI1",
					"name": "Snodgrass Borehole 1",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors, piezometer",
					"research_theme": "Subsurface water and solute inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Pore water temperature; matric potentials; water levels; pore water chemical composition; pore gas composition",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNI2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9766448,
						38.92577653,
						3123.97
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL EESA"
					},
					"id": "SG-SNI2",
					"name": "Snodgrass Borehole 2",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors, piezometer",
					"research_theme": "Subsurface water and solute inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Pore water temperature; matric potentials; water levels; pore water chemical composition; pore gas composition",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"SG-SNI2_1FwnVgeFB0GpzEdjUBuvM09VPagZ_-cdv"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNI3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9709078,
						38.92552828,
						3021.25
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL EESA"
					},
					"id": "SG-SNI3",
					"name": "Snodgrass Borehole 3",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors, piezometer",
					"research_theme": "Subsurface water and solute inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Pore water temperature; matric potentials; water levels; pore water chemical composition; pore gas composition",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ",
							"SG-SNI3_1L7ksbmn65NwDC05Bz0Qqex7AINgaZAeO",
							"SG-SNI3_1zIbU3MPWQIcnH_F7DYGlhL4PvfcRwjLo",
							"SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNI4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9861055,
						38.93233584,
						3358.96
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL EESA"
					},
					"id": "SG-SNI4",
					"name": "Snodgrass Borehole 4",
					"category": "SFA Intensive",
					"instrumentation": "Borehole with Gas Samplers, Water Samplers,Soil Matric Potential Sensors, thermistors",
					"research_theme": "Subsurface water and solute inventories and fluxes",
					"description": "Information needed to quantify water and gas phase flow and transport in the subsurface is being obtained through measurements of profile physical and biogeochemical characteristics, wetting-drying trends, composition of aqueous and gas phases",
					"variables_measured": "Pore water temperature; matric potentials; pore water chemical composition; pore gas composition",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv",
							"SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI",
							"SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA",
							"SG-SNI4_1CUdYvu_GEzg97KRjJehBYKCQJ9KgYjfh"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHF0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9508278,
						38.92244722,
						2759.57
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PHF0",
					"name": "Pumphouse ISCO",
					"category": "SFA Intensive",
					"instrumentation": "ISCO Stream Sampler, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify integrated watershed processes. Discharge calculations based on a rating cuve approach. Two ISCOs serve the site. One to collect anions, cations, trace metals, DIC and NOPC. The second collects samples for stable isotopes with each bottle filled with approx. 2 cm oil to minimize evaproation between sample retrival.  ISCOs collect from the stream during ice-free days (April through October) and sample from winter storage (WS) November through March.",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": [
							"ER-PHF0_1SUNKjCfCU105x69XIkqnfnwEV0TRiwDm",
							"ER-PHF0_1AjzaqW2975cRaNzzSISAsDcbb8Uj9_0i"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHF1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.951405,
						38.922353,
						2759.54
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PHF1",
					"name": "Pumphouse YSI",
					"category": "SFA Intensive",
					"instrumentation": "YSI Sonde",
					"research_theme": "Stream water quality parameters",
					"description": "Multi-parameter probe installed within the East River water column adjacent to the ER-PHF0 discharge transducer measuring the following water quality paramters at 5-minute intervals: pH, oxidation reduction potential (ORP), temperature, fluid conductivity, water column height, dissolved oxygen, fluorescent dissolved organic matter (fDOM), turbidity.",
					"variables_measured": "Water Temperature; Electrical Conductivity (EC); pH; Redox Potential (ORP); Water Level; Total Dissolved Solids (TDS); Dissolved Oxygen (DO); Colored Dissolved Organic Matter (FDOM); Turbidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-PHF1_1aNmd-9OBx33o3jfwjkcFwpfc3TFWeSqk"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SUF1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9772066,
						38.9225152,
						3070.06
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SUF1",
					"name": "Snodgrass Upper Flume",
					"category": "SFA Intensive",
					"instrumentation": "Stream flume",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Discharge data determined through direct measurement via stream flume",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-AVY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9973282,
						38.97521672,
						2923.93
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-AVY1",
					"name": "Avery Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-AVY1_1nnkbVSeckmOCSVbiPAJlpWE0TcH0m1xF",
							"ER-AVY1_1HFoba3DfET07yAfpMYgob55oZF1jQH0Z"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9094606,
						38.88659938,
						2722.2
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-BCC0",
					"name": "Brush Creek Confluence ISCO",
					"category": "SFA Satellite Site",
					"instrumentation": "ISCO Stream Sampler",
					"research_theme": "Surface water solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. The ISCO was deployed during ice-free conditions in 2015. Data window: April 3, 2015 to October 24, 2015.",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Phosphate (PO4)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-BCC0_1rmKoACou7XMB5MmaYYBEutbkPYBTfjLY",
							"ER-BCC0_1f3GdVRWTQS6AMq3pHUO8eF_i9H_cMBTX",
							"ER-BCC0_1IZPq1EJPIq3_rZt8wC5w6o-FIHHj1yG9",
							"ER-BCC0_13ztzLwVTVcTDYYH8DfJ-CL-t77N3xx2q"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BRD1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0048454,
						38.98540925,
						2939.9
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-BRD1",
					"name": "Bradley Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-BRD1_1YrnvDmmLbq_m7pckHaqEK9zRAZxc1hej"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BTH1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9923154,
						38.96082622,
						2900.65
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-BTH1",
					"name": "Benthette Brook",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data. Data window: July 30, 2014 to October 19, 2016.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-11",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.033615,
						38.863696,
						2838.72
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-11",
					"name": "Coal-11",
					"category": "SFA Satellite Site",
					"instrumentation": "ISCO Stream Sampler during ice free conditions; direct sampling from stream water at other times",
					"research_theme": "Surface discharge and solute flux",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale.",
					"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPR1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.988286,
						38.95705903,
						2884.74
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPR1",
					"name": "Copper Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-CPR1_1YABLBd05P-y8NhdOQJb4Y_ruc95IwAit"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-EAQ1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0145513,
						38.99518558,
						2983.96
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-EAQ1",
					"name": "East River above Quigley Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale.  Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-EAQ1_1iAT3Un1XYN79br8b27e2aGHBNWpG6ht4"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-EBC0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9894862,
						38.95242537,
						2864.92
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-EBC0",
					"name": "East River below Copper Creek ISCO",
					"category": "SFA Satellite Site",
					"instrumentation": "ISCO Stream Sampler",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. The ISCO is deployed during ice-free conditions in 2015 and 2016. Data windows: April 5 to September 20, 2015; May 28 to September 27, 2016.",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-EBC0_1VC-KmuX1iROuujgfWarajGUvaXiMyQLm"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-EBC1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9894862,
						38.95242537,
						2864.92
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-EBC1",
					"name": "East River below Copper Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-EBC1_1sjwAulA3mjsE1OfJ2KdGVOHeMEcGbRQW"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-YUL0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9908336,
						38.9576942,
						2882.7
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-YUL0",
					"name": "Yule ISCO",
					"category": "SFA Satellite Site",
					"instrumentation": "ISCO Stream Sampler",
					"research_theme": "Surface water solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. The ISCO was deployed during ice-free conditions in 2014. Data window: May 9, 2014 to October 26, 2014.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-YUL0_1SgG10QYcOkRTL2o694mcT3qBrNCgZsIG",
							"ER-YUL0_1Cf-iHrXGhBarsVu5nXIUz07R9Cc6MBwo"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-GTH1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0045576,
						38.97845224,
						2935.22
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-GTH1",
					"name": "Gothic Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-GTH1_1AtWkH44Jams2WJsCyCEoV3Vi6Ta0eNXM"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MMT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9978241,
						38.97930968,
						2969.49
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MMT1",
					"name": "Marmot Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-MMT1_1bsH_cMQXOv6f_z8s00VyUSkTz_4c2IdV"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-QLY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0141949,
						38.9934266,
						2981.63
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-QLY1",
					"name": "Quigley Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location, Discharge transducer",
					"research_theme": "Surface discharge and solute flux",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes at the sub-catchment scale. Rating curved approach applied to pressure transducer data.",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Dissolved Total Nitrogen (DTN); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-QLY1_1NbFc2sZR8W7fwJJP000umti3ZQP9j6Iq"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "Elk-00",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.059989,
						38.857128,
						2926.27
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Elk-00",
					"name": "Elk-00",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location; stream flume",
					"research_theme": "Surface discharge and solute flux",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN); stream discharge",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-LOC1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.621097,
						38.769319,
						2789.79
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "TR-LOC1",
					"name": "Lottis Creek gauging station",
					"category": "SFA Intensive",
					"instrumentation": "Transducer, ISCO automatic sampler",
					"research_theme": "Surface discharge and solute flux",
					"description": "Stream gauging station with automatic sampler",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, discharge, stage",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-NLA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.011,
						38.89693,
						2712.59
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "rosemary.carroll@dri.edu; rcarrollcb@gmail.com",
						"affiliation": "DRI"
					},
					"id": "SR-NLA1",
					"name": "Nicholson Lake",
					"category": "SFA Satellite Site",
					"instrumentation": "Pressure transducer (Hobo MX2001-04) serial number 20752650",
					"research_theme": "Surface discharge",
					"description": "Data used to quantify seasonal discharge.",
					"variables_measured": "Stream temperature, water level above sensor, discharge",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-GSB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0144444,
						38.93888889,
						3003.47
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "rosemary.carroll@dri.edu; rcarrollcb@gmail.com",
						"affiliation": "DRI"
					},
					"id": "SR-GSB1",
					"name": "Gunsight Bridge",
					"category": "SFA Satellite Site",
					"instrumentation": "Pressure transducer (Hobo MX2001-04) serial number 20739205",
					"research_theme": "Surface discharge",
					"description": "Data used to quantify seasonal discharge.",
					"variables_measured": "Stream temperature, water level above sensor, discharge",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL115",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.043765,
						38.862236,
						2868.46
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL115",
					"name": "CC-11.5",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "Wild-00",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.009074,
						38.869424,
						2767.55
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Wild-00",
					"name": "Wildcat Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Splains",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06417,
						38.8552,
						2922.7
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Splains",
					"name": "Splains",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-RLY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.021425,
						38.868361,
						2817.86
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-RLY1",
					"name": "Red Lady",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-RLY1_1cmOTVtFTXg_A2Kwp9llMCnfYZKiAhYgI"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-OHO1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.092554,
						38.855179,
						2988.53
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-OHO1",
					"name": "Ohio Creek",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-OHO1_1P_P9OQUhhJLbMwXchqxW3eag6LZaY6Sv"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-OHO2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0968,
						38.84995,
						3023.09
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-OHO2",
					"name": "Ohio Creek-2",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-OHO3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09589,
						38.85185,
						3012.63
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-OHO3",
					"name": "Ohio Creek-3",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-OHO4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09429,
						38.85379,
						2999.35
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-OHO4",
					"name": "Ohio Creek-4",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-OHP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09805,
						38.84567,
						3043.11
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-OHP1",
					"name": "Ohio Pass",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "IR-00",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.100659,
						38.875245,
						3144.61
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "IR-00",
					"name": "IR-00",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Evans",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.050068,
						38.860616,
						2893.22
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Evans",
					"name": "Evans",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Elk-East",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.058804,
						38.857112,
						2924.58
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Elk-East",
					"name": "Elk East",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.020513,
						38.86837,
						2798.14
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-5",
					"name": "Coal-5",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-20",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.059795,
						38.85597,
						2908.77
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-20",
					"name": "Coal-20",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.990217,
						38.86804,
						2731.79
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-2",
					"name": "Coal-2",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-15",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.058623,
						38.856062,
						2904.97
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-15",
					"name": "Coal-15",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-12",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.046608,
						38.861683,
						2866.6
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-12",
					"name": "Coal-12",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Coal-30",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.093626,
						38.866714,
						3047.85
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "Coal-30",
					"name": "Coal-30",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Long-term monitoring site for the Coal Creek Watershed Coalition. Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06315,
						38.855573,
						2920.84
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL9",
					"name": "CC-9",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL9_1cMYlJHh0_LzvhnmQVfYRGdX2ETL55C9p"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.07307,
						38.855716,
						2952.68
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL8",
					"name": "CC-8",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.079844,
						38.854348,
						2968.05
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL7",
					"name": "CC-7",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL7_1bN9L3MsxC1SYzBVBFyRvLmButPlZNnn_"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.085749,
						38.853976,
						2976.56
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL6",
					"name": "CC-6",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL6_1UwGzcnd8AgGHuFpWY2S8I7InHIjor_Bq"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.095536,
						38.858234,
						3001.41
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL5",
					"name": "CC-5",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL5_1k8tymV5VzOjNmHISsgw8Zhb0xx_keqSE",
							"CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.095071,
						38.8719,
						3085.28
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL3",
					"name": "CC-3",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL3_1SEtNaLFEC_42OJvCdsP6NIvzgVd_imyP"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.094504,
						38.872883,
						3098.47
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL2",
					"name": "CC-2",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ",
							"CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL12",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.007998,
						38.869416,
						2766.6
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL12",
					"name": "CC-12",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz",
							"CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL11",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.048801,
						38.859758,
						2872.77
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL11",
					"name": "CC-11",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn",
							"CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-COL10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.056848,
						38.85625,
						2899.37
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-COL10",
					"name": "CC-10",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-BOG3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.043242,
						38.862473,
						2874.53
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-BOG3",
					"name": "Bog-03",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-BOG3_151QuDD2UzRCXC5DTTtCM8MWqloRxdWXp"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-BOG2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.043604,
						38.862433,
						2875.13
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-BOG2",
					"name": "Bog-02",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-BOG0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.044806,
						38.863,
						2880.64
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-BOG0",
					"name": "Bog-00",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": [
							"CC-BOG0_1YIffKvdArow8ys3h1hJzjbHcNoqMq5Jm"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-BOG4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0428,
						38.8625,
						2873.55
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-BOG4",
					"name": "Bog-04",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-KYS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.024,
						38.8676,
						2827.59
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-KYS1",
					"name": "Keystone",
					"category": "SFA Satellite Site",
					"instrumentation": "Stream sampling location",
					"research_theme": "Solute composition of surface water",
					"description": "Data used to quantify quarterly variations in the flux of solutes along the reach length of Coal Creek including its key tributaries",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Arsenic (As); Total Phosphorous (P); Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Dissolved Inorganic C (DIC); Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-CBS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.061086,
						38.855914,
						2912.6
					]
				},
				"properties": {
					"contact": {
						"name": "Wendy S. Brown",
						"email": "bugsunlimitedllc@gmail.com",
						"affiliation": "The Rocky Mountain Biological Laboratory"
					},
					"id": "CC-CBS1",
					"name": "Coal Below Splains",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Weekly data about 2km upstream of Coal11",
					"description": "Data used to quantify seasonal and interannual hydrologic response and mass flux of solutes in Coal Creek.",
					"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97987,
						38.92493964,
						3128.7
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-SS1",
					"name": "Snodgrass Synoptic site 1",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-MT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9795183,
						38.92478731,
						3119.85
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-MT1",
					"name": "Snodgrass synoptic meadow tributary 1",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SS2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9790488,
						38.92433618,
						3111.74
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-SS2",
					"name": "Snodgrass synoptic site 2",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-MT2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9783835,
						38.92399746,
						3096.91
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-MT2",
					"name": "Snodgrass synoptic meadow tributary 2",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SS3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9783835,
						38.92399746,
						3096.91
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-SS3",
					"name": "Snodgrass synoptic site 3",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SS4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.977957,
						38.92349366,
						3085.75
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-SS4",
					"name": "Snodgrass synoptic site 4",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SS5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9776867,
						38.92311427,
						3079.21
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-SS5",
					"name": "Snodgrass synoptic site 5",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-FT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9771441,
						38.9230646,
						3080.83
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-FT1",
					"name": "Snodgrass synoptic forest tributary 1",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SLF1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97331,
						38.91687,
						2926.36
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-SLF1",
					"name": "Snodgrass Lower Flume",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Water Quality",
					"description": "Grab Samples near terminus of Snodgrass Stream Reach",
					"variables_measured": "Electrical Conductivity, Total Dissolved Solids, Oxidation/Reduction Potential, pH, Total Dissolved Carbon, Cations, Anions, Ammonium",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR1       ",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9463049,
						38.921345,
						2756.61
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR1       ",
					"name": "pumphouse 10 Meander, location1",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947941,
						38.921743,
						2756.96
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR2",
					"name": "pumphouse 10 Meander, location2",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94927,
						38.922213,
						2757.45
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR3",
					"name": "pumphouse 10 Meander, location3",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.949477,
						38.923097,
						2758.13
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR4",
					"name": "pumphouse 10 Meander, location4",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.950427,
						38.922816,
						2759.85
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR5",
					"name": "pumphouse 10 Meander, location5",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.951271,
						38.922157,
						2762.12
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR6",
					"name": "pumphouse 10 Meander, location6",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.953858,
						38.923302,
						2760.24
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR7",
					"name": "pumphouse 10 Meander, location7",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.952521,
						38.924748,
						2760.74
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR8",
					"name": "pumphouse 10 Meander, location9",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.954602,
						38.925008,
						2761.49
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR9",
					"name": "pumphouse 10 Meander, location11",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.954797,
						38.925675,
						2762.18
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR10",
					"name": "pumphouse 10 Meander, location13",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR11",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95563,
						38.9269069,
						2764.17
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR11",
					"name": "pumphouse 10 Meander, location14",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR12",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95752,
						38.928536,
						2765.88
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR12",
					"name": "pumphouse 10 Meander, location15",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHR13",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.959354,
						38.930631,
						2768.13
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-PHR13",
					"name": "pumphouse 10 Meander, location16",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MTR8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.953432,
						38.923772,
						2760.42
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-MTR8",
					"name": "pumphouse 10 Meander, location8",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MTR10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95404,
						38.924465,
						2762.1
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-MTR10",
					"name": "pumphouse 10 Meander, location10",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MTR12",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.955573,
						38.9253,
						2763.31
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-MTR12",
					"name": "pumphouse 10 Meander, location12",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.909214,
						38.894202,
						2725.2
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC1",
					"name": "brush creek 10 Meander, site1",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908515,
						38.893079,
						2725.5
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC2",
					"name": "brush creek 10 Meander, site2",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908735,
						38.892255,
						2724.86
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC3",
					"name": "brush creek 10 Meander, site3",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908955,
						38.891644,
						2724.5
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC4",
					"name": "brush creek 10 Meander, site4",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908828,
						38.890363,
						2724.18
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC5",
					"name": "brush creek 10 Meander, site5",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.907962,
						38.889797,
						2723.48
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC6",
					"name": "brush creek 10 Meander, site6",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90727,
						38.889583,
						2723.28
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC7",
					"name": "brush creek 10 Meander, site7",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908104,
						38.889311,
						2723.39
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC8",
					"name": "brush creek 10 Meander, site8",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.909216,
						38.888608,
						2722.97
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC9",
					"name": "brush creek 10 Meander, site9",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCC10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908622,
						38.886602,
						2722.19
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-BCC10",
					"name": "brush creek 10 Meander, site10",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "river solute concentrations",
					"description": "River water sampling location in the Pumphouse vicinity used for 10-meander modeling. River water geochemical data is used to understand and predict river corridor behavior including influence of hyporheic exchange of solutes and hotspots.",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4; pH; ORP; EC",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-PZ01",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9797,
						38.92725,
						3162.9
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-PZ01",
					"name": "Historic Snodgrass well 1",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
					"description": "Well used to collect groundwater geochemical samples",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-PZ02",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97743,
						38.92366,
						3093.59
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-PZ02",
					"name": "Historic Snodgrass well 2",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
					"description": "Well used to collect groundwater geochemical samples",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-PZ04",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97665,
						38.92255,
						3070.75
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-PZ04",
					"name": "Historic Snodgrass well 4",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
					"description": "Well used to collect groundwater geochemical samples",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-PZ05",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97613,
						38.92063,
						3036.18
					]
				},
				"properties": {
					"contact": {
						"name": "Kenneth Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "SG-PZ05",
					"name": "Historic Snodgrass well 5",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Subsurface water and carbon/nutrient inventories and fluxes",
					"description": "Well used to collect groundwater geochemical samples",
					"variables_measured": "DOC/DIC, Cations, anions, water isotope, NH4+, pH, ORP, Conductivity, TDS, Temp",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-TTL1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9909661,
						38.9450276,
						2911.82
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-TTL1",
					"name": "Tuttle spring",
					"category": "SFA Satellite Site",
					"instrumentation": "Surface spring",
					"research_theme": "solute composition of surface spring",
					"description": "Data used to evaluate seasonal changes in spring geochemistry",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BLY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9924642,
						38.9636028,
						2922.43
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-BLY1",
					"name": "billy's spring",
					"category": "SFA Satellite Site",
					"instrumentation": "Surface spring",
					"research_theme": "solute composition of surface spring",
					"description": "Data used to evaluate seasonal changes in spring geochemistry",
					"variables_measured": "Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P); Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Water - Deuterium (dD); Water - d18O; Beryllium (Be); Total Chromium (Cr); Titanium (Ti); Germanium (Ge); Rubidium (Rb); Zirconium (Zr); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Europium (Eu); Lead (Pb); Thorium (Th)",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": [
							"ER-BLY1_1lfq6itnxKJjJOeHstOJNFgh7_m28P7tt"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.038739,
						39.006026,
						3196.9
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH1",
					"name": "East River below Emerald Lake",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.017662,
						38.995781,
						2995.24
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH2",
					"name": "East River above Gothic Beaver Cmplx",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.014524,
						38.995168,
						2983.93
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH3",
					"name": "East River above Quigley at road",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.013267,
						38.993772,
						2978.29
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH4",
					"name": "East River just above Quigley",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00831,
						38.991445,
						2956.49
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH5",
					"name": "East River at Rustler Shale",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.002027,
						38.97767,
						2924.89
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH6",
					"name": "East River above Texas Bridge",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.996545,
						38.970326,
						2918.53
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH7",
					"name": "East River at Bus Turnaround",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.991159,
						38.956849,
						2878.22
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH8",
					"name": "East River below Director's Cabin",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.989221,
						38.952139,
						2863.7
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH9",
					"name": "East River Downstream Gothic Bridge",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.989513,
						38.952476,
						2865.01
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH10",
					"name": "East River Upstream of Gothic Bridge",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to river, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement and [222Rn]",
					"variables_measured": "[222Rn]; DO; Temp; 87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH11",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.013967,
						38.993666,
						2980.4
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH11",
					"name": "Quigley CK at road",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
					"description": "Samples taken for isotopic measurement",
					"variables_measured": "87Sr/86Sr; d34S of sulfate",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH12",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.007654,
						38.989692,
						2958.55
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH12",
					"name": "Rustler's Creek near road",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
					"description": "Samples taken for isotopic measurement",
					"variables_measured": "87Sr/86Sr; d34S of sulfate (DO; Temp) [222Rn]",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH13",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.005609,
						38.981659,
						2933.75
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH13",
					"name": "Rock Ck at road",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
					"description": "Samples taken for isotopic measurement",
					"variables_measured": "87Sr/86Sr; (DO; Temp) [222Rn]",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH14",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.005625,
						38.981672,
						2933.88
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH14",
					"name": "Fe Ck (next to Rock Ck)",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
					"description": "Samples taken for isotopic measurement",
					"variables_measured": "87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH15",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.988324,
						38.957047,
						2884.58
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH15",
					"name": "Copper Ck at RMBL",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
					"description": "Samples taken for isotopic measurement",
					"variables_measured": "87Sr/86Sr; d34S of sulfate (DO; Temp) [222Rn]",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH16",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.977477,
						38.937794,
						2886.22
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH16",
					"name": "Quién Sabe Ck",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Sources of dissolved elements to ER- 87Sr/86Sr etc",
					"description": "Samples taken for isotopic measurement",
					"variables_measured": "87Sr/86Sr",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM11",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947546,
						38.921134,
						2756.57
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM11",
					"name": "PLM River1 Steam Sample",
					"category": "SFA Intensive",
					"instrumentation": "Stream Sampling Location",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "Dissolved Carbon, Anions, Cations, Ammonium, Stable Water Isotopes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PLM12",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947546,
						38.921134,
						2756.57
					]
				},
				"properties": {
					"contact": {
						"name": "Tetsu Tokunaga",
						"email": "tktokunaga@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PLM12",
					"name": "PLM River2 Steam Sample",
					"category": "SFA Intensive",
					"instrumentation": "Stream Sampling Location",
					"research_theme": "Subsurface water and carbon inventories and fluxes",
					"description": "Information needed to quantify water flow and transport from the hillslope subsurface to East river channel surface water",
					"variables_measured": "Dissolved Carbon, Anions, Cations, Ammonium, Stable Water Isotopes",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.6248004,
						38.89986029,
						3055.53
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCT1",
					"name": "Trail Creek Trib 1",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCT2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.6190439,
						38.90761057,
						3042.13
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCT2",
					"name": "Trail Creek Trib 2",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.62314,
						38.900568,
						3051.18
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR1",
					"name": "Trail Creek 1",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.619764,
						38.904554,
						3043.1
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR2",
					"name": "Trail Creek 2",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.619885,
						38.907755,
						3038.62
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR3",
					"name": "Trail Creek 3",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.621033,
						38.90973,
						3035.39
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR4",
					"name": "Trail Creek 4",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.619573,
						38.911675,
						3032.9
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR5",
					"name": "Trail Creek 5",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.617688,
						38.913863,
						3029.86
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR6",
					"name": "Trail Creek 6",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.617538,
						38.917136,
						3026.15
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR7",
					"name": "Trail Creek 7",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.613626,
						38.920046,
						3022.45
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR8",
					"name": "Trail Creek 8",
					"category": "SFA Satellite Site",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "TR-TCR9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.604171,
						38.921036,
						2957.87
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "TR-TCR9",
					"name": "Trail Creek 9",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Groundwater flux to stream, sources of dissolved elements",
					"description": "Samples taken for isotopic measurement, [222Rn], elemental composition",
					"variables_measured": "222Rn, 87Sr/86Sr, water isotopes, elemental composition, DO, temperature, conductance, turbidity, Q",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH17",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.003082,
						38.981382,
						2928.9
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH17",
					"name": "East River just below Rock Ck, Xe tracer experiment",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Rearation rate for gas exchange. Injection point",
					"description": "Injection point for Xe tracer experiments",
					"variables_measured": "[Xe] Injection point for Xe experiments",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.002118,
						38.977276,
						2924.49
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH18",
					"name": "East River just downstream of Texas bridge, Xe time series",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Rearation rate for gas exchange. Collection point for Xe time series",
					"description": "Station for time series collection of Xe samples",
					"variables_measured": "[Xe] Time series station for Xe",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH19",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.951074,
						38.923511,
						2759.06
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH19",
					"name": "Pump House Xe Tracer Experiment",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Rearation rate for gas exchange. Injection point",
					"description": "Injection point for Xe tracer experiments",
					"variables_measured": "[Xe] Injection point for Xe experiments",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JCH20",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947367,
						38.920877,
						2756.36
					]
				},
				"properties": {
					"contact": {
						"name": "John Christensen",
						"email": "jnchristensen@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-JCH20",
					"name": "Pump Houes Xe time series",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Rearation rate for gas exchange. Injection point",
					"description": "Station for time series collection of Xe samples",
					"variables_measured": "[Xe] Time series station for Xe",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LMA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97113,
						38.90874,
						2888.47
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "WG-LMA1",
					"name": "Local Metrologic Water Line (LMWL) subregion location A",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LMB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97107,
						38.90873,
						2888.52
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "WG-LMB1",
					"name": "Local Metrologic Water Line (LMWL) subregion location B",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LMC1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97101,
						38.90872,
						2888.66
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "WG-LMC1",
					"name": "Local Metrologic Water Line (LMWL) subregion location C",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SPH1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9514,
						38.92213,
						2763.19
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-SPH1",
					"name": "Snowmelt location near C-Q stations at Pumphouse intensive region",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SPM1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94929,
						38.91972,
						2787.62
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-SPM1",
					"name": "Snowmelt location near PLM1 shallow groundwater well",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SBB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99286,
						38.96297,
						2918.4
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-SBB1",
					"name": "Snowmelt location near Billy Barr weather station",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SBT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95331,
						38.89434,
						3104.8
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-SBT1",
					"name": "Snowmelt location near Butte SNOTEL station",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SSG1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98627,
						38.93234,
						3358.55
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "SG-SSG1",
					"name": "Snowmelt location near Snodgrass weather station",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "End member mixing Analysis",
					"description": "Snowmelt was collected using a buried reservoir from which snowmelt entered with no contact with the soil. A sampling port allowed me to pull all the snowmelt from the reservoir. Data was collected weekly and analyzed for water isotopes d2H and d18O. Snow depth and snowmelt volume were collected concurrently.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-EST1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.858597,
						38.731972,
						2513.62
					]
				},
				"properties": {
					"contact": {
						"name": "Carleton Bern",
						"email": "cbern@usgs.gov",
						"affiliation": "USGS NGWOS"
					},
					"id": "ER-EST1",
					"name": "Estess",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Snowmelt and water isotope ratios",
					"description": "Precipitation samples collected weekly and seasonally measuring water isotope ratios. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: While coordinates are outside of the East River (ER) watershed boundary, we are anticipating that the watershed boundaries will expand as the project grows-- ER is the correct region code.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-IRB2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.107721259,
						38.88793153,
						3181.55
					]
				},
				"properties": {
					"contact": {
						"name": "Carleton Bern",
						"email": "cbern@usgs.gov",
						"affiliation": "USGS NGWOS"
					},
					"id": "CC-IRB2",
					"name": "Irwin Barn",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Snowmelt and water isotope ratios",
					"description": "Precipitation samples collected weekly and seasonally measuring water isotope ratios. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: This Irwin Barn location falls just outside of the Coal Creek (CC) watershed boundary but it is treated as input data signals for CC-- CC is the correct region code. ",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BRD2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00374,
						38.9875,
						2972.54
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-BRD2",
					"name": "Bradley Creek weekly rain chemistry",
					"category": "SFA One-off Sampling",
					"instrumentation": "single gauge",
					"research_theme": "streamflow age rSAS",
					"description": "weekly summer rain collected with plastic gauge w/mineral oil",
					"variables_measured": "rain volume; water isotopes d2H and d18O",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-FRR1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98563,
						38.95793,
						2910.51
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-FRR1",
					"name": "Forest site near warming meadow weekly rain chemistry",
					"category": "SFA One-off Sampling",
					"instrumentation": "single gauge",
					"research_theme": "streamflow age rSAS",
					"description": "weekly summer rain collected with plastic gauge w/mineral oil",
					"variables_measured": "rain volume; water isotopes d2H and d18O",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LMR1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97091,
						38.90889,
						2885.52
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "WG-LMR1",
					"name": "Local Meteorologic Water Line (LMWL) subregion weekly rain chemistry",
					"category": "SFA One-off Sampling",
					"instrumentation": "two gauges. w/o mineral oil",
					"research_theme": "streamflow age rSAS",
					"description": "weekly summer rain collected with plastic gauge w/mineral oil",
					"variables_measured": "rain volume; water isotopes d2H and d18O; cations; anions; NPOC; DIC",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RCH403",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0363,
						38.97442,
						3451.61
					]
				},
				"properties": {
					"contact": {
						"name": "Rosemary Carroll",
						"email": "Rosemary.Carroll@dri.edu",
						"affiliation": "DRI"
					},
					"id": "ER-RCH403",
					"name": "Rain chemistry near trail 403 in Rock Creek",
					"category": "SFA One-off Sampling",
					"instrumentation": "single gauge",
					"research_theme": "streamflow age rSAS",
					"description": "weekly summer rain collected with plastic gauge w/mineral oil",
					"variables_measured": "rain volume; water isotopes d2H and d18O",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-LMR1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985552,
						38.867674,
						2718.08
					]
				},
				"properties": {
					"contact": {
						"name": "Wendy S. Brown",
						"email": "bugsunlimitedllc@gmail.com",
						"affiliation": "The Rocky Mountain Biological Laboratory"
					},
					"id": "CC-LMR1",
					"name": "LMWL_CB",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Rain and Snow data",
					"description": "Data used to establish a Local Meteoric Water Line",
					"variables_measured": "Water - Deuterium (dD); Water - d18O; Chloride (Cl); Sulfate (SO4); Nitrate (NO3); Phosphate (PO4); Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P); Dissolved Inorganic C (DIC); Non-Purgable Organic Carbon (NPOC); Dissolved Total Nitrogen (DTN)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-EST2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.858597,
						38.731972,
						2513.62
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-EST2",
					"name": "Event based precipitation measurments at Estess ranch",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Precipitation/snowmelt water isotope ratios",
					"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: While coordinates are outside of the East River (ER) watershed boundary, we are anticipating that the watershed boundaries will expand as the project grows-- ER is the correct region code.",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-EST2_12U0xe6oGY5MQqYx9_PFOAMWrLJekUPxJ"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-IRB3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.107721259,
						38.88793153,
						3181.55
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-IRB3",
					"name": "Event based precipitation measurments at Irwin Barn",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Precipitation/snowmelt water isotope ratios",
					"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event. The Location_ID prefix (i.e. AA-) and the Geographic_Region do not match; the Location ID was assigned before verifying that the point location was registered within the correct drainage basin. 08/2022: This Irwin Barn location falls just outside of the Coal Creek (CC) watershed boundary but it is treated as input data signals for CC-- CC is the correct region code. ",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"CC-IRB3_1a9UiHSCTmRMHIGshhH4-NXwUROt9eSz5"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LMR2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.971092,
						38.908878,
						2890.36
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "WG-LMR2",
					"name": "Event based precipitation measurements at historic LMWL measurement site",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Precipitation/snowmelt water isotope ratios",
					"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event",
					"variables_measured": "Snowmelt; water isotopes d2H and d18O.",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"WG-LMR2_1xFtTmjUsG8iRdihZwudzxi5AdCFYgnb3"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PPT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.949333,
						38.92095,
						2767.31
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PPT1",
					"name": "Rain based precipitation measurments at Pumphouse site",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Precipitation water isotope ratios",
					"description": "Precipitation samples collected on an event basis measuring water isotopes and volume of event, utilizing mineral oil to prevent evaporation",
					"variables_measured": "Water isotopes D2H and d18O.",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9499837,
						38.923195,
						2759.45
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPA1",
					"name": "CP1-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPA2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9498154,
						38.9232443,
						2759
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPA2",
					"name": "CP2-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPA3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9495975,
						38.923195,
						2758.93
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPA3",
					"name": "CP3-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPA4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9497815,
						38.92312214,
						2759.09
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPA4",
					"name": "CP4-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPA5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9499118,
						38.9229531,
						2759.58
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPA5",
					"name": "CP5-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-CPA6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9497278,
						38.9229671,
						2759.17
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-CPA6",
					"name": "CP6-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature probe. An Air Hobo is colocated with CP1.",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level measurements measured with a piezometer. These locations were previously maintained by Helen Melenda from Colorado School of Mines to measure water level and chemistry (see location Alias field for prior identifiers starting with CMSL_).",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-DOW",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9499648,
						38.9216511,
						2759.62
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-DOW",
					"name": "DO1WEST-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-DOE",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9510847,
						38.9239407,
						2760.11
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-DOE",
					"name": "DO2EAST-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MBA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9506166,
						38.9227614,
						2760.1
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MBA1",
					"name": "M1BEND1-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MBA2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9505485,
						38.9228061,
						2759.89
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MBA2",
					"name": "M1BEND2-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-UPW",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9522385,
						38.92315,
						2759.95
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-UPW",
					"name": "UP1WEST-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-UPM",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9518048,
						38.9235342,
						2760.27
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-UPM",
					"name": "UP2M-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-UPE",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9510847,
						38.9239407,
						2760.11
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-UPE",
					"name": "UP3EAST-BOT",
					"category": "SFA Intensive",
					"instrumentation": "Pressure transducer and fluid temperature",
					"research_theme": "Subsurface water",
					"description": "Floodplain groundwater level and temperature",
					"variables_measured": "Barometric pressure; fluid temperature; depth to sensor; groundwater level elevation",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9503469,
						38.92285027,
						2759.3
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCP1",
					"name": "Meander MCP1",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9501704,
						38.9228384,
						2759.66
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCP2",
					"name": "Meander MCP2",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCP3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9499975,
						38.92283223,
						2759.47
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCP3",
					"name": "Meander MCP3",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCP4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9498236,
						38.92281603,
						2759.28
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCP4",
					"name": "Meander MCP4",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander C floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.8-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCP5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9496442,
						38.92279538,
						2758.34
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCP5",
					"name": "Meander MCP5",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Hillslope drilling location used to collect continuous core over the 0 to 10-m depth interval and to install a groundwater monitoring well used to measure sesonal variations in groundwater elevation and solute composition. Groundwater sampling depth is 7.6-m below ground surface.",
					"variables_measured": "Lithium (Li); Beryllium (Be); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Chromium (Cr); Total Manganese (Mn); Calcium (Ca); Total Iron (Fe); Titanium (Ti); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Germanium (Ge); Arsenic (As); Rubidium (Rb); Strontium (Sr); Zirconium (Zr); Molybdenum (Mo); Silver (Ag); Cadmium (Cd); Tin (Sn); Antimony (Sb); Cesium (Cs); Barium (Ba); Europium (Eu); Lead (Pb); Thorium (Th); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MDP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9471793,
						38.9213208,
						2757.09
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MDP1",
					"name": "Meander MDP1",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander D floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.1-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MDP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9472086,
						38.9211396,
						2757.03
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MDP2",
					"name": "Meander MDP2",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander D floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.1-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MDP3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9471435,
						38.9210594,
						2756.73
					]
				},
				"properties": {
					"contact": {
						"name": "Ken Williams",
						"email": "khwilliams@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MDP3",
					"name": "Meander MDP3",
					"category": "SFA Intensive",
					"instrumentation": "Drive-point piezometer.",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander D floodplain at the Pumphouse location. The piezometer is designed to collected groundwater from a depth of 1.1-m over a slotted section of 15-cm.",
					"variables_measured": "Lithium (Li); Boron (B); Sodium (Na); Magnesium (Mg); Aluminum (Al); Silicon (Si); Potassium (K); Vanadium (V); Total Manganese (Mn); Total Iron (Fe); Calcium (Ca); Nickel (Ni); Cobalt (Co); Copper (Cu); Zinc (Zn); Arsenic (As); Strontium (Sr); Molybdenum (Mo); Barium (Ba); Uranium (U); Total Phosphorous (P)",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MOP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9478836,
						38.92197704,
						2758.02
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MOP1",
					"name": "Meander O (oxbow), position 1",
					"category": "SFA Intensive",
					"instrumentation": "Single piezometers",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MOP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9477129,
						38.92191415,
						2757.75
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MOP2",
					"name": "Meander O (oxbow), position 2",
					"category": "SFA Intensive",
					"instrumentation": "Single piezometers",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MOP3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9475228,
						38.92186363,
						2757.39
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MOP3",
					"name": "Meander O (oxbow), position 3",
					"category": "SFA Intensive",
					"instrumentation": "Single piezometers",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MOP4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947293,
						38.92184408,
						2756.93
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MOP4",
					"name": "Meander O (oxbow), position 4",
					"category": "SFA Intensive",
					"instrumentation": "Single piezometers",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying the Meander O (oxbow) floodplain at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9501598,
						38.92296836,
						2759.71
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCB1",
					"name": "Meander C, transect 2, position 1",
					"category": "SFA Intensive",
					"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCB2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9500587,
						38.92295536,
						2759.59
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCB2",
					"name": "Meander C, transect 2, position 2",
					"category": "SFA Intensive",
					"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCB3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9499313,
						38.922948,
						2759.54
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCB3",
					"name": "Meander C, transect 2, position 3",
					"category": "SFA Intensive",
					"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MCB4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9497152,
						38.92292541,
						2759.27
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-MCB4",
					"name": "Meander C, transect 2, position 4",
					"category": "SFA Intensive",
					"instrumentation": "Cluster of piezometers and soil rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander C at the Pumphouse location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9081525,
						38.88977065,
						2723.88
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZA1",
					"name": "Meander Z, transect 1, position 1",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZA2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9081644,
						38.88965275,
						2723.68
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZA2",
					"name": "Meander Z, transect 1, position 2",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZA3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9081672,
						38.88954611,
						2723.65
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZA3",
					"name": "Meander Z, transect 1, position 3",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZA4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908172,
						38.88943873,
						2723.55
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZA4",
					"name": "Meander Z, transect 1, position 4",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZA5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9081634,
						38.88934289,
						2723.58
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZA5",
					"name": "Meander Z, transect 1, position 5",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9077575,
						38.88987028,
						2723.52
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZB1",
					"name": "Meander Z, transect 2, position 1",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZB2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9077752,
						38.88972131,
						2723.8
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZB2",
					"name": "Meander Z, transect 2, position 2",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZB3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9078013,
						38.88958791,
						2723.68
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZB3",
					"name": "Meander Z, transect 2, position 3",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZB4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9078238,
						38.88949574,
						2723.58
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZB4",
					"name": "Meander Z, transect 2, position 4",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MZB5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9078419,
						38.8893628,
						2723.63
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MZB5",
					"name": "Meander Z, transect 2, position 5",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Z at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MYP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9088918,
						38.88989028,
						2723.98
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MYP1",
					"name": "Meander Y (oxbow just above MZ) piezometer 2",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Y (oxbow) at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MYP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9090547,
						38.88989372,
						2723.95
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-MYP2",
					"name": "Meander Y (oxbow just above MZ) piezometer 1",
					"category": "SFA Satellite Site",
					"instrumentation": "Several piezometers and rhizon samplers installed to various depths",
					"research_theme": "Alluvial aquifer solute concentrations.",
					"description": "Floodplain piezometer used to collect groundwater samples from the alluvial aquifer underlying Meander Y (oxbow) at the Brush Creek location. Groundwater geochemical data is used to understand and predict floodplain biogeochemical cycling and hyporheic exchange of solutes.",
					"variables_measured": "Ground water samples; biogeochemical cycling",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_AP-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95101,
						38.92334,
						2759.81
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_AP-1",
					"name": "CMSL_AP-1",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_AP-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95096,
						38.92315,
						2759.94
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_AP-2",
					"name": "CMSL_AP-2",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_AP-3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95068,
						38.92324,
						2759.65
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_AP-3",
					"name": "CMSL_AP-3",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_AP-4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95074,
						38.92296,
						2759.93
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_AP-4",
					"name": "CMSL_AP-4",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_DP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9472,
						38.92135,
						2757.09
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_DP1",
					"name": "CMSL_DP1",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_DP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9471,
						38.92128,
						2756.85
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_DP2",
					"name": "CMSL_DP2",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_DP3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94733,
						38.92129,
						2757.15
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_DP3",
					"name": "CMSL_DP3",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_DP4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94722,
						38.92115,
						2757.04
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_DP4",
					"name": "CMSL_DP4",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_DP5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94715,
						38.92108,
						2756.85
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_DP5",
					"name": "CMSL_DP5",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_DSW",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94744,
						38.92115,
						2756.66
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_DSW",
					"name": "CMSL_DSW",
					"category": "SFA Collaborator",
					"instrumentation": "Stilling Well",
					"research_theme": "Hydrology",
					"description": "Stilling Well",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_EP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90887,
						38.88702,
						2723.05
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_EP1",
					"name": "CMSL_EP1",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_EP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90874,
						38.8867,
						2722.9
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_EP2",
					"name": "CMSL_EP2",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_EP3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90901,
						38.88674,
						2722.79
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_EP3",
					"name": "CMSL_EP3",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer. Air Hobo colocated with EP3",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_EP4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90891,
						38.88681,
						2722.96
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_EP4",
					"name": "CMSL_EP4",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_EP5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90905,
						38.88689,
						2722.95
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_EP5",
					"name": "CMSL_EP5",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_ESW",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90874,
						38.88612,
						2721.96
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_ESW",
					"name": "CMSL_ESW",
					"category": "SFA Collaborator",
					"instrumentation": "Stilling Well",
					"research_theme": "Hydrology",
					"description": "Stilling Well",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_FP-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90807,
						38.8861,
						2722.5
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_FP-1",
					"name": "CMSL_FP-1",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_FP-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908,
						38.88591,
						2722.42
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_FP-2",
					"name": "CMSL_FP-2",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_FP-3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90839,
						38.88572,
						2722.49
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_FP-3",
					"name": "CMSL_FP-3",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_FP-4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.90829,
						38.88591,
						2722.64
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_FP-4",
					"name": "CMSL_FP-4",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_FP-5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9088,
						38.88601,
						2723.08
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_FP-5",
					"name": "CMSL_FP-5",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_GP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00315,
						38.97795,
						2925.92
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_GP1",
					"name": "CMSL_GP1",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer, Air Hobo",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_GP2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00303,
						38.97808,
						2925.89
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_GP2",
					"name": "CMSL_GP2",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_GP3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00275,
						38.978,
						2925.82
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_GP3",
					"name": "CMSL_GP3",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_GP4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00293,
						38.97792,
						2925.57
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_GP4",
					"name": "CMSL_GP4",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_GP5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00282,
						38.97783,
						2925.68
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_GP5",
					"name": "CMSL_GP5",
					"category": "SFA Collaborator",
					"instrumentation": "Piezometer",
					"research_theme": "Hydrology",
					"description": "Piezometer",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CMSL_GSW",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00317,
						38.97807,
						2925.53
					]
				},
				"properties": {
					"contact": {
						"name": "Kamini Singha",
						"email": "ksingha@mines.edu",
						"affiliation": "Colorado School of Mines"
					},
					"id": "CMSL_GSW",
					"name": "CMSL_GSW",
					"category": "SFA Collaborator",
					"instrumentation": "Stilling Well",
					"research_theme": "Hydrology",
					"description": "Stilling Well",
					"variables_measured": "Water level",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LPZ1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94915,
						38.921047,
						2761.75
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-LPZ1",
					"name": "Lower Montane Piezometer 1",
					"category": "SFA Intensive",
					"instrumentation": "drive point piezometer",
					"research_theme": "hillslope-floodplain connection",
					"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
					"variables_measured": "",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LPZ2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948642,
						38.9214,
						2758
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-LPZ2",
					"name": "Lower Montane Piezometer 2",
					"category": "SFA Intensive",
					"instrumentation": "drive point piezometer",
					"research_theme": "hillslope-floodplain connection",
					"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LPZ3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948344,
						38.921522,
						2758.29
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-LPZ3",
					"name": "Lower Montane Piezometer 3",
					"category": "SFA Intensive",
					"instrumentation": "drive point piezometer",
					"research_theme": "hillslope-floodplain connection",
					"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LPZ4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948131,
						38.920767,
						2759.41
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-LPZ4",
					"name": "Lower Montane Piezometer 4",
					"category": "SFA Intensive",
					"instrumentation": "drive point piezometer",
					"research_theme": "hillslope-floodplain connection",
					"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
					"variables_measured": "",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LPZ5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947969,
						38.920897,
						2757.61
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-LPZ5",
					"name": "Lower Montane Piezometer 5",
					"category": "SFA Intensive",
					"instrumentation": "drive point piezometer",
					"research_theme": "hillslope-floodplain connection",
					"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
					"variables_measured": "",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LPZ6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9478,
						38.921147,
						2757.18
					]
				},
				"properties": {
					"contact": {
						"name": "Patricia Fox",
						"email": "pmfox@lbl.gov",
						"affiliation": "LBL"
					},
					"id": "ER-LPZ6",
					"name": "Lower Montane Piezometer 6",
					"category": "SFA Intensive",
					"instrumentation": "drive point piezometer",
					"research_theme": "hillslope-floodplain connection",
					"description": "Piezometer used to collect shallow groundwater geochemical samples near the toeslope in the pumphouse vicinity. Data is used to understand the contribution of hillslope groundwater to the floodplain/river corridor. ",
					"variables_measured": "DIC; DOC; Anions; Cations; NH4",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "MeanderA_RB_A",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9512095,
						38.92315752,
						2759.26
					]
				},
				"properties": {
					"contact": {
						"name": "Mike Wilkins",
						"email": "mike.wilkins@colostate.edu",
						"affiliation": "Colorado State University"
					},
					"id": "MeanderA_RB_A",
					"name": "MeanderA_RB_A",
					"category": "SFA Collaborator",
					"instrumentation": "HOBO temperature loggers installed in riverbed at 5, 10, 20, and 35-cm depths.",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology, Surface discharge and solute flux",
					"description": "Data used to quantify river water and groundwater mixing dynamics and associated biogeochemical/microbiological responses",
					"variables_measured": "Temperature; metagenomics",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "MeanderA_RB_B",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.951007,
						38.92354069,
						2759.1
					]
				},
				"properties": {
					"contact": {
						"name": "Mike Wilkins",
						"email": "mike.wilkins@colostate.edu",
						"affiliation": "Colorado State University"
					},
					"id": "MeanderA_RB_B",
					"name": "MeanderA_RB_B",
					"category": "SFA Collaborator",
					"instrumentation": "HOBO temperature loggers installed in riverbed at 5, 10, 20, and 35-cm depths.",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology, Surface discharge and solute flux",
					"description": "Data used to quantify river water and groundwater mixing dynamics and associated biogeochemical/microbiological responses",
					"variables_measured": "Temperature; metagenomics",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "MeanderA_RB_C",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9505926,
						38.92331134,
						2759.06
					]
				},
				"properties": {
					"contact": {
						"name": "Mike Wilkins",
						"email": "mike.wilkins@colostate.edu",
						"affiliation": "Colorado State University"
					},
					"id": "MeanderA_RB_C",
					"name": "MeanderA_RB_C",
					"category": "SFA Collaborator",
					"instrumentation": "HOBO temperature loggers installed in riverbed at 5, 10, 20, and 35-cm depths.",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology, Surface discharge and solute flux",
					"description": "Data used to quantify river water and groundwater mixing dynamics and associated biogeochemical/microbiological responses",
					"variables_measured": "Temperature; metagenomics",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948681,
						38.920199,
						2776.55
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMA1L",
					"name": "Lower Montane A1 left",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9487,
						38.920206,
						2776.37
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMA1R",
					"name": "Lower Montane A1 right",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948827,
						38.920264,
						2775.94
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMA2L",
					"name": "Lower Montane A2 left",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94885,
						38.920274,
						2775.86
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMA2R",
					"name": "Lower Montane A2 right",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948368,
						38.920264,
						2772.31
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMB1L",
					"name": "Lower Montane B1 left",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948385,
						38.920272,
						2772.41
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMB1R",
					"name": "Lower Montane B1 right",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948532,
						38.920357,
						2771.39
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMB2L",
					"name": "Lower Montane B2 left",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948553,
						38.920362,
						2771.55
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMB2R",
					"name": "Lower Montane B2 right",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2L17",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948517,
						38.92032,
						2772.49
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMB2L17",
					"name": "Lower Montane B2 left 2017",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2R17",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948531,
						38.920326,
						2772.48
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMB2R17",
					"name": "Lower Montane B2 right 2017",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948652,
						38.92041,
						2771.33
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMC1L",
					"name": "Lower Montane C1 left",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948669,
						38.920417,
						2771.31
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMC1R",
					"name": "Lower Montane C1 right",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94883,
						38.920444,
						2771.61
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMC2L",
					"name": "Lower Montane C2 left",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948847,
						38.92045,
						2771.48
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-LMC2R",
					"name": "Lower Montane C2 right",
					"category": "SFA Intensive",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMA1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.009247,
						38.932903,
						2945.14
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMA1L",
					"name": "Upper Montane A1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMA1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.009284,
						38.932915,
						2944.99
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMA1R",
					"name": "Upper Montane A1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMA2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.009091,
						38.932854,
						2945.38
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMA2L",
					"name": "Upper Montane A2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMA2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.009123,
						38.932865,
						2945.46
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMA2R",
					"name": "Upper Montane A2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMB1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008757,
						38.932734,
						2944
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMB1L",
					"name": "Upper Montane B1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMB1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008762,
						38.932743,
						2943.99
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMB1R",
					"name": "Upper Montane B1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMB2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008543,
						38.932668,
						2943.42
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMB2L",
					"name": "Upper Montane B2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMB2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008562,
						38.932673,
						2943.48
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMB2R",
					"name": "Upper Montane B2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMC1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008255,
						38.932677,
						2940.7
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMC1L",
					"name": "Upper Montane C1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMC1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008281,
						38.932691,
						2940.83
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMC1R",
					"name": "Upper Montane C1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMC2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008133,
						38.932596,
						2940.6
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMC2L",
					"name": "Upper Montane C2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-UMC2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.008153,
						38.93261,
						2940.71
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-UMC2R",
					"name": "Upper Montane C2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSA1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02897,
						38.95598,
						3116.22
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSA1L",
					"name": "Lower Subalpine A1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSA1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028999,
						38.956019,
						3116.63
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSA1R",
					"name": "Lower Subalpine A1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSA2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02893,
						38.95584,
						3115.68
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSA2L",
					"name": "Lower Subalpine A2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSA2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028945,
						38.955876,
						3115.78
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSA2R",
					"name": "Lower Subalpine A2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSB1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028891,
						38.95571,
						3115.59
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSB1L",
					"name": "Lower Subalpine B1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSB1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0289,
						38.955732,
						3115.52
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSB1R",
					"name": "Lower Subalpine B1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSB2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028853,
						38.955566,
						3114.91
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSB2L",
					"name": "Lower Subalpine B2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSB2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028863,
						38.955582,
						3114.99
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSB2R",
					"name": "Lower Subalpine B2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSC1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028516,
						38.955129,
						3109.13
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSC1L",
					"name": "Lower Subalpine C1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSC1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028534,
						38.955172,
						3109.57
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSC1R",
					"name": "Lower Subalpine C1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSC2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028487,
						38.954969,
						3108.5
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSC2L",
					"name": "Lower Subalpine C2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WG-LSC2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.028502,
						38.955014,
						3108.86
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "WG-LSC2R",
					"name": "Lower Subalpine C2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USA1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036676,
						38.974022,
						3460.58
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USA1L",
					"name": "Upper Subalpine A1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USA1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036711,
						38.974012,
						3460.66
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USA1R",
					"name": "Upper Subalpine A1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USA2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036824,
						38.973974,
						3461.09
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USA2L",
					"name": "Upper Subalpine A2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USA2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036871,
						38.973961,
						3461.23
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USA2R",
					"name": "Upper Subalpine A2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USB1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036707,
						38.974244,
						3458.39
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USB1L",
					"name": "Upper Subalpine B1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USB1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036745,
						38.974253,
						3458.42
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USB1R",
					"name": "Upper Subalpine B1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USB2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036518,
						38.97436,
						3454.88
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USB2L",
					"name": "Upper Subalpine B2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USB2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.036553,
						38.974362,
						3455.07
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USB2R",
					"name": "Upper Subalpine B2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USC1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.037085,
						38.974302,
						3458.78
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USC1L",
					"name": "Upper Subalpine C1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USC1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.037109,
						38.974304,
						3458.8
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USC1R",
					"name": "Upper Subalpine C1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USC2L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.037236,
						38.974332,
						3459.34
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USC2L",
					"name": "Upper Subalpine C2 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-USC2R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.037269,
						38.974331,
						3459.72
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-USC2R",
					"name": "Upper Subalpine C2 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ALA1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.067419,
						38.996929,
						3636.23
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "XX-ALA1L",
					"name": "Alpine A1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ALA1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.067405,
						38.996955,
						3635.43
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "XX-ALA1R",
					"name": "Alpine A1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ALB1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.067228,
						38.996881,
						3629.95
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "XX-ALB1L",
					"name": "Alpine B1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ALB1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.067207,
						38.996908,
						3626.65
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "XX-ALB1R",
					"name": "Alpine B1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ALC1L",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.067085,
						38.996731,
						3620.2
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "XX-ALC1L",
					"name": "Alpine C1 left",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ALC1R",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.067052,
						38.996758,
						3620.2
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "XX-ALC1R",
					"name": "Alpine C1 right",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Phenology and microclimate monitoring in response to experimental snowmelt advance",
					"description": "Phenology Plot. Subplot within experimental plot",
					"variables_measured": "Phenophases; soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985509,
						38.95706684,
						2917.46
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU1",
					"name": "Warming Meadow 1 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985446,
						38.95706163,
						2916.18
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML1",
					"name": "Warming Meadow 1 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9855037,
						38.95712212,
						2917.36
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU2",
					"name": "Warming Meadow 2 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9854379,
						38.95711273,
						2916.16
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML2",
					"name": "Warming Meadow 2 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9854849,
						38.95717009,
						2917.19
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU3",
					"name": "Warming Meadow 3 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9854232,
						38.95715653,
						2915.8
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML3",
					"name": "Warming Meadow 3 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9854688,
						38.95722014,
						2917.12
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU4",
					"name": "Warming Meadow 4 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9854058,
						38.95720033,
						2915.81
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML4",
					"name": "Warming Meadow 4 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985442,
						38.95726395,
						2917.03
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU5",
					"name": "Warming Meadow 5 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9853843,
						38.95724517,
						2915.8
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML5",
					"name": "Warming Meadow 5 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9854111,
						38.95731192,
						2917.05
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU6",
					"name": "Warming Meadow 6 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9853588,
						38.95729002,
						2915.84
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML6",
					"name": "Warming Meadow 6 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9853776,
						38.95735363,
						2917.25
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU7",
					"name": "Warming Meadow 7 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9853293,
						38.95732652,
						2916.05
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML7",
					"name": "Warming Meadow 7 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9853347,
						38.95739117,
						2917.55
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU8",
					"name": "Warming Meadow 8 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9852904,
						38.95736197,
						2916.35
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML8",
					"name": "Warming Meadow 8 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9852891,
						38.95742976,
						2917.71
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU9",
					"name": "Warming Meadow 9 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9852408,
						38.95739222,
						2916.37
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML9",
					"name": "Warming Meadow 9 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WMU10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9852341,
						38.95746939,
						2917.8
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WMU10",
					"name": "Warming Meadow 10 upper zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-WML10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9851872,
						38.95742976,
						2916.72
					]
				},
				"properties": {
					"contact": {
						"name": "Heidi Steltzer",
						"email": "steltzer_h@fortlewis.edu",
						"affiliation": "Ft. Lewis"
					},
					"id": "ER-WML10",
					"name": "Warming Meadow 10 lower zone",
					"category": "SFA Satellite Site",
					"instrumentation": "HOBO logger and microclimate sensors",
					"research_theme": "Microclimate monitoring",
					"description": "Experimental plot sub-zone. Subplot within experimental plot",
					"variables_measured": "Soil water content; soil temperature",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9488357,
						38.92025272,
						2776.28
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-1",
					"name": "Pumphouse Snow Manipulation Plot sensor station A2-1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9487786,
						38.92028205,
						2775.28
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-2",
					"name": "Pumphouse Snow Manipulation Plot sensor station A2-2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9486837,
						38.92021441,
						2776.22
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-1",
					"name": "Pumphouse Snow Manipulation Plot sensor station A1-1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9486333,
						38.9202656,
						2774.5
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-2",
					"name": "Pumphouse Snow Manipulation Plot sensor station A1-2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484184,
						38.92030497,
						2771.88
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-1",
					"name": "Pumphouse Snow Manipulation Plot sensor station B1-1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948345,
						38.92035176,
						2769.69
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-2",
					"name": "Pumphouse Snow Manipulation Plot sensor station B1-2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484864,
						38.92033763,
						2771.69
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-1",
					"name": "Pumphouse Snow Manipulation Plot sensor station B2-1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9485132,
						38.92039429,
						2770.27
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-2",
					"name": "Pumphouse Snow Manipulation Plot sensor station B2-2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9486608,
						38.92039446,
						2771.8
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-1",
					"name": "Pumphouse Snow Manipulation Plot sensor station C1-1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9486782,
						38.9204693,
						2769.65
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-2",
					"name": "Pumphouse Snow Manipulation Plot sensor station C1-2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9488019,
						38.92045273,
						2771.08
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-1",
					"name": "Pumphouse Snow Manipulation Plot sensor station C2-1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9487664,
						38.92047172,
						2770.42
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-2",
					"name": "Pumphouse Snow Manipulation Plot sensor station C2-2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 150cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMF1-1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948078,
						38.92100711,
						2757.43
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMF1-1",
					"name": "Pumphouse floodplan sensor station FP - 1",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 114cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMF2-2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9479755,
						38.92119667,
						2757.6
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMF2-2",
					"name": "Pumphouse floodplan sensor station FP - 2",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 114cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMF3-3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.947799,
						38.92134673,
						2757.47
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMF3-3",
					"name": "Pumphouse floodplan sensor station FP - 3",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-6 cm (T); -9cm (T/WC/EC); -17cm (T/WP); -60cm (T/WC/EC); - 114cm (T/WP)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95,
						38.92,
						2791.16
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PHS1",
					"name": "PumpHouse sensor tower #1",
					"category": "SFA Intensive",
					"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
					"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHS2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9472883,
						38.9225826,
						2760.73
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PHS2",
					"name": "Pumphouse sensor tower #2",
					"category": "SFA Intensive",
					"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
					"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHS3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9516586,
						38.9206498,
						2789.22
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "Ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PHS3",
					"name": "Pumphouse sensor tower #3",
					"category": "SFA Intensive",
					"instrumentation": "As of October 2021, this site only contains soil sensors. Historical Location Instrumentation: Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "As of October 2021, this sensor tower, along with ER-PHS4, was moved to new monitoring locations at SG-EHS7 and SG-EHS8. The site as of October 2021, has a reduced sensor package only containing soil sensors. Historical Location Description: This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
					"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PHS4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95154,
						38.9205581,
						2791.19
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-PHS4",
					"name": "Pumphouse sensor tower #4",
					"category": "SFA Intensive",
					"instrumentation": "As of October 2021, this site only contains soil sensors. Historical Location Instrumentation: Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "As of October 2021, this sensor tower, along with ER-PHS3, was moved to new monitoring locations at SG-EHS7 and SG-EHS8. The site as of October 2021, has a reduced sensor package only containing soil sensors. Historical Location Description: This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
					"variables_measured": "3m (Micromet); 2.5m (PAR); 1.6m (NetR; IR); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-EHS5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98,
						38.92625,
						3146.68
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "Ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-EHS5",
					"name": "Snodgrass tower #5",
					"category": "SFA Intensive",
					"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
					"variables_measured": "4m (Micromet); 3.5m (PAR); 2m (NetR; IR; Snow Depth); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC); -115 cm(T/WC/EC)2",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-EHS6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.977,
						38.92565,
						3120.61
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-EHS6",
					"name": "Snodgrass tower #6",
					"category": "SFA Intensive",
					"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "This is the above and below ground sensor suite station #1 installed close to the new deep wells on the north facing slope close to PLM#2. This has a weather Station, Sampling Station, Soil moisture sensor, soil matrix potential sensor, CO2 flux chamber, Infrared camera, Net radiation sensor, Soil heat flux, temperature probes",
					"variables_measured": "4m (Micromet); 3.5m (PAR); 2m (NetR; IR; Snow Depth); 0m (CO2 flux); -5cm (Heat flux);-10cm (T/WC/EC); -30cm(T/WC/EC/WP/O2); -60cm (T/WC/EC)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-EHS7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9861122,
						38.9323418,
						3558.95
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-EHS7",
					"name": "Snodgrass tower #7",
					"category": "SFA Intensive",
					"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, PAR sensor, temperature probes, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, soil oxygen sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "This site is at the snodgrass mountain sumit, in a conifer understory. We monitor ambient and soil variables to model daily, seasonal and long-term energy fluxes (i.e. evapotranspiration) and soil water dynamics (i.e. snow, melt, monsoon and plant water use). ",
					"variables_measured": "3.35m (Micromet: air temperature, vapor pressure, barometric pressure, wind and gust speed (2D), wind direction (2D), precipitation); 2.7m (Photosynthetic active radiation, incoming); 2m (Net radiation); 1.9m (Infrared temperature); 0m (Soil CO2 flux); -0.05m (Soil heat flux); -0.1m (Soil temperature/water content/bulk electrical conductivity); -0.3 m(Soil T/WC/EC/matric potential/O2 concentration); -0.5m (Soil T/WC/EC)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-EHS8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9707767,
						38.9255186,
						3020.68
					]
				},
				"properties": {
					"contact": {
						"name": "Yuxin Wu",
						"email": "ywu3@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-EHS8",
					"name": "Snodgrass tower #8",
					"category": "SFA Intensive",
					"instrumentation": "Station includes a suite of above and below ground sensors including a micromet sensor, infrared sensor, net radiation sensor, PAR sensor, temperature probes, snow depth sensor, soil moisture sensors, soil matrix potential sensor, soil heat flux sensor, soil oxygen sensor, CO2 flux chamber.",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "This site is at the snodgrass mountain (right pass the third gate), in an aspen understory. We monitor ambient and soil variables to model and study daily, seasonal and long-term energy fluxes (i.e. evapotranspiration) and soil water dynamics (i.e. snow, melt, monsoon and plant water use). ",
					"variables_measured": "2.8m (Micromet: air temperature, vapor pressure, barometric pressure, wind and gust speed (2D), wind direction (2D), precipitation); 2.4m (Photosynthetic active radiation, incoming); 1.75m (Net radiation, snow depth); 1.65m (Infrared temperature); 0m (Soil CO2 flux); -0.05m (Soil heat flux); -0.1m (Soil temperature/water content/bulk electrical conductivity); -0.3 m(Soil T/WC/EC/matric potential/O2 concentration); -0.6m (Soil T/WC/EC); -0.75m (Soil T/WC/EC)",
					"measurement_categories": [
						"hydrogeology",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SMA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SMA1",
					"name": "Soil array at Snodgrass southwest ridge 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, 60, and 80 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SMB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SMB1",
					"name": "Soil array at Snodgrass southwest ridge 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 30 and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMA2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMA2",
					"name": "Soil array at Baldy Mountain east slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMB2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMB2",
					"name": "Soil array at Baldy Mountain east slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMA3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMA3",
					"name": "Soil array at Avery Peak lower west slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMB3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMB3",
					"name": "Soil array at Avery Peak lower west slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SMA4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SMA4",
					"name": "Soil array at Carbon Creek valley 3 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SMB4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SMB4",
					"name": "Soil array at Carbon Creek valley 3 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMA5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMA5",
					"name": "Soil array at Gothic Mountain east slope replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMB5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMB5",
					"name": "Soil array at Gothic Mountain east slope replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SMA6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SMA6",
					"name": "Soil array at Point Lookout north slope 2 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SMB6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SMB6",
					"name": "Soil array at Point Lookout north slope 2 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-SMA7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.08
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-SMA7",
					"name": "Soil array at Poverty Gulch 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-SMB7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.08
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-SMB7",
					"name": "Soil array at Poverty Gulch 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMA8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMA8",
					"name": "Soil array at Avery Peak upper west slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMB8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMB8",
					"name": "Soil array at Avery Peak upper west slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-SMA9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-SMA9",
					"name": "Soil array at Coal Valley south 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-SMB9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-SMB9",
					"name": "Soil array at Coal Valley south 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SMA10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SMA10",
					"name": "Soil array at Snodgrass northeast slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SMB10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SMB10",
					"name": "Soil array at Snodgrass northeast slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "METER TEROS 12 volumetric soil water content, soil temperature, and soil conductivity arrays at two pits per site and three depths per pit (10, 30, 60 cm)",
					"research_theme": "Subsurface water",
					"description": "Probes collecting volumetric soil water content, soil temperature, and soil conductivity measurements in one replicate pit at depths of 10, 30, and 60 cm",
					"variables_measured": "Soil volumetric water content, soil temperature, soil conductivity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SNA1",
					"name": "Distributed snow temperature profiling system at Snodgrass southwest ridge 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SNB1",
					"name": "Distributed snow temperature profiling system at Snodgrass southwest ridge 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNA2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNA2",
					"name": "Distributed snow temperature profiling system at Baldy Mountain east slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNB2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNB2",
					"name": "Distributed snow temperature profiling system at Baldy Mountain east slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNA3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNA3",
					"name": "Distributed snow temperature profiling system at Avery Peak lower west slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNB3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNB3",
					"name": "Distributed snow temperature profiling system at Avery Peak lower west slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SNA4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SNA4",
					"name": "Distributed snow temperature profiling system at Carbon Creek valley 3 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SNB4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SNB4",
					"name": "Distributed snow temperature profiling system at Carbon Creek valley 3 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SNC4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SNC4",
					"name": "Distributed snow temperature profiling system at Carbon Creek valley 3 replicate C",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNA5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNA5",
					"name": "Distributed snow temperature profiling system at Gothic Mountain east slope replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNB5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNB5",
					"name": "Distributed snow temperature profiling system at Gothic Mountain east slope replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SNA6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SNA6",
					"name": "Distributed snow temperature profiling system at Point Lookout north slope 2 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SNB6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SNB6",
					"name": "Distributed snow temperature profiling system at Point Lookout north slope 2 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-SNA7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.01
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-SNA7",
					"name": "Distributed snow temperature profiling system at Poverty Gulch 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-SNB7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.01
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-SNB7",
					"name": "Distributed snow temperature profiling system at Poverty Gulch 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNA8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNA8",
					"name": "Distributed snow temperature profiling system at Avery Peak upper west slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SNB8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SNB8",
					"name": "Distributed snow temperature profiling system at Avery Peak upper west slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-SNA9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-SNA9",
					"name": "Distributed snow temperature profiling system at Coal Valley south 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-SNB9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-SNB9",
					"name": "Distributed snow temperature profiling system at Coal Valley south 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNA10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SNA10",
					"name": "Distributed snow temperature profiling system at Snodgrass northeast slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SNB10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SNB10",
					"name": "Distributed snow temperature profiling system at Snodgrass northeast slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed snow temperature profiling system",
					"research_theme": "Snow inputs to water fluxes",
					"description": "External temperature measured at intervals along a vertical profile to infer snow accumulation, depth, and melt dynamics",
					"variables_measured": "Snow depth inferred via snow-air temperature differential",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SOA1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SOA1",
					"name": "Distributed soil temperature profiling system at Snodgrass southwest ridge 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SOB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SOB1",
					"name": "Distributed soil temperature profiling system at Snodgrass southwest ridge 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOA2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOA2",
					"name": "Distributed soil temperature profiling system at Baldy Mountain east slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOB2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOB2",
					"name": "Distributed soil temperature profiling system at Baldy Mountain east slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOA3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOA3",
					"name": "Distributed soil temperature profiling system at Avery Peak lower west slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOB3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOB3",
					"name": "Distributed soil temperature profiling system at Avery Peak lower west slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SOA4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SOA4",
					"name": "Distributed soil temperature profiling system at Carbon Creek valley 3 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SOB4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SOB4",
					"name": "Distributed soil temperature profiling system at Carbon Creek valley 3 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOA5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOA5",
					"name": "Distributed soil temperature profiling system at Gothic Mountain east slope replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOB5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOB5",
					"name": "Distributed soil temperature profiling system at Gothic Mountain east slope replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SOA6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SOA6",
					"name": "Distributed soil temperature profiling system at Point Lookout north slope 2 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SOB6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SOB6",
					"name": "Distributed soil temperature profiling system at Point Lookout north slope 2 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-SOC6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-SOC6",
					"name": "Distributed soil temperature profiling system at Point Lookout north slope 2 replicate C",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-SOA7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.01
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-SOA7",
					"name": "Distributed soil temperature profiling system at Poverty Gulch 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-SOB7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.01
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-SOB7",
					"name": "Distributed soil temperature profiling system at Poverty Gulch 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOA8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOA8",
					"name": "Distributed soil temperature profiling system at Avery Peak upper west slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SOB8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SOB8",
					"name": "Distributed soil temperature profiling system at Avery Peak upper west slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-SOA9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-SOA9",
					"name": "Distributed soil temperature profiling system at Coal Valley south 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-SOB9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-SOB9",
					"name": "Distributed soil temperature profiling system at Coal Valley south 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SOA10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SOA10",
					"name": "Distributed soil temperature profiling system at Snodgrass northeast slope 1 replicate A",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SOB10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SOB10",
					"name": "Distributed soil temperature profiling system at Snodgrass northeast slope 1 replicate B",
					"category": "SFA Intensive",
					"instrumentation": "Distributed soil temperature profiling system",
					"research_theme": "Subsurface water and energy flux",
					"description": "Soil temperature measured at intervals along a vertical column to infer moisture infiltration dynamics",
					"variables_measured": "Soil temperature along vertical profile",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-ATH1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98427,
						38.9220943,
						3283.98
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-ATH1",
					"name": "Air temperature and relative humidity sensor at Snodgrass southwest ridge 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-ATH2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03067,
						38.9761534,
						3342.23
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-ATH2",
					"name": "Air temperature and relative humidity sensor at Baldy Mountain east slope 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-ATH3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.99245,
						38.9770753,
						3048.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-ATH3",
					"name": "Air temperature and relative humidity sensor at Avery Peak lower west slope 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ATH4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03922,
						38.8165497,
						2990.91
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-ATH4",
					"name": "Air temperature and relative humidity sensor at Carbon Creek valley 3",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-ATH5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0059,
						38.9770912,
						3006.02
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-ATH5",
					"name": "Air temperature and relative humidity sensor at Gothic Mountain east slope",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "XX-ATH6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8694,
						38.8536627,
						3131.21
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "XX-ATH6",
					"name": "Air temperature and relative humidity sensor at Point Lookout north slope 2",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SR-ATH7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.08073,
						38.954328,
						2969.01
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SR-ATH7",
					"name": "Air temperature and relative humidity sensor at Poverty Gulch 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-ATH8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.9790796,
						3552.61
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-ATH8",
					"name": "Air temperature and relative humidity sensor at Avery Peak upper west slope 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CC-ATH9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03527,
						38.8609133,
						2907.2
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "CC-ATH9",
					"name": "Air temperature and relative humidity sensor at Coal Valley south 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-ATH10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865,
						38.933091,
						3334.63
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-ATH10",
					"name": "Air temperature and relative humidity sensor at Snodgrass northeast slope 1",
					"category": "SFA Intensive",
					"instrumentation": "Onset HOBO U23 Pro v2 External Temperature/Relative Humidity Data Sensor and Logger mounted on 2 m fencepost",
					"research_theme": "Surface-atmosphere water and energy flux",
					"description": "Continuous external air temperature and relative humidity measurements",
					"variables_measured": "External air temperature and relative humidity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMN1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9486228,
						38.92059975,
						2765.05
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMN1",
					"name": "E1-54",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -10 (T/WC/EC); -10 (T/WP)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMN2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9485847,
						38.92072525,
						2761.17
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMN2",
					"name": "E2-3",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -30 (T/WP); -10 (T/WP)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMN3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9485306,
						38.92090132,
						2759.26
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMN3",
					"name": "E2-19",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -30 (T/WC/EC); -10 (T/WC/EC); -10 (T/WP)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMN4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484757,
						38.92105419,
						2758.81
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMN4",
					"name": "E2-33",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-40 cm (T/WC/EC); -40 (T/WP); -30 (T/WC/EC); -10 (T/WC/EC); -10 (T/WP)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SMN5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484702,
						38.92113326,
						2757.86
					]
				},
				"properties": {
					"contact": {
						"name": "Baptiste Dafflon",
						"email": "BDafflon@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-SMN5",
					"name": "E2-40",
					"category": "SFA Intensive",
					"instrumentation": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"research_theme": "Thermohydroclimate Monitoring",
					"description": "Multilevel decagon sensors with a temperature probe, soil moisture, pressure",
					"variables_measured": "-50 cm (T/WC/EC); -50 (T/WP); -30 (T/WP); -10 (T/WC/EC); -10 (T/WP)",
					"measurement_categories": [
						"hydrogeology"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WU-KCOCREST10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97194,
						38.894249,
						2803.56
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "Weather Underground"
					},
					"id": "WU-KCOCREST10",
					"name": "Weather Underground KCOCREST10",
					"category": "External Datasource",
					"instrumentation": "Weather Station",
					"research_theme": "",
					"description": "Weather Underground Weather Station",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WU-KCOCREST4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9762,
						38.8803978,
						2707.16
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "Weather Underground"
					},
					"id": "WU-KCOCREST4",
					"name": "Weather Underground KCOCREST4",
					"category": "External Datasource",
					"instrumentation": "Weather Station",
					"research_theme": "",
					"description": "Weather Underground Weather Station",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WU-KCOCREST6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.944467,
						38.8494644,
						2708.87
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "Weather Underground"
					},
					"id": "WU-KCOCREST6",
					"name": "Weather Underground KCOCREST6",
					"category": "External Datasource",
					"instrumentation": "Weather Station",
					"research_theme": "",
					"description": "Weather Underground Weather Station",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WU-KCOMTCRE2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95892,
						38.9150314,
						2923.12
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "Weather Underground"
					},
					"id": "WU-KCOMTCRE2",
					"name": "Weather Underground KCOMTCRE2",
					"category": "External Datasource",
					"instrumentation": "Weather Station",
					"research_theme": "",
					"description": "Weather Underground Weather Station near Crested Butte",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WU-MRMEX",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.064,
						39.0283,
						3410.51
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "Weather Underground"
					},
					"id": "WU-MRMEX",
					"name": "Weather Underground MRMEX",
					"category": "External Datasource",
					"instrumentation": "Weather Station",
					"research_theme": "",
					"description": "Weather Underground Weather Station",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "WU-MTAPC2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.603,
						38.9086,
						3174.17
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "Weather Underground"
					},
					"id": "WU-MTAPC2",
					"name": "Weather Underground MTAPC2",
					"category": "External Datasource",
					"instrumentation": "Weather Station",
					"research_theme": "",
					"description": "Weather Underground Weather Station",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-AMT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.8591304,
						38.65369565,
						2440.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "ER-AMT1",
					"name": "Almont Weather Station",
					"category": "SFA Collaborator",
					"instrumentation": "Weather Station. Maintained currently by NCAR, instrumentation partly paid for by the SFA.",
					"research_theme": "Atmospheric inputs of water and energy",
					"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-AMT1_1WL_KcZGPiRKNgAKsqdZs5ZwKK3ub_nk6"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BLB1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9911594,
						38.96021739,
						2902.17
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "ER-BLB1",
					"name": "Billy Barr Weather Station",
					"category": "SFA Collaborator",
					"instrumentation": "Weather Station. Maintained currently by NCAR",
					"research_theme": "Atmospheric inputs of water and energy",
					"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth;",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-BLB1_19HFEd1-3inv9qhhPaZeDIMRNV9QATzqg",
							"ER-BLB1_1m8X3jwzFJRo-ss8Q1tmLHM8qWJXoJh1g"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-JDF1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9835507,
						38.96065217,
						2975.59
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "ER-JDF1",
					"name": "Judd Falls Weather Station",
					"category": "SFA Collaborator",
					"instrumentation": "Weather Station. Maintained currently by NCAR",
					"research_theme": "Atmospheric inputs of water and energy",
					"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-JDF1_1X-gx9lYQxfDlkoi30dtHycjnXzcrEBmm"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-KLP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9716667,
						38.93985507,
						2838.19
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "ER-KLP1",
					"name": "Kettle Ponds Weather Station",
					"category": "SFA Collaborator",
					"instrumentation": "Weather Station. Maintained currently by NCAR",
					"research_theme": "Atmospheric inputs of water and energy",
					"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Snow Depth; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-KLP1_1UmAgH7geJfEQL4g0C7QbTyOr6Ish_9xG"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-MXC1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0606522,
						39.0257971,
						3404.08
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "ER-MXC1",
					"name": "Mexican Cut Weather Station",
					"category": "SFA Collaborator",
					"instrumentation": "Weather Station. Maintained currently by NCAR",
					"research_theme": "Atmospheric inputs of water and energy",
					"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR); Snow Depth",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy",
							"ER-MXC1_1wfQjfEhZlZTNHkx12kkEhfg5hDRmr_sB"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SMT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9855072,
						38.92949275,
						3328.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "SG-SMT1",
					"name": "Snodgrass Mountain Weather Station",
					"category": "SFA Collaborator",
					"instrumentation": "Weather Station. Maintained currently by NCAR",
					"research_theme": "Atmospheric inputs of water and energy",
					"description": "Data define boundary condition fluxes of water and energy at the landsurface for hydrologic interpretation. Weather stations are positioned across an elevation gradient.",
					"variables_measured": "Wind Speed; Wind Direction; Air Temperature; Relative Humidity; Barometric Pressure; Photosynthetically Active Radiation; Reflected PAR; Soil Temperature; Soil Moisture (TDR);",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": [
							"SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PFT0",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.949699,
						38.922242,
						2759.11
					]
				},
				"properties": {
					"contact": {
						"name": "Dave Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "LBNL"
					},
					"id": "ER-PFT0",
					"name": "Pumphouse Flux Tower",
					"category": "SFA Collaborator",
					"instrumentation": "The eddy flux tower stands at six meters high and supports multiple sensors. The sensor suite for the eddy covariance (EC)/energy balance system include air temperature\n and humidity sensors, a snow depth sensor, an air pressure transducer, a three-dimensional sonic anemometer with integrated CO2 and H2O open-path gas analyzer, two levels of soil moisture, soil temperature and soil electrical conductivity (5 cm and 25 cm), and ground heat flux plates located at a 5cm depth. The measurement height for the eddy covariance/infra-red gas analyzer and 4-way radiometer was set at just below 6 m (5.9 m) which is approximately 3-4 meters above the willow shrub gallery that covers much of the valley floor.",
					"research_theme": "Water-Energy Balance",
					"description": "The 6 m tall tower situated near the pumphouse meanders was situated to capture the turbulence from the dominant northwestern wind direction. Data from the tower are used to constrain the upper values of latent heat flux in the riparian zone. See details in Ryken et al. (2020) in review.",
					"variables_measured": "The sensor suite for the eddy covariance (EC)/energy balance system include air temperature\n and humidity sensors; a snow depth sensor; an air pressure transducer; a three-dimensional sonic anemometer with integrated CO2 and H2O open-path gas analyzer; two levels of soil moisture; soil temperature and soil electrical conductivity (5 cm and 25 cm); and ground heat flux plates located at a 5cm depth.",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-PFT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95231,
						38.9229,
						2760.43
					]
				},
				"properties": {
					"contact": {
						"name": "David Gochis",
						"email": "gochis@ucar.edu",
						"affiliation": "NCAR"
					},
					"id": "ER-PFT1",
					"name": "SFA Pumphouse Eddy Covariance",
					"category": "SFA Collaborator",
					"instrumentation": "Campbell Scientific Irgason, K&Z CNR4",
					"research_theme": "Evapotranspiration, CO2 and energy fluxes",
					"description": "Eddy Covariance and Energy Balance measurements",
					"variables_measured": "ET, CO2 flux, sensible heat flux, latent heat flux, soil moisture/temperature, ground heat flux, snow depth, T/RH, surface skin temperature",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CASTNET-GTH161",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98587,
						38.95627,
						2917.45
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "EPA"
					},
					"id": "CASTNET-GTH161",
					"name": "U.S. EPA CASTNET Gothic station",
					"category": "External Datasource",
					"instrumentation": "Air Quality Monitoring Station",
					"research_theme": "",
					"description": "U.S. EPA CASTNET Air Quality Monitoring Station at Gothic (GTH161). See https://www3.epa.gov/castnet/site_pages/GTH161.html for details.",
					"variables_measured": "Ozone; Wet and dry nitrogen and sulfur deposition; Air Temperature; Relative Humidity; Wind Speed; Wind Direction",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "NRCS-380",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.953,
						38.8943,
						3102.73
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "NRCS"
					},
					"id": "NRCS-380",
					"name": "snotel_butte",
					"category": "External Datasource",
					"instrumentation": "NRCS SNOTEL station",
					"research_theme": "",
					"description": "NRCS SNOTEL station. See https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=380",
					"variables_measured": "Snow Water Equivalent; Snow Depth",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "NRCS-737",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0488,
						39.0152,
						3252.3
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "NRCS"
					},
					"id": "NRCS-737",
					"name": "snotel_schofield_pass",
					"category": "External Datasource",
					"instrumentation": "NRCS SNOTEL station",
					"research_theme": "",
					"description": "NRCS SNOTEL station. See: https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=737",
					"variables_measured": "Snow Water Equivalent; Snow Depth",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "NRCS-1141",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.7542,
						38.9908,
						3346.86
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "NRCS"
					},
					"id": "NRCS-1141",
					"name": "snotel_upper_taylor",
					"category": "External Datasource",
					"instrumentation": "NRCS SNOTEL station",
					"research_theme": "",
					"description": "NRCS SNOTEL. See: https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=1141",
					"variables_measured": "Snow Water Equivalent; Snow Depth",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "NRCS-680",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.583333,
						38.816667,
						2937.1
					]
				},
				"properties": {
					"contact": {
						"name": "",
						"email": "",
						"affiliation": "NRCS"
					},
					"id": "NRCS-680",
					"name": "snotel_park_cone",
					"category": "External Datasource",
					"instrumentation": "NRCS SNOTEL station",
					"research_theme": "",
					"description": "NRCS SNOTEL station. See: https://wcc.sc.egov.usda.gov/nwcc/site?sitenum=680",
					"variables_measured": "Snow Water Equivalent; Snow Depth",
					"measurement_categories": [
						"hydrogeology",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9875285,
						38.95777091,
						2889.42
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT1",
					"name": "RMBL Research Meadow PIEN1",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9867145,
						38.95786025,
						2902.42
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT2",
					"name": "RMBL Research Meadow PIEN2",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865703,
						38.95795908,
						2905.64
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT3",
					"name": "RMBL Research Meadow PIEN3",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985511,
						38.9580112,
						2910.37
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT4",
					"name": "RMBL Research Meadow PIEN4",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985663,
						38.95755356,
						2912.03
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT5",
					"name": "RMBL Research Meadow PIEN5",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9875559,
						38.95771349,
						2889.47
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT6",
					"name": "RMBL Research Meadow ABLA1",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9866935,
						38.95791657,
						2900.04
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT7",
					"name": "RMBL Research Meadow ABLA2",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT8",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9865978,
						38.95789492,
						2905.65
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT8",
					"name": "RMBL Research Meadow ABLA3",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT9",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9855968,
						38.95796062,
						2910.66
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT9",
					"name": "RMBL Research Meadow ABLA4",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMT10",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9855458,
						38.95750334,
						2914.96
					]
				},
				"properties": {
					"contact": {
						"name": "Lara Kueppers",
						"email": "lmkueppers@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-RMT10",
					"name": "RMBL Research Meadow ABLA5",
					"category": "SFA Collaborator",
					"instrumentation": "",
					"research_theme": "Tree traits, leaf physiology",
					"description": "Data used to characterize species differences in water-use strategies and transpiration rates.",
					"variables_measured": "Terminal brachlette (needles and stem) pressure-volume curves; apical branch xylem conductivity; stomatal conductance.",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SFX1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9708,
						38.92578,
						3019.88
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "SG-SFX1",
					"name": "Snodgrass Sapflux 1",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SFX2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9772,
						38.93018,
						3114.81
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "SG-SFX2",
					"name": "Snodgrass Sapflux 2",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SFX3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9796,
						38.92918,
						3177.78
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "SG-SFX3",
					"name": "Snodgrass Sapflux 3",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SFX4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9863,
						38.9276,
						3273.21
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "SG-SFX4",
					"name": "Snodgrass Sapflux 4",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SFX5",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9858,
						38.93207,
						3359.89
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "SG-SFX5",
					"name": "Snodgrass Sapflux 5",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SFX6",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9658,
						38.92759,
						2961.7
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "SG-SFX6",
					"name": "Snodgrass Sapflux 6",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SFX7",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9852,
						38.95765,
						2913
					]
				},
				"properties": {
					"contact": {
						"name": "Max Berkelhammer",
						"email": "berkelha@uic.edu",
						"affiliation": "University of Illinois at Chicago"
					},
					"id": "ER-SFX7",
					"name": "Research Meadow Sapflux 7",
					"category": "SFA Collaborator",
					"instrumentation": "ICT SFM 1 standalone sap flux sensor",
					"research_theme": "Transpiration/Hydrogeology",
					"description": "Continuous sap flux measured on fir, spurce and aspen",
					"variables_measured": "Sap velocity",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation",
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Almont_Enquist",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.860992,
						38.654421,
						2467.26
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Almont_Enquist",
					"name": "Almont_Enquist",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CBT_Enquist_2012_2014",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.980441,
						38.881751,
						2706.23
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "CBT_Enquist_2012_2014",
					"name": "CBT_Enquist_2012_2014",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "CBT_Enquist_2015_2017",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.980293,
						38.88167,
						2706.15
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "CBT_Enquist_2015_2017",
					"name": "CBT_Enquist_2015_2017",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "PBM_Enquist_2014_2016",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04111,
						38.96935,
						3372.36
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "PBM_Enquist_2014_2016",
					"name": "PBM_Enquist_2014_2016",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "PBM_Enquist_2017",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04088,
						38.969139,
						3369.88
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "PBM_Enquist_2017",
					"name": "PBM_Enquist_2017",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Pfeiler_Enquist_2012_2016",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.031093,
						38.960805,
						3176.39
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Pfeiler_Enquist_2012_2016",
					"name": "Pfeiler_Enquist_2012_2016",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Pfeiler_Enquist_2017",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.031272,
						38.96056,
						3169.58
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Pfeiler_Enquist_2017",
					"name": "Pfeiler_Enquist_2017",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Road_Enquist_2012_2016",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.978616,
						38.897206,
						2811.35
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Road_Enquist_2012_2016",
					"name": "Road_Enquist_2012_2016",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Road_Enquist_2017",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.978186,
						38.897171,
						2807.11
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Road_Enquist_2017",
					"name": "Road_Enquist_2017",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Baldy_Enquist",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0369021,
						38.97378285,
						3464.03
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Baldy_Enquist",
					"name": "Baldy",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Lowermontane_Enquist",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9488181,
						38.92014512,
						2778.23
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Lowermontane_Enquist",
					"name": "Lowermontane",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Pfeiler_Enquist",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0288438,
						38.9555559,
						3114.78
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Pfeiler_Enquist",
					"name": "Pfeiler",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "Uppermontane_Enquist",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0085358,
						38.93262502,
						2943.69
					]
				},
				"properties": {
					"contact": {
						"name": "Brian Enquist",
						"email": "benquist@email.arizona.edu",
						"affiliation": "University of Arizona"
					},
					"id": "Uppermontane_Enquist",
					"name": "Uppermontane",
					"category": "SFA Collaborator",
					"instrumentation": "Phenocam",
					"research_theme": "",
					"description": "Phenocam",
					"variables_measured": "Photographs",
					"measurement_categories": [
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RMP1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.985268,
						38.957829,
						2913.7
					]
				},
				"properties": {
					"contact": {
						"name": "Mariah S Carbone",
						"email": "mariah.carbone@nau.edu",
						"affiliation": "NAU"
					},
					"id": "ER-RMP1",
					"name": "RMBL Research Meadow Soil Pits",
					"category": "SFA Collaborator",
					"instrumentation": "For each pit there are temperature, moisture, and soil CO2 sensors at 50cm, 15cm, 5cm, 0cm depths. And additional soil CO2 probe and temperature sensor is at 1.5m above the ground. All measurements are hourly.",
					"research_theme": "Soil Carbon cycling",
					"description": "Two soil pits: one in the aspen stand, one in the spruce/fir stand.",
					"variables_measured": "Soil CO2 concentration; temperature; moisture",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-115",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9559947,
						38.917216053,
						2926.62
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-115",
					"name": 115,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-116",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.955994698,
						38.917216053,
						2926.62
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-116",
					"name": 116,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-117",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.955994698,
						38.917216053,
						2926.62
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-117",
					"name": 117,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-118",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948286972,
						38.920399525,
						2767.93
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-118",
					"name": 118,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-119",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948286972,
						38.920399525,
						2767.93
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-119",
					"name": 119,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-120",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948286972,
						38.920399525,
						2767.93
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-120",
					"name": 120,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-121",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948286622,
						38.920405996,
						2767.9
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-121",
					"name": 121,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-122",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948286622,
						38.920405996,
						2767.9
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-122",
					"name": 122,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-123",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948286622,
						38.920405996,
						2767.9
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-123",
					"name": 123,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-134",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948918934,
						38.920281155,
						2776.06
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-134",
					"name": 134,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA1-135",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948918934,
						38.920281155,
						2776.06
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA1-135",
					"name": 135,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-139",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948918934,
						38.920281155,
						2776.06
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-139",
					"name": 139,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-140",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948918934,
						38.920281155,
						2776.06
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-140",
					"name": 140,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-141",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948918934,
						38.920281155,
						2776.06
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-141",
					"name": 141,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-142",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-142",
					"name": 142,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-143",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-143",
					"name": 143,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-144",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-144",
					"name": 144,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-145",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-145",
					"name": 145,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-146",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-146",
					"name": 146,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-147",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-147",
					"name": 147,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-148",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-148",
					"name": 148,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-149",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-149",
					"name": 149,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-150",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948452785,
						38.92045766,
						2767.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-150",
					"name": 150,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-151",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948748019,
						38.920576363,
						2766.94
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-151",
					"name": 151,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-152",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948748019,
						38.920576363,
						2766.94
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-152",
					"name": 152,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-153",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948748019,
						38.920576363,
						2766.94
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-153",
					"name": 153,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-157",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948748019,
						38.920576363,
						2766.94
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-157",
					"name": 157,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-158",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948748019,
						38.920576363,
						2766.94
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-158",
					"name": 158,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-159",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948748019,
						38.920576363,
						2766.94
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-159",
					"name": 159,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-181",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948759261,
						38.920297724,
						2774.85
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-181",
					"name": 181,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-182",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948759261,
						38.920297724,
						2774.85
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-182",
					"name": 182,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-183",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948759261,
						38.920297724,
						2774.85
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-183",
					"name": 183,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-184",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948394713,
						38.920307005,
						2771.63
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-184",
					"name": 184,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-185",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948394713,
						38.920307005,
						2771.63
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-185",
					"name": 185,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB1-186",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948394713,
						38.920307005,
						2771.63
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB1-186",
					"name": 186,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-193",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484972,
						38.920405922,
						2769.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-193",
					"name": 193,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-194",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484972,
						38.920405922,
						2769.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-194",
					"name": 194,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-195",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9484972,
						38.920405922,
						2769.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-195",
					"name": 195,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-196",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948682649,
						38.920405856,
						2771.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-196",
					"name": 196,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-197",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948682649,
						38.920405856,
						2771.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-197",
					"name": 197,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC1-198",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948682649,
						38.920405856,
						2771.69
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC1-198",
					"name": 198,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-202",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948817965,
						38.920442553,
						2771.5
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-202",
					"name": 202,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-203",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948817965,
						38.920442553,
						2771.5
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-203",
					"name": 203,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-204",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948817965,
						38.920442553,
						2771.5
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-204",
					"name": 204,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-355",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94875775,
						38.920294564,
						2774.89
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-355",
					"name": 355,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-356",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94875775,
						38.920294564,
						2774.89
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-356",
					"name": 356,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMA2-357",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94875775,
						38.920294564,
						2774.89
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMA2-357",
					"name": 357,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-367",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948476151,
						38.920406451,
						2769.35
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-367",
					"name": 367,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-368",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948476151,
						38.920406451,
						2769.35
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-368",
					"name": 368,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMB2-369",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948476151,
						38.920406451,
						2769.35
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMB2-369",
					"name": 369,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-379",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948785516,
						38.920487572,
						2770.27
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-379",
					"name": 379,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-380",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948785516,
						38.920487572,
						2770.27
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-380",
					"name": 380,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LMC2-381",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948785516,
						38.920487572,
						2770.27
					]
				},
				"properties": {
					"contact": {
						"name": "Eoin Brodie",
						"email": "elbrodie@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LMC2-381",
					"name": 381,
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Plant and Microbial Phenology",
					"description": "Soil cores were collected using soil bulk density corer attached to a slide hammer",
					"variables_measured": "Soil extractable nitrogen pools; Bacterial and fungal marker genes; Metagenomes and transcriptomes",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SPS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.976111,
						38.926111,
						3128.78
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SPS1",
					"name": "Conifers on Granodiorite",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
					"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
					"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
					"measurement_categories": [
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SPS2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98,
						38.92625,
						3146.68
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SPS2",
					"name": "Meadow",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
					"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
					"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
					"measurement_categories": [
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SPS3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.977,
						38.92565,
						3120.61
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SPS3",
					"name": "Conifers on Shale",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
					"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
					"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
					"measurement_categories": [
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "SG-SPS4",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9708,
						38.92578,
						3019.88
					]
				},
				"properties": {
					"contact": {
						"name": "Matthias Sprenger",
						"email": "msprenger@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "SG-SPS4",
					"name": "Aspen on Shale",
					"category": "SFA Intensive",
					"instrumentation": "",
					"research_theme": "Hydrogeology, Biogeochemistry, Microbiology",
					"description": "Soil and plant sampling for isotope and biogeochemical, microbiological analyeses",
					"variables_measured": "2H & 18O (H2O); 15N, 17O, 18O (NO3); 87Sr/ 86Sr + 44Ca; N; DOC; DOM; Microbiology ",
					"measurement_categories": [
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-LLN1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.948333,
						38.920555,
						2764.91
					]
				},
				"properties": {
					"contact": {
						"name": "Ben Gilbert",
						"email": "bgilbert@lbl.gov",
						"affiliation": "LBNL"
					},
					"id": "ER-LLN1",
					"name": "North Facing Hillslope Sagebrush Site 1",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Subsurface deep-root inducing rock weathering",
					"description": "Geochemical analysis and metagenomic of soil and root rhizosphere",
					"variables_measured": "Soil geochemical analysis, water content, microbiology, metabolomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T1-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0031454,
						38.97796352,
						2926.06
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T1-0m",
					"name": "Meander G, Banfield Transect 1: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T1-19m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0030383,
						38.97780667,
						2925.98
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T1-19m",
					"name": "Meander G, Banfield Transect 1: 19m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T1-38m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0029515,
						38.97765246,
						2925.69
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T1-38m",
					"name": "Meander G, Banfield Transect 1: 38m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T1-57m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0028515,
						38.97751102,
						2925.88
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T1-57m",
					"name": "Meander G, Banfield Transect 1: 57m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T2-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0030191,
						38.97818072,
						2925.49
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T2-0m",
					"name": "Meander G, Banfield Transect 2: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T2-22m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0028979,
						38.97799937,
						2925.66
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T2-22m",
					"name": "Meander G, Banfield Transect 2: 22m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T2-44m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.002778,
						38.97782265,
						2925.75
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T2-44m",
					"name": "Meander G, Banfield Transect 2: 44m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T2-66m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0026628,
						38.97765338,
						2925.59
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T2-66m",
					"name": "Meander G, Banfield Transect 2: 66m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T3-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.002696,
						38.97806743,
						2925.13
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T3-0m",
					"name": "Meander G, Banfield Transect 3: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T3-19m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0025907,
						38.97791787,
						2925.47
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T3-19m",
					"name": "Meander G, Banfield Transect 3: 19m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T3-38m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0024813,
						38.97777158,
						2925.52
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T3-38m",
					"name": "Meander G, Banfield Transect 3: 38m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T3-57m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0023841,
						38.97761482,
						2925.23
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T3-57m",
					"name": "Meander G, Banfield Transect 3: 57m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T4-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0024506,
						38.97799882,
						2925.38
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T4-0m",
					"name": "Meander G, Banfield Transect 4: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T4-18m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0023256,
						38.9778785,
						2925.92
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T4-18m",
					"name": "Meander G, Banfield Transect 4: 18m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T4-36m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0022256,
						38.97773274,
						2925.21
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T4-36m",
					"name": "Meander G, Banfield Transect 4: 36m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T4-54m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0021148,
						38.97759448,
						2925
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T4-54m",
					"name": "Meander G, Banfield Transect 4: 54m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T5-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0032328,
						38.97790012,
						2926.2
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T5-0m",
					"name": "Meander G, Banfield Transect 5: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T5-13m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0031251,
						38.97797787,
						2926.12
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T5-13m",
					"name": "Meander G, Banfield Transect 5: 13m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T5-26m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0030096,
						38.97806503,
						2925.85
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T5-26m",
					"name": "Meander G, Banfield Transect 5: 26m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T5-39m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0029099,
						38.97814385,
						2925.69
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T5-39m",
					"name": "Meander G, Banfield Transect 5: 39m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T6-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0030271,
						38.97777495,
						2925.96
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T6-0m",
					"name": "Meander G, Banfield Transect 6: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T6-15m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.002895,
						38.97786211,
						2925.68
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T6-15m",
					"name": "Meander G, Banfield Transect 6: 15m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T6-30m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0027664,
						38.97795089,
						2925.72
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T6-30m",
					"name": "Meander G, Banfield Transect 6: 30m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T6-42m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0026456,
						38.97804542,
						2925.63
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T6-42m",
					"name": "Meander G, Banfield Transect 6: 42m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T7-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0029218,
						38.97756833,
						2925.87
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T7-0m",
					"name": "Meander G, Banfield Transect 7: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T7-23m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00273,
						38.97770911,
						2925.56
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T7-23m",
					"name": "Meander G, Banfield Transect 7: 23m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T7-45m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0025408,
						38.97785589,
						2925.67
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T7-45m",
					"name": "Meander G, Banfield Transect 7: 45m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T7-69m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0023516,
						38.97798779,
						2925.15
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T7-69m",
					"name": "Meander G, Banfield Transect 7: 69m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T8-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0024421,
						38.97765067,
						2925.67
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T8-0m",
					"name": "Meander G, Banfield Transect 8: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T8-14m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.002317,
						38.97774113,
						2925.33
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T8-14m",
					"name": "Meander G, Banfield Transect 8: 14m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T8-28m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0022098,
						38.97783142,
						2925.43
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T8-28m",
					"name": "Meander G, Banfield Transect 8: 28m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMG-T8-42m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0020967,
						38.97791529,
						2925.34
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMG-T8-42m",
					"name": "Meander G, Banfield Transect 8: 42m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T1-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9514187,
						38.92240419,
						2760.15
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T1-0m",
					"name": "Meander L, Banfield Transect 1: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T1-21m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9512126,
						38.92247307,
						2760.3
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T1-21m",
					"name": "Meander L, Banfield Transect 1: 31m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T1-42m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9509952,
						38.92256114,
						2760.06
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T1-42m",
					"name": "Meander L, Banfield Transect 1: 32m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T1-63m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9507774,
						38.92265306,
						2759.99
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T1-63m",
					"name": "Meander L, Banfield Transect 1: 63m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T2-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9518147,
						38.92241153,
						2760.2
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T2-0m",
					"name": "Meander L, Banfield Transect 2: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T2-31m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9515103,
						38.92253739,
						2759.98
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T2-31m",
					"name": "Meander L, Banfield Transect 2: 31m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T2-62m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9511996,
						38.92267205,
						2760.04
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T2-62m",
					"name": "Meander L, Banfield Transect 2: 62m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T2-93m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9508934,
						38.92280431,
						2759.99
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T2-93m",
					"name": "Meander L, Banfield Transect 2: 93m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T3-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9521814,
						38.92255065,
						2760.18
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T3-0m",
					"name": "Meander L, Banfield Transect 3: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T3-33m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9518593,
						38.92269322,
						2760.08
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T3-33m",
					"name": "Meander L, Banfield Transect 3: 33m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T3-66m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9515113,
						38.92282932,
						2759.76
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T3-66m",
					"name": "Meander L, Banfield Transect 3: 66m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T3-99m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9511746,
						38.92297587,
						2759.75
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T3-99m",
					"name": "Meander L, Banfield Transect 3: 99m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T4-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9523002,
						38.9227381,
						2760.19
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T4-0m",
					"name": "Meander L, Banfield Transect 4: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T4-33m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9519776,
						38.9228743,
						2760.06
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T4-33m",
					"name": "Meander L, Banfield Transect 4: 33m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T4-66m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9516517,
						38.92302234,
						2759.87
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T4-66m",
					"name": "Meander L, Banfield Transect 4: 66m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T4-99m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9513188,
						38.9231868,
						2760.02
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T4-99m",
					"name": "Meander L, Banfield Transect 4: 99m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T5-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9514759,
						38.92342372,
						2760.19
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T5-0m",
					"name": "Meander L, Banfield Transect 5: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T5-30m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9513126,
						38.92318997,
						2759.99
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T5-30m",
					"name": "Meander L, Banfield Transect 5: 30m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T5-60m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9511378,
						38.9229531,
						2759.85
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T5-60m",
					"name": "Meander L, Banfield Transect 5: 60m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T5-90m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9509661,
						38.92271612,
						2760.02
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T5-90m",
					"name": "Meander L, Banfield Transect 5: 90m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T6-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9516224,
						38.92335709,
						2760.19
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T6-0m",
					"name": "Meander L, Banfield Transect 6: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T6-30m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9514495,
						38.92312587,
						2759.9
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T6-30m",
					"name": "Meander L, Banfield Transect 6: 30m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T6-60m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9512875,
						38.92288236,
						2759.84
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T6-60m",
					"name": "Meander L, Banfield Transect 6: 60m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T6-90m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9511332,
						38.92264565,
						2760.08
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T6-90m",
					"name": "Meander L, Banfield Transect 6: 90m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T7-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9519148,
						38.92324636,
						2760.19
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T7-0m",
					"name": "Meander L, Banfield Transect 7: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T7-30m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9517289,
						38.92299299,
						2759.71
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T7-30m",
					"name": "Meander L, Banfield Transect 7: 30m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T7-60m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9515819,
						38.92276159,
						2759.84
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T7-60m",
					"name": "Meander L, Banfield Transect 7: 60m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T7-90m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9514294,
						38.92253775,
						2760.15
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T7-90m",
					"name": "Meander L, Banfield Transect 7: 90m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T8-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9521913,
						38.92311363,
						2760.04
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T8-0m",
					"name": "Meander L, Banfield Transect 8: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T8-30m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9520442,
						38.92287056,
						2759.98
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T8-30m",
					"name": "Meander L, Banfield Transect 8: 30m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T8-60m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9518819,
						38.92264199,
						2759.96
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T8-60m",
					"name": "Meander L, Banfield Transect 8: 60m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERML-T8-90m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9517276,
						38.92239714,
						2760.39
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERML-T8-90m",
					"name": "Meander L, Banfield Transect 8: 90m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T1-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9077099,
						38.8898623,
						2723.69
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T1-0m",
					"name": "Meander Z, Banfield Transect 1: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T1-33m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9080679,
						38.88976922,
						2723.85
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T1-33m",
					"name": "Meander Z, Banfield Transect 1: 33m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T1-66m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9084319,
						38.8896764,
						2723.9
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T1-66m",
					"name": "Meander Z, Banfield Transect 1: 66m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T1-99m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.908791,
						38.88958068,
						2723.99
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T1-99m",
					"name": "Meander Z, Banfield Transect 1: 99m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T2-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9075512,
						38.88979864,
						2723.75
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T2-0m",
					"name": "Meander Z, Banfield Transect 2: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T2-33m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9079111,
						38.88969895,
						2723.82
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T2-33m",
					"name": "Meander Z, Banfield Transect 2: 33m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T2-66m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9082668,
						38.88960357,
						2723.7
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T2-66m",
					"name": "Meander Z, Banfield Transect 2: 66m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T2-99m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9086226,
						38.8895031,
						2723.84
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T2-99m",
					"name": "Meander Z, Banfield Transect 2: 99m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T3-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9073786,
						38.88969705,
						2723.64
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T3-0m",
					"name": "Meander Z, Banfield Transect 3: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T3-33m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9077378,
						38.88959798,
						2723.72
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T3-33m",
					"name": "Meander Z, Banfield Transect 3: 33m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T3-66m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9081093,
						38.88949776,
						2723.6
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T3-66m",
					"name": "Meander Z, Banfield Transect 3: 66m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T3-99m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9084615,
						38.88940349,
						2723.56
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T3-99m",
					"name": "Meander Z, Banfield Transect 3: 99m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T4-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9073083,
						38.88955405,
						2723.53
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T4-0m",
					"name": "Meander Z, Banfield Transect 4: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T4-23m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9075667,
						38.88950122,
						2723.59
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T4-23m",
					"name": "Meander Z, Banfield Transect 4: 23m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T4-46m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9078274,
						38.88945593,
						2723.56
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T4-46m",
					"name": "Meander Z, Banfield Transect 4: 46m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T4-69m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9080823,
						38.88939892,
						2723.61
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T4-69m",
					"name": "Meander Z, Banfield Transect 4: 69m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T5-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9085817,
						38.88967134,
						2723.91
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T5-0m",
					"name": "Meander Z, Banfield Transect 5: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T5-17m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9084602,
						38.88956016,
						2723.74
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T5-17m",
					"name": "Meander Z, Banfield Transect 5:17m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T5-34m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9083345,
						38.88944015,
						2723.5
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T5-34m",
					"name": "Meander Z, Banfield Transect 5: 34m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T5-51m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9082076,
						38.88932277,
						2723.6
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T5-51m",
					"name": "Meander Z, Banfield Transect 5: 51m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T6-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9083451,
						38.88976135,
						2723.93
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T6-0m",
					"name": "Meander Z, Banfield Transect 6: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T6-20m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9081957,
						38.88962425,
						2723.71
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T6-20m",
					"name": "Meander Z, Banfield Transect 6: 20m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T6-40m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9080441,
						38.88948842,
						2723.6
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T6-40m",
					"name": "Meander Z, Banfield Transect 6: 40m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T6-60m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9078949,
						38.8893505,
						2723.56
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T6-60m",
					"name": "Meander Z, Banfield Transect 6: 60m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T7-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9080462,
						38.88978301,
						2723.47
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T7-0m",
					"name": "Meander Z, Banfield Transect 7: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T7-18m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9079104,
						38.88964534,
						2723.69
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T7-18m",
					"name": "Meander Z, Banfield Transect 7: 18m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T7-36m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9077727,
						38.88953387,
						2723.64
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T7-36m",
					"name": "Meander Z, Banfield Transect 7: 36m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T7-54m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9076365,
						38.88941233,
						2723.63
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T7-54m",
					"name": "Meander Z, Banfield Transect 7: 54m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T8-0m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9078348,
						38.8898624,
						2723.55
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T8-0m",
					"name": "Meander Z, Banfield Transect 8: 0m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T8-20m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9076814,
						38.88972594,
						2723.81
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T8-20m",
					"name": "Meander Z, Banfield Transect 8: 20m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T8-40m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9075294,
						38.88958657,
						2723.78
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T8-40m",
					"name": "Meander Z, Banfield Transect 8: 40m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ERMZ-T8-60m",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9073811,
						38.88944698,
						2723.56
					]
				},
				"properties": {
					"contact": {
						"name": "Jill Banfield",
						"email": "jbanfield@berkeley.edu",
						"affiliation": "UC Berkeley"
					},
					"id": "ERMZ-T8-60m",
					"name": "Meander Z, Banfield Transect 8: 60m",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Metagenomics of the East River riparian zone",
					"description": "Genome-resolved metagenomics and geochemical analyses of a soil interval (~10-25 cm) from floodplains associated to three meandering reaches of the East River: upstream (ERMG), midstream (ERML), and downstream (ERMZ).",
					"variables_measured": "Genome-resolved metagenomics",
					"measurement_categories": [
						"biogeochemistry"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "001-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9861,
						38.957229,
						2908.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "001-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"001-ER18_1M8Yf1i2VjaoAa1y0ixG7_VyJBlErqEix"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "002-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9861,
						38.957288,
						2908.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "002-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"002-ER18_1VeP3Zc2Wfrkwyrq-eTvKtgIRYnM72emx"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "003-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98616,
						38.957368,
						2908.38
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "003-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"003-ER18_1vEnBHHxEXKC0T8tKdP8MxVdes8GF4TUo"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "004-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98611,
						38.957477,
						2908.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "004-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "005-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98623,
						38.957461,
						2907.91
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "005-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "006-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98483,
						38.957868,
						2915.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "006-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"006-ER18_1QRFC1u9728Wa4EIruhHuQK3p5ZPxb7yp"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "007-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98475,
						38.957824,
						2916.53
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "007-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "008-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98483,
						38.957823,
						2915.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "008-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "009-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9845,
						38.957937,
						2918.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "009-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "010-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95189,
						38.921891,
						2767.98
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "010-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"010-ER18_1j165RaP-jDI_mtkUJa47eFZAhD__O0lw"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "011-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95211,
						38.921874,
						2769.54
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "011-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "012-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9522,
						38.921828,
						2771.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "012-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "013-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95241,
						38.921662,
						2775.28
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "013-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "014-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95265,
						38.921775,
						2777.12
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "014-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "015-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95262,
						38.921582,
						2779.8
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "015-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "016-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95276,
						38.921584,
						2782.47
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "016-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "017-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95267,
						38.921531,
						2781.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "017-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "018-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95302,
						38.921552,
						2790.71
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "018-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"018-ER18_1X3ztxvSxKE7thV3t0etcsA1H7qo7fWaH"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "019-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95282,
						38.92152,
						2785.83
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "019-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "020-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06585,
						38.991241,
						3455.53
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "020-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "021-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98749,
						38.95691,
						2891.08
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "021-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "022-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98741,
						38.956973,
						2891.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "022-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "023-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98684,
						38.957091,
						2901.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "023-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "024-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98672,
						38.957034,
						2902.78
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "024-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"024-ER18_1Ih_4RpBXse6184d88br1k--hXTBAByl3"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "025-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98629,
						38.956726,
						2909.32
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "025-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "026-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98646,
						38.956511,
						2910.78
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "026-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "027-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98619,
						38.956822,
						2908.25
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "027-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "028-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98611,
						38.956765,
						2909.78
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "028-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "029-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98575,
						38.956699,
						2912.09
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "029-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "030-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98593,
						38.956705,
						2912.76
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "030-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"030-ER18_1wTdaxgQBmOlmxX3Lgd0azD1L83TuJU-F"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "031-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98615,
						38.95712,
						2908.71
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "031-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "032-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9856,
						38.95769,
						2910.92
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "032-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"032-ER18_1YlJDfsBjZbilfH_o1hLUBcy5XfimEQUV"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "033-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95356,
						38.92172,
						2799.83
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "033-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"033-ER18_14yWpkYYa86gdH6puwjSQZYGzrZPB_VAt"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "034-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95376,
						38.921865,
						2797.37
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "034-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "035-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95145,
						38.920659,
						2784.33
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "035-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "036-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95147,
						38.920605,
						2787.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "036-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "037-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95134,
						38.920454,
						2788.48
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "037-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "038-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95135,
						38.92037,
						2792.44
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "038-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "039-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95163,
						38.920603,
						2790.73
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "039-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "040-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95154,
						38.920632,
						2787.59
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "040-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "041-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95173,
						38.919704,
						2825.05
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "041-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "042-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95154,
						38.919887,
						2813.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "042-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "043-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98046,
						38.927272,
						3173.28
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "043-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "044-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95093,
						38.920993,
						2773.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "044-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"044-ER18_1ijgtyLZjTSiYNzg4JQ5IL7bpHySNZizY"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "045-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95081,
						38.920918,
						2774.17
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "045-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "046-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95097,
						38.920866,
						2775.39
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "046-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "047-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9508,
						38.920941,
						2773.81
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "047-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "048-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95091,
						38.920768,
						2777.55
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "048-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "050-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95087,
						38.920598,
						2781.39
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "050-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "051-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95117,
						38.920701,
						2779.61
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "051-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "052-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95086,
						38.920868,
						2775.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "052-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "053-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95135,
						38.920851,
						2777.59
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "053-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "054-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95118,
						38.920831,
						2776.69
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "054-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "055-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94999,
						38.923004,
						2759.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "055-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "056-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.94965,
						38.923082,
						2758.92
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "056-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "057-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95009,
						38.92248,
						2760.4
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "057-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "058-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95018,
						38.92201,
						2760.4
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "058-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "059-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95035,
						38.92202,
						2761.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "059-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "060-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95052,
						38.921769,
						2762.93
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "060-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "061-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95174,
						38.921533,
						2770.53
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "061-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "062-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95146,
						38.921254,
						2768.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "062-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "063-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95165,
						38.921183,
						2771.14
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "063-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "064-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.95114,
						38.920534,
						2784.11
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "064-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "065-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97917,
						38.927266,
						3155.5
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "065-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"065-ER18_1bElv-IgFqW3F_Xjez6lkBCSbrfkpSqb0"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "066-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97933,
						38.927241,
						3157.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "066-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"066-ER18_13AEse1W8xze_zsM7i-j-EyrFS3Yy1ZKt"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "067-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97924,
						38.927039,
						3154.69
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "067-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "068-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97936,
						38.927114,
						3156.95
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "068-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "069-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97941,
						38.927235,
						3159.28
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "069-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "070-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9795,
						38.927161,
						3160.01
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "070-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "071-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97352,
						38.926902,
						3062.34
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "071-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "072-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97351,
						38.926992,
						3060.73
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "072-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "073-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97366,
						38.926899,
						3066.38
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "073-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "074-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97319,
						38.927083,
						3050
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "074-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"074-ER18_1zTM7CQ9kFfEt4ep1JrcDF7LjnxbCR6sp"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "075-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97304,
						38.92705,
						3046.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "075-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "076-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97306,
						38.92709,
						3046.08
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "076-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"076-ER18_1nZaNckHtC_OSB_SGCW8YonqWvGCvKfLj"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "077-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97288,
						38.927026,
						3042.32
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "077-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "078-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97277,
						38.927014,
						3040.15
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "078-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"078-ER18_14J9_i2nH92fn2_RATy4D92pM9qSjHsnh"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "079-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97268,
						38.927011,
						3038.42
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "079-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "080-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9723,
						38.927247,
						3030.69
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "080-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"080-ER18_1brO_ZKWrE7Tuj2LR-sJX-shlCNsO4b4e"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "081-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97265,
						38.927043,
						3037.44
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "081-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "082-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97255,
						38.927301,
						3033.8
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "082-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"082-ER18_1L_IP3NhgvxyUgrZEs9S21e8WXCZrN_fH"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "083-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97262,
						38.927066,
						3037.05
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "083-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"083-ER18_1g7d4DwsQJ9050KDa9heHIOSxsLy1oazi"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "084-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97243,
						38.927547,
						3029.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "084-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "085-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97866,
						38.92772,
						3152.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "085-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "086-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97794,
						38.927832,
						3144.15
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "086-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "087-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97733,
						38.927743,
						3138.24
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "087-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "088-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97787,
						38.926729,
						3139.76
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "088-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "089-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97325,
						38.927379,
						3044.68
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "089-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "090-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97334,
						38.927458,
						3045.26
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "090-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "091-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97306,
						38.927967,
						3032.24
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "091-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "092-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97312,
						38.928202,
						3031.32
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "092-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "093-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9734,
						38.928463,
						3032.95
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "093-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "094-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97371,
						38.928128,
						3048.46
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "094-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"094-ER18_1beMXKMRWRT7P9U2Rm1yoxRCrMIXLLgWh"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "095-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97988,
						38.927578,
						3165.58
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "095-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "096-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98066,
						38.927245,
						3180.45
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "096-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "097-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98023,
						38.927808,
						3170.12
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "097-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "098-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98033,
						38.927711,
						3171.06
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "098-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "099-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97424,
						38.927998,
						3069.28
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "099-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"099-ER18_1T07GTLSlpGq_9RuM0t2Fq1fCC6aCmr_t"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "100-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9742,
						38.927451,
						3077.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "100-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "101-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97426,
						38.927544,
						3079.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "101-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "102-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97347,
						38.927547,
						3048.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "102-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "103-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97291,
						38.927336,
						3038.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "103-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "104-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00545,
						38.987082,
						2955.93
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "104-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "105-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00534,
						38.986841,
						2954.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "105-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "106-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00494,
						38.986848,
						2953.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "106-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "107-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00471,
						38.986554,
						2952.31
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "107-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "108-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0047,
						38.986361,
						2950.58
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "108-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "109-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00489,
						38.98602,
						2947.52
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "109-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "110-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00492,
						38.985411,
						2940.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "110-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "111-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00491,
						38.985465,
						2940.9
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "111-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "112-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00547,
						38.986253,
						2955.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "112-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"112-ER18_1lsSYF7zkArl5H5sXzYW4et_eX-dzvbt7"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "113-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00538,
						38.986426,
						2955
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "113-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"113-ER18_106_ubACGiTICmmiFgC2Wf5T15sivR1jB"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "114-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00404,
						38.987348,
						2966.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "114-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"114-ER18_14g0HTeBKLDAh5yobMIwYArjSpjzBOmAP"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "115-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00394,
						38.9874,
						2967.78
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "115-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "116-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00558,
						38.988511,
						2968.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "116-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "117-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00561,
						38.988447,
						2967.81
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "117-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "118-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00654,
						38.989248,
						2970.64
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "118-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "119-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00665,
						38.989288,
						2968.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "119-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "120-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00887,
						38.982461,
						2964.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "120-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "121-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00933,
						38.982342,
						2979.21
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "121-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "122-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01017,
						38.982675,
						2998.26
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "122-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "123-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01022,
						38.98303,
						2997.76
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "123-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "124-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01162,
						38.939115,
						3022.1
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "124-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "125-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01153,
						38.938981,
						3019.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "125-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "126-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0124,
						38.939028,
						3015.09
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "126-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "127-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01264,
						38.938929,
						3011.67
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "127-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "128-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0137,
						38.939784,
						3017.55
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "128-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "129-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01378,
						38.939684,
						3015.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "129-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "130-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01349,
						38.937274,
						2973.76
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "130-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "131-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01288,
						38.937385,
						2972.51
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "131-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "132-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0116,
						38.937293,
						2983.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "132-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "133-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01195,
						38.936757,
						2974.71
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "133-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "134-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01314,
						38.937038,
						2970.01
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "134-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "135-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01269,
						38.936883,
						2967.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "135-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "136-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01241,
						38.936861,
						2967.62
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "136-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "137-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01263,
						38.936339,
						2962.59
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "137-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "138-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01205,
						38.935903,
						2963.7
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "138-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "139-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01223,
						38.935431,
						2957.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "139-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "140-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01352,
						38.935454,
						2952.68
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "140-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "141-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01332,
						38.93567,
						2955.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "141-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "142-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01307,
						38.936354,
						2962.8
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "142-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "143-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01315,
						38.936866,
						2968.12
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "143-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "144-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00244,
						38.98771,
						2990.99
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "144-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "145-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00247,
						38.987809,
						2991.52
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "145-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "146-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00264,
						38.987631,
						2987.21
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "146-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"146-ER18_1-OwEPmp6sxnw4tLDvz_E5Oqj20MtWKLn"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "147-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00288,
						38.987527,
						2983.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "147-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "148-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00309,
						38.987276,
						2979.28
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "148-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"148-ER18_19_T4PMNaRIjxwJ-9NhaKRIJPlqxgdW_i"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "149-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00317,
						38.98745,
						2979.26
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "149-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "150-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00333,
						38.987137,
						2975.75
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "150-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"150-ER18_1fo-POOVIIBgz83gY9u88e__FJxCUYFjL"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "151-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00323,
						38.987337,
						2978.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "151-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"151-ER18_1oWMOGNE9z66SO_0HyPtJTaebqcnHT79T"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "152-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00417,
						38.986541,
						2959.64
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "152-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"152-ER18_1W-coBV8w461fGMSKmtyA-2AQsbgHZ3es"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "153-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00337,
						38.987249,
						2976.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "153-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "154-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00975,
						38.982841,
						2983.5
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "154-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"154-ER18_18BDXgP_vi0tQDNSobF7QVw4aAlr_4RX1"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "155-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00373,
						38.987252,
						2972.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "155-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "156-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00959,
						38.982871,
						2978.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "156-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "157-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00945,
						38.982859,
						2973.98
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "157-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"157-ER18_1UezNOcqO3IWrFGZSoCiinPq_oNDi5Mso"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "158-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00941,
						38.982892,
						2972.8
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "158-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"158-ER18_1hEzk4cJ6aY8ogyopTpmg_UeOU-ZtZmR-"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "160-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00926,
						38.982966,
						2968.05
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "160-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"160-ER18_11zK1GzxPFiZJ2fRqI8vfDAcjni1S30IE"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "161-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00921,
						38.982985,
						2966.64
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "161-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "162-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00913,
						38.982996,
						2964.33
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "162-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "163-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.00903,
						38.983061,
						2961.79
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "163-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"163-ER18_1npne8tINalaObkCOJuX9SbG52QV72uoN",
							"163-ER18_1ANhwOSThPRki0Y7xFF7nlAWtEMBmbDBH"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "164-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0124,
						38.93742,
						2976.83
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "164-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "165-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01236,
						38.937357,
						2975.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "165-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"165-ER18_1jeSdTKlwP5Lqk_9STR3S1ZYyKg6FhY9C"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "166-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01252,
						38.937319,
						2974.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "166-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"166-ER18_17bKLO4Z7YVAFpM7shK0P6gMtPfMsOJ_s"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "167-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01258,
						38.937245,
						2972.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "167-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"167-ER18_15_--JO2X8fU-O2RpGYC0qpAtMzQB8duj"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "168-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0126,
						38.93711,
						2970.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "168-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "169-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01178,
						38.937476,
						2983.74
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "169-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"169-ER18_1_OgYM3Ksvke6ps7FYUIYqbAb1qwahmto"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "170-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01173,
						38.937422,
						2983.29
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "170-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "171-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01181,
						38.93729,
						2980.32
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "171-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"171-ER18_1-WuTyOd1QbAJK_s29mkn2Vf3zXRBrtx3"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "172-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01193,
						38.937374,
						2979.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "172-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "173-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01204,
						38.93721,
						2974.45
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "173-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"173-ER18_12z-ylJQChhpR4V-dq45xQUpd6CzPRwqt"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "174-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01191,
						38.936374,
						2972.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "174-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"174-ER18_1vwgJf0uavLajHlhSswqAKU4nbc_jK6BE"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "176-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.01189,
						38.936167,
						2964.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "176-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"176-ER18_1zV0CgdojVRhnTWd6zLnzjDO2aHI1ICM0"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "177-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09725,
						38.856311,
						3013.26
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "177-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "178-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09792,
						38.857553,
						3015.61
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "178-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "179-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09817,
						38.857521,
						3020.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "179-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "180-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0117,
						38.934887,
						2948.24
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "180-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"180-ER18_1uQwVuezg2cpUhis5iSrhWA1Z-xe_ODEG"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "181-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09871,
						38.856687,
						3040.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "181-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "182-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0121,
						38.934645,
						2945.93
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "182-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "183-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09169,
						38.857012,
						3010.53
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "183-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"183-ER18_17uYodbIHB3uiLzcQBeY-yfjDJrkPnp1L"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "184-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09118,
						38.857117,
						3027.74
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "184-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "185-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09113,
						38.858074,
						3071.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "185-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "186-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09214,
						38.858369,
						3042.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "186-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "187-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09264,
						38.857959,
						3017.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "187-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "188-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09175,
						38.856819,
						3006.08
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "188-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "189-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0969,
						38.858264,
						3006.9
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "189-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "190-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09675,
						38.857983,
						3004.74
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "190-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "191-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09682,
						38.857126,
						3007.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "191-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "192-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0971,
						38.856731,
						3010.31
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "192-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "193-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09639,
						38.8573,
						3003.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "193-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "194-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09508,
						38.857841,
						2999.46
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "194-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "195-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09274,
						38.856785,
						2995.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "195-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "196-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09232,
						38.857021,
						3000.07
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "196-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "197-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09209,
						38.856692,
						2998.93
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "197-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "198-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09268,
						38.857258,
						3006.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "198-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "199-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09749,
						38.857451,
						3011.82
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "199-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "200-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09735,
						38.857508,
						3010.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "200-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"200-ER18_10DcO41RMUoBIuGjs9frEoplr3eOWIJU-"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "201-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09717,
						38.857565,
						3009.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "201-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"201-ER18_1tdmVgdBHU74V55Q-l7cHDdof2zxPyizu"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "202-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09716,
						38.857651,
						3009.48
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "202-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "204-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09238,
						38.856574,
						2995.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "204-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "205-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09219,
						38.856762,
						2999.01
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "205-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"205-ER18_1w7TqgHxCmIHCMgitBRdfYCnjdHZLHpNH"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "206-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09215,
						38.856826,
						2999.01
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "206-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "207-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0921,
						38.856899,
						3000.87
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "207-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"207-ER18_1jRKZsJ_y9RD-_WvOud5ZffiNy3_VrmSC"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "208-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09785,
						38.857287,
						3016.45
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "208-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"208-ER18_1VGRhSyp_HI71gCtLzZ5wJ8xEpYw4B3Jw"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "211-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09195,
						38.85705,
						3007.93
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "211-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "212-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0919,
						38.857119,
						3009.66
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "212-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"212-ER18_1nKQL7O0kZuVzLf2s-40NfwPfdvbqYHe-"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "213-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09185,
						38.857161,
						3014.48
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "213-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"213-ER18_1AgDi0crTOPD935yS5AsmP8VBCecI0ycz"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "214-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09175,
						38.857266,
						3020.15
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "214-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "215-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0917,
						38.85733,
						3024.08
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "215-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "216-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09163,
						38.857385,
						3025.81
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "216-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"216-ER18_193omF-S7wJaXGlHXc-Pn-HEfaO3NCpC5"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "217-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0917,
						38.857654,
						3036.37
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "217-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "218-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.09158,
						38.857769,
						3043.14
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "218-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "219-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03002,
						38.962247,
						3227.97
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "219-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "220-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03009,
						38.962189,
						3225.46
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "220-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "221-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03015,
						38.962125,
						3222.39
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "221-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "222-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0302,
						38.962079,
						3219.92
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "222-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"222-ER18_1LZQkGW08nb81XDBKajs3Cn9Ck8Nxqqa5"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "223-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03019,
						38.961962,
						3215.12
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "223-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"223-ER18_16vNt1do6cn1CkXeHNuiwql7gVVUKJhoF"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "224-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0303,
						38.961815,
						3206.89
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "224-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"224-ER18_1PWG_WKXNhXwNnFg9L29aW0Cdyvd0RuS7"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "225-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03037,
						38.961778,
						3204.89
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "225-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"225-ER18_1m7RnEjiBQ9UwTFg-kzFGa7-57fC8VWjA"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "226-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03044,
						38.961795,
						3204.77
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "226-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"226-ER18_1sBH0jKo2XU6MKPY_pphbVmyz2uhtXBMA"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "227-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0305,
						38.961713,
						3202.47
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "227-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "228-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03059,
						38.961576,
						3199.78
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "228-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"228-ER18_1k1ybMEpgXdTZF3Nob5eZSdoazA6kv0fu"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "229-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02964,
						38.961823,
						3216.4
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "229-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "232-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02962,
						38.961553,
						3202.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "232-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "233-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0296,
						38.961518,
						3200.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "233-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"233-ER18_1CQWeohxZLZiteioJY43f-Sa-vOKUl9kh"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "234-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02963,
						38.961494,
						3199.31
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "234-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "235-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02981,
						38.961441,
						3199.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "235-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "236-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02966,
						38.960791,
						3164.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "236-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"236-ER18_1depuYlP4j1cX7yqjkcqORYpF_-iqIkFS"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "237-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02968,
						38.960682,
						3161.38
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "237-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"237-ER18_1urdwji2Ok3pTd32quo8Kx8K6H_uAsjeq",
							"237-ER18_1QxcFX9CO_ucZODzkG4gplksMJudpmmkg"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "238-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02971,
						38.960587,
						3159.32
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "238-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "239-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02957,
						38.962414,
						3233.09
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "239-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"239-ER18_1hCSVs0gvqaeUVrX8Hxre4P9sHliPf4qh"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "240-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02979,
						38.962537,
						3236.89
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "240-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "241-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02954,
						38.961612,
						3204.04
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "241-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "242-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02935,
						38.96149,
						3195.4
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "242-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "243-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03009,
						38.961143,
						3191.89
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "243-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "244-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02954,
						38.960816,
						3161.49
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "244-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "245-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02959,
						38.960684,
						3158.5
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "245-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "246-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02957,
						38.960306,
						3147.9
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "246-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "247-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02961,
						38.960089,
						3145.97
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "247-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "248-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03197,
						38.960647,
						3163.1
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "248-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "249-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0286,
						38.961513,
						3187.64
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "249-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "250-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02901,
						38.961528,
						3195.95
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "250-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "251-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02864,
						38.961855,
						3204.46
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "251-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "252-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02884,
						38.962088,
						3215.69
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "252-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "253-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02937,
						38.962148,
						3229.51
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "253-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "254-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02937,
						38.962183,
						3230.45
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "254-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"254-ER18_1p4XoC_47NIpg3pvJTXj0OOFy9d_nNQ8V"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "255-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02935,
						38.963379,
						3246.54
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "255-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "256-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02836,
						38.963368,
						3248.29
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "256-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "257-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02731,
						38.963425,
						3246.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "257-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "258-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02993,
						38.962724,
						3234.95
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "258-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"258-ER18_1fxyBxofnQ1CqWiwB-RirtICzChxm5ynR"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "259-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0402,
						38.979452,
						3480.61
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "259-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "260-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04046,
						38.979704,
						3479.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "260-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "261-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04043,
						38.979984,
						3477.72
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "261-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "262-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04003,
						38.980581,
						3473.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "262-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "263-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04028,
						38.980202,
						3475.44
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "263-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "264-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04012,
						38.980142,
						3475.39
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "264-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "265-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03998,
						38.98046,
						3473.23
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "265-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "266-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04013,
						38.980912,
						3473.95
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "266-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "267-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04022,
						38.980898,
						3474.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "267-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "268-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04031,
						38.981207,
						3476.1
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "268-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "269-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03777,
						38.979832,
						3456.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "269-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "270-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0381,
						38.979831,
						3462.01
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "270-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"270-ER18_17iMPPsAkiqIn05H6DYZjtw0w-6vENmp9"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "271-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03836,
						38.979362,
						3464.21
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "271-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "272-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03822,
						38.979392,
						3462.01
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "272-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"272-ER18_1QtgikUX5qUFIJuGNDfAIRaFOiGubt2IA"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "273-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03773,
						38.97945,
						3455.91
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "273-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"273-ER18_1AXILP_ZSU7ijBcOvPkZlo373KX-AO6mp"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "274-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03774,
						38.979414,
						3456.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "274-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "275-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03769,
						38.979185,
						3456.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "275-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "276-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03751,
						38.979116,
						3455.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "276-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "277-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03745,
						38.978788,
						3457.26
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "277-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "278-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03767,
						38.9786,
						3459.62
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "278-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"278-ER18_1CgFWCj3l6d2-ptq7QOXmdGkX_obn3nkc"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "279-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03737,
						38.978592,
						3458.85
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "279-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "280-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03751,
						38.979251,
						3455.57
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "280-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "281-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03778,
						38.979314,
						3457.53
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "281-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "282-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03785,
						38.97966,
						3457.15
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "282-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "283-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0399,
						38.98052,
						3473.67
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "283-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "284-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03988,
						38.981278,
						3478.23
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "284-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"284-ER18_1VTFJGD_YFp1yyh2SZylr32_QwW5csKQb"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "285-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03847,
						38.980509,
						3461.97
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "285-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "286-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03893,
						38.980663,
						3474.22
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "286-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "287-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03893,
						38.980686,
						3474.06
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "287-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"287-ER18_1ieEPa4YmNIw25tb0QYFIQOs-d6lBRfwX"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "288-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03857,
						38.979679,
						3469.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "288-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "289-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03665,
						38.979871,
						3450.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "289-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "290-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03585,
						38.978912,
						3458.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "290-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "291-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03632,
						38.980041,
						3443.7
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "291-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "292-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03926,
						38.978067,
						3492.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "292-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "293-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03573,
						38.978463,
						3456.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "293-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "294-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03575,
						38.978888,
						3456.92
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "294-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "295-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03639,
						38.979906,
						3445.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "295-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "296-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0396,
						38.978468,
						3492.55
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "296-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "297-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.03963,
						38.977129,
						3490.8
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "297-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "298-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04031,
						38.97827,
						3497.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "298-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "299-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0274,
						38.907007,
						2733.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "299-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "300-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02809,
						38.907654,
						2730.62
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "300-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "301-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02865,
						38.908321,
						2731.5
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "301-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "302-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02874,
						38.90806,
						2733.19
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "302-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "303-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02892,
						38.908083,
						2737.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "303-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "304-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0299,
						38.908741,
						2745.76
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "304-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "305-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02978,
						38.908667,
						2746.46
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "305-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "306-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02926,
						38.90706,
						2755.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "306-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "307-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02886,
						38.906297,
						2769.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "307-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "308-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02896,
						38.90657,
						2760.17
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "308-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "309-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02818,
						38.90939,
						2726.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "309-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "310-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02831,
						38.909482,
						2726.17
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "310-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "311-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02835,
						38.909473,
						2726.34
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "311-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "312-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02866,
						38.909423,
						2726.83
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "312-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "313-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02862,
						38.90973,
						2726.87
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "313-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "314-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0286,
						38.909654,
						2726.73
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "314-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "315-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02843,
						38.909576,
						2726.51
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "315-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "316-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02849,
						38.909457,
						2726.5
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "316-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "317-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02858,
						38.909415,
						2726.66
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "317-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"317-ER18_1Rn1MZwEQauRXv4E0tRXmw5Klbdh1v0Aq"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "318-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02831,
						38.909569,
						2726.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "318-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "319-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06696,
						38.952952,
						2883.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "319-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "320-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06696,
						38.952891,
						2883.41
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "320-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "321-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06674,
						38.95335,
						2890.66
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "321-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "322-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06691,
						38.953516,
						2893.61
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "322-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "323-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06711,
						38.953568,
						2896.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "323-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "324-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98549,
						38.957479,
						2916.09
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "324-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "325-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.9861,
						38.957997,
						2908.71
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "325-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "326-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98464,
						38.95805,
						2916.91
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "326-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "327-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.98438,
						38.958101,
						2917.97
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "327-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "328-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06741,
						38.953243,
						2894.86
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "328-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "329-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06733,
						38.953296,
						2894.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "329-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "330-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06791,
						38.953702,
						2906.25
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "330-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "331-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06753,
						38.953876,
						2906.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "331-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "332-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06807,
						38.953579,
						2905.67
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "332-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "333-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06487,
						38.975674,
						2998.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "333-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "334-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06722,
						38.952801,
						2883.82
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "334-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "335-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06711,
						38.952763,
						2881.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "335-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "336-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06705,
						38.9528,
						2882.72
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "336-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "337-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06678,
						38.952661,
						2877.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "337-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"337-ER18_1lyDUiGxnLJyiwN2rZ5-z4l-ntHZENa0X"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "338-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06667,
						38.952748,
						2877.59
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "338-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "340-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06636,
						38.952785,
						2877.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "340-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "341-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06637,
						38.952902,
						2878.61
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "341-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"341-ER18_1O4MSttpj5RtBt6b9lU26o4QgFX5CAsaA"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "342-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06627,
						38.953093,
						2880.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "342-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "343-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06613,
						38.953073,
						2879.83
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "343-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"343-ER18_1J_a5z9ckwcvGbHoJIwY3aBB3CxhD84II"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "344-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06632,
						38.952732,
						2876.14
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "344-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "345-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06618,
						38.952445,
						2872.37
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "345-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "346-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0667,
						38.952428,
						2875.62
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "346-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "347-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06704,
						38.952701,
						2881.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "347-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "348-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06774,
						38.953783,
						2906.58
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "348-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "349-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06753,
						38.953783,
						2903.89
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "349-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "351-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06403,
						38.989335,
						3437.11
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "351-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "352-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06428,
						38.98921,
						3440.71
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "352-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "353-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06434,
						38.989272,
						3438.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "353-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "354-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06911,
						38.953949,
						2924.38
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "354-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "355-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06925,
						38.953869,
						2921.28
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "355-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "356-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06977,
						38.953725,
						2916.91
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "356-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "357-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06974,
						38.953478,
						2908.47
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "357-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "358-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06927,
						38.953445,
						2909.54
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "358-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "359-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06983,
						38.95326,
						2902
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "359-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "360-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06871,
						38.953212,
						2902.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "360-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "361-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06758,
						38.953502,
						2898.55
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "361-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "362-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0677,
						38.953618,
						2904.24
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "362-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "363-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06715,
						38.953153,
						2891.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "363-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "364-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06541,
						38.991428,
						3453.73
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "364-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "365-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06522,
						38.991519,
						3451.4
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "365-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "366-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0649,
						38.991636,
						3443.54
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "366-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "367-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06479,
						38.991665,
						3440.87
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "367-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "368-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06468,
						38.991559,
						3434.98
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "368-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"368-ER18_1cGl5DXpWPTkXLMNKsrOU-etD_l9eYWZA"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "369-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06465,
						38.991361,
						3429.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "369-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"369-ER18_1J6pe2wjx-b3k5ujo_oMpOxSkxqoM7ODP"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "370-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06455,
						38.991227,
						3424.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "370-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "371-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06448,
						38.991121,
						3421.34
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "371-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "372-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06427,
						38.991034,
						3415.86
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "372-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "373-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06413,
						38.990856,
						3412.45
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "373-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "374-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06267,
						38.990756,
						3389.68
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "374-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "375-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06228,
						38.990709,
						3387.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "375-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "376-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06166,
						38.990558,
						3386.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "376-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "377-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06088,
						38.991022,
						3378.62
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "377-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "378-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06046,
						38.990831,
						3383.54
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "378-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "379-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06005,
						38.990865,
						3385
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "379-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "381-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05987,
						38.990445,
						3389.78
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "381-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "382-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05975,
						38.990447,
						3390.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "382-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "383-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05959,
						38.990356,
						3392.88
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "383-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "384-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06461,
						38.992046,
						3447.44
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "384-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "385-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06442,
						38.992055,
						3441.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "385-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "386-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06408,
						38.992416,
						3441.85
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "386-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "387-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0636,
						38.992294,
						3413.94
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "387-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "388-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06302,
						38.991552,
						3389.74
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "388-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "389-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06242,
						38.991518,
						3382.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "389-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "390-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06234,
						38.990631,
						3389.59
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "390-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "391-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06139,
						38.990639,
						3385.49
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "391-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "392-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05997,
						38.990704,
						3387
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "392-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "393-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05914,
						38.990715,
						3391.9
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "393-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": [
							"393-ER18_1Z8pd8qK3S4QB2Kjdu9eVihIIw4nzpTL4"
						]
					}
				}
			},
			{
				"type": "Feature",
				"id": "394-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0644,
						38.989216,
						3440.8
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "394-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "395-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06424,
						38.988792,
						3442.72
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "395-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "396-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06388,
						38.9893,
						3435.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "396-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "397-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06344,
						38.989602,
						3423.56
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "397-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "398-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06312,
						38.98909,
						3430.72
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "398-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "399-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06325,
						38.989172,
						3431.29
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "399-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "400-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06382,
						38.97594,
						3041.92
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "400-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "401-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06378,
						38.975831,
						3051
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "401-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "402-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06352,
						38.975857,
						3056.3
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "402-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "403-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06331,
						38.975994,
						3064.45
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "403-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "404-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06568,
						38.975692,
						2977.38
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "404-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "405-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06552,
						38.97556,
						2980.43
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "405-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "406-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06564,
						38.975531,
						2978.53
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "406-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "407-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06558,
						38.975221,
						2976.52
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "407-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "408-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06562,
						38.975071,
						2977.02
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "408-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "409-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06551,
						38.974974,
						2979.31
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "409-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "410-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06558,
						38.974878,
						2977.69
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "410-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "411-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06562,
						38.974729,
						2978.05
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "411-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "412-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0652,
						38.97452,
						2985.73
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "412-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "413-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0653,
						38.974396,
						2982.31
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "413-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "414-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06555,
						38.975789,
						2980.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "414-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "415-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06535,
						38.975698,
						2984.24
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "415-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "416-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.065,
						38.975754,
						2993.16
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "416-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "417-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0647,
						38.97593,
						3001.66
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "417-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "418-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06644,
						38.97694,
						2977.67
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "418-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "419-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06641,
						38.977012,
						2978.75
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "419-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "420-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06668,
						38.976832,
						2980.35
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "420-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "421-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06676,
						38.976971,
						2984.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "421-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "422-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06559,
						38.97591,
						2978.58
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "422-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "423-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06535,
						38.975828,
						2983.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "423-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "424-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06658,
						38.974811,
						2964.96
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "424-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "425-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06672,
						38.974758,
						2964.12
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "425-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "426-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06677,
						38.975046,
						2964.2
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "426-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "427-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06602,
						38.97565,
						2972.34
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "427-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "428-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06549,
						38.975754,
						2980.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "428-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "429-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06511,
						38.975779,
						2987.5
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "429-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "430-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06518,
						38.975525,
						2989.65
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "430-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "431-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06751,
						38.975574,
						2981.98
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "431-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "432-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06731,
						38.976189,
						2984.54
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "432-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "433-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06686,
						38.976758,
						2982.63
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "433-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "434-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06353,
						38.976855,
						3054.84
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "434-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "435-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06337,
						38.976918,
						3059.27
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "435-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "436-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0641,
						38.976571,
						3023.66
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "436-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "437-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06487,
						38.976806,
						2995.51
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "437-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "438-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06498,
						38.976789,
						2993.02
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "438-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "439-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06691,
						38.975495,
						2966.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "439-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "440-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06729,
						38.975447,
						2971.7
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "440-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "441-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0672,
						38.975526,
						2971.76
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "441-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "442-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06711,
						38.975468,
						2969.97
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "442-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "443-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.06702,
						38.97547,
						2967.95
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "443-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "447-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05535,
						38.895138,
						3265.29
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "447-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "448-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0553,
						38.894959,
						3266.14
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "448-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "449-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05534,
						38.894922,
						3266.14
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "449-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "450-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05517,
						38.894319,
						3271.1
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "450-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "451-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05524,
						38.894302,
						3271.3
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "451-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "452-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05528,
						38.894333,
						3271.7
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "452-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "453-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05509,
						38.894282,
						3270.97
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "453-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "458-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04709,
						38.861323,
						2866
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "458-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "459-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04691,
						38.861282,
						2865.42
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "459-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "460-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04667,
						38.861097,
						2865.48
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "460-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "461-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05529,
						38.894031,
						3276.55
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "461-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "462-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.05315,
						38.894447,
						3280.86
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "462-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "463-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04699,
						38.860938,
						2866.13
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "463-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "464-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.047,
						38.86105,
						2866
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "464-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "465-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04009,
						38.862329,
						2855.44
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "465-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "466-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04016,
						38.862215,
						2854.48
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "466-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "467-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04039,
						38.862218,
						2856.94
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "467-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "468-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04049,
						38.862282,
						2858.77
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "468-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Meadow Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "469-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02304,
						38.867383,
						2807.18
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "469-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "470-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02271,
						38.867429,
						2807.03
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "470-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "471-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.0222,
						38.867677,
						2806.1
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "471-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "472-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.02183,
						38.867855,
						2805.36
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "472-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Shrub Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "474-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04218,
						38.868239,
						3016.57
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "474-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "475-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04175,
						38.867972,
						3010.1
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "475-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "476-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04173,
						38.867825,
						3004.68
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "476-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "477-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04137,
						38.866244,
						2961.75
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "477-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "478-ER18",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-107.04082,
						38.866244,
						2955.75
					]
				},
				"properties": {
					"contact": {
						"name": "Dana Chadwick",
						"email": "kdc@stanford.edu",
						"affiliation": "Stanford University"
					},
					"id": "478-ER18",
					"name": "2018 NEON Hyperspectral Ground Campaign",
					"category": "SFA One-off Sampling",
					"instrumentation": "",
					"research_theme": "Mapping vegetation properties to infer subsurface characteristics",
					"description": "Temporary 2018 Tree Sampling Site",
					"variables_measured": "Soil Moisture; Vegetation Height; Leaf Traits; Soil Properties; Species Cover; Microbial Communities",
					"measurement_categories": [
						"hydrogeology",
						"biogeochemistry",
						"vegetation"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SAI1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.987746,
						38.956192,
						2887.44
					]
				},
				"properties": {
					"contact": {
						"name": "Daniel Feldman",
						"email": "drfeldman@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-SAI1",
					"name": "SAIL Main Site Container",
					"category": "SFA Collaborator",
					"instrumentation": "Radar Wind Profiler (RWP), Ka-band ARM Zenith Radar (KAZR), Doppler Lidar (DL), Micropulse Lidar (MPL), Ceilometer (CEIL), High-spectral-resolution Lidar (HSRL), Marine-Atmosphere Emitted Radiance Interferometer (MAERI), Total Sky Imager (TSI), Microwave radiometer (MWR), Multi-filter Rotating Shadowband Radiometer (MFRSR)",
					"research_theme": "Surface atmosphere interactions",
					"description": "Integrated field observations to study surface atmosphere interactions and their impacts on mountainous water cycles. SAIL container measurements (remote sensing).",
					"variables_measured": "Atmospheric turbulence, wind, aerosol and cloud backscatter profiles, precipitation, downwelling infrared spectral radiation, cloud fraction, precipitable water vapor, liquid water path, narrowband shortwave radiation, aerosol optical depth",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SAI2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.973117,
						38.941398,
						2856.5
					]
				},
				"properties": {
					"contact": {
						"name": "Daniel Feldman",
						"email": "drfeldman@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-SAI2",
					"name": "SAIL Main Site Field",
					"category": "SFA Collaborator",
					"instrumentation": "Eddy correlation flux measurement system (ECOR), Surface energy balance system (SEBS)",
					"research_theme": "Surface atmosphere interactions",
					"description": "Integrated field observations to study surface atmosphere interactions and their impacts on mountainous water cycles. SAIL field measurements.",
					"variables_measured": "Surface turbulent fluxes, upwelling and downwelling radiation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-SAI3",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.943266,
						38.898356,
						3137.72
					]
				},
				"properties": {
					"contact": {
						"name": "Daniel Feldman",
						"email": "drfeldman@lbl.gov",
						"affiliation": "Lawrence Berkeley National Laboratory"
					},
					"id": "ER-SAI3",
					"name": "SAIL Supplementary Site",
					"category": "SFA Collaborator",
					"instrumentation": "Atmosphere Observing System (AOS), X-band radar",
					"research_theme": "Atmosheric aerosol and precipitation",
					"description": "ARM aerosol observing system for aerosol observations and CSU X-band Radar for precipitation observations. SAIL AOS and X-band radar measurements.",
					"variables_measured": "Aerosol chemical composition, cloud condensation nuclei, CO/H2O/N2O concentration, aerosol concentration, aerosol particle size distribution, ozone concentration, black carbon concentration, aerosol absorption and extinction, precipitation",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-RJY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.853011,
						38.716829,
						2494.96
					]
				},
				"properties": {
					"contact": {
						"name": "Gijs de Boer",
						"email": "gijs.deboer@colorado.edu",
						"affiliation": "University of Colorado / NOAA PSL"
					},
					"id": "ER-RJY1",
					"name": "SPLASH Roaring Judy",
					"category": "SFA Collaborator",
					"instrumentation": "Instrumentation information to be added soon",
					"research_theme": "Atmospheric science and surface energy exchange",
					"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
					"variables_measured": "Variable information to be added soon",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-BCK1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.921055,
						38.8589,
						2719.64
					]
				},
				"properties": {
					"contact": {
						"name": "Gijs de Boer",
						"email": "gijs.deboer@colorado.edu",
						"affiliation": "University of Colorado / NOAA PSL"
					},
					"id": "ER-BCK1",
					"name": "SPLASH Brush Creek",
					"category": "SFA Collaborator",
					"instrumentation": "Instrumentation information to be added soon",
					"research_theme": "Atmospheric science and surface energy exchange",
					"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
					"variables_measured": "Variable information to be added soon",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-KPS2",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.97021,
						38.939909,
						2848.21
					]
				},
				"properties": {
					"contact": {
						"name": "Gijs de Boer",
						"email": "gijs.deboer@colorado.edu",
						"affiliation": "University of Colorado / NOAA PSL"
					},
					"id": "ER-KPS2",
					"name": "SPLASH Kettle Ponds Annex",
					"category": "SFA Collaborator",
					"instrumentation": "Instrumentation information to be added soon",
					"research_theme": "Atmospheric science and surface energy exchange",
					"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
					"variables_measured": "Variable information to be added soon",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-KPS1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.973021,
						38.941797,
						2858.48
					]
				},
				"properties": {
					"contact": {
						"name": "Gijs de Boer",
						"email": "gijs.deboer@colorado.edu",
						"affiliation": "University of Colorado / NOAA PSL"
					},
					"id": "ER-KPS1",
					"name": "SPLASH Kettle Ponds",
					"category": "SFA Collaborator",
					"instrumentation": "Instrumentation information to be added soon",
					"research_theme": "Atmospheric science and surface energy exchange",
					"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
					"variables_measured": "Variable information to be added soon",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			},
			{
				"type": "Feature",
				"id": "ER-APY1",
				"geometry": {
					"type": "Point",
					"coordinates": [
						-106.996983,
						38.972585,
						2925.07
					]
				},
				"properties": {
					"contact": {
						"name": "Gijs de Boer",
						"email": "gijs.deboer@colorado.edu",
						"affiliation": "University of Colorado / NOAA PSL"
					},
					"id": "ER-APY1",
					"name": "SPLASH Avery Picnic",
					"category": "SFA Collaborator",
					"instrumentation": "Instrumentation information to be added soon",
					"research_theme": "Atmospheric science and surface energy exchange",
					"description": "Observing site for the Study of Precipitation, the Lower Atmosphere, and Surface for Hydrometeorology (SPLASH). This entry provides information on the location of the SPLASH observing sites. Individual sensor information is available via the East River Sensor Listing correlated with the Location_ID",
					"variables_measured": "Variable information to be added soon",
					"measurement_categories": [
						"climate"
					],
					"links": {
						"images": []
					}
				}
			}
		]
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.7.1, a JS library for interactive maps. http://leafletjs.com
	 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.L = {})));
	}(this, (function (exports) { 'use strict';
	
	  var version = "1.7.1";
	
	  /*
	   * @namespace Util
	   *
	   * Various utility functions, used by Leaflet internally.
	   */
	
	  // @function extend(dest: Object, src?: Object): Object
	  // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	  function extend(dest) {
	  	var i, j, len, src;
	
	  	for (j = 1, len = arguments.length; j < len; j++) {
	  		src = arguments[j];
	  		for (i in src) {
	  			dest[i] = src[i];
	  		}
	  	}
	  	return dest;
	  }
	
	  // @function create(proto: Object, properties?: Object): Object
	  // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	  var create = Object.create || (function () {
	  	function F() {}
	  	return function (proto) {
	  		F.prototype = proto;
	  		return new F();
	  	};
	  })();
	
	  // @function bind(fn: Function, …): Function
	  // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	  // Has a `L.bind()` shortcut.
	  function bind(fn, obj) {
	  	var slice = Array.prototype.slice;
	
	  	if (fn.bind) {
	  		return fn.bind.apply(fn, slice.call(arguments, 1));
	  	}
	
	  	var args = slice.call(arguments, 2);
	
	  	return function () {
	  		return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
	  	};
	  }
	
	  // @property lastId: Number
	  // Last unique ID used by [`stamp()`](#util-stamp)
	  var lastId = 0;
	
	  // @function stamp(obj: Object): Number
	  // Returns the unique ID of an object, assigning it one if it doesn't have it.
	  function stamp(obj) {
	  	/*eslint-disable */
	  	obj._leaflet_id = obj._leaflet_id || ++lastId;
	  	return obj._leaflet_id;
	  	/* eslint-enable */
	  }
	
	  // @function throttle(fn: Function, time: Number, context: Object): Function
	  // Returns a function which executes function `fn` with the given scope `context`
	  // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	  // `fn` will be called no more than one time per given amount of `time`. The arguments
	  // received by the bound function will be any arguments passed when binding the
	  // function, followed by any arguments passed when invoking the bound function.
	  // Has an `L.throttle` shortcut.
	  function throttle(fn, time, context) {
	  	var lock, args, wrapperFn, later;
	
	  	later = function () {
	  		// reset lock and call if queued
	  		lock = false;
	  		if (args) {
	  			wrapperFn.apply(context, args);
	  			args = false;
	  		}
	  	};
	
	  	wrapperFn = function () {
	  		if (lock) {
	  			// called too soon, queue to call later
	  			args = arguments;
	
	  		} else {
	  			// call and lock until later
	  			fn.apply(context, arguments);
	  			setTimeout(later, time);
	  			lock = true;
	  		}
	  	};
	
	  	return wrapperFn;
	  }
	
	  // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	  // Returns the number `num` modulo `range` in such a way so it lies within
	  // `range[0]` and `range[1]`. The returned value will be always smaller than
	  // `range[1]` unless `includeMax` is set to `true`.
	  function wrapNum(x, range, includeMax) {
	  	var max = range[1],
	  	    min = range[0],
	  	    d = max - min;
	  	return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	  }
	
	  // @function falseFn(): Function
	  // Returns a function which always returns `false`.
	  function falseFn() { return false; }
	
	  // @function formatNum(num: Number, digits?: Number): Number
	  // Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
	  function formatNum(num, digits) {
	  	var pow = Math.pow(10, (digits === undefined ? 6 : digits));
	  	return Math.round(num * pow) / pow;
	  }
	
	  // @function trim(str: String): String
	  // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	  function trim(str) {
	  	return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	  }
	
	  // @function splitWords(str: String): String[]
	  // Trims and splits the string on whitespace and returns the array of parts.
	  function splitWords(str) {
	  	return trim(str).split(/\s+/);
	  }
	
	  // @function setOptions(obj: Object, options: Object): Object
	  // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	  function setOptions(obj, options) {
	  	if (!Object.prototype.hasOwnProperty.call(obj, 'options')) {
	  		obj.options = obj.options ? create(obj.options) : {};
	  	}
	  	for (var i in options) {
	  		obj.options[i] = options[i];
	  	}
	  	return obj.options;
	  }
	
	  // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	  // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	  // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	  // be appended at the end. If `uppercase` is `true`, the parameter names will
	  // be uppercased (e.g. `'?A=foo&B=bar'`)
	  function getParamString(obj, existingUrl, uppercase) {
	  	var params = [];
	  	for (var i in obj) {
	  		params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	  	}
	  	return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	  }
	
	  var templateRe = /\{ *([\w_-]+) *\}/g;
	
	  // @function template(str: String, data: Object): String
	  // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	  // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	  // `('Hello foo, bar')`. You can also specify functions instead of strings for
	  // data values — they will be evaluated passing `data` as an argument.
	  function template(str, data) {
	  	return str.replace(templateRe, function (str, key) {
	  		var value = data[key];
	
	  		if (value === undefined) {
	  			throw new Error('No value provided for variable ' + str);
	
	  		} else if (typeof value === 'function') {
	  			value = value(data);
	  		}
	  		return value;
	  	});
	  }
	
	  // @function isArray(obj): Boolean
	  // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	  var isArray = Array.isArray || function (obj) {
	  	return (Object.prototype.toString.call(obj) === '[object Array]');
	  };
	
	  // @function indexOf(array: Array, el: Object): Number
	  // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	  function indexOf(array, el) {
	  	for (var i = 0; i < array.length; i++) {
	  		if (array[i] === el) { return i; }
	  	}
	  	return -1;
	  }
	
	  // @property emptyImageUrl: String
	  // Data URI string containing a base64-encoded empty GIF image.
	  // Used as a hack to free memory from unused images on WebKit-powered
	  // mobile devices (by setting image `src` to this string).
	  var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	  // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	  function getPrefixed(name) {
	  	return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	  }
	
	  var lastTime = 0;
	
	  // fallback for IE 7-8
	  function timeoutDefer(fn) {
	  	var time = +new Date(),
	  	    timeToCall = Math.max(0, 16 - (time - lastTime));
	
	  	lastTime = time + timeToCall;
	  	return window.setTimeout(fn, timeToCall);
	  }
	
	  var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	  var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
	  		getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	  // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	  // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	  // `context` if given. When `immediate` is set, `fn` is called immediately if
	  // the browser doesn't have native support for
	  // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	  // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	  function requestAnimFrame(fn, context, immediate) {
	  	if (immediate && requestFn === timeoutDefer) {
	  		fn.call(context);
	  	} else {
	  		return requestFn.call(window, bind(fn, context));
	  	}
	  }
	
	  // @function cancelAnimFrame(id: Number): undefined
	  // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	  function cancelAnimFrame(id) {
	  	if (id) {
	  		cancelFn.call(window, id);
	  	}
	  }
	
	  var Util = ({
	    extend: extend,
	    create: create,
	    bind: bind,
	    lastId: lastId,
	    stamp: stamp,
	    throttle: throttle,
	    wrapNum: wrapNum,
	    falseFn: falseFn,
	    formatNum: formatNum,
	    trim: trim,
	    splitWords: splitWords,
	    setOptions: setOptions,
	    getParamString: getParamString,
	    template: template,
	    isArray: isArray,
	    indexOf: indexOf,
	    emptyImageUrl: emptyImageUrl,
	    requestFn: requestFn,
	    cancelFn: cancelFn,
	    requestAnimFrame: requestAnimFrame,
	    cancelAnimFrame: cancelAnimFrame
	  });
	
	  // @class Class
	  // @aka L.Class
	
	  // @section
	  // @uninheritable
	
	  // Thanks to John Resig and Dean Edwards for inspiration!
	
	  function Class() {}
	
	  Class.extend = function (props) {
	
	  	// @function extend(props: Object): Function
	  	// [Extends the current class](#class-inheritance) given the properties to be included.
	  	// Returns a Javascript function that is a class constructor (to be called with `new`).
	  	var NewClass = function () {
	
	  		// call the constructor
	  		if (this.initialize) {
	  			this.initialize.apply(this, arguments);
	  		}
	
	  		// call all constructor hooks
	  		this.callInitHooks();
	  	};
	
	  	var parentProto = NewClass.__super__ = this.prototype;
	
	  	var proto = create(parentProto);
	  	proto.constructor = NewClass;
	
	  	NewClass.prototype = proto;
	
	  	// inherit parent's statics
	  	for (var i in this) {
	  		if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') {
	  			NewClass[i] = this[i];
	  		}
	  	}
	
	  	// mix static properties into the class
	  	if (props.statics) {
	  		extend(NewClass, props.statics);
	  		delete props.statics;
	  	}
	
	  	// mix includes into the prototype
	  	if (props.includes) {
	  		checkDeprecatedMixinEvents(props.includes);
	  		extend.apply(null, [proto].concat(props.includes));
	  		delete props.includes;
	  	}
	
	  	// merge options
	  	if (proto.options) {
	  		props.options = extend(create(proto.options), props.options);
	  	}
	
	  	// mix given properties into the prototype
	  	extend(proto, props);
	
	  	proto._initHooks = [];
	
	  	// add method for calling all hooks
	  	proto.callInitHooks = function () {
	
	  		if (this._initHooksCalled) { return; }
	
	  		if (parentProto.callInitHooks) {
	  			parentProto.callInitHooks.call(this);
	  		}
	
	  		this._initHooksCalled = true;
	
	  		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
	  			proto._initHooks[i].call(this);
	  		}
	  	};
	
	  	return NewClass;
	  };
	
	
	  // @function include(properties: Object): this
	  // [Includes a mixin](#class-includes) into the current class.
	  Class.include = function (props) {
	  	extend(this.prototype, props);
	  	return this;
	  };
	
	  // @function mergeOptions(options: Object): this
	  // [Merges `options`](#class-options) into the defaults of the class.
	  Class.mergeOptions = function (options) {
	  	extend(this.prototype.options, options);
	  	return this;
	  };
	
	  // @function addInitHook(fn: Function): this
	  // Adds a [constructor hook](#class-constructor-hooks) to the class.
	  Class.addInitHook = function (fn) { // (Function) || (String, args...)
	  	var args = Array.prototype.slice.call(arguments, 1);
	
	  	var init = typeof fn === 'function' ? fn : function () {
	  		this[fn].apply(this, args);
	  	};
	
	  	this.prototype._initHooks = this.prototype._initHooks || [];
	  	this.prototype._initHooks.push(init);
	  	return this;
	  };
	
	  function checkDeprecatedMixinEvents(includes) {
	  	if (typeof L === 'undefined' || !L || !L.Mixin) { return; }
	
	  	includes = isArray(includes) ? includes : [includes];
	
	  	for (var i = 0; i < includes.length; i++) {
	  		if (includes[i] === L.Mixin.Events) {
	  			console.warn('Deprecated include of L.Mixin.Events: ' +
	  				'this property will be removed in future releases, ' +
	  				'please inherit from L.Evented instead.', new Error().stack);
	  		}
	  	}
	  }
	
	  /*
	   * @class Evented
	   * @aka L.Evented
	   * @inherits Class
	   *
	   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	   *
	   * @example
	   *
	   * ```js
	   * map.on('click', function(e) {
	   * 	alert(e.latlng);
	   * } );
	   * ```
	   *
	   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	   *
	   * ```js
	   * function onClick(e) { ... }
	   *
	   * map.on('click', onClick);
	   * map.off('click', onClick);
	   * ```
	   */
	
	  var Events = {
	  	/* @method on(type: String, fn: Function, context?: Object): this
	  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	  	 *
	  	 * @alternative
	  	 * @method on(eventMap: Object): this
	  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  	 */
	  	on: function (types, fn, context) {
	
	  		// types can be a map of types/handlers
	  		if (typeof types === 'object') {
	  			for (var type in types) {
	  				// we don't process space-separated events here for performance;
	  				// it's a hot path since Layer uses the on(obj) syntax
	  				this._on(type, types[type], fn);
	  			}
	
	  		} else {
	  			// types can be a string of space-separated words
	  			types = splitWords(types);
	
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				this._on(types[i], fn, context);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	/* @method off(type: String, fn?: Function, context?: Object): this
	  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	  	 *
	  	 * @alternative
	  	 * @method off(eventMap: Object): this
	  	 * Removes a set of type/listener pairs.
	  	 *
	  	 * @alternative
	  	 * @method off: this
	  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
	  	 */
	  	off: function (types, fn, context) {
	
	  		if (!types) {
	  			// clear all listeners if called without arguments
	  			delete this._events;
	
	  		} else if (typeof types === 'object') {
	  			for (var type in types) {
	  				this._off(type, types[type], fn);
	  			}
	
	  		} else {
	  			types = splitWords(types);
	
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				this._off(types[i], fn, context);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// attach listener (without syntactic sugar now)
	  	_on: function (type, fn, context) {
	  		this._events = this._events || {};
	
	  		/* get/init listeners for type */
	  		var typeListeners = this._events[type];
	  		if (!typeListeners) {
	  			typeListeners = [];
	  			this._events[type] = typeListeners;
	  		}
	
	  		if (context === this) {
	  			// Less memory footprint.
	  			context = undefined;
	  		}
	  		var newListener = {fn: fn, ctx: context},
	  		    listeners = typeListeners;
	
	  		// check if fn already there
	  		for (var i = 0, len = listeners.length; i < len; i++) {
	  			if (listeners[i].fn === fn && listeners[i].ctx === context) {
	  				return;
	  			}
	  		}
	
	  		listeners.push(newListener);
	  	},
	
	  	_off: function (type, fn, context) {
	  		var listeners,
	  		    i,
	  		    len;
	
	  		if (!this._events) { return; }
	
	  		listeners = this._events[type];
	
	  		if (!listeners) {
	  			return;
	  		}
	
	  		if (!fn) {
	  			// Set all removed listeners to noop so they are not called if remove happens in fire
	  			for (i = 0, len = listeners.length; i < len; i++) {
	  				listeners[i].fn = falseFn;
	  			}
	  			// clear all listeners for a type if function isn't specified
	  			delete this._events[type];
	  			return;
	  		}
	
	  		if (context === this) {
	  			context = undefined;
	  		}
	
	  		if (listeners) {
	
	  			// find fn and remove it
	  			for (i = 0, len = listeners.length; i < len; i++) {
	  				var l = listeners[i];
	  				if (l.ctx !== context) { continue; }
	  				if (l.fn === fn) {
	
	  					// set the removed listener to noop so that's not called if remove happens in fire
	  					l.fn = falseFn;
	
	  					if (this._firingCount) {
	  						/* copy array in case events are being fired */
	  						this._events[type] = listeners = listeners.slice();
	  					}
	  					listeners.splice(i, 1);
	
	  					return;
	  				}
	  			}
	  		}
	  	},
	
	  	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	  	// Fires an event of the specified type. You can optionally provide an data
	  	// object — the first argument of the listener function will contain its
	  	// properties. The event can optionally be propagated to event parents.
	  	fire: function (type, data, propagate) {
	  		if (!this.listens(type, propagate)) { return this; }
	
	  		var event = extend({}, data, {
	  			type: type,
	  			target: this,
	  			sourceTarget: data && data.sourceTarget || this
	  		});
	
	  		if (this._events) {
	  			var listeners = this._events[type];
	
	  			if (listeners) {
	  				this._firingCount = (this._firingCount + 1) || 1;
	  				for (var i = 0, len = listeners.length; i < len; i++) {
	  					var l = listeners[i];
	  					l.fn.call(l.ctx || this, event);
	  				}
	
	  				this._firingCount--;
	  			}
	  		}
	
	  		if (propagate) {
	  			// propagate the event to parents (set with addEventParent)
	  			this._propagateEvent(event);
	  		}
	
	  		return this;
	  	},
	
	  	// @method listens(type: String): Boolean
	  	// Returns `true` if a particular event type has any listeners attached to it.
	  	listens: function (type, propagate) {
	  		var listeners = this._events && this._events[type];
	  		if (listeners && listeners.length) { return true; }
	
	  		if (propagate) {
	  			// also check parents for listeners if event propagates
	  			for (var id in this._eventParents) {
	  				if (this._eventParents[id].listens(type, propagate)) { return true; }
	  			}
	  		}
	  		return false;
	  	},
	
	  	// @method once(…): this
	  	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	  	once: function (types, fn, context) {
	
	  		if (typeof types === 'object') {
	  			for (var type in types) {
	  				this.once(type, types[type], fn);
	  			}
	  			return this;
	  		}
	
	  		var handler = bind(function () {
	  			this
	  			    .off(types, fn, context)
	  			    .off(types, handler, context);
	  		}, this);
	
	  		// add a listener that's executed once and removed after that
	  		return this
	  		    .on(types, fn, context)
	  		    .on(types, handler, context);
	  	},
	
	  	// @method addEventParent(obj: Evented): this
	  	// Adds an event parent - an `Evented` that will receive propagated events
	  	addEventParent: function (obj) {
	  		this._eventParents = this._eventParents || {};
	  		this._eventParents[stamp(obj)] = obj;
	  		return this;
	  	},
	
	  	// @method removeEventParent(obj: Evented): this
	  	// Removes an event parent, so it will stop receiving propagated events
	  	removeEventParent: function (obj) {
	  		if (this._eventParents) {
	  			delete this._eventParents[stamp(obj)];
	  		}
	  		return this;
	  	},
	
	  	_propagateEvent: function (e) {
	  		for (var id in this._eventParents) {
	  			this._eventParents[id].fire(e.type, extend({
	  				layer: e.target,
	  				propagatedFrom: e.target
	  			}, e), true);
	  		}
	  	}
	  };
	
	  // aliases; we should ditch those eventually
	
	  // @method addEventListener(…): this
	  // Alias to [`on(…)`](#evented-on)
	  Events.addEventListener = Events.on;
	
	  // @method removeEventListener(…): this
	  // Alias to [`off(…)`](#evented-off)
	
	  // @method clearAllEventListeners(…): this
	  // Alias to [`off()`](#evented-off)
	  Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	  // @method addOneTimeEventListener(…): this
	  // Alias to [`once(…)`](#evented-once)
	  Events.addOneTimeEventListener = Events.once;
	
	  // @method fireEvent(…): this
	  // Alias to [`fire(…)`](#evented-fire)
	  Events.fireEvent = Events.fire;
	
	  // @method hasEventListeners(…): Boolean
	  // Alias to [`listens(…)`](#evented-listens)
	  Events.hasEventListeners = Events.listens;
	
	  var Evented = Class.extend(Events);
	
	  /*
	   * @class Point
	   * @aka L.Point
	   *
	   * Represents a point with `x` and `y` coordinates in pixels.
	   *
	   * @example
	   *
	   * ```js
	   * var point = L.point(200, 300);
	   * ```
	   *
	   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	   *
	   * ```js
	   * map.panBy([200, 300]);
	   * map.panBy(L.point(200, 300));
	   * ```
	   *
	   * Note that `Point` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function Point(x, y, round) {
	  	// @property x: Number; The `x` coordinate of the point
	  	this.x = (round ? Math.round(x) : x);
	  	// @property y: Number; The `y` coordinate of the point
	  	this.y = (round ? Math.round(y) : y);
	  }
	
	  var trunc = Math.trunc || function (v) {
	  	return v > 0 ? Math.floor(v) : Math.ceil(v);
	  };
	
	  Point.prototype = {
	
	  	// @method clone(): Point
	  	// Returns a copy of the current point.
	  	clone: function () {
	  		return new Point(this.x, this.y);
	  	},
	
	  	// @method add(otherPoint: Point): Point
	  	// Returns the result of addition of the current and the given points.
	  	add: function (point) {
	  		// non-destructive, returns a new point
	  		return this.clone()._add(toPoint(point));
	  	},
	
	  	_add: function (point) {
	  		// destructive, used directly for performance in situations where it's safe to modify existing point
	  		this.x += point.x;
	  		this.y += point.y;
	  		return this;
	  	},
	
	  	// @method subtract(otherPoint: Point): Point
	  	// Returns the result of subtraction of the given point from the current.
	  	subtract: function (point) {
	  		return this.clone()._subtract(toPoint(point));
	  	},
	
	  	_subtract: function (point) {
	  		this.x -= point.x;
	  		this.y -= point.y;
	  		return this;
	  	},
	
	  	// @method divideBy(num: Number): Point
	  	// Returns the result of division of the current point by the given number.
	  	divideBy: function (num) {
	  		return this.clone()._divideBy(num);
	  	},
	
	  	_divideBy: function (num) {
	  		this.x /= num;
	  		this.y /= num;
	  		return this;
	  	},
	
	  	// @method multiplyBy(num: Number): Point
	  	// Returns the result of multiplication of the current point by the given number.
	  	multiplyBy: function (num) {
	  		return this.clone()._multiplyBy(num);
	  	},
	
	  	_multiplyBy: function (num) {
	  		this.x *= num;
	  		this.y *= num;
	  		return this;
	  	},
	
	  	// @method scaleBy(scale: Point): Point
	  	// Multiply each coordinate of the current point by each coordinate of
	  	// `scale`. In linear algebra terms, multiply the point by the
	  	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	  	// defined by `scale`.
	  	scaleBy: function (point) {
	  		return new Point(this.x * point.x, this.y * point.y);
	  	},
	
	  	// @method unscaleBy(scale: Point): Point
	  	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	  	// each coordinate of `scale`.
	  	unscaleBy: function (point) {
	  		return new Point(this.x / point.x, this.y / point.y);
	  	},
	
	  	// @method round(): Point
	  	// Returns a copy of the current point with rounded coordinates.
	  	round: function () {
	  		return this.clone()._round();
	  	},
	
	  	_round: function () {
	  		this.x = Math.round(this.x);
	  		this.y = Math.round(this.y);
	  		return this;
	  	},
	
	  	// @method floor(): Point
	  	// Returns a copy of the current point with floored coordinates (rounded down).
	  	floor: function () {
	  		return this.clone()._floor();
	  	},
	
	  	_floor: function () {
	  		this.x = Math.floor(this.x);
	  		this.y = Math.floor(this.y);
	  		return this;
	  	},
	
	  	// @method ceil(): Point
	  	// Returns a copy of the current point with ceiled coordinates (rounded up).
	  	ceil: function () {
	  		return this.clone()._ceil();
	  	},
	
	  	_ceil: function () {
	  		this.x = Math.ceil(this.x);
	  		this.y = Math.ceil(this.y);
	  		return this;
	  	},
	
	  	// @method trunc(): Point
	  	// Returns a copy of the current point with truncated coordinates (rounded towards zero).
	  	trunc: function () {
	  		return this.clone()._trunc();
	  	},
	
	  	_trunc: function () {
	  		this.x = trunc(this.x);
	  		this.y = trunc(this.y);
	  		return this;
	  	},
	
	  	// @method distanceTo(otherPoint: Point): Number
	  	// Returns the cartesian distance between the current and the given points.
	  	distanceTo: function (point) {
	  		point = toPoint(point);
	
	  		var x = point.x - this.x,
	  		    y = point.y - this.y;
	
	  		return Math.sqrt(x * x + y * y);
	  	},
	
	  	// @method equals(otherPoint: Point): Boolean
	  	// Returns `true` if the given point has the same coordinates.
	  	equals: function (point) {
	  		point = toPoint(point);
	
	  		return point.x === this.x &&
	  		       point.y === this.y;
	  	},
	
	  	// @method contains(otherPoint: Point): Boolean
	  	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	  	contains: function (point) {
	  		point = toPoint(point);
	
	  		return Math.abs(point.x) <= Math.abs(this.x) &&
	  		       Math.abs(point.y) <= Math.abs(this.y);
	  	},
	
	  	// @method toString(): String
	  	// Returns a string representation of the point for debugging purposes.
	  	toString: function () {
	  		return 'Point(' +
	  		        formatNum(this.x) + ', ' +
	  		        formatNum(this.y) + ')';
	  	}
	  };
	
	  // @factory L.point(x: Number, y: Number, round?: Boolean)
	  // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	  // @alternative
	  // @factory L.point(coords: Number[])
	  // Expects an array of the form `[x, y]` instead.
	
	  // @alternative
	  // @factory L.point(coords: Object)
	  // Expects a plain object of the form `{x: Number, y: Number}` instead.
	  function toPoint(x, y, round) {
	  	if (x instanceof Point) {
	  		return x;
	  	}
	  	if (isArray(x)) {
	  		return new Point(x[0], x[1]);
	  	}
	  	if (x === undefined || x === null) {
	  		return x;
	  	}
	  	if (typeof x === 'object' && 'x' in x && 'y' in x) {
	  		return new Point(x.x, x.y);
	  	}
	  	return new Point(x, y, round);
	  }
	
	  /*
	   * @class Bounds
	   * @aka L.Bounds
	   *
	   * Represents a rectangular area in pixel coordinates.
	   *
	   * @example
	   *
	   * ```js
	   * var p1 = L.point(10, 10),
	   * p2 = L.point(40, 60),
	   * bounds = L.bounds(p1, p2);
	   * ```
	   *
	   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	   *
	   * ```js
	   * otherBounds.intersects([[10, 10], [40, 60]]);
	   * ```
	   *
	   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function Bounds(a, b) {
	  	if (!a) { return; }
	
	  	var points = b ? [a, b] : a;
	
	  	for (var i = 0, len = points.length; i < len; i++) {
	  		this.extend(points[i]);
	  	}
	  }
	
	  Bounds.prototype = {
	  	// @method extend(point: Point): this
	  	// Extends the bounds to contain the given point.
	  	extend: function (point) { // (Point)
	  		point = toPoint(point);
	
	  		// @property min: Point
	  		// The top left corner of the rectangle.
	  		// @property max: Point
	  		// The bottom right corner of the rectangle.
	  		if (!this.min && !this.max) {
	  			this.min = point.clone();
	  			this.max = point.clone();
	  		} else {
	  			this.min.x = Math.min(point.x, this.min.x);
	  			this.max.x = Math.max(point.x, this.max.x);
	  			this.min.y = Math.min(point.y, this.min.y);
	  			this.max.y = Math.max(point.y, this.max.y);
	  		}
	  		return this;
	  	},
	
	  	// @method getCenter(round?: Boolean): Point
	  	// Returns the center point of the bounds.
	  	getCenter: function (round) {
	  		return new Point(
	  		        (this.min.x + this.max.x) / 2,
	  		        (this.min.y + this.max.y) / 2, round);
	  	},
	
	  	// @method getBottomLeft(): Point
	  	// Returns the bottom-left point of the bounds.
	  	getBottomLeft: function () {
	  		return new Point(this.min.x, this.max.y);
	  	},
	
	  	// @method getTopRight(): Point
	  	// Returns the top-right point of the bounds.
	  	getTopRight: function () { // -> Point
	  		return new Point(this.max.x, this.min.y);
	  	},
	
	  	// @method getTopLeft(): Point
	  	// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
	  	getTopLeft: function () {
	  		return this.min; // left, top
	  	},
	
	  	// @method getBottomRight(): Point
	  	// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
	  	getBottomRight: function () {
	  		return this.max; // right, bottom
	  	},
	
	  	// @method getSize(): Point
	  	// Returns the size of the given bounds
	  	getSize: function () {
	  		return this.max.subtract(this.min);
	  	},
	
	  	// @method contains(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle contains the given one.
	  	// @alternative
	  	// @method contains(point: Point): Boolean
	  	// Returns `true` if the rectangle contains the given point.
	  	contains: function (obj) {
	  		var min, max;
	
	  		if (typeof obj[0] === 'number' || obj instanceof Point) {
	  			obj = toPoint(obj);
	  		} else {
	  			obj = toBounds(obj);
	  		}
	
	  		if (obj instanceof Bounds) {
	  			min = obj.min;
	  			max = obj.max;
	  		} else {
	  			min = max = obj;
	  		}
	
	  		return (min.x >= this.min.x) &&
	  		       (max.x <= this.max.x) &&
	  		       (min.y >= this.min.y) &&
	  		       (max.y <= this.max.y);
	  	},
	
	  	// @method intersects(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	  	// intersect if they have at least one point in common.
	  	intersects: function (bounds) { // (Bounds) -> Boolean
	  		bounds = toBounds(bounds);
	
	  		var min = this.min,
	  		    max = this.max,
	  		    min2 = bounds.min,
	  		    max2 = bounds.max,
	  		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
	  		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
	  		return xIntersects && yIntersects;
	  	},
	
	  	// @method overlaps(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	  	// overlap if their intersection is an area.
	  	overlaps: function (bounds) { // (Bounds) -> Boolean
	  		bounds = toBounds(bounds);
	
	  		var min = this.min,
	  		    max = this.max,
	  		    min2 = bounds.min,
	  		    max2 = bounds.max,
	  		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
	  		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
	  		return xOverlaps && yOverlaps;
	  	},
	
	  	isValid: function () {
	  		return !!(this.min && this.max);
	  	}
	  };
	
	
	  // @factory L.bounds(corner1: Point, corner2: Point)
	  // Creates a Bounds object from two corners coordinate pairs.
	  // @alternative
	  // @factory L.bounds(points: Point[])
	  // Creates a Bounds object from the given array of points.
	  function toBounds(a, b) {
	  	if (!a || a instanceof Bounds) {
	  		return a;
	  	}
	  	return new Bounds(a, b);
	  }
	
	  /*
	   * @class LatLngBounds
	   * @aka L.LatLngBounds
	   *
	   * Represents a rectangular geographical area on a map.
	   *
	   * @example
	   *
	   * ```js
	   * var corner1 = L.latLng(40.712, -74.227),
	   * corner2 = L.latLng(40.774, -74.125),
	   * bounds = L.latLngBounds(corner1, corner2);
	   * ```
	   *
	   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	   *
	   * ```js
	   * map.fitBounds([
	   * 	[40.712, -74.227],
	   * 	[40.774, -74.125]
	   * ]);
	   * ```
	   *
	   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	   *
	   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
	  	if (!corner1) { return; }
	
	  	var latlngs = corner2 ? [corner1, corner2] : corner1;
	
	  	for (var i = 0, len = latlngs.length; i < len; i++) {
	  		this.extend(latlngs[i]);
	  	}
	  }
	
	  LatLngBounds.prototype = {
	
	  	// @method extend(latlng: LatLng): this
	  	// Extend the bounds to contain the given point
	
	  	// @alternative
	  	// @method extend(otherBounds: LatLngBounds): this
	  	// Extend the bounds to contain the given bounds
	  	extend: function (obj) {
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2, ne2;
	
	  		if (obj instanceof LatLng) {
	  			sw2 = obj;
	  			ne2 = obj;
	
	  		} else if (obj instanceof LatLngBounds) {
	  			sw2 = obj._southWest;
	  			ne2 = obj._northEast;
	
	  			if (!sw2 || !ne2) { return this; }
	
	  		} else {
	  			return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
	  		}
	
	  		if (!sw && !ne) {
	  			this._southWest = new LatLng(sw2.lat, sw2.lng);
	  			this._northEast = new LatLng(ne2.lat, ne2.lng);
	  		} else {
	  			sw.lat = Math.min(sw2.lat, sw.lat);
	  			sw.lng = Math.min(sw2.lng, sw.lng);
	  			ne.lat = Math.max(ne2.lat, ne.lat);
	  			ne.lng = Math.max(ne2.lng, ne.lng);
	  		}
	
	  		return this;
	  	},
	
	  	// @method pad(bufferRatio: Number): LatLngBounds
	  	// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
	  	// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
	  	// Negative values will retract the bounds.
	  	pad: function (bufferRatio) {
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
	  		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
	  		return new LatLngBounds(
	  		        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
	  		        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center point of the bounds.
	  	getCenter: function () {
	  		return new LatLng(
	  		        (this._southWest.lat + this._northEast.lat) / 2,
	  		        (this._southWest.lng + this._northEast.lng) / 2);
	  	},
	
	  	// @method getSouthWest(): LatLng
	  	// Returns the south-west point of the bounds.
	  	getSouthWest: function () {
	  		return this._southWest;
	  	},
	
	  	// @method getNorthEast(): LatLng
	  	// Returns the north-east point of the bounds.
	  	getNorthEast: function () {
	  		return this._northEast;
	  	},
	
	  	// @method getNorthWest(): LatLng
	  	// Returns the north-west point of the bounds.
	  	getNorthWest: function () {
	  		return new LatLng(this.getNorth(), this.getWest());
	  	},
	
	  	// @method getSouthEast(): LatLng
	  	// Returns the south-east point of the bounds.
	  	getSouthEast: function () {
	  		return new LatLng(this.getSouth(), this.getEast());
	  	},
	
	  	// @method getWest(): Number
	  	// Returns the west longitude of the bounds
	  	getWest: function () {
	  		return this._southWest.lng;
	  	},
	
	  	// @method getSouth(): Number
	  	// Returns the south latitude of the bounds
	  	getSouth: function () {
	  		return this._southWest.lat;
	  	},
	
	  	// @method getEast(): Number
	  	// Returns the east longitude of the bounds
	  	getEast: function () {
	  		return this._northEast.lng;
	  	},
	
	  	// @method getNorth(): Number
	  	// Returns the north latitude of the bounds
	  	getNorth: function () {
	  		return this._northEast.lat;
	  	},
	
	  	// @method contains(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle contains the given one.
	
	  	// @alternative
	  	// @method contains (latlng: LatLng): Boolean
	  	// Returns `true` if the rectangle contains the given point.
	  	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
	  		if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
	  			obj = toLatLng(obj);
	  		} else {
	  			obj = toLatLngBounds(obj);
	  		}
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2, ne2;
	
	  		if (obj instanceof LatLngBounds) {
	  			sw2 = obj.getSouthWest();
	  			ne2 = obj.getNorthEast();
	  		} else {
	  			sw2 = ne2 = obj;
	  		}
	
	  		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
	  		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	  	},
	
	  	// @method intersects(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	  	intersects: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2 = bounds.getSouthWest(),
	  		    ne2 = bounds.getNorthEast(),
	
	  		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
	  		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
	  		return latIntersects && lngIntersects;
	  	},
	
	  	// @method overlaps(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	  	overlaps: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2 = bounds.getSouthWest(),
	  		    ne2 = bounds.getNorthEast(),
	
	  		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
	  		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
	  		return latOverlaps && lngOverlaps;
	  	},
	
	  	// @method toBBoxString(): String
	  	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	  	toBBoxString: function () {
	  		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	  	},
	
	  	// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
	  	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
	  	equals: function (bounds, maxMargin) {
	  		if (!bounds) { return false; }
	
	  		bounds = toLatLngBounds(bounds);
	
	  		return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
	  		       this._northEast.equals(bounds.getNorthEast(), maxMargin);
	  	},
	
	  	// @method isValid(): Boolean
	  	// Returns `true` if the bounds are properly initialized.
	  	isValid: function () {
	  		return !!(this._southWest && this._northEast);
	  	}
	  };
	
	  // TODO International date line?
	
	  // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	  // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	  // @alternative
	  // @factory L.latLngBounds(latlngs: LatLng[])
	  // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	  function toLatLngBounds(a, b) {
	  	if (a instanceof LatLngBounds) {
	  		return a;
	  	}
	  	return new LatLngBounds(a, b);
	  }
	
	  /* @class LatLng
	   * @aka L.LatLng
	   *
	   * Represents a geographical point with a certain latitude and longitude.
	   *
	   * @example
	   *
	   * ```
	   * var latlng = L.latLng(50.5, 30.5);
	   * ```
	   *
	   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	   *
	   * ```
	   * map.panTo([50, 30]);
	   * map.panTo({lon: 30, lat: 50});
	   * map.panTo({lat: 50, lng: 30});
	   * map.panTo(L.latLng(50, 30));
	   * ```
	   *
	   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function LatLng(lat, lng, alt) {
	  	if (isNaN(lat) || isNaN(lng)) {
	  		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	  	}
	
	  	// @property lat: Number
	  	// Latitude in degrees
	  	this.lat = +lat;
	
	  	// @property lng: Number
	  	// Longitude in degrees
	  	this.lng = +lng;
	
	  	// @property alt: Number
	  	// Altitude in meters (optional)
	  	if (alt !== undefined) {
	  		this.alt = +alt;
	  	}
	  }
	
	  LatLng.prototype = {
	  	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	  	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
	  	equals: function (obj, maxMargin) {
	  		if (!obj) { return false; }
	
	  		obj = toLatLng(obj);
	
	  		var margin = Math.max(
	  		        Math.abs(this.lat - obj.lat),
	  		        Math.abs(this.lng - obj.lng));
	
	  		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	  	},
	
	  	// @method toString(): String
	  	// Returns a string representation of the point (for debugging purposes).
	  	toString: function (precision) {
	  		return 'LatLng(' +
	  		        formatNum(this.lat, precision) + ', ' +
	  		        formatNum(this.lng, precision) + ')';
	  	},
	
	  	// @method distanceTo(otherLatLng: LatLng): Number
	  	// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
	  	distanceTo: function (other) {
	  		return Earth.distance(this, toLatLng(other));
	  	},
	
	  	// @method wrap(): LatLng
	  	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	  	wrap: function () {
	  		return Earth.wrapLatLng(this);
	  	},
	
	  	// @method toBounds(sizeInMeters: Number): LatLngBounds
	  	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	  	toBounds: function (sizeInMeters) {
	  		var latAccuracy = 180 * sizeInMeters / 40075017,
	  		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
	  		return toLatLngBounds(
	  		        [this.lat - latAccuracy, this.lng - lngAccuracy],
	  		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	  	},
	
	  	clone: function () {
	  		return new LatLng(this.lat, this.lng, this.alt);
	  	}
	  };
	
	
	
	  // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	  // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	  // @alternative
	  // @factory L.latLng(coords: Array): LatLng
	  // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	  // @alternative
	  // @factory L.latLng(coords: Object): LatLng
	  // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	  function toLatLng(a, b, c) {
	  	if (a instanceof LatLng) {
	  		return a;
	  	}
	  	if (isArray(a) && typeof a[0] !== 'object') {
	  		if (a.length === 3) {
	  			return new LatLng(a[0], a[1], a[2]);
	  		}
	  		if (a.length === 2) {
	  			return new LatLng(a[0], a[1]);
	  		}
	  		return null;
	  	}
	  	if (a === undefined || a === null) {
	  		return a;
	  	}
	  	if (typeof a === 'object' && 'lat' in a) {
	  		return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	  	}
	  	if (b === undefined) {
	  		return null;
	  	}
	  	return new LatLng(a, b, c);
	  }
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Base
	   * Object that defines coordinate reference systems for projecting
	   * geographical points into pixel (screen) coordinates and back (and to
	   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	   * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	   *
	   * Leaflet defines the most usual CRSs by default. If you want to use a
	   * CRS not defined by default, take a look at the
	   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	   *
	   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
	   * and can't be instantiated. Also, new classes can't inherit from them,
	   * and methods can't be added to them with the `include` function.
	   */
	
	  var CRS = {
	  	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	  	// Projects geographical coordinates into pixel coordinates for a given zoom.
	  	latLngToPoint: function (latlng, zoom) {
	  		var projectedPoint = this.projection.project(latlng),
	  		    scale = this.scale(zoom);
	
	  		return this.transformation._transform(projectedPoint, scale);
	  	},
	
	  	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	  	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	  	// zoom into geographical coordinates.
	  	pointToLatLng: function (point, zoom) {
	  		var scale = this.scale(zoom),
	  		    untransformedPoint = this.transformation.untransform(point, scale);
	
	  		return this.projection.unproject(untransformedPoint);
	  	},
	
	  	// @method project(latlng: LatLng): Point
	  	// Projects geographical coordinates into coordinates in units accepted for
	  	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	  	project: function (latlng) {
	  		return this.projection.project(latlng);
	  	},
	
	  	// @method unproject(point: Point): LatLng
	  	// Given a projected coordinate returns the corresponding LatLng.
	  	// The inverse of `project`.
	  	unproject: function (point) {
	  		return this.projection.unproject(point);
	  	},
	
	  	// @method scale(zoom: Number): Number
	  	// Returns the scale used when transforming projected coordinates into
	  	// pixel coordinates for a particular zoom. For example, it returns
	  	// `256 * 2^zoom` for Mercator-based CRS.
	  	scale: function (zoom) {
	  		return 256 * Math.pow(2, zoom);
	  	},
	
	  	// @method zoom(scale: Number): Number
	  	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	  	// factor of `scale`.
	  	zoom: function (scale) {
	  		return Math.log(scale / 256) / Math.LN2;
	  	},
	
	  	// @method getProjectedBounds(zoom: Number): Bounds
	  	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	  	getProjectedBounds: function (zoom) {
	  		if (this.infinite) { return null; }
	
	  		var b = this.projection.bounds,
	  		    s = this.scale(zoom),
	  		    min = this.transformation.transform(b.min, s),
	  		    max = this.transformation.transform(b.max, s);
	
	  		return new Bounds(min, max);
	  	},
	
	  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	  	// Returns the distance between two geographical coordinates.
	
	  	// @property code: String
	  	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	  	//
	  	// @property wrapLng: Number[]
	  	// An array of two numbers defining whether the longitude (horizontal) coordinate
	  	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	  	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	  	//
	  	// @property wrapLat: Number[]
	  	// Like `wrapLng`, but for the latitude (vertical) axis.
	
	  	// wrapLng: [min, max],
	  	// wrapLat: [min, max],
	
	  	// @property infinite: Boolean
	  	// If true, the coordinate space will be unbounded (infinite in both axes)
	  	infinite: false,
	
	  	// @method wrapLatLng(latlng: LatLng): LatLng
	  	// Returns a `LatLng` where lat and lng has been wrapped according to the
	  	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	  	wrapLatLng: function (latlng) {
	  		var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
	  		    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
	  		    alt = latlng.alt;
	
	  		return new LatLng(lat, lng, alt);
	  	},
	
	  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	  	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	  	// that its center is within the CRS's bounds.
	  	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	  	wrapLatLngBounds: function (bounds) {
	  		var center = bounds.getCenter(),
	  		    newCenter = this.wrapLatLng(center),
	  		    latShift = center.lat - newCenter.lat,
	  		    lngShift = center.lng - newCenter.lng;
	
	  		if (latShift === 0 && lngShift === 0) {
	  			return bounds;
	  		}
	
	  		var sw = bounds.getSouthWest(),
	  		    ne = bounds.getNorthEast(),
	  		    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
	  		    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
	  		return new LatLngBounds(newSw, newNe);
	  	}
	  };
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Earth
	   *
	   * Serves as the base for CRS that are global such that they cover the earth.
	   * Can only be used as the base for other CRS and cannot be used directly,
	   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	   * meters.
	   */
	
	  var Earth = extend({}, CRS, {
	  	wrapLng: [-180, 180],
	
	  	// Mean Earth Radius, as recommended for use by
	  	// the International Union of Geodesy and Geophysics,
	  	// see http://rosettacode.org/wiki/Haversine_formula
	  	R: 6371000,
	
	  	// distance between two geographical points using spherical law of cosines approximation
	  	distance: function (latlng1, latlng2) {
	  		var rad = Math.PI / 180,
	  		    lat1 = latlng1.lat * rad,
	  		    lat2 = latlng2.lat * rad,
	  		    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
	  		    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
	  		    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
	  		    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  		return this.R * c;
	  	}
	  });
	
	  /*
	   * @namespace Projection
	   * @projection L.Projection.SphericalMercator
	   *
	   * Spherical Mercator projection — the most common projection for online maps,
	   * used by almost all free and commercial tile providers. Assumes that Earth is
	   * a sphere. Used by the `EPSG:3857` CRS.
	   */
	
	  var earthRadius = 6378137;
	
	  var SphericalMercator = {
	
	  	R: earthRadius,
	  	MAX_LATITUDE: 85.0511287798,
	
	  	project: function (latlng) {
	  		var d = Math.PI / 180,
	  		    max = this.MAX_LATITUDE,
	  		    lat = Math.max(Math.min(max, latlng.lat), -max),
	  		    sin = Math.sin(lat * d);
	
	  		return new Point(
	  			this.R * latlng.lng * d,
	  			this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	  	},
	
	  	unproject: function (point) {
	  		var d = 180 / Math.PI;
	
	  		return new LatLng(
	  			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
	  			point.x * d / this.R);
	  	},
	
	  	bounds: (function () {
	  		var d = earthRadius * Math.PI;
	  		return new Bounds([-d, -d], [d, d]);
	  	})()
	  };
	
	  /*
	   * @class Transformation
	   * @aka L.Transformation
	   *
	   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	   * the reverse. Used by Leaflet in its projections code.
	   *
	   * @example
	   *
	   * ```js
	   * var transformation = L.transformation(2, 5, -1, 10),
	   * 	p = L.point(1, 2),
	   * 	p2 = transformation.transform(p), //  L.point(7, 8)
	   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	   * ```
	   */
	
	
	  // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	  // Creates a `Transformation` object with the given coefficients.
	  function Transformation(a, b, c, d) {
	  	if (isArray(a)) {
	  		// use array properties
	  		this._a = a[0];
	  		this._b = a[1];
	  		this._c = a[2];
	  		this._d = a[3];
	  		return;
	  	}
	  	this._a = a;
	  	this._b = b;
	  	this._c = c;
	  	this._d = d;
	  }
	
	  Transformation.prototype = {
	  	// @method transform(point: Point, scale?: Number): Point
	  	// Returns a transformed point, optionally multiplied by the given scale.
	  	// Only accepts actual `L.Point` instances, not arrays.
	  	transform: function (point, scale) { // (Point, Number) -> Point
	  		return this._transform(point.clone(), scale);
	  	},
	
	  	// destructive transform (faster)
	  	_transform: function (point, scale) {
	  		scale = scale || 1;
	  		point.x = scale * (this._a * point.x + this._b);
	  		point.y = scale * (this._c * point.y + this._d);
	  		return point;
	  	},
	
	  	// @method untransform(point: Point, scale?: Number): Point
	  	// Returns the reverse transformation of the given point, optionally divided
	  	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
	  	untransform: function (point, scale) {
	  		scale = scale || 1;
	  		return new Point(
	  		        (point.x / scale - this._b) / this._a,
	  		        (point.y / scale - this._d) / this._c);
	  	}
	  };
	
	  // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	  // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	  // Instantiates a Transformation object with the given coefficients.
	
	  // @alternative
	  // @factory L.transformation(coefficients: Array): Transformation
	  // Expects an coefficients array of the form
	  // `[a: Number, b: Number, c: Number, d: Number]`.
	
	  function toTransformation(a, b, c, d) {
	  	return new Transformation(a, b, c, d);
	  }
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG3857
	   *
	   * The most common CRS for online maps, used by almost all free and commercial
	   * tile providers. Uses Spherical Mercator projection. Set in by default in
	   * Map's `crs` option.
	   */
	
	  var EPSG3857 = extend({}, Earth, {
	  	code: 'EPSG:3857',
	  	projection: SphericalMercator,
	
	  	transformation: (function () {
	  		var scale = 0.5 / (Math.PI * SphericalMercator.R);
	  		return toTransformation(scale, 0.5, -scale, 0.5);
	  	}())
	  });
	
	  var EPSG900913 = extend({}, EPSG3857, {
	  	code: 'EPSG:900913'
	  });
	
	  // @namespace SVG; @section
	  // There are several static functions which can be called without instantiating L.SVG:
	
	  // @function create(name: String): SVGElement
	  // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	  // corresponding to the class name passed. For example, using 'line' will return
	  // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	  function svgCreate(name) {
	  	return document.createElementNS('http://www.w3.org/2000/svg', name);
	  }
	
	  // @function pointsToPath(rings: Point[], closed: Boolean): String
	  // Generates a SVG path string for multiple rings, with each ring turning
	  // into "M..L..L.." instructions
	  function pointsToPath(rings, closed) {
	  	var str = '',
	  	i, j, len, len2, points, p;
	
	  	for (i = 0, len = rings.length; i < len; i++) {
	  		points = rings[i];
	
	  		for (j = 0, len2 = points.length; j < len2; j++) {
	  			p = points[j];
	  			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
	  		}
	
	  		// closes the ring for polygons; "x" is VML syntax
	  		str += closed ? (svg ? 'z' : 'x') : '';
	  	}
	
	  	// SVG complains about empty path strings
	  	return str || 'M0 0';
	  }
	
	  /*
	   * @namespace Browser
	   * @aka L.Browser
	   *
	   * A namespace with static properties for browser/feature detection used by Leaflet internally.
	   *
	   * @example
	   *
	   * ```js
	   * if (L.Browser.ielt9) {
	   *   alert('Upgrade your browser, dude!');
	   * }
	   * ```
	   */
	
	  var style$1 = document.documentElement.style;
	
	  // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	  var ie = 'ActiveXObject' in window;
	
	  // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	  var ielt9 = ie && !document.addEventListener;
	
	  // @property edge: Boolean; `true` for the Edge web browser.
	  var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	  // @property webkit: Boolean;
	  // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	  var webkit = userAgentContains('webkit');
	
	  // @property android: Boolean
	  // `true` for any browser running on an Android platform.
	  var android = userAgentContains('android');
	
	  // @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
	  var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	  /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	  var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	  // @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
	  var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
	
	  // @property opera: Boolean; `true` for the Opera browser
	  var opera = !!window.opera;
	
	  // @property chrome: Boolean; `true` for the Chrome browser.
	  var chrome = !edge && userAgentContains('chrome');
	
	  // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	  var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	  // @property safari: Boolean; `true` for the Safari browser.
	  var safari = !chrome && userAgentContains('safari');
	
	  var phantom = userAgentContains('phantom');
	
	  // @property opera12: Boolean
	  // `true` for the Opera browser supporting CSS transforms (version 12 or later).
	  var opera12 = 'OTransition' in style$1;
	
	  // @property win: Boolean; `true` when the browser is running in a Windows platform
	  var win = navigator.platform.indexOf('Win') === 0;
	
	  // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	  var ie3d = ie && ('transition' in style$1);
	
	  // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	  var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	  // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	  var gecko3d = 'MozPerspective' in style$1;
	
	  // @property any3d: Boolean
	  // `true` for all browsers supporting CSS transforms.
	  var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	  // @property mobile: Boolean; `true` for all browsers running in a mobile device.
	  var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	  // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	  var mobileWebkit = mobile && webkit;
	
	  // @property mobileWebkit3d: Boolean
	  // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	  var mobileWebkit3d = mobile && webkit3d;
	
	  // @property msPointer: Boolean
	  // `true` for browsers implementing the Microsoft touch events model (notably IE10).
	  var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	  // @property pointer: Boolean
	  // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	  var pointer = !!(window.PointerEvent || msPointer);
	
	  // @property touch: Boolean
	  // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	  // This does not necessarily mean that the browser is running in a computer with
	  // a touchscreen, it only means that the browser is capable of understanding
	  // touch events.
	  var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
	  		(window.DocumentTouch && document instanceof window.DocumentTouch));
	
	  // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	  var mobileOpera = mobile && opera;
	
	  // @property mobileGecko: Boolean
	  // `true` for gecko-based browsers running in a mobile device.
	  var mobileGecko = mobile && gecko;
	
	  // @property retina: Boolean
	  // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	  var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	  // @property passiveEvents: Boolean
	  // `true` for browsers that support passive events.
	  var passiveEvents = (function () {
	  	var supportsPassiveOption = false;
	  	try {
	  		var opts = Object.defineProperty({}, 'passive', {
	  			get: function () { // eslint-disable-line getter-return
	  				supportsPassiveOption = true;
	  			}
	  		});
	  		window.addEventListener('testPassiveEventSupport', falseFn, opts);
	  		window.removeEventListener('testPassiveEventSupport', falseFn, opts);
	  	} catch (e) {
	  		// Errors can safely be ignored since this is only a browser support test.
	  	}
	  	return supportsPassiveOption;
	  }());
	
	  // @property canvas: Boolean
	  // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	  var canvas = (function () {
	  	return !!document.createElement('canvas').getContext;
	  }());
	
	  // @property svg: Boolean
	  // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	  var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	  // @property vml: Boolean
	  // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	  var vml = !svg && (function () {
	  	try {
	  		var div = document.createElement('div');
	  		div.innerHTML = '<v:shape adj="1"/>';
	
	  		var shape = div.firstChild;
	  		shape.style.behavior = 'url(#default#VML)';
	
	  		return shape && (typeof shape.adj === 'object');
	
	  	} catch (e) {
	  		return false;
	  	}
	  }());
	
	
	  function userAgentContains(str) {
	  	return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	  }
	
	  var Browser = ({
	    ie: ie,
	    ielt9: ielt9,
	    edge: edge,
	    webkit: webkit,
	    android: android,
	    android23: android23,
	    androidStock: androidStock,
	    opera: opera,
	    chrome: chrome,
	    gecko: gecko,
	    safari: safari,
	    phantom: phantom,
	    opera12: opera12,
	    win: win,
	    ie3d: ie3d,
	    webkit3d: webkit3d,
	    gecko3d: gecko3d,
	    any3d: any3d,
	    mobile: mobile,
	    mobileWebkit: mobileWebkit,
	    mobileWebkit3d: mobileWebkit3d,
	    msPointer: msPointer,
	    pointer: pointer,
	    touch: touch,
	    mobileOpera: mobileOpera,
	    mobileGecko: mobileGecko,
	    retina: retina,
	    passiveEvents: passiveEvents,
	    canvas: canvas,
	    svg: svg,
	    vml: vml
	  });
	
	  /*
	   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	   */
	
	
	  var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
	  var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
	  var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
	  var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
	
	  var _pointers = {};
	  var _pointerDocListener = false;
	
	  // Provides a touch events wrapper for (ms)pointer events.
	  // ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	  function addPointerListener(obj, type, handler, id) {
	  	if (type === 'touchstart') {
	  		_addPointerStart(obj, handler, id);
	
	  	} else if (type === 'touchmove') {
	  		_addPointerMove(obj, handler, id);
	
	  	} else if (type === 'touchend') {
	  		_addPointerEnd(obj, handler, id);
	  	}
	
	  	return this;
	  }
	
	  function removePointerListener(obj, type, id) {
	  	var handler = obj['_leaflet_' + type + id];
	
	  	if (type === 'touchstart') {
	  		obj.removeEventListener(POINTER_DOWN, handler, false);
	
	  	} else if (type === 'touchmove') {
	  		obj.removeEventListener(POINTER_MOVE, handler, false);
	
	  	} else if (type === 'touchend') {
	  		obj.removeEventListener(POINTER_UP, handler, false);
	  		obj.removeEventListener(POINTER_CANCEL, handler, false);
	  	}
	
	  	return this;
	  }
	
	  function _addPointerStart(obj, handler, id) {
	  	var onDown = bind(function (e) {
	  		// IE10 specific: MsTouch needs preventDefault. See #2000
	  		if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
	  			preventDefault(e);
	  		}
	
	  		_handlePointer(e, handler);
	  	});
	
	  	obj['_leaflet_touchstart' + id] = onDown;
	  	obj.addEventListener(POINTER_DOWN, onDown, false);
	
	  	// need to keep track of what pointers and how many are active to provide e.touches emulation
	  	if (!_pointerDocListener) {
	  		// we listen document as any drags that end by moving the touch off the screen get fired there
	  		document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
	  		document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
	  		document.addEventListener(POINTER_UP, _globalPointerUp, true);
	  		document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
	  		_pointerDocListener = true;
	  	}
	  }
	
	  function _globalPointerDown(e) {
	  	_pointers[e.pointerId] = e;
	  }
	
	  function _globalPointerMove(e) {
	  	if (_pointers[e.pointerId]) {
	  		_pointers[e.pointerId] = e;
	  	}
	  }
	
	  function _globalPointerUp(e) {
	  	delete _pointers[e.pointerId];
	  }
	
	  function _handlePointer(e, handler) {
	  	e.touches = [];
	  	for (var i in _pointers) {
	  		e.touches.push(_pointers[i]);
	  	}
	  	e.changedTouches = [e];
	
	  	handler(e);
	  }
	
	  function _addPointerMove(obj, handler, id) {
	  	var onMove = function (e) {
	  		// don't fire touch moves when mouse isn't down
	  		if ((e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) && e.buttons === 0) {
	  			return;
	  		}
	
	  		_handlePointer(e, handler);
	  	};
	
	  	obj['_leaflet_touchmove' + id] = onMove;
	  	obj.addEventListener(POINTER_MOVE, onMove, false);
	  }
	
	  function _addPointerEnd(obj, handler, id) {
	  	var onUp = function (e) {
	  		_handlePointer(e, handler);
	  	};
	
	  	obj['_leaflet_touchend' + id] = onUp;
	  	obj.addEventListener(POINTER_UP, onUp, false);
	  	obj.addEventListener(POINTER_CANCEL, onUp, false);
	  }
	
	  /*
	   * Extends the event handling code with double tap support for mobile browsers.
	   */
	
	  var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
	  var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
	  var _pre = '_leaflet_';
	
	  // inspired by Zepto touch code by Thomas Fuchs
	  function addDoubleTapListener(obj, handler, id) {
	  	var last, touch$$1,
	  	    doubleTap = false,
	  	    delay = 250;
	
	  	function onTouchStart(e) {
	
	  		if (pointer) {
	  			if (!e.isPrimary) { return; }
	  			if (e.pointerType === 'mouse') { return; } // mouse fires native dblclick
	  		} else if (e.touches.length > 1) {
	  			return;
	  		}
	
	  		var now = Date.now(),
	  		    delta = now - (last || now);
	
	  		touch$$1 = e.touches ? e.touches[0] : e;
	  		doubleTap = (delta > 0 && delta <= delay);
	  		last = now;
	  	}
	
	  	function onTouchEnd(e) {
	  		if (doubleTap && !touch$$1.cancelBubble) {
	  			if (pointer) {
	  				if (e.pointerType === 'mouse') { return; }
	  				// work around .type being readonly with MSPointer* events
	  				var newTouch = {},
	  				    prop, i;
	
	  				for (i in touch$$1) {
	  					prop = touch$$1[i];
	  					newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
	  				}
	  				touch$$1 = newTouch;
	  			}
	  			touch$$1.type = 'dblclick';
	  			touch$$1.button = 0;
	  			handler(touch$$1);
	  			last = null;
	  		}
	  	}
	
	  	obj[_pre + _touchstart + id] = onTouchStart;
	  	obj[_pre + _touchend + id] = onTouchEnd;
	  	obj[_pre + 'dblclick' + id] = handler;
	
	  	obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? {passive: false} : false);
	  	obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? {passive: false} : false);
	
	  	// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
	  	// the browser doesn't fire touchend/pointerup events but does fire
	  	// native dblclicks. See #4127.
	  	// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
	  	obj.addEventListener('dblclick', handler, false);
	
	  	return this;
	  }
	
	  function removeDoubleTapListener(obj, id) {
	  	var touchstart = obj[_pre + _touchstart + id],
	  	    touchend = obj[_pre + _touchend + id],
	  	    dblclick = obj[_pre + 'dblclick' + id];
	
	  	obj.removeEventListener(_touchstart, touchstart, passiveEvents ? {passive: false} : false);
	  	obj.removeEventListener(_touchend, touchend, passiveEvents ? {passive: false} : false);
	  	obj.removeEventListener('dblclick', dblclick, false);
	
	  	return this;
	  }
	
	  /*
	   * @namespace DomUtil
	   *
	   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	   * tree, used by Leaflet internally.
	   *
	   * Most functions expecting or returning a `HTMLElement` also work for
	   * SVG elements. The only difference is that classes refer to CSS classes
	   * in HTML and SVG classes in SVG.
	   */
	
	
	  // @property TRANSFORM: String
	  // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	  var TRANSFORM = testProp(
	  	['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	  // webkitTransition comes first because some browser versions that drop vendor prefix don't do
	  // the same for the transitionend event, in particular the Android 4.1 stock browser
	
	  // @property TRANSITION: String
	  // Vendor-prefixed transition style name.
	  var TRANSITION = testProp(
	  	['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	  // @property TRANSITION_END: String
	  // Vendor-prefixed transitionend event name.
	  var TRANSITION_END =
	  	TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	  // @function get(id: String|HTMLElement): HTMLElement
	  // Returns an element given its DOM id, or returns the element itself
	  // if it was passed directly.
	  function get(id) {
	  	return typeof id === 'string' ? document.getElementById(id) : id;
	  }
	
	  // @function getStyle(el: HTMLElement, styleAttrib: String): String
	  // Returns the value for a certain style attribute on an element,
	  // including computed values or values set through CSS.
	  function getStyle(el, style) {
	  	var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
	  	if ((!value || value === 'auto') && document.defaultView) {
	  		var css = document.defaultView.getComputedStyle(el, null);
	  		value = css ? css[style] : null;
	  	}
	  	return value === 'auto' ? null : value;
	  }
	
	  // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	  // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	  function create$1(tagName, className, container) {
	  	var el = document.createElement(tagName);
	  	el.className = className || '';
	
	  	if (container) {
	  		container.appendChild(el);
	  	}
	  	return el;
	  }
	
	  // @function remove(el: HTMLElement)
	  // Removes `el` from its parent element
	  function remove(el) {
	  	var parent = el.parentNode;
	  	if (parent) {
	  		parent.removeChild(el);
	  	}
	  }
	
	  // @function empty(el: HTMLElement)
	  // Removes all of `el`'s children elements from `el`
	  function empty(el) {
	  	while (el.firstChild) {
	  		el.removeChild(el.firstChild);
	  	}
	  }
	
	  // @function toFront(el: HTMLElement)
	  // Makes `el` the last child of its parent, so it renders in front of the other children.
	  function toFront(el) {
	  	var parent = el.parentNode;
	  	if (parent && parent.lastChild !== el) {
	  		parent.appendChild(el);
	  	}
	  }
	
	  // @function toBack(el: HTMLElement)
	  // Makes `el` the first child of its parent, so it renders behind the other children.
	  function toBack(el) {
	  	var parent = el.parentNode;
	  	if (parent && parent.firstChild !== el) {
	  		parent.insertBefore(el, parent.firstChild);
	  	}
	  }
	
	  // @function hasClass(el: HTMLElement, name: String): Boolean
	  // Returns `true` if the element's class attribute contains `name`.
	  function hasClass(el, name) {
	  	if (el.classList !== undefined) {
	  		return el.classList.contains(name);
	  	}
	  	var className = getClass(el);
	  	return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	  }
	
	  // @function addClass(el: HTMLElement, name: String)
	  // Adds `name` to the element's class attribute.
	  function addClass(el, name) {
	  	if (el.classList !== undefined) {
	  		var classes = splitWords(name);
	  		for (var i = 0, len = classes.length; i < len; i++) {
	  			el.classList.add(classes[i]);
	  		}
	  	} else if (!hasClass(el, name)) {
	  		var className = getClass(el);
	  		setClass(el, (className ? className + ' ' : '') + name);
	  	}
	  }
	
	  // @function removeClass(el: HTMLElement, name: String)
	  // Removes `name` from the element's class attribute.
	  function removeClass(el, name) {
	  	if (el.classList !== undefined) {
	  		el.classList.remove(name);
	  	} else {
	  		setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
	  	}
	  }
	
	  // @function setClass(el: HTMLElement, name: String)
	  // Sets the element's class.
	  function setClass(el, name) {
	  	if (el.className.baseVal === undefined) {
	  		el.className = name;
	  	} else {
	  		// in case of SVG element
	  		el.className.baseVal = name;
	  	}
	  }
	
	  // @function getClass(el: HTMLElement): String
	  // Returns the element's class.
	  function getClass(el) {
	  	// Check if the element is an SVGElementInstance and use the correspondingElement instead
	  	// (Required for linked SVG elements in IE11.)
	  	if (el.correspondingElement) {
	  		el = el.correspondingElement;
	  	}
	  	return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	  }
	
	  // @function setOpacity(el: HTMLElement, opacity: Number)
	  // Set the opacity of an element (including old IE support).
	  // `opacity` must be a number from `0` to `1`.
	  function setOpacity(el, value) {
	  	if ('opacity' in el.style) {
	  		el.style.opacity = value;
	  	} else if ('filter' in el.style) {
	  		_setOpacityIE(el, value);
	  	}
	  }
	
	  function _setOpacityIE(el, value) {
	  	var filter = false,
	  	    filterName = 'DXImageTransform.Microsoft.Alpha';
	
	  	// filters collection throws an error if we try to retrieve a filter that doesn't exist
	  	try {
	  		filter = el.filters.item(filterName);
	  	} catch (e) {
	  		// don't set opacity to 1 if we haven't already set an opacity,
	  		// it isn't needed and breaks transparent pngs.
	  		if (value === 1) { return; }
	  	}
	
	  	value = Math.round(value * 100);
	
	  	if (filter) {
	  		filter.Enabled = (value !== 100);
	  		filter.Opacity = value;
	  	} else {
	  		el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
	  	}
	  }
	
	  // @function testProp(props: String[]): String|false
	  // Goes through the array of style names and returns the first name
	  // that is a valid style name for an element. If no such name is found,
	  // it returns false. Useful for vendor-prefixed styles like `transform`.
	  function testProp(props) {
	  	var style = document.documentElement.style;
	
	  	for (var i = 0; i < props.length; i++) {
	  		if (props[i] in style) {
	  			return props[i];
	  		}
	  	}
	  	return false;
	  }
	
	  // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	  // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	  // and optionally scaled by `scale`. Does not have an effect if the
	  // browser doesn't support 3D CSS transforms.
	  function setTransform(el, offset, scale) {
	  	var pos = offset || new Point(0, 0);
	
	  	el.style[TRANSFORM] =
	  		(ie3d ?
	  			'translate(' + pos.x + 'px,' + pos.y + 'px)' :
	  			'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
	  		(scale ? ' scale(' + scale + ')' : '');
	  }
	
	  // @function setPosition(el: HTMLElement, position: Point)
	  // Sets the position of `el` to coordinates specified by `position`,
	  // using CSS translate or top/left positioning depending on the browser
	  // (used by Leaflet internally to position its layers).
	  function setPosition(el, point) {
	
	  	/*eslint-disable */
	  	el._leaflet_pos = point;
	  	/* eslint-enable */
	
	  	if (any3d) {
	  		setTransform(el, point);
	  	} else {
	  		el.style.left = point.x + 'px';
	  		el.style.top = point.y + 'px';
	  	}
	  }
	
	  // @function getPosition(el: HTMLElement): Point
	  // Returns the coordinates of an element previously positioned with setPosition.
	  function getPosition(el) {
	  	// this method is only used for elements previously positioned using setPosition,
	  	// so it's safe to cache the position for performance
	
	  	return el._leaflet_pos || new Point(0, 0);
	  }
	
	  // @function disableTextSelection()
	  // Prevents the user from generating `selectstart` DOM events, usually generated
	  // when the user drags the mouse through a page with text. Used internally
	  // by Leaflet to override the behaviour of any click-and-drag interaction on
	  // the map. Affects drag interactions on the whole document.
	
	  // @function enableTextSelection()
	  // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	  var disableTextSelection;
	  var enableTextSelection;
	  var _userSelect;
	  if ('onselectstart' in document) {
	  	disableTextSelection = function () {
	  		on(window, 'selectstart', preventDefault);
	  	};
	  	enableTextSelection = function () {
	  		off(window, 'selectstart', preventDefault);
	  	};
	  } else {
	  	var userSelectProperty = testProp(
	  		['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
	  	disableTextSelection = function () {
	  		if (userSelectProperty) {
	  			var style = document.documentElement.style;
	  			_userSelect = style[userSelectProperty];
	  			style[userSelectProperty] = 'none';
	  		}
	  	};
	  	enableTextSelection = function () {
	  		if (userSelectProperty) {
	  			document.documentElement.style[userSelectProperty] = _userSelect;
	  			_userSelect = undefined;
	  		}
	  	};
	  }
	
	  // @function disableImageDrag()
	  // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	  // for `dragstart` DOM events, usually generated when the user drags an image.
	  function disableImageDrag() {
	  	on(window, 'dragstart', preventDefault);
	  }
	
	  // @function enableImageDrag()
	  // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	  function enableImageDrag() {
	  	off(window, 'dragstart', preventDefault);
	  }
	
	  var _outlineElement, _outlineStyle;
	  // @function preventOutline(el: HTMLElement)
	  // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	  // of the element `el` invisible. Used internally by Leaflet to prevent
	  // focusable elements from displaying an outline when the user performs a
	  // drag interaction on them.
	  function preventOutline(element) {
	  	while (element.tabIndex === -1) {
	  		element = element.parentNode;
	  	}
	  	if (!element.style) { return; }
	  	restoreOutline();
	  	_outlineElement = element;
	  	_outlineStyle = element.style.outline;
	  	element.style.outline = 'none';
	  	on(window, 'keydown', restoreOutline);
	  }
	
	  // @function restoreOutline()
	  // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	  function restoreOutline() {
	  	if (!_outlineElement) { return; }
	  	_outlineElement.style.outline = _outlineStyle;
	  	_outlineElement = undefined;
	  	_outlineStyle = undefined;
	  	off(window, 'keydown', restoreOutline);
	  }
	
	  // @function getSizedParentNode(el: HTMLElement): HTMLElement
	  // Finds the closest parent node which size (width and height) is not null.
	  function getSizedParentNode(element) {
	  	do {
	  		element = element.parentNode;
	  	} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
	  	return element;
	  }
	
	  // @function getScale(el: HTMLElement): Object
	  // Computes the CSS scale currently applied on the element.
	  // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	  // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	  function getScale(element) {
	  	var rect = element.getBoundingClientRect(); // Read-only in old browsers.
	
	  	return {
	  		x: rect.width / element.offsetWidth || 1,
	  		y: rect.height / element.offsetHeight || 1,
	  		boundingClientRect: rect
	  	};
	  }
	
	  var DomUtil = ({
	    TRANSFORM: TRANSFORM,
	    TRANSITION: TRANSITION,
	    TRANSITION_END: TRANSITION_END,
	    get: get,
	    getStyle: getStyle,
	    create: create$1,
	    remove: remove,
	    empty: empty,
	    toFront: toFront,
	    toBack: toBack,
	    hasClass: hasClass,
	    addClass: addClass,
	    removeClass: removeClass,
	    setClass: setClass,
	    getClass: getClass,
	    setOpacity: setOpacity,
	    testProp: testProp,
	    setTransform: setTransform,
	    setPosition: setPosition,
	    getPosition: getPosition,
	    disableTextSelection: disableTextSelection,
	    enableTextSelection: enableTextSelection,
	    disableImageDrag: disableImageDrag,
	    enableImageDrag: enableImageDrag,
	    preventOutline: preventOutline,
	    restoreOutline: restoreOutline,
	    getSizedParentNode: getSizedParentNode,
	    getScale: getScale
	  });
	
	  /*
	   * @namespace DomEvent
	   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	   */
	
	  // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	  // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	  // Adds a listener function (`fn`) to a particular DOM event type of the
	  // element `el`. You can optionally specify the context of the listener
	  // (object the `this` keyword will point to). You can also pass several
	  // space-separated types (e.g. `'click dblclick'`).
	
	  // @alternative
	  // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	  // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  function on(obj, types, fn, context) {
	
	  	if (typeof types === 'object') {
	  		for (var type in types) {
	  			addOne(obj, type, types[type], fn);
	  		}
	  	} else {
	  		types = splitWords(types);
	
	  		for (var i = 0, len = types.length; i < len; i++) {
	  			addOne(obj, types[i], fn, context);
	  		}
	  	}
	
	  	return this;
	  }
	
	  var eventsKey = '_leaflet_events';
	
	  // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	  // Removes a previously added listener function.
	  // Note that if you passed a custom context to on, you must pass the same
	  // context to `off` in order to remove the listener.
	
	  // @alternative
	  // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	  // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  function off(obj, types, fn, context) {
	
	  	if (typeof types === 'object') {
	  		for (var type in types) {
	  			removeOne(obj, type, types[type], fn);
	  		}
	  	} else if (types) {
	  		types = splitWords(types);
	
	  		for (var i = 0, len = types.length; i < len; i++) {
	  			removeOne(obj, types[i], fn, context);
	  		}
	  	} else {
	  		for (var j in obj[eventsKey]) {
	  			removeOne(obj, j, obj[eventsKey][j]);
	  		}
	  		delete obj[eventsKey];
	  	}
	
	  	return this;
	  }
	
	  function browserFiresNativeDblClick() {
	  	// See https://github.com/w3c/pointerevents/issues/171
	  	if (pointer) {
	  		return !(edge || safari);
	  	}
	  }
	
	  var mouseSubst = {
	  	mouseenter: 'mouseover',
	  	mouseleave: 'mouseout',
	  	wheel: !('onwheel' in window) && 'mousewheel'
	  };
	
	  function addOne(obj, type, fn, context) {
	  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
	  	if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
	  	var handler = function (e) {
	  		return fn.call(context || obj, e || window.event);
	  	};
	
	  	var originalHandler = handler;
	
	  	if (pointer && type.indexOf('touch') === 0) {
	  		// Needs DomEvent.Pointer.js
	  		addPointerListener(obj, type, handler, id);
	
	  	} else if (touch && (type === 'dblclick') && !browserFiresNativeDblClick()) {
	  		addDoubleTapListener(obj, handler, id);
	
	  	} else if ('addEventListener' in obj) {
	
	  		if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' ||  type === 'mousewheel') {
	  			obj.addEventListener(mouseSubst[type] || type, handler, passiveEvents ? {passive: false} : false);
	
	  		} else if (type === 'mouseenter' || type === 'mouseleave') {
	  			handler = function (e) {
	  				e = e || window.event;
	  				if (isExternalTarget(obj, e)) {
	  					originalHandler(e);
	  				}
	  			};
	  			obj.addEventListener(mouseSubst[type], handler, false);
	
	  		} else {
	  			obj.addEventListener(type, originalHandler, false);
	  		}
	
	  	} else if ('attachEvent' in obj) {
	  		obj.attachEvent('on' + type, handler);
	  	}
	
	  	obj[eventsKey] = obj[eventsKey] || {};
	  	obj[eventsKey][id] = handler;
	  }
	
	  function removeOne(obj, type, fn, context) {
	
	  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
	  	    handler = obj[eventsKey] && obj[eventsKey][id];
	
	  	if (!handler) { return this; }
	
	  	if (pointer && type.indexOf('touch') === 0) {
	  		removePointerListener(obj, type, id);
	
	  	} else if (touch && (type === 'dblclick') && !browserFiresNativeDblClick()) {
	  		removeDoubleTapListener(obj, id);
	
	  	} else if ('removeEventListener' in obj) {
	
	  		obj.removeEventListener(mouseSubst[type] || type, handler, false);
	
	  	} else if ('detachEvent' in obj) {
	  		obj.detachEvent('on' + type, handler);
	  	}
	
	  	obj[eventsKey][id] = null;
	  }
	
	  // @function stopPropagation(ev: DOMEvent): this
	  // Stop the given event from propagation to parent elements. Used inside the listener functions:
	  // ```js
	  // L.DomEvent.on(div, 'click', function (ev) {
	  // 	L.DomEvent.stopPropagation(ev);
	  // });
	  // ```
	  function stopPropagation(e) {
	
	  	if (e.stopPropagation) {
	  		e.stopPropagation();
	  	} else if (e.originalEvent) {  // In case of Leaflet event.
	  		e.originalEvent._stopped = true;
	  	} else {
	  		e.cancelBubble = true;
	  	}
	  	skipped(e);
	
	  	return this;
	  }
	
	  // @function disableScrollPropagation(el: HTMLElement): this
	  // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
	  function disableScrollPropagation(el) {
	  	addOne(el, 'wheel', stopPropagation);
	  	return this;
	  }
	
	  // @function disableClickPropagation(el: HTMLElement): this
	  // Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	  // `'mousedown'` and `'touchstart'` events (plus browser variants).
	  function disableClickPropagation(el) {
	  	on(el, 'mousedown touchstart dblclick', stopPropagation);
	  	addOne(el, 'click', fakeStop);
	  	return this;
	  }
	
	  // @function preventDefault(ev: DOMEvent): this
	  // Prevents the default action of the DOM Event `ev` from happening (such as
	  // following a link in the href of the a element, or doing a POST request
	  // with page reload when a `<form>` is submitted).
	  // Use it inside listener functions.
	  function preventDefault(e) {
	  	if (e.preventDefault) {
	  		e.preventDefault();
	  	} else {
	  		e.returnValue = false;
	  	}
	  	return this;
	  }
	
	  // @function stop(ev: DOMEvent): this
	  // Does `stopPropagation` and `preventDefault` at the same time.
	  function stop(e) {
	  	preventDefault(e);
	  	stopPropagation(e);
	  	return this;
	  }
	
	  // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	  // Gets normalized mouse position from a DOM event relative to the
	  // `container` (border excluded) or to the whole page if not specified.
	  function getMousePosition(e, container) {
	  	if (!container) {
	  		return new Point(e.clientX, e.clientY);
	  	}
	
	  	var scale = getScale(container),
	  	    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
	
	  	return new Point(
	  		// offset.left/top values are in page scale (like clientX/Y),
	  		// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
	  		(e.clientX - offset.left) / scale.x - container.clientLeft,
	  		(e.clientY - offset.top) / scale.y - container.clientTop
	  	);
	  }
	
	  // Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	  // and Firefox scrolls device pixels, not CSS pixels
	  var wheelPxFactor =
	  	(win && chrome) ? 2 * window.devicePixelRatio :
	  	gecko ? window.devicePixelRatio : 1;
	
	  // @function getWheelDelta(ev: DOMEvent): Number
	  // Gets normalized wheel delta from a wheel DOM event, in vertical
	  // pixels scrolled (negative if scrolling down).
	  // Events from pointing devices without precise scrolling are mapped to
	  // a best guess of 60 pixels.
	  function getWheelDelta(e) {
	  	return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
	  	       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
	  	       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
	  	       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
	  	       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
	  	       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
	  	       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
	  	       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
	  	       0;
	  }
	
	  var skipEvents = {};
	
	  function fakeStop(e) {
	  	// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
	  	skipEvents[e.type] = true;
	  }
	
	  function skipped(e) {
	  	var events = skipEvents[e.type];
	  	// reset when checking, as it's only used in map container and propagates outside of the map
	  	skipEvents[e.type] = false;
	  	return events;
	  }
	
	  // check if element really left/entered the event target (for mouseenter/mouseleave)
	  function isExternalTarget(el, e) {
	
	  	var related = e.relatedTarget;
	
	  	if (!related) { return true; }
	
	  	try {
	  		while (related && (related !== el)) {
	  			related = related.parentNode;
	  		}
	  	} catch (err) {
	  		return false;
	  	}
	  	return (related !== el);
	  }
	
	  var DomEvent = ({
	    on: on,
	    off: off,
	    stopPropagation: stopPropagation,
	    disableScrollPropagation: disableScrollPropagation,
	    disableClickPropagation: disableClickPropagation,
	    preventDefault: preventDefault,
	    stop: stop,
	    getMousePosition: getMousePosition,
	    getWheelDelta: getWheelDelta,
	    fakeStop: fakeStop,
	    skipped: skipped,
	    isExternalTarget: isExternalTarget,
	    addListener: on,
	    removeListener: off
	  });
	
	  /*
	   * @class PosAnimation
	   * @aka L.PosAnimation
	   * @inherits Evented
	   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	   *
	   * @example
	   * ```js
	   * var fx = new L.PosAnimation();
	   * fx.run(el, [300, 500], 0.5);
	   * ```
	   *
	   * @constructor L.PosAnimation()
	   * Creates a `PosAnimation` object.
	   *
	   */
	
	  var PosAnimation = Evented.extend({
	
	  	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	  	// Run an animation of a given element to a new position, optionally setting
	  	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	  	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
	  	// `0.5` by default).
	  	run: function (el, newPos, duration, easeLinearity) {
	  		this.stop();
	
	  		this._el = el;
	  		this._inProgress = true;
	  		this._duration = duration || 0.25;
	  		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
	  		this._startPos = getPosition(el);
	  		this._offset = newPos.subtract(this._startPos);
	  		this._startTime = +new Date();
	
	  		// @event start: Event
	  		// Fired when the animation starts
	  		this.fire('start');
	
	  		this._animate();
	  	},
	
	  	// @method stop()
	  	// Stops the animation (if currently running).
	  	stop: function () {
	  		if (!this._inProgress) { return; }
	
	  		this._step(true);
	  		this._complete();
	  	},
	
	  	_animate: function () {
	  		// animation loop
	  		this._animId = requestAnimFrame(this._animate, this);
	  		this._step();
	  	},
	
	  	_step: function (round) {
	  		var elapsed = (+new Date()) - this._startTime,
	  		    duration = this._duration * 1000;
	
	  		if (elapsed < duration) {
	  			this._runFrame(this._easeOut(elapsed / duration), round);
	  		} else {
	  			this._runFrame(1);
	  			this._complete();
	  		}
	  	},
	
	  	_runFrame: function (progress, round) {
	  		var pos = this._startPos.add(this._offset.multiplyBy(progress));
	  		if (round) {
	  			pos._round();
	  		}
	  		setPosition(this._el, pos);
	
	  		// @event step: Event
	  		// Fired continuously during the animation.
	  		this.fire('step');
	  	},
	
	  	_complete: function () {
	  		cancelAnimFrame(this._animId);
	
	  		this._inProgress = false;
	  		// @event end: Event
	  		// Fired when the animation ends.
	  		this.fire('end');
	  	},
	
	  	_easeOut: function (t) {
	  		return 1 - Math.pow(1 - t, this._easeOutPower);
	  	}
	  });
	
	  /*
	   * @class Map
	   * @aka L.Map
	   * @inherits Evented
	   *
	   * The central class of the API — it is used to create a map on a page and manipulate it.
	   *
	   * @example
	   *
	   * ```js
	   * // initialize the map on the "map" div with a given center and zoom
	   * var map = L.map('map', {
	   * 	center: [51.505, -0.09],
	   * 	zoom: 13
	   * });
	   * ```
	   *
	   */
	
	  var Map = Evented.extend({
	
	  	options: {
	  		// @section Map State Options
	  		// @option crs: CRS = L.CRS.EPSG3857
	  		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
	  		// sure what it means.
	  		crs: EPSG3857,
	
	  		// @option center: LatLng = undefined
	  		// Initial geographic center of the map
	  		center: undefined,
	
	  		// @option zoom: Number = undefined
	  		// Initial map zoom level
	  		zoom: undefined,
	
	  		// @option minZoom: Number = *
	  		// Minimum zoom level of the map.
	  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	  		// the lowest of their `minZoom` options will be used instead.
	  		minZoom: undefined,
	
	  		// @option maxZoom: Number = *
	  		// Maximum zoom level of the map.
	  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	  		// the highest of their `maxZoom` options will be used instead.
	  		maxZoom: undefined,
	
	  		// @option layers: Layer[] = []
	  		// Array of layers that will be added to the map initially
	  		layers: [],
	
	  		// @option maxBounds: LatLngBounds = null
	  		// When this option is set, the map restricts the view to the given
	  		// geographical bounds, bouncing the user back if the user tries to pan
	  		// outside the view. To set the restriction dynamically, use
	  		// [`setMaxBounds`](#map-setmaxbounds) method.
	  		maxBounds: undefined,
	
	  		// @option renderer: Renderer = *
	  		// The default method for drawing vector layers on the map. `L.SVG`
	  		// or `L.Canvas` by default depending on browser support.
	  		renderer: undefined,
	
	
	  		// @section Animation Options
	  		// @option zoomAnimation: Boolean = true
	  		// Whether the map zoom animation is enabled. By default it's enabled
	  		// in all browsers that support CSS3 Transitions except Android.
	  		zoomAnimation: true,
	
	  		// @option zoomAnimationThreshold: Number = 4
	  		// Won't animate zoom if the zoom difference exceeds this value.
	  		zoomAnimationThreshold: 4,
	
	  		// @option fadeAnimation: Boolean = true
	  		// Whether the tile fade animation is enabled. By default it's enabled
	  		// in all browsers that support CSS3 Transitions except Android.
	  		fadeAnimation: true,
	
	  		// @option markerZoomAnimation: Boolean = true
	  		// Whether markers animate their zoom with the zoom animation, if disabled
	  		// they will disappear for the length of the animation. By default it's
	  		// enabled in all browsers that support CSS3 Transitions except Android.
	  		markerZoomAnimation: true,
	
	  		// @option transform3DLimit: Number = 2^23
	  		// Defines the maximum size of a CSS translation transform. The default
	  		// value should not be changed unless a web browser positions layers in
	  		// the wrong place after doing a large `panBy`.
	  		transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
	  		// @section Interaction Options
	  		// @option zoomSnap: Number = 1
	  		// Forces the map's zoom level to always be a multiple of this, particularly
	  		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
	  		// By default, the zoom level snaps to the nearest integer; lower values
	  		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
	  		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
	  		zoomSnap: 1,
	
	  		// @option zoomDelta: Number = 1
	  		// Controls how much the map's zoom level will change after a
	  		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
	  		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
	  		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
	  		zoomDelta: 1,
	
	  		// @option trackResize: Boolean = true
	  		// Whether the map automatically handles browser window resize to update itself.
	  		trackResize: true
	  	},
	
	  	initialize: function (id, options) { // (HTMLElement or String, Object)
	  		options = setOptions(this, options);
	
	  		// Make sure to assign internal flags at the beginning,
	  		// to avoid inconsistent state in some edge cases.
	  		this._handlers = [];
	  		this._layers = {};
	  		this._zoomBoundLayers = {};
	  		this._sizeChanged = true;
	
	  		this._initContainer(id);
	  		this._initLayout();
	
	  		// hack for https://github.com/Leaflet/Leaflet/issues/1980
	  		this._onResize = bind(this._onResize, this);
	
	  		this._initEvents();
	
	  		if (options.maxBounds) {
	  			this.setMaxBounds(options.maxBounds);
	  		}
	
	  		if (options.zoom !== undefined) {
	  			this._zoom = this._limitZoom(options.zoom);
	  		}
	
	  		if (options.center && options.zoom !== undefined) {
	  			this.setView(toLatLng(options.center), options.zoom, {reset: true});
	  		}
	
	  		this.callInitHooks();
	
	  		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
	  		this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
	  				this.options.zoomAnimation;
	
	  		// zoom transitions run with the same duration for all layers, so if one of transitionend events
	  		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
	  		if (this._zoomAnimated) {
	  			this._createAnimProxy();
	  			on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
	  		}
	
	  		this._addLayers(this.options.layers);
	  	},
	
	
	  	// @section Methods for modifying map state
	
	  	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	  	// Sets the view of the map (geographical center and zoom) with the given
	  	// animation options.
	  	setView: function (center, zoom, options) {
	
	  		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
	  		center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
	  		options = options || {};
	
	  		this._stop();
	
	  		if (this._loaded && !options.reset && options !== true) {
	
	  			if (options.animate !== undefined) {
	  				options.zoom = extend({animate: options.animate}, options.zoom);
	  				options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
	  			}
	
	  			// try animating pan or zoom
	  			var moved = (this._zoom !== zoom) ?
	  				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
	  				this._tryAnimatedPan(center, options.pan);
	
	  			if (moved) {
	  				// prevent resize handler call, the view will refresh after animation anyway
	  				clearTimeout(this._sizeTimer);
	  				return this;
	  			}
	  		}
	
	  		// animation didn't start, just reset the map view
	  		this._resetView(center, zoom);
	
	  		return this;
	  	},
	
	  	// @method setZoom(zoom: Number, options?: Zoom/pan options): this
	  	// Sets the zoom of the map.
	  	setZoom: function (zoom, options) {
	  		if (!this._loaded) {
	  			this._zoom = zoom;
	  			return this;
	  		}
	  		return this.setView(this.getCenter(), zoom, {zoom: options});
	  	},
	
	  	// @method zoomIn(delta?: Number, options?: Zoom options): this
	  	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	  	zoomIn: function (delta, options) {
	  		delta = delta || (any3d ? this.options.zoomDelta : 1);
	  		return this.setZoom(this._zoom + delta, options);
	  	},
	
	  	// @method zoomOut(delta?: Number, options?: Zoom options): this
	  	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	  	zoomOut: function (delta, options) {
	  		delta = delta || (any3d ? this.options.zoomDelta : 1);
	  		return this.setZoom(this._zoom - delta, options);
	  	},
	
	  	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	  	// Zooms the map while keeping a specified geographical point on the map
	  	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	  	// @alternative
	  	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	  	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	  	setZoomAround: function (latlng, zoom, options) {
	  		var scale = this.getZoomScale(zoom),
	  		    viewHalf = this.getSize().divideBy(2),
	  		    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
	  		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
	  		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
	  		return this.setView(newCenter, zoom, {zoom: options});
	  	},
	
	  	_getBoundsCenterZoom: function (bounds, options) {
	
	  		options = options || {};
	  		bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
	  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
	  		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
	  		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
	  		if (zoom === Infinity) {
	  			return {
	  				center: bounds.getCenter(),
	  				zoom: zoom
	  			};
	  		}
	
	  		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
	  		    swPoint = this.project(bounds.getSouthWest(), zoom),
	  		    nePoint = this.project(bounds.getNorthEast(), zoom),
	  		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
	  		return {
	  			center: center,
	  			zoom: zoom
	  		};
	  	},
	
	  	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	  	// Sets a map view that contains the given geographical bounds with the
	  	// maximum zoom level possible.
	  	fitBounds: function (bounds, options) {
	
	  		bounds = toLatLngBounds(bounds);
	
	  		if (!bounds.isValid()) {
	  			throw new Error('Bounds are not valid.');
	  		}
	
	  		var target = this._getBoundsCenterZoom(bounds, options);
	  		return this.setView(target.center, target.zoom, options);
	  	},
	
	  	// @method fitWorld(options?: fitBounds options): this
	  	// Sets a map view that mostly contains the whole world with the maximum
	  	// zoom level possible.
	  	fitWorld: function (options) {
	  		return this.fitBounds([[-90, -180], [90, 180]], options);
	  	},
	
	  	// @method panTo(latlng: LatLng, options?: Pan options): this
	  	// Pans the map to a given center.
	  	panTo: function (center, options) { // (LatLng)
	  		return this.setView(center, this._zoom, {pan: options});
	  	},
	
	  	// @method panBy(offset: Point, options?: Pan options): this
	  	// Pans the map by a given number of pixels (animated).
	  	panBy: function (offset, options) {
	  		offset = toPoint(offset).round();
	  		options = options || {};
	
	  		if (!offset.x && !offset.y) {
	  			return this.fire('moveend');
	  		}
	  		// If we pan too far, Chrome gets issues with tiles
	  		// and makes them disappear or appear in the wrong place (slightly offset) #2602
	  		if (options.animate !== true && !this.getSize().contains(offset)) {
	  			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
	  			return this;
	  		}
	
	  		if (!this._panAnim) {
	  			this._panAnim = new PosAnimation();
	
	  			this._panAnim.on({
	  				'step': this._onPanTransitionStep,
	  				'end': this._onPanTransitionEnd
	  			}, this);
	  		}
	
	  		// don't fire movestart if animating inertia
	  		if (!options.noMoveStart) {
	  			this.fire('movestart');
	  		}
	
	  		// animate pan unless animate: false specified
	  		if (options.animate !== false) {
	  			addClass(this._mapPane, 'leaflet-pan-anim');
	
	  			var newPos = this._getMapPanePos().subtract(offset).round();
	  			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
	  		} else {
	  			this._rawPanBy(offset);
	  			this.fire('move').fire('moveend');
	  		}
	
	  		return this;
	  	},
	
	  	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	  	// Sets the view of the map (geographical center and zoom) performing a smooth
	  	// pan-zoom animation.
	  	flyTo: function (targetCenter, targetZoom, options) {
	
	  		options = options || {};
	  		if (options.animate === false || !any3d) {
	  			return this.setView(targetCenter, targetZoom, options);
	  		}
	
	  		this._stop();
	
	  		var from = this.project(this.getCenter()),
	  		    to = this.project(targetCenter),
	  		    size = this.getSize(),
	  		    startZoom = this._zoom;
	
	  		targetCenter = toLatLng(targetCenter);
	  		targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
	  		var w0 = Math.max(size.x, size.y),
	  		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
	  		    u1 = (to.distanceTo(from)) || 1,
	  		    rho = 1.42,
	  		    rho2 = rho * rho;
	
	  		function r(i) {
	  			var s1 = i ? -1 : 1,
	  			    s2 = i ? w1 : w0,
	  			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
	  			    b1 = 2 * s2 * rho2 * u1,
	  			    b = t1 / b1,
	  			    sq = Math.sqrt(b * b + 1) - b;
	
	  			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
	  			    // thus triggering an infinite loop in flyTo
	  			    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
	  			return log;
	  		}
	
	  		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
	  		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
	  		function tanh(n) { return sinh(n) / cosh(n); }
	
	  		var r0 = r(0);
	
	  		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
	  		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
	  		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
	  		var start = Date.now(),
	  		    S = (r(1) - r0) / rho,
	  		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
	  		function frame() {
	  			var t = (Date.now() - start) / duration,
	  			    s = easeOut(t) * S;
	
	  			if (t <= 1) {
	  				this._flyToFrame = requestAnimFrame(frame, this);
	
	  				this._move(
	  					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
	  					this.getScaleZoom(w0 / w(s), startZoom),
	  					{flyTo: true});
	
	  			} else {
	  				this
	  					._move(targetCenter, targetZoom)
	  					._moveEnd(true);
	  			}
	  		}
	
	  		this._moveStart(true, options.noMoveStart);
	
	  		frame.call(this);
	  		return this;
	  	},
	
	  	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	  	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	  	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	  	flyToBounds: function (bounds, options) {
	  		var target = this._getBoundsCenterZoom(bounds, options);
	  		return this.flyTo(target.center, target.zoom, options);
	  	},
	
	  	// @method setMaxBounds(bounds: LatLngBounds): this
	  	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	  	setMaxBounds: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		if (!bounds.isValid()) {
	  			this.options.maxBounds = null;
	  			return this.off('moveend', this._panInsideMaxBounds);
	  		} else if (this.options.maxBounds) {
	  			this.off('moveend', this._panInsideMaxBounds);
	  		}
	
	  		this.options.maxBounds = bounds;
	
	  		if (this._loaded) {
	  			this._panInsideMaxBounds();
	  		}
	
	  		return this.on('moveend', this._panInsideMaxBounds);
	  	},
	
	  	// @method setMinZoom(zoom: Number): this
	  	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	  	setMinZoom: function (zoom) {
	  		var oldZoom = this.options.minZoom;
	  		this.options.minZoom = zoom;
	
	  		if (this._loaded && oldZoom !== zoom) {
	  			this.fire('zoomlevelschange');
	
	  			if (this.getZoom() < this.options.minZoom) {
	  				return this.setZoom(zoom);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method setMaxZoom(zoom: Number): this
	  	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	  	setMaxZoom: function (zoom) {
	  		var oldZoom = this.options.maxZoom;
	  		this.options.maxZoom = zoom;
	
	  		if (this._loaded && oldZoom !== zoom) {
	  			this.fire('zoomlevelschange');
	
	  			if (this.getZoom() > this.options.maxZoom) {
	  				return this.setZoom(zoom);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	  	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	  	panInsideBounds: function (bounds, options) {
	  		this._enforcingBounds = true;
	  		var center = this.getCenter(),
	  		    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
	  		if (!center.equals(newCenter)) {
	  			this.panTo(newCenter, options);
	  		}
	
	  		this._enforcingBounds = false;
	  		return this;
	  	},
	
	  	// @method panInside(latlng: LatLng, options?: options): this
	  	// Pans the map the minimum amount to make the `latlng` visible. Use
	  	// `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
	  	// the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
	  	// If `latlng` is already within the (optionally padded) display bounds,
	  	// the map will not be panned.
	  	panInside: function (latlng, options) {
	  		options = options || {};
	
	  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	  		    center = this.getCenter(),
	  		    pixelCenter = this.project(center),
	  		    pixelPoint = this.project(latlng),
	  		    pixelBounds = this.getPixelBounds(),
	  		    halfPixelBounds = pixelBounds.getSize().divideBy(2),
	  		    paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]);
	
	  		if (!paddedBounds.contains(pixelPoint)) {
	  			this._enforcingBounds = true;
	  			var diff = pixelCenter.subtract(pixelPoint),
	  			    newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);
	
	  			if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
	  				newCenter.x = pixelCenter.x - diff.x;
	  				if (diff.x > 0) {
	  					newCenter.x += halfPixelBounds.x - paddingTL.x;
	  				} else {
	  					newCenter.x -= halfPixelBounds.x - paddingBR.x;
	  				}
	  			}
	  			if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
	  				newCenter.y = pixelCenter.y - diff.y;
	  				if (diff.y > 0) {
	  					newCenter.y += halfPixelBounds.y - paddingTL.y;
	  				} else {
	  					newCenter.y -= halfPixelBounds.y - paddingBR.y;
	  				}
	  			}
	  			this.panTo(this.unproject(newCenter), options);
	  			this._enforcingBounds = false;
	  		}
	  		return this;
	  	},
	
	  	// @method invalidateSize(options: Zoom/pan options): this
	  	// Checks if the map container size changed and updates the map if so —
	  	// call it after you've changed the map size dynamically, also animating
	  	// pan by default. If `options.pan` is `false`, panning will not occur.
	  	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	  	// that it doesn't happen often even if the method is called many
	  	// times in a row.
	
	  	// @alternative
	  	// @method invalidateSize(animate: Boolean): this
	  	// Checks if the map container size changed and updates the map if so —
	  	// call it after you've changed the map size dynamically, also animating
	  	// pan by default.
	  	invalidateSize: function (options) {
	  		if (!this._loaded) { return this; }
	
	  		options = extend({
	  			animate: false,
	  			pan: true
	  		}, options === true ? {animate: true} : options);
	
	  		var oldSize = this.getSize();
	  		this._sizeChanged = true;
	  		this._lastCenter = null;
	
	  		var newSize = this.getSize(),
	  		    oldCenter = oldSize.divideBy(2).round(),
	  		    newCenter = newSize.divideBy(2).round(),
	  		    offset = oldCenter.subtract(newCenter);
	
	  		if (!offset.x && !offset.y) { return this; }
	
	  		if (options.animate && options.pan) {
	  			this.panBy(offset);
	
	  		} else {
	  			if (options.pan) {
	  				this._rawPanBy(offset);
	  			}
	
	  			this.fire('move');
	
	  			if (options.debounceMoveend) {
	  				clearTimeout(this._sizeTimer);
	  				this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
	  			} else {
	  				this.fire('moveend');
	  			}
	  		}
	
	  		// @section Map state change events
	  		// @event resize: ResizeEvent
	  		// Fired when the map is resized.
	  		return this.fire('resize', {
	  			oldSize: oldSize,
	  			newSize: newSize
	  		});
	  	},
	
	  	// @section Methods for modifying map state
	  	// @method stop(): this
	  	// Stops the currently running `panTo` or `flyTo` animation, if any.
	  	stop: function () {
	  		this.setZoom(this._limitZoom(this._zoom));
	  		if (!this.options.zoomSnap) {
	  			this.fire('viewreset');
	  		}
	  		return this._stop();
	  	},
	
	  	// @section Geolocation methods
	  	// @method locate(options?: Locate options): this
	  	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	  	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	  	// and optionally sets the map view to the user's location with respect to
	  	// detection accuracy (or to the world view if geolocation failed).
	  	// Note that, if your page doesn't use HTTPS, this method will fail in
	  	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	  	// See `Locate options` for more details.
	  	locate: function (options) {
	
	  		options = this._locateOptions = extend({
	  			timeout: 10000,
	  			watch: false
	  			// setView: false
	  			// maxZoom: <Number>
	  			// maximumAge: 0
	  			// enableHighAccuracy: false
	  		}, options);
	
	  		if (!('geolocation' in navigator)) {
	  			this._handleGeolocationError({
	  				code: 0,
	  				message: 'Geolocation not supported.'
	  			});
	  			return this;
	  		}
	
	  		var onResponse = bind(this._handleGeolocationResponse, this),
	  		    onError = bind(this._handleGeolocationError, this);
	
	  		if (options.watch) {
	  			this._locationWatchId =
	  			        navigator.geolocation.watchPosition(onResponse, onError, options);
	  		} else {
	  			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
	  		}
	  		return this;
	  	},
	
	  	// @method stopLocate(): this
	  	// Stops watching location previously initiated by `map.locate({watch: true})`
	  	// and aborts resetting the map view if map.locate was called with
	  	// `{setView: true}`.
	  	stopLocate: function () {
	  		if (navigator.geolocation && navigator.geolocation.clearWatch) {
	  			navigator.geolocation.clearWatch(this._locationWatchId);
	  		}
	  		if (this._locateOptions) {
	  			this._locateOptions.setView = false;
	  		}
	  		return this;
	  	},
	
	  	_handleGeolocationError: function (error) {
	  		var c = error.code,
	  		    message = error.message ||
	  		            (c === 1 ? 'permission denied' :
	  		            (c === 2 ? 'position unavailable' : 'timeout'));
	
	  		if (this._locateOptions.setView && !this._loaded) {
	  			this.fitWorld();
	  		}
	
	  		// @section Location events
	  		// @event locationerror: ErrorEvent
	  		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
	  		this.fire('locationerror', {
	  			code: c,
	  			message: 'Geolocation error: ' + message + '.'
	  		});
	  	},
	
	  	_handleGeolocationResponse: function (pos) {
	  		var lat = pos.coords.latitude,
	  		    lng = pos.coords.longitude,
	  		    latlng = new LatLng(lat, lng),
	  		    bounds = latlng.toBounds(pos.coords.accuracy * 2),
	  		    options = this._locateOptions;
	
	  		if (options.setView) {
	  			var zoom = this.getBoundsZoom(bounds);
	  			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
	  		}
	
	  		var data = {
	  			latlng: latlng,
	  			bounds: bounds,
	  			timestamp: pos.timestamp
	  		};
	
	  		for (var i in pos.coords) {
	  			if (typeof pos.coords[i] === 'number') {
	  				data[i] = pos.coords[i];
	  			}
	  		}
	
	  		// @event locationfound: LocationEvent
	  		// Fired when geolocation (using the [`locate`](#map-locate) method)
	  		// went successfully.
	  		this.fire('locationfound', data);
	  	},
	
	  	// TODO Appropriate docs section?
	  	// @section Other Methods
	  	// @method addHandler(name: String, HandlerClass: Function): this
	  	// Adds a new `Handler` to the map, given its name and constructor function.
	  	addHandler: function (name, HandlerClass) {
	  		if (!HandlerClass) { return this; }
	
	  		var handler = this[name] = new HandlerClass(this);
	
	  		this._handlers.push(handler);
	
	  		if (this.options[name]) {
	  			handler.enable();
	  		}
	
	  		return this;
	  	},
	
	  	// @method remove(): this
	  	// Destroys the map and clears all related event listeners.
	  	remove: function () {
	
	  		this._initEvents(true);
	  		this.off('moveend', this._panInsideMaxBounds);
	
	  		if (this._containerId !== this._container._leaflet_id) {
	  			throw new Error('Map container is being reused by another instance');
	  		}
	
	  		try {
	  			// throws error in IE6-8
	  			delete this._container._leaflet_id;
	  			delete this._containerId;
	  		} catch (e) {
	  			/*eslint-disable */
	  			this._container._leaflet_id = undefined;
	  			/* eslint-enable */
	  			this._containerId = undefined;
	  		}
	
	  		if (this._locationWatchId !== undefined) {
	  			this.stopLocate();
	  		}
	
	  		this._stop();
	
	  		remove(this._mapPane);
	
	  		if (this._clearControlPos) {
	  			this._clearControlPos();
	  		}
	  		if (this._resizeRequest) {
	  			cancelAnimFrame(this._resizeRequest);
	  			this._resizeRequest = null;
	  		}
	
	  		this._clearHandlers();
	
	  		if (this._loaded) {
	  			// @section Map state change events
	  			// @event unload: Event
	  			// Fired when the map is destroyed with [remove](#map-remove) method.
	  			this.fire('unload');
	  		}
	
	  		var i;
	  		for (i in this._layers) {
	  			this._layers[i].remove();
	  		}
	  		for (i in this._panes) {
	  			remove(this._panes[i]);
	  		}
	
	  		this._layers = [];
	  		this._panes = [];
	  		delete this._mapPane;
	  		delete this._renderer;
	
	  		return this;
	  	},
	
	  	// @section Other Methods
	  	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	  	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	  	// then returns it. The pane is created as a child of `container`, or
	  	// as a child of the main map pane if not set.
	  	createPane: function (name, container) {
	  		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
	  		    pane = create$1('div', className, container || this._mapPane);
	
	  		if (name) {
	  			this._panes[name] = pane;
	  		}
	  		return pane;
	  	},
	
	  	// @section Methods for Getting Map State
	
	  	// @method getCenter(): LatLng
	  	// Returns the geographical center of the map view
	  	getCenter: function () {
	  		this._checkIfLoaded();
	
	  		if (this._lastCenter && !this._moved()) {
	  			return this._lastCenter;
	  		}
	  		return this.layerPointToLatLng(this._getCenterLayerPoint());
	  	},
	
	  	// @method getZoom(): Number
	  	// Returns the current zoom level of the map view
	  	getZoom: function () {
	  		return this._zoom;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the geographical bounds visible in the current map view
	  	getBounds: function () {
	  		var bounds = this.getPixelBounds(),
	  		    sw = this.unproject(bounds.getBottomLeft()),
	  		    ne = this.unproject(bounds.getTopRight());
	
	  		return new LatLngBounds(sw, ne);
	  	},
	
	  	// @method getMinZoom(): Number
	  	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	  	getMinZoom: function () {
	  		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	  	},
	
	  	// @method getMaxZoom(): Number
	  	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	  	getMaxZoom: function () {
	  		return this.options.maxZoom === undefined ?
	  			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
	  			this.options.maxZoom;
	  	},
	
	  	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
	  	// Returns the maximum zoom level on which the given bounds fit to the map
	  	// view in its entirety. If `inside` (optional) is set to `true`, the method
	  	// instead returns the minimum zoom level on which the map view fits into
	  	// the given bounds in its entirety.
	  	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
	  		bounds = toLatLngBounds(bounds);
	  		padding = toPoint(padding || [0, 0]);
	
	  		var zoom = this.getZoom() || 0,
	  		    min = this.getMinZoom(),
	  		    max = this.getMaxZoom(),
	  		    nw = bounds.getNorthWest(),
	  		    se = bounds.getSouthEast(),
	  		    size = this.getSize().subtract(padding),
	  		    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
	  		    snap = any3d ? this.options.zoomSnap : 1,
	  		    scalex = size.x / boundsSize.x,
	  		    scaley = size.y / boundsSize.y,
	  		    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
	  		zoom = this.getScaleZoom(scale, zoom);
	
	  		if (snap) {
	  			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
	  			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
	  		}
	
	  		return Math.max(min, Math.min(max, zoom));
	  	},
	
	  	// @method getSize(): Point
	  	// Returns the current size of the map container (in pixels).
	  	getSize: function () {
	  		if (!this._size || this._sizeChanged) {
	  			this._size = new Point(
	  				this._container.clientWidth || 0,
	  				this._container.clientHeight || 0);
	
	  			this._sizeChanged = false;
	  		}
	  		return this._size.clone();
	  	},
	
	  	// @method getPixelBounds(): Bounds
	  	// Returns the bounds of the current map view in projected pixel
	  	// coordinates (sometimes useful in layer and overlay implementations).
	  	getPixelBounds: function (center, zoom) {
	  		var topLeftPoint = this._getTopLeftPoint(center, zoom);
	  		return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	  	},
	
	  	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	  	// the map pane? "left point of the map layer" can be confusing, specially
	  	// since there can be negative offsets.
	  	// @method getPixelOrigin(): Point
	  	// Returns the projected pixel coordinates of the top left point of
	  	// the map layer (useful in custom layer and overlay implementations).
	  	getPixelOrigin: function () {
	  		this._checkIfLoaded();
	  		return this._pixelOrigin;
	  	},
	
	  	// @method getPixelWorldBounds(zoom?: Number): Bounds
	  	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	  	// If `zoom` is omitted, the map's current zoom level is used.
	  	getPixelWorldBounds: function (zoom) {
	  		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	  	},
	
	  	// @section Other Methods
	
	  	// @method getPane(pane: String|HTMLElement): HTMLElement
	  	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	  	getPane: function (pane) {
	  		return typeof pane === 'string' ? this._panes[pane] : pane;
	  	},
	
	  	// @method getPanes(): Object
	  	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	  	// the panes as values.
	  	getPanes: function () {
	  		return this._panes;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTML element that contains the map.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	
	  	// @section Conversion Methods
	
	  	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	  	// Returns the scale factor to be applied to a map transition from zoom level
	  	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	  	getZoomScale: function (toZoom, fromZoom) {
	  		// TODO replace with universal implementation after refactoring projections
	  		var crs = this.options.crs;
	  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	  		return crs.scale(toZoom) / crs.scale(fromZoom);
	  	},
	
	  	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	  	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	  	// level and everything is scaled by a factor of `scale`. Inverse of
	  	// [`getZoomScale`](#map-getZoomScale).
	  	getScaleZoom: function (scale, fromZoom) {
	  		var crs = this.options.crs;
	  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	  		var zoom = crs.zoom(scale * crs.scale(fromZoom));
	  		return isNaN(zoom) ? Infinity : zoom;
	  	},
	
	  	// @method project(latlng: LatLng, zoom: Number): Point
	  	// Projects a geographical coordinate `LatLng` according to the projection
	  	// of the map's CRS, then scales it according to `zoom` and the CRS's
	  	// `Transformation`. The result is pixel coordinate relative to
	  	// the CRS origin.
	  	project: function (latlng, zoom) {
	  		zoom = zoom === undefined ? this._zoom : zoom;
	  		return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
	  	},
	
	  	// @method unproject(point: Point, zoom: Number): LatLng
	  	// Inverse of [`project`](#map-project).
	  	unproject: function (point, zoom) {
	  		zoom = zoom === undefined ? this._zoom : zoom;
	  		return this.options.crs.pointToLatLng(toPoint(point), zoom);
	  	},
	
	  	// @method layerPointToLatLng(point: Point): LatLng
	  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	  	// returns the corresponding geographical coordinate (for the current zoom level).
	  	layerPointToLatLng: function (point) {
	  		var projectedPoint = toPoint(point).add(this.getPixelOrigin());
	  		return this.unproject(projectedPoint);
	  	},
	
	  	// @method latLngToLayerPoint(latlng: LatLng): Point
	  	// Given a geographical coordinate, returns the corresponding pixel coordinate
	  	// relative to the [origin pixel](#map-getpixelorigin).
	  	latLngToLayerPoint: function (latlng) {
	  		var projectedPoint = this.project(toLatLng(latlng))._round();
	  		return projectedPoint._subtract(this.getPixelOrigin());
	  	},
	
	  	// @method wrapLatLng(latlng: LatLng): LatLng
	  	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	  	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	  	// CRS's bounds.
	  	// By default this means longitude is wrapped around the dateline so its
	  	// value is between -180 and +180 degrees.
	  	wrapLatLng: function (latlng) {
	  		return this.options.crs.wrapLatLng(toLatLng(latlng));
	  	},
	
	  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	  	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
	  	// its center is within the CRS's bounds.
	  	// By default this means the center longitude is wrapped around the dateline so its
	  	// value is between -180 and +180 degrees, and the majority of the bounds
	  	// overlaps the CRS's bounds.
	  	wrapLatLngBounds: function (latlng) {
	  		return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
	  	},
	
	  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	  	// Returns the distance between two geographical coordinates according to
	  	// the map's CRS. By default this measures distance in meters.
	  	distance: function (latlng1, latlng2) {
	  		return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
	  	},
	
	  	// @method containerPointToLayerPoint(point: Point): Point
	  	// Given a pixel coordinate relative to the map container, returns the corresponding
	  	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	  	containerPointToLayerPoint: function (point) { // (Point)
	  		return toPoint(point).subtract(this._getMapPanePos());
	  	},
	
	  	// @method layerPointToContainerPoint(point: Point): Point
	  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	  	// returns the corresponding pixel coordinate relative to the map container.
	  	layerPointToContainerPoint: function (point) { // (Point)
	  		return toPoint(point).add(this._getMapPanePos());
	  	},
	
	  	// @method containerPointToLatLng(point: Point): LatLng
	  	// Given a pixel coordinate relative to the map container, returns
	  	// the corresponding geographical coordinate (for the current zoom level).
	  	containerPointToLatLng: function (point) {
	  		var layerPoint = this.containerPointToLayerPoint(toPoint(point));
	  		return this.layerPointToLatLng(layerPoint);
	  	},
	
	  	// @method latLngToContainerPoint(latlng: LatLng): Point
	  	// Given a geographical coordinate, returns the corresponding pixel coordinate
	  	// relative to the map container.
	  	latLngToContainerPoint: function (latlng) {
	  		return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
	  	},
	
	  	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	  	// Given a MouseEvent object, returns the pixel coordinate relative to the
	  	// map container where the event took place.
	  	mouseEventToContainerPoint: function (e) {
	  		return getMousePosition(e, this._container);
	  	},
	
	  	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	  	// Given a MouseEvent object, returns the pixel coordinate relative to
	  	// the [origin pixel](#map-getpixelorigin) where the event took place.
	  	mouseEventToLayerPoint: function (e) {
	  		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	  	},
	
	  	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	  	// Given a MouseEvent object, returns geographical coordinate where the
	  	// event took place.
	  	mouseEventToLatLng: function (e) { // (MouseEvent)
	  		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	  	},
	
	
	  	// map initialization methods
	
	  	_initContainer: function (id) {
	  		var container = this._container = get(id);
	
	  		if (!container) {
	  			throw new Error('Map container not found.');
	  		} else if (container._leaflet_id) {
	  			throw new Error('Map container is already initialized.');
	  		}
	
	  		on(container, 'scroll', this._onScroll, this);
	  		this._containerId = stamp(container);
	  	},
	
	  	_initLayout: function () {
	  		var container = this._container;
	
	  		this._fadeAnimated = this.options.fadeAnimation && any3d;
	
	  		addClass(container, 'leaflet-container' +
	  			(touch ? ' leaflet-touch' : '') +
	  			(retina ? ' leaflet-retina' : '') +
	  			(ielt9 ? ' leaflet-oldie' : '') +
	  			(safari ? ' leaflet-safari' : '') +
	  			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
	  		var position = getStyle(container, 'position');
	
	  		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
	  			container.style.position = 'relative';
	  		}
	
	  		this._initPanes();
	
	  		if (this._initControlPos) {
	  			this._initControlPos();
	  		}
	  	},
	
	  	_initPanes: function () {
	  		var panes = this._panes = {};
	  		this._paneRenderers = {};
	
	  		// @section
	  		//
	  		// Panes are DOM elements used to control the ordering of layers on the map. You
	  		// can access panes with [`map.getPane`](#map-getpane) or
	  		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
	  		// [`map.createPane`](#map-createpane) method.
	  		//
	  		// Every map has the following default panes that differ only in zIndex.
	  		//
	  		// @pane mapPane: HTMLElement = 'auto'
	  		// Pane that contains all other map panes
	
	  		this._mapPane = this.createPane('mapPane', this._container);
	  		setPosition(this._mapPane, new Point(0, 0));
	
	  		// @pane tilePane: HTMLElement = 200
	  		// Pane for `GridLayer`s and `TileLayer`s
	  		this.createPane('tilePane');
	  		// @pane overlayPane: HTMLElement = 400
	  		// Pane for overlay shadows (e.g. `Marker` shadows)
	  		this.createPane('shadowPane');
	  		// @pane shadowPane: HTMLElement = 500
	  		// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
	  		this.createPane('overlayPane');
	  		// @pane markerPane: HTMLElement = 600
	  		// Pane for `Icon`s of `Marker`s
	  		this.createPane('markerPane');
	  		// @pane tooltipPane: HTMLElement = 650
	  		// Pane for `Tooltip`s.
	  		this.createPane('tooltipPane');
	  		// @pane popupPane: HTMLElement = 700
	  		// Pane for `Popup`s.
	  		this.createPane('popupPane');
	
	  		if (!this.options.markerZoomAnimation) {
	  			addClass(panes.markerPane, 'leaflet-zoom-hide');
	  			addClass(panes.shadowPane, 'leaflet-zoom-hide');
	  		}
	  	},
	
	
	  	// private methods that modify map state
	
	  	// @section Map state change events
	  	_resetView: function (center, zoom) {
	  		setPosition(this._mapPane, new Point(0, 0));
	
	  		var loading = !this._loaded;
	  		this._loaded = true;
	  		zoom = this._limitZoom(zoom);
	
	  		this.fire('viewprereset');
	
	  		var zoomChanged = this._zoom !== zoom;
	  		this
	  			._moveStart(zoomChanged, false)
	  			._move(center, zoom)
	  			._moveEnd(zoomChanged);
	
	  		// @event viewreset: Event
	  		// Fired when the map needs to redraw its content (this usually happens
	  		// on map zoom or load). Very useful for creating custom overlays.
	  		this.fire('viewreset');
	
	  		// @event load: Event
	  		// Fired when the map is initialized (when its center and zoom are set
	  		// for the first time).
	  		if (loading) {
	  			this.fire('load');
	  		}
	  	},
	
	  	_moveStart: function (zoomChanged, noMoveStart) {
	  		// @event zoomstart: Event
	  		// Fired when the map zoom is about to change (e.g. before zoom animation).
	  		// @event movestart: Event
	  		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
	  		if (zoomChanged) {
	  			this.fire('zoomstart');
	  		}
	  		if (!noMoveStart) {
	  			this.fire('movestart');
	  		}
	  		return this;
	  	},
	
	  	_move: function (center, zoom, data) {
	  		if (zoom === undefined) {
	  			zoom = this._zoom;
	  		}
	  		var zoomChanged = this._zoom !== zoom;
	
	  		this._zoom = zoom;
	  		this._lastCenter = center;
	  		this._pixelOrigin = this._getNewPixelOrigin(center);
	
	  		// @event zoom: Event
	  		// Fired repeatedly during any change in zoom level, including zoom
	  		// and fly animations.
	  		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
	  			this.fire('zoom', data);
	  		}
	
	  		// @event move: Event
	  		// Fired repeatedly during any movement of the map, including pan and
	  		// fly animations.
	  		return this.fire('move', data);
	  	},
	
	  	_moveEnd: function (zoomChanged) {
	  		// @event zoomend: Event
	  		// Fired when the map has changed, after any animations.
	  		if (zoomChanged) {
	  			this.fire('zoomend');
	  		}
	
	  		// @event moveend: Event
	  		// Fired when the center of the map stops changing (e.g. user stopped
	  		// dragging the map).
	  		return this.fire('moveend');
	  	},
	
	  	_stop: function () {
	  		cancelAnimFrame(this._flyToFrame);
	  		if (this._panAnim) {
	  			this._panAnim.stop();
	  		}
	  		return this;
	  	},
	
	  	_rawPanBy: function (offset) {
	  		setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	  	},
	
	  	_getZoomSpan: function () {
	  		return this.getMaxZoom() - this.getMinZoom();
	  	},
	
	  	_panInsideMaxBounds: function () {
	  		if (!this._enforcingBounds) {
	  			this.panInsideBounds(this.options.maxBounds);
	  		}
	  	},
	
	  	_checkIfLoaded: function () {
	  		if (!this._loaded) {
	  			throw new Error('Set map center and zoom first.');
	  		}
	  	},
	
	  	// DOM event handling
	
	  	// @section Interaction events
	  	_initEvents: function (remove$$1) {
	  		this._targets = {};
	  		this._targets[stamp(this._container)] = this;
	
	  		var onOff = remove$$1 ? off : on;
	
	  		// @event click: MouseEvent
	  		// Fired when the user clicks (or taps) the map.
	  		// @event dblclick: MouseEvent
	  		// Fired when the user double-clicks (or double-taps) the map.
	  		// @event mousedown: MouseEvent
	  		// Fired when the user pushes the mouse button on the map.
	  		// @event mouseup: MouseEvent
	  		// Fired when the user releases the mouse button on the map.
	  		// @event mouseover: MouseEvent
	  		// Fired when the mouse enters the map.
	  		// @event mouseout: MouseEvent
	  		// Fired when the mouse leaves the map.
	  		// @event mousemove: MouseEvent
	  		// Fired while the mouse moves over the map.
	  		// @event contextmenu: MouseEvent
	  		// Fired when the user pushes the right mouse button on the map, prevents
	  		// default browser context menu from showing if there are listeners on
	  		// this event. Also fired on mobile when the user holds a single touch
	  		// for a second (also called long press).
	  		// @event keypress: KeyboardEvent
	  		// Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
	  		// @event keydown: KeyboardEvent
	  		// Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
	  		// the `keydown` event is fired for keys that produce a character value and for keys
	  		// that do not produce a character value.
	  		// @event keyup: KeyboardEvent
	  		// Fired when the user releases a key from the keyboard while the map is focused.
	  		onOff(this._container, 'click dblclick mousedown mouseup ' +
	  			'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);
	
	  		if (this.options.trackResize) {
	  			onOff(window, 'resize', this._onResize, this);
	  		}
	
	  		if (any3d && this.options.transform3DLimit) {
	  			(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
	  		}
	  	},
	
	  	_onResize: function () {
	  		cancelAnimFrame(this._resizeRequest);
	  		this._resizeRequest = requestAnimFrame(
	  		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	  	},
	
	  	_onScroll: function () {
	  		this._container.scrollTop  = 0;
	  		this._container.scrollLeft = 0;
	  	},
	
	  	_onMoveEnd: function () {
	  		var pos = this._getMapPanePos();
	  		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
	  			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
	  			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
	  			this._resetView(this.getCenter(), this.getZoom());
	  		}
	  	},
	
	  	_findEventTargets: function (e, type) {
	  		var targets = [],
	  		    target,
	  		    isHover = type === 'mouseout' || type === 'mouseover',
	  		    src = e.target || e.srcElement,
	  		    dragging = false;
	
	  		while (src) {
	  			target = this._targets[stamp(src)];
	  			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
	  				// Prevent firing click after you just dragged an object.
	  				dragging = true;
	  				break;
	  			}
	  			if (target && target.listens(type, true)) {
	  				if (isHover && !isExternalTarget(src, e)) { break; }
	  				targets.push(target);
	  				if (isHover) { break; }
	  			}
	  			if (src === this._container) { break; }
	  			src = src.parentNode;
	  		}
	  		if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
	  			targets = [this];
	  		}
	  		return targets;
	  	},
	
	  	_handleDOMEvent: function (e) {
	  		if (!this._loaded || skipped(e)) { return; }
	
	  		var type = e.type;
	
	  		if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') {
	  			// prevents outline when clicking on keyboard-focusable element
	  			preventOutline(e.target || e.srcElement);
	  		}
	
	  		this._fireDOMEvent(e, type);
	  	},
	
	  	_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
	  	_fireDOMEvent: function (e, type, targets) {
	
	  		if (e.type === 'click') {
	  			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
	  			// @event preclick: MouseEvent
	  			// Fired before mouse click on the map (sometimes useful when you
	  			// want something to happen on click before any existing click
	  			// handlers start running).
	  			var synth = extend({}, e);
	  			synth.type = 'preclick';
	  			this._fireDOMEvent(synth, synth.type, targets);
	  		}
	
	  		if (e._stopped) { return; }
	
	  		// Find the layer the event is propagating from and its parents.
	  		targets = (targets || []).concat(this._findEventTargets(e, type));
	
	  		if (!targets.length) { return; }
	
	  		var target = targets[0];
	  		if (type === 'contextmenu' && target.listens(type, true)) {
	  			preventDefault(e);
	  		}
	
	  		var data = {
	  			originalEvent: e
	  		};
	
	  		if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
	  			var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
	  			data.containerPoint = isMarker ?
	  				this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
	  			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
	  			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
	  		}
	
	  		for (var i = 0; i < targets.length; i++) {
	  			targets[i].fire(type, data, true);
	  			if (data.originalEvent._stopped ||
	  				(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
	  		}
	  	},
	
	  	_draggableMoved: function (obj) {
	  		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
	  		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	  	},
	
	  	_clearHandlers: function () {
	  		for (var i = 0, len = this._handlers.length; i < len; i++) {
	  			this._handlers[i].disable();
	  		}
	  	},
	
	  	// @section Other Methods
	
	  	// @method whenReady(fn: Function, context?: Object): this
	  	// Runs the given function `fn` when the map gets initialized with
	  	// a view (center and zoom) and at least one layer, or immediately
	  	// if it's already initialized, optionally passing a function context.
	  	whenReady: function (callback, context) {
	  		if (this._loaded) {
	  			callback.call(context || this, {target: this});
	  		} else {
	  			this.on('load', callback, context);
	  		}
	  		return this;
	  	},
	
	
	  	// private methods for getting map state
	
	  	_getMapPanePos: function () {
	  		return getPosition(this._mapPane) || new Point(0, 0);
	  	},
	
	  	_moved: function () {
	  		var pos = this._getMapPanePos();
	  		return pos && !pos.equals([0, 0]);
	  	},
	
	  	_getTopLeftPoint: function (center, zoom) {
	  		var pixelOrigin = center && zoom !== undefined ?
	  			this._getNewPixelOrigin(center, zoom) :
	  			this.getPixelOrigin();
	  		return pixelOrigin.subtract(this._getMapPanePos());
	  	},
	
	  	_getNewPixelOrigin: function (center, zoom) {
	  		var viewHalf = this.getSize()._divideBy(2);
	  		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	  	},
	
	  	_latLngToNewLayerPoint: function (latlng, zoom, center) {
	  		var topLeft = this._getNewPixelOrigin(center, zoom);
	  		return this.project(latlng, zoom)._subtract(topLeft);
	  	},
	
	  	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
	  		var topLeft = this._getNewPixelOrigin(center, zoom);
	  		return toBounds([
	  			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
	  		]);
	  	},
	
	  	// layer point of the current center
	  	_getCenterLayerPoint: function () {
	  		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	  	},
	
	  	// offset of the specified place to the current center in pixels
	  	_getCenterOffset: function (latlng) {
	  		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	  	},
	
	  	// adjust center for view to get inside bounds
	  	_limitCenter: function (center, zoom, bounds) {
	
	  		if (!bounds) { return center; }
	
	  		var centerPoint = this.project(center, zoom),
	  		    viewHalf = this.getSize().divideBy(2),
	  		    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
	  		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
	  		// If offset is less than a pixel, ignore.
	  		// This prevents unstable projections from getting into
	  		// an infinite loop of tiny offsets.
	  		if (offset.round().equals([0, 0])) {
	  			return center;
	  		}
	
	  		return this.unproject(centerPoint.add(offset), zoom);
	  	},
	
	  	// adjust offset for view to get inside bounds
	  	_limitOffset: function (offset, bounds) {
	  		if (!bounds) { return offset; }
	
	  		var viewBounds = this.getPixelBounds(),
	  		    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
	  		return offset.add(this._getBoundsOffset(newBounds, bounds));
	  	},
	
	  	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	  	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
	  		var projectedMaxBounds = toBounds(
	  		        this.project(maxBounds.getNorthEast(), zoom),
	  		        this.project(maxBounds.getSouthWest(), zoom)
	  		    ),
	  		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
	  		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
	  		    dx = this._rebound(minOffset.x, -maxOffset.x),
	  		    dy = this._rebound(minOffset.y, -maxOffset.y);
	
	  		return new Point(dx, dy);
	  	},
	
	  	_rebound: function (left, right) {
	  		return left + right > 0 ?
	  			Math.round(left - right) / 2 :
	  			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	  	},
	
	  	_limitZoom: function (zoom) {
	  		var min = this.getMinZoom(),
	  		    max = this.getMaxZoom(),
	  		    snap = any3d ? this.options.zoomSnap : 1;
	  		if (snap) {
	  			zoom = Math.round(zoom / snap) * snap;
	  		}
	  		return Math.max(min, Math.min(max, zoom));
	  	},
	
	  	_onPanTransitionStep: function () {
	  		this.fire('move');
	  	},
	
	  	_onPanTransitionEnd: function () {
	  		removeClass(this._mapPane, 'leaflet-pan-anim');
	  		this.fire('moveend');
	  	},
	
	  	_tryAnimatedPan: function (center, options) {
	  		// difference between the new and current centers in pixels
	  		var offset = this._getCenterOffset(center)._trunc();
	
	  		// don't animate too far unless animate: true specified in options
	  		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
	  		this.panBy(offset, options);
	
	  		return true;
	  	},
	
	  	_createAnimProxy: function () {
	
	  		var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
	  		this._panes.mapPane.appendChild(proxy);
	
	  		this.on('zoomanim', function (e) {
	  			var prop = TRANSFORM,
	  			    transform = this._proxy.style[prop];
	
	  			setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
	  			// workaround for case when transform is the same and so transitionend event is not fired
	  			if (transform === this._proxy.style[prop] && this._animatingZoom) {
	  				this._onZoomTransitionEnd();
	  			}
	  		}, this);
	
	  		this.on('load moveend', this._animMoveEnd, this);
	
	  		this._on('unload', this._destroyAnimProxy, this);
	  	},
	
	  	_destroyAnimProxy: function () {
	  		remove(this._proxy);
	  		this.off('load moveend', this._animMoveEnd, this);
	  		delete this._proxy;
	  	},
	
	  	_animMoveEnd: function () {
	  		var c = this.getCenter(),
	  		    z = this.getZoom();
	  		setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
	  	},
	
	  	_catchTransitionEnd: function (e) {
	  		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
	  			this._onZoomTransitionEnd();
	  		}
	  	},
	
	  	_nothingToAnimate: function () {
	  		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	  	},
	
	  	_tryAnimatedZoom: function (center, zoom, options) {
	
	  		if (this._animatingZoom) { return true; }
	
	  		options = options || {};
	
	  		// don't animate if disabled, not supported or zoom difference is too large
	  		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
	  		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
	  		// offset is the pixel coords of the zoom origin relative to the current center
	  		var scale = this.getZoomScale(zoom),
	  		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
	  		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
	  		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
	  		requestAnimFrame(function () {
	  			this
	  			    ._moveStart(true, false)
	  			    ._animateZoom(center, zoom, true);
	  		}, this);
	
	  		return true;
	  	},
	
	  	_animateZoom: function (center, zoom, startAnim, noUpdate) {
	  		if (!this._mapPane) { return; }
	
	  		if (startAnim) {
	  			this._animatingZoom = true;
	
	  			// remember what center/zoom to set after animation
	  			this._animateToCenter = center;
	  			this._animateToZoom = zoom;
	
	  			addClass(this._mapPane, 'leaflet-zoom-anim');
	  		}
	
	  		// @section Other Events
	  		// @event zoomanim: ZoomAnimEvent
	  		// Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
	  		this.fire('zoomanim', {
	  			center: center,
	  			zoom: zoom,
	  			noUpdate: noUpdate
	  		});
	
	  		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
	  		setTimeout(bind(this._onZoomTransitionEnd, this), 250);
	  	},
	
	  	_onZoomTransitionEnd: function () {
	  		if (!this._animatingZoom) { return; }
	
	  		if (this._mapPane) {
	  			removeClass(this._mapPane, 'leaflet-zoom-anim');
	  		}
	
	  		this._animatingZoom = false;
	
	  		this._move(this._animateToCenter, this._animateToZoom);
	
	  		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
	  		requestAnimFrame(function () {
	  			this._moveEnd(true);
	  		}, this);
	  	}
	  });
	
	  // @section
	
	  // @factory L.map(id: String, options?: Map options)
	  // Instantiates a map object given the DOM ID of a `<div>` element
	  // and optionally an object literal with `Map options`.
	  //
	  // @alternative
	  // @factory L.map(el: HTMLElement, options?: Map options)
	  // Instantiates a map object given an instance of a `<div>` HTML element
	  // and optionally an object literal with `Map options`.
	  function createMap(id, options) {
	  	return new Map(id, options);
	  }
	
	  /*
	   * @class Control
	   * @aka L.Control
	   * @inherits Class
	   *
	   * L.Control is a base class for implementing map controls. Handles positioning.
	   * All other controls extend from this class.
	   */
	
	  var Control = Class.extend({
	  	// @section
	  	// @aka Control options
	  	options: {
	  		// @option position: String = 'topright'
	  		// The position of the control (one of the map corners). Possible values are `'topleft'`,
	  		// `'topright'`, `'bottomleft'` or `'bottomright'`
	  		position: 'topright'
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	/* @section
	  	 * Classes extending L.Control will inherit the following methods:
	  	 *
	  	 * @method getPosition: string
	  	 * Returns the position of the control.
	  	 */
	  	getPosition: function () {
	  		return this.options.position;
	  	},
	
	  	// @method setPosition(position: string): this
	  	// Sets the position of the control.
	  	setPosition: function (position) {
	  		var map = this._map;
	
	  		if (map) {
	  			map.removeControl(this);
	  		}
	
	  		this.options.position = position;
	
	  		if (map) {
	  			map.addControl(this);
	  		}
	
	  		return this;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTMLElement that contains the control.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	  	// @method addTo(map: Map): this
	  	// Adds the control to the given map.
	  	addTo: function (map) {
	  		this.remove();
	  		this._map = map;
	
	  		var container = this._container = this.onAdd(map),
	  		    pos = this.getPosition(),
	  		    corner = map._controlCorners[pos];
	
	  		addClass(container, 'leaflet-control');
	
	  		if (pos.indexOf('bottom') !== -1) {
	  			corner.insertBefore(container, corner.firstChild);
	  		} else {
	  			corner.appendChild(container);
	  		}
	
	  		this._map.on('unload', this.remove, this);
	
	  		return this;
	  	},
	
	  	// @method remove: this
	  	// Removes the control from the map it is currently active on.
	  	remove: function () {
	  		if (!this._map) {
	  			return this;
	  		}
	
	  		remove(this._container);
	
	  		if (this.onRemove) {
	  			this.onRemove(this._map);
	  		}
	
	  		this._map.off('unload', this.remove, this);
	  		this._map = null;
	
	  		return this;
	  	},
	
	  	_refocusOnMap: function (e) {
	  		// if map exists and event is not a keyboard event
	  		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
	  			this._map.getContainer().focus();
	  		}
	  	}
	  });
	
	  var control = function (options) {
	  	return new Control(options);
	  };
	
	  /* @section Extension methods
	   * @uninheritable
	   *
	   * Every control should extend from `L.Control` and (re-)implement the following methods.
	   *
	   * @method onAdd(map: Map): HTMLElement
	   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	   *
	   * @method onRemove(map: Map)
	   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	   */
	
	  /* @namespace Map
	   * @section Methods for Layers and Controls
	   */
	  Map.include({
	  	// @method addControl(control: Control): this
	  	// Adds the given control to the map
	  	addControl: function (control) {
	  		control.addTo(this);
	  		return this;
	  	},
	
	  	// @method removeControl(control: Control): this
	  	// Removes the given control from the map
	  	removeControl: function (control) {
	  		control.remove();
	  		return this;
	  	},
	
	  	_initControlPos: function () {
	  		var corners = this._controlCorners = {},
	  		    l = 'leaflet-',
	  		    container = this._controlContainer =
	  		            create$1('div', l + 'control-container', this._container);
	
	  		function createCorner(vSide, hSide) {
	  			var className = l + vSide + ' ' + l + hSide;
	
	  			corners[vSide + hSide] = create$1('div', className, container);
	  		}
	
	  		createCorner('top', 'left');
	  		createCorner('top', 'right');
	  		createCorner('bottom', 'left');
	  		createCorner('bottom', 'right');
	  	},
	
	  	_clearControlPos: function () {
	  		for (var i in this._controlCorners) {
	  			remove(this._controlCorners[i]);
	  		}
	  		remove(this._controlContainer);
	  		delete this._controlCorners;
	  		delete this._controlContainer;
	  	}
	  });
	
	  /*
	   * @class Control.Layers
	   * @aka L.Control.Layers
	   * @inherits Control
	   *
	   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
	   *
	   * @example
	   *
	   * ```js
	   * var baseLayers = {
	   * 	"Mapbox": mapbox,
	   * 	"OpenStreetMap": osm
	   * };
	   *
	   * var overlays = {
	   * 	"Marker": marker,
	   * 	"Roads": roadsLayer
	   * };
	   *
	   * L.control.layers(baseLayers, overlays).addTo(map);
	   * ```
	   *
	   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	   *
	   * ```js
	   * {
	   *     "<someName1>": layer1,
	   *     "<someName2>": layer2
	   * }
	   * ```
	   *
	   * The layer names can contain HTML, which allows you to add additional styling to the items:
	   *
	   * ```js
	   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	   * ```
	   */
	
	  var Layers = Control.extend({
	  	// @section
	  	// @aka Control.Layers options
	  	options: {
	  		// @option collapsed: Boolean = true
	  		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
	  		collapsed: true,
	  		position: 'topright',
	
	  		// @option autoZIndex: Boolean = true
	  		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
	  		autoZIndex: true,
	
	  		// @option hideSingleBase: Boolean = false
	  		// If `true`, the base layers in the control will be hidden when there is only one.
	  		hideSingleBase: false,
	
	  		// @option sortLayers: Boolean = false
	  		// Whether to sort the layers. When `false`, layers will keep the order
	  		// in which they were added to the control.
	  		sortLayers: false,
	
	  		// @option sortFunction: Function = *
	  		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
	  		// that will be used for sorting the layers, when `sortLayers` is `true`.
	  		// The function receives both the `L.Layer` instances and their names, as in
	  		// `sortFunction(layerA, layerB, nameA, nameB)`.
	  		// By default, it sorts layers alphabetically by their name.
	  		sortFunction: function (layerA, layerB, nameA, nameB) {
	  			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
	  		}
	  	},
	
	  	initialize: function (baseLayers, overlays, options) {
	  		setOptions(this, options);
	
	  		this._layerControlInputs = [];
	  		this._layers = [];
	  		this._lastZIndex = 0;
	  		this._handlingClick = false;
	
	  		for (var i in baseLayers) {
	  			this._addLayer(baseLayers[i], i);
	  		}
	
	  		for (i in overlays) {
	  			this._addLayer(overlays[i], i, true);
	  		}
	  	},
	
	  	onAdd: function (map) {
	  		this._initLayout();
	  		this._update();
	
	  		this._map = map;
	  		map.on('zoomend', this._checkDisabledLayers, this);
	
	  		for (var i = 0; i < this._layers.length; i++) {
	  			this._layers[i].layer.on('add remove', this._onLayerChange, this);
	  		}
	
	  		return this._container;
	  	},
	
	  	addTo: function (map) {
	  		Control.prototype.addTo.call(this, map);
	  		// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
	  		return this._expandIfNotCollapsed();
	  	},
	
	  	onRemove: function () {
	  		this._map.off('zoomend', this._checkDisabledLayers, this);
	
	  		for (var i = 0; i < this._layers.length; i++) {
	  			this._layers[i].layer.off('add remove', this._onLayerChange, this);
	  		}
	  	},
	
	  	// @method addBaseLayer(layer: Layer, name: String): this
	  	// Adds a base layer (radio button entry) with the given name to the control.
	  	addBaseLayer: function (layer, name) {
	  		this._addLayer(layer, name);
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method addOverlay(layer: Layer, name: String): this
	  	// Adds an overlay (checkbox entry) with the given name to the control.
	  	addOverlay: function (layer, name) {
	  		this._addLayer(layer, name, true);
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Remove the given layer from the control.
	  	removeLayer: function (layer) {
	  		layer.off('add remove', this._onLayerChange, this);
	
	  		var obj = this._getLayer(stamp(layer));
	  		if (obj) {
	  			this._layers.splice(this._layers.indexOf(obj), 1);
	  		}
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method expand(): this
	  	// Expand the control container if collapsed.
	  	expand: function () {
	  		addClass(this._container, 'leaflet-control-layers-expanded');
	  		this._section.style.height = null;
	  		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
	  		if (acceptableHeight < this._section.clientHeight) {
	  			addClass(this._section, 'leaflet-control-layers-scrollbar');
	  			this._section.style.height = acceptableHeight + 'px';
	  		} else {
	  			removeClass(this._section, 'leaflet-control-layers-scrollbar');
	  		}
	  		this._checkDisabledLayers();
	  		return this;
	  	},
	
	  	// @method collapse(): this
	  	// Collapse the control container if expanded.
	  	collapse: function () {
	  		removeClass(this._container, 'leaflet-control-layers-expanded');
	  		return this;
	  	},
	
	  	_initLayout: function () {
	  		var className = 'leaflet-control-layers',
	  		    container = this._container = create$1('div', className),
	  		    collapsed = this.options.collapsed;
	
	  		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
	  		container.setAttribute('aria-haspopup', true);
	
	  		disableClickPropagation(container);
	  		disableScrollPropagation(container);
	
	  		var section = this._section = create$1('section', className + '-list');
	
	  		if (collapsed) {
	  			this._map.on('click', this.collapse, this);
	
	  			if (!android) {
	  				on(container, {
	  					mouseenter: this.expand,
	  					mouseleave: this.collapse
	  				}, this);
	  			}
	  		}
	
	  		var link = this._layersLink = create$1('a', className + '-toggle', container);
	  		link.href = '#';
	  		link.title = 'Layers';
	
	  		if (touch) {
	  			on(link, 'click', stop);
	  			on(link, 'click', this.expand, this);
	  		} else {
	  			on(link, 'focus', this.expand, this);
	  		}
	
	  		if (!collapsed) {
	  			this.expand();
	  		}
	
	  		this._baseLayersList = create$1('div', className + '-base', section);
	  		this._separator = create$1('div', className + '-separator', section);
	  		this._overlaysList = create$1('div', className + '-overlays', section);
	
	  		container.appendChild(section);
	  	},
	
	  	_getLayer: function (id) {
	  		for (var i = 0; i < this._layers.length; i++) {
	
	  			if (this._layers[i] && stamp(this._layers[i].layer) === id) {
	  				return this._layers[i];
	  			}
	  		}
	  	},
	
	  	_addLayer: function (layer, name, overlay) {
	  		if (this._map) {
	  			layer.on('add remove', this._onLayerChange, this);
	  		}
	
	  		this._layers.push({
	  			layer: layer,
	  			name: name,
	  			overlay: overlay
	  		});
	
	  		if (this.options.sortLayers) {
	  			this._layers.sort(bind(function (a, b) {
	  				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
	  			}, this));
	  		}
	
	  		if (this.options.autoZIndex && layer.setZIndex) {
	  			this._lastZIndex++;
	  			layer.setZIndex(this._lastZIndex);
	  		}
	
	  		this._expandIfNotCollapsed();
	  	},
	
	  	_update: function () {
	  		if (!this._container) { return this; }
	
	  		empty(this._baseLayersList);
	  		empty(this._overlaysList);
	
	  		this._layerControlInputs = [];
	  		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
	  		for (i = 0; i < this._layers.length; i++) {
	  			obj = this._layers[i];
	  			this._addItem(obj);
	  			overlaysPresent = overlaysPresent || obj.overlay;
	  			baseLayersPresent = baseLayersPresent || !obj.overlay;
	  			baseLayersCount += !obj.overlay ? 1 : 0;
	  		}
	
	  		// Hide base layers section if there's only one layer.
	  		if (this.options.hideSingleBase) {
	  			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
	  			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
	  		}
	
	  		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
	  		return this;
	  	},
	
	  	_onLayerChange: function (e) {
	  		if (!this._handlingClick) {
	  			this._update();
	  		}
	
	  		var obj = this._getLayer(stamp(e.target));
	
	  		// @namespace Map
	  		// @section Layer events
	  		// @event baselayerchange: LayersControlEvent
	  		// Fired when the base layer is changed through the [layers control](#control-layers).
	  		// @event overlayadd: LayersControlEvent
	  		// Fired when an overlay is selected through the [layers control](#control-layers).
	  		// @event overlayremove: LayersControlEvent
	  		// Fired when an overlay is deselected through the [layers control](#control-layers).
	  		// @namespace Control.Layers
	  		var type = obj.overlay ?
	  			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
	  			(e.type === 'add' ? 'baselayerchange' : null);
	
	  		if (type) {
	  			this._map.fire(type, obj);
	  		}
	  	},
	
	  	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	  	_createRadioElement: function (name, checked) {
	
	  		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
	  				name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
	  		var radioFragment = document.createElement('div');
	  		radioFragment.innerHTML = radioHtml;
	
	  		return radioFragment.firstChild;
	  	},
	
	  	_addItem: function (obj) {
	  		var label = document.createElement('label'),
	  		    checked = this._map.hasLayer(obj.layer),
	  		    input;
	
	  		if (obj.overlay) {
	  			input = document.createElement('input');
	  			input.type = 'checkbox';
	  			input.className = 'leaflet-control-layers-selector';
	  			input.defaultChecked = checked;
	  		} else {
	  			input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
	  		}
	
	  		this._layerControlInputs.push(input);
	  		input.layerId = stamp(obj.layer);
	
	  		on(input, 'click', this._onInputClick, this);
	
	  		var name = document.createElement('span');
	  		name.innerHTML = ' ' + obj.name;
	
	  		// Helps from preventing layer control flicker when checkboxes are disabled
	  		// https://github.com/Leaflet/Leaflet/issues/2771
	  		var holder = document.createElement('div');
	
	  		label.appendChild(holder);
	  		holder.appendChild(input);
	  		holder.appendChild(name);
	
	  		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
	  		container.appendChild(label);
	
	  		this._checkDisabledLayers();
	  		return label;
	  	},
	
	  	_onInputClick: function () {
	  		var inputs = this._layerControlInputs,
	  		    input, layer;
	  		var addedLayers = [],
	  		    removedLayers = [];
	
	  		this._handlingClick = true;
	
	  		for (var i = inputs.length - 1; i >= 0; i--) {
	  			input = inputs[i];
	  			layer = this._getLayer(input.layerId).layer;
	
	  			if (input.checked) {
	  				addedLayers.push(layer);
	  			} else if (!input.checked) {
	  				removedLayers.push(layer);
	  			}
	  		}
	
	  		// Bugfix issue 2318: Should remove all old layers before readding new ones
	  		for (i = 0; i < removedLayers.length; i++) {
	  			if (this._map.hasLayer(removedLayers[i])) {
	  				this._map.removeLayer(removedLayers[i]);
	  			}
	  		}
	  		for (i = 0; i < addedLayers.length; i++) {
	  			if (!this._map.hasLayer(addedLayers[i])) {
	  				this._map.addLayer(addedLayers[i]);
	  			}
	  		}
	
	  		this._handlingClick = false;
	
	  		this._refocusOnMap();
	  	},
	
	  	_checkDisabledLayers: function () {
	  		var inputs = this._layerControlInputs,
	  		    input,
	  		    layer,
	  		    zoom = this._map.getZoom();
	
	  		for (var i = inputs.length - 1; i >= 0; i--) {
	  			input = inputs[i];
	  			layer = this._getLayer(input.layerId).layer;
	  			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
	  			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
	  		}
	  	},
	
	  	_expandIfNotCollapsed: function () {
	  		if (this._map && !this.options.collapsed) {
	  			this.expand();
	  		}
	  		return this;
	  	},
	
	  	_expand: function () {
	  		// Backward compatibility, remove me in 1.1.
	  		return this.expand();
	  	},
	
	  	_collapse: function () {
	  		// Backward compatibility, remove me in 1.1.
	  		return this.collapse();
	  	}
	
	  });
	
	
	  // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	  // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	  var layers = function (baseLayers, overlays, options) {
	  	return new Layers(baseLayers, overlays, options);
	  };
	
	  /*
	   * @class Control.Zoom
	   * @aka L.Control.Zoom
	   * @inherits Control
	   *
	   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	   */
	
	  var Zoom = Control.extend({
	  	// @section
	  	// @aka Control.Zoom options
	  	options: {
	  		position: 'topleft',
	
	  		// @option zoomInText: String = '+'
	  		// The text set on the 'zoom in' button.
	  		zoomInText: '+',
	
	  		// @option zoomInTitle: String = 'Zoom in'
	  		// The title set on the 'zoom in' button.
	  		zoomInTitle: 'Zoom in',
	
	  		// @option zoomOutText: String = '&#x2212;'
	  		// The text set on the 'zoom out' button.
	  		zoomOutText: '&#x2212;',
	
	  		// @option zoomOutTitle: String = 'Zoom out'
	  		// The title set on the 'zoom out' button.
	  		zoomOutTitle: 'Zoom out'
	  	},
	
	  	onAdd: function (map) {
	  		var zoomName = 'leaflet-control-zoom',
	  		    container = create$1('div', zoomName + ' leaflet-bar'),
	  		    options = this.options;
	
	  		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
	  		        zoomName + '-in',  container, this._zoomIn);
	  		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
	  		        zoomName + '-out', container, this._zoomOut);
	
	  		this._updateDisabled();
	  		map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
	  		return container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	  	},
	
	  	disable: function () {
	  		this._disabled = true;
	  		this._updateDisabled();
	  		return this;
	  	},
	
	  	enable: function () {
	  		this._disabled = false;
	  		this._updateDisabled();
	  		return this;
	  	},
	
	  	_zoomIn: function (e) {
	  		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
	  			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	  		}
	  	},
	
	  	_zoomOut: function (e) {
	  		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
	  			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	  		}
	  	},
	
	  	_createButton: function (html, title, className, container, fn) {
	  		var link = create$1('a', className, container);
	  		link.innerHTML = html;
	  		link.href = '#';
	  		link.title = title;
	
	  		/*
	  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
	  		 */
	  		link.setAttribute('role', 'button');
	  		link.setAttribute('aria-label', title);
	
	  		disableClickPropagation(link);
	  		on(link, 'click', stop);
	  		on(link, 'click', fn, this);
	  		on(link, 'click', this._refocusOnMap, this);
	
	  		return link;
	  	},
	
	  	_updateDisabled: function () {
	  		var map = this._map,
	  		    className = 'leaflet-disabled';
	
	  		removeClass(this._zoomInButton, className);
	  		removeClass(this._zoomOutButton, className);
	
	  		if (this._disabled || map._zoom === map.getMinZoom()) {
	  			addClass(this._zoomOutButton, className);
	  		}
	  		if (this._disabled || map._zoom === map.getMaxZoom()) {
	  			addClass(this._zoomInButton, className);
	  		}
	  	}
	  });
	
	  // @namespace Map
	  // @section Control options
	  // @option zoomControl: Boolean = true
	  // Whether a [zoom control](#control-zoom) is added to the map by default.
	  Map.mergeOptions({
	  	zoomControl: true
	  });
	
	  Map.addInitHook(function () {
	  	if (this.options.zoomControl) {
	  		// @section Controls
	  		// @property zoomControl: Control.Zoom
	  		// The default zoom control (only available if the
	  		// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
	  		this.zoomControl = new Zoom();
	  		this.addControl(this.zoomControl);
	  	}
	  });
	
	  // @namespace Control.Zoom
	  // @factory L.control.zoom(options: Control.Zoom options)
	  // Creates a zoom control
	  var zoom = function (options) {
	  	return new Zoom(options);
	  };
	
	  /*
	   * @class Control.Scale
	   * @aka L.Control.Scale
	   * @inherits Control
	   *
	   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	   *
	   * @example
	   *
	   * ```js
	   * L.control.scale().addTo(map);
	   * ```
	   */
	
	  var Scale = Control.extend({
	  	// @section
	  	// @aka Control.Scale options
	  	options: {
	  		position: 'bottomleft',
	
	  		// @option maxWidth: Number = 100
	  		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
	  		maxWidth: 100,
	
	  		// @option metric: Boolean = True
	  		// Whether to show the metric scale line (m/km).
	  		metric: true,
	
	  		// @option imperial: Boolean = True
	  		// Whether to show the imperial scale line (mi/ft).
	  		imperial: true
	
	  		// @option updateWhenIdle: Boolean = false
	  		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	  	},
	
	  	onAdd: function (map) {
	  		var className = 'leaflet-control-scale',
	  		    container = create$1('div', className),
	  		    options = this.options;
	
	  		this._addScales(options, className + '-line', container);
	
	  		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	  		map.whenReady(this._update, this);
	
	  		return container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	  	},
	
	  	_addScales: function (options, className, container) {
	  		if (options.metric) {
	  			this._mScale = create$1('div', className, container);
	  		}
	  		if (options.imperial) {
	  			this._iScale = create$1('div', className, container);
	  		}
	  	},
	
	  	_update: function () {
	  		var map = this._map,
	  		    y = map.getSize().y / 2;
	
	  		var maxMeters = map.distance(
	  			map.containerPointToLatLng([0, y]),
	  			map.containerPointToLatLng([this.options.maxWidth, y]));
	
	  		this._updateScales(maxMeters);
	  	},
	
	  	_updateScales: function (maxMeters) {
	  		if (this.options.metric && maxMeters) {
	  			this._updateMetric(maxMeters);
	  		}
	  		if (this.options.imperial && maxMeters) {
	  			this._updateImperial(maxMeters);
	  		}
	  	},
	
	  	_updateMetric: function (maxMeters) {
	  		var meters = this._getRoundNum(maxMeters),
	  		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
	  		this._updateScale(this._mScale, label, meters / maxMeters);
	  	},
	
	  	_updateImperial: function (maxMeters) {
	  		var maxFeet = maxMeters * 3.2808399,
	  		    maxMiles, miles, feet;
	
	  		if (maxFeet > 5280) {
	  			maxMiles = maxFeet / 5280;
	  			miles = this._getRoundNum(maxMiles);
	  			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
	  		} else {
	  			feet = this._getRoundNum(maxFeet);
	  			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
	  		}
	  	},
	
	  	_updateScale: function (scale, text, ratio) {
	  		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
	  		scale.innerHTML = text;
	  	},
	
	  	_getRoundNum: function (num) {
	  		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
	  		    d = num / pow10;
	
	  		d = d >= 10 ? 10 :
	  		    d >= 5 ? 5 :
	  		    d >= 3 ? 3 :
	  		    d >= 2 ? 2 : 1;
	
	  		return pow10 * d;
	  	}
	  });
	
	
	  // @factory L.control.scale(options?: Control.Scale options)
	  // Creates an scale control with the given options.
	  var scale = function (options) {
	  	return new Scale(options);
	  };
	
	  /*
	   * @class Control.Attribution
	   * @aka L.Control.Attribution
	   * @inherits Control
	   *
	   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	   */
	
	  var Attribution = Control.extend({
	  	// @section
	  	// @aka Control.Attribution options
	  	options: {
	  		position: 'bottomright',
	
	  		// @option prefix: String = 'Leaflet'
	  		// The HTML text shown before the attributions. Pass `false` to disable.
	  		prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	
	  		this._attributions = {};
	  	},
	
	  	onAdd: function (map) {
	  		map.attributionControl = this;
	  		this._container = create$1('div', 'leaflet-control-attribution');
	  		disableClickPropagation(this._container);
	
	  		// TODO ugly, refactor
	  		for (var i in map._layers) {
	  			if (map._layers[i].getAttribution) {
	  				this.addAttribution(map._layers[i].getAttribution());
	  			}
	  		}
	
	  		this._update();
	
	  		return this._container;
	  	},
	
	  	// @method setPrefix(prefix: String): this
	  	// Sets the text before the attributions.
	  	setPrefix: function (prefix) {
	  		this.options.prefix = prefix;
	  		this._update();
	  		return this;
	  	},
	
	  	// @method addAttribution(text: String): this
	  	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
	  	addAttribution: function (text) {
	  		if (!text) { return this; }
	
	  		if (!this._attributions[text]) {
	  			this._attributions[text] = 0;
	  		}
	  		this._attributions[text]++;
	
	  		this._update();
	
	  		return this;
	  	},
	
	  	// @method removeAttribution(text: String): this
	  	// Removes an attribution text.
	  	removeAttribution: function (text) {
	  		if (!text) { return this; }
	
	  		if (this._attributions[text]) {
	  			this._attributions[text]--;
	  			this._update();
	  		}
	
	  		return this;
	  	},
	
	  	_update: function () {
	  		if (!this._map) { return; }
	
	  		var attribs = [];
	
	  		for (var i in this._attributions) {
	  			if (this._attributions[i]) {
	  				attribs.push(i);
	  			}
	  		}
	
	  		var prefixAndAttribs = [];
	
	  		if (this.options.prefix) {
	  			prefixAndAttribs.push(this.options.prefix);
	  		}
	  		if (attribs.length) {
	  			prefixAndAttribs.push(attribs.join(', '));
	  		}
	
	  		this._container.innerHTML = prefixAndAttribs.join(' | ');
	  	}
	  });
	
	  // @namespace Map
	  // @section Control options
	  // @option attributionControl: Boolean = true
	  // Whether a [attribution control](#control-attribution) is added to the map by default.
	  Map.mergeOptions({
	  	attributionControl: true
	  });
	
	  Map.addInitHook(function () {
	  	if (this.options.attributionControl) {
	  		new Attribution().addTo(this);
	  	}
	  });
	
	  // @namespace Control.Attribution
	  // @factory L.control.attribution(options: Control.Attribution options)
	  // Creates an attribution control.
	  var attribution = function (options) {
	  	return new Attribution(options);
	  };
	
	  Control.Layers = Layers;
	  Control.Zoom = Zoom;
	  Control.Scale = Scale;
	  Control.Attribution = Attribution;
	
	  control.layers = layers;
	  control.zoom = zoom;
	  control.scale = scale;
	  control.attribution = attribution;
	
	  /*
	  	L.Handler is a base class for handler classes that are used internally to inject
	  	interaction features like dragging to classes like Map and Marker.
	  */
	
	  // @class Handler
	  // @aka L.Handler
	  // Abstract class for map interaction handlers
	
	  var Handler = Class.extend({
	  	initialize: function (map) {
	  		this._map = map;
	  	},
	
	  	// @method enable(): this
	  	// Enables the handler
	  	enable: function () {
	  		if (this._enabled) { return this; }
	
	  		this._enabled = true;
	  		this.addHooks();
	  		return this;
	  	},
	
	  	// @method disable(): this
	  	// Disables the handler
	  	disable: function () {
	  		if (!this._enabled) { return this; }
	
	  		this._enabled = false;
	  		this.removeHooks();
	  		return this;
	  	},
	
	  	// @method enabled(): Boolean
	  	// Returns `true` if the handler is enabled
	  	enabled: function () {
	  		return !!this._enabled;
	  	}
	
	  	// @section Extension methods
	  	// Classes inheriting from `Handler` must implement the two following methods:
	  	// @method addHooks()
	  	// Called when the handler is enabled, should add event hooks.
	  	// @method removeHooks()
	  	// Called when the handler is disabled, should remove the event hooks added previously.
	  });
	
	  // @section There is static function which can be called without instantiating L.Handler:
	  // @function addTo(map: Map, name: String): this
	  // Adds a new Handler to the given map with the given name.
	  Handler.addTo = function (map, name) {
	  	map.addHandler(name, this);
	  	return this;
	  };
	
	  var Mixin = {Events: Events};
	
	  /*
	   * @class Draggable
	   * @aka L.Draggable
	   * @inherits Evented
	   *
	   * A class for making DOM elements draggable (including touch support).
	   * Used internally for map and marker dragging. Only works for elements
	   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	   *
	   * @example
	   * ```js
	   * var draggable = new L.Draggable(elementToDrag);
	   * draggable.enable();
	   * ```
	   */
	
	  var START = touch ? 'touchstart mousedown' : 'mousedown';
	  var END = {
	  	mousedown: 'mouseup',
	  	touchstart: 'touchend',
	  	pointerdown: 'touchend',
	  	MSPointerDown: 'touchend'
	  };
	  var MOVE = {
	  	mousedown: 'mousemove',
	  	touchstart: 'touchmove',
	  	pointerdown: 'touchmove',
	  	MSPointerDown: 'touchmove'
	  };
	
	
	  var Draggable = Evented.extend({
	
	  	options: {
	  		// @section
	  		// @aka Draggable options
	  		// @option clickTolerance: Number = 3
	  		// The max number of pixels a user can shift the mouse pointer during a click
	  		// for it to be considered a valid click (as opposed to a mouse drag).
	  		clickTolerance: 3
	  	},
	
	  	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
	  	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	  	initialize: function (element, dragStartTarget, preventOutline$$1, options) {
	  		setOptions(this, options);
	
	  		this._element = element;
	  		this._dragStartTarget = dragStartTarget || element;
	  		this._preventOutline = preventOutline$$1;
	  	},
	
	  	// @method enable()
	  	// Enables the dragging ability
	  	enable: function () {
	  		if (this._enabled) { return; }
	
	  		on(this._dragStartTarget, START, this._onDown, this);
	
	  		this._enabled = true;
	  	},
	
	  	// @method disable()
	  	// Disables the dragging ability
	  	disable: function () {
	  		if (!this._enabled) { return; }
	
	  		// If we're currently dragging this draggable,
	  		// disabling it counts as first ending the drag.
	  		if (Draggable._dragging === this) {
	  			this.finishDrag();
	  		}
	
	  		off(this._dragStartTarget, START, this._onDown, this);
	
	  		this._enabled = false;
	  		this._moved = false;
	  	},
	
	  	_onDown: function (e) {
	  		// Ignore simulated events, since we handle both touch and
	  		// mouse explicitly; otherwise we risk getting duplicates of
	  		// touch events, see #4315.
	  		// Also ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (e._simulated || !this._enabled) { return; }
	
	  		this._moved = false;
	
	  		if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
	  		if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
	  		Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
	  		if (this._preventOutline) {
	  			preventOutline(this._element);
	  		}
	
	  		disableImageDrag();
	  		disableTextSelection();
	
	  		if (this._moving) { return; }
	
	  		// @event down: Event
	  		// Fired when a drag is about to start.
	  		this.fire('down');
	
	  		var first = e.touches ? e.touches[0] : e,
	  		    sizedParent = getSizedParentNode(this._element);
	
	  		this._startPoint = new Point(first.clientX, first.clientY);
	
	  		// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
	  		this._parentScale = getScale(sizedParent);
	
	  		on(document, MOVE[e.type], this._onMove, this);
	  		on(document, END[e.type], this._onUp, this);
	  	},
	
	  	_onMove: function (e) {
	  		// Ignore simulated events, since we handle both touch and
	  		// mouse explicitly; otherwise we risk getting duplicates of
	  		// touch events, see #4315.
	  		// Also ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (e._simulated || !this._enabled) { return; }
	
	  		if (e.touches && e.touches.length > 1) {
	  			this._moved = true;
	  			return;
	  		}
	
	  		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
	  		    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	
	  		if (!offset.x && !offset.y) { return; }
	  		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
	  		// We assume that the parent container's position, border and scale do not change for the duration of the drag.
	  		// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
	  		// and we can use the cached value for the scale.
	  		offset.x /= this._parentScale.x;
	  		offset.y /= this._parentScale.y;
	
	  		preventDefault(e);
	
	  		if (!this._moved) {
	  			// @event dragstart: Event
	  			// Fired when a drag starts
	  			this.fire('dragstart');
	
	  			this._moved = true;
	  			this._startPos = getPosition(this._element).subtract(offset);
	
	  			addClass(document.body, 'leaflet-dragging');
	
	  			this._lastTarget = e.target || e.srcElement;
	  			// IE and Edge do not give the <use> element, so fetch it
	  			// if necessary
	  			if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
	  				this._lastTarget = this._lastTarget.correspondingUseElement;
	  			}
	  			addClass(this._lastTarget, 'leaflet-drag-target');
	  		}
	
	  		this._newPos = this._startPos.add(offset);
	  		this._moving = true;
	
	  		cancelAnimFrame(this._animRequest);
	  		this._lastEvent = e;
	  		this._animRequest = requestAnimFrame(this._updatePosition, this, true);
	  	},
	
	  	_updatePosition: function () {
	  		var e = {originalEvent: this._lastEvent};
	
	  		// @event predrag: Event
	  		// Fired continuously during dragging *before* each corresponding
	  		// update of the element's position.
	  		this.fire('predrag', e);
	  		setPosition(this._element, this._newPos);
	
	  		// @event drag: Event
	  		// Fired continuously during dragging.
	  		this.fire('drag', e);
	  	},
	
	  	_onUp: function (e) {
	  		// Ignore simulated events, since we handle both touch and
	  		// mouse explicitly; otherwise we risk getting duplicates of
	  		// touch events, see #4315.
	  		// Also ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (e._simulated || !this._enabled) { return; }
	  		this.finishDrag();
	  	},
	
	  	finishDrag: function () {
	  		removeClass(document.body, 'leaflet-dragging');
	
	  		if (this._lastTarget) {
	  			removeClass(this._lastTarget, 'leaflet-drag-target');
	  			this._lastTarget = null;
	  		}
	
	  		for (var i in MOVE) {
	  			off(document, MOVE[i], this._onMove, this);
	  			off(document, END[i], this._onUp, this);
	  		}
	
	  		enableImageDrag();
	  		enableTextSelection();
	
	  		if (this._moved && this._moving) {
	  			// ensure drag is not fired after dragend
	  			cancelAnimFrame(this._animRequest);
	
	  			// @event dragend: DragEndEvent
	  			// Fired when the drag ends.
	  			this.fire('dragend', {
	  				distance: this._newPos.distanceTo(this._startPos)
	  			});
	  		}
	
	  		this._moving = false;
	  		Draggable._dragging = false;
	  	}
	
	  });
	
	  /*
	   * @namespace LineUtil
	   *
	   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	   */
	
	  // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	  // Improves rendering performance dramatically by lessening the number of points to draw.
	
	  // @function simplify(points: Point[], tolerance: Number): Point[]
	  // Dramatically reduces the number of points in a polyline while retaining
	  // its shape and returns a new array of simplified points, using the
	  // [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	  // Used for a huge performance boost when processing/displaying Leaflet polylines for
	  // each zoom level and also reducing visual noise. tolerance affects the amount of
	  // simplification (lesser value means higher quality but slower and with more points).
	  // Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	  function simplify(points, tolerance) {
	  	if (!tolerance || !points.length) {
	  		return points.slice();
	  	}
	
	  	var sqTolerance = tolerance * tolerance;
	
	  	    // stage 1: vertex reduction
	  	    points = _reducePoints(points, sqTolerance);
	
	  	    // stage 2: Douglas-Peucker simplification
	  	    points = _simplifyDP(points, sqTolerance);
	
	  	return points;
	  }
	
	  // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	  // Returns the distance between point `p` and segment `p1` to `p2`.
	  function pointToSegmentDistance(p, p1, p2) {
	  	return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	  }
	
	  // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	  // Returns the closest point from a point `p` on a segment `p1` to `p2`.
	  function closestPointOnSegment(p, p1, p2) {
	  	return _sqClosestPointOnSegment(p, p1, p2);
	  }
	
	  // Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	  function _simplifyDP(points, sqTolerance) {
	
	  	var len = points.length,
	  	    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
	  	    markers = new ArrayConstructor(len);
	
	  	    markers[0] = markers[len - 1] = 1;
	
	  	_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
	  	var i,
	  	    newPoints = [];
	
	  	for (i = 0; i < len; i++) {
	  		if (markers[i]) {
	  			newPoints.push(points[i]);
	  		}
	  	}
	
	  	return newPoints;
	  }
	
	  function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
	  	var maxSqDist = 0,
	  	index, i, sqDist;
	
	  	for (i = first + 1; i <= last - 1; i++) {
	  		sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
	  		if (sqDist > maxSqDist) {
	  			index = i;
	  			maxSqDist = sqDist;
	  		}
	  	}
	
	  	if (maxSqDist > sqTolerance) {
	  		markers[index] = 1;
	
	  		_simplifyDPStep(points, markers, sqTolerance, first, index);
	  		_simplifyDPStep(points, markers, sqTolerance, index, last);
	  	}
	  }
	
	  // reduce points that are too close to each other to a single point
	  function _reducePoints(points, sqTolerance) {
	  	var reducedPoints = [points[0]];
	
	  	for (var i = 1, prev = 0, len = points.length; i < len; i++) {
	  		if (_sqDist(points[i], points[prev]) > sqTolerance) {
	  			reducedPoints.push(points[i]);
	  			prev = i;
	  		}
	  	}
	  	if (prev < len - 1) {
	  		reducedPoints.push(points[len - 1]);
	  	}
	  	return reducedPoints;
	  }
	
	  var _lastCode;
	
	  // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	  // Clips the segment a to b by rectangular bounds with the
	  // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	  // (modifying the segment points directly!). Used by Leaflet to only show polyline
	  // points that are on the screen or near, increasing performance.
	  function clipSegment(a, b, bounds, useLastCode, round) {
	  	var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
	  	    codeB = _getBitCode(b, bounds),
	
	  	    codeOut, p, newCode;
	
	  	    // save 2nd code to avoid calculating it on the next segment
	  	    _lastCode = codeB;
	
	  	while (true) {
	  		// if a,b is inside the clip window (trivial accept)
	  		if (!(codeA | codeB)) {
	  			return [a, b];
	  		}
	
	  		// if a,b is outside the clip window (trivial reject)
	  		if (codeA & codeB) {
	  			return false;
	  		}
	
	  		// other cases
	  		codeOut = codeA || codeB;
	  		p = _getEdgeIntersection(a, b, codeOut, bounds, round);
	  		newCode = _getBitCode(p, bounds);
	
	  		if (codeOut === codeA) {
	  			a = p;
	  			codeA = newCode;
	  		} else {
	  			b = p;
	  			codeB = newCode;
	  		}
	  	}
	  }
	
	  function _getEdgeIntersection(a, b, code, bounds, round) {
	  	var dx = b.x - a.x,
	  	    dy = b.y - a.y,
	  	    min = bounds.min,
	  	    max = bounds.max,
	  	    x, y;
	
	  	if (code & 8) { // top
	  		x = a.x + dx * (max.y - a.y) / dy;
	  		y = max.y;
	
	  	} else if (code & 4) { // bottom
	  		x = a.x + dx * (min.y - a.y) / dy;
	  		y = min.y;
	
	  	} else if (code & 2) { // right
	  		x = max.x;
	  		y = a.y + dy * (max.x - a.x) / dx;
	
	  	} else if (code & 1) { // left
	  		x = min.x;
	  		y = a.y + dy * (min.x - a.x) / dx;
	  	}
	
	  	return new Point(x, y, round);
	  }
	
	  function _getBitCode(p, bounds) {
	  	var code = 0;
	
	  	if (p.x < bounds.min.x) { // left
	  		code |= 1;
	  	} else if (p.x > bounds.max.x) { // right
	  		code |= 2;
	  	}
	
	  	if (p.y < bounds.min.y) { // bottom
	  		code |= 4;
	  	} else if (p.y > bounds.max.y) { // top
	  		code |= 8;
	  	}
	
	  	return code;
	  }
	
	  // square distance (to avoid unnecessary Math.sqrt calls)
	  function _sqDist(p1, p2) {
	  	var dx = p2.x - p1.x,
	  	    dy = p2.y - p1.y;
	  	return dx * dx + dy * dy;
	  }
	
	  // return closest point on segment or distance to that point
	  function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
	  	var x = p1.x,
	  	    y = p1.y,
	  	    dx = p2.x - x,
	  	    dy = p2.y - y,
	  	    dot = dx * dx + dy * dy,
	  	    t;
	
	  	if (dot > 0) {
	  		t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
	  		if (t > 1) {
	  			x = p2.x;
	  			y = p2.y;
	  		} else if (t > 0) {
	  			x += dx * t;
	  			y += dy * t;
	  		}
	  	}
	
	  	dx = p.x - x;
	  	dy = p.y - y;
	
	  	return sqDist ? dx * dx + dy * dy : new Point(x, y);
	  }
	
	
	  // @function isFlat(latlngs: LatLng[]): Boolean
	  // Returns true if `latlngs` is a flat array, false is nested.
	  function isFlat(latlngs) {
	  	return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	  }
	
	  function _flat(latlngs) {
	  	console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
	  	return isFlat(latlngs);
	  }
	
	  var LineUtil = ({
	    simplify: simplify,
	    pointToSegmentDistance: pointToSegmentDistance,
	    closestPointOnSegment: closestPointOnSegment,
	    clipSegment: clipSegment,
	    _getEdgeIntersection: _getEdgeIntersection,
	    _getBitCode: _getBitCode,
	    _sqClosestPointOnSegment: _sqClosestPointOnSegment,
	    isFlat: isFlat,
	    _flat: _flat
	  });
	
	  /*
	   * @namespace PolyUtil
	   * Various utility functions for polygon geometries.
	   */
	
	  /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	   * performance. Note that polygon points needs different algorithm for clipping
	   * than polyline, so there's a separate method for it.
	   */
	  function clipPolygon(points, bounds, round) {
	  	var clippedPoints,
	  	    edges = [1, 4, 2, 8],
	  	    i, j, k,
	  	    a, b,
	  	    len, edge, p;
	
	  	for (i = 0, len = points.length; i < len; i++) {
	  		points[i]._code = _getBitCode(points[i], bounds);
	  	}
	
	  	// for each edge (left, bottom, right, top)
	  	for (k = 0; k < 4; k++) {
	  		edge = edges[k];
	  		clippedPoints = [];
	
	  		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
	  			a = points[i];
	  			b = points[j];
	
	  			// if a is inside the clip window
	  			if (!(a._code & edge)) {
	  				// if b is outside the clip window (a->b goes out of screen)
	  				if (b._code & edge) {
	  					p = _getEdgeIntersection(b, a, edge, bounds, round);
	  					p._code = _getBitCode(p, bounds);
	  					clippedPoints.push(p);
	  				}
	  				clippedPoints.push(a);
	
	  			// else if b is inside the clip window (a->b enters the screen)
	  			} else if (!(b._code & edge)) {
	  				p = _getEdgeIntersection(b, a, edge, bounds, round);
	  				p._code = _getBitCode(p, bounds);
	  				clippedPoints.push(p);
	  			}
	  		}
	  		points = clippedPoints;
	  	}
	
	  	return points;
	  }
	
	  var PolyUtil = ({
	    clipPolygon: clipPolygon
	  });
	
	  /*
	   * @namespace Projection
	   * @section
	   * Leaflet comes with a set of already defined Projections out of the box:
	   *
	   * @projection L.Projection.LonLat
	   *
	   * Equirectangular, or Plate Carree projection — the most simple projection,
	   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	   * `EPSG:4326` and `Simple` CRS.
	   */
	
	  var LonLat = {
	  	project: function (latlng) {
	  		return new Point(latlng.lng, latlng.lat);
	  	},
	
	  	unproject: function (point) {
	  		return new LatLng(point.y, point.x);
	  	},
	
	  	bounds: new Bounds([-180, -90], [180, 90])
	  };
	
	  /*
	   * @namespace Projection
	   * @projection L.Projection.Mercator
	   *
	   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
	   */
	
	  var Mercator = {
	  	R: 6378137,
	  	R_MINOR: 6356752.314245179,
	
	  	bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
	  	project: function (latlng) {
	  		var d = Math.PI / 180,
	  		    r = this.R,
	  		    y = latlng.lat * d,
	  		    tmp = this.R_MINOR / r,
	  		    e = Math.sqrt(1 - tmp * tmp),
	  		    con = e * Math.sin(y);
	
	  		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
	  		y = -r * Math.log(Math.max(ts, 1E-10));
	
	  		return new Point(latlng.lng * d * r, y);
	  	},
	
	  	unproject: function (point) {
	  		var d = 180 / Math.PI,
	  		    r = this.R,
	  		    tmp = this.R_MINOR / r,
	  		    e = Math.sqrt(1 - tmp * tmp),
	  		    ts = Math.exp(-point.y / r),
	  		    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
	  		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
	  			con = e * Math.sin(phi);
	  			con = Math.pow((1 - con) / (1 + con), e / 2);
	  			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
	  			phi += dphi;
	  		}
	
	  		return new LatLng(phi * d, point.x * d / r);
	  	}
	  };
	
	  /*
	   * @class Projection
	
	   * An object with methods for projecting geographical coordinates of the world onto
	   * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).
	
	   * @property bounds: Bounds
	   * The bounds (specified in CRS units) where the projection is valid
	
	   * @method project(latlng: LatLng): Point
	   * Projects geographical coordinates into a 2D point.
	   * Only accepts actual `L.LatLng` instances, not arrays.
	
	   * @method unproject(point: Point): LatLng
	   * The inverse of `project`. Projects a 2D point into a geographical location.
	   * Only accepts actual `L.Point` instances, not arrays.
	
	   * Note that the projection instances do not inherit from Leaflet's `Class` object,
	   * and can't be instantiated. Also, new classes can't inherit from them,
	   * and methods can't be added to them with the `include` function.
	
	   */
	
	  var index = ({
	    LonLat: LonLat,
	    Mercator: Mercator,
	    SphericalMercator: SphericalMercator
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG3395
	   *
	   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	   */
	  var EPSG3395 = extend({}, Earth, {
	  	code: 'EPSG:3395',
	  	projection: Mercator,
	
	  	transformation: (function () {
	  		var scale = 0.5 / (Math.PI * Mercator.R);
	  		return toTransformation(scale, 0.5, -scale, 0.5);
	  	}())
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG4326
	   *
	   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	   *
	   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	   */
	
	  var EPSG4326 = extend({}, Earth, {
	  	code: 'EPSG:4326',
	  	projection: LonLat,
	  	transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Simple
	   *
	   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	   * axis should still be inverted (going from bottom to top). `distance()` returns
	   * simple euclidean distance.
	   */
	
	  var Simple = extend({}, CRS, {
	  	projection: LonLat,
	  	transformation: toTransformation(1, 0, -1, 0),
	
	  	scale: function (zoom) {
	  		return Math.pow(2, zoom);
	  	},
	
	  	zoom: function (scale) {
	  		return Math.log(scale) / Math.LN2;
	  	},
	
	  	distance: function (latlng1, latlng2) {
	  		var dx = latlng2.lng - latlng1.lng,
	  		    dy = latlng2.lat - latlng1.lat;
	
	  		return Math.sqrt(dx * dx + dy * dy);
	  	},
	
	  	infinite: true
	  });
	
	  CRS.Earth = Earth;
	  CRS.EPSG3395 = EPSG3395;
	  CRS.EPSG3857 = EPSG3857;
	  CRS.EPSG900913 = EPSG900913;
	  CRS.EPSG4326 = EPSG4326;
	  CRS.Simple = Simple;
	
	  /*
	   * @class Layer
	   * @inherits Evented
	   * @aka L.Layer
	   * @aka ILayer
	   *
	   * A set of methods from the Layer base class that all Leaflet layers use.
	   * Inherits all methods, options and events from `L.Evented`.
	   *
	   * @example
	   *
	   * ```js
	   * var layer = L.marker(latlng).addTo(map);
	   * layer.addTo(map);
	   * layer.remove();
	   * ```
	   *
	   * @event add: Event
	   * Fired after the layer is added to a map
	   *
	   * @event remove: Event
	   * Fired after the layer is removed from a map
	   */
	
	
	  var Layer = Evented.extend({
	
	  	// Classes extending `L.Layer` will inherit the following options:
	  	options: {
	  		// @option pane: String = 'overlayPane'
	  		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
	  		pane: 'overlayPane',
	
	  		// @option attribution: String = null
	  		// String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
	  		attribution: null,
	
	  		bubblingMouseEvents: true
	  	},
	
	  	/* @section
	  	 * Classes extending `L.Layer` will inherit the following methods:
	  	 *
	  	 * @method addTo(map: Map|LayerGroup): this
	  	 * Adds the layer to the given map or layer group.
	  	 */
	  	addTo: function (map) {
	  		map.addLayer(this);
	  		return this;
	  	},
	
	  	// @method remove: this
	  	// Removes the layer from the map it is currently active on.
	  	remove: function () {
	  		return this.removeFrom(this._map || this._mapToAdd);
	  	},
	
	  	// @method removeFrom(map: Map): this
	  	// Removes the layer from the given map
	  	//
	  	// @alternative
	  	// @method removeFrom(group: LayerGroup): this
	  	// Removes the layer from the given `LayerGroup`
	  	removeFrom: function (obj) {
	  		if (obj) {
	  			obj.removeLayer(this);
	  		}
	  		return this;
	  	},
	
	  	// @method getPane(name? : String): HTMLElement
	  	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	  	getPane: function (name) {
	  		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	  	},
	
	  	addInteractiveTarget: function (targetEl) {
	  		this._map._targets[stamp(targetEl)] = this;
	  		return this;
	  	},
	
	  	removeInteractiveTarget: function (targetEl) {
	  		delete this._map._targets[stamp(targetEl)];
	  		return this;
	  	},
	
	  	// @method getAttribution: String
	  	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	  	getAttribution: function () {
	  		return this.options.attribution;
	  	},
	
	  	_layerAdd: function (e) {
	  		var map = e.target;
	
	  		// check in case layer gets added and then removed before the map is ready
	  		if (!map.hasLayer(this)) { return; }
	
	  		this._map = map;
	  		this._zoomAnimated = map._zoomAnimated;
	
	  		if (this.getEvents) {
	  			var events = this.getEvents();
	  			map.on(events, this);
	  			this.once('remove', function () {
	  				map.off(events, this);
	  			}, this);
	  		}
	
	  		this.onAdd(map);
	
	  		if (this.getAttribution && map.attributionControl) {
	  			map.attributionControl.addAttribution(this.getAttribution());
	  		}
	
	  		this.fire('add');
	  		map.fire('layeradd', {layer: this});
	  	}
	  });
	
	  /* @section Extension methods
	   * @uninheritable
	   *
	   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	   *
	   * @method onAdd(map: Map): this
	   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	   *
	   * @method onRemove(map: Map): this
	   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	   *
	   * @method getEvents(): Object
	   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	   *
	   * @method getAttribution(): String
	   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	   *
	   * @method beforeAdd(map: Map): this
	   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	   */
	
	
	  /* @namespace Map
	   * @section Layer events
	   *
	   * @event layeradd: LayerEvent
	   * Fired when a new layer is added to the map.
	   *
	   * @event layerremove: LayerEvent
	   * Fired when some layer is removed from the map
	   *
	   * @section Methods for Layers and Controls
	   */
	  Map.include({
	  	// @method addLayer(layer: Layer): this
	  	// Adds the given layer to the map
	  	addLayer: function (layer) {
	  		if (!layer._layerAdd) {
	  			throw new Error('The provided object is not a Layer.');
	  		}
	
	  		var id = stamp(layer);
	  		if (this._layers[id]) { return this; }
	  		this._layers[id] = layer;
	
	  		layer._mapToAdd = this;
	
	  		if (layer.beforeAdd) {
	  			layer.beforeAdd(this);
	  		}
	
	  		this.whenReady(layer._layerAdd, layer);
	
	  		return this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Removes the given layer from the map.
	  	removeLayer: function (layer) {
	  		var id = stamp(layer);
	
	  		if (!this._layers[id]) { return this; }
	
	  		if (this._loaded) {
	  			layer.onRemove(this);
	  		}
	
	  		if (layer.getAttribution && this.attributionControl) {
	  			this.attributionControl.removeAttribution(layer.getAttribution());
	  		}
	
	  		delete this._layers[id];
	
	  		if (this._loaded) {
	  			this.fire('layerremove', {layer: layer});
	  			layer.fire('remove');
	  		}
	
	  		layer._map = layer._mapToAdd = null;
	
	  		return this;
	  	},
	
	  	// @method hasLayer(layer: Layer): Boolean
	  	// Returns `true` if the given layer is currently added to the map
	  	hasLayer: function (layer) {
	  		return !!layer && (stamp(layer) in this._layers);
	  	},
	
	  	/* @method eachLayer(fn: Function, context?: Object): this
	  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	  	 * ```
	  	 * map.eachLayer(function(layer){
	  	 *     layer.bindPopup('Hello');
	  	 * });
	  	 * ```
	  	 */
	  	eachLayer: function (method, context) {
	  		for (var i in this._layers) {
	  			method.call(context, this._layers[i]);
	  		}
	  		return this;
	  	},
	
	  	_addLayers: function (layers) {
	  		layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
	  		for (var i = 0, len = layers.length; i < len; i++) {
	  			this.addLayer(layers[i]);
	  		}
	  	},
	
	  	_addZoomLimit: function (layer) {
	  		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
	  			this._zoomBoundLayers[stamp(layer)] = layer;
	  			this._updateZoomLevels();
	  		}
	  	},
	
	  	_removeZoomLimit: function (layer) {
	  		var id = stamp(layer);
	
	  		if (this._zoomBoundLayers[id]) {
	  			delete this._zoomBoundLayers[id];
	  			this._updateZoomLevels();
	  		}
	  	},
	
	  	_updateZoomLevels: function () {
	  		var minZoom = Infinity,
	  		    maxZoom = -Infinity,
	  		    oldZoomSpan = this._getZoomSpan();
	
	  		for (var i in this._zoomBoundLayers) {
	  			var options = this._zoomBoundLayers[i].options;
	
	  			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
	  			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
	  		}
	
	  		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
	  		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
	  		// @section Map state change events
	  		// @event zoomlevelschange: Event
	  		// Fired when the number of zoomlevels on the map is changed due
	  		// to adding or removing a layer.
	  		if (oldZoomSpan !== this._getZoomSpan()) {
	  			this.fire('zoomlevelschange');
	  		}
	
	  		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
	  			this.setZoom(this._layersMaxZoom);
	  		}
	  		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
	  			this.setZoom(this._layersMinZoom);
	  		}
	  	}
	  });
	
	  /*
	   * @class LayerGroup
	   * @aka L.LayerGroup
	   * @inherits Layer
	   *
	   * Used to group several layers and handle them as one. If you add it to the map,
	   * any layers added or removed from the group will be added/removed on the map as
	   * well. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.layerGroup([marker1, marker2])
	   * 	.addLayer(polyline)
	   * 	.addTo(map);
	   * ```
	   */
	
	  var LayerGroup = Layer.extend({
	
	  	initialize: function (layers, options) {
	  		setOptions(this, options);
	
	  		this._layers = {};
	
	  		var i, len;
	
	  		if (layers) {
	  			for (i = 0, len = layers.length; i < len; i++) {
	  				this.addLayer(layers[i]);
	  			}
	  		}
	  	},
	
	  	// @method addLayer(layer: Layer): this
	  	// Adds the given layer to the group.
	  	addLayer: function (layer) {
	  		var id = this.getLayerId(layer);
	
	  		this._layers[id] = layer;
	
	  		if (this._map) {
	  			this._map.addLayer(layer);
	  		}
	
	  		return this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Removes the given layer from the group.
	  	// @alternative
	  	// @method removeLayer(id: Number): this
	  	// Removes the layer with the given internal ID from the group.
	  	removeLayer: function (layer) {
	  		var id = layer in this._layers ? layer : this.getLayerId(layer);
	
	  		if (this._map && this._layers[id]) {
	  			this._map.removeLayer(this._layers[id]);
	  		}
	
	  		delete this._layers[id];
	
	  		return this;
	  	},
	
	  	// @method hasLayer(layer: Layer): Boolean
	  	// Returns `true` if the given layer is currently added to the group.
	  	// @alternative
	  	// @method hasLayer(id: Number): Boolean
	  	// Returns `true` if the given internal ID is currently added to the group.
	  	hasLayer: function (layer) {
	  		if (!layer) { return false; }
	  		var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
	  		return layerId in this._layers;
	  	},
	
	  	// @method clearLayers(): this
	  	// Removes all the layers from the group.
	  	clearLayers: function () {
	  		return this.eachLayer(this.removeLayer, this);
	  	},
	
	  	// @method invoke(methodName: String, …): this
	  	// Calls `methodName` on every layer contained in this group, passing any
	  	// additional parameters. Has no effect if the layers contained do not
	  	// implement `methodName`.
	  	invoke: function (methodName) {
	  		var args = Array.prototype.slice.call(arguments, 1),
	  		    i, layer;
	
	  		for (i in this._layers) {
	  			layer = this._layers[i];
	
	  			if (layer[methodName]) {
	  				layer[methodName].apply(layer, args);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	onAdd: function (map) {
	  		this.eachLayer(map.addLayer, map);
	  	},
	
	  	onRemove: function (map) {
	  		this.eachLayer(map.removeLayer, map);
	  	},
	
	  	// @method eachLayer(fn: Function, context?: Object): this
	  	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	  	// ```js
	  	// group.eachLayer(function (layer) {
	  	// 	layer.bindPopup('Hello');
	  	// });
	  	// ```
	  	eachLayer: function (method, context) {
	  		for (var i in this._layers) {
	  			method.call(context, this._layers[i]);
	  		}
	  		return this;
	  	},
	
	  	// @method getLayer(id: Number): Layer
	  	// Returns the layer with the given internal ID.
	  	getLayer: function (id) {
	  		return this._layers[id];
	  	},
	
	  	// @method getLayers(): Layer[]
	  	// Returns an array of all the layers added to the group.
	  	getLayers: function () {
	  		var layers = [];
	  		this.eachLayer(layers.push, layers);
	  		return layers;
	  	},
	
	  	// @method setZIndex(zIndex: Number): this
	  	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	  	setZIndex: function (zIndex) {
	  		return this.invoke('setZIndex', zIndex);
	  	},
	
	  	// @method getLayerId(layer: Layer): Number
	  	// Returns the internal ID for a layer
	  	getLayerId: function (layer) {
	  		return stamp(layer);
	  	}
	  });
	
	
	  // @factory L.layerGroup(layers?: Layer[], options?: Object)
	  // Create a layer group, optionally given an initial set of layers and an `options` object.
	  var layerGroup = function (layers, options) {
	  	return new LayerGroup(layers, options);
	  };
	
	  /*
	   * @class FeatureGroup
	   * @aka L.FeatureGroup
	   * @inherits LayerGroup
	   *
	   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	   * handler, it will handle events from any of the layers. This includes mouse events
	   * and custom events.
	   *  * Has `layeradd` and `layerremove` events
	   *
	   * @example
	   *
	   * ```js
	   * L.featureGroup([marker1, marker2, polyline])
	   * 	.bindPopup('Hello world!')
	   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	   * 	.addTo(map);
	   * ```
	   */
	
	  var FeatureGroup = LayerGroup.extend({
	
	  	addLayer: function (layer) {
	  		if (this.hasLayer(layer)) {
	  			return this;
	  		}
	
	  		layer.addEventParent(this);
	
	  		LayerGroup.prototype.addLayer.call(this, layer);
	
	  		// @event layeradd: LayerEvent
	  		// Fired when a layer is added to this `FeatureGroup`
	  		return this.fire('layeradd', {layer: layer});
	  	},
	
	  	removeLayer: function (layer) {
	  		if (!this.hasLayer(layer)) {
	  			return this;
	  		}
	  		if (layer in this._layers) {
	  			layer = this._layers[layer];
	  		}
	
	  		layer.removeEventParent(this);
	
	  		LayerGroup.prototype.removeLayer.call(this, layer);
	
	  		// @event layerremove: LayerEvent
	  		// Fired when a layer is removed from this `FeatureGroup`
	  		return this.fire('layerremove', {layer: layer});
	  	},
	
	  	// @method setStyle(style: Path options): this
	  	// Sets the given path options to each layer of the group that has a `setStyle` method.
	  	setStyle: function (style) {
	  		return this.invoke('setStyle', style);
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer group to the top of all other layers
	  	bringToFront: function () {
	  		return this.invoke('bringToFront');
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer group to the back of all other layers
	  	bringToBack: function () {
	  		return this.invoke('bringToBack');
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	  	getBounds: function () {
	  		var bounds = new LatLngBounds();
	
	  		for (var id in this._layers) {
	  			var layer = this._layers[id];
	  			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
	  		}
	  		return bounds;
	  	}
	  });
	
	  // @factory L.featureGroup(layers?: Layer[], options?: Object)
	  // Create a feature group, optionally given an initial set of layers and an `options` object.
	  var featureGroup = function (layers, options) {
	  	return new FeatureGroup(layers, options);
	  };
	
	  /*
	   * @class Icon
	   * @aka L.Icon
	   *
	   * Represents an icon to provide when creating a marker.
	   *
	   * @example
	   *
	   * ```js
	   * var myIcon = L.icon({
	   *     iconUrl: 'my-icon.png',
	   *     iconRetinaUrl: 'my-icon@2x.png',
	   *     iconSize: [38, 95],
	   *     iconAnchor: [22, 94],
	   *     popupAnchor: [-3, -76],
	   *     shadowUrl: 'my-icon-shadow.png',
	   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	   *     shadowSize: [68, 95],
	   *     shadowAnchor: [22, 94]
	   * });
	   *
	   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	   * ```
	   *
	   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	   *
	   */
	
	  var Icon = Class.extend({
	
	  	/* @section
	  	 * @aka Icon options
	  	 *
	  	 * @option iconUrl: String = null
	  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	  	 *
	  	 * @option iconRetinaUrl: String = null
	  	 * The URL to a retina sized version of the icon image (absolute or relative to your
	  	 * script path). Used for Retina screen devices.
	  	 *
	  	 * @option iconSize: Point = null
	  	 * Size of the icon image in pixels.
	  	 *
	  	 * @option iconAnchor: Point = null
	  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	  	 * will be aligned so that this point is at the marker's geographical location. Centered
	  	 * by default if size is specified, also can be set in CSS with negative margins.
	  	 *
	  	 * @option popupAnchor: Point = [0, 0]
	  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	  	 *
	  	 * @option tooltipAnchor: Point = [0, 0]
	  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
	  	 *
	  	 * @option shadowUrl: String = null
	  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	  	 *
	  	 * @option shadowRetinaUrl: String = null
	  	 *
	  	 * @option shadowSize: Point = null
	  	 * Size of the shadow image in pixels.
	  	 *
	  	 * @option shadowAnchor: Point = null
	  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	  	 * as iconAnchor if not specified).
	  	 *
	  	 * @option className: String = ''
	  	 * A custom class name to assign to both icon and shadow images. Empty by default.
	  	 */
	
	  	options: {
	  		popupAnchor: [0, 0],
	  		tooltipAnchor: [0, 0]
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	  	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	  	// styled according to the options.
	  	createIcon: function (oldIcon) {
	  		return this._createIcon('icon', oldIcon);
	  	},
	
	  	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	  	// As `createIcon`, but for the shadow beneath it.
	  	createShadow: function (oldIcon) {
	  		return this._createIcon('shadow', oldIcon);
	  	},
	
	  	_createIcon: function (name, oldIcon) {
	  		var src = this._getIconUrl(name);
	
	  		if (!src) {
	  			if (name === 'icon') {
	  				throw new Error('iconUrl not set in Icon options (see the docs).');
	  			}
	  			return null;
	  		}
	
	  		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
	  		this._setIconStyles(img, name);
	
	  		return img;
	  	},
	
	  	_setIconStyles: function (img, name) {
	  		var options = this.options;
	  		var sizeOption = options[name + 'Size'];
	
	  		if (typeof sizeOption === 'number') {
	  			sizeOption = [sizeOption, sizeOption];
	  		}
	
	  		var size = toPoint(sizeOption),
	  		    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
	  		            size && size.divideBy(2, true));
	
	  		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
	  		if (anchor) {
	  			img.style.marginLeft = (-anchor.x) + 'px';
	  			img.style.marginTop  = (-anchor.y) + 'px';
	  		}
	
	  		if (size) {
	  			img.style.width  = size.x + 'px';
	  			img.style.height = size.y + 'px';
	  		}
	  	},
	
	  	_createImg: function (src, el) {
	  		el = el || document.createElement('img');
	  		el.src = src;
	  		return el;
	  	},
	
	  	_getIconUrl: function (name) {
	  		return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	  	}
	  });
	
	
	  // @factory L.icon(options: Icon options)
	  // Creates an icon instance with the given options.
	  function icon(options) {
	  	return new Icon(options);
	  }
	
	  /*
	   * @miniclass Icon.Default (Icon)
	   * @aka L.Icon.Default
	   * @section
	   *
	   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	   * no icon is specified. Points to the blue marker image distributed with Leaflet
	   * releases.
	   *
	   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	   * (which is a set of `Icon options`).
	   *
	   * If you want to _completely_ replace the default icon, override the
	   * `L.Marker.prototype.options.icon` with your own icon instead.
	   */
	
	  var IconDefault = Icon.extend({
	
	  	options: {
	  		iconUrl:       'marker-icon.png',
	  		iconRetinaUrl: 'marker-icon-2x.png',
	  		shadowUrl:     'marker-shadow.png',
	  		iconSize:    [25, 41],
	  		iconAnchor:  [12, 41],
	  		popupAnchor: [1, -34],
	  		tooltipAnchor: [16, -28],
	  		shadowSize:  [41, 41]
	  	},
	
	  	_getIconUrl: function (name) {
	  		if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
	  			IconDefault.imagePath = this._detectIconPath();
	  		}
	
	  		// @option imagePath: String
	  		// `Icon.Default` will try to auto-detect the location of the
	  		// blue icon images. If you are placing these images in a non-standard
	  		// way, set this option to point to the right path.
	  		return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
	  	},
	
	  	_detectIconPath: function () {
	  		var el = create$1('div',  'leaflet-default-icon-path', document.body);
	  		var path = getStyle(el, 'background-image') ||
	  		           getStyle(el, 'backgroundImage');	// IE8
	
	  		document.body.removeChild(el);
	
	  		if (path === null || path.indexOf('url') !== 0) {
	  			path = '';
	  		} else {
	  			path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
	  		}
	
	  		return path;
	  	}
	  });
	
	  /*
	   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	   */
	
	
	  /* @namespace Marker
	   * @section Interaction handlers
	   *
	   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	   *
	   * ```js
	   * marker.dragging.disable();
	   * ```
	   *
	   * @property dragging: Handler
	   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	   */
	
	  var MarkerDrag = Handler.extend({
	  	initialize: function (marker) {
	  		this._marker = marker;
	  	},
	
	  	addHooks: function () {
	  		var icon = this._marker._icon;
	
	  		if (!this._draggable) {
	  			this._draggable = new Draggable(icon, icon, true);
	  		}
	
	  		this._draggable.on({
	  			dragstart: this._onDragStart,
	  			predrag: this._onPreDrag,
	  			drag: this._onDrag,
	  			dragend: this._onDragEnd
	  		}, this).enable();
	
	  		addClass(icon, 'leaflet-marker-draggable');
	  	},
	
	  	removeHooks: function () {
	  		this._draggable.off({
	  			dragstart: this._onDragStart,
	  			predrag: this._onPreDrag,
	  			drag: this._onDrag,
	  			dragend: this._onDragEnd
	  		}, this).disable();
	
	  		if (this._marker._icon) {
	  			removeClass(this._marker._icon, 'leaflet-marker-draggable');
	  		}
	  	},
	
	  	moved: function () {
	  		return this._draggable && this._draggable._moved;
	  	},
	
	  	_adjustPan: function (e) {
	  		var marker = this._marker,
	  		    map = marker._map,
	  		    speed = this._marker.options.autoPanSpeed,
	  		    padding = this._marker.options.autoPanPadding,
	  		    iconPos = getPosition(marker._icon),
	  		    bounds = map.getPixelBounds(),
	  		    origin = map.getPixelOrigin();
	
	  		var panBounds = toBounds(
	  			bounds.min._subtract(origin).add(padding),
	  			bounds.max._subtract(origin).subtract(padding)
	  		);
	
	  		if (!panBounds.contains(iconPos)) {
	  			// Compute incremental movement
	  			var movement = toPoint(
	  				(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
	  				(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
	
	  				(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
	  				(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
	  			).multiplyBy(speed);
	
	  			map.panBy(movement, {animate: false});
	
	  			this._draggable._newPos._add(movement);
	  			this._draggable._startPos._add(movement);
	
	  			setPosition(marker._icon, this._draggable._newPos);
	  			this._onDrag(e);
	
	  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	  		}
	  	},
	
	  	_onDragStart: function () {
	  		// @section Dragging events
	  		// @event dragstart: Event
	  		// Fired when the user starts dragging the marker.
	
	  		// @event movestart: Event
	  		// Fired when the marker starts moving (because of dragging).
	
	  		this._oldLatLng = this._marker.getLatLng();
	
	  		// When using ES6 imports it could not be set when `Popup` was not imported as well
	  		this._marker.closePopup && this._marker.closePopup();
	
	  		this._marker
	  			.fire('movestart')
	  			.fire('dragstart');
	  	},
	
	  	_onPreDrag: function (e) {
	  		if (this._marker.options.autoPan) {
	  			cancelAnimFrame(this._panRequest);
	  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	  		}
	  	},
	
	  	_onDrag: function (e) {
	  		var marker = this._marker,
	  		    shadow = marker._shadow,
	  		    iconPos = getPosition(marker._icon),
	  		    latlng = marker._map.layerPointToLatLng(iconPos);
	
	  		// update shadow position
	  		if (shadow) {
	  			setPosition(shadow, iconPos);
	  		}
	
	  		marker._latlng = latlng;
	  		e.latlng = latlng;
	  		e.oldLatLng = this._oldLatLng;
	
	  		// @event drag: Event
	  		// Fired repeatedly while the user drags the marker.
	  		marker
	  		    .fire('move', e)
	  		    .fire('drag', e);
	  	},
	
	  	_onDragEnd: function (e) {
	  		// @event dragend: DragEndEvent
	  		// Fired when the user stops dragging the marker.
	
	  		 cancelAnimFrame(this._panRequest);
	
	  		// @event moveend: Event
	  		// Fired when the marker stops moving (because of dragging).
	  		delete this._oldLatLng;
	  		this._marker
	  		    .fire('moveend')
	  		    .fire('dragend', e);
	  	}
	  });
	
	  /*
	   * @class Marker
	   * @inherits Interactive layer
	   * @aka L.Marker
	   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.marker([50.5, 30.5]).addTo(map);
	   * ```
	   */
	
	  var Marker = Layer.extend({
	
	  	// @section
	  	// @aka Marker options
	  	options: {
	  		// @option icon: Icon = *
	  		// Icon instance to use for rendering the marker.
	  		// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
	  		// If not specified, a common instance of `L.Icon.Default` is used.
	  		icon: new IconDefault(),
	
	  		// Option inherited from "Interactive layer" abstract class
	  		interactive: true,
	
	  		// @option keyboard: Boolean = true
	  		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
	  		keyboard: true,
	
	  		// @option title: String = ''
	  		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
	  		title: '',
	
	  		// @option alt: String = ''
	  		// Text for the `alt` attribute of the icon image (useful for accessibility).
	  		alt: '',
	
	  		// @option zIndexOffset: Number = 0
	  		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
	  		zIndexOffset: 0,
	
	  		// @option opacity: Number = 1.0
	  		// The opacity of the marker.
	  		opacity: 1,
	
	  		// @option riseOnHover: Boolean = false
	  		// If `true`, the marker will get on top of others when you hover the mouse over it.
	  		riseOnHover: false,
	
	  		// @option riseOffset: Number = 250
	  		// The z-index offset used for the `riseOnHover` feature.
	  		riseOffset: 250,
	
	  		// @option pane: String = 'markerPane'
	  		// `Map pane` where the markers icon will be added.
	  		pane: 'markerPane',
	
	  		// @option shadowPane: String = 'shadowPane'
	  		// `Map pane` where the markers shadow will be added.
	  		shadowPane: 'shadowPane',
	
	  		// @option bubblingMouseEvents: Boolean = false
	  		// When `true`, a mouse event on this marker will trigger the same event on the map
	  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	  		bubblingMouseEvents: false,
	
	  		// @section Draggable marker options
	  		// @option draggable: Boolean = false
	  		// Whether the marker is draggable with mouse/touch or not.
	  		draggable: false,
	
	  		// @option autoPan: Boolean = false
	  		// Whether to pan the map when dragging this marker near its edge or not.
	  		autoPan: false,
	
	  		// @option autoPanPadding: Point = Point(50, 50)
	  		// Distance (in pixels to the left/right and to the top/bottom) of the
	  		// map edge to start panning the map.
	  		autoPanPadding: [50, 50],
	
	  		// @option autoPanSpeed: Number = 10
	  		// Number of pixels the map should pan by.
	  		autoPanSpeed: 10
	  	},
	
	  	/* @section
	  	 *
	  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	  	 */
	
	  	initialize: function (latlng, options) {
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	  	},
	
	  	onAdd: function (map) {
	  		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
	  		if (this._zoomAnimated) {
	  			map.on('zoomanim', this._animateZoom, this);
	  		}
	
	  		this._initIcon();
	  		this.update();
	  	},
	
	  	onRemove: function (map) {
	  		if (this.dragging && this.dragging.enabled()) {
	  			this.options.draggable = true;
	  			this.dragging.removeHooks();
	  		}
	  		delete this.dragging;
	
	  		if (this._zoomAnimated) {
	  			map.off('zoomanim', this._animateZoom, this);
	  		}
	
	  		this._removeIcon();
	  		this._removeShadow();
	  	},
	
	  	getEvents: function () {
	  		return {
	  			zoom: this.update,
	  			viewreset: this.update
	  		};
	  	},
	
	  	// @method getLatLng: LatLng
	  	// Returns the current geographical position of the marker.
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setLatLng(latlng: LatLng): this
	  	// Changes the marker position to the given point.
	  	setLatLng: function (latlng) {
	  		var oldLatLng = this._latlng;
	  		this._latlng = toLatLng(latlng);
	  		this.update();
	
	  		// @event move: Event
	  		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	  	},
	
	  	// @method setZIndexOffset(offset: Number): this
	  	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	  	setZIndexOffset: function (offset) {
	  		this.options.zIndexOffset = offset;
	  		return this.update();
	  	},
	
	  	// @method getIcon: Icon
	  	// Returns the current icon used by the marker
	  	getIcon: function () {
	  		return this.options.icon;
	  	},
	
	  	// @method setIcon(icon: Icon): this
	  	// Changes the marker icon.
	  	setIcon: function (icon) {
	
	  		this.options.icon = icon;
	
	  		if (this._map) {
	  			this._initIcon();
	  			this.update();
	  		}
	
	  		if (this._popup) {
	  			this.bindPopup(this._popup, this._popup.options);
	  		}
	
	  		return this;
	  	},
	
	  	getElement: function () {
	  		return this._icon;
	  	},
	
	  	update: function () {
	
	  		if (this._icon && this._map) {
	  			var pos = this._map.latLngToLayerPoint(this._latlng).round();
	  			this._setPos(pos);
	  		}
	
	  		return this;
	  	},
	
	  	_initIcon: function () {
	  		var options = this.options,
	  		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
	  		var icon = options.icon.createIcon(this._icon),
	  		    addIcon = false;
	
	  		// if we're not reusing the icon, remove the old one and init new one
	  		if (icon !== this._icon) {
	  			if (this._icon) {
	  				this._removeIcon();
	  			}
	  			addIcon = true;
	
	  			if (options.title) {
	  				icon.title = options.title;
	  			}
	
	  			if (icon.tagName === 'IMG') {
	  				icon.alt = options.alt || '';
	  			}
	  		}
	
	  		addClass(icon, classToAdd);
	
	  		if (options.keyboard) {
	  			icon.tabIndex = '0';
	  		}
	
	  		this._icon = icon;
	
	  		if (options.riseOnHover) {
	  			this.on({
	  				mouseover: this._bringToFront,
	  				mouseout: this._resetZIndex
	  			});
	  		}
	
	  		var newShadow = options.icon.createShadow(this._shadow),
	  		    addShadow = false;
	
	  		if (newShadow !== this._shadow) {
	  			this._removeShadow();
	  			addShadow = true;
	  		}
	
	  		if (newShadow) {
	  			addClass(newShadow, classToAdd);
	  			newShadow.alt = '';
	  		}
	  		this._shadow = newShadow;
	
	
	  		if (options.opacity < 1) {
	  			this._updateOpacity();
	  		}
	
	
	  		if (addIcon) {
	  			this.getPane().appendChild(this._icon);
	  		}
	  		this._initInteraction();
	  		if (newShadow && addShadow) {
	  			this.getPane(options.shadowPane).appendChild(this._shadow);
	  		}
	  	},
	
	  	_removeIcon: function () {
	  		if (this.options.riseOnHover) {
	  			this.off({
	  				mouseover: this._bringToFront,
	  				mouseout: this._resetZIndex
	  			});
	  		}
	
	  		remove(this._icon);
	  		this.removeInteractiveTarget(this._icon);
	
	  		this._icon = null;
	  	},
	
	  	_removeShadow: function () {
	  		if (this._shadow) {
	  			remove(this._shadow);
	  		}
	  		this._shadow = null;
	  	},
	
	  	_setPos: function (pos) {
	
	  		if (this._icon) {
	  			setPosition(this._icon, pos);
	  		}
	
	  		if (this._shadow) {
	  			setPosition(this._shadow, pos);
	  		}
	
	  		this._zIndex = pos.y + this.options.zIndexOffset;
	
	  		this._resetZIndex();
	  	},
	
	  	_updateZIndex: function (offset) {
	  		if (this._icon) {
	  			this._icon.style.zIndex = this._zIndex + offset;
	  		}
	  	},
	
	  	_animateZoom: function (opt) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
	  		this._setPos(pos);
	  	},
	
	  	_initInteraction: function () {
	
	  		if (!this.options.interactive) { return; }
	
	  		addClass(this._icon, 'leaflet-interactive');
	
	  		this.addInteractiveTarget(this._icon);
	
	  		if (MarkerDrag) {
	  			var draggable = this.options.draggable;
	  			if (this.dragging) {
	  				draggable = this.dragging.enabled();
	  				this.dragging.disable();
	  			}
	
	  			this.dragging = new MarkerDrag(this);
	
	  			if (draggable) {
	  				this.dragging.enable();
	  			}
	  		}
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Changes the opacity of the marker.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	  		if (this._map) {
	  			this._updateOpacity();
	  		}
	
	  		return this;
	  	},
	
	  	_updateOpacity: function () {
	  		var opacity = this.options.opacity;
	
	  		if (this._icon) {
	  			setOpacity(this._icon, opacity);
	  		}
	
	  		if (this._shadow) {
	  			setOpacity(this._shadow, opacity);
	  		}
	  	},
	
	  	_bringToFront: function () {
	  		this._updateZIndex(this.options.riseOffset);
	  	},
	
	  	_resetZIndex: function () {
	  		this._updateZIndex(0);
	  	},
	
	  	_getPopupAnchor: function () {
	  		return this.options.icon.options.popupAnchor;
	  	},
	
	  	_getTooltipAnchor: function () {
	  		return this.options.icon.options.tooltipAnchor;
	  	}
	  });
	
	
	  // factory L.marker(latlng: LatLng, options? : Marker options)
	
	  // @factory L.marker(latlng: LatLng, options? : Marker options)
	  // Instantiates a Marker object given a geographical point and optionally an options object.
	  function marker(latlng, options) {
	  	return new Marker(latlng, options);
	  }
	
	  /*
	   * @class Path
	   * @aka L.Path
	   * @inherits Interactive layer
	   *
	   * An abstract class that contains options and constants shared between vector
	   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	   */
	
	  var Path = Layer.extend({
	
	  	// @section
	  	// @aka Path options
	  	options: {
	  		// @option stroke: Boolean = true
	  		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
	  		stroke: true,
	
	  		// @option color: String = '#3388ff'
	  		// Stroke color
	  		color: '#3388ff',
	
	  		// @option weight: Number = 3
	  		// Stroke width in pixels
	  		weight: 3,
	
	  		// @option opacity: Number = 1.0
	  		// Stroke opacity
	  		opacity: 1,
	
	  		// @option lineCap: String= 'round'
	  		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
	  		lineCap: 'round',
	
	  		// @option lineJoin: String = 'round'
	  		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
	  		lineJoin: 'round',
	
	  		// @option dashArray: String = null
	  		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	  		dashArray: null,
	
	  		// @option dashOffset: String = null
	  		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	  		dashOffset: null,
	
	  		// @option fill: Boolean = depends
	  		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
	  		fill: false,
	
	  		// @option fillColor: String = *
	  		// Fill color. Defaults to the value of the [`color`](#path-color) option
	  		fillColor: null,
	
	  		// @option fillOpacity: Number = 0.2
	  		// Fill opacity.
	  		fillOpacity: 0.2,
	
	  		// @option fillRule: String = 'evenodd'
	  		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
	  		fillRule: 'evenodd',
	
	  		// className: '',
	
	  		// Option inherited from "Interactive layer" abstract class
	  		interactive: true,
	
	  		// @option bubblingMouseEvents: Boolean = true
	  		// When `true`, a mouse event on this path will trigger the same event on the map
	  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	  		bubblingMouseEvents: true
	  	},
	
	  	beforeAdd: function (map) {
	  		// Renderer is set here because we need to call renderer.getEvents
	  		// before this.getEvents.
	  		this._renderer = map.getRenderer(this);
	  	},
	
	  	onAdd: function () {
	  		this._renderer._initPath(this);
	  		this._reset();
	  		this._renderer._addPath(this);
	  	},
	
	  	onRemove: function () {
	  		this._renderer._removePath(this);
	  	},
	
	  	// @method redraw(): this
	  	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	  	redraw: function () {
	  		if (this._map) {
	  			this._renderer._updatePath(this);
	  		}
	  		return this;
	  	},
	
	  	// @method setStyle(style: Path options): this
	  	// Changes the appearance of a Path based on the options in the `Path options` object.
	  	setStyle: function (style) {
	  		setOptions(this, style);
	  		if (this._renderer) {
	  			this._renderer._updateStyle(this);
	  			if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) {
	  				this._updateBounds();
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer to the top of all path layers.
	  	bringToFront: function () {
	  		if (this._renderer) {
	  			this._renderer._bringToFront(this);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer to the bottom of all path layers.
	  	bringToBack: function () {
	  		if (this._renderer) {
	  			this._renderer._bringToBack(this);
	  		}
	  		return this;
	  	},
	
	  	getElement: function () {
	  		return this._path;
	  	},
	
	  	_reset: function () {
	  		// defined in child classes
	  		this._project();
	  		this._update();
	  	},
	
	  	_clickTolerance: function () {
	  		// used when doing hit detection for Canvas layers
	  		return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
	  	}
	  });
	
	  /*
	   * @class CircleMarker
	   * @aka L.CircleMarker
	   * @inherits Path
	   *
	   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	   */
	
	  var CircleMarker = Path.extend({
	
	  	// @section
	  	// @aka CircleMarker options
	  	options: {
	  		fill: true,
	
	  		// @option radius: Number = 10
	  		// Radius of the circle marker, in pixels
	  		radius: 10
	  	},
	
	  	initialize: function (latlng, options) {
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	  		this._radius = this.options.radius;
	  	},
	
	  	// @method setLatLng(latLng: LatLng): this
	  	// Sets the position of a circle marker to a new location.
	  	setLatLng: function (latlng) {
	  		var oldLatLng = this._latlng;
	  		this._latlng = toLatLng(latlng);
	  		this.redraw();
	
	  		// @event move: Event
	  		// Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	  	},
	
	  	// @method getLatLng(): LatLng
	  	// Returns the current geographical position of the circle marker
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setRadius(radius: Number): this
	  	// Sets the radius of a circle marker. Units are in pixels.
	  	setRadius: function (radius) {
	  		this.options.radius = this._radius = radius;
	  		return this.redraw();
	  	},
	
	  	// @method getRadius(): Number
	  	// Returns the current radius of the circle
	  	getRadius: function () {
	  		return this._radius;
	  	},
	
	  	setStyle : function (options) {
	  		var radius = options && options.radius || this._radius;
	  		Path.prototype.setStyle.call(this, options);
	  		this.setRadius(radius);
	  		return this;
	  	},
	
	  	_project: function () {
	  		this._point = this._map.latLngToLayerPoint(this._latlng);
	  		this._updateBounds();
	  	},
	
	  	_updateBounds: function () {
	  		var r = this._radius,
	  		    r2 = this._radiusY || r,
	  		    w = this._clickTolerance(),
	  		    p = [r + w, r2 + w];
	  		this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
	  	},
	
	  	_update: function () {
	  		if (this._map) {
	  			this._updatePath();
	  		}
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updateCircle(this);
	  	},
	
	  	_empty: function () {
	  		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p) {
	  		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	  	}
	  });
	
	
	  // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	  // Instantiates a circle marker object given a geographical point, and an optional options object.
	  function circleMarker(latlng, options) {
	  	return new CircleMarker(latlng, options);
	  }
	
	  /*
	   * @class Circle
	   * @aka L.Circle
	   * @inherits CircleMarker
	   *
	   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	   *
	   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	   *
	   * @example
	   *
	   * ```js
	   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	   * ```
	   */
	
	  var Circle = CircleMarker.extend({
	
	  	initialize: function (latlng, options, legacyOptions) {
	  		if (typeof options === 'number') {
	  			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
	  			options = extend({}, legacyOptions, {radius: options});
	  		}
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	
	  		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
	  		// @section
	  		// @aka Circle options
	  		// @option radius: Number; Radius of the circle, in meters.
	  		this._mRadius = this.options.radius;
	  	},
	
	  	// @method setRadius(radius: Number): this
	  	// Sets the radius of a circle. Units are in meters.
	  	setRadius: function (radius) {
	  		this._mRadius = radius;
	  		return this.redraw();
	  	},
	
	  	// @method getRadius(): Number
	  	// Returns the current radius of a circle. Units are in meters.
	  	getRadius: function () {
	  		return this._mRadius;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the `LatLngBounds` of the path.
	  	getBounds: function () {
	  		var half = [this._radius, this._radiusY || this._radius];
	
	  		return new LatLngBounds(
	  			this._map.layerPointToLatLng(this._point.subtract(half)),
	  			this._map.layerPointToLatLng(this._point.add(half)));
	  	},
	
	  	setStyle: Path.prototype.setStyle,
	
	  	_project: function () {
	
	  		var lng = this._latlng.lng,
	  		    lat = this._latlng.lat,
	  		    map = this._map,
	  		    crs = map.options.crs;
	
	  		if (crs.distance === Earth.distance) {
	  			var d = Math.PI / 180,
	  			    latR = (this._mRadius / Earth.R) / d,
	  			    top = map.project([lat + latR, lng]),
	  			    bottom = map.project([lat - latR, lng]),
	  			    p = top.add(bottom).divideBy(2),
	  			    lat2 = map.unproject(p).lat,
	  			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
	  			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
	  			if (isNaN(lngR) || lngR === 0) {
	  				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
	  			}
	
	  			this._point = p.subtract(map.getPixelOrigin());
	  			this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
	  			this._radiusY = p.y - top.y;
	
	  		} else {
	  			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
	  			this._point = map.latLngToLayerPoint(this._latlng);
	  			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
	  		}
	
	  		this._updateBounds();
	  	}
	  });
	
	  // @factory L.circle(latlng: LatLng, options?: Circle options)
	  // Instantiates a circle object given a geographical point, and an options object
	  // which contains the circle radius.
	  // @alternative
	  // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	  // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	  // Do not use in new applications or plugins.
	  function circle(latlng, options, legacyOptions) {
	  	return new Circle(latlng, options, legacyOptions);
	  }
	
	  /*
	   * @class Polyline
	   * @aka L.Polyline
	   * @inherits Path
	   *
	   * A class for drawing polyline overlays on a map. Extends `Path`.
	   *
	   * @example
	   *
	   * ```js
	   * // create a red polyline from an array of LatLng points
	   * var latlngs = [
	   * 	[45.51, -122.68],
	   * 	[37.77, -122.43],
	   * 	[34.04, -118.2]
	   * ];
	   *
	   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	   *
	   * // zoom the map to the polyline
	   * map.fitBounds(polyline.getBounds());
	   * ```
	   *
	   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	   *
	   * ```js
	   * // create a red polyline from an array of arrays of LatLng points
	   * var latlngs = [
	   * 	[[45.51, -122.68],
	   * 	 [37.77, -122.43],
	   * 	 [34.04, -118.2]],
	   * 	[[40.78, -73.91],
	   * 	 [41.83, -87.62],
	   * 	 [32.76, -96.72]]
	   * ];
	   * ```
	   */
	
	
	  var Polyline = Path.extend({
	
	  	// @section
	  	// @aka Polyline options
	  	options: {
	  		// @option smoothFactor: Number = 1.0
	  		// How much to simplify the polyline on each zoom level. More means
	  		// better performance and smoother look, and less means more accurate representation.
	  		smoothFactor: 1.0,
	
	  		// @option noClip: Boolean = false
	  		// Disable polyline clipping.
	  		noClip: false
	  	},
	
	  	initialize: function (latlngs, options) {
	  		setOptions(this, options);
	  		this._setLatLngs(latlngs);
	  	},
	
	  	// @method getLatLngs(): LatLng[]
	  	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	  	getLatLngs: function () {
	  		return this._latlngs;
	  	},
	
	  	// @method setLatLngs(latlngs: LatLng[]): this
	  	// Replaces all the points in the polyline with the given array of geographical points.
	  	setLatLngs: function (latlngs) {
	  		this._setLatLngs(latlngs);
	  		return this.redraw();
	  	},
	
	  	// @method isEmpty(): Boolean
	  	// Returns `true` if the Polyline has no LatLngs.
	  	isEmpty: function () {
	  		return !this._latlngs.length;
	  	},
	
	  	// @method closestLayerPoint(p: Point): Point
	  	// Returns the point closest to `p` on the Polyline.
	  	closestLayerPoint: function (p) {
	  		var minDistance = Infinity,
	  		    minPoint = null,
	  		    closest = _sqClosestPointOnSegment,
	  		    p1, p2;
	
	  		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
	  			var points = this._parts[j];
	
	  			for (var i = 1, len = points.length; i < len; i++) {
	  				p1 = points[i - 1];
	  				p2 = points[i];
	
	  				var sqDist = closest(p, p1, p2, true);
	
	  				if (sqDist < minDistance) {
	  					minDistance = sqDist;
	  					minPoint = closest(p, p1, p2);
	  				}
	  			}
	  		}
	  		if (minPoint) {
	  			minPoint.distance = Math.sqrt(minDistance);
	  		}
	  		return minPoint;
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
	  	getCenter: function () {
	  		// throws error when not yet added to map as this center calculation requires projected coordinates
	  		if (!this._map) {
	  			throw new Error('Must add layer to map before using getCenter()');
	  		}
	
	  		var i, halfDist, segDist, dist, p1, p2, ratio,
	  		    points = this._rings[0],
	  		    len = points.length;
	
	  		if (!len) { return null; }
	
	  		// polyline centroid algorithm; only uses the first ring if there are multiple
	
	  		for (i = 0, halfDist = 0; i < len - 1; i++) {
	  			halfDist += points[i].distanceTo(points[i + 1]) / 2;
	  		}
	
	  		// The line is so small in the current view that all points are on the same pixel.
	  		if (halfDist === 0) {
	  			return this._map.layerPointToLatLng(points[0]);
	  		}
	
	  		for (i = 0, dist = 0; i < len - 1; i++) {
	  			p1 = points[i];
	  			p2 = points[i + 1];
	  			segDist = p1.distanceTo(p2);
	  			dist += segDist;
	
	  			if (dist > halfDist) {
	  				ratio = (dist - halfDist) / segDist;
	  				return this._map.layerPointToLatLng([
	  					p2.x - ratio * (p2.x - p1.x),
	  					p2.y - ratio * (p2.y - p1.y)
	  				]);
	  			}
	  		}
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the `LatLngBounds` of the path.
	  	getBounds: function () {
	  		return this._bounds;
	  	},
	
	  	// @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
	  	// Adds a given point to the polyline. By default, adds to the first ring of
	  	// the polyline in case of a multi-polyline, but can be overridden by passing
	  	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	  	addLatLng: function (latlng, latlngs) {
	  		latlngs = latlngs || this._defaultShape();
	  		latlng = toLatLng(latlng);
	  		latlngs.push(latlng);
	  		this._bounds.extend(latlng);
	  		return this.redraw();
	  	},
	
	  	_setLatLngs: function (latlngs) {
	  		this._bounds = new LatLngBounds();
	  		this._latlngs = this._convertLatLngs(latlngs);
	  	},
	
	  	_defaultShape: function () {
	  		return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
	  	},
	
	  	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	  	_convertLatLngs: function (latlngs) {
	  		var result = [],
	  		    flat = isFlat(latlngs);
	
	  		for (var i = 0, len = latlngs.length; i < len; i++) {
	  			if (flat) {
	  				result[i] = toLatLng(latlngs[i]);
	  				this._bounds.extend(result[i]);
	  			} else {
	  				result[i] = this._convertLatLngs(latlngs[i]);
	  			}
	  		}
	
	  		return result;
	  	},
	
	  	_project: function () {
	  		var pxBounds = new Bounds();
	  		this._rings = [];
	  		this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
	  		if (this._bounds.isValid() && pxBounds.isValid()) {
	  			this._rawPxBounds = pxBounds;
	  			this._updateBounds();
	  		}
	  	},
	
	  	_updateBounds: function () {
	  		var w = this._clickTolerance(),
	  		    p = new Point(w, w);
	  		this._pxBounds = new Bounds([
	  			this._rawPxBounds.min.subtract(p),
	  			this._rawPxBounds.max.add(p)
	  		]);
	  	},
	
	  	// recursively turns latlngs into a set of rings with projected coordinates
	  	_projectLatlngs: function (latlngs, result, projectedBounds) {
	  		var flat = latlngs[0] instanceof LatLng,
	  		    len = latlngs.length,
	  		    i, ring;
	
	  		if (flat) {
	  			ring = [];
	  			for (i = 0; i < len; i++) {
	  				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
	  				projectedBounds.extend(ring[i]);
	  			}
	  			result.push(ring);
	  		} else {
	  			for (i = 0; i < len; i++) {
	  				this._projectLatlngs(latlngs[i], result, projectedBounds);
	  			}
	  		}
	  	},
	
	  	// clip polyline by renderer bounds so that we have less to render for performance
	  	_clipPoints: function () {
	  		var bounds = this._renderer._bounds;
	
	  		this._parts = [];
	  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	  			return;
	  		}
	
	  		if (this.options.noClip) {
	  			this._parts = this._rings;
	  			return;
	  		}
	
	  		var parts = this._parts,
	  		    i, j, k, len, len2, segment, points;
	
	  		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
	  			points = this._rings[i];
	
	  			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
	  				segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
	  				if (!segment) { continue; }
	
	  				parts[k] = parts[k] || [];
	  				parts[k].push(segment[0]);
	
	  				// if segment goes out of screen, or it's the last one, it's the end of the line part
	  				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
	  					parts[k].push(segment[1]);
	  					k++;
	  				}
	  			}
	  		}
	  	},
	
	  	// simplify each clipped part of the polyline for performance
	  	_simplifyPoints: function () {
	  		var parts = this._parts,
	  		    tolerance = this.options.smoothFactor;
	
	  		for (var i = 0, len = parts.length; i < len; i++) {
	  			parts[i] = simplify(parts[i], tolerance);
	  		}
	  	},
	
	  	_update: function () {
	  		if (!this._map) { return; }
	
	  		this._clipPoints();
	  		this._simplifyPoints();
	  		this._updatePath();
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updatePoly(this);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p, closed) {
	  		var i, j, k, len, len2, part,
	  		    w = this._clickTolerance();
	
	  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
	  		// hit detection for polylines
	  		for (i = 0, len = this._parts.length; i < len; i++) {
	  			part = this._parts[i];
	
	  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	  				if (!closed && (j === 0)) { continue; }
	
	  				if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
	  					return true;
	  				}
	  			}
	  		}
	  		return false;
	  	}
	  });
	
	  // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	  // Instantiates a polyline object given an array of geographical points and
	  // optionally an options object. You can create a `Polyline` object with
	  // multiple separate lines (`MultiPolyline`) by passing an array of arrays
	  // of geographic points.
	  function polyline(latlngs, options) {
	  	return new Polyline(latlngs, options);
	  }
	
	  // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	  Polyline._flat = _flat;
	
	  /*
	   * @class Polygon
	   * @aka L.Polygon
	   * @inherits Polyline
	   *
	   * A class for drawing polygon overlays on a map. Extends `Polyline`.
	   *
	   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	   *
	   *
	   * @example
	   *
	   * ```js
	   * // create a red polygon from an array of LatLng points
	   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	   *
	   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	   *
	   * // zoom the map to the polygon
	   * map.fitBounds(polygon.getBounds());
	   * ```
	   *
	   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	   *
	   * ```js
	   * var latlngs = [
	   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	   * ];
	   * ```
	   *
	   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	   *
	   * ```js
	   * var latlngs = [
	   *   [ // first polygon
	   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	   *   ],
	   *   [ // second polygon
	   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	   *   ]
	   * ];
	   * ```
	   */
	
	  var Polygon = Polyline.extend({
	
	  	options: {
	  		fill: true
	  	},
	
	  	isEmpty: function () {
	  		return !this._latlngs.length || !this._latlngs[0].length;
	  	},
	
	  	getCenter: function () {
	  		// throws error when not yet added to map as this center calculation requires projected coordinates
	  		if (!this._map) {
	  			throw new Error('Must add layer to map before using getCenter()');
	  		}
	
	  		var i, j, p1, p2, f, area, x, y, center,
	  		    points = this._rings[0],
	  		    len = points.length;
	
	  		if (!len) { return null; }
	
	  		// polygon centroid algorithm; only uses the first ring if there are multiple
	
	  		area = x = y = 0;
	
	  		for (i = 0, j = len - 1; i < len; j = i++) {
	  			p1 = points[i];
	  			p2 = points[j];
	
	  			f = p1.y * p2.x - p2.y * p1.x;
	  			x += (p1.x + p2.x) * f;
	  			y += (p1.y + p2.y) * f;
	  			area += f * 3;
	  		}
	
	  		if (area === 0) {
	  			// Polygon is so small that all points are on same pixel.
	  			center = points[0];
	  		} else {
	  			center = [x / area, y / area];
	  		}
	  		return this._map.layerPointToLatLng(center);
	  	},
	
	  	_convertLatLngs: function (latlngs) {
	  		var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
	  		    len = result.length;
	
	  		// remove last point if it equals first one
	  		if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
	  			result.pop();
	  		}
	  		return result;
	  	},
	
	  	_setLatLngs: function (latlngs) {
	  		Polyline.prototype._setLatLngs.call(this, latlngs);
	  		if (isFlat(this._latlngs)) {
	  			this._latlngs = [this._latlngs];
	  		}
	  	},
	
	  	_defaultShape: function () {
	  		return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	  	},
	
	  	_clipPoints: function () {
	  		// polygons need a different clipping algorithm so we redefine that
	
	  		var bounds = this._renderer._bounds,
	  		    w = this.options.weight,
	  		    p = new Point(w, w);
	
	  		// increase clip padding by stroke width to avoid stroke on clip edges
	  		bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
	  		this._parts = [];
	  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	  			return;
	  		}
	
	  		if (this.options.noClip) {
	  			this._parts = this._rings;
	  			return;
	  		}
	
	  		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
	  			clipped = clipPolygon(this._rings[i], bounds, true);
	  			if (clipped.length) {
	  				this._parts.push(clipped);
	  			}
	  		}
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updatePoly(this, true);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p) {
	  		var inside = false,
	  		    part, p1, p2, i, j, k, len, len2;
	
	  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
	  		// ray casting algorithm for detecting if point is in polygon
	  		for (i = 0, len = this._parts.length; i < len; i++) {
	  			part = this._parts[i];
	
	  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	  				p1 = part[j];
	  				p2 = part[k];
	
	  				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
	  					inside = !inside;
	  				}
	  			}
	  		}
	
	  		// also check if it's on polygon stroke
	  		return inside || Polyline.prototype._containsPoint.call(this, p, true);
	  	}
	
	  });
	
	
	  // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	  function polygon(latlngs, options) {
	  	return new Polygon(latlngs, options);
	  }
	
	  /*
	   * @class GeoJSON
	   * @aka L.GeoJSON
	   * @inherits FeatureGroup
	   *
	   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	   *
	   * @example
	   *
	   * ```js
	   * L.geoJSON(data, {
	   * 	style: function (feature) {
	   * 		return {color: feature.properties.color};
	   * 	}
	   * }).bindPopup(function (layer) {
	   * 	return layer.feature.properties.description;
	   * }).addTo(map);
	   * ```
	   */
	
	  var GeoJSON = FeatureGroup.extend({
	
	  	/* @section
	  	 * @aka GeoJSON options
	  	 *
	  	 * @option pointToLayer: Function = *
	  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	  	 * The default is to spawn a default `Marker`:
	  	 * ```js
	  	 * function(geoJsonPoint, latlng) {
	  	 * 	return L.marker(latlng);
	  	 * }
	  	 * ```
	  	 *
	  	 * @option style: Function = *
	  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	  	 * called internally when data is added.
	  	 * The default value is to not override any defaults:
	  	 * ```js
	  	 * function (geoJsonFeature) {
	  	 * 	return {}
	  	 * }
	  	 * ```
	  	 *
	  	 * @option onEachFeature: Function = *
	  	 * A `Function` that will be called once for each created `Feature`, after it has
	  	 * been created and styled. Useful for attaching events and popups to features.
	  	 * The default is to do nothing with the newly created layers:
	  	 * ```js
	  	 * function (feature, layer) {}
	  	 * ```
	  	 *
	  	 * @option filter: Function = *
	  	 * A `Function` that will be used to decide whether to include a feature or not.
	  	 * The default is to include all features:
	  	 * ```js
	  	 * function (geoJsonFeature) {
	  	 * 	return true;
	  	 * }
	  	 * ```
	  	 * Note: dynamically changing the `filter` option will have effect only on newly
	  	 * added data. It will _not_ re-evaluate already included features.
	  	 *
	  	 * @option coordsToLatLng: Function = *
	  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	  	 * The default is the `coordsToLatLng` static method.
	  	 *
	  	 * @option markersInheritOptions: Boolean = false
	  	 * Whether default Markers for "Point" type Features inherit from group options.
	  	 */
	
	  	initialize: function (geojson, options) {
	  		setOptions(this, options);
	
	  		this._layers = {};
	
	  		if (geojson) {
	  			this.addData(geojson);
	  		}
	  	},
	
	  	// @method addData( <GeoJSON> data ): this
	  	// Adds a GeoJSON object to the layer.
	  	addData: function (geojson) {
	  		var features = isArray(geojson) ? geojson : geojson.features,
	  		    i, len, feature;
	
	  		if (features) {
	  			for (i = 0, len = features.length; i < len; i++) {
	  				// only add this if geometry or geometries are set and not null
	  				feature = features[i];
	  				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
	  					this.addData(feature);
	  				}
	  			}
	  			return this;
	  		}
	
	  		var options = this.options;
	
	  		if (options.filter && !options.filter(geojson)) { return this; }
	
	  		var layer = geometryToLayer(geojson, options);
	  		if (!layer) {
	  			return this;
	  		}
	  		layer.feature = asFeature(geojson);
	
	  		layer.defaultOptions = layer.options;
	  		this.resetStyle(layer);
	
	  		if (options.onEachFeature) {
	  			options.onEachFeature(geojson, layer);
	  		}
	
	  		return this.addLayer(layer);
	  	},
	
	  	// @method resetStyle( <Path> layer? ): this
	  	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	  	// If `layer` is omitted, the style of all features in the current layer is reset.
	  	resetStyle: function (layer) {
	  		if (layer === undefined) {
	  			return this.eachLayer(this.resetStyle, this);
	  		}
	  		// reset any custom styles
	  		layer.options = extend({}, layer.defaultOptions);
	  		this._setLayerStyle(layer, this.options.style);
	  		return this;
	  	},
	
	  	// @method setStyle( <Function> style ): this
	  	// Changes styles of GeoJSON vector layers with the given style function.
	  	setStyle: function (style) {
	  		return this.eachLayer(function (layer) {
	  			this._setLayerStyle(layer, style);
	  		}, this);
	  	},
	
	  	_setLayerStyle: function (layer, style) {
	  		if (layer.setStyle) {
	  			if (typeof style === 'function') {
	  				style = style(layer.feature);
	  			}
	  			layer.setStyle(style);
	  		}
	  	}
	  });
	
	  // @section
	  // There are several static functions which can be called without instantiating L.GeoJSON:
	
	  // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	  // Creates a `Layer` from a given GeoJSON feature. Can use a custom
	  // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	  // functions if provided as options.
	  function geometryToLayer(geojson, options) {
	
	  	var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	  	    coords = geometry ? geometry.coordinates : null,
	  	    layers = [],
	  	    pointToLayer = options && options.pointToLayer,
	  	    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
	  	    latlng, latlngs, i, len;
	
	  	if (!coords && !geometry) {
	  		return null;
	  	}
	
	  	switch (geometry.type) {
	  	case 'Point':
	  		latlng = _coordsToLatLng(coords);
	  		return _pointToLayer(pointToLayer, geojson, latlng, options);
	
	  	case 'MultiPoint':
	  		for (i = 0, len = coords.length; i < len; i++) {
	  			latlng = _coordsToLatLng(coords[i]);
	  			layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
	  		}
	  		return new FeatureGroup(layers);
	
	  	case 'LineString':
	  	case 'MultiLineString':
	  		latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
	  		return new Polyline(latlngs, options);
	
	  	case 'Polygon':
	  	case 'MultiPolygon':
	  		latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
	  		return new Polygon(latlngs, options);
	
	  	case 'GeometryCollection':
	  		for (i = 0, len = geometry.geometries.length; i < len; i++) {
	  			var layer = geometryToLayer({
	  				geometry: geometry.geometries[i],
	  				type: 'Feature',
	  				properties: geojson.properties
	  			}, options);
	
	  			if (layer) {
	  				layers.push(layer);
	  			}
	  		}
	  		return new FeatureGroup(layers);
	
	  	default:
	  		throw new Error('Invalid GeoJSON object.');
	  	}
	  }
	
	  function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
	  	return pointToLayerFn ?
	  		pointToLayerFn(geojson, latlng) :
	  		new Marker(latlng, options && options.markersInheritOptions && options);
	  }
	
	  // @function coordsToLatLng(coords: Array): LatLng
	  // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	  // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	  function coordsToLatLng(coords) {
	  	return new LatLng(coords[1], coords[0], coords[2]);
	  }
	
	  // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	  // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	  // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	  // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	  function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
	  	var latlngs = [];
	
	  	for (var i = 0, len = coords.length, latlng; i < len; i++) {
	  		latlng = levelsDeep ?
	  			coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
	  			(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
	  		latlngs.push(latlng);
	  	}
	
	  	return latlngs;
	  }
	
	  // @function latLngToCoords(latlng: LatLng, precision?: Number): Array
	  // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	  function latLngToCoords(latlng, precision) {
	  	precision = typeof precision === 'number' ? precision : 6;
	  	return latlng.alt !== undefined ?
	  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
	  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	  }
	
	  // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	  // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	  // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	  function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
	  	var coords = [];
	
	  	for (var i = 0, len = latlngs.length; i < len; i++) {
	  		coords.push(levelsDeep ?
	  			latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
	  			latLngToCoords(latlngs[i], precision));
	  	}
	
	  	if (!levelsDeep && closed) {
	  		coords.push(coords[0]);
	  	}
	
	  	return coords;
	  }
	
	  function getFeature(layer, newGeometry) {
	  	return layer.feature ?
	  		extend({}, layer.feature, {geometry: newGeometry}) :
	  		asFeature(newGeometry);
	  }
	
	  // @function asFeature(geojson: Object): Object
	  // Normalize GeoJSON geometries/features into GeoJSON features.
	  function asFeature(geojson) {
	  	if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
	  		return geojson;
	  	}
	
	  	return {
	  		type: 'Feature',
	  		properties: {},
	  		geometry: geojson
	  	};
	  }
	
	  var PointToGeoJSON = {
	  	toGeoJSON: function (precision) {
	  		return getFeature(this, {
	  			type: 'Point',
	  			coordinates: latLngToCoords(this.getLatLng(), precision)
	  		});
	  	}
	  };
	
	  // @namespace Marker
	  // @section Other methods
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	  Marker.include(PointToGeoJSON);
	
	  // @namespace CircleMarker
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	  Circle.include(PointToGeoJSON);
	  CircleMarker.include(PointToGeoJSON);
	
	
	  // @namespace Polyline
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	  Polyline.include({
	  	toGeoJSON: function (precision) {
	  		var multi = !isFlat(this._latlngs);
	
	  		var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
	  		return getFeature(this, {
	  			type: (multi ? 'Multi' : '') + 'LineString',
	  			coordinates: coords
	  		});
	  	}
	  });
	
	  // @namespace Polygon
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	  Polygon.include({
	  	toGeoJSON: function (precision) {
	  		var holes = !isFlat(this._latlngs),
	  		    multi = holes && !isFlat(this._latlngs[0]);
	
	  		var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
	  		if (!holes) {
	  			coords = [coords];
	  		}
	
	  		return getFeature(this, {
	  			type: (multi ? 'Multi' : '') + 'Polygon',
	  			coordinates: coords
	  		});
	  	}
	  });
	
	
	  // @namespace LayerGroup
	  LayerGroup.include({
	  	toMultiPoint: function (precision) {
	  		var coords = [];
	
	  		this.eachLayer(function (layer) {
	  			coords.push(layer.toGeoJSON(precision).geometry.coordinates);
	  		});
	
	  		return getFeature(this, {
	  			type: 'MultiPoint',
	  			coordinates: coords
	  		});
	  	},
	
	  	// @method toGeoJSON(precision?: Number): Object
	  	// `precision` is the number of decimal places for coordinates.
	  	// The default value is 6 places.
	  	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
	  	toGeoJSON: function (precision) {
	
	  		var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
	  		if (type === 'MultiPoint') {
	  			return this.toMultiPoint(precision);
	  		}
	
	  		var isGeometryCollection = type === 'GeometryCollection',
	  		    jsons = [];
	
	  		this.eachLayer(function (layer) {
	  			if (layer.toGeoJSON) {
	  				var json = layer.toGeoJSON(precision);
	  				if (isGeometryCollection) {
	  					jsons.push(json.geometry);
	  				} else {
	  					var feature = asFeature(json);
	  					// Squash nested feature collections
	  					if (feature.type === 'FeatureCollection') {
	  						jsons.push.apply(jsons, feature.features);
	  					} else {
	  						jsons.push(feature);
	  					}
	  				}
	  			}
	  		});
	
	  		if (isGeometryCollection) {
	  			return getFeature(this, {
	  				geometries: jsons,
	  				type: 'GeometryCollection'
	  			});
	  		}
	
	  		return {
	  			type: 'FeatureCollection',
	  			features: jsons
	  		};
	  	}
	  });
	
	  // @namespace GeoJSON
	  // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	  // Creates a GeoJSON layer. Optionally accepts an object in
	  // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	  // (you can alternatively add it later with `addData` method) and an `options` object.
	  function geoJSON(geojson, options) {
	  	return new GeoJSON(geojson, options);
	  }
	
	  // Backward compatibility.
	  var geoJson = geoJSON;
	
	  /*
	   * @class ImageOverlay
	   * @aka L.ImageOverlay
	   * @inherits Interactive layer
	   *
	   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	   * ```
	   */
	
	  var ImageOverlay = Layer.extend({
	
	  	// @section
	  	// @aka ImageOverlay options
	  	options: {
	  		// @option opacity: Number = 1.0
	  		// The opacity of the image overlay.
	  		opacity: 1,
	
	  		// @option alt: String = ''
	  		// Text for the `alt` attribute of the image (useful for accessibility).
	  		alt: '',
	
	  		// @option interactive: Boolean = false
	  		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
	  		interactive: false,
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the image.
	  		// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false,
	
	  		// @option errorOverlayUrl: String = ''
	  		// URL to the overlay image to show in place of the overlay that failed to load.
	  		errorOverlayUrl: '',
	
	  		// @option zIndex: Number = 1
	  		// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
	  		zIndex: 1,
	
	  		// @option className: String = ''
	  		// A custom class name to assign to the image. Empty by default.
	  		className: ''
	  	},
	
	  	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
	  		this._url = url;
	  		this._bounds = toLatLngBounds(bounds);
	
	  		setOptions(this, options);
	  	},
	
	  	onAdd: function () {
	  		if (!this._image) {
	  			this._initImage();
	
	  			if (this.options.opacity < 1) {
	  				this._updateOpacity();
	  			}
	  		}
	
	  		if (this.options.interactive) {
	  			addClass(this._image, 'leaflet-interactive');
	  			this.addInteractiveTarget(this._image);
	  		}
	
	  		this.getPane().appendChild(this._image);
	  		this._reset();
	  	},
	
	  	onRemove: function () {
	  		remove(this._image);
	  		if (this.options.interactive) {
	  			this.removeInteractiveTarget(this._image);
	  		}
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Sets the opacity of the overlay.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	
	  		if (this._image) {
	  			this._updateOpacity();
	  		}
	  		return this;
	  	},
	
	  	setStyle: function (styleOpts) {
	  		if (styleOpts.opacity) {
	  			this.setOpacity(styleOpts.opacity);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer to the top of all overlays.
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._image);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer to the bottom of all overlays.
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._image);
	  		}
	  		return this;
	  	},
	
	  	// @method setUrl(url: String): this
	  	// Changes the URL of the image.
	  	setUrl: function (url) {
	  		this._url = url;
	
	  		if (this._image) {
	  			this._image.src = url;
	  		}
	  		return this;
	  	},
	
	  	// @method setBounds(bounds: LatLngBounds): this
	  	// Update the bounds that this ImageOverlay covers
	  	setBounds: function (bounds) {
	  		this._bounds = toLatLngBounds(bounds);
	
	  		if (this._map) {
	  			this._reset();
	  		}
	  		return this;
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			zoom: this._reset,
	  			viewreset: this._reset
	  		};
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	
	  		return events;
	  	},
	
	  	// @method setZIndex(value: Number): this
	  	// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
	  	setZIndex: function (value) {
	  		this.options.zIndex = value;
	  		this._updateZIndex();
	  		return this;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Get the bounds that this ImageOverlay covers
	  	getBounds: function () {
	  		return this._bounds;
	  	},
	
	  	// @method getElement(): HTMLElement
	  	// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
	  	// used by this overlay.
	  	getElement: function () {
	  		return this._image;
	  	},
	
	  	_initImage: function () {
	  		var wasElementSupplied = this._url.tagName === 'IMG';
	  		var img = this._image = wasElementSupplied ? this._url : create$1('img');
	
	  		addClass(img, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(img, this.options.className); }
	
	  		img.onselectstart = falseFn;
	  		img.onmousemove = falseFn;
	
	  		// @event load: Event
	  		// Fired when the ImageOverlay layer has loaded its image
	  		img.onload = bind(this.fire, this, 'load');
	  		img.onerror = bind(this._overlayOnError, this, 'error');
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		if (this.options.zIndex) {
	  			this._updateZIndex();
	  		}
	
	  		if (wasElementSupplied) {
	  			this._url = img.src;
	  			return;
	  		}
	
	  		img.src = this._url;
	  		img.alt = this.options.alt;
	  	},
	
	  	_animateZoom: function (e) {
	  		var scale = this._map.getZoomScale(e.zoom),
	  		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
	  		setTransform(this._image, offset, scale);
	  	},
	
	  	_reset: function () {
	  		var image = this._image,
	  		    bounds = new Bounds(
	  		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
	  		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
	  		    size = bounds.getSize();
	
	  		setPosition(image, bounds.min);
	
	  		image.style.width  = size.x + 'px';
	  		image.style.height = size.y + 'px';
	  	},
	
	  	_updateOpacity: function () {
	  		setOpacity(this._image, this.options.opacity);
	  	},
	
	  	_updateZIndex: function () {
	  		if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	  			this._image.style.zIndex = this.options.zIndex;
	  		}
	  	},
	
	  	_overlayOnError: function () {
	  		// @event error: Event
	  		// Fired when the ImageOverlay layer fails to load its image
	  		this.fire('error');
	
	  		var errorUrl = this.options.errorOverlayUrl;
	  		if (errorUrl && this._url !== errorUrl) {
	  			this._url = errorUrl;
	  			this._image.src = errorUrl;
	  		}
	  	}
	  });
	
	  // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	  // Instantiates an image overlay object given the URL of the image and the
	  // geographical bounds it is tied to.
	  var imageOverlay = function (url, bounds, options) {
	  	return new ImageOverlay(url, bounds, options);
	  };
	
	  /*
	   * @class VideoOverlay
	   * @aka L.VideoOverlay
	   * @inherits ImageOverlay
	   *
	   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	   *
	   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	   * HTML5 element.
	   *
	   * @example
	   *
	   * ```js
	   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	   * 	videoBounds = [[ 32, -130], [ 13, -100]];
	   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	   * ```
	   */
	
	  var VideoOverlay = ImageOverlay.extend({
	
	  	// @section
	  	// @aka VideoOverlay options
	  	options: {
	  		// @option autoplay: Boolean = true
	  		// Whether the video starts playing automatically when loaded.
	  		autoplay: true,
	
	  		// @option loop: Boolean = true
	  		// Whether the video will loop back to the beginning when played.
	  		loop: true,
	
	  		// @option keepAspectRatio: Boolean = true
	  		// Whether the video will save aspect ratio after the projection.
	  		// Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
	  		keepAspectRatio: true,
	
	  		// @option muted: Boolean = false
	  		// Whether the video starts on mute when loaded.
	  		muted: false
	  	},
	
	  	_initImage: function () {
	  		var wasElementSupplied = this._url.tagName === 'VIDEO';
	  		var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
	  		addClass(vid, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(vid, this.options.className); }
	
	  		vid.onselectstart = falseFn;
	  		vid.onmousemove = falseFn;
	
	  		// @event load: Event
	  		// Fired when the video has finished loading the first frame
	  		vid.onloadeddata = bind(this.fire, this, 'load');
	
	  		if (wasElementSupplied) {
	  			var sourceElements = vid.getElementsByTagName('source');
	  			var sources = [];
	  			for (var j = 0; j < sourceElements.length; j++) {
	  				sources.push(sourceElements[j].src);
	  			}
	
	  			this._url = (sourceElements.length > 0) ? sources : [vid.src];
	  			return;
	  		}
	
	  		if (!isArray(this._url)) { this._url = [this._url]; }
	
	  		if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) {
	  			vid.style['objectFit'] = 'fill';
	  		}
	  		vid.autoplay = !!this.options.autoplay;
	  		vid.loop = !!this.options.loop;
	  		vid.muted = !!this.options.muted;
	  		for (var i = 0; i < this._url.length; i++) {
	  			var source = create$1('source');
	  			source.src = this._url[i];
	  			vid.appendChild(source);
	  		}
	  	}
	
	  	// @method getElement(): HTMLVideoElement
	  	// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
	  	// used by this overlay.
	  });
	
	
	  // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	  // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	  // geographical bounds it is tied to.
	
	  function videoOverlay(video, bounds, options) {
	  	return new VideoOverlay(video, bounds, options);
	  }
	
	  /*
	   * @class SVGOverlay
	   * @aka L.SVGOverlay
	   * @inherits ImageOverlay
	   *
	   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
	   *
	   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
	   *
	   * @example
	   *
	   * ```js
	   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	   * svgElement.setAttribute('viewBox', "0 0 200 200");
	   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
	   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
	   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
	   * ```
	   */
	
	  var SVGOverlay = ImageOverlay.extend({
	  	_initImage: function () {
	  		var el = this._image = this._url;
	
	  		addClass(el, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(el, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(el, this.options.className); }
	
	  		el.onselectstart = falseFn;
	  		el.onmousemove = falseFn;
	  	}
	
	  	// @method getElement(): SVGElement
	  	// Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
	  	// used by this overlay.
	  });
	
	
	  // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
	  // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
	  // A viewBox attribute is required on the SVG element to zoom in and out properly.
	
	  function svgOverlay(el, bounds, options) {
	  	return new SVGOverlay(el, bounds, options);
	  }
	
	  /*
	   * @class DivOverlay
	   * @inherits Layer
	   * @aka L.DivOverlay
	   * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	   */
	
	  // @namespace DivOverlay
	  var DivOverlay = Layer.extend({
	
	  	// @section
	  	// @aka DivOverlay options
	  	options: {
	  		// @option offset: Point = Point(0, 7)
	  		// The offset of the popup position. Useful to control the anchor
	  		// of the popup when opening it on some overlays.
	  		offset: [0, 7],
	
	  		// @option className: String = ''
	  		// A custom CSS class name to assign to the popup.
	  		className: '',
	
	  		// @option pane: String = 'popupPane'
	  		// `Map pane` where the popup will be added.
	  		pane: 'popupPane'
	  	},
	
	  	initialize: function (options, source) {
	  		setOptions(this, options);
	
	  		this._source = source;
	  	},
	
	  	onAdd: function (map) {
	  		this._zoomAnimated = map._zoomAnimated;
	
	  		if (!this._container) {
	  			this._initLayout();
	  		}
	
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 0);
	  		}
	
	  		clearTimeout(this._removeTimeout);
	  		this.getPane().appendChild(this._container);
	  		this.update();
	
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 1);
	  		}
	
	  		this.bringToFront();
	  	},
	
	  	onRemove: function (map) {
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 0);
	  			this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
	  		} else {
	  			remove(this._container);
	  		}
	  	},
	
	  	// @namespace Popup
	  	// @method getLatLng: LatLng
	  	// Returns the geographical point of popup.
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setLatLng(latlng: LatLng): this
	  	// Sets the geographical point where the popup will open.
	  	setLatLng: function (latlng) {
	  		this._latlng = toLatLng(latlng);
	  		if (this._map) {
	  			this._updatePosition();
	  			this._adjustPan();
	  		}
	  		return this;
	  	},
	
	  	// @method getContent: String|HTMLElement
	  	// Returns the content of the popup.
	  	getContent: function () {
	  		return this._content;
	  	},
	
	  	// @method setContent(htmlContent: String|HTMLElement|Function): this
	  	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
	  	setContent: function (content) {
	  		this._content = content;
	  		this.update();
	  		return this;
	  	},
	
	  	// @method getElement: String|HTMLElement
	  	// Returns the HTML container of the popup.
	  	getElement: function () {
	  		return this._container;
	  	},
	
	  	// @method update: null
	  	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
	  	update: function () {
	  		if (!this._map) { return; }
	
	  		this._container.style.visibility = 'hidden';
	
	  		this._updateContent();
	  		this._updateLayout();
	  		this._updatePosition();
	
	  		this._container.style.visibility = '';
	
	  		this._adjustPan();
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			zoom: this._updatePosition,
	  			viewreset: this._updatePosition
	  		};
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	  		return events;
	  	},
	
	  	// @method isOpen: Boolean
	  	// Returns `true` when the popup is visible on the map.
	  	isOpen: function () {
	  		return !!this._map && this._map.hasLayer(this);
	  	},
	
	  	// @method bringToFront: this
	  	// Brings this popup in front of other popups (in the same map pane).
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._container);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack: this
	  	// Brings this popup to the back of other popups (in the same map pane).
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._container);
	  		}
	  		return this;
	  	},
	
	  	_prepareOpen: function (parent, layer, latlng) {
	  		if (!(layer instanceof Layer)) {
	  			latlng = layer;
	  			layer = parent;
	  		}
	
	  		if (layer instanceof FeatureGroup) {
	  			for (var id in parent._layers) {
	  				layer = parent._layers[id];
	  				break;
	  			}
	  		}
	
	  		if (!latlng) {
	  			if (layer.getCenter) {
	  				latlng = layer.getCenter();
	  			} else if (layer.getLatLng) {
	  				latlng = layer.getLatLng();
	  			} else {
	  				throw new Error('Unable to get source layer LatLng.');
	  			}
	  		}
	
	  		// set overlay source to this layer
	  		this._source = layer;
	
	  		// update the overlay (content, layout, ect...)
	  		this.update();
	
	  		return latlng;
	  	},
	
	  	_updateContent: function () {
	  		if (!this._content) { return; }
	
	  		var node = this._contentNode;
	  		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
	  		if (typeof content === 'string') {
	  			node.innerHTML = content;
	  		} else {
	  			while (node.hasChildNodes()) {
	  				node.removeChild(node.firstChild);
	  			}
	  			node.appendChild(content);
	  		}
	  		this.fire('contentupdate');
	  	},
	
	  	_updatePosition: function () {
	  		if (!this._map) { return; }
	
	  		var pos = this._map.latLngToLayerPoint(this._latlng),
	  		    offset = toPoint(this.options.offset),
	  		    anchor = this._getAnchor();
	
	  		if (this._zoomAnimated) {
	  			setPosition(this._container, pos.add(anchor));
	  		} else {
	  			offset = offset.add(pos).add(anchor);
	  		}
	
	  		var bottom = this._containerBottom = -offset.y,
	  		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
	  		// bottom position the popup in case the height of the popup changes (images loading etc)
	  		this._container.style.bottom = bottom + 'px';
	  		this._container.style.left = left + 'px';
	  	},
	
	  	_getAnchor: function () {
	  		return [0, 0];
	  	}
	
	  });
	
	  /*
	   * @class Popup
	   * @inherits DivOverlay
	   * @aka L.Popup
	   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	   * open popups while making sure that only one popup is open at one time
	   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	   *
	   * @example
	   *
	   * If you want to just bind a popup to marker click and then open it, it's really easy:
	   *
	   * ```js
	   * marker.bindPopup(popupContent).openPopup();
	   * ```
	   * Path overlays like polylines also have a `bindPopup` method.
	   * Here's a more complicated way to open a popup on a map:
	   *
	   * ```js
	   * var popup = L.popup()
	   * 	.setLatLng(latlng)
	   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	   * 	.openOn(map);
	   * ```
	   */
	
	
	  // @namespace Popup
	  var Popup = DivOverlay.extend({
	
	  	// @section
	  	// @aka Popup options
	  	options: {
	  		// @option maxWidth: Number = 300
	  		// Max width of the popup, in pixels.
	  		maxWidth: 300,
	
	  		// @option minWidth: Number = 50
	  		// Min width of the popup, in pixels.
	  		minWidth: 50,
	
	  		// @option maxHeight: Number = null
	  		// If set, creates a scrollable container of the given height
	  		// inside a popup if its content exceeds it.
	  		maxHeight: null,
	
	  		// @option autoPan: Boolean = true
	  		// Set it to `false` if you don't want the map to do panning animation
	  		// to fit the opened popup.
	  		autoPan: true,
	
	  		// @option autoPanPaddingTopLeft: Point = null
	  		// The margin between the popup and the top left corner of the map
	  		// view after autopanning was performed.
	  		autoPanPaddingTopLeft: null,
	
	  		// @option autoPanPaddingBottomRight: Point = null
	  		// The margin between the popup and the bottom right corner of the map
	  		// view after autopanning was performed.
	  		autoPanPaddingBottomRight: null,
	
	  		// @option autoPanPadding: Point = Point(5, 5)
	  		// Equivalent of setting both top left and bottom right autopan padding to the same value.
	  		autoPanPadding: [5, 5],
	
	  		// @option keepInView: Boolean = false
	  		// Set it to `true` if you want to prevent users from panning the popup
	  		// off of the screen while it is open.
	  		keepInView: false,
	
	  		// @option closeButton: Boolean = true
	  		// Controls the presence of a close button in the popup.
	  		closeButton: true,
	
	  		// @option autoClose: Boolean = true
	  		// Set it to `false` if you want to override the default behavior of
	  		// the popup closing when another popup is opened.
	  		autoClose: true,
	
	  		// @option closeOnEscapeKey: Boolean = true
	  		// Set it to `false` if you want to override the default behavior of
	  		// the ESC key for closing of the popup.
	  		closeOnEscapeKey: true,
	
	  		// @option closeOnClick: Boolean = *
	  		// Set it if you want to override the default behavior of the popup closing when user clicks
	  		// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
	  		// @option className: String = ''
	  		// A custom CSS class name to assign to the popup.
	  		className: ''
	  	},
	
	  	// @namespace Popup
	  	// @method openOn(map: Map): this
	  	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
	  	openOn: function (map) {
	  		map.openPopup(this);
	  		return this;
	  	},
	
	  	onAdd: function (map) {
	  		DivOverlay.prototype.onAdd.call(this, map);
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event popupopen: PopupEvent
	  		// Fired when a popup is opened in the map
	  		map.fire('popupopen', {popup: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Popup events
	  			// @event popupopen: PopupEvent
	  			// Fired when a popup bound to this layer is opened
	  			this._source.fire('popupopen', {popup: this}, true);
	  			// For non-path layers, we toggle the popup when clicking
	  			// again the layer, so prevent the map to reopen it.
	  			if (!(this._source instanceof Path)) {
	  				this._source.on('preclick', stopPropagation);
	  			}
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		DivOverlay.prototype.onRemove.call(this, map);
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event popupclose: PopupEvent
	  		// Fired when a popup in the map is closed
	  		map.fire('popupclose', {popup: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Popup events
	  			// @event popupclose: PopupEvent
	  			// Fired when a popup bound to this layer is closed
	  			this._source.fire('popupclose', {popup: this}, true);
	  			if (!(this._source instanceof Path)) {
	  				this._source.off('preclick', stopPropagation);
	  			}
	  		}
	  	},
	
	  	getEvents: function () {
	  		var events = DivOverlay.prototype.getEvents.call(this);
	
	  		if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
	  			events.preclick = this._close;
	  		}
	
	  		if (this.options.keepInView) {
	  			events.moveend = this._adjustPan;
	  		}
	
	  		return events;
	  	},
	
	  	_close: function () {
	  		if (this._map) {
	  			this._map.closePopup(this);
	  		}
	  	},
	
	  	_initLayout: function () {
	  		var prefix = 'leaflet-popup',
	  		    container = this._container = create$1('div',
	  			prefix + ' ' + (this.options.className || '') +
	  			' leaflet-zoom-animated');
	
	  		var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
	  		this._contentNode = create$1('div', prefix + '-content', wrapper);
	
	  		disableClickPropagation(container);
	  		disableScrollPropagation(this._contentNode);
	  		on(container, 'contextmenu', stopPropagation);
	
	  		this._tipContainer = create$1('div', prefix + '-tip-container', container);
	  		this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
	  		if (this.options.closeButton) {
	  			var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
	  			closeButton.href = '#close';
	  			closeButton.innerHTML = '&#215;';
	
	  			on(closeButton, 'click', this._onCloseButtonClick, this);
	  		}
	  	},
	
	  	_updateLayout: function () {
	  		var container = this._contentNode,
	  		    style = container.style;
	
	  		style.width = '';
	  		style.whiteSpace = 'nowrap';
	
	  		var width = container.offsetWidth;
	  		width = Math.min(width, this.options.maxWidth);
	  		width = Math.max(width, this.options.minWidth);
	
	  		style.width = (width + 1) + 'px';
	  		style.whiteSpace = '';
	
	  		style.height = '';
	
	  		var height = container.offsetHeight,
	  		    maxHeight = this.options.maxHeight,
	  		    scrolledClass = 'leaflet-popup-scrolled';
	
	  		if (maxHeight && height > maxHeight) {
	  			style.height = maxHeight + 'px';
	  			addClass(container, scrolledClass);
	  		} else {
	  			removeClass(container, scrolledClass);
	  		}
	
	  		this._containerWidth = this._container.offsetWidth;
	  	},
	
	  	_animateZoom: function (e) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
	  		    anchor = this._getAnchor();
	  		setPosition(this._container, pos.add(anchor));
	  	},
	
	  	_adjustPan: function () {
	  		if (!this.options.autoPan) { return; }
	  		if (this._map._panAnim) { this._map._panAnim.stop(); }
	
	  		var map = this._map,
	  		    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
	  		    containerHeight = this._container.offsetHeight + marginBottom,
	  		    containerWidth = this._containerWidth,
	  		    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
	  		layerPos._add(getPosition(this._container));
	
	  		var containerPos = map.layerPointToContainerPoint(layerPos),
	  		    padding = toPoint(this.options.autoPanPadding),
	  		    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
	  		    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
	  		    size = map.getSize(),
	  		    dx = 0,
	  		    dy = 0;
	
	  		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
	  			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
	  		}
	  		if (containerPos.x - dx - paddingTL.x < 0) { // left
	  			dx = containerPos.x - paddingTL.x;
	  		}
	  		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
	  			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
	  		}
	  		if (containerPos.y - dy - paddingTL.y < 0) { // top
	  			dy = containerPos.y - paddingTL.y;
	  		}
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event autopanstart: Event
	  		// Fired when the map starts autopanning when opening a popup.
	  		if (dx || dy) {
	  			map
	  			    .fire('autopanstart')
	  			    .panBy([dx, dy]);
	  		}
	  	},
	
	  	_onCloseButtonClick: function (e) {
	  		this._close();
	  		stop(e);
	  	},
	
	  	_getAnchor: function () {
	  		// Where should we anchor the popup on the source layer?
	  		return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	  	}
	
	  });
	
	  // @namespace Popup
	  // @factory L.popup(options?: Popup options, source?: Layer)
	  // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	  var popup = function (options, source) {
	  	return new Popup(options, source);
	  };
	
	
	  /* @namespace Map
	   * @section Interaction Options
	   * @option closePopupOnClick: Boolean = true
	   * Set it to `false` if you don't want popups to close when user clicks the map.
	   */
	  Map.mergeOptions({
	  	closePopupOnClick: true
	  });
	
	
	  // @namespace Map
	  // @section Methods for Layers and Controls
	  Map.include({
	  	// @method openPopup(popup: Popup): this
	  	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	  	// @alternative
	  	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	  	// Creates a popup with the specified content and options and opens it in the given point on a map.
	  	openPopup: function (popup, latlng, options) {
	  		if (!(popup instanceof Popup)) {
	  			popup = new Popup(options).setContent(popup);
	  		}
	
	  		if (latlng) {
	  			popup.setLatLng(latlng);
	  		}
	
	  		if (this.hasLayer(popup)) {
	  			return this;
	  		}
	
	  		if (this._popup && this._popup.options.autoClose) {
	  			this.closePopup();
	  		}
	
	  		this._popup = popup;
	  		return this.addLayer(popup);
	  	},
	
	  	// @method closePopup(popup?: Popup): this
	  	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	  	closePopup: function (popup) {
	  		if (!popup || popup === this._popup) {
	  			popup = this._popup;
	  			this._popup = null;
	  		}
	  		if (popup) {
	  			this.removeLayer(popup);
	  		}
	  		return this;
	  	}
	  });
	
	  /*
	   * @namespace Layer
	   * @section Popup methods example
	   *
	   * All layers share a set of methods convenient for binding popups to it.
	   *
	   * ```js
	   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	   * layer.openPopup();
	   * layer.closePopup();
	   * ```
	   *
	   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	   */
	
	  // @section Popup methods
	  Layer.include({
	
	  	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	  	// Binds a popup to the layer with the passed `content` and sets up the
	  	// necessary event listeners. If a `Function` is passed it will receive
	  	// the layer as the first argument and should return a `String` or `HTMLElement`.
	  	bindPopup: function (content, options) {
	
	  		if (content instanceof Popup) {
	  			setOptions(content, options);
	  			this._popup = content;
	  			content._source = this;
	  		} else {
	  			if (!this._popup || options) {
	  				this._popup = new Popup(options, this);
	  			}
	  			this._popup.setContent(content);
	  		}
	
	  		if (!this._popupHandlersAdded) {
	  			this.on({
	  				click: this._openPopup,
	  				keypress: this._onKeyPress,
	  				remove: this.closePopup,
	  				move: this._movePopup
	  			});
	  			this._popupHandlersAdded = true;
	  		}
	
	  		return this;
	  	},
	
	  	// @method unbindPopup(): this
	  	// Removes the popup previously bound with `bindPopup`.
	  	unbindPopup: function () {
	  		if (this._popup) {
	  			this.off({
	  				click: this._openPopup,
	  				keypress: this._onKeyPress,
	  				remove: this.closePopup,
	  				move: this._movePopup
	  			});
	  			this._popupHandlersAdded = false;
	  			this._popup = null;
	  		}
	  		return this;
	  	},
	
	  	// @method openPopup(latlng?: LatLng): this
	  	// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
	  	openPopup: function (layer, latlng) {
	  		if (this._popup && this._map) {
	  			latlng = this._popup._prepareOpen(this, layer, latlng);
	
	  			// open the popup on the map
	  			this._map.openPopup(this._popup, latlng);
	  		}
	
	  		return this;
	  	},
	
	  	// @method closePopup(): this
	  	// Closes the popup bound to this layer if it is open.
	  	closePopup: function () {
	  		if (this._popup) {
	  			this._popup._close();
	  		}
	  		return this;
	  	},
	
	  	// @method togglePopup(): this
	  	// Opens or closes the popup bound to this layer depending on its current state.
	  	togglePopup: function (target) {
	  		if (this._popup) {
	  			if (this._popup._map) {
	  				this.closePopup();
	  			} else {
	  				this.openPopup(target);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method isPopupOpen(): boolean
	  	// Returns `true` if the popup bound to this layer is currently open.
	  	isPopupOpen: function () {
	  		return (this._popup ? this._popup.isOpen() : false);
	  	},
	
	  	// @method setPopupContent(content: String|HTMLElement|Popup): this
	  	// Sets the content of the popup bound to this layer.
	  	setPopupContent: function (content) {
	  		if (this._popup) {
	  			this._popup.setContent(content);
	  		}
	  		return this;
	  	},
	
	  	// @method getPopup(): Popup
	  	// Returns the popup bound to this layer.
	  	getPopup: function () {
	  		return this._popup;
	  	},
	
	  	_openPopup: function (e) {
	  		var layer = e.layer || e.target;
	
	  		if (!this._popup) {
	  			return;
	  		}
	
	  		if (!this._map) {
	  			return;
	  		}
	
	  		// prevent map click
	  		stop(e);
	
	  		// if this inherits from Path its a vector and we can just
	  		// open the popup at the new location
	  		if (layer instanceof Path) {
	  			this.openPopup(e.layer || e.target, e.latlng);
	  			return;
	  		}
	
	  		// otherwise treat it like a marker and figure out
	  		// if we should toggle it open/closed
	  		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
	  			this.closePopup();
	  		} else {
	  			this.openPopup(layer, e.latlng);
	  		}
	  	},
	
	  	_movePopup: function (e) {
	  		this._popup.setLatLng(e.latlng);
	  	},
	
	  	_onKeyPress: function (e) {
	  		if (e.originalEvent.keyCode === 13) {
	  			this._openPopup(e);
	  		}
	  	}
	  });
	
	  /*
	   * @class Tooltip
	   * @inherits DivOverlay
	   * @aka L.Tooltip
	   * Used to display small texts on top of map layers.
	   *
	   * @example
	   *
	   * ```js
	   * marker.bindTooltip("my tooltip text").openTooltip();
	   * ```
	   * Note about tooltip offset. Leaflet takes two options in consideration
	   * for computing tooltip offsetting:
	   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	   *   move it to the bottom. Negatives will move to the left and top.
	   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	   *   should adapt this value if you use a custom icon.
	   */
	
	
	  // @namespace Tooltip
	  var Tooltip = DivOverlay.extend({
	
	  	// @section
	  	// @aka Tooltip options
	  	options: {
	  		// @option pane: String = 'tooltipPane'
	  		// `Map pane` where the tooltip will be added.
	  		pane: 'tooltipPane',
	
	  		// @option offset: Point = Point(0, 0)
	  		// Optional offset of the tooltip position.
	  		offset: [0, 0],
	
	  		// @option direction: String = 'auto'
	  		// Direction where to open the tooltip. Possible values are: `right`, `left`,
	  		// `top`, `bottom`, `center`, `auto`.
	  		// `auto` will dynamically switch between `right` and `left` according to the tooltip
	  		// position on the map.
	  		direction: 'auto',
	
	  		// @option permanent: Boolean = false
	  		// Whether to open the tooltip permanently or only on mouseover.
	  		permanent: false,
	
	  		// @option sticky: Boolean = false
	  		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
	  		sticky: false,
	
	  		// @option interactive: Boolean = false
	  		// If true, the tooltip will listen to the feature events.
	  		interactive: false,
	
	  		// @option opacity: Number = 0.9
	  		// Tooltip container opacity.
	  		opacity: 0.9
	  	},
	
	  	onAdd: function (map) {
	  		DivOverlay.prototype.onAdd.call(this, map);
	  		this.setOpacity(this.options.opacity);
	
	  		// @namespace Map
	  		// @section Tooltip events
	  		// @event tooltipopen: TooltipEvent
	  		// Fired when a tooltip is opened in the map.
	  		map.fire('tooltipopen', {tooltip: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Tooltip events
	  			// @event tooltipopen: TooltipEvent
	  			// Fired when a tooltip bound to this layer is opened.
	  			this._source.fire('tooltipopen', {tooltip: this}, true);
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		DivOverlay.prototype.onRemove.call(this, map);
	
	  		// @namespace Map
	  		// @section Tooltip events
	  		// @event tooltipclose: TooltipEvent
	  		// Fired when a tooltip in the map is closed.
	  		map.fire('tooltipclose', {tooltip: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Tooltip events
	  			// @event tooltipclose: TooltipEvent
	  			// Fired when a tooltip bound to this layer is closed.
	  			this._source.fire('tooltipclose', {tooltip: this}, true);
	  		}
	  	},
	
	  	getEvents: function () {
	  		var events = DivOverlay.prototype.getEvents.call(this);
	
	  		if (touch && !this.options.permanent) {
	  			events.preclick = this._close;
	  		}
	
	  		return events;
	  	},
	
	  	_close: function () {
	  		if (this._map) {
	  			this._map.closeTooltip(this);
	  		}
	  	},
	
	  	_initLayout: function () {
	  		var prefix = 'leaflet-tooltip',
	  		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
	  		this._contentNode = this._container = create$1('div', className);
	  	},
	
	  	_updateLayout: function () {},
	
	  	_adjustPan: function () {},
	
	  	_setPosition: function (pos) {
	  		var subX, subY,
	  		    map = this._map,
	  		    container = this._container,
	  		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
	  		    tooltipPoint = map.layerPointToContainerPoint(pos),
	  		    direction = this.options.direction,
	  		    tooltipWidth = container.offsetWidth,
	  		    tooltipHeight = container.offsetHeight,
	  		    offset = toPoint(this.options.offset),
	  		    anchor = this._getAnchor();
	
	  		if (direction === 'top') {
	  			subX = tooltipWidth / 2;
	  			subY = tooltipHeight;
	  		} else if (direction === 'bottom') {
	  			subX = tooltipWidth / 2;
	  			subY = 0;
	  		} else if (direction === 'center') {
	  			subX = tooltipWidth / 2;
	  			subY = tooltipHeight / 2;
	  		} else if (direction === 'right') {
	  			subX = 0;
	  			subY = tooltipHeight / 2;
	  		} else if (direction === 'left') {
	  			subX = tooltipWidth;
	  			subY = tooltipHeight / 2;
	  		} else if (tooltipPoint.x < centerPoint.x) {
	  			direction = 'right';
	  			subX = 0;
	  			subY = tooltipHeight / 2;
	  		} else {
	  			direction = 'left';
	  			subX = tooltipWidth + (offset.x + anchor.x) * 2;
	  			subY = tooltipHeight / 2;
	  		}
	
	  		pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
	
	  		removeClass(container, 'leaflet-tooltip-right');
	  		removeClass(container, 'leaflet-tooltip-left');
	  		removeClass(container, 'leaflet-tooltip-top');
	  		removeClass(container, 'leaflet-tooltip-bottom');
	  		addClass(container, 'leaflet-tooltip-' + direction);
	  		setPosition(container, pos);
	  	},
	
	  	_updatePosition: function () {
	  		var pos = this._map.latLngToLayerPoint(this._latlng);
	  		this._setPosition(pos);
	  	},
	
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	
	  		if (this._container) {
	  			setOpacity(this._container, opacity);
	  		}
	  	},
	
	  	_animateZoom: function (e) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
	  		this._setPosition(pos);
	  	},
	
	  	_getAnchor: function () {
	  		// Where should we anchor the tooltip on the source layer?
	  		return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	  	}
	
	  });
	
	  // @namespace Tooltip
	  // @factory L.tooltip(options?: Tooltip options, source?: Layer)
	  // Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	  var tooltip = function (options, source) {
	  	return new Tooltip(options, source);
	  };
	
	  // @namespace Map
	  // @section Methods for Layers and Controls
	  Map.include({
	
	  	// @method openTooltip(tooltip: Tooltip): this
	  	// Opens the specified tooltip.
	  	// @alternative
	  	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	  	// Creates a tooltip with the specified content and options and open it.
	  	openTooltip: function (tooltip, latlng, options) {
	  		if (!(tooltip instanceof Tooltip)) {
	  			tooltip = new Tooltip(options).setContent(tooltip);
	  		}
	
	  		if (latlng) {
	  			tooltip.setLatLng(latlng);
	  		}
	
	  		if (this.hasLayer(tooltip)) {
	  			return this;
	  		}
	
	  		return this.addLayer(tooltip);
	  	},
	
	  	// @method closeTooltip(tooltip?: Tooltip): this
	  	// Closes the tooltip given as parameter.
	  	closeTooltip: function (tooltip) {
	  		if (tooltip) {
	  			this.removeLayer(tooltip);
	  		}
	  		return this;
	  	}
	
	  });
	
	  /*
	   * @namespace Layer
	   * @section Tooltip methods example
	   *
	   * All layers share a set of methods convenient for binding tooltips to it.
	   *
	   * ```js
	   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	   * layer.openTooltip();
	   * layer.closeTooltip();
	   * ```
	   */
	
	  // @section Tooltip methods
	  Layer.include({
	
	  	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	  	// Binds a tooltip to the layer with the passed `content` and sets up the
	  	// necessary event listeners. If a `Function` is passed it will receive
	  	// the layer as the first argument and should return a `String` or `HTMLElement`.
	  	bindTooltip: function (content, options) {
	
	  		if (content instanceof Tooltip) {
	  			setOptions(content, options);
	  			this._tooltip = content;
	  			content._source = this;
	  		} else {
	  			if (!this._tooltip || options) {
	  				this._tooltip = new Tooltip(options, this);
	  			}
	  			this._tooltip.setContent(content);
	
	  		}
	
	  		this._initTooltipInteractions();
	
	  		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
	  			this.openTooltip();
	  		}
	
	  		return this;
	  	},
	
	  	// @method unbindTooltip(): this
	  	// Removes the tooltip previously bound with `bindTooltip`.
	  	unbindTooltip: function () {
	  		if (this._tooltip) {
	  			this._initTooltipInteractions(true);
	  			this.closeTooltip();
	  			this._tooltip = null;
	  		}
	  		return this;
	  	},
	
	  	_initTooltipInteractions: function (remove$$1) {
	  		if (!remove$$1 && this._tooltipHandlersAdded) { return; }
	  		var onOff = remove$$1 ? 'off' : 'on',
	  		    events = {
	  			remove: this.closeTooltip,
	  			move: this._moveTooltip
	  		    };
	  		if (!this._tooltip.options.permanent) {
	  			events.mouseover = this._openTooltip;
	  			events.mouseout = this.closeTooltip;
	  			if (this._tooltip.options.sticky) {
	  				events.mousemove = this._moveTooltip;
	  			}
	  			if (touch) {
	  				events.click = this._openTooltip;
	  			}
	  		} else {
	  			events.add = this._openTooltip;
	  		}
	  		this[onOff](events);
	  		this._tooltipHandlersAdded = !remove$$1;
	  	},
	
	  	// @method openTooltip(latlng?: LatLng): this
	  	// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
	  	openTooltip: function (layer, latlng) {
	  		if (this._tooltip && this._map) {
	  			latlng = this._tooltip._prepareOpen(this, layer, latlng);
	
	  			// open the tooltip on the map
	  			this._map.openTooltip(this._tooltip, latlng);
	
	  			// Tooltip container may not be defined if not permanent and never
	  			// opened.
	  			if (this._tooltip.options.interactive && this._tooltip._container) {
	  				addClass(this._tooltip._container, 'leaflet-clickable');
	  				this.addInteractiveTarget(this._tooltip._container);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method closeTooltip(): this
	  	// Closes the tooltip bound to this layer if it is open.
	  	closeTooltip: function () {
	  		if (this._tooltip) {
	  			this._tooltip._close();
	  			if (this._tooltip.options.interactive && this._tooltip._container) {
	  				removeClass(this._tooltip._container, 'leaflet-clickable');
	  				this.removeInteractiveTarget(this._tooltip._container);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method toggleTooltip(): this
	  	// Opens or closes the tooltip bound to this layer depending on its current state.
	  	toggleTooltip: function (target) {
	  		if (this._tooltip) {
	  			if (this._tooltip._map) {
	  				this.closeTooltip();
	  			} else {
	  				this.openTooltip(target);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method isTooltipOpen(): boolean
	  	// Returns `true` if the tooltip bound to this layer is currently open.
	  	isTooltipOpen: function () {
	  		return this._tooltip.isOpen();
	  	},
	
	  	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	  	// Sets the content of the tooltip bound to this layer.
	  	setTooltipContent: function (content) {
	  		if (this._tooltip) {
	  			this._tooltip.setContent(content);
	  		}
	  		return this;
	  	},
	
	  	// @method getTooltip(): Tooltip
	  	// Returns the tooltip bound to this layer.
	  	getTooltip: function () {
	  		return this._tooltip;
	  	},
	
	  	_openTooltip: function (e) {
	  		var layer = e.layer || e.target;
	
	  		if (!this._tooltip || !this._map) {
	  			return;
	  		}
	  		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
	  	},
	
	  	_moveTooltip: function (e) {
	  		var latlng = e.latlng, containerPoint, layerPoint;
	  		if (this._tooltip.options.sticky && e.originalEvent) {
	  			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
	  			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
	  			latlng = this._map.layerPointToLatLng(layerPoint);
	  		}
	  		this._tooltip.setLatLng(latlng);
	  	}
	  });
	
	  /*
	   * @class DivIcon
	   * @aka L.DivIcon
	   * @inherits Icon
	   *
	   * Represents a lightweight icon for markers that uses a simple `<div>`
	   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	   *
	   * @example
	   * ```js
	   * var myIcon = L.divIcon({className: 'my-div-icon'});
	   * // you can set .my-div-icon styles in CSS
	   *
	   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	   * ```
	   *
	   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	   */
	
	  var DivIcon = Icon.extend({
	  	options: {
	  		// @section
	  		// @aka DivIcon options
	  		iconSize: [12, 12], // also can be set through CSS
	
	  		// iconAnchor: (Point),
	  		// popupAnchor: (Point),
	
	  		// @option html: String|HTMLElement = ''
	  		// Custom HTML code to put inside the div element, empty by default. Alternatively,
	  		// an instance of `HTMLElement`.
	  		html: false,
	
	  		// @option bgPos: Point = [0, 0]
	  		// Optional relative position of the background, in pixels
	  		bgPos: null,
	
	  		className: 'leaflet-div-icon'
	  	},
	
	  	createIcon: function (oldIcon) {
	  		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
	  		    options = this.options;
	
	  		if (options.html instanceof Element) {
	  			empty(div);
	  			div.appendChild(options.html);
	  		} else {
	  			div.innerHTML = options.html !== false ? options.html : '';
	  		}
	
	  		if (options.bgPos) {
	  			var bgPos = toPoint(options.bgPos);
	  			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
	  		}
	  		this._setIconStyles(div, 'icon');
	
	  		return div;
	  	},
	
	  	createShadow: function () {
	  		return null;
	  	}
	  });
	
	  // @factory L.divIcon(options: DivIcon options)
	  // Creates a `DivIcon` instance with the given options.
	  function divIcon(options) {
	  	return new DivIcon(options);
	  }
	
	  Icon.Default = IconDefault;
	
	  /*
	   * @class GridLayer
	   * @inherits Layer
	   * @aka L.GridLayer
	   *
	   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	   *
	   *
	   * @section Synchronous usage
	   * @example
	   *
	   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	   *
	   * ```js
	   * var CanvasLayer = L.GridLayer.extend({
	   *     createTile: function(coords){
	   *         // create a <canvas> element for drawing
	   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	   *
	   *         // setup tile width and height according to the options
	   *         var size = this.getTileSize();
	   *         tile.width = size.x;
	   *         tile.height = size.y;
	   *
	   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	   *         var ctx = tile.getContext('2d');
	   *
	   *         // return the tile so it can be rendered on screen
	   *         return tile;
	   *     }
	   * });
	   * ```
	   *
	   * @section Asynchronous usage
	   * @example
	   *
	   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	   *
	   * ```js
	   * var CanvasLayer = L.GridLayer.extend({
	   *     createTile: function(coords, done){
	   *         var error;
	   *
	   *         // create a <canvas> element for drawing
	   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	   *
	   *         // setup tile width and height according to the options
	   *         var size = this.getTileSize();
	   *         tile.width = size.x;
	   *         tile.height = size.y;
	   *
	   *         // draw something asynchronously and pass the tile to the done() callback
	   *         setTimeout(function() {
	   *             done(error, tile);
	   *         }, 1000);
	   *
	   *         return tile;
	   *     }
	   * });
	   * ```
	   *
	   * @section
	   */
	
	
	  var GridLayer = Layer.extend({
	
	  	// @section
	  	// @aka GridLayer options
	  	options: {
	  		// @option tileSize: Number|Point = 256
	  		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
	  		tileSize: 256,
	
	  		// @option opacity: Number = 1.0
	  		// Opacity of the tiles. Can be used in the `createTile()` function.
	  		opacity: 1,
	
	  		// @option updateWhenIdle: Boolean = (depends)
	  		// Load new tiles only when panning ends.
	  		// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
	  		// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
	  		// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
	  		updateWhenIdle: mobile,
	
	  		// @option updateWhenZooming: Boolean = true
	  		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
	  		updateWhenZooming: true,
	
	  		// @option updateInterval: Number = 200
	  		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
	  		updateInterval: 200,
	
	  		// @option zIndex: Number = 1
	  		// The explicit zIndex of the tile layer.
	  		zIndex: 1,
	
	  		// @option bounds: LatLngBounds = undefined
	  		// If set, tiles will only be loaded inside the set `LatLngBounds`.
	  		bounds: null,
	
	  		// @option minZoom: Number = 0
	  		// The minimum zoom level down to which this layer will be displayed (inclusive).
	  		minZoom: 0,
	
	  		// @option maxZoom: Number = undefined
	  		// The maximum zoom level up to which this layer will be displayed (inclusive).
	  		maxZoom: undefined,
	
	  		// @option maxNativeZoom: Number = undefined
	  		// Maximum zoom number the tile source has available. If it is specified,
	  		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
	  		// from `maxNativeZoom` level and auto-scaled.
	  		maxNativeZoom: undefined,
	
	  		// @option minNativeZoom: Number = undefined
	  		// Minimum zoom number the tile source has available. If it is specified,
	  		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
	  		// from `minNativeZoom` level and auto-scaled.
	  		minNativeZoom: undefined,
	
	  		// @option noWrap: Boolean = false
	  		// Whether the layer is wrapped around the antimeridian. If `true`, the
	  		// GridLayer will only be displayed once at low zoom levels. Has no
	  		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
	  		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
	  		// tiles outside the CRS limits.
	  		noWrap: false,
	
	  		// @option pane: String = 'tilePane'
	  		// `Map pane` where the grid layer will be added.
	  		pane: 'tilePane',
	
	  		// @option className: String = ''
	  		// A custom class name to assign to the tile layer. Empty by default.
	  		className: '',
	
	  		// @option keepBuffer: Number = 2
	  		// When panning the map, keep this many rows and columns of tiles before unloading them.
	  		keepBuffer: 2
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	onAdd: function () {
	  		this._initContainer();
	
	  		this._levels = {};
	  		this._tiles = {};
	
	  		this._resetView();
	  		this._update();
	  	},
	
	  	beforeAdd: function (map) {
	  		map._addZoomLimit(this);
	  	},
	
	  	onRemove: function (map) {
	  		this._removeAllTiles();
	  		remove(this._container);
	  		map._removeZoomLimit(this);
	  		this._container = null;
	  		this._tileZoom = undefined;
	  	},
	
	  	// @method bringToFront: this
	  	// Brings the tile layer to the top of all tile layers.
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._container);
	  			this._setAutoZIndex(Math.max);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack: this
	  	// Brings the tile layer to the bottom of all tile layers.
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._container);
	  			this._setAutoZIndex(Math.min);
	  		}
	  		return this;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTML element that contains the tiles for this layer.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	  		this._updateOpacity();
	  		return this;
	  	},
	
	  	// @method setZIndex(zIndex: Number): this
	  	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	  	setZIndex: function (zIndex) {
	  		this.options.zIndex = zIndex;
	  		this._updateZIndex();
	
	  		return this;
	  	},
	
	  	// @method isLoading: Boolean
	  	// Returns `true` if any tile in the grid layer has not finished loading.
	  	isLoading: function () {
	  		return this._loading;
	  	},
	
	  	// @method redraw: this
	  	// Causes the layer to clear all the tiles and request them again.
	  	redraw: function () {
	  		if (this._map) {
	  			this._removeAllTiles();
	  			this._update();
	  		}
	  		return this;
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			viewprereset: this._invalidateAll,
	  			viewreset: this._resetView,
	  			zoom: this._resetView,
	  			moveend: this._onMoveEnd
	  		};
	
	  		if (!this.options.updateWhenIdle) {
	  			// update tiles on move, but not more often than once per given interval
	  			if (!this._onMove) {
	  				this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
	  			}
	
	  			events.move = this._onMove;
	  		}
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	
	  		return events;
	  	},
	
	  	// @section Extension methods
	  	// Layers extending `GridLayer` shall reimplement the following method.
	  	// @method createTile(coords: Object, done?: Function): HTMLElement
	  	// Called only internally, must be overridden by classes extending `GridLayer`.
	  	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	  	// is specified, it must be called when the tile has finished loading and drawing.
	  	createTile: function () {
	  		return document.createElement('div');
	  	},
	
	  	// @section
	  	// @method getTileSize: Point
	  	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	  	getTileSize: function () {
	  		var s = this.options.tileSize;
	  		return s instanceof Point ? s : new Point(s, s);
	  	},
	
	  	_updateZIndex: function () {
	  		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	  			this._container.style.zIndex = this.options.zIndex;
	  		}
	  	},
	
	  	_setAutoZIndex: function (compare) {
	  		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
	  		var layers = this.getPane().children,
	  		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
	  		for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
	  			zIndex = layers[i].style.zIndex;
	
	  			if (layers[i] !== this._container && zIndex) {
	  				edgeZIndex = compare(edgeZIndex, +zIndex);
	  			}
	  		}
	
	  		if (isFinite(edgeZIndex)) {
	  			this.options.zIndex = edgeZIndex + compare(-1, 1);
	  			this._updateZIndex();
	  		}
	  	},
	
	  	_updateOpacity: function () {
	  		if (!this._map) { return; }
	
	  		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
	  		if (ielt9) { return; }
	
	  		setOpacity(this._container, this.options.opacity);
	
	  		var now = +new Date(),
	  		    nextFrame = false,
	  		    willPrune = false;
	
	  		for (var key in this._tiles) {
	  			var tile = this._tiles[key];
	  			if (!tile.current || !tile.loaded) { continue; }
	
	  			var fade = Math.min(1, (now - tile.loaded) / 200);
	
	  			setOpacity(tile.el, fade);
	  			if (fade < 1) {
	  				nextFrame = true;
	  			} else {
	  				if (tile.active) {
	  					willPrune = true;
	  				} else {
	  					this._onOpaqueTile(tile);
	  				}
	  				tile.active = true;
	  			}
	  		}
	
	  		if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
	  		if (nextFrame) {
	  			cancelAnimFrame(this._fadeFrame);
	  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	  		}
	  	},
	
	  	_onOpaqueTile: falseFn,
	
	  	_initContainer: function () {
	  		if (this._container) { return; }
	
	  		this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
	  		this._updateZIndex();
	
	  		if (this.options.opacity < 1) {
	  			this._updateOpacity();
	  		}
	
	  		this.getPane().appendChild(this._container);
	  	},
	
	  	_updateLevels: function () {
	
	  		var zoom = this._tileZoom,
	  		    maxZoom = this.options.maxZoom;
	
	  		if (zoom === undefined) { return undefined; }
	
	  		for (var z in this._levels) {
	  			z = Number(z);
	  			if (this._levels[z].el.children.length || z === zoom) {
	  				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
	  				this._onUpdateLevel(z);
	  			} else {
	  				remove(this._levels[z].el);
	  				this._removeTilesAtZoom(z);
	  				this._onRemoveLevel(z);
	  				delete this._levels[z];
	  			}
	  		}
	
	  		var level = this._levels[zoom],
	  		    map = this._map;
	
	  		if (!level) {
	  			level = this._levels[zoom] = {};
	
	  			level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
	  			level.el.style.zIndex = maxZoom;
	
	  			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
	  			level.zoom = zoom;
	
	  			this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
	  			// force the browser to consider the newly added element for transition
	  			falseFn(level.el.offsetWidth);
	
	  			this._onCreateLevel(level);
	  		}
	
	  		this._level = level;
	
	  		return level;
	  	},
	
	  	_onUpdateLevel: falseFn,
	
	  	_onRemoveLevel: falseFn,
	
	  	_onCreateLevel: falseFn,
	
	  	_pruneTiles: function () {
	  		if (!this._map) {
	  			return;
	  		}
	
	  		var key, tile;
	
	  		var zoom = this._map.getZoom();
	  		if (zoom > this.options.maxZoom ||
	  			zoom < this.options.minZoom) {
	  			this._removeAllTiles();
	  			return;
	  		}
	
	  		for (key in this._tiles) {
	  			tile = this._tiles[key];
	  			tile.retain = tile.current;
	  		}
	
	  		for (key in this._tiles) {
	  			tile = this._tiles[key];
	  			if (tile.current && !tile.active) {
	  				var coords = tile.coords;
	  				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
	  					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
	  				}
	  			}
	  		}
	
	  		for (key in this._tiles) {
	  			if (!this._tiles[key].retain) {
	  				this._removeTile(key);
	  			}
	  		}
	  	},
	
	  	_removeTilesAtZoom: function (zoom) {
	  		for (var key in this._tiles) {
	  			if (this._tiles[key].coords.z !== zoom) {
	  				continue;
	  			}
	  			this._removeTile(key);
	  		}
	  	},
	
	  	_removeAllTiles: function () {
	  		for (var key in this._tiles) {
	  			this._removeTile(key);
	  		}
	  	},
	
	  	_invalidateAll: function () {
	  		for (var z in this._levels) {
	  			remove(this._levels[z].el);
	  			this._onRemoveLevel(Number(z));
	  			delete this._levels[z];
	  		}
	  		this._removeAllTiles();
	
	  		this._tileZoom = undefined;
	  	},
	
	  	_retainParent: function (x, y, z, minZoom) {
	  		var x2 = Math.floor(x / 2),
	  		    y2 = Math.floor(y / 2),
	  		    z2 = z - 1,
	  		    coords2 = new Point(+x2, +y2);
	  		coords2.z = +z2;
	
	  		var key = this._tileCoordsToKey(coords2),
	  		    tile = this._tiles[key];
	
	  		if (tile && tile.active) {
	  			tile.retain = true;
	  			return true;
	
	  		} else if (tile && tile.loaded) {
	  			tile.retain = true;
	  		}
	
	  		if (z2 > minZoom) {
	  			return this._retainParent(x2, y2, z2, minZoom);
	  		}
	
	  		return false;
	  	},
	
	  	_retainChildren: function (x, y, z, maxZoom) {
	
	  		for (var i = 2 * x; i < 2 * x + 2; i++) {
	  			for (var j = 2 * y; j < 2 * y + 2; j++) {
	
	  				var coords = new Point(i, j);
	  				coords.z = z + 1;
	
	  				var key = this._tileCoordsToKey(coords),
	  				    tile = this._tiles[key];
	
	  				if (tile && tile.active) {
	  					tile.retain = true;
	  					continue;
	
	  				} else if (tile && tile.loaded) {
	  					tile.retain = true;
	  				}
	
	  				if (z + 1 < maxZoom) {
	  					this._retainChildren(i, j, z + 1, maxZoom);
	  				}
	  			}
	  		}
	  	},
	
	  	_resetView: function (e) {
	  		var animating = e && (e.pinch || e.flyTo);
	  		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	  	},
	
	  	_animateZoom: function (e) {
	  		this._setView(e.center, e.zoom, true, e.noUpdate);
	  	},
	
	  	_clampZoom: function (zoom) {
	  		var options = this.options;
	
	  		if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
	  			return options.minNativeZoom;
	  		}
	
	  		if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
	  			return options.maxNativeZoom;
	  		}
	
	  		return zoom;
	  	},
	
	  	_setView: function (center, zoom, noPrune, noUpdate) {
	  		var tileZoom = Math.round(zoom);
	  		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
	  		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
	  			tileZoom = undefined;
	  		} else {
	  			tileZoom = this._clampZoom(tileZoom);
	  		}
	
	  		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
	  		if (!noUpdate || tileZoomChanged) {
	
	  			this._tileZoom = tileZoom;
	
	  			if (this._abortLoading) {
	  				this._abortLoading();
	  			}
	
	  			this._updateLevels();
	  			this._resetGrid();
	
	  			if (tileZoom !== undefined) {
	  				this._update(center);
	  			}
	
	  			if (!noPrune) {
	  				this._pruneTiles();
	  			}
	
	  			// Flag to prevent _updateOpacity from pruning tiles during
	  			// a zoom anim or a pinch gesture
	  			this._noPrune = !!noPrune;
	  		}
	
	  		this._setZoomTransforms(center, zoom);
	  	},
	
	  	_setZoomTransforms: function (center, zoom) {
	  		for (var i in this._levels) {
	  			this._setZoomTransform(this._levels[i], center, zoom);
	  		}
	  	},
	
	  	_setZoomTransform: function (level, center, zoom) {
	  		var scale = this._map.getZoomScale(zoom, level.zoom),
	  		    translate = level.origin.multiplyBy(scale)
	  		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
	  		if (any3d) {
	  			setTransform(level.el, translate, scale);
	  		} else {
	  			setPosition(level.el, translate);
	  		}
	  	},
	
	  	_resetGrid: function () {
	  		var map = this._map,
	  		    crs = map.options.crs,
	  		    tileSize = this._tileSize = this.getTileSize(),
	  		    tileZoom = this._tileZoom;
	
	  		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
	  		if (bounds) {
	  			this._globalTileRange = this._pxBoundsToTileRange(bounds);
	  		}
	
	  		this._wrapX = crs.wrapLng && !this.options.noWrap && [
	  			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
	  			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
	  		];
	  		this._wrapY = crs.wrapLat && !this.options.noWrap && [
	  			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
	  			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
	  		];
	  	},
	
	  	_onMoveEnd: function () {
	  		if (!this._map || this._map._animatingZoom) { return; }
	
	  		this._update();
	  	},
	
	  	_getTiledPixelBounds: function (center) {
	  		var map = this._map,
	  		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
	  		    scale = map.getZoomScale(mapZoom, this._tileZoom),
	  		    pixelCenter = map.project(center, this._tileZoom).floor(),
	  		    halfSize = map.getSize().divideBy(scale * 2);
	
	  		return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	  	},
	
	  	// Private method to load tiles in the grid's active zoom level according to map bounds
	  	_update: function (center) {
	  		var map = this._map;
	  		if (!map) { return; }
	  		var zoom = this._clampZoom(map.getZoom());
	
	  		if (center === undefined) { center = map.getCenter(); }
	  		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
	  		var pixelBounds = this._getTiledPixelBounds(center),
	  		    tileRange = this._pxBoundsToTileRange(pixelBounds),
	  		    tileCenter = tileRange.getCenter(),
	  		    queue = [],
	  		    margin = this.options.keepBuffer,
	  		    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
	  		                              tileRange.getTopRight().add([margin, -margin]));
	
	  		// Sanity check: panic if the tile range contains Infinity somewhere.
	  		if (!(isFinite(tileRange.min.x) &&
	  		      isFinite(tileRange.min.y) &&
	  		      isFinite(tileRange.max.x) &&
	  		      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
	  		for (var key in this._tiles) {
	  			var c = this._tiles[key].coords;
	  			if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
	  				this._tiles[key].current = false;
	  			}
	  		}
	
	  		// _update just loads more tiles. If the tile zoom level differs too much
	  		// from the map's, let _setView reset levels and prune old tiles.
	  		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
	  		// create a queue of coordinates to load tiles from
	  		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
	  			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
	  				var coords = new Point(i, j);
	  				coords.z = this._tileZoom;
	
	  				if (!this._isValidTile(coords)) { continue; }
	
	  				var tile = this._tiles[this._tileCoordsToKey(coords)];
	  				if (tile) {
	  					tile.current = true;
	  				} else {
	  					queue.push(coords);
	  				}
	  			}
	  		}
	
	  		// sort tile queue to load tiles in order of their distance to center
	  		queue.sort(function (a, b) {
	  			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
	  		});
	
	  		if (queue.length !== 0) {
	  			// if it's the first batch of tiles to load
	  			if (!this._loading) {
	  				this._loading = true;
	  				// @event loading: Event
	  				// Fired when the grid layer starts loading tiles.
	  				this.fire('loading');
	  			}
	
	  			// create DOM fragment to append tiles in one batch
	  			var fragment = document.createDocumentFragment();
	
	  			for (i = 0; i < queue.length; i++) {
	  				this._addTile(queue[i], fragment);
	  			}
	
	  			this._level.el.appendChild(fragment);
	  		}
	  	},
	
	  	_isValidTile: function (coords) {
	  		var crs = this._map.options.crs;
	
	  		if (!crs.infinite) {
	  			// don't load tile if it's out of bounds and not wrapped
	  			var bounds = this._globalTileRange;
	  			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
	  			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
	  		}
	
	  		if (!this.options.bounds) { return true; }
	
	  		// don't load tile if it doesn't intersect the bounds in options
	  		var tileBounds = this._tileCoordsToBounds(coords);
	  		return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
	  	},
	
	  	_keyToBounds: function (key) {
	  		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	  	},
	
	  	_tileCoordsToNwSe: function (coords) {
	  		var map = this._map,
	  		    tileSize = this.getTileSize(),
	  		    nwPoint = coords.scaleBy(tileSize),
	  		    sePoint = nwPoint.add(tileSize),
	  		    nw = map.unproject(nwPoint, coords.z),
	  		    se = map.unproject(sePoint, coords.z);
	  		return [nw, se];
	  	},
	
	  	// converts tile coordinates to its geographical bounds
	  	_tileCoordsToBounds: function (coords) {
	  		var bp = this._tileCoordsToNwSe(coords),
	  		    bounds = new LatLngBounds(bp[0], bp[1]);
	
	  		if (!this.options.noWrap) {
	  			bounds = this._map.wrapLatLngBounds(bounds);
	  		}
	  		return bounds;
	  	},
	  	// converts tile coordinates to key for the tile cache
	  	_tileCoordsToKey: function (coords) {
	  		return coords.x + ':' + coords.y + ':' + coords.z;
	  	},
	
	  	// converts tile cache key to coordinates
	  	_keyToTileCoords: function (key) {
	  		var k = key.split(':'),
	  		    coords = new Point(+k[0], +k[1]);
	  		coords.z = +k[2];
	  		return coords;
	  	},
	
	  	_removeTile: function (key) {
	  		var tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		remove(tile.el);
	
	  		delete this._tiles[key];
	
	  		// @event tileunload: TileEvent
	  		// Fired when a tile is removed (e.g. when a tile goes off the screen).
	  		this.fire('tileunload', {
	  			tile: tile.el,
	  			coords: this._keyToTileCoords(key)
	  		});
	  	},
	
	  	_initTile: function (tile) {
	  		addClass(tile, 'leaflet-tile');
	
	  		var tileSize = this.getTileSize();
	  		tile.style.width = tileSize.x + 'px';
	  		tile.style.height = tileSize.y + 'px';
	
	  		tile.onselectstart = falseFn;
	  		tile.onmousemove = falseFn;
	
	  		// update opacity on tiles in IE7-8 because of filter inheritance problems
	  		if (ielt9 && this.options.opacity < 1) {
	  			setOpacity(tile, this.options.opacity);
	  		}
	
	  		// without this hack, tiles disappear after zoom on Chrome for Android
	  		// https://github.com/Leaflet/Leaflet/issues/2078
	  		if (android && !android23) {
	  			tile.style.WebkitBackfaceVisibility = 'hidden';
	  		}
	  	},
	
	  	_addTile: function (coords, container) {
	  		var tilePos = this._getTilePos(coords),
	  		    key = this._tileCoordsToKey(coords);
	
	  		var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
	  		this._initTile(tile);
	
	  		// if createTile is defined with a second argument ("done" callback),
	  		// we know that tile is async and will be ready later; otherwise
	  		if (this.createTile.length < 2) {
	  			// mark tile as ready, but delay one frame for opacity animation to happen
	  			requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
	  		}
	
	  		setPosition(tile, tilePos);
	
	  		// save tile in cache
	  		this._tiles[key] = {
	  			el: tile,
	  			coords: coords,
	  			current: true
	  		};
	
	  		container.appendChild(tile);
	  		// @event tileloadstart: TileEvent
	  		// Fired when a tile is requested and starts loading.
	  		this.fire('tileloadstart', {
	  			tile: tile,
	  			coords: coords
	  		});
	  	},
	
	  	_tileReady: function (coords, err, tile) {
	  		if (err) {
	  			// @event tileerror: TileErrorEvent
	  			// Fired when there is an error loading a tile.
	  			this.fire('tileerror', {
	  				error: err,
	  				tile: tile,
	  				coords: coords
	  			});
	  		}
	
	  		var key = this._tileCoordsToKey(coords);
	
	  		tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		tile.loaded = +new Date();
	  		if (this._map._fadeAnimated) {
	  			setOpacity(tile.el, 0);
	  			cancelAnimFrame(this._fadeFrame);
	  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	  		} else {
	  			tile.active = true;
	  			this._pruneTiles();
	  		}
	
	  		if (!err) {
	  			addClass(tile.el, 'leaflet-tile-loaded');
	
	  			// @event tileload: TileEvent
	  			// Fired when a tile loads.
	  			this.fire('tileload', {
	  				tile: tile.el,
	  				coords: coords
	  			});
	  		}
	
	  		if (this._noTilesToLoad()) {
	  			this._loading = false;
	  			// @event load: Event
	  			// Fired when the grid layer loaded all visible tiles.
	  			this.fire('load');
	
	  			if (ielt9 || !this._map._fadeAnimated) {
	  				requestAnimFrame(this._pruneTiles, this);
	  			} else {
	  				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
	  				// to trigger a pruning.
	  				setTimeout(bind(this._pruneTiles, this), 250);
	  			}
	  		}
	  	},
	
	  	_getTilePos: function (coords) {
	  		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	  	},
	
	  	_wrapCoords: function (coords) {
	  		var newCoords = new Point(
	  			this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
	  			this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
	  		newCoords.z = coords.z;
	  		return newCoords;
	  	},
	
	  	_pxBoundsToTileRange: function (bounds) {
	  		var tileSize = this.getTileSize();
	  		return new Bounds(
	  			bounds.min.unscaleBy(tileSize).floor(),
	  			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	  	},
	
	  	_noTilesToLoad: function () {
	  		for (var key in this._tiles) {
	  			if (!this._tiles[key].loaded) { return false; }
	  		}
	  		return true;
	  	}
	  });
	
	  // @factory L.gridLayer(options?: GridLayer options)
	  // Creates a new instance of GridLayer with the supplied options.
	  function gridLayer(options) {
	  	return new GridLayer(options);
	  }
	
	  /*
	   * @class TileLayer
	   * @inherits GridLayer
	   * @aka L.TileLayer
	   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
	   * ```
	   *
	   * @section URL template
	   * @example
	   *
	   * A string of the following form:
	   *
	   * ```
	   * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	   * ```
	   *
	   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	   *
	   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	   *
	   * ```
	   * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	   * ```
	   */
	
	
	  var TileLayer = GridLayer.extend({
	
	  	// @section
	  	// @aka TileLayer options
	  	options: {
	  		// @option minZoom: Number = 0
	  		// The minimum zoom level down to which this layer will be displayed (inclusive).
	  		minZoom: 0,
	
	  		// @option maxZoom: Number = 18
	  		// The maximum zoom level up to which this layer will be displayed (inclusive).
	  		maxZoom: 18,
	
	  		// @option subdomains: String|String[] = 'abc'
	  		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
	  		subdomains: 'abc',
	
	  		// @option errorTileUrl: String = ''
	  		// URL to the tile image to show in place of the tile that failed to load.
	  		errorTileUrl: '',
	
	  		// @option zoomOffset: Number = 0
	  		// The zoom number used in tile URLs will be offset with this value.
	  		zoomOffset: 0,
	
	  		// @option tms: Boolean = false
	  		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
	  		tms: false,
	
	  		// @option zoomReverse: Boolean = false
	  		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
	  		zoomReverse: false,
	
	  		// @option detectRetina: Boolean = false
	  		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
	  		detectRetina: false,
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the tiles.
	  		// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false
	  	},
	
	  	initialize: function (url, options) {
	
	  		this._url = url;
	
	  		options = setOptions(this, options);
	
	  		// detecting retina displays, adjusting tileSize and zoom levels
	  		if (options.detectRetina && retina && options.maxZoom > 0) {
	
	  			options.tileSize = Math.floor(options.tileSize / 2);
	
	  			if (!options.zoomReverse) {
	  				options.zoomOffset++;
	  				options.maxZoom--;
	  			} else {
	  				options.zoomOffset--;
	  				options.minZoom++;
	  			}
	
	  			options.minZoom = Math.max(0, options.minZoom);
	  		}
	
	  		if (typeof options.subdomains === 'string') {
	  			options.subdomains = options.subdomains.split('');
	  		}
	
	  		// for https://github.com/Leaflet/Leaflet/issues/137
	  		if (!android) {
	  			this.on('tileunload', this._onTileRemove);
	  		}
	  	},
	
	  	// @method setUrl(url: String, noRedraw?: Boolean): this
	  	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	  	// If the URL does not change, the layer will not be redrawn unless
	  	// the noRedraw parameter is set to false.
	  	setUrl: function (url, noRedraw) {
	  		if (this._url === url && noRedraw === undefined) {
	  			noRedraw = true;
	  		}
	
	  		this._url = url;
	
	  		if (!noRedraw) {
	  			this.redraw();
	  		}
	  		return this;
	  	},
	
	  	// @method createTile(coords: Object, done?: Function): HTMLElement
	  	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	  	// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
	  	// callback is called when the tile has been loaded.
	  	createTile: function (coords, done) {
	  		var tile = document.createElement('img');
	
	  		on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
	  		on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		/*
	  		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
	  		 http://www.w3.org/TR/WCAG20-TECHS/H67
	  		*/
	  		tile.alt = '';
	
	  		/*
	  		 Set role="presentation" to force screen readers to ignore this
	  		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
	  		*/
	  		tile.setAttribute('role', 'presentation');
	
	  		tile.src = this.getTileUrl(coords);
	
	  		return tile;
	  	},
	
	  	// @section Extension methods
	  	// @uninheritable
	  	// Layers extending `TileLayer` might reimplement the following method.
	  	// @method getTileUrl(coords: Object): String
	  	// Called only internally, returns the URL for a tile given its coordinates.
	  	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	  	getTileUrl: function (coords) {
	  		var data = {
	  			r: retina ? '@2x' : '',
	  			s: this._getSubdomain(coords),
	  			x: coords.x,
	  			y: coords.y,
	  			z: this._getZoomForUrl()
	  		};
	  		if (this._map && !this._map.options.crs.infinite) {
	  			var invertedY = this._globalTileRange.max.y - coords.y;
	  			if (this.options.tms) {
	  				data['y'] = invertedY;
	  			}
	  			data['-y'] = invertedY;
	  		}
	
	  		return template(this._url, extend(data, this.options));
	  	},
	
	  	_tileOnLoad: function (done, tile) {
	  		// For https://github.com/Leaflet/Leaflet/issues/3332
	  		if (ielt9) {
	  			setTimeout(bind(done, this, null, tile), 0);
	  		} else {
	  			done(null, tile);
	  		}
	  	},
	
	  	_tileOnError: function (done, tile, e) {
	  		var errorUrl = this.options.errorTileUrl;
	  		if (errorUrl && tile.getAttribute('src') !== errorUrl) {
	  			tile.src = errorUrl;
	  		}
	  		done(e, tile);
	  	},
	
	  	_onTileRemove: function (e) {
	  		e.tile.onload = null;
	  	},
	
	  	_getZoomForUrl: function () {
	  		var zoom = this._tileZoom,
	  		maxZoom = this.options.maxZoom,
	  		zoomReverse = this.options.zoomReverse,
	  		zoomOffset = this.options.zoomOffset;
	
	  		if (zoomReverse) {
	  			zoom = maxZoom - zoom;
	  		}
	
	  		return zoom + zoomOffset;
	  	},
	
	  	_getSubdomain: function (tilePoint) {
	  		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
	  		return this.options.subdomains[index];
	  	},
	
	  	// stops loading all tiles in the background layer
	  	_abortLoading: function () {
	  		var i, tile;
	  		for (i in this._tiles) {
	  			if (this._tiles[i].coords.z !== this._tileZoom) {
	  				tile = this._tiles[i].el;
	
	  				tile.onload = falseFn;
	  				tile.onerror = falseFn;
	
	  				if (!tile.complete) {
	  					tile.src = emptyImageUrl;
	  					remove(tile);
	  					delete this._tiles[i];
	  				}
	  			}
	  		}
	  	},
	
	  	_removeTile: function (key) {
	  		var tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		// Cancels any pending http requests associated with the tile
	  		// unless we're on Android's stock browser,
	  		// see https://github.com/Leaflet/Leaflet/issues/137
	  		if (!androidStock) {
	  			tile.el.setAttribute('src', emptyImageUrl);
	  		}
	
	  		return GridLayer.prototype._removeTile.call(this, key);
	  	},
	
	  	_tileReady: function (coords, err, tile) {
	  		if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
	  			return;
	  		}
	
	  		return GridLayer.prototype._tileReady.call(this, coords, err, tile);
	  	}
	  });
	
	
	  // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	  // Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	  function tileLayer(url, options) {
	  	return new TileLayer(url, options);
	  }
	
	  /*
	   * @class TileLayer.WMS
	   * @inherits TileLayer
	   * @aka L.TileLayer.WMS
	   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	   *
	   * @example
	   *
	   * ```js
	   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	   * 	layers: 'nexrad-n0r-900913',
	   * 	format: 'image/png',
	   * 	transparent: true,
	   * 	attribution: "Weather data © 2012 IEM Nexrad"
	   * });
	   * ```
	   */
	
	  var TileLayerWMS = TileLayer.extend({
	
	  	// @section
	  	// @aka TileLayer.WMS options
	  	// If any custom options not documented here are used, they will be sent to the
	  	// WMS server as extra parameters in each request URL. This can be useful for
	  	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	  	defaultWmsParams: {
	  		service: 'WMS',
	  		request: 'GetMap',
	
	  		// @option layers: String = ''
	  		// **(required)** Comma-separated list of WMS layers to show.
	  		layers: '',
	
	  		// @option styles: String = ''
	  		// Comma-separated list of WMS styles.
	  		styles: '',
	
	  		// @option format: String = 'image/jpeg'
	  		// WMS image format (use `'image/png'` for layers with transparency).
	  		format: 'image/jpeg',
	
	  		// @option transparent: Boolean = false
	  		// If `true`, the WMS service will return images with transparency.
	  		transparent: false,
	
	  		// @option version: String = '1.1.1'
	  		// Version of the WMS service to use
	  		version: '1.1.1'
	  	},
	
	  	options: {
	  		// @option crs: CRS = null
	  		// Coordinate Reference System to use for the WMS requests, defaults to
	  		// map CRS. Don't change this if you're not sure what it means.
	  		crs: null,
	
	  		// @option uppercase: Boolean = false
	  		// If `true`, WMS request parameter keys will be uppercase.
	  		uppercase: false
	  	},
	
	  	initialize: function (url, options) {
	
	  		this._url = url;
	
	  		var wmsParams = extend({}, this.defaultWmsParams);
	
	  		// all keys that are not TileLayer options go to WMS params
	  		for (var i in options) {
	  			if (!(i in this.options)) {
	  				wmsParams[i] = options[i];
	  			}
	  		}
	
	  		options = setOptions(this, options);
	
	  		var realRetina = options.detectRetina && retina ? 2 : 1;
	  		var tileSize = this.getTileSize();
	  		wmsParams.width = tileSize.x * realRetina;
	  		wmsParams.height = tileSize.y * realRetina;
	
	  		this.wmsParams = wmsParams;
	  	},
	
	  	onAdd: function (map) {
	
	  		this._crs = this.options.crs || map.options.crs;
	  		this._wmsVersion = parseFloat(this.wmsParams.version);
	
	  		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
	  		this.wmsParams[projectionKey] = this._crs.code;
	
	  		TileLayer.prototype.onAdd.call(this, map);
	  	},
	
	  	getTileUrl: function (coords) {
	
	  		var tileBounds = this._tileCoordsToNwSe(coords),
	  		    crs = this._crs,
	  		    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
	  		    min = bounds.min,
	  		    max = bounds.max,
	  		    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
	  		    [min.y, min.x, max.y, max.x] :
	  		    [min.x, min.y, max.x, max.y]).join(','),
	  		    url = TileLayer.prototype.getTileUrl.call(this, coords);
	  		return url +
	  			getParamString(this.wmsParams, url, this.options.uppercase) +
	  			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	  	},
	
	  	// @method setParams(params: Object, noRedraw?: Boolean): this
	  	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	  	setParams: function (params, noRedraw) {
	
	  		extend(this.wmsParams, params);
	
	  		if (!noRedraw) {
	  			this.redraw();
	  		}
	
	  		return this;
	  	}
	  });
	
	
	  // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	  // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	  function tileLayerWMS(url, options) {
	  	return new TileLayerWMS(url, options);
	  }
	
	  TileLayer.WMS = TileLayerWMS;
	  tileLayer.wms = tileLayerWMS;
	
	  /*
	   * @class Renderer
	   * @inherits Layer
	   * @aka L.Renderer
	   *
	   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	   * DOM container of the renderer, its bounds, and its zoom animation.
	   *
	   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	   * itself can be added or removed to the map. All paths use a renderer, which can
	   * be implicit (the map will decide the type of renderer and use it automatically)
	   * or explicit (using the [`renderer`](#path-renderer) option of the path).
	   *
	   * Do not use this class directly, use `SVG` and `Canvas` instead.
	   *
	   * @event update: Event
	   * Fired when the renderer updates its bounds, center and zoom, for example when
	   * its map has moved
	   */
	
	  var Renderer = Layer.extend({
	
	  	// @section
	  	// @aka Renderer options
	  	options: {
	  		// @option padding: Number = 0.1
	  		// How much to extend the clip area around the map view (relative to its size)
	  		// e.g. 0.1 would be 10% of map view in each direction
	  		padding: 0.1,
	
	  		// @option tolerance: Number = 0
	  		// How much to extend click tolerance round a path/object on the map
	  		tolerance : 0
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  		stamp(this);
	  		this._layers = this._layers || {};
	  	},
	
	  	onAdd: function () {
	  		if (!this._container) {
	  			this._initContainer(); // defined by renderer implementations
	
	  			if (this._zoomAnimated) {
	  				addClass(this._container, 'leaflet-zoom-animated');
	  			}
	  		}
	
	  		this.getPane().appendChild(this._container);
	  		this._update();
	  		this.on('update', this._updatePaths, this);
	  	},
	
	  	onRemove: function () {
	  		this.off('update', this._updatePaths, this);
	  		this._destroyContainer();
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			viewreset: this._reset,
	  			zoom: this._onZoom,
	  			moveend: this._update,
	  			zoomend: this._onZoomEnd
	  		};
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._onAnimZoom;
	  		}
	  		return events;
	  	},
	
	  	_onAnimZoom: function (ev) {
	  		this._updateTransform(ev.center, ev.zoom);
	  	},
	
	  	_onZoom: function () {
	  		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	  	},
	
	  	_updateTransform: function (center, zoom) {
	  		var scale = this._map.getZoomScale(zoom, this._zoom),
	  		    position = getPosition(this._container),
	  		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
	  		    currentCenterPoint = this._map.project(this._center, zoom),
	  		    destCenterPoint = this._map.project(center, zoom),
	  		    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
	  		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
	  		if (any3d) {
	  			setTransform(this._container, topLeftOffset, scale);
	  		} else {
	  			setPosition(this._container, topLeftOffset);
	  		}
	  	},
	
	  	_reset: function () {
	  		this._update();
	  		this._updateTransform(this._center, this._zoom);
	
	  		for (var id in this._layers) {
	  			this._layers[id]._reset();
	  		}
	  	},
	
	  	_onZoomEnd: function () {
	  		for (var id in this._layers) {
	  			this._layers[id]._project();
	  		}
	  	},
	
	  	_updatePaths: function () {
	  		for (var id in this._layers) {
	  			this._layers[id]._update();
	  		}
	  	},
	
	  	_update: function () {
	  		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
	  		// Subclasses are responsible of firing the 'update' event.
	  		var p = this.options.padding,
	  		    size = this._map.getSize(),
	  		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
	  		this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
	  		this._center = this._map.getCenter();
	  		this._zoom = this._map.getZoom();
	  	}
	  });
	
	  /*
	   * @class Canvas
	   * @inherits Renderer
	   * @aka L.Canvas
	   *
	   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	   * Inherits `Renderer`.
	   *
	   * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	   * available in all web browsers, notably IE8, and overlapping geometries might
	   * not display properly in some edge cases.
	   *
	   * @example
	   *
	   * Use Canvas by default for all paths in the map:
	   *
	   * ```js
	   * var map = L.map('map', {
	   * 	renderer: L.canvas()
	   * });
	   * ```
	   *
	   * Use a Canvas renderer with extra padding for specific vector geometries:
	   *
	   * ```js
	   * var map = L.map('map');
	   * var myRenderer = L.canvas({ padding: 0.5 });
	   * var line = L.polyline( coordinates, { renderer: myRenderer } );
	   * var circle = L.circle( center, { renderer: myRenderer } );
	   * ```
	   */
	
	  var Canvas = Renderer.extend({
	  	getEvents: function () {
	  		var events = Renderer.prototype.getEvents.call(this);
	  		events.viewprereset = this._onViewPreReset;
	  		return events;
	  	},
	
	  	_onViewPreReset: function () {
	  		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
	  		this._postponeUpdatePaths = true;
	  	},
	
	  	onAdd: function () {
	  		Renderer.prototype.onAdd.call(this);
	
	  		// Redraw vectors since canvas is cleared upon removal,
	  		// in case of removing the renderer itself from the map.
	  		this._draw();
	  	},
	
	  	_initContainer: function () {
	  		var container = this._container = document.createElement('canvas');
	
	  		on(container, 'mousemove', this._onMouseMove, this);
	  		on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
	  		on(container, 'mouseout', this._handleMouseOut, this);
	
	  		this._ctx = container.getContext('2d');
	  	},
	
	  	_destroyContainer: function () {
	  		cancelAnimFrame(this._redrawRequest);
	  		delete this._ctx;
	  		remove(this._container);
	  		off(this._container);
	  		delete this._container;
	  	},
	
	  	_updatePaths: function () {
	  		if (this._postponeUpdatePaths) { return; }
	
	  		var layer;
	  		this._redrawBounds = null;
	  		for (var id in this._layers) {
	  			layer = this._layers[id];
	  			layer._update();
	  		}
	  		this._redraw();
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom && this._bounds) { return; }
	
	  		Renderer.prototype._update.call(this);
	
	  		var b = this._bounds,
	  		    container = this._container,
	  		    size = b.getSize(),
	  		    m = retina ? 2 : 1;
	
	  		setPosition(container, b.min);
	
	  		// set canvas size (also clearing it); use double size on retina
	  		container.width = m * size.x;
	  		container.height = m * size.y;
	  		container.style.width = size.x + 'px';
	  		container.style.height = size.y + 'px';
	
	  		if (retina) {
	  			this._ctx.scale(2, 2);
	  		}
	
	  		// translate so we use the same path coordinates after canvas element moves
	  		this._ctx.translate(-b.min.x, -b.min.y);
	
	  		// Tell paths to redraw themselves
	  		this.fire('update');
	  	},
	
	  	_reset: function () {
	  		Renderer.prototype._reset.call(this);
	
	  		if (this._postponeUpdatePaths) {
	  			this._postponeUpdatePaths = false;
	  			this._updatePaths();
	  		}
	  	},
	
	  	_initPath: function (layer) {
	  		this._updateDashArray(layer);
	  		this._layers[stamp(layer)] = layer;
	
	  		var order = layer._order = {
	  			layer: layer,
	  			prev: this._drawLast,
	  			next: null
	  		};
	  		if (this._drawLast) { this._drawLast.next = order; }
	  		this._drawLast = order;
	  		this._drawFirst = this._drawFirst || this._drawLast;
	  	},
	
	  	_addPath: function (layer) {
	  		this._requestRedraw(layer);
	  	},
	
	  	_removePath: function (layer) {
	  		var order = layer._order;
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (next) {
	  			next.prev = prev;
	  		} else {
	  			this._drawLast = prev;
	  		}
	  		if (prev) {
	  			prev.next = next;
	  		} else {
	  			this._drawFirst = next;
	  		}
	
	  		delete layer._order;
	
	  		delete this._layers[stamp(layer)];
	
	  		this._requestRedraw(layer);
	  	},
	
	  	_updatePath: function (layer) {
	  		// Redraw the union of the layer's old pixel
	  		// bounds and the new pixel bounds.
	  		this._extendRedrawBounds(layer);
	  		layer._project();
	  		layer._update();
	  		// The redraw will extend the redraw bounds
	  		// with the new pixel bounds.
	  		this._requestRedraw(layer);
	  	},
	
	  	_updateStyle: function (layer) {
	  		this._updateDashArray(layer);
	  		this._requestRedraw(layer);
	  	},
	
	  	_updateDashArray: function (layer) {
	  		if (typeof layer.options.dashArray === 'string') {
	  			var parts = layer.options.dashArray.split(/[, ]+/),
	  			    dashArray = [],
	  			    dashValue,
	  			    i;
	  			for (i = 0; i < parts.length; i++) {
	  				dashValue = Number(parts[i]);
	  				// Ignore dash array containing invalid lengths
	  				if (isNaN(dashValue)) { return; }
	  				dashArray.push(dashValue);
	  			}
	  			layer.options._dashArray = dashArray;
	  		} else {
	  			layer.options._dashArray = layer.options.dashArray;
	  		}
	  	},
	
	  	_requestRedraw: function (layer) {
	  		if (!this._map) { return; }
	
	  		this._extendRedrawBounds(layer);
	  		this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
	  	},
	
	  	_extendRedrawBounds: function (layer) {
	  		if (layer._pxBounds) {
	  			var padding = (layer.options.weight || 0) + 1;
	  			this._redrawBounds = this._redrawBounds || new Bounds();
	  			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
	  			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
	  		}
	  	},
	
	  	_redraw: function () {
	  		this._redrawRequest = null;
	
	  		if (this._redrawBounds) {
	  			this._redrawBounds.min._floor();
	  			this._redrawBounds.max._ceil();
	  		}
	
	  		this._clear(); // clear layers in redraw bounds
	  		this._draw(); // draw layers
	
	  		this._redrawBounds = null;
	  	},
	
	  	_clear: function () {
	  		var bounds = this._redrawBounds;
	  		if (bounds) {
	  			var size = bounds.getSize();
	  			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
	  		} else {
	  			this._ctx.save();
	  			this._ctx.setTransform(1, 0, 0, 1, 0, 0);
	  			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
	  			this._ctx.restore();
	  		}
	  	},
	
	  	_draw: function () {
	  		var layer, bounds = this._redrawBounds;
	  		this._ctx.save();
	  		if (bounds) {
	  			var size = bounds.getSize();
	  			this._ctx.beginPath();
	  			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
	  			this._ctx.clip();
	  		}
	
	  		this._drawing = true;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
	  				layer._updatePath();
	  			}
	  		}
	
	  		this._drawing = false;
	
	  		this._ctx.restore();  // Restore state before clipping.
	  	},
	
	  	_updatePoly: function (layer, closed) {
	  		if (!this._drawing) { return; }
	
	  		var i, j, len2, p,
	  		    parts = layer._parts,
	  		    len = parts.length,
	  		    ctx = this._ctx;
	
	  		if (!len) { return; }
	
	  		ctx.beginPath();
	
	  		for (i = 0; i < len; i++) {
	  			for (j = 0, len2 = parts[i].length; j < len2; j++) {
	  				p = parts[i][j];
	  				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
	  			}
	  			if (closed) {
	  				ctx.closePath();
	  			}
	  		}
	
	  		this._fillStroke(ctx, layer);
	
	  		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	  	},
	
	  	_updateCircle: function (layer) {
	
	  		if (!this._drawing || layer._empty()) { return; }
	
	  		var p = layer._point,
	  		    ctx = this._ctx,
	  		    r = Math.max(Math.round(layer._radius), 1),
	  		    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	
	  		if (s !== 1) {
	  			ctx.save();
	  			ctx.scale(1, s);
	  		}
	
	  		ctx.beginPath();
	  		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
	  		if (s !== 1) {
	  			ctx.restore();
	  		}
	
	  		this._fillStroke(ctx, layer);
	  	},
	
	  	_fillStroke: function (ctx, layer) {
	  		var options = layer.options;
	
	  		if (options.fill) {
	  			ctx.globalAlpha = options.fillOpacity;
	  			ctx.fillStyle = options.fillColor || options.color;
	  			ctx.fill(options.fillRule || 'evenodd');
	  		}
	
	  		if (options.stroke && options.weight !== 0) {
	  			if (ctx.setLineDash) {
	  				ctx.setLineDash(layer.options && layer.options._dashArray || []);
	  			}
	  			ctx.globalAlpha = options.opacity;
	  			ctx.lineWidth = options.weight;
	  			ctx.strokeStyle = options.color;
	  			ctx.lineCap = options.lineCap;
	  			ctx.lineJoin = options.lineJoin;
	  			ctx.stroke();
	  		}
	  	},
	
	  	// Canvas obviously doesn't have mouse events for individual drawn objects,
	  	// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
	  	_onClick: function (e) {
	  		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (layer.options.interactive && layer._containsPoint(point)) {
	  				if (!(e.type === 'click' || e.type !== 'preclick') || !this._map._draggableMoved(layer)) {
	  					clickedLayer = layer;
	  				}
	  			}
	  		}
	  		if (clickedLayer)  {
	  			fakeStop(e);
	  			this._fireEvent([clickedLayer], e);
	  		}
	  	},
	
	  	_onMouseMove: function (e) {
	  		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
	  		var point = this._map.mouseEventToLayerPoint(e);
	  		this._handleMouseHover(e, point);
	  	},
	
	
	  	_handleMouseOut: function (e) {
	  		var layer = this._hoveredLayer;
	  		if (layer) {
	  			// if we're leaving the layer, fire mouseout
	  			removeClass(this._container, 'leaflet-interactive');
	  			this._fireEvent([layer], e, 'mouseout');
	  			this._hoveredLayer = null;
	  			this._mouseHoverThrottled = false;
	  		}
	  	},
	
	  	_handleMouseHover: function (e, point) {
	  		if (this._mouseHoverThrottled) {
	  			return;
	  		}
	
	  		var layer, candidateHoveredLayer;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (layer.options.interactive && layer._containsPoint(point)) {
	  				candidateHoveredLayer = layer;
	  			}
	  		}
	
	  		if (candidateHoveredLayer !== this._hoveredLayer) {
	  			this._handleMouseOut(e);
	
	  			if (candidateHoveredLayer) {
	  				addClass(this._container, 'leaflet-interactive'); // change cursor
	  				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
	  				this._hoveredLayer = candidateHoveredLayer;
	  			}
	  		}
	
	  		if (this._hoveredLayer) {
	  			this._fireEvent([this._hoveredLayer], e);
	  		}
	
	  		this._mouseHoverThrottled = true;
	  		setTimeout(bind(function () {
	  			this._mouseHoverThrottled = false;
	  		}, this), 32);
	  	},
	
	  	_fireEvent: function (layers, e, type) {
	  		this._map._fireDOMEvent(e, type || e.type, layers);
	  	},
	
	  	_bringToFront: function (layer) {
	  		var order = layer._order;
	
	  		if (!order) { return; }
	
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (next) {
	  			next.prev = prev;
	  		} else {
	  			// Already last
	  			return;
	  		}
	  		if (prev) {
	  			prev.next = next;
	  		} else if (next) {
	  			// Update first entry unless this is the
	  			// single entry
	  			this._drawFirst = next;
	  		}
	
	  		order.prev = this._drawLast;
	  		this._drawLast.next = order;
	
	  		order.next = null;
	  		this._drawLast = order;
	
	  		this._requestRedraw(layer);
	  	},
	
	  	_bringToBack: function (layer) {
	  		var order = layer._order;
	
	  		if (!order) { return; }
	
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (prev) {
	  			prev.next = next;
	  		} else {
	  			// Already first
	  			return;
	  		}
	  		if (next) {
	  			next.prev = prev;
	  		} else if (prev) {
	  			// Update last entry unless this is the
	  			// single entry
	  			this._drawLast = prev;
	  		}
	
	  		order.prev = null;
	
	  		order.next = this._drawFirst;
	  		this._drawFirst.prev = order;
	  		this._drawFirst = order;
	
	  		this._requestRedraw(layer);
	  	}
	  });
	
	  // @factory L.canvas(options?: Renderer options)
	  // Creates a Canvas renderer with the given options.
	  function canvas$1(options) {
	  	return canvas ? new Canvas(options) : null;
	  }
	
	  /*
	   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	   */
	
	
	  var vmlCreate = (function () {
	  	try {
	  		document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
	  		return function (name) {
	  			return document.createElement('<lvml:' + name + ' class="lvml">');
	  		};
	  	} catch (e) {
	  		return function (name) {
	  			return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
	  		};
	  	}
	  })();
	
	
	  /*
	   * @class SVG
	   *
	   *
	   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	   * with old versions of Internet Explorer.
	   */
	
	  // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	  var vmlMixin = {
	
	  	_initContainer: function () {
	  		this._container = create$1('div', 'leaflet-vml-container');
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom) { return; }
	  		Renderer.prototype._update.call(this);
	  		this.fire('update');
	  	},
	
	  	_initPath: function (layer) {
	  		var container = layer._container = vmlCreate('shape');
	
	  		addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
	  		container.coordsize = '1 1';
	
	  		layer._path = vmlCreate('path');
	  		container.appendChild(layer._path);
	
	  		this._updateStyle(layer);
	  		this._layers[stamp(layer)] = layer;
	  	},
	
	  	_addPath: function (layer) {
	  		var container = layer._container;
	  		this._container.appendChild(container);
	
	  		if (layer.options.interactive) {
	  			layer.addInteractiveTarget(container);
	  		}
	  	},
	
	  	_removePath: function (layer) {
	  		var container = layer._container;
	  		remove(container);
	  		layer.removeInteractiveTarget(container);
	  		delete this._layers[stamp(layer)];
	  	},
	
	  	_updateStyle: function (layer) {
	  		var stroke = layer._stroke,
	  		    fill = layer._fill,
	  		    options = layer.options,
	  		    container = layer._container;
	
	  		container.stroked = !!options.stroke;
	  		container.filled = !!options.fill;
	
	  		if (options.stroke) {
	  			if (!stroke) {
	  				stroke = layer._stroke = vmlCreate('stroke');
	  			}
	  			container.appendChild(stroke);
	  			stroke.weight = options.weight + 'px';
	  			stroke.color = options.color;
	  			stroke.opacity = options.opacity;
	
	  			if (options.dashArray) {
	  				stroke.dashStyle = isArray(options.dashArray) ?
	  				    options.dashArray.join(' ') :
	  				    options.dashArray.replace(/( *, *)/g, ' ');
	  			} else {
	  				stroke.dashStyle = '';
	  			}
	  			stroke.endcap = options.lineCap.replace('butt', 'flat');
	  			stroke.joinstyle = options.lineJoin;
	
	  		} else if (stroke) {
	  			container.removeChild(stroke);
	  			layer._stroke = null;
	  		}
	
	  		if (options.fill) {
	  			if (!fill) {
	  				fill = layer._fill = vmlCreate('fill');
	  			}
	  			container.appendChild(fill);
	  			fill.color = options.fillColor || options.color;
	  			fill.opacity = options.fillOpacity;
	
	  		} else if (fill) {
	  			container.removeChild(fill);
	  			layer._fill = null;
	  		}
	  	},
	
	  	_updateCircle: function (layer) {
	  		var p = layer._point.round(),
	  		    r = Math.round(layer._radius),
	  		    r2 = Math.round(layer._radiusY || r);
	
	  		this._setPath(layer, layer._empty() ? 'M0 0' :
	  			'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	  	},
	
	  	_setPath: function (layer, path) {
	  		layer._path.v = path;
	  	},
	
	  	_bringToFront: function (layer) {
	  		toFront(layer._container);
	  	},
	
	  	_bringToBack: function (layer) {
	  		toBack(layer._container);
	  	}
	  };
	
	  var create$2 = vml ? vmlCreate : svgCreate;
	
	  /*
	   * @class SVG
	   * @inherits Renderer
	   * @aka L.SVG
	   *
	   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	   * Inherits `Renderer`.
	   *
	   * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	   * available in all web browsers, notably Android 2.x and 3.x.
	   *
	   * Although SVG is not available on IE7 and IE8, these browsers support
	   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	   * (a now deprecated technology), and the SVG renderer will fall back to VML in
	   * this case.
	   *
	   * @example
	   *
	   * Use SVG by default for all paths in the map:
	   *
	   * ```js
	   * var map = L.map('map', {
	   * 	renderer: L.svg()
	   * });
	   * ```
	   *
	   * Use a SVG renderer with extra padding for specific vector geometries:
	   *
	   * ```js
	   * var map = L.map('map');
	   * var myRenderer = L.svg({ padding: 0.5 });
	   * var line = L.polyline( coordinates, { renderer: myRenderer } );
	   * var circle = L.circle( center, { renderer: myRenderer } );
	   * ```
	   */
	
	  var SVG = Renderer.extend({
	
	  	getEvents: function () {
	  		var events = Renderer.prototype.getEvents.call(this);
	  		events.zoomstart = this._onZoomStart;
	  		return events;
	  	},
	
	  	_initContainer: function () {
	  		this._container = create$2('svg');
	
	  		// makes it possible to click through svg root; we'll reset it back in individual paths
	  		this._container.setAttribute('pointer-events', 'none');
	
	  		this._rootGroup = create$2('g');
	  		this._container.appendChild(this._rootGroup);
	  	},
	
	  	_destroyContainer: function () {
	  		remove(this._container);
	  		off(this._container);
	  		delete this._container;
	  		delete this._rootGroup;
	  		delete this._svgSize;
	  	},
	
	  	_onZoomStart: function () {
	  		// Drag-then-pinch interactions might mess up the center and zoom.
	  		// In this case, the easiest way to prevent this is re-do the renderer
	  		//   bounds and padding when the zooming starts.
	  		this._update();
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom && this._bounds) { return; }
	
	  		Renderer.prototype._update.call(this);
	
	  		var b = this._bounds,
	  		    size = b.getSize(),
	  		    container = this._container;
	
	  		// set size of svg-container if changed
	  		if (!this._svgSize || !this._svgSize.equals(size)) {
	  			this._svgSize = size;
	  			container.setAttribute('width', size.x);
	  			container.setAttribute('height', size.y);
	  		}
	
	  		// movement: update container viewBox so that we don't have to change coordinates of individual layers
	  		setPosition(container, b.min);
	  		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
	  		this.fire('update');
	  	},
	
	  	// methods below are called by vector layers implementations
	
	  	_initPath: function (layer) {
	  		var path = layer._path = create$2('path');
	
	  		// @namespace Path
	  		// @option className: String = null
	  		// Custom class name set on an element. Only for SVG renderer.
	  		if (layer.options.className) {
	  			addClass(path, layer.options.className);
	  		}
	
	  		if (layer.options.interactive) {
	  			addClass(path, 'leaflet-interactive');
	  		}
	
	  		this._updateStyle(layer);
	  		this._layers[stamp(layer)] = layer;
	  	},
	
	  	_addPath: function (layer) {
	  		if (!this._rootGroup) { this._initContainer(); }
	  		this._rootGroup.appendChild(layer._path);
	  		layer.addInteractiveTarget(layer._path);
	  	},
	
	  	_removePath: function (layer) {
	  		remove(layer._path);
	  		layer.removeInteractiveTarget(layer._path);
	  		delete this._layers[stamp(layer)];
	  	},
	
	  	_updatePath: function (layer) {
	  		layer._project();
	  		layer._update();
	  	},
	
	  	_updateStyle: function (layer) {
	  		var path = layer._path,
	  		    options = layer.options;
	
	  		if (!path) { return; }
	
	  		if (options.stroke) {
	  			path.setAttribute('stroke', options.color);
	  			path.setAttribute('stroke-opacity', options.opacity);
	  			path.setAttribute('stroke-width', options.weight);
	  			path.setAttribute('stroke-linecap', options.lineCap);
	  			path.setAttribute('stroke-linejoin', options.lineJoin);
	
	  			if (options.dashArray) {
	  				path.setAttribute('stroke-dasharray', options.dashArray);
	  			} else {
	  				path.removeAttribute('stroke-dasharray');
	  			}
	
	  			if (options.dashOffset) {
	  				path.setAttribute('stroke-dashoffset', options.dashOffset);
	  			} else {
	  				path.removeAttribute('stroke-dashoffset');
	  			}
	  		} else {
	  			path.setAttribute('stroke', 'none');
	  		}
	
	  		if (options.fill) {
	  			path.setAttribute('fill', options.fillColor || options.color);
	  			path.setAttribute('fill-opacity', options.fillOpacity);
	  			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
	  		} else {
	  			path.setAttribute('fill', 'none');
	  		}
	  	},
	
	  	_updatePoly: function (layer, closed) {
	  		this._setPath(layer, pointsToPath(layer._parts, closed));
	  	},
	
	  	_updateCircle: function (layer) {
	  		var p = layer._point,
	  		    r = Math.max(Math.round(layer._radius), 1),
	  		    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
	  		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
	  		// drawing a circle with two half-arcs
	  		var d = layer._empty() ? 'M0 0' :
	  			'M' + (p.x - r) + ',' + p.y +
	  			arc + (r * 2) + ',0 ' +
	  			arc + (-r * 2) + ',0 ';
	
	  		this._setPath(layer, d);
	  	},
	
	  	_setPath: function (layer, path) {
	  		layer._path.setAttribute('d', path);
	  	},
	
	  	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	  	_bringToFront: function (layer) {
	  		toFront(layer._path);
	  	},
	
	  	_bringToBack: function (layer) {
	  		toBack(layer._path);
	  	}
	  });
	
	  if (vml) {
	  	SVG.include(vmlMixin);
	  }
	
	  // @namespace SVG
	  // @factory L.svg(options?: Renderer options)
	  // Creates a SVG renderer with the given options.
	  function svg$1(options) {
	  	return svg || vml ? new SVG(options) : null;
	  }
	
	  Map.include({
	  	// @namespace Map; @method getRenderer(layer: Path): Renderer
	  	// Returns the instance of `Renderer` that should be used to render the given
	  	// `Path`. It will ensure that the `renderer` options of the map and paths
	  	// are respected, and that the renderers do exist on the map.
	  	getRenderer: function (layer) {
	  		// @namespace Path; @option renderer: Renderer
	  		// Use this specific instance of `Renderer` for this path. Takes
	  		// precedence over the map's [default renderer](#map-renderer).
	  		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
	  		if (!renderer) {
	  			renderer = this._renderer = this._createRenderer();
	  		}
	
	  		if (!this.hasLayer(renderer)) {
	  			this.addLayer(renderer);
	  		}
	  		return renderer;
	  	},
	
	  	_getPaneRenderer: function (name) {
	  		if (name === 'overlayPane' || name === undefined) {
	  			return false;
	  		}
	
	  		var renderer = this._paneRenderers[name];
	  		if (renderer === undefined) {
	  			renderer = this._createRenderer({pane: name});
	  			this._paneRenderers[name] = renderer;
	  		}
	  		return renderer;
	  	},
	
	  	_createRenderer: function (options) {
	  		// @namespace Map; @option preferCanvas: Boolean = false
	  		// Whether `Path`s should be rendered on a `Canvas` renderer.
	  		// By default, all `Path`s are rendered in a `SVG` renderer.
	  		return (this.options.preferCanvas && canvas$1(options)) || svg$1(options);
	  	}
	  });
	
	  /*
	   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	   */
	
	  /*
	   * @class Rectangle
	   * @aka L.Rectangle
	   * @inherits Polygon
	   *
	   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	   *
	   * @example
	   *
	   * ```js
	   * // define rectangle geographical bounds
	   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	   *
	   * // create an orange rectangle
	   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	   *
	   * // zoom the map to the rectangle bounds
	   * map.fitBounds(bounds);
	   * ```
	   *
	   */
	
	
	  var Rectangle = Polygon.extend({
	  	initialize: function (latLngBounds, options) {
	  		Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	  	},
	
	  	// @method setBounds(latLngBounds: LatLngBounds): this
	  	// Redraws the rectangle with the passed bounds.
	  	setBounds: function (latLngBounds) {
	  		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	  	},
	
	  	_boundsToLatLngs: function (latLngBounds) {
	  		latLngBounds = toLatLngBounds(latLngBounds);
	  		return [
	  			latLngBounds.getSouthWest(),
	  			latLngBounds.getNorthWest(),
	  			latLngBounds.getNorthEast(),
	  			latLngBounds.getSouthEast()
	  		];
	  	}
	  });
	
	
	  // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	  function rectangle(latLngBounds, options) {
	  	return new Rectangle(latLngBounds, options);
	  }
	
	  SVG.create = create$2;
	  SVG.pointsToPath = pointsToPath;
	
	  GeoJSON.geometryToLayer = geometryToLayer;
	  GeoJSON.coordsToLatLng = coordsToLatLng;
	  GeoJSON.coordsToLatLngs = coordsToLatLngs;
	  GeoJSON.latLngToCoords = latLngToCoords;
	  GeoJSON.latLngsToCoords = latLngsToCoords;
	  GeoJSON.getFeature = getFeature;
	  GeoJSON.asFeature = asFeature;
	
	  /*
	   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	   * (zoom to a selected bounding box), enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @option boxZoom: Boolean = true
	  	// Whether the map can be zoomed to a rectangular area specified by
	  	// dragging the mouse while pressing the shift key.
	  	boxZoom: true
	  });
	
	  var BoxZoom = Handler.extend({
	  	initialize: function (map) {
	  		this._map = map;
	  		this._container = map._container;
	  		this._pane = map._panes.overlayPane;
	  		this._resetStateTimeout = 0;
	  		map.on('unload', this._destroy, this);
	  	},
	
	  	addHooks: function () {
	  		on(this._container, 'mousedown', this._onMouseDown, this);
	  	},
	
	  	removeHooks: function () {
	  		off(this._container, 'mousedown', this._onMouseDown, this);
	  	},
	
	  	moved: function () {
	  		return this._moved;
	  	},
	
	  	_destroy: function () {
	  		remove(this._pane);
	  		delete this._pane;
	  	},
	
	  	_resetState: function () {
	  		this._resetStateTimeout = 0;
	  		this._moved = false;
	  	},
	
	  	_clearDeferredResetState: function () {
	  		if (this._resetStateTimeout !== 0) {
	  			clearTimeout(this._resetStateTimeout);
	  			this._resetStateTimeout = 0;
	  		}
	  	},
	
	  	_onMouseDown: function (e) {
	  		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
	  		// Clear the deferred resetState if it hasn't executed yet, otherwise it
	  		// will interrupt the interaction and orphan a box element in the container.
	  		this._clearDeferredResetState();
	  		this._resetState();
	
	  		disableTextSelection();
	  		disableImageDrag();
	
	  		this._startPoint = this._map.mouseEventToContainerPoint(e);
	
	  		on(document, {
	  			contextmenu: stop,
	  			mousemove: this._onMouseMove,
	  			mouseup: this._onMouseUp,
	  			keydown: this._onKeyDown
	  		}, this);
	  	},
	
	  	_onMouseMove: function (e) {
	  		if (!this._moved) {
	  			this._moved = true;
	
	  			this._box = create$1('div', 'leaflet-zoom-box', this._container);
	  			addClass(this._container, 'leaflet-crosshair');
	
	  			this._map.fire('boxzoomstart');
	  		}
	
	  		this._point = this._map.mouseEventToContainerPoint(e);
	
	  		var bounds = new Bounds(this._point, this._startPoint),
	  		    size = bounds.getSize();
	
	  		setPosition(this._box, bounds.min);
	
	  		this._box.style.width  = size.x + 'px';
	  		this._box.style.height = size.y + 'px';
	  	},
	
	  	_finish: function () {
	  		if (this._moved) {
	  			remove(this._box);
	  			removeClass(this._container, 'leaflet-crosshair');
	  		}
	
	  		enableTextSelection();
	  		enableImageDrag();
	
	  		off(document, {
	  			contextmenu: stop,
	  			mousemove: this._onMouseMove,
	  			mouseup: this._onMouseUp,
	  			keydown: this._onKeyDown
	  		}, this);
	  	},
	
	  	_onMouseUp: function (e) {
	  		if ((e.which !== 1) && (e.button !== 1)) { return; }
	
	  		this._finish();
	
	  		if (!this._moved) { return; }
	  		// Postpone to next JS tick so internal click event handling
	  		// still see it as "moved".
	  		this._clearDeferredResetState();
	  		this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
	  		var bounds = new LatLngBounds(
	  		        this._map.containerPointToLatLng(this._startPoint),
	  		        this._map.containerPointToLatLng(this._point));
	
	  		this._map
	  			.fitBounds(bounds)
	  			.fire('boxzoomend', {boxZoomBounds: bounds});
	  	},
	
	  	_onKeyDown: function (e) {
	  		if (e.keyCode === 27) {
	  			this._finish();
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property boxZoom: Handler
	  // Box (shift-drag with mouse) zoom handler.
	  Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	  /*
	   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	
	  Map.mergeOptions({
	  	// @option doubleClickZoom: Boolean|String = true
	  	// Whether the map can be zoomed in by double clicking on it and
	  	// zoomed out by double clicking while holding shift. If passed
	  	// `'center'`, double-click zoom will zoom to the center of the
	  	//  view regardless of where the mouse was.
	  	doubleClickZoom: true
	  });
	
	  var DoubleClickZoom = Handler.extend({
	  	addHooks: function () {
	  		this._map.on('dblclick', this._onDoubleClick, this);
	  	},
	
	  	removeHooks: function () {
	  		this._map.off('dblclick', this._onDoubleClick, this);
	  	},
	
	  	_onDoubleClick: function (e) {
	  		var map = this._map,
	  		    oldZoom = map.getZoom(),
	  		    delta = map.options.zoomDelta,
	  		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
	  		if (map.options.doubleClickZoom === 'center') {
	  			map.setZoom(zoom);
	  		} else {
	  			map.setZoomAround(e.containerPoint, zoom);
	  		}
	  	}
	  });
	
	  // @section Handlers
	  //
	  // Map properties include interaction handlers that allow you to control
	  // interaction behavior in runtime, enabling or disabling certain features such
	  // as dragging or touch zoom (see `Handler` methods). For example:
	  //
	  // ```js
	  // map.doubleClickZoom.disable();
	  // ```
	  //
	  // @property doubleClickZoom: Handler
	  // Double click zoom handler.
	  Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	  /*
	   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @option dragging: Boolean = true
	  	// Whether the map be draggable with mouse/touch or not.
	  	dragging: true,
	
	  	// @section Panning Inertia Options
	  	// @option inertia: Boolean = *
	  	// If enabled, panning of the map will have an inertia effect where
	  	// the map builds momentum while dragging and continues moving in
	  	// the same direction for some time. Feels especially nice on touch
	  	// devices. Enabled by default unless running on old Android devices.
	  	inertia: !android23,
	
	  	// @option inertiaDeceleration: Number = 3000
	  	// The rate with which the inertial movement slows down, in pixels/second².
	  	inertiaDeceleration: 3400, // px/s^2
	
	  	// @option inertiaMaxSpeed: Number = Infinity
	  	// Max speed of the inertial movement, in pixels/second.
	  	inertiaMaxSpeed: Infinity, // px/s
	
	  	// @option easeLinearity: Number = 0.2
	  	easeLinearity: 0.2,
	
	  	// TODO refactor, move to CRS
	  	// @option worldCopyJump: Boolean = false
	  	// With this option enabled, the map tracks when you pan to another "copy"
	  	// of the world and seamlessly jumps to the original one so that all overlays
	  	// like markers and vector layers are still visible.
	  	worldCopyJump: false,
	
	  	// @option maxBoundsViscosity: Number = 0.0
	  	// If `maxBounds` is set, this option will control how solid the bounds
	  	// are when dragging the map around. The default value of `0.0` allows the
	  	// user to drag outside the bounds at normal speed, higher values will
	  	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	  	// solid, preventing the user from dragging outside the bounds.
	  	maxBoundsViscosity: 0.0
	  });
	
	  var Drag = Handler.extend({
	  	addHooks: function () {
	  		if (!this._draggable) {
	  			var map = this._map;
	
	  			this._draggable = new Draggable(map._mapPane, map._container);
	
	  			this._draggable.on({
	  				dragstart: this._onDragStart,
	  				drag: this._onDrag,
	  				dragend: this._onDragEnd
	  			}, this);
	
	  			this._draggable.on('predrag', this._onPreDragLimit, this);
	  			if (map.options.worldCopyJump) {
	  				this._draggable.on('predrag', this._onPreDragWrap, this);
	  				map.on('zoomend', this._onZoomEnd, this);
	
	  				map.whenReady(this._onZoomEnd, this);
	  			}
	  		}
	  		addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
	  		this._draggable.enable();
	  		this._positions = [];
	  		this._times = [];
	  	},
	
	  	removeHooks: function () {
	  		removeClass(this._map._container, 'leaflet-grab');
	  		removeClass(this._map._container, 'leaflet-touch-drag');
	  		this._draggable.disable();
	  	},
	
	  	moved: function () {
	  		return this._draggable && this._draggable._moved;
	  	},
	
	  	moving: function () {
	  		return this._draggable && this._draggable._moving;
	  	},
	
	  	_onDragStart: function () {
	  		var map = this._map;
	
	  		map._stop();
	  		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
	  			var bounds = toLatLngBounds(this._map.options.maxBounds);
	
	  			this._offsetLimit = toBounds(
	  				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
	  				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
	  					.add(this._map.getSize()));
	
	  			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
	  		} else {
	  			this._offsetLimit = null;
	  		}
	
	  		map
	  		    .fire('movestart')
	  		    .fire('dragstart');
	
	  		if (map.options.inertia) {
	  			this._positions = [];
	  			this._times = [];
	  		}
	  	},
	
	  	_onDrag: function (e) {
	  		if (this._map.options.inertia) {
	  			var time = this._lastTime = +new Date(),
	  			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
	  			this._positions.push(pos);
	  			this._times.push(time);
	
	  			this._prunePositions(time);
	  		}
	
	  		this._map
	  		    .fire('move', e)
	  		    .fire('drag', e);
	  	},
	
	  	_prunePositions: function (time) {
	  		while (this._positions.length > 1 && time - this._times[0] > 50) {
	  			this._positions.shift();
	  			this._times.shift();
	  		}
	  	},
	
	  	_onZoomEnd: function () {
	  		var pxCenter = this._map.getSize().divideBy(2),
	  		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
	  		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
	  		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	  	},
	
	  	_viscousLimit: function (value, threshold) {
	  		return value - (value - threshold) * this._viscosity;
	  	},
	
	  	_onPreDragLimit: function () {
	  		if (!this._viscosity || !this._offsetLimit) { return; }
	
	  		var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
	  		var limit = this._offsetLimit;
	  		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
	  		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
	  		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
	  		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
	  		this._draggable._newPos = this._draggable._startPos.add(offset);
	  	},
	
	  	_onPreDragWrap: function () {
	  		// TODO refactor to be able to adjust map pane position after zoom
	  		var worldWidth = this._worldWidth,
	  		    halfWidth = Math.round(worldWidth / 2),
	  		    dx = this._initialWorldOffset,
	  		    x = this._draggable._newPos.x,
	  		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
	  		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
	  		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
	  		this._draggable._absPos = this._draggable._newPos.clone();
	  		this._draggable._newPos.x = newX;
	  	},
	
	  	_onDragEnd: function (e) {
	  		var map = this._map,
	  		    options = map.options,
	
	  		    noInertia = !options.inertia || this._times.length < 2;
	
	  		map.fire('dragend', e);
	
	  		if (noInertia) {
	  			map.fire('moveend');
	
	  		} else {
	  			this._prunePositions(+new Date());
	
	  			var direction = this._lastPos.subtract(this._positions[0]),
	  			    duration = (this._lastTime - this._times[0]) / 1000,
	  			    ease = options.easeLinearity,
	
	  			    speedVector = direction.multiplyBy(ease / duration),
	  			    speed = speedVector.distanceTo([0, 0]),
	
	  			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
	  			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
	  			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
	  			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
	  			if (!offset.x && !offset.y) {
	  				map.fire('moveend');
	
	  			} else {
	  				offset = map._limitOffset(offset, map.options.maxBounds);
	
	  				requestAnimFrame(function () {
	  					map.panBy(offset, {
	  						duration: decelerationDuration,
	  						easeLinearity: ease,
	  						noMoveStart: true,
	  						animate: true
	  					});
	  				});
	  			}
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property dragging: Handler
	  // Map dragging handler (by both mouse and touch).
	  Map.addInitHook('addHandler', 'dragging', Drag);
	
	  /*
	   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	   */
	
	  // @namespace Map
	  // @section Keyboard Navigation Options
	  Map.mergeOptions({
	  	// @option keyboard: Boolean = true
	  	// Makes the map focusable and allows users to navigate the map with keyboard
	  	// arrows and `+`/`-` keys.
	  	keyboard: true,
	
	  	// @option keyboardPanDelta: Number = 80
	  	// Amount of pixels to pan when pressing an arrow key.
	  	keyboardPanDelta: 80
	  });
	
	  var Keyboard = Handler.extend({
	
	  	keyCodes: {
	  		left:    [37],
	  		right:   [39],
	  		down:    [40],
	  		up:      [38],
	  		zoomIn:  [187, 107, 61, 171],
	  		zoomOut: [189, 109, 54, 173]
	  	},
	
	  	initialize: function (map) {
	  		this._map = map;
	
	  		this._setPanDelta(map.options.keyboardPanDelta);
	  		this._setZoomDelta(map.options.zoomDelta);
	  	},
	
	  	addHooks: function () {
	  		var container = this._map._container;
	
	  		// make the container focusable by tabbing
	  		if (container.tabIndex <= 0) {
	  			container.tabIndex = '0';
	  		}
	
	  		on(container, {
	  			focus: this._onFocus,
	  			blur: this._onBlur,
	  			mousedown: this._onMouseDown
	  		}, this);
	
	  		this._map.on({
	  			focus: this._addHooks,
	  			blur: this._removeHooks
	  		}, this);
	  	},
	
	  	removeHooks: function () {
	  		this._removeHooks();
	
	  		off(this._map._container, {
	  			focus: this._onFocus,
	  			blur: this._onBlur,
	  			mousedown: this._onMouseDown
	  		}, this);
	
	  		this._map.off({
	  			focus: this._addHooks,
	  			blur: this._removeHooks
	  		}, this);
	  	},
	
	  	_onMouseDown: function () {
	  		if (this._focused) { return; }
	
	  		var body = document.body,
	  		    docEl = document.documentElement,
	  		    top = body.scrollTop || docEl.scrollTop,
	  		    left = body.scrollLeft || docEl.scrollLeft;
	
	  		this._map._container.focus();
	
	  		window.scrollTo(left, top);
	  	},
	
	  	_onFocus: function () {
	  		this._focused = true;
	  		this._map.fire('focus');
	  	},
	
	  	_onBlur: function () {
	  		this._focused = false;
	  		this._map.fire('blur');
	  	},
	
	  	_setPanDelta: function (panDelta) {
	  		var keys = this._panKeys = {},
	  		    codes = this.keyCodes,
	  		    i, len;
	
	  		for (i = 0, len = codes.left.length; i < len; i++) {
	  			keys[codes.left[i]] = [-1 * panDelta, 0];
	  		}
	  		for (i = 0, len = codes.right.length; i < len; i++) {
	  			keys[codes.right[i]] = [panDelta, 0];
	  		}
	  		for (i = 0, len = codes.down.length; i < len; i++) {
	  			keys[codes.down[i]] = [0, panDelta];
	  		}
	  		for (i = 0, len = codes.up.length; i < len; i++) {
	  			keys[codes.up[i]] = [0, -1 * panDelta];
	  		}
	  	},
	
	  	_setZoomDelta: function (zoomDelta) {
	  		var keys = this._zoomKeys = {},
	  		    codes = this.keyCodes,
	  		    i, len;
	
	  		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
	  			keys[codes.zoomIn[i]] = zoomDelta;
	  		}
	  		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
	  			keys[codes.zoomOut[i]] = -zoomDelta;
	  		}
	  	},
	
	  	_addHooks: function () {
	  		on(document, 'keydown', this._onKeyDown, this);
	  	},
	
	  	_removeHooks: function () {
	  		off(document, 'keydown', this._onKeyDown, this);
	  	},
	
	  	_onKeyDown: function (e) {
	  		if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
	  		var key = e.keyCode,
	  		    map = this._map,
	  		    offset;
	
	  		if (key in this._panKeys) {
	  			if (!map._panAnim || !map._panAnim._inProgress) {
	  				offset = this._panKeys[key];
	  				if (e.shiftKey) {
	  					offset = toPoint(offset).multiplyBy(3);
	  				}
	
	  				map.panBy(offset);
	
	  				if (map.options.maxBounds) {
	  					map.panInsideBounds(map.options.maxBounds);
	  				}
	  			}
	  		} else if (key in this._zoomKeys) {
	  			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
	  		} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
	  			map.closePopup();
	
	  		} else {
	  			return;
	  		}
	
	  		stop(e);
	  	}
	  });
	
	  // @section Handlers
	  // @section Handlers
	  // @property keyboard: Handler
	  // Keyboard navigation handler.
	  Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	  /*
	   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Mouse wheel options
	  	// @option scrollWheelZoom: Boolean|String = true
	  	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	  	// it will zoom to the center of the view regardless of where the mouse was.
	  	scrollWheelZoom: true,
	
	  	// @option wheelDebounceTime: Number = 40
	  	// Limits the rate at which a wheel can fire (in milliseconds). By default
	  	// user can't zoom via wheel more often than once per 40 ms.
	  	wheelDebounceTime: 40,
	
	  	// @option wheelPxPerZoomLevel: Number = 60
	  	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	  	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	  	// faster (and vice versa).
	  	wheelPxPerZoomLevel: 60
	  });
	
	  var ScrollWheelZoom = Handler.extend({
	  	addHooks: function () {
	  		on(this._map._container, 'wheel', this._onWheelScroll, this);
	
	  		this._delta = 0;
	  	},
	
	  	removeHooks: function () {
	  		off(this._map._container, 'wheel', this._onWheelScroll, this);
	  	},
	
	  	_onWheelScroll: function (e) {
	  		var delta = getWheelDelta(e);
	
	  		var debounce = this._map.options.wheelDebounceTime;
	
	  		this._delta += delta;
	  		this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
	  		if (!this._startTime) {
	  			this._startTime = +new Date();
	  		}
	
	  		var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
	  		clearTimeout(this._timer);
	  		this._timer = setTimeout(bind(this._performZoom, this), left);
	
	  		stop(e);
	  	},
	
	  	_performZoom: function () {
	  		var map = this._map,
	  		    zoom = map.getZoom(),
	  		    snap = this._map.options.zoomSnap || 0;
	
	  		map._stop(); // stop panning and fly animations if any
	
	  		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
	  		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
	  		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
	  		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
	  		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
	  		this._delta = 0;
	  		this._startTime = null;
	
	  		if (!delta) { return; }
	
	  		if (map.options.scrollWheelZoom === 'center') {
	  			map.setZoom(zoom + delta);
	  		} else {
	  			map.setZoomAround(this._lastMousePos, zoom + delta);
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property scrollWheelZoom: Handler
	  // Scroll wheel zoom handler.
	  Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	  /*
	   * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Touch interaction options
	  	// @option tap: Boolean = true
	  	// Enables mobile hacks for supporting instant taps (fixing 200ms click
	  	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
	  	tap: true,
	
	  	// @option tapTolerance: Number = 15
	  	// The max number of pixels a user can shift his finger during touch
	  	// for it to be considered a valid tap.
	  	tapTolerance: 15
	  });
	
	  var Tap = Handler.extend({
	  	addHooks: function () {
	  		on(this._map._container, 'touchstart', this._onDown, this);
	  	},
	
	  	removeHooks: function () {
	  		off(this._map._container, 'touchstart', this._onDown, this);
	  	},
	
	  	_onDown: function (e) {
	  		if (!e.touches) { return; }
	
	  		preventDefault(e);
	
	  		this._fireClick = true;
	
	  		// don't simulate click or track longpress if more than 1 touch
	  		if (e.touches.length > 1) {
	  			this._fireClick = false;
	  			clearTimeout(this._holdTimeout);
	  			return;
	  		}
	
	  		var first = e.touches[0],
	  		    el = first.target;
	
	  		this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
	  		// if touching a link, highlight it
	  		if (el.tagName && el.tagName.toLowerCase() === 'a') {
	  			addClass(el, 'leaflet-active');
	  		}
	
	  		// simulate long hold but setting a timeout
	  		this._holdTimeout = setTimeout(bind(function () {
	  			if (this._isTapValid()) {
	  				this._fireClick = false;
	  				this._onUp();
	  				this._simulateEvent('contextmenu', first);
	  			}
	  		}, this), 1000);
	
	  		this._simulateEvent('mousedown', first);
	
	  		on(document, {
	  			touchmove: this._onMove,
	  			touchend: this._onUp
	  		}, this);
	  	},
	
	  	_onUp: function (e) {
	  		clearTimeout(this._holdTimeout);
	
	  		off(document, {
	  			touchmove: this._onMove,
	  			touchend: this._onUp
	  		}, this);
	
	  		if (this._fireClick && e && e.changedTouches) {
	
	  			var first = e.changedTouches[0],
	  			    el = first.target;
	
	  			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
	  				removeClass(el, 'leaflet-active');
	  			}
	
	  			this._simulateEvent('mouseup', first);
	
	  			// simulate click if the touch didn't move too much
	  			if (this._isTapValid()) {
	  				this._simulateEvent('click', first);
	  			}
	  		}
	  	},
	
	  	_isTapValid: function () {
	  		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	  	},
	
	  	_onMove: function (e) {
	  		var first = e.touches[0];
	  		this._newPos = new Point(first.clientX, first.clientY);
	  		this._simulateEvent('mousemove', first);
	  	},
	
	  	_simulateEvent: function (type, e) {
	  		var simulatedEvent = document.createEvent('MouseEvents');
	
	  		simulatedEvent._simulated = true;
	  		e.target._simulatedClick = true;
	
	  		simulatedEvent.initMouseEvent(
	  		        type, true, true, window, 1,
	  		        e.screenX, e.screenY,
	  		        e.clientX, e.clientY,
	  		        false, false, false, false, 0, null);
	
	  		e.target.dispatchEvent(simulatedEvent);
	  	}
	  });
	
	  // @section Handlers
	  // @property tap: Handler
	  // Mobile touch hacks (quick tap and touch hold) handler.
	  if (touch && (!pointer || safari)) {
	  	Map.addInitHook('addHandler', 'tap', Tap);
	  }
	
	  /*
	   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Touch interaction options
	  	// @option touchZoom: Boolean|String = *
	  	// Whether the map can be zoomed by touch-dragging with two fingers. If
	  	// passed `'center'`, it will zoom to the center of the view regardless of
	  	// where the touch events (fingers) were. Enabled for touch-capable web
	  	// browsers except for old Androids.
	  	touchZoom: touch && !android23,
	
	  	// @option bounceAtZoomLimits: Boolean = true
	  	// Set it to false if you don't want the map to zoom beyond min/max zoom
	  	// and then bounce back when pinch-zooming.
	  	bounceAtZoomLimits: true
	  });
	
	  var TouchZoom = Handler.extend({
	  	addHooks: function () {
	  		addClass(this._map._container, 'leaflet-touch-zoom');
	  		on(this._map._container, 'touchstart', this._onTouchStart, this);
	  	},
	
	  	removeHooks: function () {
	  		removeClass(this._map._container, 'leaflet-touch-zoom');
	  		off(this._map._container, 'touchstart', this._onTouchStart, this);
	  	},
	
	  	_onTouchStart: function (e) {
	  		var map = this._map;
	  		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
	  		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
	  		    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
	  		this._centerPoint = map.getSize()._divideBy(2);
	  		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
	  		if (map.options.touchZoom !== 'center') {
	  			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
	  		}
	
	  		this._startDist = p1.distanceTo(p2);
	  		this._startZoom = map.getZoom();
	
	  		this._moved = false;
	  		this._zooming = true;
	
	  		map._stop();
	
	  		on(document, 'touchmove', this._onTouchMove, this);
	  		on(document, 'touchend', this._onTouchEnd, this);
	
	  		preventDefault(e);
	  	},
	
	  	_onTouchMove: function (e) {
	  		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
	  		var map = this._map,
	  		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
	  		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
	  		    scale = p1.distanceTo(p2) / this._startDist;
	
	  		this._zoom = map.getScaleZoom(scale, this._startZoom);
	
	  		if (!map.options.bounceAtZoomLimits && (
	  			(this._zoom < map.getMinZoom() && scale < 1) ||
	  			(this._zoom > map.getMaxZoom() && scale > 1))) {
	  			this._zoom = map._limitZoom(this._zoom);
	  		}
	
	  		if (map.options.touchZoom === 'center') {
	  			this._center = this._startLatLng;
	  			if (scale === 1) { return; }
	  		} else {
	  			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
	  			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
	  			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
	  			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
	  		}
	
	  		if (!this._moved) {
	  			map._moveStart(true, false);
	  			this._moved = true;
	  		}
	
	  		cancelAnimFrame(this._animRequest);
	
	  		var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
	  		this._animRequest = requestAnimFrame(moveFn, this, true);
	
	  		preventDefault(e);
	  	},
	
	  	_onTouchEnd: function () {
	  		if (!this._moved || !this._zooming) {
	  			this._zooming = false;
	  			return;
	  		}
	
	  		this._zooming = false;
	  		cancelAnimFrame(this._animRequest);
	
	  		off(document, 'touchmove', this._onTouchMove, this);
	  		off(document, 'touchend', this._onTouchEnd, this);
	
	  		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
	  		if (this._map.options.zoomAnimation) {
	  			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
	  		} else {
	  			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property touchZoom: Handler
	  // Touch zoom handler.
	  Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	  Map.BoxZoom = BoxZoom;
	  Map.DoubleClickZoom = DoubleClickZoom;
	  Map.Drag = Drag;
	  Map.Keyboard = Keyboard;
	  Map.ScrollWheelZoom = ScrollWheelZoom;
	  Map.Tap = Tap;
	  Map.TouchZoom = TouchZoom;
	
	  exports.version = version;
	  exports.Control = Control;
	  exports.control = control;
	  exports.Browser = Browser;
	  exports.Evented = Evented;
	  exports.Mixin = Mixin;
	  exports.Util = Util;
	  exports.Class = Class;
	  exports.Handler = Handler;
	  exports.extend = extend;
	  exports.bind = bind;
	  exports.stamp = stamp;
	  exports.setOptions = setOptions;
	  exports.DomEvent = DomEvent;
	  exports.DomUtil = DomUtil;
	  exports.PosAnimation = PosAnimation;
	  exports.Draggable = Draggable;
	  exports.LineUtil = LineUtil;
	  exports.PolyUtil = PolyUtil;
	  exports.Point = Point;
	  exports.point = toPoint;
	  exports.Bounds = Bounds;
	  exports.bounds = toBounds;
	  exports.Transformation = Transformation;
	  exports.transformation = toTransformation;
	  exports.Projection = index;
	  exports.LatLng = LatLng;
	  exports.latLng = toLatLng;
	  exports.LatLngBounds = LatLngBounds;
	  exports.latLngBounds = toLatLngBounds;
	  exports.CRS = CRS;
	  exports.GeoJSON = GeoJSON;
	  exports.geoJSON = geoJSON;
	  exports.geoJson = geoJson;
	  exports.Layer = Layer;
	  exports.LayerGroup = LayerGroup;
	  exports.layerGroup = layerGroup;
	  exports.FeatureGroup = FeatureGroup;
	  exports.featureGroup = featureGroup;
	  exports.ImageOverlay = ImageOverlay;
	  exports.imageOverlay = imageOverlay;
	  exports.VideoOverlay = VideoOverlay;
	  exports.videoOverlay = videoOverlay;
	  exports.SVGOverlay = SVGOverlay;
	  exports.svgOverlay = svgOverlay;
	  exports.DivOverlay = DivOverlay;
	  exports.Popup = Popup;
	  exports.popup = popup;
	  exports.Tooltip = Tooltip;
	  exports.tooltip = tooltip;
	  exports.Icon = Icon;
	  exports.icon = icon;
	  exports.DivIcon = DivIcon;
	  exports.divIcon = divIcon;
	  exports.Marker = Marker;
	  exports.marker = marker;
	  exports.TileLayer = TileLayer;
	  exports.tileLayer = tileLayer;
	  exports.GridLayer = GridLayer;
	  exports.gridLayer = gridLayer;
	  exports.SVG = SVG;
	  exports.svg = svg$1;
	  exports.Renderer = Renderer;
	  exports.Canvas = Canvas;
	  exports.canvas = canvas$1;
	  exports.Path = Path;
	  exports.CircleMarker = CircleMarker;
	  exports.circleMarker = circleMarker;
	  exports.Circle = Circle;
	  exports.circle = circle;
	  exports.Polyline = Polyline;
	  exports.polyline = polyline;
	  exports.Polygon = Polygon;
	  exports.polygon = polygon;
	  exports.Rectangle = Rectangle;
	  exports.rectangle = rectangle;
	  exports.Map = Map;
	  exports.map = createMap;
	
	  var oldL = window.L;
	  exports.noConflict = function() {
	  	window.L = oldL;
	  	return this;
	  }
	
	  // Always export us to window global (see #2364)
	  window.L = exports;
	
	})));
	//# sourceMappingURL=leaflet-src.js.map


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(305)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 159 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(224);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(310);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 162 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(80);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(58);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(371);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(58);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(40);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(101);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(80);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(441);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(72);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(72);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(39);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(48);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(23);
	
	var quoteAttributeValueForBrowser = __webpack_require__(435);
	var warning = __webpack_require__(12);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var LinkedValueUtils = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(29);
	
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 188 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(395);
	
	var containsNode = __webpack_require__(292);
	var focusNode = __webpack_require__(154);
	var getActiveElement = __webpack_require__(155);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(47);
	var DOMProperty = __webpack_require__(48);
	var React = __webpack_require__(51);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMContainerInfo = __webpack_require__(389);
	var ReactDOMFeatureFlags = __webpack_require__(391);
	var ReactFeatureFlags = __webpack_require__(188);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMarkupChecksum = __webpack_require__(405);
	var ReactReconciler = __webpack_require__(49);
	var ReactUpdateQueue = __webpack_require__(115);
	var ReactUpdates = __webpack_require__(29);
	
	var emptyObject = __webpack_require__(99);
	var instantiateReactComponent = __webpack_require__(199);
	var invariant = __webpack_require__(10);
	var setInnerHTML = __webpack_require__(79);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var warning = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var React = __webpack_require__(51);
	
	var invariant = __webpack_require__(10);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 193 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(192);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var ReactCompositeComponent = __webpack_require__(386);
	var ReactEmptyComponent = __webpack_require__(187);
	var ReactHostComponent = __webpack_require__(189);
	
	var getNextDebugID = __webpack_require__(483);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var setInnerHTML = __webpack_require__(79);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var REACT_ELEMENT_TYPE = __webpack_require__(401);
	
	var getIteratorFn = __webpack_require__(432);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(111);
	var warning = __webpack_require__(12);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(124);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(63);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(123);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(45);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(206);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(63);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(68);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(150);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(68);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(98);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(69);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(44);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(211);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 210 */
50,
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(50);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(127);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(158);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = exports.WatershedSFA = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _Filters = __webpack_require__(465);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _SitesMap = __webpack_require__(467);
	
	var _SitesMap2 = _interopRequireDefault(_SitesMap);
	
	var _SitesPane = __webpack_require__(469);
	
	var _SitesPane2 = _interopRequireDefault(_SitesPane);
	
	__webpack_require__(215);
	
	__webpack_require__(471);
	
	var _sites = __webpack_require__(156);
	
	var _sites2 = _interopRequireDefault(_sites);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WatershedSFA = exports.WatershedSFA = function (_Component) {
	    _inherits(WatershedSFA, _Component);
	
	    function WatershedSFA(props) {
	        _classCallCheck(this, WatershedSFA);
	
	        var _this = _possibleConstructorReturn(this, (WatershedSFA.__proto__ || Object.getPrototypeOf(WatershedSFA)).call(this, props));
	
	        _this.state = { container: false };
	        _this.containerRendered = _this.containerRendered.bind(_this);
	        return _this;
	    }
	
	    _createClass(WatershedSFA, [{
	        key: 'containerRendered',
	        value: function containerRendered() {
	            this.setState({ container: true });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.documentElement.className = 'app';
	            document.body.className = 'app';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    this.state.container && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'navbar' },
	                            _react2.default.createElement(Header, null)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(Description, null)
	                        )
	                    ),
	                    _react2.default.createElement(SitesContainer, { data: _sites2.default, hasRendered: this.containerRendered })
	                )
	            );
	        }
	    }]);
	
	    return WatershedSFA;
	}(_react.Component);
	
	var Header = exports.Header = function (_Component2) {
	    _inherits(Header, _Component2);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	    }
	
	    _createClass(Header, [{
	        key: 'render',
	        value: function render() {
	            var logo = __webpack_require__(493);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Navbar,
	                { inverse: true, fluid: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Navbar.Header,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pull-left' },
	                        _react2.default.createElement('img', { id: 'logo', alt: 'SFA Logo', src: logo })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Navbar.Brand,
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://watershed.lbl.gov' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Watershed Function SFA'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Nav,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { active: true },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Field Information Portal'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { href: window.location.origin },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Data Access'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { href: 'https://lbnlsfa.paf.subsurfaceinsights.com/datapackages', target: '_blank' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Data Package System'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { href: 'https://drive.google.com/file/d/0Bz9Zv4YIp0kPVnpZTkRNb0ZyQ2tTdEFZX0xwc05QX0VzRDFj/view' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Data Policy'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { href: window.location.origin + "/feedback" },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Feedback'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component);
	
	var Description = function (_Component3) {
	    _inherits(Description, _Component3);
	
	    function Description() {
	        _classCallCheck(this, Description);
	
	        return _possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).apply(this, arguments));
	    }
	
	    _createClass(Description, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row', id: 'description' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Field Information Portal'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The East River Watershed Function SFA study site provides a collaborative platform that enables the broader scientific community to address a range of questions relevant to watershed structure and behavior. The interactive map below identifies sites where the SFA team and collaborators are acquiring different types of measurements within the watershed.'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Description;
	}(_react.Component);
	
	var SitesContainer = function (_Component4) {
	    _inherits(SitesContainer, _Component4);
	
	    function SitesContainer(props) {
	        _classCallCheck(this, SitesContainer);
	
	        var _this4 = _possibleConstructorReturn(this, (SitesContainer.__proto__ || Object.getPrototypeOf(SitesContainer)).call(this, props));
	
	        _this4.state = {
	            sites: _this4.props.data,
	            active: _this4.props.data.features[0],
	            filters: { measurement_categories: new Set(), search_keywords: [] }
	        };
	        _this4.handleCategoryFilterInput = _this4.handleCategoryFilterInput.bind(_this4);
	        _this4.handleSearchFilterInput = _this4.handleSearchFilterInput.bind(_this4);
	        _this4.handleSearchSubmit = _this4.handleSearchSubmit.bind(_this4);
	        _this4.handleMapInput = _this4.handleMapInput.bind(_this4);
	        _this4.handleTableInput = _this4.handleTableInput.bind(_this4);
	        _this4.markerActivated = _this4.markerActivated.bind(_this4);
	        _this4.applyFilters = _this4.applyFilters.bind(_this4);
	
	        _this4.hasRendered = props.hasRendered.bind(_this4);
	        return _this4;
	    }
	
	    _createClass(SitesContainer, [{
	        key: 'handleCategoryFilterInput',
	        value: function handleCategoryFilterInput(categories) {
	            var filters = {
	                measurement_categories: categories,
	                search_keywords: this.state.filters.search_keywords
	            };
	            this.setState({ filters: filters });
	            this.applyFilters(filters);
	        }
	    }, {
	        key: 'handleSearchFilterInput',
	        value: function handleSearchFilterInput(text) {
	            if (text === "") {
	                this.applyFilters({
	                    measurement_categories: this.state.filters.measurement_categories,
	                    search_keywords: []
	                });
	                return;
	            }
	
	            clearTimeout(this.searchTimeout);
	
	            if (text.trim().length < 3) {
	                return;
	            }
	
	            var self = this;
	            this.searchTimeout = setTimeout(function () {
	                var keywords = text.split(' ');
	                var filters = {
	                    measurement_categories: self.state.filters.measurement_categories,
	                    search_keywords: keywords
	                };
	                self.setState({ search_keywords: keywords });
	                self.applyFilters(filters);
	            }, 500);
	        }
	    }, {
	        key: 'handleSearchSubmit',
	        value: function handleSearchSubmit(text) {
	            var keywords = text.split(' ');
	            var filters = {
	                measurement_categories: this.state.filters.measurement_categories,
	                search_keywords: keywords
	            };
	            this.applyFilters(filters);
	        }
	    }, {
	        key: 'applyFilters',
	        value: function applyFilters(filters) {
	            var filteredSites = {
	                type: this.props.data.type,
	                features: this.props.data.features.filter(function (val) {
	                    if (filters.measurement_categories.size === 0 && filters.search_keywords.length === 0) {
	                        return true;
	                    }
	
	                    var found = false;
	                    if (filters.measurement_categories.size === 0) {
	                        found = true;
	                    } else {
	                        for (var i = val.properties.measurement_categories.length - 1; i >= 0; i--) {
	                            found = found || filters.measurement_categories.has(val.properties.measurement_categories[i]);
	                        }
	                    }
	
	                    // test a regex against a string
	                    function match_words(s, re) {
	                        var m = false;
	
	                        if (s) {
	                            // split the string into words, try to match each word
	                            // any word match is enough
	                            s.toString().split(' ').forEach(function (item) {
	                                m = m || item.match(re) !== null;
	                            });
	                            return m;
	                        } else {
	                            return false;
	                        }
	                    }
	
	                    var re = void 0,
	                        matched = {};
	                    for (var _i = 0; _i < filters.search_keywords.length; _i++) {
	                        //escape all regex characters in the search text
	                        re = new RegExp('^' + filters.search_keywords[_i].replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&'), 'i');
	
	                        matched.id = match_words(val.properties.id, re);
	                        matched.name = match_words(val.properties.name, re);
	                        matched.parameters = match_words(val.properties.parameters, re);
	                        matched.category = match_words(val.properties.category, re);
	                        matched.theme = match_words(val.properties.research_theme, re);
	                        matched.contact = match_words(val.properties.contact.name, re);
	                        matched.affiliation = match_words(val.properties.contact.affiliation, re);
	
	                        // if the keyword matches at least one field
	                        found = found && (matched.id || matched.name || matched.parameters || matched.category || matched.theme || matched.contact || matched.affiliation);
	                    }
	
	                    // if all keywords had at least one field match, keep this site
	                    return found;
	                })
	            };
	
	            this.setState({
	                sites: filteredSites,
	                active: filteredSites.features.length > 0 ? filteredSites.features[0] : null
	            });
	        }
	    }, {
	        key: 'markerActivated',
	        value: function markerActivated(feature) {
	            this.setState({ active: feature });
	        }
	    }, {
	        key: 'handleMapInput',
	        value: function handleMapInput(mapState) {
	            console.log(mapState);
	        }
	    }, {
	        key: 'handleTableInput',
	        value: function handleTableInput(id) {
	            for (var i = this.state.sites.features.length - 1; i >= 0; i--) {
	                if (this.state.sites.features[i].id === id) {
	                    this.setState({ active: this.state.sites.features[i] });
	                    break;
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({
	                active: this.props.data.features[0],
	                sites: this.props.data
	            });
	            this.hasRendered();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(_Filters2.default, { onCategoryFilterInput: this.handleCategoryFilterInput,
	                    onSearchFilterInput: this.handleSearchFilterInput,
	                    onSearchSubmit: this.handleSearchSubmit }),
	                _react2.default.createElement(_SitesMap2.default, { sites: this.state.sites,
	                    activeSite: this.state.active,
	                    markerActivated: this.markerActivated,
	                    onMapInput: this.handleMapInput }),
	                _react2.default.createElement(_SitesPane2.default, { sites: this.state.sites,
	                    activeSite: this.state.active,
	                    totalSites: this.props.data.features.length,
	                    onTableInput: this.handleTableInput })
	            );
	        }
	    }]);
	
	    return SitesContainer;
	}(_react.Component);

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uuid = __webpack_require__(858);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _leaflet = __webpack_require__(157);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _esriLeaflet = __webpack_require__(289);
	
	__webpack_require__(470);
	
	__webpack_require__(472);
	
	var _hydrogeologyIcon = __webpack_require__(130);
	
	var _hydrogeologyIcon2 = _interopRequireDefault(_hydrogeologyIcon);
	
	var _biogeochemistryIcon = __webpack_require__(128);
	
	var _biogeochemistryIcon2 = _interopRequireDefault(_biogeochemistryIcon);
	
	var _vegetationIcon = __webpack_require__(132);
	
	var _vegetationIcon2 = _interopRequireDefault(_vegetationIcon);
	
	var _climateIcon = __webpack_require__(129);
	
	var _climateIcon2 = _interopRequireDefault(_climateIcon);
	
	var _modeloutputIcon = __webpack_require__(131);
	
	var _modeloutputIcon2 = _interopRequireDefault(_modeloutputIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icons = {
	    hydrogeology: [0, _hydrogeologyIcon2.default],
	    ecohydrology: [1, _vegetationIcon2.default],
	    biogeochemistry: [2, _biogeochemistryIcon2.default],
	    vegetation: [3, _vegetationIcon2.default],
	    climate: [4, _climateIcon2.default],
	    modeloutput: [5, _modeloutputIcon2.default]
	};
	
	var legendColors = {
	    alpine: "#261447",
	    subalpine: "#FF3864",
	    montane: "#9999CC",
	    foothills: "#F6BD60",
	    plains: "#EDEDE6"
	};
	
	var LeafletMap = function (_Component) {
	    _inherits(LeafletMap, _Component);
	
	    function LeafletMap(props) {
	        _classCallCheck(this, LeafletMap);
	
	        var _this = _possibleConstructorReturn(this, (LeafletMap.__proto__ || Object.getPrototypeOf(LeafletMap)).call(this, props));
	
	        _this.state = {
	            map: null,
	            mapId: _uuid2.default.v4(),
	            activeSite: null,
	            focusOnSite: props.hasOwnProperty("focusOnSite") ? props.focusOnSite : false
	        };
	
	        _this.layers = {
	            markersLayer: null,
	            basemapLayer: null
	        };
	
	        if (props.markerActivated) {
	            _this.markerActivated = props.markerActivated.bind(_this);
	        } else {
	            _this.markerActivated = function (feature) {
	                this.setState({ activeSite: feature });
	            };
	        }
	
	        _this.getBounds = _this.getBounds.bind(_this);
	        _this.onEachFeature = _this.onEachFeature.bind(_this);
	        _this.pointToLayer = _this.pointToLayer.bind(_this);
	        _this.onDragEnd = _this.onDragEnd.bind(_this);
	        _this.onZoomEnd = _this.onZoomEnd.bind(_this);
	        return _this;
	    }
	
	    _createClass(LeafletMap, [{
	        key: 'noop',
	        value: function noop() {
	            //
	            /*
	            
	            
	            
	            watershed_sfa.zones.loaded = false;
	            
	            watershed_sfa.zones.toggle = function() {
	                if (!watershed_sfa.zones.loaded) {
	                    watershed_sfa.map.addLayer(watershed_sfa.zones.layer);
	                    watershed_sfa.map.addControl(watershed_sfa.zones.legend.control);
	                }
	                else {
	                    watershed_sfa.map.removeLayer(watershed_sfa.zones.layer);
	                    watershed_sfa.map.removeControl(watershed_sfa.zones.legend.control);
	                }
	            
	                watershed_sfa.zones.loaded = !watershed_sfa.zones.loaded;
	            }
	            */
	        }
	    }, {
	        key: 'onDragEnd',
	        value: function onDragEnd(e) {
	            //
	        }
	    }, {
	        key: 'onZoomEnd',
	        value: function onZoomEnd(e) {
	            //
	        }
	    }, {
	        key: 'getBounds',
	        value: function getBounds(sites) {
	            var bounds = [[90.0, 180.0], [-90.0, -180.0]];
	            var lat = void 0,
	                lon = void 0;
	            // compute a bounding box to fit the current sites
	            for (var i = sites.features.length - 1; i >= 0; i--) {
	                lat = sites.features[i].geometry.coordinates[1];
	                lon = sites.features[i].geometry.coordinates[0];
	                if (lat > bounds[1][0]) {
	                    bounds[1][0] = lat;
	                }
	                if (lat < bounds[0][0]) {
	                    bounds[0][0] = lat;
	                }
	                if (lon > bounds[1][1]) {
	                    bounds[1][1] = lon;
	                }
	                if (lon < bounds[0][1]) {
	                    bounds[0][1] = lon;
	                }
	            }
	
	            var buffer = 0.001;
	            // pad the bounds to not clip sites near the edge
	            bounds[0][0] -= buffer;
	            bounds[1][0] += buffer;
	            bounds[0][1] -= buffer;
	            bounds[1][1] += buffer;
	
	            return bounds;
	        }
	    }, {
	        key: 'pointToLayer',
	        value: function pointToLayer(feature, latlng) {
	            var html = "";
	            var categories = feature.properties.measurement_categories.sort(function (a, b) {
	                if (icons.hasOwnProperty(a) && icons.hasOwnProperty(b)) {
	                    return icons[a][0] - icons[b][0];
	                } else {
	                    var unknownCategories = [];
	                    if (!icons.hasOwnProperty(a)) {
	                        unknownCategories.push(a);
	                    }
	                    if (!icons.hasOwnProperty(b)) {
	                        unknownCategories.push(b);
	                    }
	                    throw Error("Unrecognized measurement categories: " + unknownCategories);
	                }
	            });
	            var numIcons = 0;
	            var iconSize = [32, 20];
	
	            for (var i = 0; i < categories.length; i++) {
	                if (icons.hasOwnProperty(categories[i])) {
	                    html += "<img class='measurement-icon' id='" + feature.id + "-icon' src='" + icons[categories[i]][1] + "'/>";
	                    numIcons += 1;
	                }
	            }
	
	            if (numIcons > 1) {
	                iconSize[0] = 28 * numIcons;
	            }
	
	            return _leaflet2.default.marker(latlng, { icon: _leaflet2.default.divIcon({
	                    className: 'custom-div-icon',
	                    iconSize: iconSize,
	                    html: html
	                }) });
	        }
	    }, {
	        key: 'onEachFeature',
	        value: function onEachFeature(feature, layer) {
	            var self = this;
	
	            layer.on('mouseover', function (evt) {
	                evt.target.bindPopup(_leaflet2.default.popup().setContent("<div>" + feature.id + "</div>")).openPopup();
	            });
	            layer.on('mouseout', function (evt) {
	                evt.target.closePopup();
	            });
	            layer.on('click', function (evt) {
	                self.markerActivated(feature);
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.map && this.layers.markersLayer) {
	                var map = this.state.map;
	
	                if (nextProps.sites === this.props.sites) {
	                    if (this.state.activeSite && this.state.activeSite.id !== nextProps.activeSite.id) {
	                        //document.getElementsByClassName("custom-div-icon-activated")
	
	                        //console.log(document.getElementById(this.state.activeSite.id + "-icon").parentElement.className.replace("custom-div-icon-activated",""));
	                        // clear state of last active icon
	                        document.getElementById(this.state.activeSite.id + "-icon").parentElement.className = document.getElementById(this.state.activeSite.id + "-icon").parentElement.className.replace(new RegExp("custom-div-icon-activated", 'g'), "");
	                        // set new active icon state
	                        document.getElementById(nextProps.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
	                    }
	
	                    this.setState({ activeSite: nextProps.activeSite });
	                    return;
	                }
	
	                map.removeLayer(this.layers.markersLayer);
	                this.layers.markersLayer = _leaflet2.default.geoJSON(nextProps.sites, {
	                    pointToLayer: this.pointToLayer,
	                    onEachFeature: this.onEachFeature
	                });
	                map.addLayer(this.layers.markersLayer);
	                if (nextProps.activeSite && !document.getElementById(nextProps.activeSite.id + "-icon").parentElement.className.includes("custom-div-icon-activated")) {
	                    document.getElementById(nextProps.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
	                }
	
	                map.fitBounds(this.getBounds(nextProps.sites), { animate: true });
	                this.setState({ map: map, activeSite: nextProps.activeSite });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var map = this.state.map;
	            if (map) {
	                map.invalidateSize(false);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var map = _leaflet2.default.map(this.state.mapId, { renderer: _leaflet2.default.canvas() });
	
	            var esriLayers = [(0, _esriLeaflet.basemapLayer)("Topographic", { maxNativeZoom: 19, maxZoom: 24 }), (0, _esriLeaflet.basemapLayer)("NationalGeographic", { maxNativeZoom: 16, maxZoom: 24, zoom: 18 }), (0, _esriLeaflet.basemapLayer)("Terrain", { maxNativeZoom: 13, maxZoom: 24 }), (0, _esriLeaflet.basemapLayer)("USATopo", { maxNativeZoom: 15, maxZoom: 24 }), (0, _esriLeaflet.basemapLayer)("ShadedRelief", { maxNativeZoom: 13, maxZoom: 24 }), (0, _esriLeaflet.basemapLayer)("Imagery", { maxNativeZoom: 19, maxZoom: 24 })];
	
	            var baseMaps = {
	                "Topographic": esriLayers[0],
	                "NationalGeographic": esriLayers[1],
	                "Terrain": esriLayers[2],
	                "USATopo": esriLayers[3],
	                "ShadedRelief": esriLayers[4],
	                "Imagery": esriLayers[5]
	            };
	
	            var zonesLegend = _leaflet2.default.control({ position: 'topright' });
	            zonesLegend.onAdd = function (map) {
	                this._div = _leaflet2.default.DomUtil.create('div', 'legend');
	                this._div.innerHTML += '<div id="zonesLegend">' + '<div class="legend-color" style="background:' + legendColors.alpine + '"></div>' + '<div class="legend-label">Alpine</div>' + '<div class="legend-color" style="background:' + legendColors.subalpine + '"></div>' + '<div class="legend-label">Sub-Alpine</div>' + '<div class="legend-color" style="background:' + legendColors.montane + '"></div>' + '<div class="legend-label">Montane</div>' + '<div class="legend-color" style="background:' + legendColors.foothills + '"></div>' + '<div class="legend-label">Foothills</div>' + '<div class="legend-color" style="background:' + legendColors.plains + '"></div>' + '<div class="legend-label">Plains</div>' + '</div>';
	                return this._div;
	            };
	            var zonesLayer = (0, _esriLeaflet.featureLayer)({
	                url: "https://services4.arcgis.com/jzlMsmscSx37zEbh/arcgis/rest/services/Colorado_Lifezones/FeatureServer/0",
	                renderer: _leaflet2.default.canvas(),
	                cacheLayers: true,
	                style: function style(feature) {
	                    if (!feature.hasOwnProperty('properties')) {
	                        return;
	                    }
	
	                    if (feature.properties.Name === "Alpine") {
	                        return { color: legendColors.alpine, weight: 1, fillOpacity: 0.5 };
	                    } else if (feature.properties.Name === "Sub-Alpine") {
	                        return { color: legendColors.subalpine, weight: 1, fillOpacity: 0.5 };
	                    } else if (feature.properties.Name === "Montane") {
	                        return { color: legendColors.montane, weight: 1, fillOpacity: 0.5 };
	                    } else if (feature.properties.Name === "Foothills") {
	                        return { color: legendColors.foothills, weight: 1, fillOpacity: 0.5 };
	                    } else if (feature.properties.Name === "Plains") {
	                        return { color: legendColors.plains, weight: 1, fillOpacity: 0.5 };
	                    } else {
	                        return null;
	                    }
	                }
	            });
	            var zonesLoading = _leaflet2.default.control({ position: 'topright' });
	            zonesLoading.onAdd = function (map) {
	                var div = _leaflet2.default.DomUtil.create('div', 'loading');
	                div.innerHTML += '' + '<span class="glyphicon-left glyphicon glyphicon-refresh spinning"></span>' + '<span class="loading-text">Loading</span>';
	                return div;
	            };
	
	            zonesLayer.on('load', function (evt) {
	                zonesLoading.remove(map);
	            });
	
	            map.on('overlayadd', function (eventLayer) {
	                if (eventLayer.name === "Life Zones") {
	                    zonesLoading.addTo(map);
	                    zonesLegend.addTo(map);
	                }
	            });
	
	            map.on('overlayremove', function (eventLayer) {
	                if (eventLayer.name === "Life Zones") {
	                    zonesLegend.remove(map);
	                }
	            });
	
	            _leaflet2.default.control.layers(baseMaps, { "Life Zones": zonesLayer }, { position: 'topleft' }).addTo(map);
	            _leaflet2.default.control.scale({ position: 'topright' }).addTo(map);
	
	            if (this.state.focusOnSite) {
	                var bounds = [[this.props.activeSite.geometry.coordinates[1] - 1.0, this.props.activeSite.geometry.coordinates[0] - 1.0], [this.props.activeSite.geometry.coordinates[1] + 1.0, this.props.activeSite.geometry.coordinates[0] + 1.0]];
	                this.layers.basemapLayer = baseMaps["NationalGeographic"];
	                map.addLayer(this.layers.basemapLayer);
	                map.invalidateSize(false).fitBounds(bounds).setView({
	                    lon: this.props.activeSite.geometry.coordinates[0],
	                    lat: this.props.activeSite.geometry.coordinates[1]
	                }, 16);
	                this.layers.markersLayer = _leaflet2.default.geoJSON(this.props.sites, {
	                    pointToLayer: this.pointToLayer,
	                    onEachFeature: this.onEachFeature
	                });
	                map.addLayer(this.layers.markersLayer);
	                document.getElementById(this.props.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
	            } else {
	                map.invalidateSize(false).fitBounds(this.getBounds(this.props.sites));
	
	                if (this.layers.markersLayer !== null && map.hasLayer(this.layers.markersLayer)) {
	                    map.removeLayer(this.layers.markersLayer);
	                }
	
	                if (this.layers.basemapLayer === null) {
	                    this.layers.basemapLayer = baseMaps["NationalGeographic"];
	                    map.addLayer(this.layers.basemapLayer);
	                }
	
	                this.layers.markersLayer = _leaflet2.default.geoJSON(this.props.sites, {
	                    pointToLayer: this.pointToLayer,
	                    onEachFeature: this.onEachFeature
	                });
	                map.addLayer(this.layers.markersLayer);
	                if (!document.getElementById(this.props.activeSite.id + "-icon").parentElement.className.includes("custom-div-icon-activated")) {
	                    document.getElementById(this.props.activeSite.id + "-icon").parentElement.className += " custom-div-icon-activated";
	                }
	            }
	
	            this.setState(function (prevState, props) {
	                return { map: map, activeSite: this.props.activeSite };
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var map = this.state.map;
	            var mapId = this.state.mapId;
	
	            return _react2.default.createElement(
	                'div',
	                { id: mapId, className: 'map' },
	                map && this.props.children
	            );
	        }
	    }]);
	
	    return LeafletMap;
	}(_react.Component);
	
	LeafletMap.propTypes = {
	    zoom: _react.PropTypes.number,
	    sites: _react.PropTypes.object,
	    activeSite: _react.PropTypes.object,
	    focusOnSite: _react.PropTypes.bool
	};
	
	exports.default = LeafletMap;

/***/ },
/* 215 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(14);
	
	var ReactNoopUpdateQueue = __webpack_require__(219);
	
	var canDefineProperty = __webpack_require__(220);
	var emptyObject = __webpack_require__(99);
	var invariant = __webpack_require__(10);
	var lowPriorityWarning = __webpack_require__(484);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(31);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 218 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 221 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 222 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 223 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 224 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(230), __esModule: true };

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(232), __esModule: true };

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(236), __esModule: true };

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(145);
	__webpack_require__(260);
	module.exports = __webpack_require__(22).Array.from;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(262);
	module.exports = __webpack_require__(22).Object.assign;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(263);
	var $Object = __webpack_require__(22).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(267);
	module.exports = __webpack_require__(22).Object.entries;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(264);
	module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(268);
	module.exports = __webpack_require__(22).Object.values;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	__webpack_require__(265);
	__webpack_require__(269);
	__webpack_require__(270);
	module.exports = __webpack_require__(22).Symbol;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(145);
	__webpack_require__(271);
	module.exports = __webpack_require__(97).f('iterator');


/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 239 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(38);
	var toLength = __webpack_require__(144);
	var toAbsoluteIndex = __webpack_require__(258);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(85);
	var TAG = __webpack_require__(25)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(37);
	var createDesc = __webpack_require__(57);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(55);
	var gOPS = __webpack_require__(90);
	var pIE = __webpack_require__(56);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(34).document;
	module.exports = document && document.documentElement;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(54);
	var ITERATOR = __webpack_require__(25)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(85);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(41);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(89);
	var descriptor = __webpack_require__(57);
	var setToStringTag = __webpack_require__(91);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(42)(IteratorPrototype, __webpack_require__(25)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(25)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(67)('meta');
	var isObject = __webpack_require__(43);
	var has = __webpack_require__(36);
	var setDesc = __webpack_require__(37).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(53)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(32);
	var getKeys = __webpack_require__(55);
	var gOPS = __webpack_require__(90);
	var pIE = __webpack_require__(56);
	var toObject = __webpack_require__(66);
	var IObject = __webpack_require__(137);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(53)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(37);
	var anObject = __webpack_require__(41);
	var getKeys = __webpack_require__(55);
	
	module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(38);
	var gOPN = __webpack_require__(140).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(36);
	var toObject = __webpack_require__(66);
	var IE_PROTO = __webpack_require__(92)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(43);
	var anObject = __webpack_require__(41);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(86)(Function.call, __webpack_require__(139).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(94);
	var defined = __webpack_require__(87);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(94);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(241);
	var ITERATOR = __webpack_require__(25)('iterator');
	var Iterators = __webpack_require__(54);
	module.exports = __webpack_require__(22).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(86);
	var $export = __webpack_require__(33);
	var toObject = __webpack_require__(66);
	var call = __webpack_require__(247);
	var isArrayIter = __webpack_require__(245);
	var toLength = __webpack_require__(144);
	var createProperty = __webpack_require__(242);
	var getIterFn = __webpack_require__(259);
	
	$export($export.S + $export.F * !__webpack_require__(249)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(239);
	var step = __webpack_require__(250);
	var Iterators = __webpack_require__(54);
	var toIObject = __webpack_require__(38);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(138)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(33);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(252) });


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(33);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(89) });


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(33);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(256).set });


/***/ },
/* 265 */
/***/ function(module, exports) {



/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(34);
	var has = __webpack_require__(36);
	var DESCRIPTORS = __webpack_require__(32);
	var $export = __webpack_require__(33);
	var redefine = __webpack_require__(143);
	var META = __webpack_require__(251).KEY;
	var $fails = __webpack_require__(53);
	var shared = __webpack_require__(93);
	var setToStringTag = __webpack_require__(91);
	var uid = __webpack_require__(67);
	var wks = __webpack_require__(25);
	var wksExt = __webpack_require__(97);
	var wksDefine = __webpack_require__(96);
	var enumKeys = __webpack_require__(243);
	var isArray = __webpack_require__(246);
	var anObject = __webpack_require__(41);
	var isObject = __webpack_require__(43);
	var toObject = __webpack_require__(66);
	var toIObject = __webpack_require__(38);
	var toPrimitive = __webpack_require__(95);
	var createDesc = __webpack_require__(57);
	var _create = __webpack_require__(89);
	var gOPNExt = __webpack_require__(254);
	var $GOPD = __webpack_require__(139);
	var $GOPS = __webpack_require__(90);
	var $DP = __webpack_require__(37);
	var $keys = __webpack_require__(55);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(140).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(56).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(65)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(42)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(33);
	var $entries = __webpack_require__(142)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(33);
	var $values = __webpack_require__(142)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('asyncIterator');


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(96)('observable');


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(261);
	var global = __webpack_require__(34);
	var hide = __webpack_require__(42);
	var Iterators = __webpack_require__(54);
	var TO_STRING_TAG = __webpack_require__(25)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(147));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(273));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(275));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(147));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(45));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(281));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(68));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(98));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(276));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(278));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(35));
	
	var _on = _interopRequireDefault(__webpack_require__(68));
	
	var _off = _interopRequireDefault(__webpack_require__(98));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(44));
	
	var _style = _interopRequireDefault(__webpack_require__(70));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(223));
	
	var _offset = _interopRequireDefault(__webpack_require__(148));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(279));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(149));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(282));
	
	var _style = _interopRequireDefault(__webpack_require__(70));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 281 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(69));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(151));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 284 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 285 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 286 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 287 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(287));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/* esri-leaflet - v2.5.3 - Wed Jan 06 2021 13:19:09 GMT-0600 (Central Standard Time)
	 * Copyright (c) 2021 Environmental Systems Research Institute, Inc.
	 * Apache-2.0 */
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(157)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'leaflet'], factory) :
	  (global = global || self, factory((global.L = global.L || {}, global.L.esri = {}), global.L));
	}(this, (function (exports, leaflet) { 'use strict';
	
	  var version = "2.5.3";
	
	  var cors = ((window.XMLHttpRequest && 'withCredentials' in new window.XMLHttpRequest()));
	  var pointerEvents = document.documentElement.style.pointerEvents === '';
	
	  var Support = {
	    cors: cors,
	    pointerEvents: pointerEvents
	  };
	
	  var options = {
	    attributionWidthOffset: 55
	  };
	
	  var callbacks = 0;
	
	  function serialize (params) {
	    var data = '';
	
	    params.f = params.f || 'json';
	
	    for (var key in params) {
	      if (params.hasOwnProperty(key)) {
	        var param = params[key];
	        var type = Object.prototype.toString.call(param);
	        var value;
	
	        if (data.length) {
	          data += '&';
	        }
	
	        if (type === '[object Array]') {
	          value = (Object.prototype.toString.call(param[0]) === '[object Object]') ? JSON.stringify(param) : param.join(',');
	        } else if (type === '[object Object]') {
	          value = JSON.stringify(param);
	        } else if (type === '[object Date]') {
	          value = param.valueOf();
	        } else {
	          value = param;
	        }
	
	        data += encodeURIComponent(key) + '=' + encodeURIComponent(value);
	      }
	    }
	
	    return data;
	  }
	
	  function createRequest (callback, context) {
	    var httpRequest = new window.XMLHttpRequest();
	
	    httpRequest.onerror = function (e) {
	      httpRequest.onreadystatechange = leaflet.Util.falseFn;
	
	      callback.call(context, {
	        error: {
	          code: 500,
	          message: 'XMLHttpRequest error'
	        }
	      }, null);
	    };
	
	    httpRequest.onreadystatechange = function () {
	      var response;
	      var error;
	
	      if (httpRequest.readyState === 4) {
	        try {
	          response = JSON.parse(httpRequest.responseText);
	        } catch (e) {
	          response = null;
	          error = {
	            code: 500,
	            message: 'Could not parse response as JSON. This could also be caused by a CORS or XMLHttpRequest error.'
	          };
	        }
	
	        if (!error && response.error) {
	          error = response.error;
	          response = null;
	        }
	
	        httpRequest.onerror = leaflet.Util.falseFn;
	
	        callback.call(context, error, response);
	      }
	    };
	
	    httpRequest.ontimeout = function () {
	      this.onerror();
	    };
	
	    return httpRequest;
	  }
	
	  function xmlHttpPost (url, params, callback, context) {
	    var httpRequest = createRequest(callback, context);
	    httpRequest.open('POST', url);
	
	    if (typeof context !== 'undefined' && context !== null) {
	      if (typeof context.options !== 'undefined') {
	        httpRequest.timeout = context.options.timeout;
	      }
	    }
	    httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
	    httpRequest.send(serialize(params));
	
	    return httpRequest;
	  }
	
	  function xmlHttpGet (url, params, callback, context) {
	    var httpRequest = createRequest(callback, context);
	    httpRequest.open('GET', url + '?' + serialize(params), true);
	
	    if (typeof context !== 'undefined' && context !== null) {
	      if (typeof context.options !== 'undefined') {
	        httpRequest.timeout = context.options.timeout;
	        if (context.options.withCredentials) {
	          httpRequest.withCredentials = true;
	        }
	      }
	    }
	    httpRequest.send(null);
	
	    return httpRequest;
	  }
	
	  // AJAX handlers for CORS (modern browsers) or JSONP (older browsers)
	  function request (url, params, callback, context) {
	    var paramString = serialize(params);
	    var httpRequest = createRequest(callback, context);
	    var requestLength = (url + '?' + paramString).length;
	
	    // ie10/11 require the request be opened before a timeout is applied
	    if (requestLength <= 2000 && Support.cors) {
	      httpRequest.open('GET', url + '?' + paramString);
	    } else if (requestLength > 2000 && Support.cors) {
	      httpRequest.open('POST', url);
	      httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
	    }
	
	    if (typeof context !== 'undefined' && context !== null) {
	      if (typeof context.options !== 'undefined') {
	        httpRequest.timeout = context.options.timeout;
	        if (context.options.withCredentials) {
	          httpRequest.withCredentials = true;
	        }
	      }
	    }
	
	    // request is less than 2000 characters and the browser supports CORS, make GET request with XMLHttpRequest
	    if (requestLength <= 2000 && Support.cors) {
	      httpRequest.send(null);
	
	    // request is more than 2000 characters and the browser supports CORS, make POST request with XMLHttpRequest
	    } else if (requestLength > 2000 && Support.cors) {
	      httpRequest.send(paramString);
	
	    // request is less  than 2000 characters and the browser does not support CORS, make a JSONP request
	    } else if (requestLength <= 2000 && !Support.cors) {
	      return jsonp(url, params, callback, context);
	
	    // request is longer then 2000 characters and the browser does not support CORS, log a warning
	    } else {
	      warn('a request to ' + url + ' was longer then 2000 characters and this browser cannot make a cross-domain post request. Please use a proxy http://esri.github.io/esri-leaflet/api-reference/request.html');
	      return;
	    }
	
	    return httpRequest;
	  }
	
	  function jsonp (url, params, callback, context) {
	    window._EsriLeafletCallbacks = window._EsriLeafletCallbacks || {};
	    var callbackId = 'c' + callbacks;
	    params.callback = 'window._EsriLeafletCallbacks.' + callbackId;
	
	    window._EsriLeafletCallbacks[callbackId] = function (response) {
	      if (window._EsriLeafletCallbacks[callbackId] !== true) {
	        var error;
	        var responseType = Object.prototype.toString.call(response);
	
	        if (!(responseType === '[object Object]' || responseType === '[object Array]')) {
	          error = {
	            error: {
	              code: 500,
	              message: 'Expected array or object as JSONP response'
	            }
	          };
	          response = null;
	        }
	
	        if (!error && response.error) {
	          error = response;
	          response = null;
	        }
	
	        callback.call(context, error, response);
	        window._EsriLeafletCallbacks[callbackId] = true;
	      }
	    };
	
	    var script = leaflet.DomUtil.create('script', null, document.body);
	    script.type = 'text/javascript';
	    script.src = url + '?' + serialize(params);
	    script.id = callbackId;
	    script.onerror = function (error) {
	      if (error && window._EsriLeafletCallbacks[callbackId] !== true) {
	        // Can't get true error code: it can be 404, or 401, or 500
	        var err = {
	          error: {
	            code: 500,
	            message: 'An unknown error occurred'
	          }
	        };
	
	        callback.call(context, err);
	        window._EsriLeafletCallbacks[callbackId] = true;
	      }
	    };
	    leaflet.DomUtil.addClass(script, 'esri-leaflet-jsonp');
	
	    callbacks++;
	
	    return {
	      id: callbackId,
	      url: script.src,
	      abort: function () {
	        window._EsriLeafletCallbacks._callback[callbackId]({
	          code: 0,
	          message: 'Request aborted.'
	        });
	      }
	    };
	  }
	
	  var get = ((Support.cors) ? xmlHttpGet : jsonp);
	  get.CORS = xmlHttpGet;
	  get.JSONP = jsonp;
	
	  function warn () {
	    if (console && console.warn) {
	      console.warn.apply(console, arguments);
	    }
	  }
	
	  // export the Request object to call the different handlers for debugging
	  var Request = {
	    request: request,
	    get: get,
	    post: xmlHttpPost
	  };
	
	  /* @preserve
	  * @terraformer/arcgis - v2.0.6 - MIT
	  * Copyright (c) 2012-2020 Environmental Systems Research Institute, Inc.
	  * Mon May 18 2020 14:30:35 GMT-0700 (Pacific Daylight Time)
	  */
	  /* Copyright (c) 2012-2019 Environmental Systems Research Institute, Inc.
	   * Apache-2.0 */
	
	  var edgeIntersectsEdge = function edgeIntersectsEdge(a1, a2, b1, b2) {
	    var uaT = (b2[0] - b1[0]) * (a1[1] - b1[1]) - (b2[1] - b1[1]) * (a1[0] - b1[0]);
	    var ubT = (a2[0] - a1[0]) * (a1[1] - b1[1]) - (a2[1] - a1[1]) * (a1[0] - b1[0]);
	    var uB = (b2[1] - b1[1]) * (a2[0] - a1[0]) - (b2[0] - b1[0]) * (a2[1] - a1[1]);
	
	    if (uB !== 0) {
	      var ua = uaT / uB;
	      var ub = ubT / uB;
	
	      if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
	        return true;
	      }
	    }
	
	    return false;
	  };
	  var coordinatesContainPoint = function coordinatesContainPoint(coordinates, point) {
	    var contains = false;
	
	    for (var i = -1, l = coordinates.length, j = l - 1; ++i < l; j = i) {
	      if ((coordinates[i][1] <= point[1] && point[1] < coordinates[j][1] || coordinates[j][1] <= point[1] && point[1] < coordinates[i][1]) && point[0] < (coordinates[j][0] - coordinates[i][0]) * (point[1] - coordinates[i][1]) / (coordinates[j][1] - coordinates[i][1]) + coordinates[i][0]) {
	        contains = !contains;
	      }
	    }
	
	    return contains;
	  };
	  var pointsEqual = function pointsEqual(a, b) {
	    for (var i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	  var arrayIntersectsArray = function arrayIntersectsArray(a, b) {
	    for (var i = 0; i < a.length - 1; i++) {
	      for (var j = 0; j < b.length - 1; j++) {
	        if (edgeIntersectsEdge(a[i], a[i + 1], b[j], b[j + 1])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  };
	
	  /* Copyright (c) 2012-2019 Environmental Systems Research Institute, Inc.
	   * Apache-2.0 */
	
	  var closeRing = function closeRing(coordinates) {
	    if (!pointsEqual(coordinates[0], coordinates[coordinates.length - 1])) {
	      coordinates.push(coordinates[0]);
	    }
	
	    return coordinates;
	  }; // determine if polygon ring coordinates are clockwise. clockwise signifies outer ring, counter-clockwise an inner ring
	  // or hole. this logic was found at http://stackoverflow.com/questions/1165647/how-to-determine-if-a-list-of-polygon-
	  // points-are-in-clockwise-order
	
	  var ringIsClockwise = function ringIsClockwise(ringToTest) {
	    var total = 0;
	    var i = 0;
	    var rLength = ringToTest.length;
	    var pt1 = ringToTest[i];
	    var pt2;
	
	    for (i; i < rLength - 1; i++) {
	      pt2 = ringToTest[i + 1];
	      total += (pt2[0] - pt1[0]) * (pt2[1] + pt1[1]);
	      pt1 = pt2;
	    }
	
	    return total >= 0;
	  }; // This function ensures that rings are oriented in the right directions
	  // from http://jsperf.com/cloning-an-object/2
	
	  var shallowClone = function shallowClone(obj) {
	    var target = {};
	
	    for (var i in obj) {
	      // both arcgis attributes and geojson props are just hardcoded keys
	      if (obj.hasOwnProperty(i)) {
	        // eslint-disable-line no-prototype-builtins
	        target[i] = obj[i];
	      }
	    }
	
	    return target;
	  };
	
	  /* Copyright (c) 2012-2019 Environmental Systems Research Institute, Inc.
	   * Apache-2.0 */
	
	  var coordinatesContainCoordinates = function coordinatesContainCoordinates(outer, inner) {
	    var intersects = arrayIntersectsArray(outer, inner);
	    var contains = coordinatesContainPoint(outer, inner[0]);
	
	    if (!intersects && contains) {
	      return true;
	    }
	
	    return false;
	  }; // do any polygons in this array contain any other polygons in this array?
	  // used for checking for holes in arcgis rings
	
	
	  var convertRingsToGeoJSON = function convertRingsToGeoJSON(rings) {
	    var outerRings = [];
	    var holes = [];
	    var x; // iterator
	
	    var outerRing; // current outer ring being evaluated
	
	    var hole; // current hole being evaluated
	    // for each ring
	
	    for (var r = 0; r < rings.length; r++) {
	      var ring = closeRing(rings[r].slice(0));
	
	      if (ring.length < 4) {
	        continue;
	      } // is this ring an outer ring? is it clockwise?
	
	
	      if (ringIsClockwise(ring)) {
	        var polygon = [ring.slice().reverse()]; // wind outer rings counterclockwise for RFC 7946 compliance
	
	        outerRings.push(polygon); // push to outer rings
	      } else {
	        holes.push(ring.slice().reverse()); // wind inner rings clockwise for RFC 7946 compliance
	      }
	    }
	
	    var uncontainedHoles = []; // while there are holes left...
	
	    while (holes.length) {
	      // pop a hole off out stack
	      hole = holes.pop(); // loop over all outer rings and see if they contain our hole.
	
	      var contained = false;
	
	      for (x = outerRings.length - 1; x >= 0; x--) {
	        outerRing = outerRings[x][0];
	
	        if (coordinatesContainCoordinates(outerRing, hole)) {
	          // the hole is contained push it into our polygon
	          outerRings[x].push(hole);
	          contained = true;
	          break;
	        }
	      } // ring is not contained in any outer ring
	      // sometimes this happens https://github.com/Esri/esri-leaflet/issues/320
	
	
	      if (!contained) {
	        uncontainedHoles.push(hole);
	      }
	    } // if we couldn't match any holes using contains we can try intersects...
	
	
	    while (uncontainedHoles.length) {
	      // pop a hole off out stack
	      hole = uncontainedHoles.pop(); // loop over all outer rings and see if any intersect our hole.
	
	      var intersects = false;
	
	      for (x = outerRings.length - 1; x >= 0; x--) {
	        outerRing = outerRings[x][0];
	
	        if (arrayIntersectsArray(outerRing, hole)) {
	          // the hole is contained push it into our polygon
	          outerRings[x].push(hole);
	          intersects = true;
	          break;
	        }
	      }
	
	      if (!intersects) {
	        outerRings.push([hole.reverse()]);
	      }
	    }
	
	    if (outerRings.length === 1) {
	      return {
	        type: 'Polygon',
	        coordinates: outerRings[0]
	      };
	    } else {
	      return {
	        type: 'MultiPolygon',
	        coordinates: outerRings
	      };
	    }
	  };
	
	  var getId = function getId(attributes, idAttribute) {
	    var keys = idAttribute ? [idAttribute, 'OBJECTID', 'FID'] : ['OBJECTID', 'FID'];
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	
	      if (key in attributes && (typeof attributes[key] === 'string' || typeof attributes[key] === 'number')) {
	        return attributes[key];
	      }
	    }
	
	    throw Error('No valid id attribute found');
	  };
	
	  var arcgisToGeoJSON = function arcgisToGeoJSON(arcgis, idAttribute) {
	    var geojson = {};
	
	    if (arcgis.features) {
	      geojson.type = 'FeatureCollection';
	      geojson.features = [];
	
	      for (var i = 0; i < arcgis.features.length; i++) {
	        geojson.features.push(arcgisToGeoJSON(arcgis.features[i], idAttribute));
	      }
	    }
	
	    if (typeof arcgis.x === 'number' && typeof arcgis.y === 'number') {
	      geojson.type = 'Point';
	      geojson.coordinates = [arcgis.x, arcgis.y];
	
	      if (typeof arcgis.z === 'number') {
	        geojson.coordinates.push(arcgis.z);
	      }
	    }
	
	    if (arcgis.points) {
	      geojson.type = 'MultiPoint';
	      geojson.coordinates = arcgis.points.slice(0);
	    }
	
	    if (arcgis.paths) {
	      if (arcgis.paths.length === 1) {
	        geojson.type = 'LineString';
	        geojson.coordinates = arcgis.paths[0].slice(0);
	      } else {
	        geojson.type = 'MultiLineString';
	        geojson.coordinates = arcgis.paths.slice(0);
	      }
	    }
	
	    if (arcgis.rings) {
	      geojson = convertRingsToGeoJSON(arcgis.rings.slice(0));
	    }
	
	    if (typeof arcgis.xmin === 'number' && typeof arcgis.ymin === 'number' && typeof arcgis.xmax === 'number' && typeof arcgis.ymax === 'number') {
	      geojson.type = 'Polygon';
	      geojson.coordinates = [[[arcgis.xmax, arcgis.ymax], [arcgis.xmin, arcgis.ymax], [arcgis.xmin, arcgis.ymin], [arcgis.xmax, arcgis.ymin], [arcgis.xmax, arcgis.ymax]]];
	    }
	
	    if (arcgis.geometry || arcgis.attributes) {
	      geojson.type = 'Feature';
	      geojson.geometry = arcgis.geometry ? arcgisToGeoJSON(arcgis.geometry) : null;
	      geojson.properties = arcgis.attributes ? shallowClone(arcgis.attributes) : null;
	
	      if (arcgis.attributes) {
	        try {
	          geojson.id = getId(arcgis.attributes, idAttribute);
	        } catch (err) {// don't set an id
	        }
	      }
	    } // if no valid geometry was encountered
	
	
	    if (JSON.stringify(geojson.geometry) === JSON.stringify({})) {
	      geojson.geometry = null;
	    }
	
	    if (arcgis.spatialReference && arcgis.spatialReference.wkid && arcgis.spatialReference.wkid !== 4326) {
	      console.warn('Object converted in non-standard crs - ' + JSON.stringify(arcgis.spatialReference));
	    }
	
	    return geojson;
	  };
	
	  /* Copyright (c) 2012-2019 Environmental Systems Research Institute, Inc.
	   * Apache-2.0 */
	  // outer rings are clockwise, holes are counterclockwise
	  // used for converting GeoJSON Polygons to ArcGIS Polygons
	
	  var orientRings = function orientRings(poly) {
	    var output = [];
	    var polygon = poly.slice(0);
	    var outerRing = closeRing(polygon.shift().slice(0));
	
	    if (outerRing.length >= 4) {
	      if (!ringIsClockwise(outerRing)) {
	        outerRing.reverse();
	      }
	
	      output.push(outerRing);
	
	      for (var i = 0; i < polygon.length; i++) {
	        var hole = closeRing(polygon[i].slice(0));
	
	        if (hole.length >= 4) {
	          if (ringIsClockwise(hole)) {
	            hole.reverse();
	          }
	
	          output.push(hole);
	        }
	      }
	    }
	
	    return output;
	  }; // This function flattens holes in multipolygons to one array of polygons
	  // used for converting GeoJSON Polygons to ArcGIS Polygons
	
	
	  var flattenMultiPolygonRings = function flattenMultiPolygonRings(rings) {
	    var output = [];
	
	    for (var i = 0; i < rings.length; i++) {
	      var polygon = orientRings(rings[i]);
	
	      for (var x = polygon.length - 1; x >= 0; x--) {
	        var ring = polygon[x].slice(0);
	        output.push(ring);
	      }
	    }
	
	    return output;
	  };
	
	  var geojsonToArcGIS = function geojsonToArcGIS(geojson, idAttribute) {
	    idAttribute = idAttribute || 'OBJECTID';
	    var spatialReference = {
	      wkid: 4326
	    };
	    var result = {};
	    var i;
	
	    switch (geojson.type) {
	      case 'Point':
	        result.x = geojson.coordinates[0];
	        result.y = geojson.coordinates[1];
	        result.spatialReference = spatialReference;
	        break;
	
	      case 'MultiPoint':
	        result.points = geojson.coordinates.slice(0);
	        result.spatialReference = spatialReference;
	        break;
	
	      case 'LineString':
	        result.paths = [geojson.coordinates.slice(0)];
	        result.spatialReference = spatialReference;
	        break;
	
	      case 'MultiLineString':
	        result.paths = geojson.coordinates.slice(0);
	        result.spatialReference = spatialReference;
	        break;
	
	      case 'Polygon':
	        result.rings = orientRings(geojson.coordinates.slice(0));
	        result.spatialReference = spatialReference;
	        break;
	
	      case 'MultiPolygon':
	        result.rings = flattenMultiPolygonRings(geojson.coordinates.slice(0));
	        result.spatialReference = spatialReference;
	        break;
	
	      case 'Feature':
	        if (geojson.geometry) {
	          result.geometry = geojsonToArcGIS(geojson.geometry, idAttribute);
	        }
	
	        result.attributes = geojson.properties ? shallowClone(geojson.properties) : {};
	
	        if (geojson.id) {
	          result.attributes[idAttribute] = geojson.id;
	        }
	
	        break;
	
	      case 'FeatureCollection':
	        result = [];
	
	        for (i = 0; i < geojson.features.length; i++) {
	          result.push(geojsonToArcGIS(geojson.features[i], idAttribute));
	        }
	
	        break;
	
	      case 'GeometryCollection':
	        result = [];
	
	        for (i = 0; i < geojson.geometries.length; i++) {
	          result.push(geojsonToArcGIS(geojson.geometries[i], idAttribute));
	        }
	
	        break;
	    }
	
	    return result;
	  };
	
	  var BASE_LEAFLET_ATTRIBUTION_STRING = '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>';
	  var POWERED_BY_ESRI_ATTRIBUTION_STRING = 'Powered by <a href="https://www.esri.com">Esri</a>';
	
	  function geojsonToArcGIS$1 (geojson, idAttr) {
	    return geojsonToArcGIS(geojson, idAttr);
	  }
	
	  function arcgisToGeoJSON$1 (arcgis, idAttr) {
	    return arcgisToGeoJSON(arcgis, idAttr);
	  }
	
	  // convert an extent (ArcGIS) to LatLngBounds (Leaflet)
	  function extentToBounds (extent) {
	    // "NaN" coordinates from ArcGIS Server indicate a null geometry
	    if (extent.xmin !== 'NaN' && extent.ymin !== 'NaN' && extent.xmax !== 'NaN' && extent.ymax !== 'NaN') {
	      var sw = leaflet.latLng(extent.ymin, extent.xmin);
	      var ne = leaflet.latLng(extent.ymax, extent.xmax);
	      return leaflet.latLngBounds(sw, ne);
	    } else {
	      return null;
	    }
	  }
	
	  // convert an LatLngBounds (Leaflet) to extent (ArcGIS)
	  function boundsToExtent (bounds) {
	    bounds = leaflet.latLngBounds(bounds);
	    return {
	      'xmin': bounds.getSouthWest().lng,
	      'ymin': bounds.getSouthWest().lat,
	      'xmax': bounds.getNorthEast().lng,
	      'ymax': bounds.getNorthEast().lat,
	      'spatialReference': {
	        'wkid': 4326
	      }
	    };
	  }
	
	  var knownFieldNames = /^(OBJECTID|FID|OID|ID)$/i;
	
	  // Attempts to find the ID Field from response
	  function _findIdAttributeFromResponse (response) {
	    var result;
	
	    if (response.objectIdFieldName) {
	      // Find Id Field directly
	      result = response.objectIdFieldName;
	    } else if (response.fields) {
	      // Find ID Field based on field type
	      for (var j = 0; j <= response.fields.length - 1; j++) {
	        if (response.fields[j].type === 'esriFieldTypeOID') {
	          result = response.fields[j].name;
	          break;
	        }
	      }
	      if (!result) {
	        // If no field was marked as being the esriFieldTypeOID try well known field names
	        for (j = 0; j <= response.fields.length - 1; j++) {
	          if (response.fields[j].name.match(knownFieldNames)) {
	            result = response.fields[j].name;
	            break;
	          }
	        }
	      }
	    }
	    return result;
	  }
	
	  // This is the 'last' resort, find the Id field from the specified feature
	  function _findIdAttributeFromFeature (feature) {
	    for (var key in feature.attributes) {
	      if (key.match(knownFieldNames)) {
	        return key;
	      }
	    }
	  }
	
	  function responseToFeatureCollection (response, idAttribute) {
	    var objectIdField;
	    var features = response.features || response.results;
	    var count = features && features.length;
	
	    if (idAttribute) {
	      objectIdField = idAttribute;
	    } else {
	      objectIdField = _findIdAttributeFromResponse(response);
	    }
	
	    var featureCollection = {
	      type: 'FeatureCollection',
	      features: []
	    };
	
	    if (count) {
	      for (var i = features.length - 1; i >= 0; i--) {
	        var feature = arcgisToGeoJSON$1(features[i], objectIdField || _findIdAttributeFromFeature(features[i]));
	        featureCollection.features.push(feature);
	      }
	    }
	
	    return featureCollection;
	  }
	
	    // trim url whitespace and add a trailing slash if needed
	  function cleanUrl (url) {
	    // trim leading and trailing spaces, but not spaces inside the url
	    url = leaflet.Util.trim(url);
	
	    // add a trailing slash to the url if the user omitted it
	    if (url[url.length - 1] !== '/') {
	      url += '/';
	    }
	
	    return url;
	  }
	
	  /* Extract url params if any and store them in requestParams attribute.
	     Return the options params updated */
	  function getUrlParams (options) {
	    if (options.url.indexOf('?') !== -1) {
	      options.requestParams = options.requestParams || {};
	      var queryString = options.url.substring(options.url.indexOf('?') + 1);
	      options.url = options.url.split('?')[0];
	      options.requestParams = JSON.parse('{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
	    }
	    options.url = cleanUrl(options.url.split('?')[0]);
	    return options;
	  }
	
	  function isArcgisOnline (url) {
	    /* hosted feature services support geojson as an output format
	    utility.arcgis.com services are proxied from a variety of ArcGIS Server vintages, and may not */
	    return (/^(?!.*utility\.arcgis\.com).*\.arcgis\.com.*FeatureServer/i).test(url);
	  }
	
	  function geojsonTypeToArcGIS (geoJsonType) {
	    var arcgisGeometryType;
	    switch (geoJsonType) {
	      case 'Point':
	        arcgisGeometryType = 'esriGeometryPoint';
	        break;
	      case 'MultiPoint':
	        arcgisGeometryType = 'esriGeometryMultipoint';
	        break;
	      case 'LineString':
	        arcgisGeometryType = 'esriGeometryPolyline';
	        break;
	      case 'MultiLineString':
	        arcgisGeometryType = 'esriGeometryPolyline';
	        break;
	      case 'Polygon':
	        arcgisGeometryType = 'esriGeometryPolygon';
	        break;
	      case 'MultiPolygon':
	        arcgisGeometryType = 'esriGeometryPolygon';
	        break;
	    }
	
	    return arcgisGeometryType;
	  }
	
	  function calcAttributionWidth (map) {
	    // either crop at 55px or user defined buffer
	    return (map.getSize().x - options.attributionWidthOffset) + 'px';
	  }
	
	  function setEsriAttribution (map) {
	    if (!map.attributionControl) {
	      return;
	    }
	
	    if (!map.attributionControl._esriAttributionLayerCount) {
	      map.attributionControl._esriAttributionLayerCount = 0;
	    }
	
	    if (map.attributionControl._esriAttributionLayerCount === 0) {
	      // Dynamically creating the CSS rules, only run this once per page load:
	      if (!map.attributionControl._esriAttributionAddedOnce) {
	        var hoverAttributionStyle = document.createElement('style');
	        hoverAttributionStyle.type = 'text/css';
	        hoverAttributionStyle.innerHTML = '.esri-truncated-attribution:hover {' +
	          'white-space: normal;' +
	        '}';
	        document.getElementsByTagName('head')[0].appendChild(hoverAttributionStyle);
	
	        // define a new css class in JS to trim attribution into a single line
	        var attributionStyle = document.createElement('style');
	        attributionStyle.type = 'text/css';
	        attributionStyle.innerHTML = '.esri-truncated-attribution {' +
	          'vertical-align: -3px;' +
	          'white-space: nowrap;' +
	          'overflow: hidden;' +
	          'text-overflow: ellipsis;' +
	          'display: inline-block;' +
	          'transition: 0s white-space;' +
	          'transition-delay: 1s;' +
	          'max-width: ' + calcAttributionWidth(map) + ';' +
	        '}';
	        document.getElementsByTagName('head')[0].appendChild(attributionStyle);
	
	        // update the width used to truncate when the map itself is resized
	        map.on('resize', function (e) {
	          if (map.attributionControl) {
	            map.attributionControl._container.style.maxWidth = calcAttributionWidth(e.target);
	          }
	        });
	
	        map.attributionControl._esriAttributionAddedOnce = true;
	      }
	
	      map.attributionControl.setPrefix(BASE_LEAFLET_ATTRIBUTION_STRING + ' | ' + POWERED_BY_ESRI_ATTRIBUTION_STRING);
	      leaflet.DomUtil.addClass(map.attributionControl._container, 'esri-truncated-attribution:hover');
	      leaflet.DomUtil.addClass(map.attributionControl._container, 'esri-truncated-attribution');
	    }
	
	    // Track the number of esri-leaflet layers that are on the map so we can know when we can remove the attribution (below in removeEsriAttribution)
	    map.attributionControl._esriAttributionLayerCount = map.attributionControl._esriAttributionLayerCount + 1;
	  }
	
	  function removeEsriAttribution (map) {
	    if (!map.attributionControl) {
	      return;
	    }
	
	    // Only remove the attribution if we're about to remove the LAST esri-leaflet layer (_esriAttributionLayerCount)
	    if (map.attributionControl._esriAttributionLayerCount && map.attributionControl._esriAttributionLayerCount === 1) {
	      map.attributionControl.setPrefix(BASE_LEAFLET_ATTRIBUTION_STRING);
	      leaflet.DomUtil.removeClass(map.attributionControl._container, 'esri-truncated-attribution:hover');
	      leaflet.DomUtil.removeClass(map.attributionControl._container, 'esri-truncated-attribution');
	    }
	    map.attributionControl._esriAttributionLayerCount = map.attributionControl._esriAttributionLayerCount - 1;
	  }
	
	  function _setGeometry (geometry) {
	    var params = {
	      geometry: null,
	      geometryType: null
	    };
	
	    // convert bounds to extent and finish
	    if (geometry instanceof leaflet.LatLngBounds) {
	      // set geometry + geometryType
	      params.geometry = boundsToExtent(geometry);
	      params.geometryType = 'esriGeometryEnvelope';
	      return params;
	    }
	
	    // convert L.Marker > L.LatLng
	    if (geometry.getLatLng) {
	      geometry = geometry.getLatLng();
	    }
	
	    // convert L.LatLng to a geojson point and continue;
	    if (geometry instanceof leaflet.LatLng) {
	      geometry = {
	        type: 'Point',
	        coordinates: [geometry.lng, geometry.lat]
	      };
	    }
	
	    // handle L.GeoJSON, pull out the first geometry
	    if (geometry instanceof leaflet.GeoJSON) {
	      // reassign geometry to the GeoJSON value  (we are assuming that only one feature is present)
	      geometry = geometry.getLayers()[0].feature.geometry;
	      params.geometry = geojsonToArcGIS$1(geometry);
	      params.geometryType = geojsonTypeToArcGIS(geometry.type);
	    }
	
	    // Handle L.Polyline and L.Polygon
	    if (geometry.toGeoJSON) {
	      geometry = geometry.toGeoJSON();
	    }
	
	    // handle GeoJSON feature by pulling out the geometry
	    if (geometry.type === 'Feature') {
	      // get the geometry of the geojson feature
	      geometry = geometry.geometry;
	    }
	
	    // confirm that our GeoJSON is a point, line or polygon
	    if (geometry.type === 'Point' || geometry.type === 'LineString' || geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
	      params.geometry = geojsonToArcGIS$1(geometry);
	      params.geometryType = geojsonTypeToArcGIS(geometry.type);
	      return params;
	    }
	
	    // warn the user if we havn't found an appropriate object
	    warn('invalid geometry passed to spatial query. Should be L.LatLng, L.LatLngBounds, L.Marker or a GeoJSON Point, Line, Polygon or MultiPolygon object');
	
	    return;
	  }
	
	  function _getAttributionData (url, map) {
	    if (Support.cors) {
	      request(url, {}, leaflet.Util.bind(function (error, attributions) {
	        if (error) { return; }
	        map._esriAttributions = [];
	        for (var c = 0; c < attributions.contributors.length; c++) {
	          var contributor = attributions.contributors[c];
	
	          for (var i = 0; i < contributor.coverageAreas.length; i++) {
	            var coverageArea = contributor.coverageAreas[i];
	            var southWest = leaflet.latLng(coverageArea.bbox[0], coverageArea.bbox[1]);
	            var northEast = leaflet.latLng(coverageArea.bbox[2], coverageArea.bbox[3]);
	            map._esriAttributions.push({
	              attribution: contributor.attribution,
	              score: coverageArea.score,
	              bounds: leaflet.latLngBounds(southWest, northEast),
	              minZoom: coverageArea.zoomMin,
	              maxZoom: coverageArea.zoomMax
	            });
	          }
	        }
	
	        map._esriAttributions.sort(function (a, b) {
	          return b.score - a.score;
	        });
	
	        // pass the same argument as the map's 'moveend' event
	        var obj = { target: map };
	        _updateMapAttribution(obj);
	      }, this));
	    }
	  }
	
	  function _updateMapAttribution (evt) {
	    var map = evt.target;
	    var oldAttributions = map._esriAttributions;
	
	    if (!map || !map.attributionControl) return;
	
	    var attributionElement = map.attributionControl._container.querySelector('.esri-dynamic-attribution');
	
	    if (attributionElement && oldAttributions) {
	      var newAttributions = '';
	      var bounds = map.getBounds();
	      var wrappedBounds = leaflet.latLngBounds(
	        bounds.getSouthWest().wrap(),
	        bounds.getNorthEast().wrap()
	      );
	      var zoom = map.getZoom();
	
	      for (var i = 0; i < oldAttributions.length; i++) {
	        var attribution = oldAttributions[i];
	        var text = attribution.attribution;
	
	        if (!newAttributions.match(text) && attribution.bounds.intersects(wrappedBounds) && zoom >= attribution.minZoom && zoom <= attribution.maxZoom) {
	          newAttributions += (', ' + text);
	        }
	      }
	
	      newAttributions = newAttributions.substr(2);
	      attributionElement.innerHTML = newAttributions;
	      attributionElement.style.maxWidth = calcAttributionWidth(map);
	
	      map.fire('attributionupdated', {
	        attribution: newAttributions
	      });
	    }
	  }
	
	  var EsriUtil = {
	    warn: warn,
	    cleanUrl: cleanUrl,
	    getUrlParams: getUrlParams,
	    isArcgisOnline: isArcgisOnline,
	    geojsonTypeToArcGIS: geojsonTypeToArcGIS,
	    responseToFeatureCollection: responseToFeatureCollection,
	    geojsonToArcGIS: geojsonToArcGIS$1,
	    arcgisToGeoJSON: arcgisToGeoJSON$1,
	    boundsToExtent: boundsToExtent,
	    extentToBounds: extentToBounds,
	    calcAttributionWidth: calcAttributionWidth,
	    setEsriAttribution: setEsriAttribution,
	    _setGeometry: _setGeometry,
	    _getAttributionData: _getAttributionData,
	    _updateMapAttribution: _updateMapAttribution,
	    _findIdAttributeFromFeature: _findIdAttributeFromFeature,
	    _findIdAttributeFromResponse: _findIdAttributeFromResponse
	  };
	
	  var Task = leaflet.Class.extend({
	
	    options: {
	      proxy: false,
	      useCors: cors
	    },
	
	    // Generate a method for each methodName:paramName in the setters for this task.
	    generateSetter: function (param, context) {
	      return leaflet.Util.bind(function (value) {
	        this.params[param] = value;
	        return this;
	      }, context);
	    },
	
	    initialize: function (endpoint) {
	      // endpoint can be either a url (and options) for an ArcGIS Rest Service or an instance of EsriLeaflet.Service
	      if (endpoint.request && endpoint.options) {
	        this._service = endpoint;
	        leaflet.Util.setOptions(this, endpoint.options);
	      } else {
	        leaflet.Util.setOptions(this, endpoint);
	        this.options.url = cleanUrl(endpoint.url);
	      }
	
	      // clone default params into this object
	      this.params = leaflet.Util.extend({}, this.params || {});
	
	      // generate setter methods based on the setters object implimented a child class
	      if (this.setters) {
	        for (var setter in this.setters) {
	          var param = this.setters[setter];
	          this[setter] = this.generateSetter(param, this);
	        }
	      }
	    },
	
	    token: function (token) {
	      if (this._service) {
	        this._service.authenticate(token);
	      } else {
	        this.params.token = token;
	      }
	      return this;
	    },
	
	    // ArcGIS Server Find/Identify 10.5+
	    format: function (boolean) {
	      // use double negative to expose a more intuitive positive method name
	      this.params.returnUnformattedValues = !boolean;
	      return this;
	    },
	
	    request: function (callback, context) {
	      if (this.options.requestParams) {
	        leaflet.Util.extend(this.params, this.options.requestParams);
	      }
	      if (this._service) {
	        return this._service.request(this.path, this.params, callback, context);
	      }
	
	      return this._request('request', this.path, this.params, callback, context);
	    },
	
	    _request: function (method, path, params, callback, context) {
	      var url = (this.options.proxy) ? this.options.proxy + '?' + this.options.url + path : this.options.url + path;
	
	      if ((method === 'get' || method === 'request') && !this.options.useCors) {
	        return Request.get.JSONP(url, params, callback, context);
	      }
	
	      return Request[method](url, params, callback, context);
	    }
	  });
	
	  function task (options) {
	    options = getUrlParams(options);
	    return new Task(options);
	  }
	
	  var Query = Task.extend({
	    setters: {
	      'offset': 'resultOffset',
	      'limit': 'resultRecordCount',
	      'fields': 'outFields',
	      'precision': 'geometryPrecision',
	      'featureIds': 'objectIds',
	      'returnGeometry': 'returnGeometry',
	      'returnM': 'returnM',
	      'transform': 'datumTransformation',
	      'token': 'token'
	    },
	
	    path: 'query',
	
	    params: {
	      returnGeometry: true,
	      where: '1=1',
	      outSR: 4326,
	      outFields: '*'
	    },
	
	    // Returns a feature if its shape is wholly contained within the search geometry. Valid for all shape type combinations.
	    within: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelContains'; // to the REST api this reads geometry **contains** layer
	      return this;
	    },
	
	    // Returns a feature if any spatial relationship is found. Applies to all shape type combinations.
	    intersects: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelIntersects';
	      return this;
	    },
	
	    // Returns a feature if its shape wholly contains the search geometry. Valid for all shape type combinations.
	    contains: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelWithin'; // to the REST api this reads geometry **within** layer
	      return this;
	    },
	
	    // Returns a feature if the intersection of the interiors of the two shapes is not empty and has a lower dimension than the maximum dimension of the two shapes. Two lines that share an endpoint in common do not cross. Valid for Line/Line, Line/Area, Multi-point/Area, and Multi-point/Line shape type combinations.
	    crosses: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelCrosses';
	      return this;
	    },
	
	    // Returns a feature if the two shapes share a common boundary. However, the intersection of the interiors of the two shapes must be empty. In the Point/Line case, the point may touch an endpoint only of the line. Applies to all combinations except Point/Point.
	    touches: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelTouches';
	      return this;
	    },
	
	    // Returns a feature if the intersection of the two shapes results in an object of the same dimension, but different from both of the shapes. Applies to Area/Area, Line/Line, and Multi-point/Multi-point shape type combinations.
	    overlaps: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelOverlaps';
	      return this;
	    },
	
	    // Returns a feature if the envelope of the two shapes intersects.
	    bboxIntersects: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelEnvelopeIntersects';
	      return this;
	    },
	
	    // if someone can help decipher the ArcObjects explanation and translate to plain speak, we should mention this method in the doc
	    indexIntersects: function (geometry) {
	      this._setGeometryParams(geometry);
	      this.params.spatialRel = 'esriSpatialRelIndexIntersects'; // Returns a feature if the envelope of the query geometry intersects the index entry for the target geometry
	      return this;
	    },
	
	    // only valid for Feature Services running on ArcGIS Server 10.3+ or ArcGIS Online
	    nearby: function (latlng, radius) {
	      latlng = leaflet.latLng(latlng);
	      this.params.geometry = [latlng.lng, latlng.lat];
	      this.params.geometryType = 'esriGeometryPoint';
	      this.params.spatialRel = 'esriSpatialRelIntersects';
	      this.params.units = 'esriSRUnit_Meter';
	      this.params.distance = radius;
	      this.params.inSR = 4326;
	      return this;
	    },
	
	    where: function (string) {
	      // instead of converting double-quotes to single quotes, pass as is, and provide a more informative message if a 400 is encountered
	      this.params.where = string;
	      return this;
	    },
	
	    between: function (start, end) {
	      this.params.time = [start.valueOf(), end.valueOf()];
	      return this;
	    },
	
	    simplify: function (map, factor) {
	      var mapWidth = Math.abs(map.getBounds().getWest() - map.getBounds().getEast());
	      this.params.maxAllowableOffset = (mapWidth / map.getSize().y) * factor;
	      return this;
	    },
	
	    orderBy: function (fieldName, order) {
	      order = order || 'ASC';
	      this.params.orderByFields = (this.params.orderByFields) ? this.params.orderByFields + ',' : '';
	      this.params.orderByFields += ([fieldName, order]).join(' ');
	      return this;
	    },
	
	    run: function (callback, context) {
	      this._cleanParams();
	
	      // services hosted on ArcGIS Online and ArcGIS Server 10.3.1+ support requesting geojson directly
	      if (this.options.isModern || (isArcgisOnline(this.options.url) && this.options.isModern === undefined)) {
	        this.params.f = 'geojson';
	
	        return this.request(function (error, response) {
	          this._trapSQLerrors(error);
	          callback.call(context, error, response, response);
	        }, this);
	
	        // otherwise convert it in the callback then pass it on
	      } else {
	        return this.request(function (error, response) {
	          this._trapSQLerrors(error);
	          callback.call(context, error, (response && responseToFeatureCollection(response)), response);
	        }, this);
	      }
	    },
	
	    count: function (callback, context) {
	      this._cleanParams();
	      this.params.returnCountOnly = true;
	      return this.request(function (error, response) {
	        callback.call(this, error, (response && response.count), response);
	      }, context);
	    },
	
	    ids: function (callback, context) {
	      this._cleanParams();
	      this.params.returnIdsOnly = true;
	      return this.request(function (error, response) {
	        callback.call(this, error, (response && response.objectIds), response);
	      }, context);
	    },
	
	    // only valid for Feature Services running on ArcGIS Server 10.3+ or ArcGIS Online
	    bounds: function (callback, context) {
	      this._cleanParams();
	      this.params.returnExtentOnly = true;
	      return this.request(function (error, response) {
	        if (response && response.extent && extentToBounds(response.extent)) {
	          callback.call(context, error, extentToBounds(response.extent), response);
	        } else {
	          error = {
	            message: 'Invalid Bounds'
	          };
	          callback.call(context, error, null, response);
	        }
	      }, context);
	    },
	
	    distinct: function () {
	      // geometry must be omitted for queries requesting distinct values
	      this.params.returnGeometry = false;
	      this.params.returnDistinctValues = true;
	      return this;
	    },
	
	    // only valid for image services
	    pixelSize: function (rawPoint) {
	      var castPoint = leaflet.point(rawPoint);
	      this.params.pixelSize = [castPoint.x, castPoint.y];
	      return this;
	    },
	
	    // only valid for map services
	    layer: function (layer) {
	      this.path = layer + '/query';
	      return this;
	    },
	
	    _trapSQLerrors: function (error) {
	      if (error) {
	        if (error.code === '400') {
	          warn('one common syntax error in query requests is encasing string values in double quotes instead of single quotes');
	        }
	      }
	    },
	
	    _cleanParams: function () {
	      delete this.params.returnIdsOnly;
	      delete this.params.returnExtentOnly;
	      delete this.params.returnCountOnly;
	    },
	
	    _setGeometryParams: function (geometry) {
	      this.params.inSR = 4326;
	      var converted = _setGeometry(geometry);
	      this.params.geometry = converted.geometry;
	      this.params.geometryType = converted.geometryType;
	    }
	
	  });
	
	  function query (options) {
	    return new Query(options);
	  }
	
	  var Find = Task.extend({
	    setters: {
	      // method name > param name
	      'contains': 'contains',
	      'text': 'searchText',
	      'fields': 'searchFields', // denote an array or single string
	      'spatialReference': 'sr',
	      'sr': 'sr',
	      'layers': 'layers',
	      'returnGeometry': 'returnGeometry',
	      'maxAllowableOffset': 'maxAllowableOffset',
	      'precision': 'geometryPrecision',
	      'dynamicLayers': 'dynamicLayers',
	      'returnZ': 'returnZ',
	      'returnM': 'returnM',
	      'gdbVersion': 'gdbVersion',
	      // skipped implementing this (for now) because the REST service implementation isnt consistent between operations
	      // 'transform': 'datumTransformations',
	      'token': 'token'
	    },
	
	    path: 'find',
	
	    params: {
	      sr: 4326,
	      contains: true,
	      returnGeometry: true,
	      returnZ: true,
	      returnM: false
	    },
	
	    layerDefs: function (id, where) {
	      this.params.layerDefs = (this.params.layerDefs) ? this.params.layerDefs + ';' : '';
	      this.params.layerDefs += ([id, where]).join(':');
	      return this;
	    },
	
	    simplify: function (map, factor) {
	      var mapWidth = Math.abs(map.getBounds().getWest() - map.getBounds().getEast());
	      this.params.maxAllowableOffset = (mapWidth / map.getSize().y) * factor;
	      return this;
	    },
	
	    run: function (callback, context) {
	      return this.request(function (error, response) {
	        callback.call(context, error, (response && responseToFeatureCollection(response)), response);
	      }, context);
	    }
	  });
	
	  function find (options) {
	    return new Find(options);
	  }
	
	  var Identify = Task.extend({
	    path: 'identify',
	
	    between: function (start, end) {
	      this.params.time = [start.valueOf(), end.valueOf()];
	      return this;
	    }
	  });
	
	  function identify (options) {
	    return new Identify(options);
	  }
	
	  var IdentifyFeatures = Identify.extend({
	    setters: {
	      'layers': 'layers',
	      'precision': 'geometryPrecision',
	      'tolerance': 'tolerance',
	      // skipped implementing this (for now) because the REST service implementation isnt consistent between operations.
	      // 'transform': 'datumTransformations'
	      'returnGeometry': 'returnGeometry'
	    },
	
	    params: {
	      sr: 4326,
	      layers: 'all',
	      tolerance: 3,
	      returnGeometry: true
	    },
	
	    on: function (map) {
	      var extent = boundsToExtent(map.getBounds());
	      var size = map.getSize();
	      this.params.imageDisplay = [size.x, size.y, 96];
	      this.params.mapExtent = [extent.xmin, extent.ymin, extent.xmax, extent.ymax];
	      return this;
	    },
	
	    at: function (geometry) {
	      // cast lat, long pairs in raw array form manually
	      if (geometry.length === 2) {
	        geometry = leaflet.latLng(geometry);
	      }
	      this._setGeometryParams(geometry);
	      return this;
	    },
	
	    layerDef: function (id, where) {
	      this.params.layerDefs = (this.params.layerDefs) ? this.params.layerDefs + ';' : '';
	      this.params.layerDefs += ([id, where]).join(':');
	      return this;
	    },
	
	    simplify: function (map, factor) {
	      var mapWidth = Math.abs(map.getBounds().getWest() - map.getBounds().getEast());
	      this.params.maxAllowableOffset = (mapWidth / map.getSize().y) * factor;
	      return this;
	    },
	
	    run: function (callback, context) {
	      return this.request(function (error, response) {
	        // immediately invoke with an error
	        if (error) {
	          callback.call(context, error, undefined, response);
	          return;
	
	        // ok no error lets just assume we have features...
	        } else {
	          var featureCollection = responseToFeatureCollection(response);
	          response.results = response.results.reverse();
	          for (var i = 0; i < featureCollection.features.length; i++) {
	            var feature = featureCollection.features[i];
	            feature.layerId = response.results[i].layerId;
	          }
	          callback.call(context, undefined, featureCollection, response);
	        }
	      });
	    },
	
	    _setGeometryParams: function (geometry) {
	      var converted = _setGeometry(geometry);
	      this.params.geometry = converted.geometry;
	      this.params.geometryType = converted.geometryType;
	    }
	  });
	
	  function identifyFeatures (options) {
	    return new IdentifyFeatures(options);
	  }
	
	  var IdentifyImage = Identify.extend({
	    setters: {
	      'setMosaicRule': 'mosaicRule',
	      'setRenderingRule': 'renderingRule',
	      'setPixelSize': 'pixelSize',
	      'returnCatalogItems': 'returnCatalogItems',
	      'returnGeometry': 'returnGeometry'
	    },
	
	    params: {
	      returnGeometry: false
	    },
	
	    at: function (latlng) {
	      latlng = leaflet.latLng(latlng);
	      this.params.geometry = JSON.stringify({
	        x: latlng.lng,
	        y: latlng.lat,
	        spatialReference: {
	          wkid: 4326
	        }
	      });
	      this.params.geometryType = 'esriGeometryPoint';
	      return this;
	    },
	
	    getMosaicRule: function () {
	      return this.params.mosaicRule;
	    },
	
	    getRenderingRule: function () {
	      return this.params.renderingRule;
	    },
	
	    getPixelSize: function () {
	      return this.params.pixelSize;
	    },
	
	    run: function (callback, context) {
	      return this.request(function (error, response) {
	        callback.call(context, error, (response && this._responseToGeoJSON(response)), response);
	      }, this);
	    },
	
	    // get pixel data and return as geoJSON point
	    // populate catalog items (if any)
	    // merging in any catalogItemVisibilities as a propery of each feature
	    _responseToGeoJSON: function (response) {
	      var location = response.location;
	      var catalogItems = response.catalogItems;
	      var catalogItemVisibilities = response.catalogItemVisibilities;
	      var geoJSON = {
	        'pixel': {
	          'type': 'Feature',
	          'geometry': {
	            'type': 'Point',
	            'coordinates': [location.x, location.y]
	          },
	          'crs': {
	            'type': 'EPSG',
	            'properties': {
	              'code': location.spatialReference.wkid
	            }
	          },
	          'properties': {
	            'OBJECTID': response.objectId,
	            'name': response.name,
	            'value': response.value
	          },
	          'id': response.objectId
	        }
	      };
	
	      if (response.properties && response.properties.Values) {
	        geoJSON.pixel.properties.values = response.properties.Values;
	      }
	
	      if (catalogItems && catalogItems.features) {
	        geoJSON.catalogItems = responseToFeatureCollection(catalogItems);
	        if (catalogItemVisibilities && catalogItemVisibilities.length === geoJSON.catalogItems.features.length) {
	          for (var i = catalogItemVisibilities.length - 1; i >= 0; i--) {
	            geoJSON.catalogItems.features[i].properties.catalogItemVisibility = catalogItemVisibilities[i];
	          }
	        }
	      }
	      return geoJSON;
	    }
	
	  });
	
	  function identifyImage (params) {
	    return new IdentifyImage(params);
	  }
	
	  var Service = leaflet.Evented.extend({
	
	    options: {
	      proxy: false,
	      useCors: cors,
	      timeout: 0
	    },
	
	    initialize: function (options) {
	      options = options || {};
	      this._requestQueue = [];
	      this._authenticating = false;
	      leaflet.Util.setOptions(this, options);
	      this.options.url = cleanUrl(this.options.url);
	    },
	
	    get: function (path, params, callback, context) {
	      return this._request('get', path, params, callback, context);
	    },
	
	    post: function (path, params, callback, context) {
	      return this._request('post', path, params, callback, context);
	    },
	
	    request: function (path, params, callback, context) {
	      return this._request('request', path, params, callback, context);
	    },
	
	    metadata: function (callback, context) {
	      return this._request('get', '', {}, callback, context);
	    },
	
	    authenticate: function (token) {
	      this._authenticating = false;
	      this.options.token = token;
	      this._runQueue();
	      return this;
	    },
	
	    getTimeout: function () {
	      return this.options.timeout;
	    },
	
	    setTimeout: function (timeout) {
	      this.options.timeout = timeout;
	    },
	
	    _request: function (method, path, params, callback, context) {
	      this.fire('requeststart', {
	        url: this.options.url + path,
	        params: params,
	        method: method
	      }, true);
	
	      var wrappedCallback = this._createServiceCallback(method, path, params, callback, context);
	
	      if (this.options.token) {
	        params.token = this.options.token;
	      }
	      if (this.options.requestParams) {
	        leaflet.Util.extend(params, this.options.requestParams);
	      }
	      if (this._authenticating) {
	        this._requestQueue.push([method, path, params, callback, context]);
	        return;
	      } else {
	        var url = (this.options.proxy) ? this.options.proxy + '?' + this.options.url + path : this.options.url + path;
	
	        if ((method === 'get' || method === 'request') && !this.options.useCors) {
	          return Request.get.JSONP(url, params, wrappedCallback, context);
	        } else {
	          return Request[method](url, params, wrappedCallback, context);
	        }
	      }
	    },
	
	    _createServiceCallback: function (method, path, params, callback, context) {
	      return leaflet.Util.bind(function (error, response) {
	        if (error && (error.code === 499 || error.code === 498)) {
	          this._authenticating = true;
	
	          this._requestQueue.push([method, path, params, callback, context]);
	
	          // fire an event for users to handle and re-authenticate
	          this.fire('authenticationrequired', {
	            authenticate: leaflet.Util.bind(this.authenticate, this)
	          }, true);
	
	          // if the user has access to a callback they can handle the auth error
	          error.authenticate = leaflet.Util.bind(this.authenticate, this);
	        }
	
	        callback.call(context, error, response);
	
	        if (error) {
	          this.fire('requesterror', {
	            url: this.options.url + path,
	            params: params,
	            message: error.message,
	            code: error.code,
	            method: method
	          }, true);
	        } else {
	          this.fire('requestsuccess', {
	            url: this.options.url + path,
	            params: params,
	            response: response,
	            method: method
	          }, true);
	        }
	
	        this.fire('requestend', {
	          url: this.options.url + path,
	          params: params,
	          method: method
	        }, true);
	      }, this);
	    },
	
	    _runQueue: function () {
	      for (var i = this._requestQueue.length - 1; i >= 0; i--) {
	        var request = this._requestQueue[i];
	        var method = request.shift();
	        this[method].apply(this, request);
	      }
	      this._requestQueue = [];
	    }
	  });
	
	  function service (options) {
	    options = getUrlParams(options);
	    return new Service(options);
	  }
	
	  var MapService = Service.extend({
	
	    identify: function () {
	      return identifyFeatures(this);
	    },
	
	    find: function () {
	      return find(this);
	    },
	
	    query: function () {
	      return query(this);
	    }
	
	  });
	
	  function mapService (options) {
	    return new MapService(options);
	  }
	
	  var ImageService = Service.extend({
	
	    query: function () {
	      return query(this);
	    },
	
	    identify: function () {
	      return identifyImage(this);
	    }
	  });
	
	  function imageService (options) {
	    return new ImageService(options);
	  }
	
	  var FeatureLayerService = Service.extend({
	
	    options: {
	      idAttribute: 'OBJECTID'
	    },
	
	    query: function () {
	      return query(this);
	    },
	
	    addFeature: function (feature, callback, context) {
	      this.addFeatures(feature, callback, context);
	    },
	
	    addFeatures: function (features, callback, context) {
	      var featuresArray = features.features ? features.features : [features];
	      for (var i = featuresArray.length - 1; i >= 0; i--) {
	        delete featuresArray[i].id;
	      }
	      features = geojsonToArcGIS$1(features);
	      features = featuresArray.length > 1 ? features : [features];
	      return this.post('addFeatures', {
	        features: features
	      }, function (error, response) {
	        // For compatibility reason with former addFeature function,
	        // we return the object in the array and not the array itself
	        var result = (response && response.addResults) ? response.addResults.length > 1 ? response.addResults : response.addResults[0] : undefined;
	        if (callback) {
	          callback.call(context, error || response.addResults[0].error, result);
	        }
	      }, context);
	    },
	
	    updateFeature: function (feature, callback, context) {
	      this.updateFeatures(feature, callback, context);
	    },
	
	    updateFeatures: function (features, callback, context) {
	      var featuresArray = features.features ? features.features : [features];
	      features = geojsonToArcGIS$1(features, this.options.idAttribute);
	      features = featuresArray.length > 1 ? features : [features];
	
	      return this.post('updateFeatures', {
	        features: features
	      }, function (error, response) {
	        // For compatibility reason with former updateFeature function,
	        // we return the object in the array and not the array itself
	        var result = (response && response.updateResults) ? response.updateResults.length > 1 ? response.updateResults : response.updateResults[0] : undefined;
	        if (callback) {
	          callback.call(context, error || response.updateResults[0].error, result);
	        }
	      }, context);
	    },
	
	    deleteFeature: function (id, callback, context) {
	      this.deleteFeatures(id, callback, context);
	    },
	
	    deleteFeatures: function (ids, callback, context) {
	      return this.post('deleteFeatures', {
	        objectIds: ids
	      }, function (error, response) {
	        // For compatibility reason with former deleteFeature function,
	        // we return the object in the array and not the array itself
	        var result = (response && response.deleteResults) ? response.deleteResults.length > 1 ? response.deleteResults : response.deleteResults[0] : undefined;
	        if (callback) {
	          callback.call(context, error || response.deleteResults[0].error, result);
	        }
	      }, context);
	    }
	  });
	
	  function featureLayerService (options) {
	    return new FeatureLayerService(options);
	  }
	
	  var tileProtocol = (window.location.protocol !== 'https:') ? 'http:' : 'https:';
	
	  var BasemapLayer = leaflet.TileLayer.extend({
	    statics: {
	      TILES: {
	        Streets: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            subdomains: ['server', 'services'],
	            attribution: 'USGS, NOAA',
	            attributionUrl: 'https://static.arcgis.com/attribution/World_Street_Map'
	          }
	        },
	        Topographic: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            subdomains: ['server', 'services'],
	            attribution: 'USGS, NOAA',
	            attributionUrl: 'https://static.arcgis.com/attribution/World_Topo_Map'
	          }
	        },
	        Oceans: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            attribution: 'USGS, NOAA',
	            attributionUrl: 'https://static.arcgis.com/attribution/Ocean_Basemap'
	          }
	        },
	        OceansLabels: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Reference/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	          }
	        },
	        NationalGeographic: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            attribution: 'National Geographic, DeLorme, HERE, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, increment P Corp.'
	          }
	        },
	        DarkGray: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            attribution: 'HERE, DeLorme, MapmyIndia, &copy; OpenStreetMap contributors'
	          }
	        },
	        DarkGrayLabels: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	
	          }
	        },
	        Gray: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            attribution: 'HERE, DeLorme, MapmyIndia, &copy; OpenStreetMap contributors'
	          }
	        },
	        GrayLabels: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 16,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	          }
	        },
	        Imagery: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            subdomains: ['server', 'services'],
	            attribution: 'DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community',
	            attributionUrl: 'https://static.arcgis.com/attribution/World_Imagery'
	          }
	        },
	        ImageryLabels: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	          }
	        },
	        ImageryTransportation: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	          }
	        },
	        ShadedRelief: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 13,
	            subdomains: ['server', 'services'],
	            attribution: 'USGS'
	          }
	        },
	        ShadedReliefLabels: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places_Alternate/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 12,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	          }
	        },
	        Terrain: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 13,
	            subdomains: ['server', 'services'],
	            attribution: 'USGS, NOAA'
	          }
	        },
	        TerrainLabels: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Reference_Overlay/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 13,
	            subdomains: ['server', 'services'],
	            pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
	            attribution: ''
	          }
	        },
	        USATopo: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 15,
	            subdomains: ['server', 'services'],
	            attribution: 'USGS, National Geographic Society, i-cubed'
	          }
	        },
	        ImageryClarity: {
	          urlTemplate: tileProtocol + '//clarity.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            attribution: 'Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
	          }
	        },
	        Physical: {
	          urlTemplate: tileProtocol + '//{s}.arcgisonline.com/arcgis/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 8,
	            subdomains: ['server', 'services'],
	            attribution: 'U.S. National Park Service'
	          }
	        },
	        ImageryFirefly: {
	          urlTemplate: tileProtocol + '//fly.maptiles.arcgis.com/arcgis/rest/services/World_Imagery_Firefly/MapServer/tile/{z}/{y}/{x}',
	          options: {
	            minZoom: 1,
	            maxZoom: 19,
	            attribution: 'Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community',
	            attributionUrl: 'https://static.arcgis.com/attribution/World_Imagery'
	          }
	        }
	      }
	    },
	
	    initialize: function (key, options) {
	      var config;
	
	      // set the config variable with the appropriate config object
	      if (typeof key === 'object' && key.urlTemplate && key.options) {
	        config = key;
	      } else if (typeof key === 'string' && BasemapLayer.TILES[key]) {
	        config = BasemapLayer.TILES[key];
	      } else {
	        throw new Error('L.esri.BasemapLayer: Invalid parameter. Use one of "Streets", "Topographic", "Oceans", "OceansLabels", "NationalGeographic", "Physical", "Gray", "GrayLabels", "DarkGray", "DarkGrayLabels", "Imagery", "ImageryLabels", "ImageryTransportation", "ImageryClarity", "ImageryFirefly", ShadedRelief", "ShadedReliefLabels", "Terrain", "TerrainLabels" or "USATopo"');
	      }
	
	      // merge passed options into the config options
	      var tileOptions = leaflet.Util.extend(config.options, options);
	
	      leaflet.Util.setOptions(this, tileOptions);
	
	      if (this.options.token && config.urlTemplate.indexOf('token=') === -1) {
	        config.urlTemplate += ('?token=' + this.options.token);
	      }
	      if (this.options.proxy) {
	        config.urlTemplate = this.options.proxy + '?' + config.urlTemplate;
	      }
	
	      // call the initialize method on L.TileLayer to set everything up
	      leaflet.TileLayer.prototype.initialize.call(this, config.urlTemplate, tileOptions);
	    },
	
	    onAdd: function (map) {
	      // include 'Powered by Esri' in map attribution
	      setEsriAttribution(map);
	
	      if (this.options.pane === 'esri-labels') {
	        this._initPane();
	      }
	      // some basemaps can supply dynamic attribution
	      if (this.options.attributionUrl) {
	        _getAttributionData((this.options.proxy ? this.options.proxy + '?' : '') + this.options.attributionUrl, map);
	      }
	
	      map.on('moveend', _updateMapAttribution);
	
	      leaflet.TileLayer.prototype.onAdd.call(this, map);
	    },
	
	    onRemove: function (map) {
	      removeEsriAttribution(map);
	
	      map.off('moveend', _updateMapAttribution);
	
	      leaflet.TileLayer.prototype.onRemove.call(this, map);
	    },
	
	    _initPane: function () {
	      if (!this._map.getPane(this.options.pane)) {
	        var pane = this._map.createPane(this.options.pane);
	        pane.style.pointerEvents = 'none';
	        pane.style.zIndex = 500;
	      }
	    },
	
	    getAttribution: function () {
	      if (this.options.attribution) {
	        var attribution = '<span class="esri-dynamic-attribution">' + this.options.attribution + '</span>';
	      }
	      return attribution;
	    }
	  });
	
	  function basemapLayer (key, options) {
	    return new BasemapLayer(key, options);
	  }
	
	  var TiledMapLayer = leaflet.TileLayer.extend({
	    options: {
	      zoomOffsetAllowance: 0.1,
	      errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEABAMAAACuXLVVAAAAA1BMVEUzNDVszlHHAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAAAAAAAAAB6mUWpAAAADZJREFUeJztwQEBAAAAgiD/r25IQAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7waBAAABw08RwAAAAABJRU5ErkJggg=='
	    },
	
	    statics: {
	      MercatorZoomLevels: {
	        '0': 156543.03392799999,
	        '1': 78271.516963999893,
	        '2': 39135.758482000099,
	        '3': 19567.879240999901,
	        '4': 9783.9396204999593,
	        '5': 4891.9698102499797,
	        '6': 2445.9849051249898,
	        '7': 1222.9924525624899,
	        '8': 611.49622628138002,
	        '9': 305.74811314055802,
	        '10': 152.874056570411,
	        '11': 76.437028285073197,
	        '12': 38.218514142536598,
	        '13': 19.109257071268299,
	        '14': 9.5546285356341496,
	        '15': 4.7773142679493699,
	        '16': 2.38865713397468,
	        '17': 1.1943285668550501,
	        '18': 0.59716428355981699,
	        '19': 0.29858214164761698,
	        '20': 0.14929107082381,
	        '21': 0.07464553541191,
	        '22': 0.0373227677059525,
	        '23': 0.0186613838529763
	      }
	    },
	
	    initialize: function (options) {
	      options = leaflet.Util.setOptions(this, options);
	
	      // set the urls
	      options = getUrlParams(options);
	      this.tileUrl = (options.proxy ? options.proxy + '?' : '') + options.url + 'tile/{z}/{y}/{x}' + (options.requestParams && Object.keys(options.requestParams).length > 0 ? leaflet.Util.getParamString(options.requestParams) : '');
	      // Remove subdomain in url
	      // https://github.com/Esri/esri-leaflet/issues/991
	      if (options.url.indexOf('{s}') !== -1 && options.subdomains) {
	        options.url = options.url.replace('{s}', options.subdomains[0]);
	      }
	      this.service = mapService(options);
	      this.service.addEventParent(this);
	
	      var arcgisonline = new RegExp(/tiles.arcgis(online)?\.com/g);
	      if (arcgisonline.test(options.url)) {
	        this.tileUrl = this.tileUrl.replace('://tiles', '://tiles{s}');
	        options.subdomains = ['1', '2', '3', '4'];
	      }
	
	      if (this.options.token) {
	        this.tileUrl += ('?token=' + this.options.token);
	      }
	
	      // init layer by calling TileLayers initialize method
	      leaflet.TileLayer.prototype.initialize.call(this, this.tileUrl, options);
	    },
	
	    getTileUrl: function (tilePoint) {
	      var zoom = this._getZoomForUrl();
	
	      return leaflet.Util.template(this.tileUrl, leaflet.Util.extend({
	        s: this._getSubdomain(tilePoint),
	        x: tilePoint.x,
	        y: tilePoint.y,
	        // try lod map first, then just default to zoom level
	        z: (this._lodMap && this._lodMap[zoom]) ? this._lodMap[zoom] : zoom
	      }, this.options));
	    },
	
	    createTile: function (coords, done) {
	      var tile = document.createElement('img');
	
	      leaflet.DomEvent.on(tile, 'load', leaflet.Util.bind(this._tileOnLoad, this, done, tile));
	      leaflet.DomEvent.on(tile, 'error', leaflet.Util.bind(this._tileOnError, this, done, tile));
	
	      if (this.options.crossOrigin) {
	        tile.crossOrigin = '';
	      }
	
	      /*
	       Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
	       http://www.w3.org/TR/WCAG20-TECHS/H67
	      */
	      tile.alt = '';
	
	      // if there is no lod map or an lod map with a proper zoom load the tile
	      // otherwise wait for the lod map to become available
	      if (!this._lodMap || (this._lodMap && this._lodMap[this._getZoomForUrl()])) {
	        tile.src = this.getTileUrl(coords);
	      } else {
	        this.once('lodmap', function () {
	          tile.src = this.getTileUrl(coords);
	        }, this);
	      }
	
	      return tile;
	    },
	
	    onAdd: function (map) {
	      // include 'Powered by Esri' in map attribution
	      setEsriAttribution(map);
	
	      if (!this._lodMap) {
	        this.metadata(function (error, metadata) {
	          if (!error && metadata.spatialReference) {
	            var sr = metadata.spatialReference.latestWkid || metadata.spatialReference.wkid;
	            // display the copyright text from the service using leaflet's attribution control
	            if (!this.options.attribution && map.attributionControl && metadata.copyrightText) {
	              this.options.attribution = metadata.copyrightText;
	              map.attributionControl.addAttribution(this.getAttribution());
	            }
	
	            // if the service tiles were published in web mercator using conventional LODs but missing levels, we can try and remap them
	            if (map.options.crs === leaflet.CRS.EPSG3857 && (sr === 102100 || sr === 3857)) {
	              this._lodMap = {};
	              // create the zoom level data
	              var arcgisLODs = metadata.tileInfo.lods;
	              var correctResolutions = TiledMapLayer.MercatorZoomLevels;
	
	              for (var i = 0; i < arcgisLODs.length; i++) {
	                var arcgisLOD = arcgisLODs[i];
	                for (var ci in correctResolutions) {
	                  var correctRes = correctResolutions[ci];
	
	                  if (this._withinPercentage(arcgisLOD.resolution, correctRes, this.options.zoomOffsetAllowance)) {
	                    this._lodMap[ci] = arcgisLOD.level;
	                    break;
	                  }
	                }
	              }
	
	              this.fire('lodmap');
	            } else if (map.options.crs && map.options.crs.code && (map.options.crs.code.indexOf(sr) > -1)) ; else {
	              // if the service was cached in a custom projection and an appropriate LOD hasn't been defined in the map, guide the developer to our Proj4 sample
	              warn('L.esri.TiledMapLayer is using a non-mercator spatial reference. Support may be available through Proj4Leaflet http://esri.github.io/esri-leaflet/examples/non-mercator-projection.html');
	            }
	          }
	        }, this);
	      }
	
	      leaflet.TileLayer.prototype.onAdd.call(this, map);
	    },
	
	    onRemove: function (map) {
	      removeEsriAttribution(map);
	    },
	
	    metadata: function (callback, context) {
	      this.service.metadata(callback, context);
	      return this;
	    },
	
	    identify: function () {
	      return this.service.identify();
	    },
	
	    find: function () {
	      return this.service.find();
	    },
	
	    query: function () {
	      return this.service.query();
	    },
	
	    authenticate: function (token) {
	      var tokenQs = '?token=' + token;
	      this.tileUrl = (this.options.token) ? this.tileUrl.replace(/\?token=(.+)/g, tokenQs) : this.tileUrl + tokenQs;
	      this.options.token = token;
	      this.service.authenticate(token);
	      return this;
	    },
	
	    _withinPercentage: function (a, b, percentage) {
	      var diff = Math.abs((a / b) - 1);
	      return diff < percentage;
	    }
	  });
	
	  function tiledMapLayer (url, options) {
	    return new TiledMapLayer(url, options);
	  }
	
	  var Overlay = leaflet.ImageOverlay.extend({
	    onAdd: function (map) {
	      this._topLeft = map.getPixelBounds().min;
	      leaflet.ImageOverlay.prototype.onAdd.call(this, map);
	    },
	    _reset: function () {
	      if (this._map.options.crs === leaflet.CRS.EPSG3857) {
	        leaflet.ImageOverlay.prototype._reset.call(this);
	      } else {
	        leaflet.DomUtil.setPosition(this._image, this._topLeft.subtract(this._map.getPixelOrigin()));
	      }
	    }
	  });
	
	  var RasterLayer = leaflet.Layer.extend({
	    options: {
	      opacity: 1,
	      position: 'front',
	      f: 'image',
	      useCors: cors,
	      attribution: null,
	      interactive: false,
	      alt: ''
	    },
	
	    onAdd: function (map) {
	      // include 'Powered by Esri' in map attribution
	      setEsriAttribution(map);
	
	      if (this.options.zIndex) {
	        this.options.position = null;
	      }
	
	      this._update = leaflet.Util.throttle(this._update, this.options.updateInterval, this);
	
	      map.on('moveend', this._update, this);
	
	      // if we had an image loaded and it matches the
	      // current bounds show the image otherwise remove it
	      if (this._currentImage && this._currentImage._bounds.equals(this._map.getBounds())) {
	        map.addLayer(this._currentImage);
	      } else if (this._currentImage) {
	        this._map.removeLayer(this._currentImage);
	        this._currentImage = null;
	      }
	
	      this._update();
	
	      if (this._popup) {
	        this._map.on('click', this._getPopupData, this);
	        this._map.on('dblclick', this._resetPopupState, this);
	      }
	
	      // add copyright text listed in service metadata
	      this.metadata(function (err, metadata) {
	        if (!err && !this.options.attribution && map.attributionControl && metadata.copyrightText) {
	          this.options.attribution = metadata.copyrightText;
	          map.attributionControl.addAttribution(this.getAttribution());
	        }
	      }, this);
	    },
	
	    onRemove: function (map) {
	      removeEsriAttribution(map);
	
	      if (this._currentImage) {
	        this._map.removeLayer(this._currentImage);
	      }
	
	      if (this._popup) {
	        this._map.off('click', this._getPopupData, this);
	        this._map.off('dblclick', this._resetPopupState, this);
	      }
	
	      this._map.off('moveend', this._update, this);
	    },
	
	    bindPopup: function (fn, popupOptions) {
	      this._shouldRenderPopup = false;
	      this._lastClick = false;
	      this._popup = leaflet.popup(popupOptions);
	      this._popupFunction = fn;
	      if (this._map) {
	        this._map.on('click', this._getPopupData, this);
	        this._map.on('dblclick', this._resetPopupState, this);
	      }
	      return this;
	    },
	
	    unbindPopup: function () {
	      if (this._map) {
	        this._map.closePopup(this._popup);
	        this._map.off('click', this._getPopupData, this);
	        this._map.off('dblclick', this._resetPopupState, this);
	      }
	      this._popup = false;
	      return this;
	    },
	
	    bringToFront: function () {
	      this.options.position = 'front';
	      if (this._currentImage) {
	        this._currentImage.bringToFront();
	        this._setAutoZIndex(Math.max);
	      }
	      return this;
	    },
	
	    bringToBack: function () {
	      this.options.position = 'back';
	      if (this._currentImage) {
	        this._currentImage.bringToBack();
	        this._setAutoZIndex(Math.min);
	      }
	      return this;
	    },
	
	    setZIndex: function (value) {
	      this.options.zIndex = value;
	      if (this._currentImage) {
	        this._currentImage.setZIndex(value);
	      }
	      return this;
	    },
	
	    _setAutoZIndex: function (compare) {
	      // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	      if (!this._currentImage) {
	        return;
	      }
	      var layers = this._currentImage.getPane().children;
	      var edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	      for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	        zIndex = layers[i].style.zIndex;
	        if (layers[i] !== this._currentImage._image && zIndex) {
	          edgeZIndex = compare(edgeZIndex, +zIndex);
	        }
	      }
	
	      if (isFinite(edgeZIndex)) {
	        this.options.zIndex = edgeZIndex + compare(-1, 1);
	        this.setZIndex(this.options.zIndex);
	      }
	    },
	
	    getAttribution: function () {
	      return this.options.attribution;
	    },
	
	    getOpacity: function () {
	      return this.options.opacity;
	    },
	
	    setOpacity: function (opacity) {
	      this.options.opacity = opacity;
	      if (this._currentImage) {
	        this._currentImage.setOpacity(opacity);
	      }
	      return this;
	    },
	
	    getTimeRange: function () {
	      return [this.options.from, this.options.to];
	    },
	
	    setTimeRange: function (from, to) {
	      this.options.from = from;
	      this.options.to = to;
	      this._update();
	      return this;
	    },
	
	    metadata: function (callback, context) {
	      this.service.metadata(callback, context);
	      return this;
	    },
	
	    authenticate: function (token) {
	      this.service.authenticate(token);
	      return this;
	    },
	
	    redraw: function () {
	      this._update();
	    },
	
	    _renderImage: function (url, bounds, contentType) {
	      if (this._map) {
	        // if no output directory has been specified for a service, MIME data will be returned
	        if (contentType) {
	          url = 'data:' + contentType + ';base64,' + url;
	        }
	
	        // if server returns an inappropriate response, abort.
	        if (!url) return;
	
	        // create a new image overlay and add it to the map
	        // to start loading the image
	        // opacity is 0 while the image is loading
	        var image = new Overlay(url, bounds, {
	          opacity: 0,
	          crossOrigin: this.options.withCredentials ? 'use-credentials' : this.options.useCors,
	          alt: this.options.alt,
	          pane: this.options.pane || this.getPane(),
	          interactive: this.options.interactive
	        }).addTo(this._map);
	
	        var onOverlayError = function () {
	          this._map.removeLayer(image);
	          this.fire('error');
	          image.off('load', onOverlayLoad, this);
	        };
	
	        var onOverlayLoad = function (e) {
	          image.off('error', onOverlayLoad, this);
	          if (this._map) {
	            var newImage = e.target;
	            var oldImage = this._currentImage;
	
	            // if the bounds of this image matches the bounds that
	            // _renderImage was called with and we have a map with the same bounds
	            // hide the old image if there is one and set the opacity
	            // of the new image otherwise remove the new image
	            if (newImage._bounds.equals(bounds) && newImage._bounds.equals(this._map.getBounds())) {
	              this._currentImage = newImage;
	
	              if (this.options.position === 'front') {
	                this.bringToFront();
	              } else if (this.options.position === 'back') {
	                this.bringToBack();
	              }
	
	              if (this.options.zIndex) {
	                this.setZIndex(this.options.zIndex);
	              }
	
	              if (this._map && this._currentImage._map) {
	                this._currentImage.setOpacity(this.options.opacity);
	              } else {
	                this._currentImage._map.removeLayer(this._currentImage);
	              }
	
	              if (oldImage && this._map) {
	                this._map.removeLayer(oldImage);
	              }
	
	              if (oldImage && oldImage._map) {
	                oldImage._map.removeLayer(oldImage);
	              }
	            } else {
	              this._map.removeLayer(newImage);
	            }
	          }
	
	          this.fire('load', {
	            bounds: bounds
	          });
	        };
	
	        // If loading the image fails
	        image.once('error', onOverlayError, this);
	
	        // once the image loads
	        image.once('load', onOverlayLoad, this);
	      }
	    },
	
	    _update: function () {
	      if (!this._map) {
	        return;
	      }
	
	      var zoom = this._map.getZoom();
	      var bounds = this._map.getBounds();
	
	      if (this._animatingZoom) {
	        return;
	      }
	
	      if (this._map._panTransition && this._map._panTransition._inProgress) {
	        return;
	      }
	
	      if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
	        if (this._currentImage) {
	          this._currentImage._map.removeLayer(this._currentImage);
	          this._currentImage = null;
	        }
	        return;
	      }
	
	      var params = this._buildExportParams();
	      leaflet.Util.extend(params, this.options.requestParams);
	
	      if (params) {
	        this._requestExport(params, bounds);
	
	        this.fire('loading', {
	          bounds: bounds
	        });
	      } else if (this._currentImage) {
	        this._currentImage._map.removeLayer(this._currentImage);
	        this._currentImage = null;
	      }
	    },
	
	    _renderPopup: function (latlng, error, results, response) {
	      latlng = leaflet.latLng(latlng);
	      if (this._shouldRenderPopup && this._lastClick.equals(latlng)) {
	        // add the popup to the map where the mouse was clicked at
	        var content = this._popupFunction(error, results, response);
	        if (content) {
	          this._popup.setLatLng(latlng).setContent(content).openOn(this._map);
	        }
	      }
	    },
	
	    _resetPopupState: function (e) {
	      this._shouldRenderPopup = false;
	      this._lastClick = e.latlng;
	    },
	
	    _calculateBbox: function () {
	      var pixelBounds = this._map.getPixelBounds();
	
	      var sw = this._map.unproject(pixelBounds.getBottomLeft());
	      var ne = this._map.unproject(pixelBounds.getTopRight());
	
	      var neProjected = this._map.options.crs.project(ne);
	      var swProjected = this._map.options.crs.project(sw);
	
	      // this ensures ne/sw are switched in polar maps where north/top bottom/south is inverted
	      var boundsProjected = leaflet.bounds(neProjected, swProjected);
	
	      return [boundsProjected.getBottomLeft().x, boundsProjected.getBottomLeft().y, boundsProjected.getTopRight().x, boundsProjected.getTopRight().y].join(',');
	    },
	
	    _calculateImageSize: function () {
	      // ensure that we don't ask ArcGIS Server for a taller image than we have actual map displaying within the div
	      var bounds = this._map.getPixelBounds();
	      var size = this._map.getSize();
	
	      var sw = this._map.unproject(bounds.getBottomLeft());
	      var ne = this._map.unproject(bounds.getTopRight());
	
	      var top = this._map.latLngToLayerPoint(ne).y;
	      var bottom = this._map.latLngToLayerPoint(sw).y;
	
	      if (top > 0 || bottom < size.y) {
	        size.y = bottom - top;
	      }
	
	      return size.x + ',' + size.y;
	    }
	  });
	
	  var ImageMapLayer = RasterLayer.extend({
	
	    options: {
	      updateInterval: 150,
	      format: 'jpgpng',
	      transparent: true,
	      f: 'image'
	    },
	
	    query: function () {
	      return this.service.query();
	    },
	
	    identify: function () {
	      return this.service.identify();
	    },
	
	    initialize: function (options) {
	      options = getUrlParams(options);
	      this.service = imageService(options);
	      this.service.addEventParent(this);
	
	      leaflet.Util.setOptions(this, options);
	    },
	
	    setPixelType: function (pixelType) {
	      this.options.pixelType = pixelType;
	      this._update();
	      return this;
	    },
	
	    getPixelType: function () {
	      return this.options.pixelType;
	    },
	
	    setBandIds: function (bandIds) {
	      if (leaflet.Util.isArray(bandIds)) {
	        this.options.bandIds = bandIds.join(',');
	      } else {
	        this.options.bandIds = bandIds.toString();
	      }
	      this._update();
	      return this;
	    },
	
	    getBandIds: function () {
	      return this.options.bandIds;
	    },
	
	    setNoData: function (noData, noDataInterpretation) {
	      if (leaflet.Util.isArray(noData)) {
	        this.options.noData = noData.join(',');
	      } else {
	        this.options.noData = noData.toString();
	      }
	      if (noDataInterpretation) {
	        this.options.noDataInterpretation = noDataInterpretation;
	      }
	      this._update();
	      return this;
	    },
	
	    getNoData: function () {
	      return this.options.noData;
	    },
	
	    getNoDataInterpretation: function () {
	      return this.options.noDataInterpretation;
	    },
	
	    setRenderingRule: function (renderingRule) {
	      this.options.renderingRule = renderingRule;
	      this._update();
	    },
	
	    getRenderingRule: function () {
	      return this.options.renderingRule;
	    },
	
	    setMosaicRule: function (mosaicRule) {
	      this.options.mosaicRule = mosaicRule;
	      this._update();
	    },
	
	    getMosaicRule: function () {
	      return this.options.mosaicRule;
	    },
	
	    _getPopupData: function (e) {
	      var callback = leaflet.Util.bind(function (error, results, response) {
	        if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
	        setTimeout(leaflet.Util.bind(function () {
	          this._renderPopup(e.latlng, error, results, response);
	        }, this), 300);
	      }, this);
	
	      var identifyRequest = this.identify().at(e.latlng);
	
	      // set mosaic rule for identify task if it is set for layer
	      if (this.options.mosaicRule) {
	        identifyRequest.setMosaicRule(this.options.mosaicRule);
	        // @TODO: force return catalog items too?
	      }
	
	      // @TODO: set rendering rule? Not sure,
	      // sometimes you want raw pixel values
	      // if (this.options.renderingRule) {
	      //   identifyRequest.setRenderingRule(this.options.renderingRule);
	      // }
	
	      identifyRequest.run(callback);
	
	      // set the flags to show the popup
	      this._shouldRenderPopup = true;
	      this._lastClick = e.latlng;
	    },
	
	    _buildExportParams: function () {
	      var sr = parseInt(this._map.options.crs.code.split(':')[1], 10);
	
	      var params = {
	        bbox: this._calculateBbox(),
	        size: this._calculateImageSize(),
	        format: this.options.format,
	        transparent: this.options.transparent,
	        bboxSR: sr,
	        imageSR: sr
	      };
	
	      if (this.options.from && this.options.to) {
	        params.time = this.options.from.valueOf() + ',' + this.options.to.valueOf();
	      }
	
	      if (this.options.pixelType) {
	        params.pixelType = this.options.pixelType;
	      }
	
	      if (this.options.interpolation) {
	        params.interpolation = this.options.interpolation;
	      }
	
	      if (this.options.compressionQuality) {
	        params.compressionQuality = this.options.compressionQuality;
	      }
	
	      if (this.options.bandIds) {
	        params.bandIds = this.options.bandIds;
	      }
	
	      // 0 is falsy *and* a valid input parameter
	      if (this.options.noData === 0 || this.options.noData) {
	        params.noData = this.options.noData;
	      }
	
	      if (this.options.noDataInterpretation) {
	        params.noDataInterpretation = this.options.noDataInterpretation;
	      }
	
	      if (this.service.options.token) {
	        params.token = this.service.options.token;
	      }
	
	      if (this.options.renderingRule) {
	        params.renderingRule = JSON.stringify(this.options.renderingRule);
	      }
	
	      if (this.options.mosaicRule) {
	        params.mosaicRule = JSON.stringify(this.options.mosaicRule);
	      }
	
	      return params;
	    },
	
	    _requestExport: function (params, bounds) {
	      if (this.options.f === 'json') {
	        this.service.request('exportImage', params, function (error, response) {
	          if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
	          if (this.options.token) {
	            response.href += ('?token=' + this.options.token);
	          }
	          if (this.options.proxy) {
	            response.href = this.options.proxy + '?' + response.href;
	          }
	          this._renderImage(response.href, bounds);
	        }, this);
	      } else {
	        params.f = 'image';
	        var fullUrl = this.options.url + 'exportImage' + leaflet.Util.getParamString(params);
	        if (this.options.proxy) {
	          fullUrl = this.options.proxy + '?' + fullUrl;
	        }
	        this._renderImage(fullUrl, bounds);
	      }
	    }
	  });
	
	  function imageMapLayer (url, options) {
	    return new ImageMapLayer(url, options);
	  }
	
	  var DynamicMapLayer = RasterLayer.extend({
	
	    options: {
	      updateInterval: 150,
	      layers: false,
	      layerDefs: false,
	      timeOptions: false,
	      format: 'png32',
	      transparent: true,
	      f: 'json'
	    },
	
	    initialize: function (options) {
	      options = getUrlParams(options);
	      this.service = mapService(options);
	      this.service.addEventParent(this);
	
	      leaflet.Util.setOptions(this, options);
	    },
	
	    getDynamicLayers: function () {
	      return this.options.dynamicLayers;
	    },
	
	    setDynamicLayers: function (dynamicLayers) {
	      this.options.dynamicLayers = dynamicLayers;
	      this._update();
	      return this;
	    },
	
	    getLayers: function () {
	      return this.options.layers;
	    },
	
	    setLayers: function (layers) {
	      this.options.layers = layers;
	      this._update();
	      return this;
	    },
	
	    getLayerDefs: function () {
	      return this.options.layerDefs;
	    },
	
	    setLayerDefs: function (layerDefs) {
	      this.options.layerDefs = layerDefs;
	      this._update();
	      return this;
	    },
	
	    getTimeOptions: function () {
	      return this.options.timeOptions;
	    },
	
	    setTimeOptions: function (timeOptions) {
	      this.options.timeOptions = timeOptions;
	      this._update();
	      return this;
	    },
	
	    query: function () {
	      return this.service.query();
	    },
	
	    identify: function () {
	      return this.service.identify();
	    },
	
	    find: function () {
	      return this.service.find();
	    },
	
	    _getPopupData: function (e) {
	      var callback = leaflet.Util.bind(function (error, featureCollection, response) {
	        if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
	        setTimeout(leaflet.Util.bind(function () {
	          this._renderPopup(e.latlng, error, featureCollection, response);
	        }, this), 300);
	      }, this);
	
	      var identifyRequest;
	      if (this.options.popup) {
	        identifyRequest = this.options.popup.on(this._map).at(e.latlng);
	      } else {
	        identifyRequest = this.identify().on(this._map).at(e.latlng);
	      }
	
	      // remove extraneous vertices from response features if it has not already been done
	      identifyRequest.params.maxAllowableOffset ? true : identifyRequest.simplify(this._map, 0.5);
	
	      if (!(this.options.popup && this.options.popup.params && this.options.popup.params.layers)) {
	        if (this.options.layers) {
	          identifyRequest.layers('visible:' + this.options.layers.join(','));
	        } else {
	          identifyRequest.layers('visible');
	        }
	      }
	
	      // if present, pass layer ids and sql filters through to the identify task
	      if (this.options.layerDefs && typeof this.options.layerDefs !== 'string' && !identifyRequest.params.layerDefs) {
	        for (var id in this.options.layerDefs) {
	          if (this.options.layerDefs.hasOwnProperty(id)) {
	            identifyRequest.layerDef(id, this.options.layerDefs[id]);
	          }
	        }
	      }
	
	      identifyRequest.run(callback);
	
	      // set the flags to show the popup
	      this._shouldRenderPopup = true;
	      this._lastClick = e.latlng;
	    },
	
	    _buildExportParams: function () {
	      var sr = parseInt(this._map.options.crs.code.split(':')[1], 10);
	
	      var params = {
	        bbox: this._calculateBbox(),
	        size: this._calculateImageSize(),
	        dpi: 96,
	        format: this.options.format,
	        transparent: this.options.transparent,
	        bboxSR: sr,
	        imageSR: sr
	      };
	
	      if (this.options.dynamicLayers) {
	        params.dynamicLayers = this.options.dynamicLayers;
	      }
	
	      if (this.options.layers) {
	        if (this.options.layers.length === 0) {
	          return;
	        } else {
	          params.layers = 'show:' + this.options.layers.join(',');
	        }
	      }
	
	      if (this.options.layerDefs) {
	        params.layerDefs = typeof this.options.layerDefs === 'string' ? this.options.layerDefs : JSON.stringify(this.options.layerDefs);
	      }
	
	      if (this.options.timeOptions) {
	        params.timeOptions = JSON.stringify(this.options.timeOptions);
	      }
	
	      if (this.options.from && this.options.to) {
	        params.time = this.options.from.valueOf() + ',' + this.options.to.valueOf();
	      }
	
	      if (this.service.options.token) {
	        params.token = this.service.options.token;
	      }
	
	      if (this.options.proxy) {
	        params.proxy = this.options.proxy;
	      }
	
	      // use a timestamp to bust server cache
	      if (this.options.disableCache) {
	        params._ts = Date.now();
	      }
	
	      return params;
	    },
	
	    _requestExport: function (params, bounds) {
	      if (this.options.f === 'json') {
	        this.service.request('export', params, function (error, response) {
	          if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
	
	          if (this.options.token && response.href) {
	            response.href += ('?token=' + this.options.token);
	          }
	          if (this.options.proxy && response.href) {
	            response.href = this.options.proxy + '?' + response.href;
	          }
	          if (response.href) {
	            this._renderImage(response.href, bounds);
	          } else {
	            this._renderImage(response.imageData, bounds, response.contentType);
	          }
	        }, this);
	      } else {
	        params.f = 'image';
	        var fullUrl = this.options.url + 'export' + leaflet.Util.getParamString(params);
	        if (this.options.proxy) {
	          fullUrl = this.options.proxy + '?' + fullUrl;
	        }
	        this._renderImage(fullUrl, bounds);
	      }
	    }
	  });
	
	  function dynamicMapLayer (url, options) {
	    return new DynamicMapLayer(url, options);
	  }
	
	  var FeatureGrid = leaflet.Layer.extend({
	    // @section
	    // @aka GridLayer options
	    options: {
	      // @option cellSize: Number|Point = 256
	      // Width and height of cells in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
	      cellSize: 512,
	
	      // @option updateWhenIdle: Boolean = (depends)
	      // Load new cells only when panning ends.
	      // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
	      // `false` otherwise in order to display new cells _during_ panning, since it is easy to pan outside the
	      // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
	      updateWhenIdle: leaflet.Browser.mobile,
	
	      // @option updateInterval: Number = 150
	      // Cells will not update more than once every `updateInterval` milliseconds when panning.
	      updateInterval: 150,
	
	      // @option noWrap: Boolean = false
	      // Whether the layer is wrapped around the antimeridian. If `true`, the
	      // GridLayer will only be displayed once at low zoom levels. Has no
	      // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
	      // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
	      // cells outside the CRS limits.
	      noWrap: false,
	
	      // @option keepBuffer: Number = 1.5
	      // When panning the map, keep this many rows and columns of cells before unloading them.
	      keepBuffer: 1.5
	    },
	
	    initialize: function (options) {
	      leaflet.Util.setOptions(this, options);
	    },
	
	    onAdd: function (map) {
	      this._cells = {};
	      this._activeCells = {};
	      this._resetView();
	      this._update();
	    },
	
	    onRemove: function (map) {
	      this._removeAllCells();
	      this._cellZoom = undefined;
	    },
	
	    // @method isLoading: Boolean
	    // Returns `true` if any cell in the grid layer has not finished loading.
	    isLoading: function () {
	      return this._loading;
	    },
	
	    // @method redraw: this
	    // Causes the layer to clear all the cells and request them again.
	    redraw: function () {
	      if (this._map) {
	        this._removeAllCells();
	        this._update();
	      }
	      return this;
	    },
	
	    getEvents: function () {
	      var events = {
	        viewprereset: this._invalidateAll,
	        viewreset: this._resetView,
	        zoom: this._resetView,
	        moveend: this._onMoveEnd
	      };
	
	      if (!this.options.updateWhenIdle) {
	        // update cells on move, but not more often than once per given interval
	        if (!this._onMove) {
	          this._onMove = leaflet.Util.throttle(
	            this._onMoveEnd,
	            this.options.updateInterval,
	            this
	          );
	        }
	
	        events.move = this._onMove;
	      }
	
	      return events;
	    },
	
	    // @section Extension methods
	    // Layers extending `GridLayer` shall reimplement the following method.
	    // @method createCell(coords: Object, done?: Function): HTMLElement
	    // Called only internally, must be overridden by classes extending `GridLayer`.
	    // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	    // is specified, it must be called when the cell has finished loading and drawing.
	    createCell: function () {
	      return document.createElement('div');
	    },
	
	    removeCell: function () {
	      return;
	    },
	
	    reuseCell: function () {
	      return;
	    },
	
	    cellLeave: function () {
	      return;
	    },
	
	    cellEnter: function () {
	      return;
	    },
	    // @section
	    // @method getCellSize: Point
	    // Normalizes the [cellSize option](#gridlayer-cellsize) into a point. Used by the `createCell()` method.
	    getCellSize: function () {
	      var s = this.options.cellSize;
	      return s instanceof leaflet.Point ? s : new leaflet.Point(s, s);
	    },
	
	    _pruneCells: function () {
	      if (!this._map) {
	        return;
	      }
	
	      var key, cell;
	
	      for (key in this._cells) {
	        cell = this._cells[key];
	        cell.retain = cell.current;
	      }
	
	      for (key in this._cells) {
	        cell = this._cells[key];
	        if (cell.current && !cell.active) {
	          var coords = cell.coords;
	          if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
	            this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
	          }
	        }
	      }
	
	      for (key in this._cells) {
	        if (!this._cells[key].retain) {
	          this._removeCell(key);
	        }
	      }
	    },
	
	    _removeAllCells: function () {
	      for (var key in this._cells) {
	        this._removeCell(key);
	      }
	    },
	
	    _invalidateAll: function () {
	      this._removeAllCells();
	
	      this._cellZoom = undefined;
	    },
	
	    _retainParent: function (x, y, z, minZoom) {
	      var x2 = Math.floor(x / 2);
	      var y2 = Math.floor(y / 2);
	      var z2 = z - 1;
	      var coords2 = new leaflet.Point(+x2, +y2);
	      coords2.z = +z2;
	
	      var key = this._cellCoordsToKey(coords2);
	      var cell = this._cells[key];
	
	      if (cell && cell.active) {
	        cell.retain = true;
	        return true;
	      } else if (cell && cell.loaded) {
	        cell.retain = true;
	      }
	
	      if (z2 > minZoom) {
	        return this._retainParent(x2, y2, z2, minZoom);
	      }
	
	      return false;
	    },
	
	    _retainChildren: function (x, y, z, maxZoom) {
	      for (var i = 2 * x; i < 2 * x + 2; i++) {
	        for (var j = 2 * y; j < 2 * y + 2; j++) {
	          var coords = new leaflet.Point(i, j);
	          coords.z = z + 1;
	
	          var key = this._cellCoordsToKey(coords);
	          var cell = this._cells[key];
	
	          if (cell && cell.active) {
	            cell.retain = true;
	            continue;
	          } else if (cell && cell.loaded) {
	            cell.retain = true;
	          }
	
	          if (z + 1 < maxZoom) {
	            this._retainChildren(i, j, z + 1, maxZoom);
	          }
	        }
	      }
	    },
	
	    _resetView: function (e) {
	      var animating = e && (e.pinch || e.flyTo);
	
	      if (animating) {
	        return;
	      }
	
	      this._setView(
	        this._map.getCenter(),
	        this._map.getZoom(),
	        animating,
	        animating
	      );
	    },
	
	    _setView: function (center, zoom, noPrune, noUpdate) {
	      var cellZoom = Math.round(zoom);
	
	      if (!noUpdate) {
	        this._cellZoom = cellZoom;
	
	        if (this._abortLoading) {
	          this._abortLoading();
	        }
	
	        this._resetGrid();
	
	        if (cellZoom !== undefined) {
	          this._update(center);
	        }
	
	        if (!noPrune) {
	          this._pruneCells();
	        }
	
	        // Flag to prevent _updateOpacity from pruning cells during
	        // a zoom anim or a pinch gesture
	        this._noPrune = !!noPrune;
	      }
	    },
	
	    _resetGrid: function () {
	      var map = this._map;
	      var crs = map.options.crs;
	      var cellSize = (this._cellSize = this.getCellSize());
	      var cellZoom = this._cellZoom;
	
	      var bounds = this._map.getPixelWorldBounds(this._cellZoom);
	      if (bounds) {
	        this._globalCellRange = this._pxBoundsToCellRange(bounds);
	      }
	
	      this._wrapX = crs.wrapLng &&
	        !this.options.noWrap && [
	          Math.floor(map.project([0, crs.wrapLng[0]], cellZoom).x / cellSize.x),
	          Math.ceil(map.project([0, crs.wrapLng[1]], cellZoom).x / cellSize.y)
	        ];
	      this._wrapY = crs.wrapLat &&
	        !this.options.noWrap && [
	          Math.floor(map.project([crs.wrapLat[0], 0], cellZoom).y / cellSize.x),
	          Math.ceil(map.project([crs.wrapLat[1], 0], cellZoom).y / cellSize.y)
	        ];
	    },
	
	    _onMoveEnd: function (e) {
	      var animating = e && (e.pinch || e.flyTo);
	
	      if (animating || !this._map || this._map._animatingZoom) {
	        return;
	      }
	
	      this._update();
	    },
	
	    _getCelldPixelBounds: function (center) {
	      var map = this._map;
	      var mapZoom = map._animatingZoom
	        ? Math.max(map._animateToZoom, map.getZoom())
	        : map.getZoom();
	      var scale = map.getZoomScale(mapZoom, this._cellZoom);
	      var pixelCenter = map.project(center, this._cellZoom).floor();
	      var halfSize = map.getSize().divideBy(scale * 2);
	
	      return new leaflet.Bounds(
	        pixelCenter.subtract(halfSize),
	        pixelCenter.add(halfSize)
	      );
	    },
	
	    // Private method to load cells in the grid's active zoom level according to map bounds
	    _update: function (center) {
	      var map = this._map;
	      if (!map) {
	        return;
	      }
	      var zoom = Math.round(map.getZoom());
	
	      if (center === undefined) {
	        center = map.getCenter();
	      }
	
	      var pixelBounds = this._getCelldPixelBounds(center);
	      var cellRange = this._pxBoundsToCellRange(pixelBounds);
	      var cellCenter = cellRange.getCenter();
	      var queue = [];
	      var margin = this.options.keepBuffer;
	      var noPruneRange = new leaflet.Bounds(
	        cellRange.getBottomLeft().subtract([margin, -margin]),
	        cellRange.getTopRight().add([margin, -margin])
	      );
	
	      // Sanity check: panic if the cell range contains Infinity somewhere.
	      if (
	        !(
	          isFinite(cellRange.min.x) &&
	          isFinite(cellRange.min.y) &&
	          isFinite(cellRange.max.x) &&
	          isFinite(cellRange.max.y)
	        )
	      ) {
	        throw new Error('Attempted to load an infinite number of cells');
	      }
	
	      for (var key in this._cells) {
	        var c = this._cells[key].coords;
	        if (
	          c.z !== this._cellZoom ||
	          !noPruneRange.contains(new leaflet.Point(c.x, c.y))
	        ) {
	          this._cells[key].current = false;
	        }
	      }
	
	      // _update just loads more cells. If the cell zoom level differs too much
	      // from the map's, let _setView reset levels and prune old cells.
	      if (Math.abs(zoom - this._cellZoom) > 1) {
	        this._setView(center, zoom);
	        return;
	      }
	
	      // create a queue of coordinates to load cells from
	      for (var j = cellRange.min.y; j <= cellRange.max.y; j++) {
	        for (var i = cellRange.min.x; i <= cellRange.max.x; i++) {
	          var coords = new leaflet.Point(i, j);
	          coords.z = this._cellZoom;
	
	          if (!this._isValidCell(coords)) {
	            continue;
	          }
	
	          var cell = this._cells[this._cellCoordsToKey(coords)];
	          if (cell) {
	            cell.current = true;
	          } else {
	            queue.push(coords);
	          }
	        }
	      }
	
	      // sort cell queue to load cells in order of their distance to center
	      queue.sort(function (a, b) {
	        return a.distanceTo(cellCenter) - b.distanceTo(cellCenter);
	      });
	
	      if (queue.length !== 0) {
	        // if it's the first batch of cells to load
	        if (!this._loading) {
	          this._loading = true;
	        }
	
	        for (i = 0; i < queue.length; i++) {
	          var _key = this._cellCoordsToKey(queue[i]);
	          var _coords = this._keyToCellCoords(_key);
	          if (this._activeCells[_coords]) {
	            this._reuseCell(queue[i]);
	          } else {
	            this._createCell(queue[i]);
	          }
	        }
	      }
	    },
	
	    _isValidCell: function (coords) {
	      var crs = this._map.options.crs;
	
	      if (!crs.infinite) {
	        // don't load cell if it's out of bounds and not wrapped
	        var bounds = this._globalCellRange;
	        if (
	          (!crs.wrapLng &&
	            (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
	          (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))
	        ) {
	          return false;
	        }
	      }
	
	      if (!this.options.bounds) {
	        return true;
	      }
	
	      // don't load cell if it doesn't intersect the bounds in options
	      var cellBounds = this._cellCoordsToBounds(coords);
	      return leaflet.toLatLngBounds(this.options.bounds).overlaps(cellBounds);
	    },
	
	    _keyToBounds: function (key) {
	      return this._cellCoordsToBounds(this._keyToCellCoords(key));
	    },
	
	    _cellCoordsToNwSe: function (coords) {
	      var map = this._map;
	      var cellSize = this.getCellSize();
	      var nwPoint = coords.scaleBy(cellSize);
	      var sePoint = nwPoint.add(cellSize);
	      var nw = map.unproject(nwPoint, coords.z);
	      var se = map.unproject(sePoint, coords.z);
	
	      return [nw, se];
	    },
	
	    // converts cell coordinates to its geographical bounds
	    _cellCoordsToBounds: function (coords) {
	      var bp = this._cellCoordsToNwSe(coords);
	      var bounds = new leaflet.LatLngBounds(bp[0], bp[1]);
	
	      if (!this.options.noWrap) {
	        bounds = this._map.wrapLatLngBounds(bounds);
	      }
	      return bounds;
	    },
	    // converts cell coordinates to key for the cell cache
	    _cellCoordsToKey: function (coords) {
	      return coords.x + ':' + coords.y + ':' + coords.z;
	    },
	
	    // converts cell cache key to coordinates
	    _keyToCellCoords: function (key) {
	      var k = key.split(':');
	      var coords = new leaflet.Point(+k[0], +k[1]);
	
	      coords.z = +k[2];
	      return coords;
	    },
	
	    _removeCell: function (key) {
	      var cell = this._cells[key];
	
	      if (!cell) {
	        return;
	      }
	
	      var coords = this._keyToCellCoords(key);
	      var wrappedCoords = this._wrapCoords(coords);
	      var cellBounds = this._cellCoordsToBounds(this._wrapCoords(coords));
	
	      cell.current = false;
	
	      delete this._cells[key];
	      this._activeCells[key] = cell;
	
	      this.cellLeave(cellBounds, wrappedCoords, key);
	
	      this.fire('cellleave', {
	        key: key,
	        coords: wrappedCoords,
	        bounds: cellBounds
	      });
	    },
	
	    _reuseCell: function (coords) {
	      var key = this._cellCoordsToKey(coords);
	
	      // save cell in cache
	      this._cells[key] = this._activeCells[key];
	      this._cells[key].current = true;
	
	      var wrappedCoords = this._wrapCoords(coords);
	      var cellBounds = this._cellCoordsToBounds(this._wrapCoords(coords));
	
	      this.cellEnter(cellBounds, wrappedCoords, key);
	
	      this.fire('cellenter', {
	        key: key,
	        coords: wrappedCoords,
	        bounds: cellBounds
	      });
	    },
	
	    _createCell: function (coords) {
	      var key = this._cellCoordsToKey(coords);
	
	      var wrappedCoords = this._wrapCoords(coords);
	      var cellBounds = this._cellCoordsToBounds(this._wrapCoords(coords));
	
	      this.createCell(cellBounds, wrappedCoords, key);
	
	      this.fire('cellcreate', {
	        key: key,
	        coords: wrappedCoords,
	        bounds: cellBounds
	      });
	
	      // save cell in cache
	      this._cells[key] = {
	        coords: coords,
	        current: true
	      };
	
	      leaflet.Util.requestAnimFrame(this._pruneCells, this);
	    },
	
	    _cellReady: function (coords, err, cell) {
	      var key = this._cellCoordsToKey(coords);
	
	      cell = this._cells[key];
	
	      if (!cell) {
	        return;
	      }
	
	      cell.loaded = +new Date();
	
	      cell.active = true;
	    },
	
	    _getCellPos: function (coords) {
	      return coords.scaleBy(this.getCellSize());
	    },
	
	    _wrapCoords: function (coords) {
	      var newCoords = new leaflet.Point(
	        this._wrapX ? leaflet.Util.wrapNum(coords.x, this._wrapX) : coords.x,
	        this._wrapY ? leaflet.Util.wrapNum(coords.y, this._wrapY) : coords.y
	      );
	      newCoords.z = coords.z;
	      return newCoords;
	    },
	
	    _pxBoundsToCellRange: function (bounds) {
	      var cellSize = this.getCellSize();
	      return new leaflet.Bounds(
	        bounds.min.unscaleBy(cellSize).floor(),
	        bounds.max.unscaleBy(cellSize).ceil().subtract([1, 1])
	      );
	    }
	  });
	
	  function BinarySearchIndex (values) {
	    this.values = [].concat(values || []);
	  }
	
	  BinarySearchIndex.prototype.query = function (value) {
	    var index = this.getIndex(value);
	    return this.values[index];
	  };
	
	  BinarySearchIndex.prototype.getIndex = function getIndex (value) {
	    if (this.dirty) {
	      this.sort();
	    }
	
	    var minIndex = 0;
	    var maxIndex = this.values.length - 1;
	    var currentIndex;
	    var currentElement;
	
	    while (minIndex <= maxIndex) {
	      currentIndex = (minIndex + maxIndex) / 2 | 0;
	      currentElement = this.values[Math.round(currentIndex)];
	      if (+currentElement.value < +value) {
	        minIndex = currentIndex + 1;
	      } else if (+currentElement.value > +value) {
	        maxIndex = currentIndex - 1;
	      } else {
	        return currentIndex;
	      }
	    }
	
	    return Math.abs(~maxIndex);
	  };
	
	  BinarySearchIndex.prototype.between = function between (start, end) {
	    var startIndex = this.getIndex(start);
	    var endIndex = this.getIndex(end);
	
	    if (startIndex === 0 && endIndex === 0) {
	      return [];
	    }
	
	    while (this.values[startIndex - 1] && this.values[startIndex - 1].value === start) {
	      startIndex--;
	    }
	
	    while (this.values[endIndex + 1] && this.values[endIndex + 1].value === end) {
	      endIndex++;
	    }
	
	    if (this.values[endIndex] && this.values[endIndex].value === end && this.values[endIndex + 1]) {
	      endIndex++;
	    }
	
	    return this.values.slice(startIndex, endIndex);
	  };
	
	  BinarySearchIndex.prototype.insert = function insert (item) {
	    this.values.splice(this.getIndex(item.value), 0, item);
	    return this;
	  };
	
	  BinarySearchIndex.prototype.bulkAdd = function bulkAdd (items, sort) {
	    this.values = this.values.concat([].concat(items || []));
	
	    if (sort) {
	      this.sort();
	    } else {
	      this.dirty = true;
	    }
	
	    return this;
	  };
	
	  BinarySearchIndex.prototype.sort = function sort () {
	    this.values.sort(function (a, b) {
	      return +b.value - +a.value;
	    }).reverse();
	    this.dirty = false;
	    return this;
	  };
	
	  var FeatureManager = FeatureGrid.extend({
	    /**
	     * Options
	     */
	
	    options: {
	      attribution: null,
	      where: '1=1',
	      fields: ['*'],
	      from: false,
	      to: false,
	      timeField: false,
	      timeFilterMode: 'server',
	      simplifyFactor: 0,
	      precision: 6,
	      fetchAllFeatures: false
	    },
	
	    /**
	     * Constructor
	     */
	
	    initialize: function (options) {
	      FeatureGrid.prototype.initialize.call(this, options);
	
	      options = getUrlParams(options);
	      options = leaflet.Util.setOptions(this, options);
	
	      this.service = featureLayerService(options);
	      this.service.addEventParent(this);
	
	      // use case insensitive regex to look for common fieldnames used for indexing
	      if (this.options.fields[0] !== '*') {
	        var oidCheck = false;
	        for (var i = 0; i < this.options.fields.length; i++) {
	          if (this.options.fields[i].match(/^(OBJECTID|FID|OID|ID)$/i)) {
	            oidCheck = true;
	          }
	        }
	        if (oidCheck === false) {
	          warn(
	            'no known esriFieldTypeOID field detected in fields Array.  Please add an attribute field containing unique IDs to ensure the layer can be drawn correctly.'
	          );
	        }
	      }
	
	      if (this.options.timeField.start && this.options.timeField.end) {
	        this._startTimeIndex = new BinarySearchIndex();
	        this._endTimeIndex = new BinarySearchIndex();
	      } else if (this.options.timeField) {
	        this._timeIndex = new BinarySearchIndex();
	      }
	
	      this._cache = {};
	      this._currentSnapshot = []; // cache of what layers should be active
	      this._activeRequests = 0;
	    },
	
	    /**
	     * Layer Interface
	     */
	
	    onAdd: function (map) {
	      // include 'Powered by Esri' in map attribution
	      setEsriAttribution(map);
	
	      this.service.metadata(function (err, metadata) {
	        if (!err) {
	          var supportedFormats = metadata.supportedQueryFormats;
	
	          // Check if someone has requested that we don't use geoJSON, even if it's available
	          var forceJsonFormat = false;
	          if (this.service.options.isModern === false || this.options.fetchAllFeatures) {
	            forceJsonFormat = true;
	          }
	
	          // Unless we've been told otherwise, check to see whether service can emit GeoJSON natively
	          if (
	            !forceJsonFormat &&
	            supportedFormats &&
	            supportedFormats.indexOf('geoJSON') !== -1
	          ) {
	            this.service.options.isModern = true;
	          }
	
	          if (metadata.objectIdField) {
	            this.service.options.idAttribute = metadata.objectIdField;
	          }
	
	          // add copyright text listed in service metadata
	          if (
	            !this.options.attribution &&
	            map.attributionControl &&
	            metadata.copyrightText
	          ) {
	            this.options.attribution = metadata.copyrightText;
	            map.attributionControl.addAttribution(this.getAttribution());
	          }
	        }
	      }, this);
	
	      map.on('zoomend', this._handleZoomChange, this);
	
	      return FeatureGrid.prototype.onAdd.call(this, map);
	    },
	
	    onRemove: function (map) {
	      removeEsriAttribution(map);
	      map.off('zoomend', this._handleZoomChange, this);
	
	      return FeatureGrid.prototype.onRemove.call(this, map);
	    },
	
	    getAttribution: function () {
	      return this.options.attribution;
	    },
	
	    /**
	     * Feature Management
	     */
	
	    createCell: function (bounds, coords) {
	      // dont fetch features outside the scale range defined for the layer
	      if (this._visibleZoom()) {
	        this._requestFeatures(bounds, coords);
	      }
	    },
	
	    _requestFeatures: function (bounds, coords, callback, offset) {
	      this._activeRequests++;
	
	      // default param
	      offset = offset || 0;
	
	      var originalWhere = this.options.where;
	
	      // our first active request fires loading
	      if (this._activeRequests === 1) {
	        this.fire(
	          'loading',
	          {
	            bounds: bounds
	          },
	          true
	        );
	      }
	
	      return this._buildQuery(bounds, offset).run(function (
	        error,
	        featureCollection,
	        response
	      ) {
	        if (response && response.exceededTransferLimit) {
	          this.fire('drawlimitexceeded');
	        }
	
	        // the where changed while this request was being run so don't it.
	        if (this.options.where !== originalWhere) {
	          return;
	        }
	
	        // no error, features
	        if (!error && featureCollection && featureCollection.features.length) {
	          // schedule adding features until the next animation frame
	          leaflet.Util.requestAnimFrame(
	            leaflet.Util.bind(function () {
	              this._addFeatures(featureCollection.features, coords);
	              this._postProcessFeatures(bounds);
	            }, this)
	          );
	        }
	
	        // no error, no features
	        if (!error && featureCollection && !featureCollection.features.length) {
	          this._postProcessFeatures(bounds);
	        }
	
	        if (error) {
	          this._postProcessFeatures(bounds);
	        }
	
	        if (callback) {
	          callback.call(this, error, featureCollection);
	        }
	        if (response && (response.exceededTransferLimit || (response.properties && response.properties.exceededTransferLimit)) && this.options.fetchAllFeatures) {
	          this._requestFeatures(bounds, coords, callback, offset + featureCollection.features.length);
	        }
	      },
	        this);
	    },
	
	    _postProcessFeatures: function (bounds) {
	      // deincrement the request counter now that we have processed features
	      this._activeRequests--;
	
	      // if there are no more active requests fire a load event for this view
	      if (this._activeRequests <= 0) {
	        this.fire('load', {
	          bounds: bounds
	        });
	      }
	    },
	
	    _cacheKey: function (coords) {
	      return coords.z + ':' + coords.x + ':' + coords.y;
	    },
	
	    _addFeatures: function (features, coords) {
	      // coords is optional - will be false if coming from addFeatures() function
	      if (coords) {
	        var key = this._cacheKey(coords);
	        this._cache[key] = this._cache[key] || [];
	      }
	
	      for (var i = features.length - 1; i >= 0; i--) {
	        var id = features[i].id;
	
	        if (this._currentSnapshot.indexOf(id) === -1) {
	          this._currentSnapshot.push(id);
	        }
	        if (typeof key !== 'undefined' && this._cache[key].indexOf(id) === -1) {
	          this._cache[key].push(id);
	        }
	      }
	
	      if (this.options.timeField) {
	        this._buildTimeIndexes(features);
	      }
	
	      this.createLayers(features);
	    },
	
	    _buildQuery: function (bounds, offset) {
	      var query = this.service
	        .query()
	        .intersects(bounds)
	        .where(this.options.where)
	        .fields(this.options.fields)
	        .precision(this.options.precision);
	
	      if (this.options.fetchAllFeatures && !isNaN(parseInt(offset))) {
	        query = query.offset(offset);
	      }
	
	      query.params['resultType'] = 'tile';
	
	      if (this.options.requestParams) {
	        leaflet.Util.extend(query.params, this.options.requestParams);
	      }
	
	      if (this.options.simplifyFactor) {
	        query.simplify(this._map, this.options.simplifyFactor);
	      }
	
	      if (
	        this.options.timeFilterMode === 'server' &&
	        this.options.from &&
	        this.options.to
	      ) {
	        query.between(this.options.from, this.options.to);
	      }
	
	      return query;
	    },
	
	    /**
	     * Where Methods
	     */
	
	    setWhere: function (where, callback, context) {
	      this.options.where = where && where.length ? where : '1=1';
	
	      var oldSnapshot = [];
	      var newSnapshot = [];
	      var pendingRequests = 0;
	      var requestError = null;
	      var requestCallback = leaflet.Util.bind(function (error, featureCollection) {
	        if (error) {
	          requestError = error;
	        }
	
	        if (featureCollection) {
	          for (var i = featureCollection.features.length - 1; i >= 0; i--) {
	            newSnapshot.push(featureCollection.features[i].id);
	          }
	        }
	
	        pendingRequests--;
	
	        if (
	          pendingRequests <= 0 &&
	          this._visibleZoom() &&
	          where === this.options.where // the where is still the same so use this one
	        ) {
	          this._currentSnapshot = newSnapshot;
	          // schedule adding features for the next animation frame
	          leaflet.Util.requestAnimFrame(
	            leaflet.Util.bind(function () {
	              this.removeLayers(oldSnapshot);
	              this.addLayers(newSnapshot);
	              if (callback) {
	                callback.call(context, requestError);
	              }
	            }, this)
	          );
	        }
	      }, this);
	
	      for (var i = this._currentSnapshot.length - 1; i >= 0; i--) {
	        oldSnapshot.push(this._currentSnapshot[i]);
	      }
	
	      this._cache = {};
	
	      for (var key in this._cells) {
	        pendingRequests++;
	        var coords = this._keyToCellCoords(key);
	        var bounds = this._cellCoordsToBounds(coords);
	        this._requestFeatures(bounds, coords, requestCallback);
	      }
	
	      return this;
	    },
	
	    getWhere: function () {
	      return this.options.where;
	    },
	
	    /**
	     * Time Range Methods
	     */
	
	    getTimeRange: function () {
	      return [this.options.from, this.options.to];
	    },
	
	    setTimeRange: function (from, to, callback, context) {
	      var oldFrom = this.options.from;
	      var oldTo = this.options.to;
	      var pendingRequests = 0;
	      var requestError = null;
	      var requestCallback = leaflet.Util.bind(function (error) {
	        if (error) {
	          requestError = error;
	        }
	        this._filterExistingFeatures(oldFrom, oldTo, from, to);
	
	        pendingRequests--;
	
	        if (callback && pendingRequests <= 0) {
	          callback.call(context, requestError);
	        }
	      }, this);
	
	      this.options.from = from;
	      this.options.to = to;
	
	      this._filterExistingFeatures(oldFrom, oldTo, from, to);
	
	      if (this.options.timeFilterMode === 'server') {
	        for (var key in this._cells) {
	          pendingRequests++;
	          var coords = this._keyToCellCoords(key);
	          var bounds = this._cellCoordsToBounds(coords);
	          this._requestFeatures(bounds, coords, requestCallback);
	        }
	      }
	
	      return this;
	    },
	
	    refresh: function () {
	      this.setWhere(this.options.where);
	    },
	
	    _filterExistingFeatures: function (oldFrom, oldTo, newFrom, newTo) {
	      var layersToRemove =
	        oldFrom && oldTo
	          ? this._getFeaturesInTimeRange(oldFrom, oldTo)
	          : this._currentSnapshot;
	      var layersToAdd = this._getFeaturesInTimeRange(newFrom, newTo);
	
	      if (layersToAdd.indexOf) {
	        for (var i = 0; i < layersToAdd.length; i++) {
	          var shouldRemoveLayer = layersToRemove.indexOf(layersToAdd[i]);
	          if (shouldRemoveLayer >= 0) {
	            layersToRemove.splice(shouldRemoveLayer, 1);
	          }
	        }
	      }
	
	      // schedule adding features until the next animation frame
	      leaflet.Util.requestAnimFrame(
	        leaflet.Util.bind(function () {
	          this.removeLayers(layersToRemove);
	          this.addLayers(layersToAdd);
	        }, this)
	      );
	    },
	
	    _getFeaturesInTimeRange: function (start, end) {
	      var ids = [];
	      var search;
	
	      if (this.options.timeField.start && this.options.timeField.end) {
	        var startTimes = this._startTimeIndex.between(start, end);
	        var endTimes = this._endTimeIndex.between(start, end);
	        search = startTimes.concat(endTimes);
	      } else if (this._timeIndex) {
	        search = this._timeIndex.between(start, end);
	      } else {
	        warn(
	          'You must set timeField in the layer constructor in order to manipulate the start and end time filter.'
	        );
	        return [];
	      }
	
	      for (var i = search.length - 1; i >= 0; i--) {
	        ids.push(search[i].id);
	      }
	
	      return ids;
	    },
	
	    _buildTimeIndexes: function (geojson) {
	      var i;
	      var feature;
	      if (this.options.timeField.start && this.options.timeField.end) {
	        var startTimeEntries = [];
	        var endTimeEntries = [];
	        for (i = geojson.length - 1; i >= 0; i--) {
	          feature = geojson[i];
	          startTimeEntries.push({
	            id: feature.id,
	            value: new Date(feature.properties[this.options.timeField.start])
	          });
	          endTimeEntries.push({
	            id: feature.id,
	            value: new Date(feature.properties[this.options.timeField.end])
	          });
	        }
	        this._startTimeIndex.bulkAdd(startTimeEntries);
	        this._endTimeIndex.bulkAdd(endTimeEntries);
	      } else {
	        var timeEntries = [];
	        for (i = geojson.length - 1; i >= 0; i--) {
	          feature = geojson[i];
	          timeEntries.push({
	            id: feature.id,
	            value: new Date(feature.properties[this.options.timeField])
	          });
	        }
	
	        this._timeIndex.bulkAdd(timeEntries);
	      }
	    },
	
	    _featureWithinTimeRange: function (feature) {
	      if (!this.options.from || !this.options.to) {
	        return true;
	      }
	
	      var from = +this.options.from.valueOf();
	      var to = +this.options.to.valueOf();
	
	      if (typeof this.options.timeField === 'string') {
	        var date = +feature.properties[this.options.timeField];
	        return date >= from && date <= to;
	      }
	
	      if (this.options.timeField.start && this.options.timeField.end) {
	        var startDate = +feature.properties[this.options.timeField.start];
	        var endDate = +feature.properties[this.options.timeField.end];
	        return (
	          (startDate >= from && startDate <= to) ||
	          (endDate >= from && endDate <= to) ||
	          (startDate <= from && endDate >= to)
	        );
	      }
	    },
	
	    _visibleZoom: function () {
	      // check to see whether the current zoom level of the map is within the optional limit defined for the FeatureLayer
	      if (!this._map) {
	        return false;
	      }
	      var zoom = this._map.getZoom();
	      if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	
	    _handleZoomChange: function () {
	      if (!this._visibleZoom()) {
	        this.removeLayers(this._currentSnapshot);
	      } else {
	        /*
	        for every cell in this._cells
	          1. Get the cache key for the coords of the cell
	          2. If this._cache[key] exists it will be an array of feature IDs.
	          3. Call this.addLayers(this._cache[key]) to instruct the feature layer to add the layers back.
	        */
	        for (var i in this._cells) {
	          var coords = this._cells[i].coords;
	          var key = this._cacheKey(coords);
	          if (this._cache[key]) {
	            this.addLayers(this._cache[key]);
	          }
	        }
	      }
	    },
	
	    /**
	     * Service Methods
	     */
	
	    authenticate: function (token) {
	      this.service.authenticate(token);
	      return this;
	    },
	
	    metadata: function (callback, context) {
	      this.service.metadata(callback, context);
	      return this;
	    },
	
	    query: function () {
	      return this.service.query();
	    },
	
	    _getMetadata: function (callback) {
	      if (this._metadata) {
	        var error;
	        callback(error, this._metadata);
	      } else {
	        this.metadata(
	          leaflet.Util.bind(function (error, response) {
	            this._metadata = response;
	            callback(error, this._metadata);
	          }, this)
	        );
	      }
	    },
	
	    addFeature: function (feature, callback, context) {
	      this.addFeatures(feature, callback, context);
	    },
	
	    addFeatures: function (features, callback, context) {
	      this._getMetadata(
	        leaflet.Util.bind(function (error, metadata) {
	          if (error) {
	            if (callback) {
	              callback.call(this, error, null);
	            }
	            return;
	          }
	          // GeoJSON featureCollection or simple feature
	          var featuresArray = features.features ? features.features : [features];
	
	          this.service.addFeatures(
	            features,
	            leaflet.Util.bind(function (error, response) {
	              if (!error) {
	                for (var i = featuresArray.length - 1; i >= 0; i--) {
	                  // assign ID from result to appropriate objectid field from service metadata
	                  featuresArray[i].properties[metadata.objectIdField] =
	                    featuresArray.length > 1
	                      ? response[i].objectId
	                      : response.objectId;
	                  // we also need to update the geojson id for createLayers() to function
	                  featuresArray[i].id =
	                    featuresArray.length > 1
	                      ? response[i].objectId
	                      : response.objectId;
	                }
	                this._addFeatures(featuresArray);
	              }
	
	              if (callback) {
	                callback.call(context, error, response);
	              }
	            }, this)
	          );
	        }, this)
	      );
	    },
	
	    updateFeature: function (feature, callback, context) {
	      this.updateFeatures(feature, callback, context);
	    },
	
	    updateFeatures: function (features, callback, context) {
	      // GeoJSON featureCollection or simple feature
	      var featuresArray = features.features ? features.features : [features];
	      this.service.updateFeatures(
	        features,
	        function (error, response) {
	          if (!error) {
	            for (var i = featuresArray.length - 1; i >= 0; i--) {
	              this.removeLayers([featuresArray[i].id], true);
	            }
	            this._addFeatures(featuresArray);
	          }
	
	          if (callback) {
	            callback.call(context, error, response);
	          }
	        },
	        this
	      );
	    },
	
	    deleteFeature: function (id, callback, context) {
	      this.deleteFeatures(id, callback, context);
	    },
	
	    deleteFeatures: function (ids, callback, context) {
	      return this.service.deleteFeatures(
	        ids,
	        function (error, response) {
	          var responseArray = response.length ? response : [response];
	          if (!error && responseArray.length > 0) {
	            for (var i = responseArray.length - 1; i >= 0; i--) {
	              this.removeLayers([responseArray[i].objectId], true);
	            }
	          }
	          if (callback) {
	            callback.call(context, error, response);
	          }
	        },
	        this
	      );
	    }
	  });
	
	  var FeatureLayer = FeatureManager.extend({
	
	    options: {
	      cacheLayers: true
	    },
	
	    /**
	     * Constructor
	     */
	    initialize: function (options) {
	      FeatureManager.prototype.initialize.call(this, options);
	      this._originalStyle = this.options.style;
	      this._layers = {};
	    },
	
	    /**
	     * Layer Interface
	     */
	
	    onRemove: function (map) {
	      for (var i in this._layers) {
	        map.removeLayer(this._layers[i]);
	        // trigger the event when the entire featureLayer is removed from the map
	        this.fire('removefeature', {
	          feature: this._layers[i].feature,
	          permanent: false
	        }, true);
	      }
	
	      return FeatureManager.prototype.onRemove.call(this, map);
	    },
	
	    createNewLayer: function (geojson) {
	      var layer = leaflet.GeoJSON.geometryToLayer(geojson, this.options);
	      // trap for GeoJSON without geometry
	      if (layer) {
	        layer.defaultOptions = layer.options;
	      }
	      return layer;
	    },
	
	    _updateLayer: function (layer, geojson) {
	      // convert the geojson coordinates into a Leaflet LatLng array/nested arrays
	      // pass it to setLatLngs to update layer geometries
	      var latlngs = [];
	      var coordsToLatLng = this.options.coordsToLatLng || leaflet.GeoJSON.coordsToLatLng;
	
	      // copy new attributes, if present
	      if (geojson.properties) {
	        layer.feature.properties = geojson.properties;
	      }
	
	      switch (geojson.geometry.type) {
	        case 'Point':
	          latlngs = leaflet.GeoJSON.coordsToLatLng(geojson.geometry.coordinates);
	          layer.setLatLng(latlngs);
	          break;
	        case 'LineString':
	          latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 0, coordsToLatLng);
	          layer.setLatLngs(latlngs);
	          break;
	        case 'MultiLineString':
	          latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 1, coordsToLatLng);
	          layer.setLatLngs(latlngs);
	          break;
	        case 'Polygon':
	          latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 1, coordsToLatLng);
	          layer.setLatLngs(latlngs);
	          break;
	        case 'MultiPolygon':
	          latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 2, coordsToLatLng);
	          layer.setLatLngs(latlngs);
	          break;
	      }
	    },
	
	    /**
	     * Feature Management Methods
	     */
	
	    createLayers: function (features) {
	      for (var i = features.length - 1; i >= 0; i--) {
	        var geojson = features[i];
	
	        var layer = this._layers[geojson.id];
	        var newLayer;
	
	        if (this._visibleZoom() && layer && !this._map.hasLayer(layer) && (!this.options.timeField || this._featureWithinTimeRange(geojson))) {
	          this._map.addLayer(layer);
	          this.fire('addfeature', {
	            feature: layer.feature
	          }, true);
	        }
	
	        // update geometry if necessary
	        if (layer && this.options.simplifyFactor > 0 && (layer.setLatLngs || layer.setLatLng)) {
	          this._updateLayer(layer, geojson);
	        }
	
	        if (!layer) {
	          newLayer = this.createNewLayer(geojson);
	
	          if (!newLayer) {
	            warn('invalid GeoJSON encountered');
	          } else {
	            newLayer.feature = geojson;
	
	            // bubble events from individual layers to the feature layer
	            newLayer.addEventParent(this);
	
	            if (this.options.onEachFeature) {
	              this.options.onEachFeature(newLayer.feature, newLayer);
	            }
	
	            // cache the layer
	            this._layers[newLayer.feature.id] = newLayer;
	
	            // style the layer
	            this.setFeatureStyle(newLayer.feature.id, this.options.style);
	
	            this.fire('createfeature', {
	              feature: newLayer.feature
	            }, true);
	
	            // add the layer if the current zoom level is inside the range defined for the layer, it is within the current time bounds or our layer is not time enabled
	            if (this._visibleZoom() && (!this.options.timeField || (this.options.timeField && this._featureWithinTimeRange(geojson)))) {
	              this._map.addLayer(newLayer);
	            }
	          }
	        }
	      }
	    },
	
	    addLayers: function (ids) {
	      for (var i = ids.length - 1; i >= 0; i--) {
	        var layer = this._layers[ids[i]];
	        if (layer && (!this.options.timeField || this._featureWithinTimeRange(layer.feature))) {
	          this._map.addLayer(layer);
	        }
	      }
	    },
	
	    removeLayers: function (ids, permanent) {
	      for (var i = ids.length - 1; i >= 0; i--) {
	        var id = ids[i];
	        var layer = this._layers[id];
	        if (layer) {
	          this.fire('removefeature', {
	            feature: layer.feature,
	            permanent: permanent
	          }, true);
	          this._map.removeLayer(layer);
	        }
	        if (layer && permanent) {
	          delete this._layers[id];
	        }
	      }
	    },
	
	    cellEnter: function (bounds, coords) {
	      if (this._visibleZoom() && !this._zooming && this._map) {
	        leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
	          var cacheKey = this._cacheKey(coords);
	          var cellKey = this._cellCoordsToKey(coords);
	          var layers = this._cache[cacheKey];
	          if (this._activeCells[cellKey] && layers) {
	            this.addLayers(layers);
	          }
	        }, this));
	      }
	    },
	
	    cellLeave: function (bounds, coords) {
	      if (!this._zooming) {
	        leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
	          if (this._map) {
	            var cacheKey = this._cacheKey(coords);
	            var cellKey = this._cellCoordsToKey(coords);
	            var layers = this._cache[cacheKey];
	            var mapBounds = this._map.getBounds();
	            if (!this._activeCells[cellKey] && layers) {
	              var removable = true;
	
	              for (var i = 0; i < layers.length; i++) {
	                var layer = this._layers[layers[i]];
	                if (layer && layer.getBounds && mapBounds.intersects(layer.getBounds())) {
	                  removable = false;
	                }
	              }
	
	              if (removable) {
	                this.removeLayers(layers, !this.options.cacheLayers);
	              }
	
	              if (!this.options.cacheLayers && removable) {
	                delete this._cache[cacheKey];
	                delete this._cells[cellKey];
	                delete this._activeCells[cellKey];
	              }
	            }
	          }
	        }, this));
	      }
	    },
	
	    /**
	     * Styling Methods
	     */
	
	    resetStyle: function () {
	      this.options.style = this._originalStyle;
	      this.eachFeature(function (layer) {
	        this.resetFeatureStyle(layer.feature.id);
	      }, this);
	      return this;
	    },
	
	    setStyle: function (style) {
	      this.options.style = style;
	      this.eachFeature(function (layer) {
	        this.setFeatureStyle(layer.feature.id, style);
	      }, this);
	      return this;
	    },
	
	    resetFeatureStyle: function (id) {
	      var layer = this._layers[id];
	      var style = this._originalStyle || leaflet.Path.prototype.options;
	      if (layer) {
	        leaflet.Util.extend(layer.options, layer.defaultOptions);
	        this.setFeatureStyle(id, style);
	      }
	      return this;
	    },
	
	    setFeatureStyle: function (id, style) {
	      var layer = this._layers[id];
	      if (typeof style === 'function') {
	        style = style(layer.feature);
	      }
	      if (layer.setStyle) {
	        layer.setStyle(style);
	      }
	      return this;
	    },
	
	    /**
	     * Utility Methods
	     */
	
	    eachActiveFeature: function (fn, context) {
	      // figure out (roughly) which layers are in view
	      if (this._map) {
	        var activeBounds = this._map.getBounds();
	        for (var i in this._layers) {
	          if (this._currentSnapshot.indexOf(this._layers[i].feature.id) !== -1) {
	            // a simple point in poly test for point geometries
	            if (typeof this._layers[i].getLatLng === 'function' && activeBounds.contains(this._layers[i].getLatLng())) {
	              fn.call(context, this._layers[i]);
	            } else if (typeof this._layers[i].getBounds === 'function' && activeBounds.intersects(this._layers[i].getBounds())) {
	              // intersecting bounds check for polyline and polygon geometries
	              fn.call(context, this._layers[i]);
	            }
	          }
	        }
	      }
	      return this;
	    },
	
	    eachFeature: function (fn, context) {
	      for (var i in this._layers) {
	        fn.call(context, this._layers[i]);
	      }
	      return this;
	    },
	
	    getFeature: function (id) {
	      return this._layers[id];
	    },
	
	    bringToBack: function () {
	      this.eachFeature(function (layer) {
	        if (layer.bringToBack) {
	          layer.bringToBack();
	        }
	      });
	    },
	
	    bringToFront: function () {
	      this.eachFeature(function (layer) {
	        if (layer.bringToFront) {
	          layer.bringToFront();
	        }
	      });
	    },
	
	    redraw: function (id) {
	      if (id) {
	        this._redraw(id);
	      }
	      return this;
	    },
	
	    _redraw: function (id) {
	      var layer = this._layers[id];
	      var geojson = layer.feature;
	
	      // if this looks like a marker
	      if (layer && layer.setIcon && this.options.pointToLayer) {
	        // update custom symbology, if necessary
	        if (this.options.pointToLayer) {
	          var getIcon = this.options.pointToLayer(geojson, leaflet.latLng(geojson.geometry.coordinates[1], geojson.geometry.coordinates[0]));
	          var updatedIcon = getIcon.options.icon;
	          layer.setIcon(updatedIcon);
	        }
	      }
	
	      // looks like a vector marker (circleMarker)
	      if (layer && layer.setStyle && this.options.pointToLayer) {
	        var getStyle = this.options.pointToLayer(geojson, leaflet.latLng(geojson.geometry.coordinates[1], geojson.geometry.coordinates[0]));
	        var updatedStyle = getStyle.options;
	        this.setFeatureStyle(geojson.id, updatedStyle);
	      }
	
	      // looks like a path (polygon/polyline)
	      if (layer && layer.setStyle && this.options.style) {
	        this.resetStyle(geojson.id);
	      }
	    }
	  });
	
	  function featureLayer (options) {
	    return new FeatureLayer(options);
	  }
	
	  exports.BasemapLayer = BasemapLayer;
	  exports.DynamicMapLayer = DynamicMapLayer;
	  exports.FeatureLayer = FeatureLayer;
	  exports.FeatureLayerService = FeatureLayerService;
	  exports.FeatureManager = FeatureManager;
	  exports.Find = Find;
	  exports.Identify = Identify;
	  exports.IdentifyFeatures = IdentifyFeatures;
	  exports.IdentifyImage = IdentifyImage;
	  exports.ImageMapLayer = ImageMapLayer;
	  exports.ImageService = ImageService;
	  exports.MapService = MapService;
	  exports.Query = Query;
	  exports.RasterLayer = RasterLayer;
	  exports.Service = Service;
	  exports.Support = Support;
	  exports.Task = Task;
	  exports.TiledMapLayer = TiledMapLayer;
	  exports.Util = EsriUtil;
	  exports.VERSION = version;
	  exports.basemapLayer = basemapLayer;
	  exports.dynamicMapLayer = dynamicMapLayer;
	  exports.featureLayer = featureLayer;
	  exports.featureLayerService = featureLayerService;
	  exports.find = find;
	  exports.get = get;
	  exports.identify = identify;
	  exports.identifyFeatures = identifyFeatures;
	  exports.identifyImage = identifyImage;
	  exports.imageMapLayer = imageMapLayer;
	  exports.imageService = imageService;
	  exports.mapService = mapService;
	  exports.options = options;
	  exports.post = xmlHttpPost;
	  exports.query = query;
	  exports.request = request;
	  exports.service = service;
	  exports.task = task;
	  exports.tiledMapLayer = tiledMapLayer;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=esri-leaflet-debug.js.map


/***/ },
/* 290 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(290);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(300);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var createArrayFromMixed = __webpack_require__(293);
	var getMarkupWrap = __webpack_require__(295);
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 296 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 297 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(297);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(299);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 301 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(488)),valueEqual=_interopDefault(__webpack_require__(862));__webpack_require__(490);var invariant=_interopDefault(__webpack_require__(489));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ },
/* 305 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(160);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(160);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(162);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(438);
	var assign = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(162);
	var checkPropTypes = __webpack_require__(308);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(179);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(40);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(163);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(58);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(317);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(165);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(103);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _capitalize = __webpack_require__(181);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(71);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(74);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(225);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(101);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(204);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(326);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(327);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(103);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(332);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(333);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(40);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(168);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(104);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(104);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(80);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(277);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(44);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(152);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(439);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(207);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(72);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(169);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(345);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(170);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(171);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(172);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(74);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(71);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(74);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(83);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(167);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(175);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(348);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(349);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(350);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(102);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(45);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(176);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(177);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(372);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(177);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(178);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(40);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(102);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(81);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(40);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(58);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(71);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(363);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(74);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(166);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(105);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(106);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(180);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(81);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(83);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(173);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(174);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(105);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(106);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(28);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(81);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(9);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(82);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(20);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 371 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(84);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(9);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(17);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(20);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 374 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var focusNode = __webpack_require__(154);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(19);
	var FallbackCompositionState = __webpack_require__(382);
	var SyntheticCompositionEvent = __webpack_require__(419);
	var SyntheticInputEvent = __webpack_require__(422);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(182);
	var ExecutionEnvironment = __webpack_require__(19);
	var ReactInstrumentation = __webpack_require__(23);
	
	var camelizeStyleName = __webpack_require__(291);
	var dangerousStyleValue = __webpack_require__(428);
	var hyphenateStyleName = __webpack_require__(298);
	var memoizeStringOnly = __webpack_require__(301);
	var warning = __webpack_require__(12);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(29);
	var SyntheticEvent = __webpack_require__(30);
	
	var inputValueTracking = __webpack_require__(198);
	var getEventTarget = __webpack_require__(119);
	var isEventSupported = __webpack_require__(120);
	var isTextInputElement = __webpack_require__(200);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(19);
	
	var createNodesFromMarkup = __webpack_require__(294);
	var emptyFunction = __webpack_require__(26);
	var invariant = __webpack_require__(10);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 380 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(15);
	var SyntheticMouseEvent = __webpack_require__(76);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(39);
	
	var getTextContentAccessor = __webpack_require__(197);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(48);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(49);
	
	var instantiateReactComponent = __webpack_require__(199);
	var KeyEscapeUtils = __webpack_require__(111);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var traverseAllChildren = __webpack_require__(202);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/watershed","REACT_APP_PREFIX":"/watershed/"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(217);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159)))

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(107);
	var ReactDOMIDOperations = __webpack_require__(392);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var React = __webpack_require__(51);
	var ReactComponentEnvironment = __webpack_require__(113);
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactErrorUtils = __webpack_require__(114);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactNodeTypes = __webpack_require__(192);
	var ReactReconciler = __webpack_require__(49);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(99);
	var invariant = __webpack_require__(10);
	var shallowEqual = __webpack_require__(100);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var warning = __webpack_require__(12);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDefaultInjection = __webpack_require__(400);
	var ReactMount = __webpack_require__(191);
	var ReactReconciler = __webpack_require__(49);
	var ReactUpdates = __webpack_require__(29);
	var ReactVersion = __webpack_require__(413);
	
	var findDOMNode = __webpack_require__(429);
	var getHostComponentFromComposite = __webpack_require__(196);
	var renderSubtreeIntoContainer = __webpack_require__(436);
	var warning = __webpack_require__(12);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var AutoFocusUtils = __webpack_require__(375);
	var CSSPropertyOperations = __webpack_require__(377);
	var DOMLazyTree = __webpack_require__(47);
	var DOMNamespaces = __webpack_require__(108);
	var DOMProperty = __webpack_require__(48);
	var DOMPropertyOperations = __webpack_require__(184);
	var EventPluginHub = __webpack_require__(59);
	var EventPluginRegistry = __webpack_require__(109);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactDOMComponentFlags = __webpack_require__(185);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMInput = __webpack_require__(393);
	var ReactDOMOption = __webpack_require__(394);
	var ReactDOMSelect = __webpack_require__(186);
	var ReactDOMTextarea = __webpack_require__(397);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMultiChild = __webpack_require__(406);
	var ReactServerRenderingTransaction = __webpack_require__(411);
	
	var emptyFunction = __webpack_require__(26);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(10);
	var isEventSupported = __webpack_require__(120);
	var shallowEqual = __webpack_require__(100);
	var inputValueTracking = __webpack_require__(198);
	var validateDOMNesting = __webpack_require__(122);
	var warning = __webpack_require__(12);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(122);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DOMPropertyOperations = __webpack_require__(184);
	var LinkedValueUtils = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(29);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var React = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMSelect = __webpack_require__(186);
	
	var warning = __webpack_require__(12);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var getNodeForCharacterOffset = __webpack_require__(433);
	var getTextContentAccessor = __webpack_require__(197);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DOMChildrenOperations = __webpack_require__(107);
	var DOMLazyTree = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(10);
	var validateDOMNesting = __webpack_require__(122);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var LinkedValueUtils = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(29);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactUpdates = __webpack_require__(29);
	var Transaction = __webpack_require__(77);
	
	var emptyFunction = __webpack_require__(26);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(374);
	var BeforeInputEventPlugin = __webpack_require__(376);
	var ChangeEventPlugin = __webpack_require__(378);
	var DefaultEventPluginOrder = __webpack_require__(380);
	var EnterLeaveEventPlugin = __webpack_require__(381);
	var HTMLDOMPropertyConfig = __webpack_require__(383);
	var ReactComponentBrowserEnvironment = __webpack_require__(385);
	var ReactDOMComponent = __webpack_require__(388);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMEmptyComponent = __webpack_require__(390);
	var ReactDOMTreeTraversal = __webpack_require__(398);
	var ReactDOMTextComponent = __webpack_require__(396);
	var ReactDefaultBatchingStrategy = __webpack_require__(399);
	var ReactEventListener = __webpack_require__(403);
	var ReactInjection = __webpack_require__(404);
	var ReactReconcileTransaction = __webpack_require__(409);
	var SVGDOMPropertyConfig = __webpack_require__(414);
	var SelectEventPlugin = __webpack_require__(415);
	var SimpleEventPlugin = __webpack_require__(416);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 401 */
218,
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventListener = __webpack_require__(153);
	var ExecutionEnvironment = __webpack_require__(19);
	var PooledClass = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(29);
	
	var getEventTarget = __webpack_require__(119);
	var getUnboundedScrollPosition = __webpack_require__(296);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(48);
	var EventPluginHub = __webpack_require__(59);
	var EventPluginUtils = __webpack_require__(110);
	var ReactComponentEnvironment = __webpack_require__(113);
	var ReactEmptyComponent = __webpack_require__(187);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactHostComponent = __webpack_require__(189);
	var ReactUpdates = __webpack_require__(29);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(427);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactComponentEnvironment = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactReconciler = __webpack_require__(49);
	var ReactChildReconciler = __webpack_require__(384);
	
	var emptyFunction = __webpack_require__(26);
	var flattenChildren = __webpack_require__(430);
	var invariant = __webpack_require__(10);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 408 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(183);
	var PooledClass = __webpack_require__(39);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactInputSelection = __webpack_require__(190);
	var ReactInstrumentation = __webpack_require__(23);
	var Transaction = __webpack_require__(77);
	var ReactUpdateQueue = __webpack_require__(115);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(407);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(39);
	var Transaction = __webpack_require__(77);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactServerUpdateQueue = __webpack_require__(412);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(115);
	
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 413 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 414 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInputSelection = __webpack_require__(190);
	var SyntheticEvent = __webpack_require__(30);
	
	var getActiveElement = __webpack_require__(155);
	var isTextInputElement = __webpack_require__(200);
	var shallowEqual = __webpack_require__(100);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventListener = __webpack_require__(153);
	var EventPropagators = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(15);
	var SyntheticAnimationEvent = __webpack_require__(417);
	var SyntheticClipboardEvent = __webpack_require__(418);
	var SyntheticEvent = __webpack_require__(30);
	var SyntheticFocusEvent = __webpack_require__(421);
	var SyntheticKeyboardEvent = __webpack_require__(423);
	var SyntheticMouseEvent = __webpack_require__(76);
	var SyntheticDragEvent = __webpack_require__(420);
	var SyntheticTouchEvent = __webpack_require__(424);
	var SyntheticTransitionEvent = __webpack_require__(425);
	var SyntheticUIEvent = __webpack_require__(62);
	var SyntheticWheelEvent = __webpack_require__(426);
	
	var emptyFunction = __webpack_require__(26);
	var getEventCharCode = __webpack_require__(117);
	var invariant = __webpack_require__(10);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(76);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	var getEventCharCode = __webpack_require__(117);
	var getEventKey = __webpack_require__(431);
	var getEventModifierState = __webpack_require__(118);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	var getEventModifierState = __webpack_require__(118);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(76);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 427 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(182);
	var warning = __webpack_require__(12);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstanceMap = __webpack_require__(61);
	
	var getHostComponentFromComposite = __webpack_require__(196);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(111);
	var traverseAllChildren = __webpack_require__(202);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/watershed","REACT_APP_PREFIX":"/watershed/"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(217);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159)))

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(117);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 433 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(191);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 437 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(437);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(124);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(203);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(440);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(63);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(206);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(443);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(146);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(45);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(123);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(70);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(274);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(152);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(207);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(445);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(203);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(442);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(204);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(124);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(444);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(123);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(63);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 443 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(148);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(280);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(149);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(63);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(210);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(46);
	
	var _Router = __webpack_require__(125);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(210);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(46);
	
	var _Router = __webpack_require__(125);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(458);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(209);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(208);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(459);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(460);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(461);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(462);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(212);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(446);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(447);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(208);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(448);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(449);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(450);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(451);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(209);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(125);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(452);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(453);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(454);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(456);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(457);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(127);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(463);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(50);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(46);
	
	var _Router = __webpack_require__(126);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(50);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(46);
	
	var _generatePath = __webpack_require__(212);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(50);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(46);
	
	var _Router = __webpack_require__(126);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(50);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(127);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(303);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(211);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(307).enable();
	  window.Promise = __webpack_require__(306);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(863);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(14);


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _hydrogeologyIcon = __webpack_require__(130);
	
	var _hydrogeologyIcon2 = _interopRequireDefault(_hydrogeologyIcon);
	
	var _biogeochemistryIcon = __webpack_require__(128);
	
	var _biogeochemistryIcon2 = _interopRequireDefault(_biogeochemistryIcon);
	
	var _vegetationIcon = __webpack_require__(132);
	
	var _vegetationIcon2 = _interopRequireDefault(_vegetationIcon);
	
	var _climateIcon = __webpack_require__(129);
	
	var _climateIcon2 = _interopRequireDefault(_climateIcon);
	
	var _modeloutputIcon = __webpack_require__(131);
	
	var _modeloutputIcon2 = _interopRequireDefault(_modeloutputIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import AutoSuggest from 'react-autosuggest';
	
	
	var CategoryButton = function (_Button) {
	    _inherits(CategoryButton, _Button);
	
	    function CategoryButton(props) {
	        _classCallCheck(this, CategoryButton);
	
	        var _this = _possibleConstructorReturn(this, (CategoryButton.__proto__ || Object.getPrototypeOf(CategoryButton)).call(this, props));
	
	        _this.state = { active: false };
	        _this.clickHandler = _this.clickHandler.bind(_this);
	        _this.onButtonChange = _this.props.onButtonChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(CategoryButton, [{
	        key: 'clickHandler',
	        value: function clickHandler(e) {
	            e.preventDefault();
	            this.onButtonChange(this.props.category);
	            this.setState({ active: !this.state.active });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactBootstrap.Button,
	                { bsClass: 'btn btn-custom', active: this.state.active, onClick: this.clickHandler },
	                _react2.default.createElement('img', { className: 'measurement-icon', src: this.props.icon, alt: "" }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    this.props.label
	                )
	            );
	        }
	    }]);
	
	    return CategoryButton;
	}(_reactBootstrap.Button);
	
	var Filters = function (_Component) {
	    _inherits(Filters, _Component);
	
	    function Filters(props) {
	        _classCallCheck(this, Filters);
	
	        var _this2 = _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props));
	
	        _this2.handleCategoryFilterInputChange = _this2.handleCategoryFilterInputChange.bind(_this2);
	        _this2.handleSearchFilterUpdate = _this2.handleSearchFilterUpdate.bind(_this2);
	        _this2.handleSearchKeyPress = _this2.handleSearchKeyPress.bind(_this2);
	        _this2.onCategoryFilterInput = props.onCategoryFilterInput.bind(_this2);
	        _this2.onSearchFilterInput = props.onSearchFilterInput.bind(_this2);
	        _this2.state = { ftypes: new Set(), search: null };
	        return _this2;
	    }
	
	    _createClass(Filters, [{
	        key: 'handleCategoryFilterInputChange',
	        value: function handleCategoryFilterInputChange(c) {
	            if (this.state.ftypes.has(c)) {
	                this.state.ftypes.delete(c);
	            } else {
	                this.state.ftypes.add(c);
	            }
	
	            this.onCategoryFilterInput(this.state.ftypes);
	        }
	    }, {
	        key: 'handleSearchKeyPress',
	        value: function handleSearchKeyPress(e) {
	            if (e.which === 13) {
	                e.preventDefault();
	            }
	        }
	    }, {
	        key: 'handleSearchFilterUpdate',
	        value: function handleSearchFilterUpdate(c) {
	            this.onSearchFilterInput(c.target.value);
	            this.setState({ search: c.target.value });
	        }
	    }, {
	        key: 'hasFilter',
	        value: function hasFilter(f) {
	            if (this.state.ftypes) {
	                return this.state.ftypes.has(f);
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 filters', style: { paddingTop: 5 + 'px', paddingBottom: 5 + 'px', backgroundColor: "#f6f6f6" } },
	                _react2.default.createElement(
	                    'h4',
	                    { style: { fontSize: 14 + 'px' } },
	                    'Filters'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(CategoryButton, { category: "hydrogeology", label: "Hydrogeology", icon: _hydrogeologyIcon2.default,
	                        onButtonChange: this.handleCategoryFilterInputChange }),
	                    _react2.default.createElement(CategoryButton, { category: "biogeochemistry", label: "Biogeochemistry", icon: _biogeochemistryIcon2.default,
	                        onButtonChange: this.handleCategoryFilterInputChange }),
	                    _react2.default.createElement(CategoryButton, { category: "vegetation", label: "Vegetation", icon: _vegetationIcon2.default,
	                        onButtonChange: this.handleCategoryFilterInputChange }),
	                    _react2.default.createElement(CategoryButton, { category: "climate", label: "Climate", icon: _climateIcon2.default,
	                        onButtonChange: this.handleCategoryFilterInputChange }),
	                    _react2.default.createElement(CategoryButton, { category: "modeloutput", label: "ModelOutput", icon: _modeloutputIcon2.default,
	                        onButtonChange: this.handleCategoryFilterInputChange }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Form,
	                        { componentClass: 'fieldset', className: 'pull-right', inline: true, style: { marginRight: 15 } },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { style: { width: 30 + 'vw' } },
	                            _react2.default.createElement(
	                                _reactBootstrap.InputGroup,
	                                null,
	                                _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text', placeholder: 'Search for sites',
	                                    onChange: this.handleSearchFilterUpdate,
	                                    onKeyPress: this.handleSearchKeyPress,
	                                    style: { width: 28 + 'vw' }
	                                }),
	                                _react2.default.createElement(
	                                    _reactBootstrap.InputGroup.Addon,
	                                    { bsStyle: 'primary', style: { width: 2 + 'vw' } },
	                                    _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'search' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Filters;
	}(_react.Component);
	
	Filters.propTypes = {
	    onSearchFilterInput: _react.PropTypes.func,
	    onSearchSubmit: _react.PropTypes.func,
	    onCategoryFilterInput: _react.PropTypes.func
	};
	
	exports.default = Filters;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(455);
	
	var _App = __webpack_require__(213);
	
	var _Site = __webpack_require__(468);
	
	var _Site2 = _interopRequireDefault(_Site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefix = "/";
	if (true) {
	    prefix = ("/watershed/");
	}
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRouterDom.BrowserRouter,
	    { basename: prefix },
	    _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _App.WatershedSFA }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: "/sites/:id", component: _Site2.default })
	        )
	    )
	), document.getElementById('root'));

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LeafletMap = __webpack_require__(214);
	
	var _LeafletMap2 = _interopRequireDefault(_LeafletMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SitesMap = function (_Component) {
	    _inherits(SitesMap, _Component);
	
	    function SitesMap() {
	        _classCallCheck(this, SitesMap);
	
	        return _possibleConstructorReturn(this, (SitesMap.__proto__ || Object.getPrototypeOf(SitesMap)).apply(this, arguments));
	    }
	
	    _createClass(SitesMap, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-sm-7 map-container' },
	                _react2.default.createElement(_LeafletMap2.default, { sites: this.props.sites,
	                    activeSite: this.props.activeSite,
	                    markerActivated: this.props.markerActivated })
	            );
	        }
	    }]);
	
	    return SitesMap;
	}(_react.Component);
	
	SitesMap.propTypes = {
	    sites: _react.PropTypes.object,
	    activeSite: _react.PropTypes.object,
	    markerActivated: _react.PropTypes.func
	};
	
	exports.default = SitesMap;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _numeral = __webpack_require__(304);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _App = __webpack_require__(213);
	
	var _LeafletMap = __webpack_require__(214);
	
	var _LeafletMap2 = _interopRequireDefault(_LeafletMap);
	
	__webpack_require__(215);
	
	__webpack_require__(473);
	
	var _sites = __webpack_require__(156);
	
	var _sites2 = _interopRequireDefault(_sites);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Site = function (_Component) {
	    _inherits(Site, _Component);
	
	    function Site(props) {
	        _classCallCheck(this, Site);
	
	        var _this = _possibleConstructorReturn(this, (Site.__proto__ || Object.getPrototypeOf(Site)).call(this, props));
	
	        _this.site = null;
	        for (var i = _sites2.default.features.length - 1; i >= 0; i--) {
	            if (_sites2.default.features[i].properties.id === props.match.params.id) {
	                _this.site = _sites2.default.features[i];
	            }
	        }
	
	        if (_this.site === null) {
	            throw Error("Unable to find site: " + props.match.params.id);
	        }
	
	        if (_this.site.geometry.coordinates.length === 2) {
	            _this.site.properties.life_zone = "N/A";
	        } else {
	            var elevation = _this.site.geometry.coordinates[2];
	
	            if (elevation > 11000) {
	                _this.site.properties.life_zone = "Alpine";
	            } else if (elevation >= 9000) {
	                _this.site.properties.life_zone = "Sub-Alpine";
	            } else if (elevation >= 7000) {
	                _this.site.properties.life_zone = "Montane";
	            } else if (elevation >= 5600) {
	                _this.site.properties.life_zone = "Foothills";
	            } else if (elevation >= 0) {
	                _this.site.properties.life_zone = "Plains";
	            }
	        }
	
	        var displayCategories = _this.site.properties.measurement_categories.slice(0);
	        for (var _i = 0; _i < displayCategories.length; _i++) {
	            displayCategories[_i] = displayCategories[_i][0].toUpperCase() + displayCategories[_i].substr(1);
	        }
	        _this.site.properties.display_categories = displayCategories;
	
	        _this.carouselImages = [];
	        _this.carouselItems = [];
	
	        if (_this.site.properties.links && _this.site.properties.links.images) {
	            _this.carouselImages = _this.site.properties.links.images;
	        }
	
	        for (var _i2 = 0, imageInclude = null; _i2 < _this.carouselImages.length; _i2++) {
	            try {
	                imageInclude = __webpack_require__(864)("./" + _this.carouselImages[_i2]);
	                _this.carouselItems.push(_react2.default.createElement(
	                    _reactBootstrap.Carousel.Item,
	                    { key: _this.site.id + _i2 },
	                    _react2.default.createElement('img', { className: 'img-responsive', alt: _this.carouselImages[_i2],
	                        src: imageInclude,
	                        style: { height: 750, maxHeight: 750, width: 'auto' } })
	                ));
	            } catch (e) {
	                console.log("Unable to find photo: " + _this.carouselImages[_i2]);
	            }
	        }
	        return _this;
	    }
	
	    _createClass(Site, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.documentElement.className = 'site';
	            document.body.className = 'site';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var carousel = _react2.default.createElement(
	                _reactBootstrap.Carousel,
	                { controls: true,
	                    indicators: true,
	                    defaultActiveIndex: 0 },
	                this.carouselItems
	            );
	
	            if (this.carouselItems.length === 0) {
	                carousel = _react2.default.createElement(
	                    'div',
	                    { className: 'text-danger', style: { textAlign: 'center' } },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'No photos available for this site'
	                    )
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'site-content', style: { overflow: 'scroll !important' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'navbar' },
	                        _react2.default.createElement(_App.Header, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { marginTop: 0 } },
	                                this.site.id + ': ' + this.site.properties.name
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                { className: 'text-danger' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    this.site.properties.research_theme
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-4' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Location'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Lat, Lon: ',
	                                    this.site.geometry.coordinates[1].toFixed(4),
	                                    ', ',
	                                    this.site.geometry.coordinates[0].toFixed(4)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Elevation: ',
	                                    this.site.geometry.coordinates.length === 3 ? (0, _numeral2.default)(this.site.geometry.coordinates[2]).format('0,0') + ' m' : "N/A"
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Estimated Life Zone: ',
	                                    this.site.properties.life_zone
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Site Category'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this.site.properties.category
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Site Contact'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: "mailto:" + this.site.properties.contact.email, target: '_top' },
	                                    this.site.properties.contact.name
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Measurement Types'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this.site.properties.display_categories.join()
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Description'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh', marginRight: 15 + 'px' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this.site.properties.description
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Instrumentation'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh', marginRight: 15 + 'px' } },
	                                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.site.properties.instrumentation } })
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Variables Measured'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'relative', left: 2.3 + 'vh', marginRight: 15 + 'px' } },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    this.site.properties.variables_measured
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12', style: { height: 750, maxHeight: 750, width: 100 + '%' } },
	                            _react2.default.createElement(
	                                _reactBootstrap.Tabs,
	                                { defaultActiveKey: 2, bsStyle: 'pills', id: 'interactive', style: { height: 750, maxHeight: 750, width: 100 + '%' } },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    { eventKey: 1, title: 'Map', className: 'map-container', style: { height: 750, maxHeight: 750, width: 100 + '%' } },
	                                    _react2.default.createElement(_LeafletMap2.default, { sites: _sites2.default, activeSite: this.site, focusOnSite: true, style: { height: 750, maxHeight: 750, width: 100 + '%' } })
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    { eventKey: 2, title: 'Photos', style: { height: 750, maxHeight: 750, width: 'auto' } },
	                                    carousel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Site;
	}(_react.Component);
	
	exports.default = Site;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(73);
	
	var _hydrogeologyIcon = __webpack_require__(130);
	
	var _hydrogeologyIcon2 = _interopRequireDefault(_hydrogeologyIcon);
	
	var _biogeochemistryIcon = __webpack_require__(128);
	
	var _biogeochemistryIcon2 = _interopRequireDefault(_biogeochemistryIcon);
	
	var _vegetationIcon = __webpack_require__(132);
	
	var _vegetationIcon2 = _interopRequireDefault(_vegetationIcon);
	
	var _climateIcon = __webpack_require__(129);
	
	var _climateIcon2 = _interopRequireDefault(_climateIcon);
	
	var _modeloutputIcon = __webpack_require__(131);
	
	var _modeloutputIcon2 = _interopRequireDefault(_modeloutputIcon);
	
	__webpack_require__(474);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icons = {
	    hydrogeology: [0, _hydrogeologyIcon2.default],
	    ecohydrology: [1, _vegetationIcon2.default],
	    biogeochemistry: [2, _biogeochemistryIcon2.default],
	    vegetation: [3, _vegetationIcon2.default],
	    climate: [4, _climateIcon2.default],
	    modeloutput: [5, _modeloutputIcon2.default]
	};
	
	var SitesPane = function (_Component) {
	    _inherits(SitesPane, _Component);
	
	    function SitesPane(props) {
	        _classCallCheck(this, SitesPane);
	
	        var _this = _possibleConstructorReturn(this, (SitesPane.__proto__ || Object.getPrototypeOf(SitesPane)).call(this, props));
	
	        _this.state = {
	            sites: props.sites,
	            activeSite: props.activeSite
	        };
	
	        _this.onTableInput = props.onTableInput.bind(_this);
	        _this.handleRowClick = _this.handleRowClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(SitesPane, [{
	        key: 'handleRowClick',
	        value: function handleRowClick(e) {
	            //prevent duplicate click events from the img and td element listeners
	            e.stopPropagation();
	            var parent = e.target.parentNode;
	            var feature_id = null;
	
	            if (parent.tagName === "TD") {
	                // received a click event from an icon in the row
	                feature_id = parent.parentNode.getAttribute('data-element');
	            } else {
	                // otherwise the parent is already the TR element
	                feature_id = parent.getAttribute('data-element');
	            }
	
	            this.onTableInput(feature_id);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                sites: nextProps.sites,
	                activeSite: nextProps.activeSite
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            /* Scroll the actively viewed site to the top of the table */
	            if (this.state.activeSite === null) {
	                return;
	            }
	            var row = this.refs[this.state.activeSite.id];
	            var rowParent = row.parentElement;
	            rowParent.scrollTop = row.offsetTop - rowParent.offsetTop;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var rows = [];
	            var cssClasses = "";
	            var f = null;
	
	            for (var i = 0; i < this.props.sites.features.length; i++) {
	                f = this.props.sites.features[i];
	                //console.log(i);
	                //console.log(this.props.sites.features[i]);
	                if (f.id === this.state.activeSite.id) {
	                    cssClasses = "highlight";
	                } else {
	                    cssClasses = "";
	                }
	
	                var categories = f.properties.measurement_categories.sort(function (a, b) {
	                    if (icons.hasOwnProperty(a) && icons.hasOwnProperty(b)) {
	                        return icons[a][0] - icons[b][0];
	                    } else {
	                        var unknownCategories = [];
	                        if (!icons.hasOwnProperty(a)) {
	                            unknownCategories.push(a);
	                        }
	                        if (!icons.hasOwnProperty(b)) {
	                            unknownCategories.push(b);
	                        }
	                        throw Error("Unrecognized measurement categories: " + unknownCategories);
	                    }
	                });
	
	                var iconRow = [];
	                for (var _i = 0; _i < categories.length; _i++) {
	                    if (icons.hasOwnProperty(categories[_i])) {
	                        iconRow.push(_react2.default.createElement('img', { className: 'measurement-icon', alt: icons[categories[_i]][1], src: icons[categories[_i]][1], key: icons[categories[_i]][1], onClick: this.handleRowClick }));
	                    }
	                }
	
	                rows.push(_react2.default.createElement(
	                    'tr',
	                    { className: cssClasses, key: f.id + ": " + i,
	                        ref: f.id, 'data-element': f.id },
	                    _react2.default.createElement(
	                        'td',
	                        { onClick: this.handleRowClick },
	                        f.id + ": " + f.properties.name
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { onClick: this.handleRowClick },
	                        f.properties.category
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { onClick: this.handleRowClick },
	                        iconRow
	                    )
	                ));
	            }
	
	            //console.log(rows);
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'list', className: 'col-sm-5' },
	                _react2.default.createElement(SitePreview, { activeSite: this.state.activeSite }),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'thead',
	                        { 'data-element': 'list-header' },
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                "Listing " + rows.length + " of " + this.props.totalSites + " Sites"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Site ID: Name'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Site Category'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Measurement Types'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        { 'data-element': 'list-rows' },
	                        rows
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SitesPane;
	}(_react.Component);
	
	var SitePreview = function (_Component2) {
	    _inherits(SitePreview, _Component2);
	
	    function SitePreview(props) {
	        _classCallCheck(this, SitePreview);
	
	        var _this2 = _possibleConstructorReturn(this, (SitePreview.__proto__ || Object.getPrototypeOf(SitePreview)).call(this, props));
	
	        _this2.state = {
	            images: [],
	            activeSite: null
	        };
	        return _this2;
	    }
	
	    _createClass(SitePreview, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                images: nextProps.images,
	                activeSite: nextProps.activeSite
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var prefix = "/";
	            if (true) {
	                prefix = ("/watershed/");
	            }
	
	            if (this.state.activeSite) {
	                var carouselImages = [];
	                var carouselItems = [];
	                var lifeZone = "N/A";
	                var site = this.state.activeSite;
	
	                if (site.geometry.coordinates.length === 3) {
	                    var elevation = site.geometry.coordinates[2];
	
	                    if (elevation > 11000) {
	                        lifeZone = "Alpine";
	                    } else if (elevation >= 9000) {
	                        lifeZone = "Sub-Alpine";
	                    } else if (elevation >= 7000) {
	                        lifeZone = "Montane";
	                    } else if (elevation >= 5600) {
	                        lifeZone = "Foothills";
	                    } else if (elevation >= 0) {
	                        lifeZone = "Plains";
	                    }
	                }
	
	                var displayCategories = site.properties.measurement_categories.slice(0);
	                for (var i = 0; i < displayCategories.length; i++) {
	                    displayCategories[i] = displayCategories[i][0].toUpperCase() + displayCategories[i].substr(1);
	                }
	
	                if (site.properties.links && site.properties.links.images) {
	                    carouselImages = site.properties.links.images;
	                }
	
	                for (var _i2 = 0, imageInclude = null; _i2 < carouselImages.length; _i2++) {
	                    try {
	                        imageInclude = __webpack_require__(865)("./" + carouselImages[_i2]);
	                        carouselItems.push(_react2.default.createElement(
	                            _reactBootstrap.Carousel.Item,
	                            { key: site.id + _i2, index: _i2 },
	                            _react2.default.createElement('img', { width: 500, height: 250, alt: carouselImages[_i2],
	                                src: imageInclude }),
	                            '}'
	                        ));
	                    } catch (e) {
	                        console.log("Unable to find photo: " + carouselImages[_i2]);
	                    }
	                }
	
	                var carousel = _react2.default.createElement(
	                    _reactBootstrap.Carousel,
	                    { controls: true,
	                        indicators: true,
	                        interval: 3000,
	                        direction: 'next' },
	                    carouselItems
	                );
	
	                if (carouselItems.length === 0) {
	                    carousel = _react2.default.createElement(
	                        'div',
	                        { className: 'text-danger', style: { top: 50 + '%', height: 50 + '%', position: 'relative' } },
	                        'No photos available for this site'
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'div',
	                    { id: 'preview' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6', id: 'preview-image' },
	                        carousel
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-6', id: 'preview-body' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { paddingTop: 0, marginTop: 0 } },
	                                    site.properties.id + ': ' + site.properties.name
	                                ),
	                                _react2.default.createElement(
	                                    'h5',
	                                    { className: 'location-sub-title' },
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        site.properties.research_theme
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginBottom: 5 + 'px' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Estimated Life Zone'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    lifeZone
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginBottom: 5 + 'px' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Site Category'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    site.properties.category
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginBottom: 5 + 'px' } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Measurement Types'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    displayCategories.join()
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-sm-6', style: { marginBottom: 5 + 'px', paddingLeft: 0 } },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Site Contact'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    site.properties.contact.name
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'view-details', className: 'col-sm-6', style: { paddingLeft: 0, paddingRight: 15 } },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { bsStyle: 'primary',
	                                        href: prefix + "sites/" + site.properties.id,
	                                        target: '_blank' },
	                                    'View Details'
	                                )
	                            )
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { id: 'preview', style: { marginRight: 0 } },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'text-danger' },
	                        'No sites match your criteria.'
	                    )
	                );
	            }
	        }
	    }]);
	
	    return SitePreview;
	}(_react.Component);
	
	exports.default = SitesPane;

/***/ },
/* 470 */
215,
/* 471 */
215,
/* 472 */
215,
/* 473 */
215,
/* 474 */
215,
/* 475 */
111,
/* 476 */
[866, 64],
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(476);
	var ReactElement = __webpack_require__(52);
	
	var emptyFunction = __webpack_require__(26);
	var traverseAllChildren = __webpack_require__(486);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(52);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(52),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(161);
	
	module.exports = factory(isValidElement);

/***/ },
/* 480 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(216),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(52),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(219);
	var factory = __webpack_require__(272);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 482 */
432,
/* 483 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactElement = __webpack_require__(52);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var REACT_ELEMENT_TYPE = __webpack_require__(218);
	
	var getIteratorFn = __webpack_require__(482);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(475);
	var warning = __webpack_require__(12);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 487 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(487);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(492);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SFA_WatershedFunction.9ad30760.jpg";

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/001-ER18_1M8Yf1i2VjaoAa1y0ixG7_VyJBlErqEix.c1eebe8a.bin";

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/002-ER18_1VeP3Zc2Wfrkwyrq-eTvKtgIRYnM72emx.ebe03f50.bin";

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/003-ER18_1vEnBHHxEXKC0T8tKdP8MxVdes8GF4TUo.f26bf9fe.bin";

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO.02e88b63.bin";

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/006-ER18_1QRFC1u9728Wa4EIruhHuQK3p5ZPxb7yp.e0a3d9b9.bin";

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/010-ER18_1j165RaP-jDI_mtkUJa47eFZAhD__O0lw.6d484dfa.bin";

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/018-ER18_1X3ztxvSxKE7thV3t0etcsA1H7qo7fWaH.72104f8a.bin";

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/024-ER18_1Ih_4RpBXse6184d88br1k--hXTBAByl3.463d19e0.bin";

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y.182701e9.bin";

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/030-ER18_1wTdaxgQBmOlmxX3Lgd0azD1L83TuJU-F.ba9e7632.bin";

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/032-ER18_1YlJDfsBjZbilfH_o1hLUBcy5XfimEQUV.399dbe11.bin";

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/033-ER18_14yWpkYYa86gdH6puwjSQZYGzrZPB_VAt.7d17e9bd.bin";

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/044-ER18_1ijgtyLZjTSiYNzg4JQ5IL7bpHySNZizY.daaaf251.bin";

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/065-ER18_1bElv-IgFqW3F_Xjez6lkBCSbrfkpSqb0.187a8bb1.bin";

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/066-ER18_13AEse1W8xze_zsM7i-j-EyrFS3Yy1ZKt.aa03c3e5.bin";

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M.8e5c071c.bin";

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp.0651a483.bin";

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/074-ER18_1zTM7CQ9kFfEt4ep1JrcDF7LjnxbCR6sp.3f763fa2.bin";

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/076-ER18_1nZaNckHtC_OSB_SGCW8YonqWvGCvKfLj.7dcc7edb.bin";

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/078-ER18_14J9_i2nH92fn2_RATy4D92pM9qSjHsnh.20570c13.bin";

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/080-ER18_1brO_ZKWrE7Tuj2LR-sJX-shlCNsO4b4e.78caedec.bin";

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/082-ER18_1L_IP3NhgvxyUgrZEs9S21e8WXCZrN_fH.2b35bb16.bin";

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/083-ER18_1g7d4DwsQJ9050KDa9heHIOSxsLy1oazi.92005227.bin";

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/094-ER18_1beMXKMRWRT7P9U2Rm1yoxRCrMIXLLgWh.63b2e4c1.bin";

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/099-ER18_1T07GTLSlpGq_9RuM0t2Fq1fCC6aCmr_t.18c9c6ba.bin";

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/112-ER18_1lsSYF7zkArl5H5sXzYW4et_eX-dzvbt7.a5d50924.bin";

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/113-ER18_106_ubACGiTICmmiFgC2Wf5T15sivR1jB.febbd533.bin";

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/114-ER18_14g0HTeBKLDAh5yobMIwYArjSpjzBOmAP.37fbea7c.bin";

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/146-ER18_1-OwEPmp6sxnw4tLDvz_E5Oqj20MtWKLn.013304c3.bin";

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/148-ER18_19_T4PMNaRIjxwJ-9NhaKRIJPlqxgdW_i.5bff1bc9.bin";

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/150-ER18_1fo-POOVIIBgz83gY9u88e__FJxCUYFjL.b33f814f.bin";

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/151-ER18_1oWMOGNE9z66SO_0HyPtJTaebqcnHT79T.8d028030.bin";

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/152-ER18_1W-coBV8w461fGMSKmtyA-2AQsbgHZ3es.94c4e0a0.bin";

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/154-ER18_18BDXgP_vi0tQDNSobF7QVw4aAlr_4RX1.ca545bb6.bin";

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/157-ER18_1UezNOcqO3IWrFGZSoCiinPq_oNDi5Mso.c36dd8fb.bin";

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/158-ER18_1hEzk4cJ6aY8ogyopTpmg_UeOU-ZtZmR-.8c6510e7.bin";

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/159-ER18_1q5-qGmelJSHfrEyEm8YlXVD1vhMWF1-9.038672e1.bin";

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/160-ER18_11zK1GzxPFiZJ2fRqI8vfDAcjni1S30IE.d9ef2084.bin";

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/163-ER18_1ANhwOSThPRki0Y7xFF7nlAWtEMBmbDBH.806a34f6.bin";

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/163-ER18_1npne8tINalaObkCOJuX9SbG52QV72uoN.37758191.bin";

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/165-ER18_1jeSdTKlwP5Lqk_9STR3S1ZYyKg6FhY9C.df39d86f.bin";

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/166-ER18_17bKLO4Z7YVAFpM7shK0P6gMtPfMsOJ_s.2c2a0d72.bin";

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/167-ER18_15_--JO2X8fU-O2RpGYC0qpAtMzQB8duj.703a1063.bin";

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/169-ER18_1_OgYM3Ksvke6ps7FYUIYqbAb1qwahmto.ac06eef0.bin";

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/171-ER18_1-WuTyOd1QbAJK_s29mkn2Vf3zXRBrtx3.709a3a29.bin";

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/173-ER18_12z-ylJQChhpR4V-dq45xQUpd6CzPRwqt.111490e8.bin";

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/174-ER18_1vwgJf0uavLajHlhSswqAKU4nbc_jK6BE.3c64a78f.bin";

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/175-ER18_1N0ziJVbaWwOHDGNyaCfwhyNrnZaPV780.199273bb.bin";

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/176-ER18_1zV0CgdojVRhnTWd6zLnzjDO2aHI1ICM0.faca92f8.bin";

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/180-ER18_1uQwVuezg2cpUhis5iSrhWA1Z-xe_ODEG.ebb0ddcc.bin";

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/183-ER18_17uYodbIHB3uiLzcQBeY-yfjDJrkPnp1L.29311779.bin";

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/200-ER18_10DcO41RMUoBIuGjs9frEoplr3eOWIJU-.2e4ee61a.bin";

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/201-ER18_1tdmVgdBHU74V55Q-l7cHDdof2zxPyizu.48072c01.bin";

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/203-ER18_1TmwKL5V1MkmQSrvnHNnY3m0D10RW245s.770f5772.bin";

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/205-ER18_1w7TqgHxCmIHCMgitBRdfYCnjdHZLHpNH.c9c18918.bin";

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/207-ER18_1jRKZsJ_y9RD-_WvOud5ZffiNy3_VrmSC.2993dc02.bin";

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/208-ER18_1VGRhSyp_HI71gCtLzZ5wJ8xEpYw4B3Jw.866deaef.bin";

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/209-ER18_1ERujGjVSKTTCWXXe9Yme1IeKI1u_4pwI.37ec2980.bin";

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/212-ER18_1nKQL7O0kZuVzLf2s-40NfwPfdvbqYHe-.20f34f94.bin";

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/213-ER18_1AgDi0crTOPD935yS5AsmP8VBCecI0ycz.158ac363.bin";

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/216-ER18_193omF-S7wJaXGlHXc-Pn-HEfaO3NCpC5.d41a42cb.bin";

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/222-ER18_1LZQkGW08nb81XDBKajs3Cn9Ck8Nxqqa5.f335f721.bin";

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/223-ER18_16vNt1do6cn1CkXeHNuiwql7gVVUKJhoF.51a71cc0.bin";

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/224-ER18_1PWG_WKXNhXwNnFg9L29aW0Cdyvd0RuS7.8949c2b1.bin";

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/225-ER18_1m7RnEjiBQ9UwTFg-kzFGa7-57fC8VWjA.b0942897.bin";

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/226-ER18_1sBH0jKo2XU6MKPY_pphbVmyz2uhtXBMA.ada5f99a.bin";

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/228-ER18_1k1ybMEpgXdTZF3Nob5eZSdoazA6kv0fu.1f17c81f.bin";

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/231-ER18_1LIzQxgJBg6U1aMfD1W5Uuun6lOf91bux.ed7b961a.bin";

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/233-ER18_1CQWeohxZLZiteioJY43f-Sa-vOKUl9kh.bc37f07d.bin";

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4.562dee11.bin";

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/236-ER18_1depuYlP4j1cX7yqjkcqORYpF_-iqIkFS.ee3e1d01.bin";

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/237-ER18_1QxcFX9CO_ucZODzkG4gplksMJudpmmkg.8ce4d1d7.bin";

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/237-ER18_1urdwji2Ok3pTd32quo8Kx8K6H_uAsjeq.31474d3b.bin";

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/239-ER18_1hCSVs0gvqaeUVrX8Hxre4P9sHliPf4qh.ae9c0cce.bin";

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/254-ER18_1p4XoC_47NIpg3pvJTXj0OOFy9d_nNQ8V.f5b99d34.bin";

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/258-ER18_1fxyBxofnQ1CqWiwB-RirtICzChxm5ynR.90a2a93b.bin";

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/270-ER18_17iMPPsAkiqIn05H6DYZjtw0w-6vENmp9.a3fd37b9.bin";

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/272-ER18_1QtgikUX5qUFIJuGNDfAIRaFOiGubt2IA.a1179900.bin";

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/273-ER18_1AXILP_ZSU7ijBcOvPkZlo373KX-AO6mp.61840dad.bin";

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/278-ER18_1CgFWCj3l6d2-ptq7QOXmdGkX_obn3nkc.d1e793fd.bin";

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/284-ER18_1VTFJGD_YFp1yyh2SZylr32_QwW5csKQb.108e56ae.bin";

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/287-ER18_1ieEPa4YmNIw25tb0QYFIQOs-d6lBRfwX.96845119.bin";

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/317-ER18_1Rn1MZwEQauRXv4E0tRXmw5Klbdh1v0Aq.0c6467b6.bin";

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/337-ER18_1lyDUiGxnLJyiwN2rZ5-z4l-ntHZENa0X.800f1635.bin";

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/339-ER18_1jizImIpMNK1vvXxmOiEP4BWYk_nQRe3F.94a9db7f.bin";

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/341-ER18_1O4MSttpj5RtBt6b9lU26o4QgFX5CAsaA.8f988ef4.bin";

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/343-ER18_1J_a5z9ckwcvGbHoJIwY3aBB3CxhD84II.6f9d69f3.bin";

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/368-ER18_1cGl5DXpWPTkXLMNKsrOU-etD_l9eYWZA.81c502b3.bin";

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/369-ER18_1J6pe2wjx-b3k5ujo_oMpOxSkxqoM7ODP.73d0076e.bin";

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/393-ER18_1Z8pd8qK3S4QB2Kjdu9eVihIIw4nzpTL4.b047de31.bin";

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-BOG0_1YIffKvdArow8ys3h1hJzjbHcNoqMq5Jm.ddc0e0ed.bin";

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-BOG3_151QuDD2UzRCXC5DTTtCM8MWqloRxdWXp.5c5c8028.bin";

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN.827ab794.bin";

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu.ed503444.bin";

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn.6f9fccfe.bin";

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A.5a22d65a.bin";

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ.42eef880.bin";

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz.b4ebe122.bin";

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL15_1Ama-4Szg7soqzvzz99qowe8usVKU-vYn.c59da993.bin";

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL20_155n4txAWhvgUxqgameCgkkbtTWN-ONrf.4f51f70f.bin";

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8.139a8935.bin";

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ.b4a9f451.bin";

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL3_1SEtNaLFEC_42OJvCdsP6NIvzgVd_imyP.e5ad5bff.bin";

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi.ce13e679.bin";

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL5_1k8tymV5VzOjNmHISsgw8Zhb0xx_keqSE.bb066d61.bin";

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL6_1UwGzcnd8AgGHuFpWY2S8I7InHIjor_Bq.95c1a592.bin";

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL7_1bN9L3MsxC1SYzBVBFyRvLmButPlZNnn_.969e390f.bin";

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4.0d6191be.bin";

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL9_1cMYlJHh0_LzvhnmQVfYRGdX2ETL55C9p.d8a3c9a1.bin";

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-ELK0_181yufjtuQU9lz_jlAQWD1dT_969-OmRN.33581f62.bin";

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-ELK1_1IE6nxQZjZcR68d8pL-Yo8Lt0bzRmfIQx.d296237c.bin";

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-EVN1_1KQbIJEr0ww57nF4vsVCNojg12AhC3h-8.11a86319.bin";

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-IRB3_1a9UiHSCTmRMHIGshhH4-NXwUROt9eSz5.a96d6160.bin";

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-IRW0_1fFaRSdXFCLCzZ7X4VLzDFF97NEQ8ztCs.f548d6f9.bin";

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-OHO1_1P_P9OQUhhJLbMwXchqxW3eag6LZaY6Sv.c093f1a6.bin";

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-RLY1_1cmOTVtFTXg_A2Kwp9llMCnfYZKiAhYgI.8a3326e5.bin";

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-SPL1_1Bl2JjkwD6Ygn8kprhhVIXoJ6PIR3pXck.1e07251c.bin";

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-WLD1_1pJB8G4GSGtljM4xj9e0qJusRhjQqA8gn.38d033cb.bin";

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-AMT1_1WL_KcZGPiRKNgAKsqdZs5ZwKK3ub_nk6.cc07181f.bin";

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-AVY1_1HFoba3DfET07yAfpMYgob55oZF1jQH0Z.23746852.bin";

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-AVY1_1nnkbVSeckmOCSVbiPAJlpWE0TcH0m1xF.823d230b.bin";

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_13ztzLwVTVcTDYYH8DfJ-CL-t77N3xx2q.323e1893.bin";

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_1IZPq1EJPIq3_rZt8wC5w6o-FIHHj1yG9.339b4951.bin";

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_1f3GdVRWTQS6AMq3pHUO8eF_i9H_cMBTX.834ff3e9.bin";

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_1rmKoACou7XMB5MmaYYBEutbkPYBTfjLY.73b03a1c.bin";

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BLB1_19HFEd1-3inv9qhhPaZeDIMRNV9QATzqg.2e487767.bin";

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BLB1_1m8X3jwzFJRo-ss8Q1tmLHM8qWJXoJh1g.f2a17323.bin";

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BLY1_1lfq6itnxKJjJOeHstOJNFgh7_m28P7tt.2433f39e.bin";

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BRD1_1YrnvDmmLbq_m7pckHaqEK9zRAZxc1hej.cfcc6a86.bin";

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-CPR1_1YABLBd05P-y8NhdOQJb4Y_ruc95IwAit.92ce45d7.bin";

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EAQ1_1iAT3Un1XYN79br8b27e2aGHBNWpG6ht4.61b846ab.bin";

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EBC0_1VC-KmuX1iROuujgfWarajGUvaXiMyQLm.a2e59058.bin";

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EBC1_1sjwAulA3mjsE1OfJ2KdGVOHeMEcGbRQW.4c9ed19f.bin";

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EST2_12U0xe6oGY5MQqYx9_PFOAMWrLJekUPxJ.3f4e411b.bin";

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GLS1_1kakMTKZyBgPBuqJVibVpFEJCr5kdRiOA.f3a1766c.bin";

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GTH1_1AtWkH44Jams2WJsCyCEoV3Vi6Ta0eNXM.0d303452.bin";

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GUM1_1ZeJ4MYQ1-XqGKMIlbPerUxiIEII3J-Mg.0f5ad26c.bin";

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GUM1_1c0VY7VgJXkJcReKGNHRllcR-zgy9UntY.0a911434.bin";

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GUM1_1okRIR8vg1q5uGSMnYia6PpM7rd9KoP32.a0097e52.bin";

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-JDF1_1X-gx9lYQxfDlkoi30dtHycjnXzcrEBmm.b563e099.bin";

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-KLP1_1UmAgH7geJfEQL4g0C7QbTyOr6Ish_9xG.d42a903f.bin";

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-MMT1_1bsH_cMQXOv6f_z8s00VyUSkTz_4c2IdV.d71ca5b4.bin";

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-MXC1_1wfQjfEhZlZTNHkx12kkEhfg5hDRmr_sB.2df6e1d3.bin";

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy.5ed5baac.bin";

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PHF0_1AjzaqW2975cRaNzzSISAsDcbb8Uj9_0i.0d4b83e7.bin";

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PHF0_1SUNKjCfCU105x69XIkqnfnwEV0TRiwDm.3ae725fa.bin";

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PHF1_1aNmd-9OBx33o3jfwjkcFwpfc3TFWeSqk.9b7fc161.bin";

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM1_1DHl4dNQEK1Jb1bRRq2j2DvLeu9L-gc1q.1e100d45.bin";

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM1_1Df8i_qTutb-lKvBamkcBaeYS7Wlnx4Pr.6919ce57.bin";

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM1_1Ig4tDFrLfYpclSnHsW4YeEoNuNFcwR8r.5cc6740a.bin";

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM2_1Rqjtly5iPAoC-O5k-VK7OBRL4Fv_3A3v.bdf67973.bin";

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM2_1z9BUKgabfr1vLS8DQ_6yYTn7UroR0vlT.dbef7130.bin";

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM3_1Ttsrqq9EptJX65fC73jBzbTfLS5Rwdsu.4fbba79e.bin";

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM3_1jk-ZktIfdcILcUL3oJxwveeNNxVCM9oj.c08ab578.bin";

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM4_1JoonMxxHy-lUDl7QZRvJ-ejJofgV4R0G.95188023.bin";

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM6_1DCRaVpzbA5cY_Msu2O1p2xANoS29VbPS.5ec7da2c.bin";

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM7_1ypKvvJqeBFFKQ0X4WceQi4obtzMxX-BV.34495218.bin";

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM8_1KIxGYic47rh8iFEQFYRV6DOIg_qu1-mp.79b57a0d.bin";

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM9_1AWokwE0jGeAWSrkgDo7aHP8W8CphDOFs.79b57a0d.bin";

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv.e8c26425.bin";

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-QLY1_1NbFc2sZR8W7fwJJP000umti3ZQP9j6Iq.adda70aa.bin";

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RBL1_1YqONoeAgGi9Si2GNTKLRIK42To9evQ7u.91d11e3d.bin";

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RBL1_1cJ1OiF7IENtxOHbfSYRWyZEgkUdZtn4F.7e686517.bin";

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RCK1_1ivpBjVxrUm4TLEXTOrkI5CEE6FRCsGsf.c59d6b34.bin";

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2.db72c460.bin";

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_.30e19f04.bin";

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw.03d65556.bin";

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht.bc423299.bin";

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-YUL0_1Cf-iHrXGhBarsVu5nXIUz07R9Cc6MBwo.dfefee15.bin";

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-YUL0_1SgG10QYcOkRTL2o694mcT3qBrNCgZsIG.fb2b6b52.bin";

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl.edfd1d63.bin";

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_.0438846f.bin";

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI2_1FwnVgeFB0GpzEdjUBuvM09VPagZ_-cdv.9b5d5ad6.bin";

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL.17e864c4.bin";

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1L7ksbmn65NwDC05Bz0Qqex7AINgaZAeO.e64ee364.bin";

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ.222ce068.bin";

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1zIbU3MPWQIcnH_F7DYGlhL4PvfcRwjLo.c6bf35d9.bin";

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1CUdYvu_GEzg97KRjJehBYKCQJ9KgYjfh.d0d6e9e5.bin";

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA.3dbf6b49.bin";

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI.956a3584.bin";

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv.cefaebdf.bin";

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/WG-LMR2_1xFtTmjUsG8iRdihZwudzxi5AdCFYgnb3.a019c515.bin";

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/001-ER18_1M8Yf1i2VjaoAa1y0ixG7_VyJBlErqEix.051d63da.bin";

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/002-ER18_1VeP3Zc2Wfrkwyrq-eTvKtgIRYnM72emx.c5d0714b.bin";

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/003-ER18_1vEnBHHxEXKC0T8tKdP8MxVdes8GF4TUo.30b1e4e6.bin";

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO.f2605098.bin";

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/006-ER18_1QRFC1u9728Wa4EIruhHuQK3p5ZPxb7yp.8ae1eedb.bin";

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/010-ER18_1j165RaP-jDI_mtkUJa47eFZAhD__O0lw.000c1d13.bin";

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/018-ER18_1X3ztxvSxKE7thV3t0etcsA1H7qo7fWaH.7f5623f7.bin";

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/024-ER18_1Ih_4RpBXse6184d88br1k--hXTBAByl3.3f7aa41d.bin";

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y.15212aa9.bin";

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/030-ER18_1wTdaxgQBmOlmxX3Lgd0azD1L83TuJU-F.58212bd1.bin";

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/032-ER18_1YlJDfsBjZbilfH_o1hLUBcy5XfimEQUV.0e026c19.bin";

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/033-ER18_14yWpkYYa86gdH6puwjSQZYGzrZPB_VAt.d9bd851d.bin";

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/044-ER18_1ijgtyLZjTSiYNzg4JQ5IL7bpHySNZizY.5486ec5c.bin";

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/065-ER18_1bElv-IgFqW3F_Xjez6lkBCSbrfkpSqb0.1a926bc1.bin";

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/066-ER18_13AEse1W8xze_zsM7i-j-EyrFS3Yy1ZKt.160e4a7d.bin";

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M.b0373242.bin";

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp.cda5fc71.bin";

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/074-ER18_1zTM7CQ9kFfEt4ep1JrcDF7LjnxbCR6sp.afc0a4e9.bin";

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/076-ER18_1nZaNckHtC_OSB_SGCW8YonqWvGCvKfLj.94b240b0.bin";

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/078-ER18_14J9_i2nH92fn2_RATy4D92pM9qSjHsnh.3ddd856b.bin";

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/080-ER18_1brO_ZKWrE7Tuj2LR-sJX-shlCNsO4b4e.09a3385e.bin";

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/082-ER18_1L_IP3NhgvxyUgrZEs9S21e8WXCZrN_fH.06bbbe52.bin";

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/083-ER18_1g7d4DwsQJ9050KDa9heHIOSxsLy1oazi.7321a9fb.bin";

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/094-ER18_1beMXKMRWRT7P9U2Rm1yoxRCrMIXLLgWh.2b3e9261.bin";

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/099-ER18_1T07GTLSlpGq_9RuM0t2Fq1fCC6aCmr_t.5e79ccab.bin";

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/112-ER18_1lsSYF7zkArl5H5sXzYW4et_eX-dzvbt7.6458379c.bin";

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/113-ER18_106_ubACGiTICmmiFgC2Wf5T15sivR1jB.0d7ff453.bin";

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/114-ER18_14g0HTeBKLDAh5yobMIwYArjSpjzBOmAP.244f498d.bin";

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/146-ER18_1-OwEPmp6sxnw4tLDvz_E5Oqj20MtWKLn.ba0245af.bin";

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/148-ER18_19_T4PMNaRIjxwJ-9NhaKRIJPlqxgdW_i.f8968adb.bin";

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/150-ER18_1fo-POOVIIBgz83gY9u88e__FJxCUYFjL.4f855fb6.bin";

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/151-ER18_1oWMOGNE9z66SO_0HyPtJTaebqcnHT79T.9d22a2bf.bin";

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/152-ER18_1W-coBV8w461fGMSKmtyA-2AQsbgHZ3es.255ff155.bin";

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/154-ER18_18BDXgP_vi0tQDNSobF7QVw4aAlr_4RX1.60414002.bin";

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/157-ER18_1UezNOcqO3IWrFGZSoCiinPq_oNDi5Mso.0e43a1b1.bin";

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/158-ER18_1hEzk4cJ6aY8ogyopTpmg_UeOU-ZtZmR-.c3854455.bin";

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/159-ER18_1q5-qGmelJSHfrEyEm8YlXVD1vhMWF1-9.cb839c82.bin";

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/160-ER18_11zK1GzxPFiZJ2fRqI8vfDAcjni1S30IE.978063d4.bin";

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/163-ER18_1ANhwOSThPRki0Y7xFF7nlAWtEMBmbDBH.e0fa6fe8.bin";

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/163-ER18_1npne8tINalaObkCOJuX9SbG52QV72uoN.d8cd90ff.bin";

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/165-ER18_1jeSdTKlwP5Lqk_9STR3S1ZYyKg6FhY9C.3f2a5de6.bin";

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/166-ER18_17bKLO4Z7YVAFpM7shK0P6gMtPfMsOJ_s.275e7802.bin";

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/167-ER18_15_--JO2X8fU-O2RpGYC0qpAtMzQB8duj.3642ac16.bin";

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/169-ER18_1_OgYM3Ksvke6ps7FYUIYqbAb1qwahmto.a59c2cb3.bin";

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/171-ER18_1-WuTyOd1QbAJK_s29mkn2Vf3zXRBrtx3.6183eed2.bin";

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/173-ER18_12z-ylJQChhpR4V-dq45xQUpd6CzPRwqt.2f5fae26.bin";

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/174-ER18_1vwgJf0uavLajHlhSswqAKU4nbc_jK6BE.5607ec08.bin";

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/175-ER18_1N0ziJVbaWwOHDGNyaCfwhyNrnZaPV780.d9695055.bin";

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/176-ER18_1zV0CgdojVRhnTWd6zLnzjDO2aHI1ICM0.ab9d9360.bin";

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/180-ER18_1uQwVuezg2cpUhis5iSrhWA1Z-xe_ODEG.408c1040.bin";

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/183-ER18_17uYodbIHB3uiLzcQBeY-yfjDJrkPnp1L.ec3a257e.bin";

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/200-ER18_10DcO41RMUoBIuGjs9frEoplr3eOWIJU-.8968f832.bin";

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/201-ER18_1tdmVgdBHU74V55Q-l7cHDdof2zxPyizu.15ee71f6.bin";

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/203-ER18_1TmwKL5V1MkmQSrvnHNnY3m0D10RW245s.9309a56e.bin";

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/205-ER18_1w7TqgHxCmIHCMgitBRdfYCnjdHZLHpNH.930a7ca5.bin";

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/207-ER18_1jRKZsJ_y9RD-_WvOud5ZffiNy3_VrmSC.a257eee5.bin";

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/208-ER18_1VGRhSyp_HI71gCtLzZ5wJ8xEpYw4B3Jw.9c88de22.bin";

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/209-ER18_1ERujGjVSKTTCWXXe9Yme1IeKI1u_4pwI.6daa6fe7.bin";

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/212-ER18_1nKQL7O0kZuVzLf2s-40NfwPfdvbqYHe-.85c7fb19.bin";

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/213-ER18_1AgDi0crTOPD935yS5AsmP8VBCecI0ycz.de5f75a9.bin";

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/216-ER18_193omF-S7wJaXGlHXc-Pn-HEfaO3NCpC5.99b6d72a.bin";

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/222-ER18_1LZQkGW08nb81XDBKajs3Cn9Ck8Nxqqa5.038de1e0.bin";

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/223-ER18_16vNt1do6cn1CkXeHNuiwql7gVVUKJhoF.54b42033.bin";

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/224-ER18_1PWG_WKXNhXwNnFg9L29aW0Cdyvd0RuS7.308e0901.bin";

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/225-ER18_1m7RnEjiBQ9UwTFg-kzFGa7-57fC8VWjA.47d748cb.bin";

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/226-ER18_1sBH0jKo2XU6MKPY_pphbVmyz2uhtXBMA.088e54d6.bin";

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/228-ER18_1k1ybMEpgXdTZF3Nob5eZSdoazA6kv0fu.a20f0e10.bin";

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/231-ER18_1LIzQxgJBg6U1aMfD1W5Uuun6lOf91bux.0153ec3b.bin";

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/233-ER18_1CQWeohxZLZiteioJY43f-Sa-vOKUl9kh.fce4b9d0.bin";

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4.2a23f8a6.bin";

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/236-ER18_1depuYlP4j1cX7yqjkcqORYpF_-iqIkFS.10955722.bin";

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/237-ER18_1QxcFX9CO_ucZODzkG4gplksMJudpmmkg.2a5d172c.bin";

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/237-ER18_1urdwji2Ok3pTd32quo8Kx8K6H_uAsjeq.a15aa3d9.bin";

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/239-ER18_1hCSVs0gvqaeUVrX8Hxre4P9sHliPf4qh.c9ae4bf9.bin";

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/254-ER18_1p4XoC_47NIpg3pvJTXj0OOFy9d_nNQ8V.a0205b62.bin";

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/258-ER18_1fxyBxofnQ1CqWiwB-RirtICzChxm5ynR.c1eb173a.bin";

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/270-ER18_17iMPPsAkiqIn05H6DYZjtw0w-6vENmp9.a54b9734.bin";

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/272-ER18_1QtgikUX5qUFIJuGNDfAIRaFOiGubt2IA.7f832d1d.bin";

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/273-ER18_1AXILP_ZSU7ijBcOvPkZlo373KX-AO6mp.a75ea9ff.bin";

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/278-ER18_1CgFWCj3l6d2-ptq7QOXmdGkX_obn3nkc.9d1e1134.bin";

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/284-ER18_1VTFJGD_YFp1yyh2SZylr32_QwW5csKQb.5897bf51.bin";

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/287-ER18_1ieEPa4YmNIw25tb0QYFIQOs-d6lBRfwX.3e02e33e.bin";

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/317-ER18_1Rn1MZwEQauRXv4E0tRXmw5Klbdh1v0Aq.8c3f5a87.bin";

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/337-ER18_1lyDUiGxnLJyiwN2rZ5-z4l-ntHZENa0X.1f2f2643.bin";

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/339-ER18_1jizImIpMNK1vvXxmOiEP4BWYk_nQRe3F.b878496a.bin";

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/341-ER18_1O4MSttpj5RtBt6b9lU26o4QgFX5CAsaA.be33f9f9.bin";

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/343-ER18_1J_a5z9ckwcvGbHoJIwY3aBB3CxhD84II.8c1d62af.bin";

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/368-ER18_1cGl5DXpWPTkXLMNKsrOU-etD_l9eYWZA.9d0c606f.bin";

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/369-ER18_1J6pe2wjx-b3k5ujo_oMpOxSkxqoM7ODP.c8457d49.bin";

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/393-ER18_1Z8pd8qK3S4QB2Kjdu9eVihIIw4nzpTL4.5eb3d4d3.bin";

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-BOG0_1YIffKvdArow8ys3h1hJzjbHcNoqMq5Jm.db5d35ba.bin";

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-BOG3_151QuDD2UzRCXC5DTTtCM8MWqloRxdWXp.59de2009.bin";

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN.70294d19.bin";

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu.e8ce84f7.bin";

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn.3d72a0fd.bin";

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A.99a905ad.bin";

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ.3441dbfa.bin";

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz.6226d753.bin";

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL15_1Ama-4Szg7soqzvzz99qowe8usVKU-vYn.477fff68.bin";

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL20_155n4txAWhvgUxqgameCgkkbtTWN-ONrf.60042720.bin";

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8.d2faca00.bin";

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ.49069679.bin";

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL3_1SEtNaLFEC_42OJvCdsP6NIvzgVd_imyP.53bcff4c.bin";

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi.e87e96fc.bin";

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL5_1k8tymV5VzOjNmHISsgw8Zhb0xx_keqSE.eb807fc9.bin";

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL6_1UwGzcnd8AgGHuFpWY2S8I7InHIjor_Bq.633141b7.bin";

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL7_1bN9L3MsxC1SYzBVBFyRvLmButPlZNnn_.ab73fd48.bin";

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4.8f184460.bin";

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-COL9_1cMYlJHh0_LzvhnmQVfYRGdX2ETL55C9p.55192a44.bin";

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-ELK0_181yufjtuQU9lz_jlAQWD1dT_969-OmRN.d4b4a1c3.bin";

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-ELK1_1IE6nxQZjZcR68d8pL-Yo8Lt0bzRmfIQx.7c596a97.bin";

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-EVN1_1KQbIJEr0ww57nF4vsVCNojg12AhC3h-8.9859f222.bin";

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-IRB3_1a9UiHSCTmRMHIGshhH4-NXwUROt9eSz5.8fa78c86.bin";

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-IRW0_1fFaRSdXFCLCzZ7X4VLzDFF97NEQ8ztCs.8d8b0ecf.bin";

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-OHO1_1P_P9OQUhhJLbMwXchqxW3eag6LZaY6Sv.f2a931cf.bin";

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-RLY1_1cmOTVtFTXg_A2Kwp9llMCnfYZKiAhYgI.08bcf05d.bin";

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-SPL1_1Bl2JjkwD6Ygn8kprhhVIXoJ6PIR3pXck.c6ddd8f3.bin";

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/CC-WLD1_1pJB8G4GSGtljM4xj9e0qJusRhjQqA8gn.18385feb.bin";

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-AMT1_1WL_KcZGPiRKNgAKsqdZs5ZwKK3ub_nk6.a41a2028.bin";

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-AVY1_1HFoba3DfET07yAfpMYgob55oZF1jQH0Z.748e9bc9.bin";

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-AVY1_1nnkbVSeckmOCSVbiPAJlpWE0TcH0m1xF.6820b447.bin";

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_13ztzLwVTVcTDYYH8DfJ-CL-t77N3xx2q.f3b6e5df.bin";

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_1IZPq1EJPIq3_rZt8wC5w6o-FIHHj1yG9.fba455c2.bin";

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_1f3GdVRWTQS6AMq3pHUO8eF_i9H_cMBTX.d5e8fe06.bin";

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BCC0_1rmKoACou7XMB5MmaYYBEutbkPYBTfjLY.594c3d0c.bin";

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BLB1_19HFEd1-3inv9qhhPaZeDIMRNV9QATzqg.9de5f021.bin";

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BLB1_1m8X3jwzFJRo-ss8Q1tmLHM8qWJXoJh1g.90a12c33.bin";

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BLY1_1lfq6itnxKJjJOeHstOJNFgh7_m28P7tt.1d4db1f4.bin";

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-BRD1_1YrnvDmmLbq_m7pckHaqEK9zRAZxc1hej.61cc044a.bin";

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-CPR1_1YABLBd05P-y8NhdOQJb4Y_ruc95IwAit.fb3a0d0b.bin";

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EAQ1_1iAT3Un1XYN79br8b27e2aGHBNWpG6ht4.b6cfca0a.bin";

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EBC0_1VC-KmuX1iROuujgfWarajGUvaXiMyQLm.4c1828dc.bin";

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EBC1_1sjwAulA3mjsE1OfJ2KdGVOHeMEcGbRQW.2720071a.bin";

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-EST2_12U0xe6oGY5MQqYx9_PFOAMWrLJekUPxJ.5b809485.bin";

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GLS1_1kakMTKZyBgPBuqJVibVpFEJCr5kdRiOA.d002ebdf.bin";

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GTH1_1AtWkH44Jams2WJsCyCEoV3Vi6Ta0eNXM.9cf4530f.bin";

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GUM1_1ZeJ4MYQ1-XqGKMIlbPerUxiIEII3J-Mg.23114f45.bin";

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GUM1_1c0VY7VgJXkJcReKGNHRllcR-zgy9UntY.520193b4.bin";

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-GUM1_1okRIR8vg1q5uGSMnYia6PpM7rd9KoP32.0f8a6405.bin";

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-JDF1_1X-gx9lYQxfDlkoi30dtHycjnXzcrEBmm.9bfb8f28.bin";

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-KLP1_1UmAgH7geJfEQL4g0C7QbTyOr6Ish_9xG.7287599e.bin";

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-MMT1_1bsH_cMQXOv6f_z8s00VyUSkTz_4c2IdV.25549972.bin";

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-MXC1_1wfQjfEhZlZTNHkx12kkEhfg5hDRmr_sB.991d3773.bin";

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy.4e55bbc1.bin";

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PHF0_1AjzaqW2975cRaNzzSISAsDcbb8Uj9_0i.5815d789.bin";

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PHF0_1SUNKjCfCU105x69XIkqnfnwEV0TRiwDm.32d55713.bin";

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PHF1_1aNmd-9OBx33o3jfwjkcFwpfc3TFWeSqk.c0115bc4.bin";

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM1_1DHl4dNQEK1Jb1bRRq2j2DvLeu9L-gc1q.2646d45d.bin";

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM1_1Df8i_qTutb-lKvBamkcBaeYS7Wlnx4Pr.75ae3768.bin";

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM1_1Ig4tDFrLfYpclSnHsW4YeEoNuNFcwR8r.0e6cebd2.bin";

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM2_1Rqjtly5iPAoC-O5k-VK7OBRL4Fv_3A3v.7dd710ff.bin";

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM2_1z9BUKgabfr1vLS8DQ_6yYTn7UroR0vlT.cf48b8b1.bin";

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM3_1Ttsrqq9EptJX65fC73jBzbTfLS5Rwdsu.7cad3778.bin";

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM3_1jk-ZktIfdcILcUL3oJxwveeNNxVCM9oj.35398c9e.bin";

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM4_1JoonMxxHy-lUDl7QZRvJ-ejJofgV4R0G.4a8aea8b.bin";

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM6_1DCRaVpzbA5cY_Msu2O1p2xANoS29VbPS.b7d91b7e.bin";

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM7_1ypKvvJqeBFFKQ0X4WceQi4obtzMxX-BV.f20b28f4.bin";

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM8_1KIxGYic47rh8iFEQFYRV6DOIg_qu1-mp.842156d3.bin";

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PLM9_1AWokwE0jGeAWSrkgDo7aHP8W8CphDOFs.842156d3.bin";

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv.a6edfdc2.bin";

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-QLY1_1NbFc2sZR8W7fwJJP000umti3ZQP9j6Iq.b4b6f74b.bin";

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RBL1_1YqONoeAgGi9Si2GNTKLRIK42To9evQ7u.3da24204.bin";

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RBL1_1cJ1OiF7IENtxOHbfSYRWyZEgkUdZtn4F.36759f40.bin";

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RCK1_1ivpBjVxrUm4TLEXTOrkI5CEE6FRCsGsf.77441e36.bin";

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2.5c384069.bin";

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_.10d0c979.bin";

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw.6df2878c.bin";

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht.4378fe24.bin";

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-YUL0_1Cf-iHrXGhBarsVu5nXIUz07R9Cc6MBwo.610d0e9d.bin";

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ER-YUL0_1SgG10QYcOkRTL2o694mcT3qBrNCgZsIG.0c5bf00d.bin";

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl.4b3e437a.bin";

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_.2f1e4939.bin";

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI2_1FwnVgeFB0GpzEdjUBuvM09VPagZ_-cdv.73c1f0b0.bin";

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL.9604b939.bin";

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1L7ksbmn65NwDC05Bz0Qqex7AINgaZAeO.629483b8.bin";

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ.8a9951fe.bin";

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI3_1zIbU3MPWQIcnH_F7DYGlhL4PvfcRwjLo.46e110f2.bin";

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1CUdYvu_GEzg97KRjJehBYKCQJ9KgYjfh.698854a5.bin";

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA.95ace243.bin";

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI.eed47fee.bin";

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv.ebd2dccb.bin";

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/WG-LMR2_1xFtTmjUsG8iRdihZwudzxi5AdCFYgnb3.e99f173f.bin";

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(859);
	var v4 = __webpack_require__(860);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(222);
	var bytesToUuid = __webpack_require__(221);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(222);
	var bytesToUuid = __webpack_require__(221);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 861 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(861);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 863 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./001-ER18_1M8Yf1i2VjaoAa1y0ixG7_VyJBlErqEix": 494,
		"./002-ER18_1VeP3Zc2Wfrkwyrq-eTvKtgIRYnM72emx": 495,
		"./003-ER18_1vEnBHHxEXKC0T8tKdP8MxVdes8GF4TUo": 496,
		"./004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO": 497,
		"./006-ER18_1QRFC1u9728Wa4EIruhHuQK3p5ZPxb7yp": 498,
		"./010-ER18_1j165RaP-jDI_mtkUJa47eFZAhD__O0lw": 499,
		"./018-ER18_1X3ztxvSxKE7thV3t0etcsA1H7qo7fWaH": 500,
		"./024-ER18_1Ih_4RpBXse6184d88br1k--hXTBAByl3": 501,
		"./028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y": 502,
		"./030-ER18_1wTdaxgQBmOlmxX3Lgd0azD1L83TuJU-F": 503,
		"./032-ER18_1YlJDfsBjZbilfH_o1hLUBcy5XfimEQUV": 504,
		"./033-ER18_14yWpkYYa86gdH6puwjSQZYGzrZPB_VAt": 505,
		"./044-ER18_1ijgtyLZjTSiYNzg4JQ5IL7bpHySNZizY": 506,
		"./065-ER18_1bElv-IgFqW3F_Xjez6lkBCSbrfkpSqb0": 507,
		"./066-ER18_13AEse1W8xze_zsM7i-j-EyrFS3Yy1ZKt": 508,
		"./068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M": 509,
		"./072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp": 510,
		"./074-ER18_1zTM7CQ9kFfEt4ep1JrcDF7LjnxbCR6sp": 511,
		"./076-ER18_1nZaNckHtC_OSB_SGCW8YonqWvGCvKfLj": 512,
		"./078-ER18_14J9_i2nH92fn2_RATy4D92pM9qSjHsnh": 513,
		"./080-ER18_1brO_ZKWrE7Tuj2LR-sJX-shlCNsO4b4e": 514,
		"./082-ER18_1L_IP3NhgvxyUgrZEs9S21e8WXCZrN_fH": 515,
		"./083-ER18_1g7d4DwsQJ9050KDa9heHIOSxsLy1oazi": 516,
		"./094-ER18_1beMXKMRWRT7P9U2Rm1yoxRCrMIXLLgWh": 517,
		"./099-ER18_1T07GTLSlpGq_9RuM0t2Fq1fCC6aCmr_t": 518,
		"./112-ER18_1lsSYF7zkArl5H5sXzYW4et_eX-dzvbt7": 519,
		"./113-ER18_106_ubACGiTICmmiFgC2Wf5T15sivR1jB": 520,
		"./114-ER18_14g0HTeBKLDAh5yobMIwYArjSpjzBOmAP": 521,
		"./146-ER18_1-OwEPmp6sxnw4tLDvz_E5Oqj20MtWKLn": 522,
		"./148-ER18_19_T4PMNaRIjxwJ-9NhaKRIJPlqxgdW_i": 523,
		"./150-ER18_1fo-POOVIIBgz83gY9u88e__FJxCUYFjL": 524,
		"./151-ER18_1oWMOGNE9z66SO_0HyPtJTaebqcnHT79T": 525,
		"./152-ER18_1W-coBV8w461fGMSKmtyA-2AQsbgHZ3es": 526,
		"./154-ER18_18BDXgP_vi0tQDNSobF7QVw4aAlr_4RX1": 527,
		"./157-ER18_1UezNOcqO3IWrFGZSoCiinPq_oNDi5Mso": 528,
		"./158-ER18_1hEzk4cJ6aY8ogyopTpmg_UeOU-ZtZmR-": 529,
		"./159-ER18_1q5-qGmelJSHfrEyEm8YlXVD1vhMWF1-9": 530,
		"./160-ER18_11zK1GzxPFiZJ2fRqI8vfDAcjni1S30IE": 531,
		"./163-ER18_1ANhwOSThPRki0Y7xFF7nlAWtEMBmbDBH": 532,
		"./163-ER18_1npne8tINalaObkCOJuX9SbG52QV72uoN": 533,
		"./165-ER18_1jeSdTKlwP5Lqk_9STR3S1ZYyKg6FhY9C": 534,
		"./166-ER18_17bKLO4Z7YVAFpM7shK0P6gMtPfMsOJ_s": 535,
		"./167-ER18_15_--JO2X8fU-O2RpGYC0qpAtMzQB8duj": 536,
		"./169-ER18_1_OgYM3Ksvke6ps7FYUIYqbAb1qwahmto": 537,
		"./171-ER18_1-WuTyOd1QbAJK_s29mkn2Vf3zXRBrtx3": 538,
		"./173-ER18_12z-ylJQChhpR4V-dq45xQUpd6CzPRwqt": 539,
		"./174-ER18_1vwgJf0uavLajHlhSswqAKU4nbc_jK6BE": 540,
		"./175-ER18_1N0ziJVbaWwOHDGNyaCfwhyNrnZaPV780": 541,
		"./176-ER18_1zV0CgdojVRhnTWd6zLnzjDO2aHI1ICM0": 542,
		"./180-ER18_1uQwVuezg2cpUhis5iSrhWA1Z-xe_ODEG": 543,
		"./183-ER18_17uYodbIHB3uiLzcQBeY-yfjDJrkPnp1L": 544,
		"./200-ER18_10DcO41RMUoBIuGjs9frEoplr3eOWIJU-": 545,
		"./201-ER18_1tdmVgdBHU74V55Q-l7cHDdof2zxPyizu": 546,
		"./203-ER18_1TmwKL5V1MkmQSrvnHNnY3m0D10RW245s": 547,
		"./205-ER18_1w7TqgHxCmIHCMgitBRdfYCnjdHZLHpNH": 548,
		"./207-ER18_1jRKZsJ_y9RD-_WvOud5ZffiNy3_VrmSC": 549,
		"./208-ER18_1VGRhSyp_HI71gCtLzZ5wJ8xEpYw4B3Jw": 550,
		"./209-ER18_1ERujGjVSKTTCWXXe9Yme1IeKI1u_4pwI": 551,
		"./212-ER18_1nKQL7O0kZuVzLf2s-40NfwPfdvbqYHe-": 552,
		"./213-ER18_1AgDi0crTOPD935yS5AsmP8VBCecI0ycz": 553,
		"./216-ER18_193omF-S7wJaXGlHXc-Pn-HEfaO3NCpC5": 554,
		"./222-ER18_1LZQkGW08nb81XDBKajs3Cn9Ck8Nxqqa5": 555,
		"./223-ER18_16vNt1do6cn1CkXeHNuiwql7gVVUKJhoF": 556,
		"./224-ER18_1PWG_WKXNhXwNnFg9L29aW0Cdyvd0RuS7": 557,
		"./225-ER18_1m7RnEjiBQ9UwTFg-kzFGa7-57fC8VWjA": 558,
		"./226-ER18_1sBH0jKo2XU6MKPY_pphbVmyz2uhtXBMA": 559,
		"./228-ER18_1k1ybMEpgXdTZF3Nob5eZSdoazA6kv0fu": 560,
		"./231-ER18_1LIzQxgJBg6U1aMfD1W5Uuun6lOf91bux": 561,
		"./233-ER18_1CQWeohxZLZiteioJY43f-Sa-vOKUl9kh": 562,
		"./235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4": 563,
		"./236-ER18_1depuYlP4j1cX7yqjkcqORYpF_-iqIkFS": 564,
		"./237-ER18_1QxcFX9CO_ucZODzkG4gplksMJudpmmkg": 565,
		"./237-ER18_1urdwji2Ok3pTd32quo8Kx8K6H_uAsjeq": 566,
		"./239-ER18_1hCSVs0gvqaeUVrX8Hxre4P9sHliPf4qh": 567,
		"./254-ER18_1p4XoC_47NIpg3pvJTXj0OOFy9d_nNQ8V": 568,
		"./258-ER18_1fxyBxofnQ1CqWiwB-RirtICzChxm5ynR": 569,
		"./270-ER18_17iMPPsAkiqIn05H6DYZjtw0w-6vENmp9": 570,
		"./272-ER18_1QtgikUX5qUFIJuGNDfAIRaFOiGubt2IA": 571,
		"./273-ER18_1AXILP_ZSU7ijBcOvPkZlo373KX-AO6mp": 572,
		"./278-ER18_1CgFWCj3l6d2-ptq7QOXmdGkX_obn3nkc": 573,
		"./284-ER18_1VTFJGD_YFp1yyh2SZylr32_QwW5csKQb": 574,
		"./287-ER18_1ieEPa4YmNIw25tb0QYFIQOs-d6lBRfwX": 575,
		"./317-ER18_1Rn1MZwEQauRXv4E0tRXmw5Klbdh1v0Aq": 576,
		"./337-ER18_1lyDUiGxnLJyiwN2rZ5-z4l-ntHZENa0X": 577,
		"./339-ER18_1jizImIpMNK1vvXxmOiEP4BWYk_nQRe3F": 578,
		"./341-ER18_1O4MSttpj5RtBt6b9lU26o4QgFX5CAsaA": 579,
		"./343-ER18_1J_a5z9ckwcvGbHoJIwY3aBB3CxhD84II": 580,
		"./368-ER18_1cGl5DXpWPTkXLMNKsrOU-etD_l9eYWZA": 581,
		"./369-ER18_1J6pe2wjx-b3k5ujo_oMpOxSkxqoM7ODP": 582,
		"./393-ER18_1Z8pd8qK3S4QB2Kjdu9eVihIIw4nzpTL4": 583,
		"./CC-BOG0_1YIffKvdArow8ys3h1hJzjbHcNoqMq5Jm": 584,
		"./CC-BOG3_151QuDD2UzRCXC5DTTtCM8MWqloRxdWXp": 585,
		"./CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN": 586,
		"./CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu": 587,
		"./CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn": 588,
		"./CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A": 589,
		"./CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ": 590,
		"./CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz": 591,
		"./CC-COL15_1Ama-4Szg7soqzvzz99qowe8usVKU-vYn": 592,
		"./CC-COL20_155n4txAWhvgUxqgameCgkkbtTWN-ONrf": 593,
		"./CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8": 594,
		"./CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ": 595,
		"./CC-COL3_1SEtNaLFEC_42OJvCdsP6NIvzgVd_imyP": 596,
		"./CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi": 597,
		"./CC-COL5_1k8tymV5VzOjNmHISsgw8Zhb0xx_keqSE": 598,
		"./CC-COL6_1UwGzcnd8AgGHuFpWY2S8I7InHIjor_Bq": 599,
		"./CC-COL7_1bN9L3MsxC1SYzBVBFyRvLmButPlZNnn_": 600,
		"./CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4": 601,
		"./CC-COL9_1cMYlJHh0_LzvhnmQVfYRGdX2ETL55C9p": 602,
		"./CC-ELK0_181yufjtuQU9lz_jlAQWD1dT_969-OmRN": 603,
		"./CC-ELK1_1IE6nxQZjZcR68d8pL-Yo8Lt0bzRmfIQx": 604,
		"./CC-EVN1_1KQbIJEr0ww57nF4vsVCNojg12AhC3h-8": 605,
		"./CC-IRB3_1a9UiHSCTmRMHIGshhH4-NXwUROt9eSz5": 606,
		"./CC-IRW0_1fFaRSdXFCLCzZ7X4VLzDFF97NEQ8ztCs": 607,
		"./CC-OHO1_1P_P9OQUhhJLbMwXchqxW3eag6LZaY6Sv": 608,
		"./CC-RLY1_1cmOTVtFTXg_A2Kwp9llMCnfYZKiAhYgI": 609,
		"./CC-SPL1_1Bl2JjkwD6Ygn8kprhhVIXoJ6PIR3pXck": 610,
		"./CC-WLD1_1pJB8G4GSGtljM4xj9e0qJusRhjQqA8gn": 611,
		"./ER-AMT1_1WL_KcZGPiRKNgAKsqdZs5ZwKK3ub_nk6": 612,
		"./ER-AVY1_1HFoba3DfET07yAfpMYgob55oZF1jQH0Z": 613,
		"./ER-AVY1_1nnkbVSeckmOCSVbiPAJlpWE0TcH0m1xF": 614,
		"./ER-BCC0_13ztzLwVTVcTDYYH8DfJ-CL-t77N3xx2q": 615,
		"./ER-BCC0_1IZPq1EJPIq3_rZt8wC5w6o-FIHHj1yG9": 616,
		"./ER-BCC0_1f3GdVRWTQS6AMq3pHUO8eF_i9H_cMBTX": 617,
		"./ER-BCC0_1rmKoACou7XMB5MmaYYBEutbkPYBTfjLY": 618,
		"./ER-BLB1_19HFEd1-3inv9qhhPaZeDIMRNV9QATzqg": 619,
		"./ER-BLB1_1m8X3jwzFJRo-ss8Q1tmLHM8qWJXoJh1g": 620,
		"./ER-BLY1_1lfq6itnxKJjJOeHstOJNFgh7_m28P7tt": 621,
		"./ER-BRD1_1YrnvDmmLbq_m7pckHaqEK9zRAZxc1hej": 622,
		"./ER-CPR1_1YABLBd05P-y8NhdOQJb4Y_ruc95IwAit": 623,
		"./ER-EAQ1_1iAT3Un1XYN79br8b27e2aGHBNWpG6ht4": 624,
		"./ER-EBC0_1VC-KmuX1iROuujgfWarajGUvaXiMyQLm": 625,
		"./ER-EBC1_1sjwAulA3mjsE1OfJ2KdGVOHeMEcGbRQW": 626,
		"./ER-EST2_12U0xe6oGY5MQqYx9_PFOAMWrLJekUPxJ": 627,
		"./ER-GLS1_1kakMTKZyBgPBuqJVibVpFEJCr5kdRiOA": 628,
		"./ER-GTH1_1AtWkH44Jams2WJsCyCEoV3Vi6Ta0eNXM": 629,
		"./ER-GUM1_1ZeJ4MYQ1-XqGKMIlbPerUxiIEII3J-Mg": 630,
		"./ER-GUM1_1c0VY7VgJXkJcReKGNHRllcR-zgy9UntY": 631,
		"./ER-GUM1_1okRIR8vg1q5uGSMnYia6PpM7rd9KoP32": 632,
		"./ER-JDF1_1X-gx9lYQxfDlkoi30dtHycjnXzcrEBmm": 633,
		"./ER-KLP1_1UmAgH7geJfEQL4g0C7QbTyOr6Ish_9xG": 634,
		"./ER-MMT1_1bsH_cMQXOv6f_z8s00VyUSkTz_4c2IdV": 635,
		"./ER-MXC1_1wfQjfEhZlZTNHkx12kkEhfg5hDRmr_sB": 636,
		"./ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy": 637,
		"./ER-PHF0_1AjzaqW2975cRaNzzSISAsDcbb8Uj9_0i": 638,
		"./ER-PHF0_1SUNKjCfCU105x69XIkqnfnwEV0TRiwDm": 639,
		"./ER-PHF1_1aNmd-9OBx33o3jfwjkcFwpfc3TFWeSqk": 640,
		"./ER-PLM1_1DHl4dNQEK1Jb1bRRq2j2DvLeu9L-gc1q": 641,
		"./ER-PLM1_1Df8i_qTutb-lKvBamkcBaeYS7Wlnx4Pr": 642,
		"./ER-PLM1_1Ig4tDFrLfYpclSnHsW4YeEoNuNFcwR8r": 643,
		"./ER-PLM2_1Rqjtly5iPAoC-O5k-VK7OBRL4Fv_3A3v": 644,
		"./ER-PLM2_1z9BUKgabfr1vLS8DQ_6yYTn7UroR0vlT": 645,
		"./ER-PLM3_1Ttsrqq9EptJX65fC73jBzbTfLS5Rwdsu": 646,
		"./ER-PLM3_1jk-ZktIfdcILcUL3oJxwveeNNxVCM9oj": 647,
		"./ER-PLM4_1JoonMxxHy-lUDl7QZRvJ-ejJofgV4R0G": 648,
		"./ER-PLM6_1DCRaVpzbA5cY_Msu2O1p2xANoS29VbPS": 649,
		"./ER-PLM7_1ypKvvJqeBFFKQ0X4WceQi4obtzMxX-BV": 650,
		"./ER-PLM8_1KIxGYic47rh8iFEQFYRV6DOIg_qu1-mp": 651,
		"./ER-PLM9_1AWokwE0jGeAWSrkgDo7aHP8W8CphDOFs": 652,
		"./ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv": 653,
		"./ER-QLY1_1NbFc2sZR8W7fwJJP000umti3ZQP9j6Iq": 654,
		"./ER-RBL1_1YqONoeAgGi9Si2GNTKLRIK42To9evQ7u": 655,
		"./ER-RBL1_1cJ1OiF7IENtxOHbfSYRWyZEgkUdZtn4F": 656,
		"./ER-RCK1_1ivpBjVxrUm4TLEXTOrkI5CEE6FRCsGsf": 657,
		"./ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2": 658,
		"./ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_": 659,
		"./ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw": 660,
		"./ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht": 661,
		"./ER-YUL0_1Cf-iHrXGhBarsVu5nXIUz07R9Cc6MBwo": 662,
		"./ER-YUL0_1SgG10QYcOkRTL2o694mcT3qBrNCgZsIG": 663,
		"./SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl": 664,
		"./SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_": 665,
		"./SG-SNI2_1FwnVgeFB0GpzEdjUBuvM09VPagZ_-cdv": 666,
		"./SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL": 667,
		"./SG-SNI3_1L7ksbmn65NwDC05Bz0Qqex7AINgaZAeO": 668,
		"./SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ": 669,
		"./SG-SNI3_1zIbU3MPWQIcnH_F7DYGlhL4PvfcRwjLo": 670,
		"./SG-SNI4_1CUdYvu_GEzg97KRjJehBYKCQJ9KgYjfh": 671,
		"./SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA": 672,
		"./SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI": 673,
		"./SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv": 674,
		"./WG-LMR2_1xFtTmjUsG8iRdihZwudzxi5AdCFYgnb3": 675
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 864;


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./001-ER18_1M8Yf1i2VjaoAa1y0ixG7_VyJBlErqEix": 676,
		"./002-ER18_1VeP3Zc2Wfrkwyrq-eTvKtgIRYnM72emx": 677,
		"./003-ER18_1vEnBHHxEXKC0T8tKdP8MxVdes8GF4TUo": 678,
		"./004-ER18_1kNdzN56MWsD2sXJCLg5Lj9JRvw2L4TiO": 679,
		"./006-ER18_1QRFC1u9728Wa4EIruhHuQK3p5ZPxb7yp": 680,
		"./010-ER18_1j165RaP-jDI_mtkUJa47eFZAhD__O0lw": 681,
		"./018-ER18_1X3ztxvSxKE7thV3t0etcsA1H7qo7fWaH": 682,
		"./024-ER18_1Ih_4RpBXse6184d88br1k--hXTBAByl3": 683,
		"./028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y": 684,
		"./030-ER18_1wTdaxgQBmOlmxX3Lgd0azD1L83TuJU-F": 685,
		"./032-ER18_1YlJDfsBjZbilfH_o1hLUBcy5XfimEQUV": 686,
		"./033-ER18_14yWpkYYa86gdH6puwjSQZYGzrZPB_VAt": 687,
		"./044-ER18_1ijgtyLZjTSiYNzg4JQ5IL7bpHySNZizY": 688,
		"./065-ER18_1bElv-IgFqW3F_Xjez6lkBCSbrfkpSqb0": 689,
		"./066-ER18_13AEse1W8xze_zsM7i-j-EyrFS3Yy1ZKt": 690,
		"./068-ER18_12D3AyzXTjMoLaexasXPJsHv4VDzeeV-M": 691,
		"./072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp": 692,
		"./074-ER18_1zTM7CQ9kFfEt4ep1JrcDF7LjnxbCR6sp": 693,
		"./076-ER18_1nZaNckHtC_OSB_SGCW8YonqWvGCvKfLj": 694,
		"./078-ER18_14J9_i2nH92fn2_RATy4D92pM9qSjHsnh": 695,
		"./080-ER18_1brO_ZKWrE7Tuj2LR-sJX-shlCNsO4b4e": 696,
		"./082-ER18_1L_IP3NhgvxyUgrZEs9S21e8WXCZrN_fH": 697,
		"./083-ER18_1g7d4DwsQJ9050KDa9heHIOSxsLy1oazi": 698,
		"./094-ER18_1beMXKMRWRT7P9U2Rm1yoxRCrMIXLLgWh": 699,
		"./099-ER18_1T07GTLSlpGq_9RuM0t2Fq1fCC6aCmr_t": 700,
		"./112-ER18_1lsSYF7zkArl5H5sXzYW4et_eX-dzvbt7": 701,
		"./113-ER18_106_ubACGiTICmmiFgC2Wf5T15sivR1jB": 702,
		"./114-ER18_14g0HTeBKLDAh5yobMIwYArjSpjzBOmAP": 703,
		"./146-ER18_1-OwEPmp6sxnw4tLDvz_E5Oqj20MtWKLn": 704,
		"./148-ER18_19_T4PMNaRIjxwJ-9NhaKRIJPlqxgdW_i": 705,
		"./150-ER18_1fo-POOVIIBgz83gY9u88e__FJxCUYFjL": 706,
		"./151-ER18_1oWMOGNE9z66SO_0HyPtJTaebqcnHT79T": 707,
		"./152-ER18_1W-coBV8w461fGMSKmtyA-2AQsbgHZ3es": 708,
		"./154-ER18_18BDXgP_vi0tQDNSobF7QVw4aAlr_4RX1": 709,
		"./157-ER18_1UezNOcqO3IWrFGZSoCiinPq_oNDi5Mso": 710,
		"./158-ER18_1hEzk4cJ6aY8ogyopTpmg_UeOU-ZtZmR-": 711,
		"./159-ER18_1q5-qGmelJSHfrEyEm8YlXVD1vhMWF1-9": 712,
		"./160-ER18_11zK1GzxPFiZJ2fRqI8vfDAcjni1S30IE": 713,
		"./163-ER18_1ANhwOSThPRki0Y7xFF7nlAWtEMBmbDBH": 714,
		"./163-ER18_1npne8tINalaObkCOJuX9SbG52QV72uoN": 715,
		"./165-ER18_1jeSdTKlwP5Lqk_9STR3S1ZYyKg6FhY9C": 716,
		"./166-ER18_17bKLO4Z7YVAFpM7shK0P6gMtPfMsOJ_s": 717,
		"./167-ER18_15_--JO2X8fU-O2RpGYC0qpAtMzQB8duj": 718,
		"./169-ER18_1_OgYM3Ksvke6ps7FYUIYqbAb1qwahmto": 719,
		"./171-ER18_1-WuTyOd1QbAJK_s29mkn2Vf3zXRBrtx3": 720,
		"./173-ER18_12z-ylJQChhpR4V-dq45xQUpd6CzPRwqt": 721,
		"./174-ER18_1vwgJf0uavLajHlhSswqAKU4nbc_jK6BE": 722,
		"./175-ER18_1N0ziJVbaWwOHDGNyaCfwhyNrnZaPV780": 723,
		"./176-ER18_1zV0CgdojVRhnTWd6zLnzjDO2aHI1ICM0": 724,
		"./180-ER18_1uQwVuezg2cpUhis5iSrhWA1Z-xe_ODEG": 725,
		"./183-ER18_17uYodbIHB3uiLzcQBeY-yfjDJrkPnp1L": 726,
		"./200-ER18_10DcO41RMUoBIuGjs9frEoplr3eOWIJU-": 727,
		"./201-ER18_1tdmVgdBHU74V55Q-l7cHDdof2zxPyizu": 728,
		"./203-ER18_1TmwKL5V1MkmQSrvnHNnY3m0D10RW245s": 729,
		"./205-ER18_1w7TqgHxCmIHCMgitBRdfYCnjdHZLHpNH": 730,
		"./207-ER18_1jRKZsJ_y9RD-_WvOud5ZffiNy3_VrmSC": 731,
		"./208-ER18_1VGRhSyp_HI71gCtLzZ5wJ8xEpYw4B3Jw": 732,
		"./209-ER18_1ERujGjVSKTTCWXXe9Yme1IeKI1u_4pwI": 733,
		"./212-ER18_1nKQL7O0kZuVzLf2s-40NfwPfdvbqYHe-": 734,
		"./213-ER18_1AgDi0crTOPD935yS5AsmP8VBCecI0ycz": 735,
		"./216-ER18_193omF-S7wJaXGlHXc-Pn-HEfaO3NCpC5": 736,
		"./222-ER18_1LZQkGW08nb81XDBKajs3Cn9Ck8Nxqqa5": 737,
		"./223-ER18_16vNt1do6cn1CkXeHNuiwql7gVVUKJhoF": 738,
		"./224-ER18_1PWG_WKXNhXwNnFg9L29aW0Cdyvd0RuS7": 739,
		"./225-ER18_1m7RnEjiBQ9UwTFg-kzFGa7-57fC8VWjA": 740,
		"./226-ER18_1sBH0jKo2XU6MKPY_pphbVmyz2uhtXBMA": 741,
		"./228-ER18_1k1ybMEpgXdTZF3Nob5eZSdoazA6kv0fu": 742,
		"./231-ER18_1LIzQxgJBg6U1aMfD1W5Uuun6lOf91bux": 743,
		"./233-ER18_1CQWeohxZLZiteioJY43f-Sa-vOKUl9kh": 744,
		"./235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4": 745,
		"./236-ER18_1depuYlP4j1cX7yqjkcqORYpF_-iqIkFS": 746,
		"./237-ER18_1QxcFX9CO_ucZODzkG4gplksMJudpmmkg": 747,
		"./237-ER18_1urdwji2Ok3pTd32quo8Kx8K6H_uAsjeq": 748,
		"./239-ER18_1hCSVs0gvqaeUVrX8Hxre4P9sHliPf4qh": 749,
		"./254-ER18_1p4XoC_47NIpg3pvJTXj0OOFy9d_nNQ8V": 750,
		"./258-ER18_1fxyBxofnQ1CqWiwB-RirtICzChxm5ynR": 751,
		"./270-ER18_17iMPPsAkiqIn05H6DYZjtw0w-6vENmp9": 752,
		"./272-ER18_1QtgikUX5qUFIJuGNDfAIRaFOiGubt2IA": 753,
		"./273-ER18_1AXILP_ZSU7ijBcOvPkZlo373KX-AO6mp": 754,
		"./278-ER18_1CgFWCj3l6d2-ptq7QOXmdGkX_obn3nkc": 755,
		"./284-ER18_1VTFJGD_YFp1yyh2SZylr32_QwW5csKQb": 756,
		"./287-ER18_1ieEPa4YmNIw25tb0QYFIQOs-d6lBRfwX": 757,
		"./317-ER18_1Rn1MZwEQauRXv4E0tRXmw5Klbdh1v0Aq": 758,
		"./337-ER18_1lyDUiGxnLJyiwN2rZ5-z4l-ntHZENa0X": 759,
		"./339-ER18_1jizImIpMNK1vvXxmOiEP4BWYk_nQRe3F": 760,
		"./341-ER18_1O4MSttpj5RtBt6b9lU26o4QgFX5CAsaA": 761,
		"./343-ER18_1J_a5z9ckwcvGbHoJIwY3aBB3CxhD84II": 762,
		"./368-ER18_1cGl5DXpWPTkXLMNKsrOU-etD_l9eYWZA": 763,
		"./369-ER18_1J6pe2wjx-b3k5ujo_oMpOxSkxqoM7ODP": 764,
		"./393-ER18_1Z8pd8qK3S4QB2Kjdu9eVihIIw4nzpTL4": 765,
		"./CC-BOG0_1YIffKvdArow8ys3h1hJzjbHcNoqMq5Jm": 766,
		"./CC-BOG3_151QuDD2UzRCXC5DTTtCM8MWqloRxdWXp": 767,
		"./CC-COL10_1xnca96C8jvKv6yqECRYlnRZxh3iyEddN": 768,
		"./CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu": 769,
		"./CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn": 770,
		"./CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A": 771,
		"./CC-COL12_1KYEkU4-w3ca9aRvpCmoumEmAyxf5zvlJ": 772,
		"./CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz": 773,
		"./CC-COL15_1Ama-4Szg7soqzvzz99qowe8usVKU-vYn": 774,
		"./CC-COL20_155n4txAWhvgUxqgameCgkkbtTWN-ONrf": 775,
		"./CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8": 776,
		"./CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ": 777,
		"./CC-COL3_1SEtNaLFEC_42OJvCdsP6NIvzgVd_imyP": 778,
		"./CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi": 779,
		"./CC-COL5_1k8tymV5VzOjNmHISsgw8Zhb0xx_keqSE": 780,
		"./CC-COL6_1UwGzcnd8AgGHuFpWY2S8I7InHIjor_Bq": 781,
		"./CC-COL7_1bN9L3MsxC1SYzBVBFyRvLmButPlZNnn_": 782,
		"./CC-COL8_16sQb6kgKMGe4rSkfS3_URsnZi75EvhH4": 783,
		"./CC-COL9_1cMYlJHh0_LzvhnmQVfYRGdX2ETL55C9p": 784,
		"./CC-ELK0_181yufjtuQU9lz_jlAQWD1dT_969-OmRN": 785,
		"./CC-ELK1_1IE6nxQZjZcR68d8pL-Yo8Lt0bzRmfIQx": 786,
		"./CC-EVN1_1KQbIJEr0ww57nF4vsVCNojg12AhC3h-8": 787,
		"./CC-IRB3_1a9UiHSCTmRMHIGshhH4-NXwUROt9eSz5": 788,
		"./CC-IRW0_1fFaRSdXFCLCzZ7X4VLzDFF97NEQ8ztCs": 789,
		"./CC-OHO1_1P_P9OQUhhJLbMwXchqxW3eag6LZaY6Sv": 790,
		"./CC-RLY1_1cmOTVtFTXg_A2Kwp9llMCnfYZKiAhYgI": 791,
		"./CC-SPL1_1Bl2JjkwD6Ygn8kprhhVIXoJ6PIR3pXck": 792,
		"./CC-WLD1_1pJB8G4GSGtljM4xj9e0qJusRhjQqA8gn": 793,
		"./ER-AMT1_1WL_KcZGPiRKNgAKsqdZs5ZwKK3ub_nk6": 794,
		"./ER-AVY1_1HFoba3DfET07yAfpMYgob55oZF1jQH0Z": 795,
		"./ER-AVY1_1nnkbVSeckmOCSVbiPAJlpWE0TcH0m1xF": 796,
		"./ER-BCC0_13ztzLwVTVcTDYYH8DfJ-CL-t77N3xx2q": 797,
		"./ER-BCC0_1IZPq1EJPIq3_rZt8wC5w6o-FIHHj1yG9": 798,
		"./ER-BCC0_1f3GdVRWTQS6AMq3pHUO8eF_i9H_cMBTX": 799,
		"./ER-BCC0_1rmKoACou7XMB5MmaYYBEutbkPYBTfjLY": 800,
		"./ER-BLB1_19HFEd1-3inv9qhhPaZeDIMRNV9QATzqg": 801,
		"./ER-BLB1_1m8X3jwzFJRo-ss8Q1tmLHM8qWJXoJh1g": 802,
		"./ER-BLY1_1lfq6itnxKJjJOeHstOJNFgh7_m28P7tt": 803,
		"./ER-BRD1_1YrnvDmmLbq_m7pckHaqEK9zRAZxc1hej": 804,
		"./ER-CPR1_1YABLBd05P-y8NhdOQJb4Y_ruc95IwAit": 805,
		"./ER-EAQ1_1iAT3Un1XYN79br8b27e2aGHBNWpG6ht4": 806,
		"./ER-EBC0_1VC-KmuX1iROuujgfWarajGUvaXiMyQLm": 807,
		"./ER-EBC1_1sjwAulA3mjsE1OfJ2KdGVOHeMEcGbRQW": 808,
		"./ER-EST2_12U0xe6oGY5MQqYx9_PFOAMWrLJekUPxJ": 809,
		"./ER-GLS1_1kakMTKZyBgPBuqJVibVpFEJCr5kdRiOA": 810,
		"./ER-GTH1_1AtWkH44Jams2WJsCyCEoV3Vi6Ta0eNXM": 811,
		"./ER-GUM1_1ZeJ4MYQ1-XqGKMIlbPerUxiIEII3J-Mg": 812,
		"./ER-GUM1_1c0VY7VgJXkJcReKGNHRllcR-zgy9UntY": 813,
		"./ER-GUM1_1okRIR8vg1q5uGSMnYia6PpM7rd9KoP32": 814,
		"./ER-JDF1_1X-gx9lYQxfDlkoi30dtHycjnXzcrEBmm": 815,
		"./ER-KLP1_1UmAgH7geJfEQL4g0C7QbTyOr6Ish_9xG": 816,
		"./ER-MMT1_1bsH_cMQXOv6f_z8s00VyUSkTz_4c2IdV": 817,
		"./ER-MXC1_1wfQjfEhZlZTNHkx12kkEhfg5hDRmr_sB": 818,
		"./ER-MXC1_1xNMfshzZmjtgj8Nqf1nQQ6SkMRjAsySy": 819,
		"./ER-PHF0_1AjzaqW2975cRaNzzSISAsDcbb8Uj9_0i": 820,
		"./ER-PHF0_1SUNKjCfCU105x69XIkqnfnwEV0TRiwDm": 821,
		"./ER-PHF1_1aNmd-9OBx33o3jfwjkcFwpfc3TFWeSqk": 822,
		"./ER-PLM1_1DHl4dNQEK1Jb1bRRq2j2DvLeu9L-gc1q": 823,
		"./ER-PLM1_1Df8i_qTutb-lKvBamkcBaeYS7Wlnx4Pr": 824,
		"./ER-PLM1_1Ig4tDFrLfYpclSnHsW4YeEoNuNFcwR8r": 825,
		"./ER-PLM2_1Rqjtly5iPAoC-O5k-VK7OBRL4Fv_3A3v": 826,
		"./ER-PLM2_1z9BUKgabfr1vLS8DQ_6yYTn7UroR0vlT": 827,
		"./ER-PLM3_1Ttsrqq9EptJX65fC73jBzbTfLS5Rwdsu": 828,
		"./ER-PLM3_1jk-ZktIfdcILcUL3oJxwveeNNxVCM9oj": 829,
		"./ER-PLM4_1JoonMxxHy-lUDl7QZRvJ-ejJofgV4R0G": 830,
		"./ER-PLM6_1DCRaVpzbA5cY_Msu2O1p2xANoS29VbPS": 831,
		"./ER-PLM7_1ypKvvJqeBFFKQ0X4WceQi4obtzMxX-BV": 832,
		"./ER-PLM8_1KIxGYic47rh8iFEQFYRV6DOIg_qu1-mp": 833,
		"./ER-PLM9_1AWokwE0jGeAWSrkgDo7aHP8W8CphDOFs": 834,
		"./ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv": 835,
		"./ER-QLY1_1NbFc2sZR8W7fwJJP000umti3ZQP9j6Iq": 836,
		"./ER-RBL1_1YqONoeAgGi9Si2GNTKLRIK42To9evQ7u": 837,
		"./ER-RBL1_1cJ1OiF7IENtxOHbfSYRWyZEgkUdZtn4F": 838,
		"./ER-RCK1_1ivpBjVxrUm4TLEXTOrkI5CEE6FRCsGsf": 839,
		"./ER-RUS1_1BTMfEXu88ZC6D5upFaILb-QYccTJ-Ro2": 840,
		"./ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_": 841,
		"./ER-RUS1_1XzC1308rUUeFMQmw8E-fkQ55HHEqplbw": 842,
		"./ER-RUS1_1ohNTLHoppzt0PVq2rMK6dnDlknjwMwht": 843,
		"./ER-YUL0_1Cf-iHrXGhBarsVu5nXIUz07R9Cc6MBwo": 844,
		"./ER-YUL0_1SgG10QYcOkRTL2o694mcT3qBrNCgZsIG": 845,
		"./SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl": 846,
		"./SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_": 847,
		"./SG-SNI2_1FwnVgeFB0GpzEdjUBuvM09VPagZ_-cdv": 848,
		"./SG-SNI3_1Is2b80PfDj8yzd4j0pVc7MLFMNfRO8KL": 849,
		"./SG-SNI3_1L7ksbmn65NwDC05Bz0Qqex7AINgaZAeO": 850,
		"./SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ": 851,
		"./SG-SNI3_1zIbU3MPWQIcnH_F7DYGlhL4PvfcRwjLo": 852,
		"./SG-SNI4_1CUdYvu_GEzg97KRjJehBYKCQJ9KgYjfh": 853,
		"./SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA": 854,
		"./SG-SNI4_1kpXzr_vGy_gWtPr7eVwMCoLSlsKBWtEI": 855,
		"./SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv": 856,
		"./WG-LMR2_1xFtTmjUsG8iRdihZwudzxi5AdCFYgnb3": 857
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 865;


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.42669e86.js